import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  JSON: any;
  JSONObject: any;
  JWT: any;
};

export type AddContactToMroCustomerInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mroCustomerId: Scalars['String'];
  mroOrganizationId: Scalars['String'];
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
};

export type AddConversationParticipantInput = {
  communicationThreadId?: InputMaybe<Scalars['String']>;
  identity?: InputMaybe<Scalars['String']>;
  mroContactId?: InputMaybe<Scalars['String']>;
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AddCraftToMroCustomerInput = {
  address: AddressInput;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCustomerId: Scalars['String'];
  mroOrganizationId: Scalars['String'];
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  year: Scalars['Int'];
};

export type AddressInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AirSyncLogSync = {
  __typename?: 'AirSyncLogSync';
  error?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type AirSyncSetup = {
  __typename?: 'AirSyncSetup';
  airSyncId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  isSetup: Scalars['Boolean'];
};

export type AirSyncTail = {
  __typename?: 'AirSyncTail';
  airSyncId: Scalars['String'];
  craftId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  isAircraftRegistered: Scalars['Boolean'];
  isSetup: Scalars['Boolean'];
  tailNumber: Scalars['String'];
};

export type AirblySetup = {
  __typename?: 'AirblySetup';
  integration_enabled?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type Airport = {
  __typename?: 'Airport';
  _count: AirportCount;
  city: Scalars['String'];
  continent: Scalars['String'];
  county: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  elevation: Scalars['Int'];
  facilityName: Scalars['String'];
  facilityType: Scalars['String'];
  favoriteRoutes?: Maybe<Array<FavoriteRoute>>;
  flights?: Maybe<Array<Flight>>;
  gps: Scalars['String'];
  iata: Scalars['String'];
  icao: Scalars['String'];
  id: Scalars['ID'];
  isoCountry: Scalars['String'];
  latitude: Scalars['Decimal'];
  legacyId?: Maybe<Scalars['String']>;
  longitude: Scalars['Decimal'];
  state: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AirportAvgAggregate = {
  __typename?: 'AirportAvgAggregate';
  elevation?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
};

export type AirportCount = {
  __typename?: 'AirportCount';
  favoriteRoutes: Scalars['Int'];
  flights: Scalars['Int'];
};

export type AirportCountAggregate = {
  __typename?: 'AirportCountAggregate';
  _all: Scalars['Int'];
  city: Scalars['Int'];
  continent: Scalars['Int'];
  county: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  elevation: Scalars['Int'];
  facilityName: Scalars['Int'];
  facilityType: Scalars['Int'];
  gps: Scalars['Int'];
  iata: Scalars['Int'];
  icao: Scalars['Int'];
  id: Scalars['Int'];
  isoCountry: Scalars['Int'];
  latitude: Scalars['Int'];
  legacyId: Scalars['Int'];
  longitude: Scalars['Int'];
  state: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AirportCreateInput = {
  city: Scalars['String'];
  continent: Scalars['String'];
  county: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation: Scalars['Int'];
  facilityName: Scalars['String'];
  facilityType: Scalars['String'];
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutAirportsInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutRouteInput>;
  gps: Scalars['String'];
  iata: Scalars['String'];
  icao: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isoCountry: Scalars['String'];
  latitude: Scalars['Decimal'];
  legacyId?: InputMaybe<Scalars['String']>;
  longitude: Scalars['Decimal'];
  state: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportCreateNestedManyWithoutFavoriteRoutesInput = {
  connect?: InputMaybe<Array<AirportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AirportCreateOrConnectWithoutFavoriteRoutesInput>>;
  create?: InputMaybe<Array<AirportCreateWithoutFavoriteRoutesInput>>;
};

export type AirportCreateNestedManyWithoutFlightsInput = {
  connect?: InputMaybe<Array<AirportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AirportCreateOrConnectWithoutFlightsInput>>;
  create?: InputMaybe<Array<AirportCreateWithoutFlightsInput>>;
};

export type AirportCreateOrConnectWithoutFavoriteRoutesInput = {
  create: AirportCreateWithoutFavoriteRoutesInput;
  where: AirportWhereUniqueInput;
};

export type AirportCreateOrConnectWithoutFlightsInput = {
  create: AirportCreateWithoutFlightsInput;
  where: AirportWhereUniqueInput;
};

export type AirportCreateWithoutFavoriteRoutesInput = {
  city: Scalars['String'];
  continent: Scalars['String'];
  county: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation: Scalars['Int'];
  facilityName: Scalars['String'];
  facilityType: Scalars['String'];
  flights?: InputMaybe<FlightCreateNestedManyWithoutRouteInput>;
  gps: Scalars['String'];
  iata: Scalars['String'];
  icao: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isoCountry: Scalars['String'];
  latitude: Scalars['Decimal'];
  legacyId?: InputMaybe<Scalars['String']>;
  longitude: Scalars['Decimal'];
  state: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportCreateWithoutFlightsInput = {
  city: Scalars['String'];
  continent: Scalars['String'];
  county: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation: Scalars['Int'];
  facilityName: Scalars['String'];
  facilityType: Scalars['String'];
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutAirportsInput>;
  gps: Scalars['String'];
  iata: Scalars['String'];
  icao: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isoCountry: Scalars['String'];
  latitude: Scalars['Decimal'];
  legacyId?: InputMaybe<Scalars['String']>;
  longitude: Scalars['Decimal'];
  state: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportListRelationFilter = {
  every?: InputMaybe<AirportWhereInput>;
  none?: InputMaybe<AirportWhereInput>;
  some?: InputMaybe<AirportWhereInput>;
};

export type AirportMaxAggregate = {
  __typename?: 'AirportMaxAggregate';
  city?: Maybe<Scalars['String']>;
  continent?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  elevation?: Maybe<Scalars['Int']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityType?: Maybe<Scalars['String']>;
  gps?: Maybe<Scalars['String']>;
  iata?: Maybe<Scalars['String']>;
  icao?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isoCountry?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Decimal']>;
  legacyId?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Decimal']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AirportMinAggregate = {
  __typename?: 'AirportMinAggregate';
  city?: Maybe<Scalars['String']>;
  continent?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  elevation?: Maybe<Scalars['Int']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityType?: Maybe<Scalars['String']>;
  gps?: Maybe<Scalars['String']>;
  iata?: Maybe<Scalars['String']>;
  icao?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isoCountry?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Decimal']>;
  legacyId?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Decimal']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AirportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AirportScalarWhereInput = {
  AND?: InputMaybe<Array<AirportScalarWhereInput>>;
  NOT?: InputMaybe<Array<AirportScalarWhereInput>>;
  OR?: InputMaybe<Array<AirportScalarWhereInput>>;
  city?: InputMaybe<StringFilter>;
  continent?: InputMaybe<StringFilter>;
  county?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  elevation?: InputMaybe<IntFilter>;
  facilityName?: InputMaybe<StringFilter>;
  facilityType?: InputMaybe<StringFilter>;
  gps?: InputMaybe<StringFilter>;
  iata?: InputMaybe<StringFilter>;
  icao?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isoCountry?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<DecimalFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<DecimalFilter>;
  state?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AirportSumAggregate = {
  __typename?: 'AirportSumAggregate';
  elevation?: Maybe<Scalars['Int']>;
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
};

export type AirportUpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  continent?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation?: InputMaybe<Scalars['Int']>;
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<Scalars['String']>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutAirportsNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutRouteNestedInput>;
  gps?: InputMaybe<Scalars['String']>;
  iata?: InputMaybe<Scalars['String']>;
  icao?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isoCountry?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  legacyId?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportUpdateManyMutationInput = {
  city?: InputMaybe<Scalars['String']>;
  continent?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation?: InputMaybe<Scalars['Int']>;
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<Scalars['String']>;
  gps?: InputMaybe<Scalars['String']>;
  iata?: InputMaybe<Scalars['String']>;
  icao?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isoCountry?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  legacyId?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportUpdateManyWithWhereWithoutFavoriteRoutesInput = {
  data: AirportUpdateManyMutationInput;
  where: AirportScalarWhereInput;
};

export type AirportUpdateManyWithWhereWithoutFlightsInput = {
  data: AirportUpdateManyMutationInput;
  where: AirportScalarWhereInput;
};

export type AirportUpdateManyWithoutFavoriteRoutesNestedInput = {
  connect?: InputMaybe<Array<AirportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AirportCreateOrConnectWithoutFavoriteRoutesInput>>;
  create?: InputMaybe<Array<AirportCreateWithoutFavoriteRoutesInput>>;
  delete?: InputMaybe<Array<AirportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AirportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AirportWhereUniqueInput>>;
  set?: InputMaybe<Array<AirportWhereUniqueInput>>;
  update?: InputMaybe<Array<AirportUpdateWithWhereUniqueWithoutFavoriteRoutesInput>>;
  updateMany?: InputMaybe<Array<AirportUpdateManyWithWhereWithoutFavoriteRoutesInput>>;
  upsert?: InputMaybe<Array<AirportUpsertWithWhereUniqueWithoutFavoriteRoutesInput>>;
};

export type AirportUpdateManyWithoutFlightsNestedInput = {
  connect?: InputMaybe<Array<AirportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AirportCreateOrConnectWithoutFlightsInput>>;
  create?: InputMaybe<Array<AirportCreateWithoutFlightsInput>>;
  delete?: InputMaybe<Array<AirportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AirportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AirportWhereUniqueInput>>;
  set?: InputMaybe<Array<AirportWhereUniqueInput>>;
  update?: InputMaybe<Array<AirportUpdateWithWhereUniqueWithoutFlightsInput>>;
  updateMany?: InputMaybe<Array<AirportUpdateManyWithWhereWithoutFlightsInput>>;
  upsert?: InputMaybe<Array<AirportUpsertWithWhereUniqueWithoutFlightsInput>>;
};

export type AirportUpdateWithWhereUniqueWithoutFavoriteRoutesInput = {
  data: AirportUpdateWithoutFavoriteRoutesInput;
  where: AirportWhereUniqueInput;
};

export type AirportUpdateWithWhereUniqueWithoutFlightsInput = {
  data: AirportUpdateWithoutFlightsInput;
  where: AirportWhereUniqueInput;
};

export type AirportUpdateWithoutFavoriteRoutesInput = {
  city?: InputMaybe<Scalars['String']>;
  continent?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation?: InputMaybe<Scalars['Int']>;
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutRouteNestedInput>;
  gps?: InputMaybe<Scalars['String']>;
  iata?: InputMaybe<Scalars['String']>;
  icao?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isoCountry?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  legacyId?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportUpdateWithoutFlightsInput = {
  city?: InputMaybe<Scalars['String']>;
  continent?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  elevation?: InputMaybe<Scalars['Int']>;
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<Scalars['String']>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutAirportsNestedInput>;
  gps?: InputMaybe<Scalars['String']>;
  iata?: InputMaybe<Scalars['String']>;
  icao?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isoCountry?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  legacyId?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AirportUpsertWithWhereUniqueWithoutFavoriteRoutesInput = {
  create: AirportCreateWithoutFavoriteRoutesInput;
  update: AirportUpdateWithoutFavoriteRoutesInput;
  where: AirportWhereUniqueInput;
};

export type AirportUpsertWithWhereUniqueWithoutFlightsInput = {
  create: AirportCreateWithoutFlightsInput;
  update: AirportUpdateWithoutFlightsInput;
  where: AirportWhereUniqueInput;
};

export type AirportWhereInput = {
  AND?: InputMaybe<Array<AirportWhereInput>>;
  NOT?: InputMaybe<Array<AirportWhereInput>>;
  OR?: InputMaybe<Array<AirportWhereInput>>;
  city?: InputMaybe<StringFilter>;
  continent?: InputMaybe<StringFilter>;
  county?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  elevation?: InputMaybe<IntFilter>;
  facilityName?: InputMaybe<StringFilter>;
  facilityType?: InputMaybe<StringFilter>;
  favoriteRoutes?: InputMaybe<FavoriteRouteListRelationFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  gps?: InputMaybe<StringFilter>;
  iata?: InputMaybe<StringFilter>;
  icao?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isoCountry?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<DecimalFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  longitude?: InputMaybe<DecimalFilter>;
  state?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AirportWhereUniqueInput = {
  AND?: InputMaybe<Array<AirportWhereInput>>;
  NOT?: InputMaybe<Array<AirportWhereInput>>;
  OR?: InputMaybe<Array<AirportWhereInput>>;
  city?: InputMaybe<StringFilter>;
  continent?: InputMaybe<StringFilter>;
  county?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  elevation?: InputMaybe<IntFilter>;
  facilityName?: InputMaybe<StringFilter>;
  facilityType?: InputMaybe<StringFilter>;
  favoriteRoutes?: InputMaybe<FavoriteRouteListRelationFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  gps?: InputMaybe<StringFilter>;
  iata?: InputMaybe<StringFilter>;
  icao?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']>;
  isoCountry?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<DecimalFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<DecimalFilter>;
  state?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AirsyncSetupInput = {
  airSyncId: Scalars['String'];
  craftId: Scalars['String'];
};

export type Announcement = {
  __typename?: 'Announcement';
  _count: AnnouncementCount;
  active: Scalars['Boolean'];
  attachments?: Maybe<Array<Attachment>>;
  authorName: Scalars['String'];
  canEdit: Scalars['Boolean'];
  comments?: Maybe<Array<Comment>>;
  content: Scalars['String'];
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creator: UserOrganizationProfile;
  creatorId: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  didMessage: Scalars['Boolean'];
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  organization: Organization;
  organizationId: Scalars['String'];
  pinned: Scalars['Boolean'];
  readBy?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AnnouncementCount = {
  __typename?: 'AnnouncementCount';
  attachments: Scalars['Int'];
  comments: Scalars['Int'];
};

export type AnnouncementCountAggregate = {
  __typename?: 'AnnouncementCountAggregate';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  content: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  creatorId: Scalars['Int'];
  deletedAt: Scalars['Int'];
  didMessage: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  organizationId: Scalars['Int'];
  pinned: Scalars['Int'];
  readBy: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type AnnouncementCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutAnnouncementInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutAnnouncementInput>;
  content: Scalars['String'];
  craft?: InputMaybe<CraftCreateNestedOneWithoutAnnouncementsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutAnnouncementsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutAnnouncementsInput;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateManyCraftInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creatorId: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateManyCraftInputEnvelope = {
  data: Array<AnnouncementCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnnouncementCreateManyCreatorInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateManyCreatorInputEnvelope = {
  data: Array<AnnouncementCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnnouncementCreateManyOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  content: Scalars['String'];
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creatorId: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateManyOrganizationInputEnvelope = {
  data: Array<AnnouncementCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AnnouncementCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<AnnouncementCreateWithoutCraftInput>>;
  createMany?: InputMaybe<AnnouncementCreateManyCraftInputEnvelope>;
};

export type AnnouncementCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<AnnouncementCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<AnnouncementCreateManyCreatorInputEnvelope>;
};

export type AnnouncementCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<AnnouncementCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<AnnouncementCreateManyOrganizationInputEnvelope>;
};

export type AnnouncementCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnnouncementCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<AnnouncementCreateWithoutAttachmentsInput>;
};

export type AnnouncementCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnnouncementCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<AnnouncementCreateWithoutCommentsInput>;
};

export type AnnouncementCreateOrConnectWithoutAttachmentsInput = {
  create: AnnouncementCreateWithoutAttachmentsInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementCreateOrConnectWithoutCommentsInput = {
  create: AnnouncementCreateWithoutCommentsInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementCreateOrConnectWithoutCraftInput = {
  create: AnnouncementCreateWithoutCraftInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementCreateOrConnectWithoutCreatorInput = {
  create: AnnouncementCreateWithoutCreatorInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementCreateOrConnectWithoutOrganizationInput = {
  create: AnnouncementCreateWithoutOrganizationInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementCreateWithoutAttachmentsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutAnnouncementInput>;
  content: Scalars['String'];
  craft?: InputMaybe<CraftCreateNestedOneWithoutAnnouncementsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutAnnouncementsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutAnnouncementsInput;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateWithoutCommentsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutAnnouncementInput>;
  content: Scalars['String'];
  craft?: InputMaybe<CraftCreateNestedOneWithoutAnnouncementsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutAnnouncementsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutAnnouncementsInput;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateWithoutCraftInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutAnnouncementInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutAnnouncementInput>;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutAnnouncementsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutAnnouncementsInput;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateWithoutCreatorInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutAnnouncementInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutAnnouncementInput>;
  content: Scalars['String'];
  craft?: InputMaybe<CraftCreateNestedOneWithoutAnnouncementsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization: OrganizationCreateNestedOneWithoutAnnouncementsInput;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementCreateWithoutOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutAnnouncementInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutAnnouncementInput>;
  content: Scalars['String'];
  craft?: InputMaybe<CraftCreateNestedOneWithoutAnnouncementsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutAnnouncementsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementListRelationFilter = {
  every?: InputMaybe<AnnouncementWhereInput>;
  none?: InputMaybe<AnnouncementWhereInput>;
  some?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementMaxAggregate = {
  __typename?: 'AnnouncementMaxAggregate';
  active?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  didMessage?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AnnouncementMinAggregate = {
  __typename?: 'AnnouncementMinAggregate';
  active?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  didMessage?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AnnouncementNullableScalarRelationFilter = {
  is?: InputMaybe<AnnouncementWhereInput>;
  isNot?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AnnouncementScalarRelationFilter = {
  is?: InputMaybe<AnnouncementWhereInput>;
  isNot?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementScalarWhereInput = {
  AND?: InputMaybe<Array<AnnouncementScalarWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementScalarWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  content?: InputMaybe<StringFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  didMessage?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringFilter>;
  pinned?: InputMaybe<BoolFilter>;
  readBy?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AnnouncementUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutAnnouncementNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutAnnouncementNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  craft?: InputMaybe<CraftUpdateOneWithoutAnnouncementsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpdateManyWithWhereWithoutCraftInput = {
  data: AnnouncementUpdateManyMutationInput;
  where: AnnouncementScalarWhereInput;
};

export type AnnouncementUpdateManyWithWhereWithoutCreatorInput = {
  data: AnnouncementUpdateManyMutationInput;
  where: AnnouncementScalarWhereInput;
};

export type AnnouncementUpdateManyWithWhereWithoutOrganizationInput = {
  data: AnnouncementUpdateManyMutationInput;
  where: AnnouncementScalarWhereInput;
};

export type AnnouncementUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<AnnouncementCreateWithoutCraftInput>>;
  createMany?: InputMaybe<AnnouncementCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnnouncementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  set?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  update?: InputMaybe<Array<AnnouncementUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<AnnouncementUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<AnnouncementUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type AnnouncementUpdateManyWithoutCreatorNestedInput = {
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<AnnouncementCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<AnnouncementCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnnouncementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  set?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  update?: InputMaybe<Array<AnnouncementUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<AnnouncementUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<AnnouncementUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type AnnouncementUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AnnouncementCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<AnnouncementCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<AnnouncementCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AnnouncementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  set?: InputMaybe<Array<AnnouncementWhereUniqueInput>>;
  update?: InputMaybe<Array<AnnouncementUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<AnnouncementUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<AnnouncementUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type AnnouncementUpdateOneRequiredWithoutCommentsNestedInput = {
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnnouncementCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<AnnouncementCreateWithoutCommentsInput>;
  update?: InputMaybe<AnnouncementUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<AnnouncementUpsertWithoutCommentsInput>;
};

export type AnnouncementUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<AnnouncementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AnnouncementCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<AnnouncementCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<AnnouncementWhereInput>;
  disconnect?: InputMaybe<AnnouncementWhereInput>;
  update?: InputMaybe<AnnouncementUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<AnnouncementUpsertWithoutAttachmentsInput>;
};

export type AnnouncementUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: AnnouncementUpdateWithoutAttachmentsInput;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementUpdateToOneWithWhereWithoutCommentsInput = {
  data: AnnouncementUpdateWithoutCommentsInput;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementUpdateWithWhereUniqueWithoutCraftInput = {
  data: AnnouncementUpdateWithoutCraftInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpdateWithWhereUniqueWithoutCreatorInput = {
  data: AnnouncementUpdateWithoutCreatorInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: AnnouncementUpdateWithoutOrganizationInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpdateWithoutAttachmentsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  comments?: InputMaybe<CommentUpdateManyWithoutAnnouncementNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  craft?: InputMaybe<CraftUpdateOneWithoutAnnouncementsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpdateWithoutCommentsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutAnnouncementNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  craft?: InputMaybe<CraftUpdateOneWithoutAnnouncementsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpdateWithoutCraftInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutAnnouncementNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutAnnouncementNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpdateWithoutCreatorInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutAnnouncementNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutAnnouncementNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  craft?: InputMaybe<CraftUpdateOneWithoutAnnouncementsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpdateWithoutOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutAnnouncementNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutAnnouncementNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  craft?: InputMaybe<CraftUpdateOneWithoutAnnouncementsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutAnnouncementsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  didMessage?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  readBy?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AnnouncementUpsertWithWhereUniqueWithoutCraftInput = {
  create: AnnouncementCreateWithoutCraftInput;
  update: AnnouncementUpdateWithoutCraftInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpsertWithWhereUniqueWithoutCreatorInput = {
  create: AnnouncementCreateWithoutCreatorInput;
  update: AnnouncementUpdateWithoutCreatorInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: AnnouncementCreateWithoutOrganizationInput;
  update: AnnouncementUpdateWithoutOrganizationInput;
  where: AnnouncementWhereUniqueInput;
};

export type AnnouncementUpsertWithoutAttachmentsInput = {
  create: AnnouncementCreateWithoutAttachmentsInput;
  update: AnnouncementUpdateWithoutAttachmentsInput;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementUpsertWithoutCommentsInput = {
  create: AnnouncementCreateWithoutCommentsInput;
  update: AnnouncementUpdateWithoutCommentsInput;
  where?: InputMaybe<AnnouncementWhereInput>;
};

export type AnnouncementWhereInput = {
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserOrganizationProfileScalarRelationFilter>;
  creatorId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  didMessage?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  pinned?: InputMaybe<BoolFilter>;
  readBy?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type AnnouncementWhereUniqueInput = {
  AND?: InputMaybe<Array<AnnouncementWhereInput>>;
  NOT?: InputMaybe<Array<AnnouncementWhereInput>>;
  OR?: InputMaybe<Array<AnnouncementWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  content?: InputMaybe<StringFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserOrganizationProfileScalarRelationFilter>;
  creatorId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  didMessage?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationScalarRelationFilter>;
  organizationId?: InputMaybe<StringFilter>;
  pinned?: InputMaybe<BoolFilter>;
  readBy?: InputMaybe<StringNullableListFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Attachment = {
  __typename?: 'Attachment';
  _count: AttachmentCount;
  announcement?: Maybe<Announcement>;
  announcementId?: Maybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  digitalSignatures?: Maybe<Array<DigitalSignature>>;
  documents?: Maybe<Array<Document>>;
  fileType: Scalars['String'];
  flight?: Maybe<Flight>;
  flightId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  import?: Maybe<Import>;
  importId?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: Maybe<Scalars['String']>;
  logEntry?: Maybe<LogEntry>;
  logEntryId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  mimeType?: Maybe<Scalars['String']>;
  mroEmployeeProfile?: Maybe<MroEmployeeProfile>;
  mroOrgBAndWIcon?: Maybe<Array<MroOrganization>>;
  mroOrgColorIcon?: Maybe<Array<MroOrganization>>;
  mroReports?: Maybe<Array<MroReport>>;
  mroWorkOrderItems?: Maybe<Array<MroWorkOrderItem>>;
  name: Scalars['String'];
  signedUrl: Scalars['String'];
  size: Scalars['Int'];
  squawk?: Maybe<Squawk>;
  squawkId?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: Maybe<UsageRecord>;
  usageRecordId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  userOrganizationProfile?: Maybe<UserOrganizationProfile>;
  userOrganizationProfileId?: Maybe<Scalars['String']>;
};

export type AttachmentAvgAggregate = {
  __typename?: 'AttachmentAvgAggregate';
  size?: Maybe<Scalars['Float']>;
};

export type AttachmentCount = {
  __typename?: 'AttachmentCount';
  digitalSignatures: Scalars['Int'];
  documents: Scalars['Int'];
  mroOrgBAndWIcon: Scalars['Int'];
  mroOrgColorIcon: Scalars['Int'];
  mroReports: Scalars['Int'];
  mroWorkOrderItems: Scalars['Int'];
};

export type AttachmentCountAggregate = {
  __typename?: 'AttachmentCountAggregate';
  _all: Scalars['Int'];
  announcementId: Scalars['Int'];
  bucket: Scalars['Int'];
  checksum: Scalars['Int'];
  contentType: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  flightId: Scalars['Int'];
  id: Scalars['Int'];
  importId: Scalars['Int'];
  key: Scalars['Int'];
  legacyId: Scalars['Int'];
  logEntryId: Scalars['Int'];
  metadata: Scalars['Int'];
  mimeType: Scalars['Int'];
  name: Scalars['Int'];
  size: Scalars['Int'];
  squawkId: Scalars['Int'];
  transactionId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  url: Scalars['Int'];
  usageRecordId: Scalars['Int'];
  userId: Scalars['Int'];
  userOrganizationProfileId: Scalars['Int'];
};

export type AttachmentCreateManyAnnouncementInput = {
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyAnnouncementInputEnvelope = {
  data: Array<AttachmentCreateManyAnnouncementInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyFlightInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyFlightInputEnvelope = {
  data: Array<AttachmentCreateManyFlightInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyImportInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyImportInputEnvelope = {
  data: Array<AttachmentCreateManyImportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyLogEntryInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyLogEntryInputEnvelope = {
  data: Array<AttachmentCreateManyLogEntryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManySquawkInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManySquawkInputEnvelope = {
  data: Array<AttachmentCreateManySquawkInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyTransactionInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyTransactionInputEnvelope = {
  data: Array<AttachmentCreateManyTransactionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyUsageRecordInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyUsageRecordInputEnvelope = {
  data: Array<AttachmentCreateManyUsageRecordInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyUserInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyUserInputEnvelope = {
  data: Array<AttachmentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateManyUserOrganizationProfileInput = {
  announcementId?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntryId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawkId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecordId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type AttachmentCreateManyUserOrganizationProfileInputEnvelope = {
  data: Array<AttachmentCreateManyUserOrganizationProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AttachmentCreateNestedManyWithoutAnnouncementInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<AttachmentCreateManyAnnouncementInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutFlightInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutFlightInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutFlightInput>>;
  createMany?: InputMaybe<AttachmentCreateManyFlightInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutImportInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutImportInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutImportInput>>;
  createMany?: InputMaybe<AttachmentCreateManyImportInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutLogEntryInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutLogEntryInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutLogEntryInput>>;
  createMany?: InputMaybe<AttachmentCreateManyLogEntryInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutMroWorkOrderItemsInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutMroWorkOrderItemsInput>>;
};

export type AttachmentCreateNestedManyWithoutSquawkInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutSquawkInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutSquawkInput>>;
  createMany?: InputMaybe<AttachmentCreateManySquawkInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutTransactionInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutTransactionInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutTransactionInput>>;
  createMany?: InputMaybe<AttachmentCreateManyTransactionInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutUsageRecordInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutUsageRecordInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutUsageRecordInput>>;
  createMany?: InputMaybe<AttachmentCreateManyUsageRecordInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutUserInput>>;
  createMany?: InputMaybe<AttachmentCreateManyUserInputEnvelope>;
};

export type AttachmentCreateNestedManyWithoutUserOrganizationProfileInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutUserOrganizationProfileInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutUserOrganizationProfileInput>>;
  createMany?: InputMaybe<AttachmentCreateManyUserOrganizationProfileInputEnvelope>;
};

export type AttachmentCreateNestedOneWithoutDigitalSignaturesInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutDigitalSignaturesInput>;
  create?: InputMaybe<AttachmentCreateWithoutDigitalSignaturesInput>;
};

export type AttachmentCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<AttachmentCreateWithoutDocumentsInput>;
};

export type AttachmentCreateNestedOneWithoutMroEmployeeProfileInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroEmployeeProfileInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroEmployeeProfileInput>;
};

export type AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroOrgBAndWIconInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroOrgBAndWIconInput>;
};

export type AttachmentCreateNestedOneWithoutMroOrgColorIconInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroOrgColorIconInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroOrgColorIconInput>;
};

export type AttachmentCreateNestedOneWithoutMroReportsInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroReportsInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroReportsInput>;
};

export type AttachmentCreateOrConnectWithoutAnnouncementInput = {
  create: AttachmentCreateWithoutAnnouncementInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutDigitalSignaturesInput = {
  create: AttachmentCreateWithoutDigitalSignaturesInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutDocumentsInput = {
  create: AttachmentCreateWithoutDocumentsInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutFlightInput = {
  create: AttachmentCreateWithoutFlightInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutImportInput = {
  create: AttachmentCreateWithoutImportInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutLogEntryInput = {
  create: AttachmentCreateWithoutLogEntryInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutMroEmployeeProfileInput = {
  create: AttachmentCreateWithoutMroEmployeeProfileInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutMroOrgBAndWIconInput = {
  create: AttachmentCreateWithoutMroOrgBAndWIconInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutMroOrgColorIconInput = {
  create: AttachmentCreateWithoutMroOrgColorIconInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutMroReportsInput = {
  create: AttachmentCreateWithoutMroReportsInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutMroWorkOrderItemsInput = {
  create: AttachmentCreateWithoutMroWorkOrderItemsInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutSquawkInput = {
  create: AttachmentCreateWithoutSquawkInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutTransactionInput = {
  create: AttachmentCreateWithoutTransactionInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutUsageRecordInput = {
  create: AttachmentCreateWithoutUsageRecordInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutUserInput = {
  create: AttachmentCreateWithoutUserInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateOrConnectWithoutUserOrganizationProfileInput = {
  create: AttachmentCreateWithoutUserOrganizationProfileInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentCreateWithoutAnnouncementInput = {
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutDigitalSignaturesInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutDocumentsInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutFlightInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutImportInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutLogEntryInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutMroEmployeeProfileInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutMroOrgBAndWIconInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutMroOrgColorIconInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutMroReportsInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutMroWorkOrderItemsInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutSquawkInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutTransactionInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutUsageRecordInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutUserInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput>;
};

export type AttachmentCreateWithoutUserOrganizationProfileInput = {
  announcement?: InputMaybe<AnnouncementCreateNestedOneWithoutAttachmentsInput>;
  bucket: Scalars['String'];
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutAttachmentInput>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutAttachmentsInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutAttachmentsInput>;
  key: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedOneWithoutAttachmentsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroColorIconInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutAttachmentInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput>;
  name: Scalars['String'];
  size: Scalars['Int'];
  squawk?: InputMaybe<SquawkCreateNestedOneWithoutAttachmentsInput>;
  transaction?: InputMaybe<TransactionCreateNestedOneWithoutAttachmentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutAttachmentsInput>;
  user?: InputMaybe<UserCreateNestedOneWithoutAttachmentsInput>;
};

export type AttachmentListRelationFilter = {
  every?: InputMaybe<AttachmentWhereInput>;
  none?: InputMaybe<AttachmentWhereInput>;
  some?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentMaxAggregate = {
  __typename?: 'AttachmentMaxAggregate';
  announcementId?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logEntryId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  squawkId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  usageRecordId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userOrganizationProfileId?: Maybe<Scalars['String']>;
};

export type AttachmentMinAggregate = {
  __typename?: 'AttachmentMinAggregate';
  announcementId?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  checksum?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logEntryId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Int']>;
  squawkId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  usageRecordId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userOrganizationProfileId?: Maybe<Scalars['String']>;
};

export type AttachmentNullableScalarRelationFilter = {
  is?: InputMaybe<AttachmentWhereInput>;
  isNot?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AttachmentScalarWhereInput = {
  AND?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  OR?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  announcementId?: InputMaybe<StringNullableFilter>;
  bucket?: InputMaybe<StringFilter>;
  checksum?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  importId?: InputMaybe<StringNullableFilter>;
  key?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logEntryId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  mimeType?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  size?: InputMaybe<IntFilter>;
  squawkId?: InputMaybe<StringNullableFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  url?: InputMaybe<StringFilter>;
  usageRecordId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userOrganizationProfileId?: InputMaybe<StringNullableFilter>;
};

export type AttachmentSumAggregate = {
  __typename?: 'AttachmentSumAggregate';
  size?: Maybe<Scalars['Int']>;
};

export type AttachmentUpdateManyMutationInput = {
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type AttachmentUpdateManyWithWhereWithoutAnnouncementInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutFlightInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutImportInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutLogEntryInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutMroWorkOrderItemsInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutSquawkInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutTransactionInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutUsageRecordInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutUserInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithWhereWithoutUserOrganizationProfileInput = {
  data: AttachmentUpdateManyMutationInput;
  where: AttachmentScalarWhereInput;
};

export type AttachmentUpdateManyWithoutAnnouncementNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<AttachmentCreateManyAnnouncementInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutAnnouncementInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutAnnouncementInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutAnnouncementInput>>;
};

export type AttachmentUpdateManyWithoutFlightNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutFlightInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutFlightInput>>;
  createMany?: InputMaybe<AttachmentCreateManyFlightInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutFlightInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutFlightInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutFlightInput>>;
};

export type AttachmentUpdateManyWithoutImportNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutImportInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutImportInput>>;
  createMany?: InputMaybe<AttachmentCreateManyImportInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutImportInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutImportInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutImportInput>>;
};

export type AttachmentUpdateManyWithoutLogEntryNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutLogEntryInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutLogEntryInput>>;
  createMany?: InputMaybe<AttachmentCreateManyLogEntryInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutLogEntryInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutLogEntryInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutLogEntryInput>>;
};

export type AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutMroWorkOrderItemsInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutMroWorkOrderItemsInput>>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutMroWorkOrderItemsInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutMroWorkOrderItemsInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutMroWorkOrderItemsInput>>;
};

export type AttachmentUpdateManyWithoutSquawkNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutSquawkInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutSquawkInput>>;
  createMany?: InputMaybe<AttachmentCreateManySquawkInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutSquawkInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutSquawkInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutSquawkInput>>;
};

export type AttachmentUpdateManyWithoutTransactionNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutTransactionInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutTransactionInput>>;
  createMany?: InputMaybe<AttachmentCreateManyTransactionInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutTransactionInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutTransactionInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutTransactionInput>>;
};

export type AttachmentUpdateManyWithoutUsageRecordNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutUsageRecordInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutUsageRecordInput>>;
  createMany?: InputMaybe<AttachmentCreateManyUsageRecordInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutUsageRecordInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutUsageRecordInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutUsageRecordInput>>;
};

export type AttachmentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutUserInput>>;
  createMany?: InputMaybe<AttachmentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput = {
  connect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AttachmentCreateOrConnectWithoutUserOrganizationProfileInput>>;
  create?: InputMaybe<Array<AttachmentCreateWithoutUserOrganizationProfileInput>>;
  createMany?: InputMaybe<AttachmentCreateManyUserOrganizationProfileInputEnvelope>;
  delete?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AttachmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  set?: InputMaybe<Array<AttachmentWhereUniqueInput>>;
  update?: InputMaybe<Array<AttachmentUpdateWithWhereUniqueWithoutUserOrganizationProfileInput>>;
  updateMany?: InputMaybe<Array<AttachmentUpdateManyWithWhereWithoutUserOrganizationProfileInput>>;
  upsert?: InputMaybe<Array<AttachmentUpsertWithWhereUniqueWithoutUserOrganizationProfileInput>>;
};

export type AttachmentUpdateOneWithoutDigitalSignaturesNestedInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutDigitalSignaturesInput>;
  create?: InputMaybe<AttachmentCreateWithoutDigitalSignaturesInput>;
  delete?: InputMaybe<AttachmentWhereInput>;
  disconnect?: InputMaybe<AttachmentWhereInput>;
  update?: InputMaybe<AttachmentUpdateToOneWithWhereWithoutDigitalSignaturesInput>;
  upsert?: InputMaybe<AttachmentUpsertWithoutDigitalSignaturesInput>;
};

export type AttachmentUpdateOneWithoutDocumentsNestedInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<AttachmentCreateWithoutDocumentsInput>;
  delete?: InputMaybe<AttachmentWhereInput>;
  disconnect?: InputMaybe<AttachmentWhereInput>;
  update?: InputMaybe<AttachmentUpdateToOneWithWhereWithoutDocumentsInput>;
  upsert?: InputMaybe<AttachmentUpsertWithoutDocumentsInput>;
};

export type AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroEmployeeProfileInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroEmployeeProfileInput>;
  delete?: InputMaybe<AttachmentWhereInput>;
  disconnect?: InputMaybe<AttachmentWhereInput>;
  update?: InputMaybe<AttachmentUpdateToOneWithWhereWithoutMroEmployeeProfileInput>;
  upsert?: InputMaybe<AttachmentUpsertWithoutMroEmployeeProfileInput>;
};

export type AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroOrgBAndWIconInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroOrgBAndWIconInput>;
  delete?: InputMaybe<AttachmentWhereInput>;
  disconnect?: InputMaybe<AttachmentWhereInput>;
  update?: InputMaybe<AttachmentUpdateToOneWithWhereWithoutMroOrgBAndWIconInput>;
  upsert?: InputMaybe<AttachmentUpsertWithoutMroOrgBAndWIconInput>;
};

export type AttachmentUpdateOneWithoutMroOrgColorIconNestedInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroOrgColorIconInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroOrgColorIconInput>;
  delete?: InputMaybe<AttachmentWhereInput>;
  disconnect?: InputMaybe<AttachmentWhereInput>;
  update?: InputMaybe<AttachmentUpdateToOneWithWhereWithoutMroOrgColorIconInput>;
  upsert?: InputMaybe<AttachmentUpsertWithoutMroOrgColorIconInput>;
};

export type AttachmentUpdateOneWithoutMroReportsNestedInput = {
  connect?: InputMaybe<AttachmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AttachmentCreateOrConnectWithoutMroReportsInput>;
  create?: InputMaybe<AttachmentCreateWithoutMroReportsInput>;
  delete?: InputMaybe<AttachmentWhereInput>;
  disconnect?: InputMaybe<AttachmentWhereInput>;
  update?: InputMaybe<AttachmentUpdateToOneWithWhereWithoutMroReportsInput>;
  upsert?: InputMaybe<AttachmentUpsertWithoutMroReportsInput>;
};

export type AttachmentUpdateToOneWithWhereWithoutDigitalSignaturesInput = {
  data: AttachmentUpdateWithoutDigitalSignaturesInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpdateToOneWithWhereWithoutDocumentsInput = {
  data: AttachmentUpdateWithoutDocumentsInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpdateToOneWithWhereWithoutMroEmployeeProfileInput = {
  data: AttachmentUpdateWithoutMroEmployeeProfileInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpdateToOneWithWhereWithoutMroOrgBAndWIconInput = {
  data: AttachmentUpdateWithoutMroOrgBAndWIconInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpdateToOneWithWhereWithoutMroOrgColorIconInput = {
  data: AttachmentUpdateWithoutMroOrgColorIconInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpdateToOneWithWhereWithoutMroReportsInput = {
  data: AttachmentUpdateWithoutMroReportsInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpdateWithWhereUniqueWithoutAnnouncementInput = {
  data: AttachmentUpdateWithoutAnnouncementInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutFlightInput = {
  data: AttachmentUpdateWithoutFlightInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutImportInput = {
  data: AttachmentUpdateWithoutImportInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutLogEntryInput = {
  data: AttachmentUpdateWithoutLogEntryInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutMroWorkOrderItemsInput = {
  data: AttachmentUpdateWithoutMroWorkOrderItemsInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutSquawkInput = {
  data: AttachmentUpdateWithoutSquawkInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutTransactionInput = {
  data: AttachmentUpdateWithoutTransactionInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutUsageRecordInput = {
  data: AttachmentUpdateWithoutUsageRecordInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutUserInput = {
  data: AttachmentUpdateWithoutUserInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithWhereUniqueWithoutUserOrganizationProfileInput = {
  data: AttachmentUpdateWithoutUserOrganizationProfileInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpdateWithoutAnnouncementInput = {
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutDigitalSignaturesInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutDocumentsInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutFlightInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutImportInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutLogEntryInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutMroEmployeeProfileInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutMroOrgBAndWIconInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutMroOrgColorIconInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutMroReportsInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutMroWorkOrderItemsInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutSquawkInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutTransactionInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutUsageRecordInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutUserInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput>;
};

export type AttachmentUpdateWithoutUserOrganizationProfileInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneWithoutAttachmentsNestedInput>;
  bucket?: InputMaybe<Scalars['String']>;
  checksum?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput>;
  documents?: InputMaybe<DocumentUpdateManyWithoutAttachmentNestedInput>;
  flight?: InputMaybe<FlightUpdateOneWithoutAttachmentsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutAttachmentsNestedInput>;
  key?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateOneWithoutAttachmentsNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mimeType?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationUpdateManyWithoutMroColorIconNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutAttachmentNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  squawk?: InputMaybe<SquawkUpdateOneWithoutAttachmentsNestedInput>;
  transaction?: InputMaybe<TransactionUpdateOneWithoutAttachmentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutAttachmentsNestedInput>;
  user?: InputMaybe<UserUpdateOneWithoutAttachmentsNestedInput>;
};

export type AttachmentUpsertWithWhereUniqueWithoutAnnouncementInput = {
  create: AttachmentCreateWithoutAnnouncementInput;
  update: AttachmentUpdateWithoutAnnouncementInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutFlightInput = {
  create: AttachmentCreateWithoutFlightInput;
  update: AttachmentUpdateWithoutFlightInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutImportInput = {
  create: AttachmentCreateWithoutImportInput;
  update: AttachmentUpdateWithoutImportInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutLogEntryInput = {
  create: AttachmentCreateWithoutLogEntryInput;
  update: AttachmentUpdateWithoutLogEntryInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutMroWorkOrderItemsInput = {
  create: AttachmentCreateWithoutMroWorkOrderItemsInput;
  update: AttachmentUpdateWithoutMroWorkOrderItemsInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutSquawkInput = {
  create: AttachmentCreateWithoutSquawkInput;
  update: AttachmentUpdateWithoutSquawkInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutTransactionInput = {
  create: AttachmentCreateWithoutTransactionInput;
  update: AttachmentUpdateWithoutTransactionInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutUsageRecordInput = {
  create: AttachmentCreateWithoutUsageRecordInput;
  update: AttachmentUpdateWithoutUsageRecordInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutUserInput = {
  create: AttachmentCreateWithoutUserInput;
  update: AttachmentUpdateWithoutUserInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithWhereUniqueWithoutUserOrganizationProfileInput = {
  create: AttachmentCreateWithoutUserOrganizationProfileInput;
  update: AttachmentUpdateWithoutUserOrganizationProfileInput;
  where: AttachmentWhereUniqueInput;
};

export type AttachmentUpsertWithoutDigitalSignaturesInput = {
  create: AttachmentCreateWithoutDigitalSignaturesInput;
  update: AttachmentUpdateWithoutDigitalSignaturesInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpsertWithoutDocumentsInput = {
  create: AttachmentCreateWithoutDocumentsInput;
  update: AttachmentUpdateWithoutDocumentsInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpsertWithoutMroEmployeeProfileInput = {
  create: AttachmentCreateWithoutMroEmployeeProfileInput;
  update: AttachmentUpdateWithoutMroEmployeeProfileInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpsertWithoutMroOrgBAndWIconInput = {
  create: AttachmentCreateWithoutMroOrgBAndWIconInput;
  update: AttachmentUpdateWithoutMroOrgBAndWIconInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpsertWithoutMroOrgColorIconInput = {
  create: AttachmentCreateWithoutMroOrgColorIconInput;
  update: AttachmentUpdateWithoutMroOrgColorIconInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentUpsertWithoutMroReportsInput = {
  create: AttachmentCreateWithoutMroReportsInput;
  update: AttachmentUpdateWithoutMroReportsInput;
  where?: InputMaybe<AttachmentWhereInput>;
};

export type AttachmentWhereInput = {
  AND?: InputMaybe<Array<AttachmentWhereInput>>;
  NOT?: InputMaybe<Array<AttachmentWhereInput>>;
  OR?: InputMaybe<Array<AttachmentWhereInput>>;
  announcement?: InputMaybe<AnnouncementNullableScalarRelationFilter>;
  announcementId?: InputMaybe<StringNullableFilter>;
  bucket?: InputMaybe<StringFilter>;
  checksum?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  digitalSignatures?: InputMaybe<DigitalSignatureListRelationFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  import?: InputMaybe<ImportNullableScalarRelationFilter>;
  importId?: InputMaybe<StringNullableFilter>;
  key?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logEntry?: InputMaybe<LogEntryNullableScalarRelationFilter>;
  logEntryId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  mimeType?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationListRelationFilter>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationListRelationFilter>;
  mroReports?: InputMaybe<MroReportListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  size?: InputMaybe<IntFilter>;
  squawk?: InputMaybe<SquawkNullableScalarRelationFilter>;
  squawkId?: InputMaybe<StringNullableFilter>;
  transaction?: InputMaybe<TransactionNullableScalarRelationFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  url?: InputMaybe<StringFilter>;
  usageRecord?: InputMaybe<UsageRecordNullableScalarRelationFilter>;
  usageRecordId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userOrganizationProfileId?: InputMaybe<StringNullableFilter>;
};

export type AttachmentWhereUniqueInput = {
  AND?: InputMaybe<Array<AttachmentWhereInput>>;
  NOT?: InputMaybe<Array<AttachmentWhereInput>>;
  OR?: InputMaybe<Array<AttachmentWhereInput>>;
  announcement?: InputMaybe<AnnouncementNullableScalarRelationFilter>;
  announcementId?: InputMaybe<StringNullableFilter>;
  bucket?: InputMaybe<StringFilter>;
  checksum?: InputMaybe<StringNullableFilter>;
  contentType?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  digitalSignatures?: InputMaybe<DigitalSignatureListRelationFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportNullableScalarRelationFilter>;
  importId?: InputMaybe<StringNullableFilter>;
  key?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryNullableScalarRelationFilter>;
  logEntryId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  mimeType?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroOrgBAndWIcon?: InputMaybe<MroOrganizationListRelationFilter>;
  mroOrgColorIcon?: InputMaybe<MroOrganizationListRelationFilter>;
  mroReports?: InputMaybe<MroReportListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  size?: InputMaybe<IntFilter>;
  squawk?: InputMaybe<SquawkNullableScalarRelationFilter>;
  squawkId?: InputMaybe<StringNullableFilter>;
  transaction?: InputMaybe<TransactionNullableScalarRelationFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  url?: InputMaybe<StringFilter>;
  usageRecord?: InputMaybe<UsageRecordNullableScalarRelationFilter>;
  usageRecordId?: InputMaybe<StringNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userOrganizationProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userOrganizationProfileId?: InputMaybe<StringNullableFilter>;
};

export enum AuditOperation {
  Delete = 'DELETE',
  Insert = 'INSERT',
  Update = 'UPDATE'
}

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken?: Maybe<Scalars['JWT']>;
  redirectToken?: Maybe<Scalars['String']>;
  /** JWT refresh token */
  refreshToken?: Maybe<Scalars['JWT']>;
  user: User;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type ChangePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type ChargebeeSubscribeInput = {
  cardNumber: Scalars['String'];
  cvv: Scalars['String'];
  month: Scalars['String'];
  promoCode?: InputMaybe<Scalars['String']>;
  year: Scalars['String'];
};

export type ChargebeeSubscription = {
  __typename?: 'ChargebeeSubscription';
  billingAmount: Scalars['String'];
  billingPeriod: Scalars['String'];
  id: Scalars['String'];
  nextBillingInfo: Scalars['String'];
  planName: Scalars['String'];
};

export type ChargebeeUpdateInput = {
  email: Scalars['String'];
  orgName: Scalars['String'];
};

export type Comment = {
  __typename?: 'Comment';
  announcement: Announcement;
  announcementId: Scalars['String'];
  authorName: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  creator: UserOrganizationProfile;
  creatorId: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type CommentCountAggregate = {
  __typename?: 'CommentCountAggregate';
  _all: Scalars['Int'];
  announcementId: Scalars['Int'];
  content: Scalars['Int'];
  createdAt: Scalars['Int'];
  creatorId: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CommentCreateInput = {
  announcement: AnnouncementCreateNestedOneWithoutCommentsInput;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutCommentsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentCreateManyAnnouncementInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creatorId: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentCreateManyAnnouncementInputEnvelope = {
  data: Array<CommentCreateManyAnnouncementInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CommentCreateManyCreatorInput = {
  announcementId: Scalars['String'];
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentCreateManyCreatorInputEnvelope = {
  data: Array<CommentCreateManyCreatorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CommentCreateNestedManyWithoutAnnouncementInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<CommentCreateManyAnnouncementInputEnvelope>;
};

export type CommentCreateNestedManyWithoutCreatorInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<CommentCreateManyCreatorInputEnvelope>;
};

export type CommentCreateOrConnectWithoutAnnouncementInput = {
  create: CommentCreateWithoutAnnouncementInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutCreatorInput = {
  create: CommentCreateWithoutCreatorInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateWithoutAnnouncementInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator: UserOrganizationProfileCreateNestedOneWithoutCommentsInput;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentCreateWithoutCreatorInput = {
  announcement: AnnouncementCreateNestedOneWithoutCommentsInput;
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentListRelationFilter = {
  every?: InputMaybe<CommentWhereInput>;
  none?: InputMaybe<CommentWhereInput>;
  some?: InputMaybe<CommentWhereInput>;
};

export type CommentMaxAggregate = {
  __typename?: 'CommentMaxAggregate';
  announcementId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommentMinAggregate = {
  __typename?: 'CommentMinAggregate';
  announcementId?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommentScalarWhereInput = {
  AND?: InputMaybe<Array<CommentScalarWhereInput>>;
  NOT?: InputMaybe<Array<CommentScalarWhereInput>>;
  OR?: InputMaybe<Array<CommentScalarWhereInput>>;
  announcementId?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creatorId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CommentUpdateInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneRequiredWithoutCommentsNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutCommentsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentUpdateManyMutationInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentUpdateManyWithWhereWithoutAnnouncementInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithWhereWithoutCreatorInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithoutAnnouncementNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutAnnouncementInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutAnnouncementInput>>;
  createMany?: InputMaybe<CommentCreateManyAnnouncementInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutAnnouncementInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutAnnouncementInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutAnnouncementInput>>;
};

export type CommentUpdateManyWithoutCreatorNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutCreatorInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutCreatorInput>>;
  createMany?: InputMaybe<CommentCreateManyCreatorInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutCreatorInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutCreatorInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutCreatorInput>>;
};

export type CommentUpdateWithWhereUniqueWithoutAnnouncementInput = {
  data: CommentUpdateWithoutAnnouncementInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithWhereUniqueWithoutCreatorInput = {
  data: CommentUpdateWithoutCreatorInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithoutAnnouncementInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creator?: InputMaybe<UserOrganizationProfileUpdateOneRequiredWithoutCommentsNestedInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentUpdateWithoutCreatorInput = {
  announcement?: InputMaybe<AnnouncementUpdateOneRequiredWithoutCommentsNestedInput>;
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CommentUpsertWithWhereUniqueWithoutAnnouncementInput = {
  create: CommentCreateWithoutAnnouncementInput;
  update: CommentUpdateWithoutAnnouncementInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithWhereUniqueWithoutCreatorInput = {
  create: CommentCreateWithoutCreatorInput;
  update: CommentUpdateWithoutCreatorInput;
  where: CommentWhereUniqueInput;
};

export type CommentWhereInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  NOT?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  announcement?: InputMaybe<AnnouncementScalarRelationFilter>;
  announcementId?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserOrganizationProfileScalarRelationFilter>;
  creatorId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CommentWhereUniqueInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  NOT?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  announcement?: InputMaybe<AnnouncementScalarRelationFilter>;
  announcementId?: InputMaybe<StringFilter>;
  content?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  creator?: InputMaybe<UserOrganizationProfileScalarRelationFilter>;
  creatorId?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Component = {
  __typename?: 'Component';
  _count: ComponentCount;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inspections?: Maybe<Array<Inspection>>;
  intervals?: Maybe<Array<Interval>>;
  legacyId?: Maybe<Scalars['String']>;
  logBook?: Maybe<LogBook>;
  logBookId?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: Maybe<Scalars['String']>;
  squawks?: Maybe<Array<Squawk>>;
  updatedAt: Scalars['DateTime'];
  year?: Maybe<Scalars['Int']>;
};

export type ComponentAvgAggregate = {
  __typename?: 'ComponentAvgAggregate';
  year?: Maybe<Scalars['Float']>;
};

export type ComponentCount = {
  __typename?: 'ComponentCount';
  inspections: Scalars['Int'];
  intervals: Scalars['Int'];
  squawks: Scalars['Int'];
};

export type ComponentCountAggregate = {
  __typename?: 'ComponentCountAggregate';
  _all: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  logBookId: Scalars['Int'];
  make: Scalars['Int'];
  model: Scalars['Int'];
  name: Scalars['Int'];
  serialNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
  year: Scalars['Int'];
};

export type ComponentCreateInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutComponentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutComponentInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutComponentInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutComponentsInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutComponentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateManyCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBookId?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateManyCraftInputEnvelope = {
  data: Array<ComponentCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentCreateManyLogBookInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateManyLogBookInputEnvelope = {
  data: Array<ComponentCreateManyLogBookInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ComponentCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ComponentCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<ComponentCreateWithoutCraftInput>>;
  createMany?: InputMaybe<ComponentCreateManyCraftInputEnvelope>;
};

export type ComponentCreateNestedManyWithoutLogBookInput = {
  connect?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ComponentCreateOrConnectWithoutLogBookInput>>;
  create?: InputMaybe<Array<ComponentCreateWithoutLogBookInput>>;
  createMany?: InputMaybe<ComponentCreateManyLogBookInputEnvelope>;
};

export type ComponentCreateNestedOneWithoutInspectionsInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutInspectionsInput>;
  create?: InputMaybe<ComponentCreateWithoutInspectionsInput>;
};

export type ComponentCreateNestedOneWithoutIntervalsInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutIntervalsInput>;
  create?: InputMaybe<ComponentCreateWithoutIntervalsInput>;
};

export type ComponentCreateNestedOneWithoutSquawksInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutSquawksInput>;
  create?: InputMaybe<ComponentCreateWithoutSquawksInput>;
};

export type ComponentCreateOrConnectWithoutCraftInput = {
  create: ComponentCreateWithoutCraftInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateOrConnectWithoutInspectionsInput = {
  create: ComponentCreateWithoutInspectionsInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateOrConnectWithoutIntervalsInput = {
  create: ComponentCreateWithoutIntervalsInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateOrConnectWithoutLogBookInput = {
  create: ComponentCreateWithoutLogBookInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateOrConnectWithoutSquawksInput = {
  create: ComponentCreateWithoutSquawksInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateWithoutCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutComponentInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutComponentInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutComponentsInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutComponentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateWithoutInspectionsInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutComponentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutComponentInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutComponentsInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutComponentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateWithoutIntervalsInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutComponentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutComponentInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutComponentsInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutComponentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateWithoutLogBookInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutComponentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutComponentInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutComponentInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutComponentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentCreateWithoutSquawksInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutComponentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutComponentInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutComponentInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutComponentsInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentListRelationFilter = {
  every?: InputMaybe<ComponentWhereInput>;
  none?: InputMaybe<ComponentWhereInput>;
  some?: InputMaybe<ComponentWhereInput>;
};

export type ComponentMaxAggregate = {
  __typename?: 'ComponentMaxAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logBookId?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Int']>;
};

export type ComponentMinAggregate = {
  __typename?: 'ComponentMinAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logBookId?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Int']>;
};

export type ComponentNullableScalarRelationFilter = {
  is?: InputMaybe<ComponentWhereInput>;
  isNot?: InputMaybe<ComponentWhereInput>;
};

export type ComponentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ComponentScalarWhereInput = {
  AND?: InputMaybe<Array<ComponentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ComponentScalarWhereInput>>;
  OR?: InputMaybe<Array<ComponentScalarWhereInput>>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logBookId?: InputMaybe<StringNullableFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  year?: InputMaybe<IntNullableFilter>;
};

export type ComponentSumAggregate = {
  __typename?: 'ComponentSumAggregate';
  year?: Maybe<Scalars['Int']>;
};

export type ComponentUpdateInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutComponentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutComponentNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutComponentNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutComponentsNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutComponentNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpdateManyWithWhereWithoutCraftInput = {
  data: ComponentUpdateManyMutationInput;
  where: ComponentScalarWhereInput;
};

export type ComponentUpdateManyWithWhereWithoutLogBookInput = {
  data: ComponentUpdateManyMutationInput;
  where: ComponentScalarWhereInput;
};

export type ComponentUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ComponentCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<ComponentCreateWithoutCraftInput>>;
  createMany?: InputMaybe<ComponentCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ComponentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  set?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  update?: InputMaybe<Array<ComponentUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<ComponentUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<ComponentUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type ComponentUpdateManyWithoutLogBookNestedInput = {
  connect?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ComponentCreateOrConnectWithoutLogBookInput>>;
  create?: InputMaybe<Array<ComponentCreateWithoutLogBookInput>>;
  createMany?: InputMaybe<ComponentCreateManyLogBookInputEnvelope>;
  delete?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ComponentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  set?: InputMaybe<Array<ComponentWhereUniqueInput>>;
  update?: InputMaybe<Array<ComponentUpdateWithWhereUniqueWithoutLogBookInput>>;
  updateMany?: InputMaybe<Array<ComponentUpdateManyWithWhereWithoutLogBookInput>>;
  upsert?: InputMaybe<Array<ComponentUpsertWithWhereUniqueWithoutLogBookInput>>;
};

export type ComponentUpdateOneWithoutInspectionsNestedInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutInspectionsInput>;
  create?: InputMaybe<ComponentCreateWithoutInspectionsInput>;
  delete?: InputMaybe<ComponentWhereInput>;
  disconnect?: InputMaybe<ComponentWhereInput>;
  update?: InputMaybe<ComponentUpdateToOneWithWhereWithoutInspectionsInput>;
  upsert?: InputMaybe<ComponentUpsertWithoutInspectionsInput>;
};

export type ComponentUpdateOneWithoutIntervalsNestedInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutIntervalsInput>;
  create?: InputMaybe<ComponentCreateWithoutIntervalsInput>;
  delete?: InputMaybe<ComponentWhereInput>;
  disconnect?: InputMaybe<ComponentWhereInput>;
  update?: InputMaybe<ComponentUpdateToOneWithWhereWithoutIntervalsInput>;
  upsert?: InputMaybe<ComponentUpsertWithoutIntervalsInput>;
};

export type ComponentUpdateOneWithoutSquawksNestedInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutSquawksInput>;
  create?: InputMaybe<ComponentCreateWithoutSquawksInput>;
  delete?: InputMaybe<ComponentWhereInput>;
  disconnect?: InputMaybe<ComponentWhereInput>;
  update?: InputMaybe<ComponentUpdateToOneWithWhereWithoutSquawksInput>;
  upsert?: InputMaybe<ComponentUpsertWithoutSquawksInput>;
};

export type ComponentUpdateToOneWithWhereWithoutInspectionsInput = {
  data: ComponentUpdateWithoutInspectionsInput;
  where?: InputMaybe<ComponentWhereInput>;
};

export type ComponentUpdateToOneWithWhereWithoutIntervalsInput = {
  data: ComponentUpdateWithoutIntervalsInput;
  where?: InputMaybe<ComponentWhereInput>;
};

export type ComponentUpdateToOneWithWhereWithoutSquawksInput = {
  data: ComponentUpdateWithoutSquawksInput;
  where?: InputMaybe<ComponentWhereInput>;
};

export type ComponentUpdateWithWhereUniqueWithoutCraftInput = {
  data: ComponentUpdateWithoutCraftInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentUpdateWithWhereUniqueWithoutLogBookInput = {
  data: ComponentUpdateWithoutLogBookInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentUpdateWithoutCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutComponentNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutComponentNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutComponentsNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutComponentNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpdateWithoutInspectionsInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutComponentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutComponentNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutComponentsNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutComponentNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpdateWithoutIntervalsInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutComponentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutComponentNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutComponentsNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutComponentNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpdateWithoutLogBookInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutComponentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutComponentNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutComponentNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutComponentNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpdateWithoutSquawksInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutComponentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutComponentNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutComponentNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutComponentsNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type ComponentUpsertWithWhereUniqueWithoutCraftInput = {
  create: ComponentCreateWithoutCraftInput;
  update: ComponentUpdateWithoutCraftInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentUpsertWithWhereUniqueWithoutLogBookInput = {
  create: ComponentCreateWithoutLogBookInput;
  update: ComponentUpdateWithoutLogBookInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentUpsertWithoutInspectionsInput = {
  create: ComponentCreateWithoutInspectionsInput;
  update: ComponentUpdateWithoutInspectionsInput;
  where?: InputMaybe<ComponentWhereInput>;
};

export type ComponentUpsertWithoutIntervalsInput = {
  create: ComponentCreateWithoutIntervalsInput;
  update: ComponentUpdateWithoutIntervalsInput;
  where?: InputMaybe<ComponentWhereInput>;
};

export type ComponentUpsertWithoutSquawksInput = {
  create: ComponentCreateWithoutSquawksInput;
  update: ComponentUpdateWithoutSquawksInput;
  where?: InputMaybe<ComponentWhereInput>;
};

export type ComponentWhereInput = {
  AND?: InputMaybe<Array<ComponentWhereInput>>;
  NOT?: InputMaybe<Array<ComponentWhereInput>>;
  OR?: InputMaybe<Array<ComponentWhereInput>>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logBook?: InputMaybe<LogBookNullableScalarRelationFilter>;
  logBookId?: InputMaybe<StringNullableFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  year?: InputMaybe<IntNullableFilter>;
};

export type ComponentWhereUniqueInput = {
  AND?: InputMaybe<Array<ComponentWhereInput>>;
  NOT?: InputMaybe<Array<ComponentWhereInput>>;
  OR?: InputMaybe<Array<ComponentWhereInput>>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBook?: InputMaybe<LogBookNullableScalarRelationFilter>;
  logBookId?: InputMaybe<StringNullableFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  year?: InputMaybe<IntNullableFilter>;
};

export type ConsumableEntry = {
  __typename?: 'ConsumableEntry';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flight?: Maybe<Flight>;
  flightId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  subentries?: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['DateTime'];
  userOrgProfile?: Maybe<UserOrganizationProfile>;
  userOrgProfileId?: Maybe<Scalars['String']>;
  value: Scalars['Decimal'];
};

export type ConsumableEntryCreateManyFlightInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrgProfileId?: InputMaybe<Scalars['String']>;
  value: Scalars['Decimal'];
};

export type ConsumableEntryCreateManyFlightInputEnvelope = {
  data: Array<ConsumableEntryCreateManyFlightInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ConsumableEntryCreateManyUserOrgProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value: Scalars['Decimal'];
};

export type ConsumableEntryCreateManyUserOrgProfileInputEnvelope = {
  data: Array<ConsumableEntryCreateManyUserOrgProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ConsumableEntryCreateNestedManyWithoutFlightInput = {
  connect?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConsumableEntryCreateOrConnectWithoutFlightInput>>;
  create?: InputMaybe<Array<ConsumableEntryCreateWithoutFlightInput>>;
  createMany?: InputMaybe<ConsumableEntryCreateManyFlightInputEnvelope>;
};

export type ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput = {
  connect?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConsumableEntryCreateOrConnectWithoutUserOrgProfileInput>>;
  create?: InputMaybe<Array<ConsumableEntryCreateWithoutUserOrgProfileInput>>;
  createMany?: InputMaybe<ConsumableEntryCreateManyUserOrgProfileInputEnvelope>;
};

export type ConsumableEntryCreateOrConnectWithoutFlightInput = {
  create: ConsumableEntryCreateWithoutFlightInput;
  where: ConsumableEntryWhereUniqueInput;
};

export type ConsumableEntryCreateOrConnectWithoutUserOrgProfileInput = {
  create: ConsumableEntryCreateWithoutUserOrgProfileInput;
  where: ConsumableEntryWhereUniqueInput;
};

export type ConsumableEntryCreateWithoutFlightInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrgProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutConsumableEntryInput>;
  value: Scalars['Decimal'];
};

export type ConsumableEntryCreateWithoutUserOrgProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutConsumableEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value: Scalars['Decimal'];
};

export type ConsumableEntryListRelationFilter = {
  every?: InputMaybe<ConsumableEntryWhereInput>;
  none?: InputMaybe<ConsumableEntryWhereInput>;
  some?: InputMaybe<ConsumableEntryWhereInput>;
};

export type ConsumableEntryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ConsumableEntryScalarWhereInput = {
  AND?: InputMaybe<Array<ConsumableEntryScalarWhereInput>>;
  NOT?: InputMaybe<Array<ConsumableEntryScalarWhereInput>>;
  OR?: InputMaybe<Array<ConsumableEntryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  subentries?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userOrgProfileId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<DecimalFilter>;
};

export type ConsumableEntryUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type ConsumableEntryUpdateManyWithWhereWithoutFlightInput = {
  data: ConsumableEntryUpdateManyMutationInput;
  where: ConsumableEntryScalarWhereInput;
};

export type ConsumableEntryUpdateManyWithWhereWithoutUserOrgProfileInput = {
  data: ConsumableEntryUpdateManyMutationInput;
  where: ConsumableEntryScalarWhereInput;
};

export type ConsumableEntryUpdateManyWithoutFlightNestedInput = {
  connect?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConsumableEntryCreateOrConnectWithoutFlightInput>>;
  create?: InputMaybe<Array<ConsumableEntryCreateWithoutFlightInput>>;
  createMany?: InputMaybe<ConsumableEntryCreateManyFlightInputEnvelope>;
  delete?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConsumableEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<ConsumableEntryUpdateWithWhereUniqueWithoutFlightInput>>;
  updateMany?: InputMaybe<Array<ConsumableEntryUpdateManyWithWhereWithoutFlightInput>>;
  upsert?: InputMaybe<Array<ConsumableEntryUpsertWithWhereUniqueWithoutFlightInput>>;
};

export type ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput = {
  connect?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ConsumableEntryCreateOrConnectWithoutUserOrgProfileInput>>;
  create?: InputMaybe<Array<ConsumableEntryCreateWithoutUserOrgProfileInput>>;
  createMany?: InputMaybe<ConsumableEntryCreateManyUserOrgProfileInputEnvelope>;
  delete?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ConsumableEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<ConsumableEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<ConsumableEntryUpdateWithWhereUniqueWithoutUserOrgProfileInput>>;
  updateMany?: InputMaybe<Array<ConsumableEntryUpdateManyWithWhereWithoutUserOrgProfileInput>>;
  upsert?: InputMaybe<Array<ConsumableEntryUpsertWithWhereUniqueWithoutUserOrgProfileInput>>;
};

export type ConsumableEntryUpdateWithWhereUniqueWithoutFlightInput = {
  data: ConsumableEntryUpdateWithoutFlightInput;
  where: ConsumableEntryWhereUniqueInput;
};

export type ConsumableEntryUpdateWithWhereUniqueWithoutUserOrgProfileInput = {
  data: ConsumableEntryUpdateWithoutUserOrgProfileInput;
  where: ConsumableEntryWhereUniqueInput;
};

export type ConsumableEntryUpdateWithoutFlightInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrgProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutConsumableEntryNestedInput>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type ConsumableEntryUpdateWithoutUserOrgProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutConsumableEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  subentries?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type ConsumableEntryUpsertWithWhereUniqueWithoutFlightInput = {
  create: ConsumableEntryCreateWithoutFlightInput;
  update: ConsumableEntryUpdateWithoutFlightInput;
  where: ConsumableEntryWhereUniqueInput;
};

export type ConsumableEntryUpsertWithWhereUniqueWithoutUserOrgProfileInput = {
  create: ConsumableEntryCreateWithoutUserOrgProfileInput;
  update: ConsumableEntryUpdateWithoutUserOrgProfileInput;
  where: ConsumableEntryWhereUniqueInput;
};

export type ConsumableEntryWhereInput = {
  AND?: InputMaybe<Array<ConsumableEntryWhereInput>>;
  NOT?: InputMaybe<Array<ConsumableEntryWhereInput>>;
  OR?: InputMaybe<Array<ConsumableEntryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  subentries?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userOrgProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userOrgProfileId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<DecimalFilter>;
};

export type ConsumableEntryWhereUniqueInput = {
  AND?: InputMaybe<Array<ConsumableEntryWhereInput>>;
  NOT?: InputMaybe<Array<ConsumableEntryWhereInput>>;
  OR?: InputMaybe<Array<ConsumableEntryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  subentries?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userOrgProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userOrgProfileId?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<DecimalFilter>;
};

export type Coupon = {
  __typename?: 'Coupon';
  _count: CouponCount;
  active?: Maybe<Scalars['Boolean']>;
  code: Scalars['String'];
  couponType?: Maybe<CouponType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Decimal']>;
  discountId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  organizations?: Maybe<Array<Organization>>;
  supportedPlans?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CouponAvgAggregate = {
  __typename?: 'CouponAvgAggregate';
  discount?: Maybe<Scalars['Decimal']>;
};

export type CouponCount = {
  __typename?: 'CouponCount';
  organizations: Scalars['Int'];
};

export type CouponCountAggregate = {
  __typename?: 'CouponCountAggregate';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  code: Scalars['Int'];
  couponType: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  discount: Scalars['Int'];
  discountId: Scalars['Int'];
  expiresAt: Scalars['Int'];
  id: Scalars['Int'];
  supportedPlans: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CouponCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  couponType?: InputMaybe<CouponType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Decimal']>;
  discountId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutCouponsInput>;
  supportedPlans?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CouponCreateNestedManyWithoutOrganizationsInput = {
  connect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CouponCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<CouponCreateWithoutOrganizationsInput>>;
};

export type CouponCreateOrConnectWithoutOrganizationsInput = {
  create: CouponCreateWithoutOrganizationsInput;
  where: CouponWhereUniqueInput;
};

export type CouponCreateWithoutOrganizationsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  couponType?: InputMaybe<CouponType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Decimal']>;
  discountId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  supportedPlans?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CouponListRelationFilter = {
  every?: InputMaybe<CouponWhereInput>;
  none?: InputMaybe<CouponWhereInput>;
  some?: InputMaybe<CouponWhereInput>;
};

export type CouponMaxAggregate = {
  __typename?: 'CouponMaxAggregate';
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  couponType?: Maybe<CouponType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Decimal']>;
  discountId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CouponMinAggregate = {
  __typename?: 'CouponMinAggregate';
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  couponType?: Maybe<CouponType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Decimal']>;
  discountId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CouponScalarWhereInput = {
  AND?: InputMaybe<Array<CouponScalarWhereInput>>;
  NOT?: InputMaybe<Array<CouponScalarWhereInput>>;
  OR?: InputMaybe<Array<CouponScalarWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  code?: InputMaybe<StringFilter>;
  couponType?: InputMaybe<EnumCouponTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discount?: InputMaybe<DecimalNullableFilter>;
  discountId?: InputMaybe<StringNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  supportedPlans?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CouponSumAggregate = {
  __typename?: 'CouponSumAggregate';
  discount?: Maybe<Scalars['Decimal']>;
};

export enum CouponType {
  Amount = 'AMOUNT',
  Freedays = 'FREEDAYS',
  Freemonths = 'FREEMONTHS',
  Percentage = 'PERCENTAGE'
}

export type CouponUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<CouponType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Decimal']>;
  discountId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutCouponsNestedInput>;
  supportedPlans?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CouponUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<CouponType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Decimal']>;
  discountId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  supportedPlans?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CouponUpdateManyWithWhereWithoutOrganizationsInput = {
  data: CouponUpdateManyMutationInput;
  where: CouponScalarWhereInput;
};

export type CouponUpdateManyWithoutOrganizationsNestedInput = {
  connect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CouponCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<CouponCreateWithoutOrganizationsInput>>;
  delete?: InputMaybe<Array<CouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CouponWhereUniqueInput>>;
  set?: InputMaybe<Array<CouponWhereUniqueInput>>;
  update?: InputMaybe<Array<CouponUpdateWithWhereUniqueWithoutOrganizationsInput>>;
  updateMany?: InputMaybe<Array<CouponUpdateManyWithWhereWithoutOrganizationsInput>>;
  upsert?: InputMaybe<Array<CouponUpsertWithWhereUniqueWithoutOrganizationsInput>>;
};

export type CouponUpdateWithWhereUniqueWithoutOrganizationsInput = {
  data: CouponUpdateWithoutOrganizationsInput;
  where: CouponWhereUniqueInput;
};

export type CouponUpdateWithoutOrganizationsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<CouponType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Decimal']>;
  discountId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  supportedPlans?: InputMaybe<Array<Scalars['String']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CouponUpsertWithWhereUniqueWithoutOrganizationsInput = {
  create: CouponCreateWithoutOrganizationsInput;
  update: CouponUpdateWithoutOrganizationsInput;
  where: CouponWhereUniqueInput;
};

export type CouponWhereInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  code?: InputMaybe<StringFilter>;
  couponType?: InputMaybe<EnumCouponTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discount?: InputMaybe<DecimalNullableFilter>;
  discountId?: InputMaybe<StringNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  supportedPlans?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CouponWhereUniqueInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  code?: InputMaybe<Scalars['String']>;
  couponType?: InputMaybe<EnumCouponTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discount?: InputMaybe<DecimalNullableFilter>;
  discountId?: InputMaybe<StringNullableFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  supportedPlans?: InputMaybe<StringNullableListFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Craft = {
  __typename?: 'Craft';
  _count: CraftCount;
  airSyncId?: Maybe<Scalars['String']>;
  announcements?: Maybe<Array<Announcement>>;
  billingInterval?: Maybe<Interval>;
  components?: Maybe<Array<Component>>;
  consumableIntervals: Array<Interval>;
  craftName: Scalars['String'];
  craftServiceRequests?: Maybe<Array<CraftServiceRequest>>;
  createdAt: Scalars['DateTime'];
  currentReservation?: Maybe<Reservation>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<Document>>;
  flights?: Maybe<Array<Flight>>;
  fuelAmount: Scalars['String'];
  fuelCapacity?: Maybe<Scalars['Float']>;
  fuelUnit: VolumeMeasurement;
  homeBase?: Maybe<Scalars['String']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  hourlyRateMethod?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inspectionGroups?: Maybe<Array<InspectionGroup>>;
  inspections?: Maybe<Array<Inspection>>;
  integrationInfo?: Maybe<Scalars['JSON']>;
  intervals?: Maybe<Array<Interval>>;
  isAirworthy: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  lastAirport?: Maybe<LastAirport>;
  legacyId?: Maybe<Scalars['String']>;
  logBooks?: Maybe<Array<LogBook>>;
  loggingOption: LogType;
  maintenanceRecords?: Maybe<Array<MaintenanceRecord>>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mroCraft?: Maybe<Array<MroCraft>>;
  name: Scalars['String'];
  nextReservation?: Maybe<Reservation>;
  normalIntervals: Array<Interval>;
  normalLoggingIntervals: Array<Interval>;
  oilUnit: VolumeMeasurement;
  organization: Organization;
  organizationId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  regAddress?: Maybe<Scalars['String']>;
  reservations?: Maybe<Array<Reservation>>;
  shareOptions?: Maybe<Scalars['JSON']>;
  shareStatus?: Maybe<Scalars['String']>;
  shareToken?: Maybe<Scalars['String']>;
  squawks?: Maybe<Array<Squawk>>;
  tailNumber: Scalars['String'];
  type: CraftType;
  updatedAt: Scalars['DateTime'];
  usageRecords?: Maybe<Array<UsageRecord>>;
  userProfiles?: Maybe<Array<UserOrganizationProfile>>;
  weatherInfo?: Maybe<WeatherMetar>;
  year?: Maybe<Scalars['Float']>;
};


export type CraftComponentsArgs = {
  input?: InputMaybe<ComponentWhereInput>;
};


export type CraftConsumableIntervalsArgs = {
  input?: InputMaybe<IntervalWhereInput>;
};


export type CraftInspectionGroupsArgs = {
  input?: InputMaybe<InspectionGroupWhereInput>;
};


export type CraftInspectionsArgs = {
  input?: InputMaybe<InspectionWhereInput>;
};


export type CraftIntervalsArgs = {
  input?: InputMaybe<IntervalWhereInput>;
};


export type CraftLogBooksArgs = {
  input?: InputMaybe<LogBookWhereInput>;
};


export type CraftMaintenanceRecordsArgs = {
  input?: InputMaybe<MaintenanceRecordWhereInput>;
};


export type CraftNormalIntervalsArgs = {
  input?: InputMaybe<IntervalWhereInput>;
};


export type CraftNormalLoggingIntervalsArgs = {
  input?: InputMaybe<IntervalWhereInput>;
};


export type CraftReservationsArgs = {
  input?: InputMaybe<ReservationWhereInput>;
  selectedDate?: InputMaybe<Scalars['String']>;
};


export type CraftSquawksArgs = {
  input?: InputMaybe<SquawkWhereInput>;
};

export type CraftAvgAggregate = {
  __typename?: 'CraftAvgAggregate';
  fuelCapacity?: Maybe<Scalars['Float']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type CraftCount = {
  __typename?: 'CraftCount';
  announcements: Scalars['Int'];
  components: Scalars['Int'];
  craftServiceRequests: Scalars['Int'];
  documents: Scalars['Int'];
  flights: Scalars['Int'];
  inspectionGroups: Scalars['Int'];
  inspections: Scalars['Int'];
  intervals: Scalars['Int'];
  logBooks: Scalars['Int'];
  maintenanceRecords: Scalars['Int'];
  mroCraft: Scalars['Int'];
  reservations: Scalars['Int'];
  squawks: Scalars['Int'];
  usageRecords: Scalars['Int'];
};

export type CraftCountAggregate = {
  __typename?: 'CraftCountAggregate';
  _all: Scalars['Int'];
  airSyncId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  fuelCapacity: Scalars['Int'];
  fuelUnit: Scalars['Int'];
  homeBase: Scalars['Int'];
  hourlyRate: Scalars['Int'];
  hourlyRateMethod: Scalars['Int'];
  id: Scalars['Int'];
  integrationInfo: Scalars['Int'];
  legacyId: Scalars['Int'];
  loggingOption: Scalars['Int'];
  make: Scalars['Int'];
  model: Scalars['Int'];
  name: Scalars['Int'];
  oilUnit: Scalars['Int'];
  organizationId: Scalars['Int'];
  position: Scalars['Int'];
  regAddress: Scalars['Int'];
  shareOptions: Scalars['Int'];
  shareStatus: Scalars['Int'];
  shareToken: Scalars['Int'];
  tailNumber: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  year: Scalars['Int'];
};

export type CraftCreateManyOrganizationInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  loggingOption?: InputMaybe<LogType>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateManyOrganizationInputEnvelope = {
  data: Array<CraftCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CraftCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<CraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<CraftCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<CraftCreateManyOrganizationInputEnvelope>;
};

export type CraftCreateNestedOneWithoutAnnouncementsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutAnnouncementsInput>;
  create?: InputMaybe<CraftCreateWithoutAnnouncementsInput>;
};

export type CraftCreateNestedOneWithoutComponentsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutComponentsInput>;
  create?: InputMaybe<CraftCreateWithoutComponentsInput>;
};

export type CraftCreateNestedOneWithoutCraftServiceRequestsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<CraftCreateWithoutCraftServiceRequestsInput>;
};

export type CraftCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<CraftCreateWithoutDocumentsInput>;
};

export type CraftCreateNestedOneWithoutFlightsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<CraftCreateWithoutFlightsInput>;
};

export type CraftCreateNestedOneWithoutInspectionGroupsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutInspectionGroupsInput>;
  create?: InputMaybe<CraftCreateWithoutInspectionGroupsInput>;
};

export type CraftCreateNestedOneWithoutInspectionsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutInspectionsInput>;
  create?: InputMaybe<CraftCreateWithoutInspectionsInput>;
};

export type CraftCreateNestedOneWithoutIntervalsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutIntervalsInput>;
  create?: InputMaybe<CraftCreateWithoutIntervalsInput>;
};

export type CraftCreateNestedOneWithoutLogBooksInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutLogBooksInput>;
  create?: InputMaybe<CraftCreateWithoutLogBooksInput>;
};

export type CraftCreateNestedOneWithoutMaintenanceRecordsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutMaintenanceRecordsInput>;
  create?: InputMaybe<CraftCreateWithoutMaintenanceRecordsInput>;
};

export type CraftCreateNestedOneWithoutMroCraftInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutMroCraftInput>;
  create?: InputMaybe<CraftCreateWithoutMroCraftInput>;
};

export type CraftCreateNestedOneWithoutReservationsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutReservationsInput>;
  create?: InputMaybe<CraftCreateWithoutReservationsInput>;
};

export type CraftCreateNestedOneWithoutSquawksInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutSquawksInput>;
  create?: InputMaybe<CraftCreateWithoutSquawksInput>;
};

export type CraftCreateNestedOneWithoutUsageRecordsInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutUsageRecordsInput>;
  create?: InputMaybe<CraftCreateWithoutUsageRecordsInput>;
};

export type CraftCreateOrConnectWithoutAnnouncementsInput = {
  create: CraftCreateWithoutAnnouncementsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutComponentsInput = {
  create: CraftCreateWithoutComponentsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutCraftServiceRequestsInput = {
  create: CraftCreateWithoutCraftServiceRequestsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutDocumentsInput = {
  create: CraftCreateWithoutDocumentsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutFlightsInput = {
  create: CraftCreateWithoutFlightsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutInspectionGroupsInput = {
  create: CraftCreateWithoutInspectionGroupsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutInspectionsInput = {
  create: CraftCreateWithoutInspectionsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutIntervalsInput = {
  create: CraftCreateWithoutIntervalsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutLogBooksInput = {
  create: CraftCreateWithoutLogBooksInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutMaintenanceRecordsInput = {
  create: CraftCreateWithoutMaintenanceRecordsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutMroCraftInput = {
  create: CraftCreateWithoutMroCraftInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutOrganizationInput = {
  create: CraftCreateWithoutOrganizationInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutReservationsInput = {
  create: CraftCreateWithoutReservationsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutSquawksInput = {
  create: CraftCreateWithoutSquawksInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateOrConnectWithoutUsageRecordsInput = {
  create: CraftCreateWithoutUsageRecordsInput;
  where: CraftWhereUniqueInput;
};

export type CraftCreateWithoutAnnouncementsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutComponentsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutCraftServiceRequestsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutDocumentsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutFlightsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutInspectionGroupsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutInspectionsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutIntervalsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutLogBooksInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutMaintenanceRecordsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutMroCraftInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutOrganizationInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutReservationsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutSquawksInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftCreateWithoutUsageRecordsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftListRelationFilter = {
  every?: InputMaybe<CraftWhereInput>;
  none?: InputMaybe<CraftWhereInput>;
  some?: InputMaybe<CraftWhereInput>;
};

export type CraftMaxAggregate = {
  __typename?: 'CraftMaxAggregate';
  airSyncId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fuelCapacity?: Maybe<Scalars['Float']>;
  fuelUnit?: Maybe<VolumeMeasurement>;
  homeBase?: Maybe<Scalars['String']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  hourlyRateMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  loggingOption?: Maybe<LogType>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  oilUnit?: Maybe<VolumeMeasurement>;
  organizationId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  regAddress?: Maybe<Scalars['String']>;
  shareStatus?: Maybe<Scalars['String']>;
  shareToken?: Maybe<Scalars['String']>;
  tailNumber?: Maybe<Scalars['String']>;
  type?: Maybe<CraftType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Float']>;
};

export type CraftMinAggregate = {
  __typename?: 'CraftMinAggregate';
  airSyncId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  fuelCapacity?: Maybe<Scalars['Float']>;
  fuelUnit?: Maybe<VolumeMeasurement>;
  homeBase?: Maybe<Scalars['String']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  hourlyRateMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  loggingOption?: Maybe<LogType>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  oilUnit?: Maybe<VolumeMeasurement>;
  organizationId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Float']>;
  regAddress?: Maybe<Scalars['String']>;
  shareStatus?: Maybe<Scalars['String']>;
  shareToken?: Maybe<Scalars['String']>;
  tailNumber?: Maybe<Scalars['String']>;
  type?: Maybe<CraftType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Float']>;
};

export type CraftNullableScalarRelationFilter = {
  is?: InputMaybe<CraftWhereInput>;
  isNot?: InputMaybe<CraftWhereInput>;
};

export type CraftOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum CraftOrderByRelevanceFieldEnum {
  AirSyncId = 'airSyncId',
  HomeBase = 'homeBase',
  HourlyRateMethod = 'hourlyRateMethod',
  Id = 'id',
  LegacyId = 'legacyId',
  Make = 'make',
  Model = 'model',
  Name = 'name',
  OrganizationId = 'organizationId',
  RegAddress = 'regAddress',
  ShareStatus = 'shareStatus',
  ShareToken = 'shareToken',
  TailNumber = 'tailNumber'
}

export type CraftOrderByRelevanceInput = {
  fields: Array<CraftOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type CraftOrderByWithRelationInput = {
  _relevance?: InputMaybe<CraftOrderByRelevanceInput>;
  airSyncId?: InputMaybe<SortOrderInput>;
  announcements?: InputMaybe<AnnouncementOrderByRelationAggregateInput>;
  components?: InputMaybe<ComponentOrderByRelationAggregateInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  documents?: InputMaybe<DocumentOrderByRelationAggregateInput>;
  flights?: InputMaybe<FlightOrderByRelationAggregateInput>;
  fuelCapacity?: InputMaybe<SortOrderInput>;
  fuelUnit?: InputMaybe<SortOrder>;
  homeBase?: InputMaybe<SortOrderInput>;
  hourlyRate?: InputMaybe<SortOrderInput>;
  hourlyRateMethod?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inspectionGroups?: InputMaybe<InspectionGroupOrderByRelationAggregateInput>;
  inspections?: InputMaybe<InspectionOrderByRelationAggregateInput>;
  integrationInfo?: InputMaybe<SortOrderInput>;
  intervals?: InputMaybe<IntervalOrderByRelationAggregateInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  logBooks?: InputMaybe<LogBookOrderByRelationAggregateInput>;
  loggingOption?: InputMaybe<SortOrder>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordOrderByRelationAggregateInput>;
  make?: InputMaybe<SortOrderInput>;
  model?: InputMaybe<SortOrderInput>;
  mroCraft?: InputMaybe<MroCraftOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  oilUnit?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  position?: InputMaybe<SortOrderInput>;
  regAddress?: InputMaybe<SortOrderInput>;
  reservations?: InputMaybe<ReservationOrderByRelationAggregateInput>;
  shareOptions?: InputMaybe<SortOrderInput>;
  shareStatus?: InputMaybe<SortOrderInput>;
  shareToken?: InputMaybe<SortOrderInput>;
  squawks?: InputMaybe<SquawkOrderByRelationAggregateInput>;
  tailNumber?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usageRecords?: InputMaybe<UsageRecordOrderByRelationAggregateInput>;
  year?: InputMaybe<SortOrderInput>;
};

export type CraftScalarRelationFilter = {
  is?: InputMaybe<CraftWhereInput>;
  isNot?: InputMaybe<CraftWhereInput>;
};

export type CraftScalarWhereInput = {
  AND?: InputMaybe<Array<CraftScalarWhereInput>>;
  NOT?: InputMaybe<Array<CraftScalarWhereInput>>;
  OR?: InputMaybe<Array<CraftScalarWhereInput>>;
  airSyncId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fuelCapacity?: InputMaybe<FloatNullableFilter>;
  fuelUnit?: InputMaybe<EnumVolumeMeasurementFilter>;
  homeBase?: InputMaybe<StringNullableFilter>;
  hourlyRate?: InputMaybe<FloatNullableFilter>;
  hourlyRateMethod?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  integrationInfo?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  loggingOption?: InputMaybe<EnumLogTypeFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  oilUnit?: InputMaybe<EnumVolumeMeasurementFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<FloatNullableFilter>;
  regAddress?: InputMaybe<StringNullableFilter>;
  shareOptions?: InputMaybe<JsonNullableFilter>;
  shareStatus?: InputMaybe<StringNullableFilter>;
  shareToken?: InputMaybe<StringNullableFilter>;
  tailNumber?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCraftTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  year?: InputMaybe<FloatNullableFilter>;
};

export type CraftServiceRequest = {
  __typename?: 'CraftServiceRequest';
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  estimateTokens?: Maybe<Scalars['JSON']>;
  estimates?: Maybe<Array<MroEstimate>>;
  id: Scalars['ID'];
  invoiceTokens?: Maybe<Scalars['JSON']>;
  invoices?: Maybe<Array<MroInvoice>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroOrganizationName?: Maybe<Scalars['String']>;
  mroOrganizationPhone?: Maybe<Scalars['String']>;
  mroServiceRequest?: Maybe<MroServiceRequest>;
  mroServiceRequestId?: Maybe<Scalars['String']>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfile?: Maybe<UserOrganizationProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type CraftServiceRequestCountAggregate = {
  __typename?: 'CraftServiceRequestCountAggregate';
  _all: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  estimateTokens: Scalars['Int'];
  id: Scalars['Int'];
  invoiceTokens: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroServiceRequestId: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userProfileId: Scalars['Int'];
};

export type CraftServiceRequestCreateInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutCraftServiceRequestsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutCraftServiceRequestsInput>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCraftServiceRequestsInput>;
};

export type CraftServiceRequestCreateManyCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroServiceRequestId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type CraftServiceRequestCreateManyCraftInputEnvelope = {
  data: Array<CraftServiceRequestCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CraftServiceRequestCreateManyMroOrganizationInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroServiceRequestId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type CraftServiceRequestCreateManyMroOrganizationInputEnvelope = {
  data: Array<CraftServiceRequestCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CraftServiceRequestCreateManyMroServiceRequestInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type CraftServiceRequestCreateManyMroServiceRequestInputEnvelope = {
  data: Array<CraftServiceRequestCreateManyMroServiceRequestInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CraftServiceRequestCreateManyMroWorkOrderInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroServiceRequestId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type CraftServiceRequestCreateManyMroWorkOrderInputEnvelope = {
  data: Array<CraftServiceRequestCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CraftServiceRequestCreateManyUserProfileInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroServiceRequestId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CraftServiceRequestCreateManyUserProfileInputEnvelope = {
  data: Array<CraftServiceRequestCreateManyUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CraftServiceRequestCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutCraftInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyCraftInputEnvelope>;
};

export type CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyMroOrganizationInputEnvelope>;
};

export type CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutMroServiceRequestInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutMroServiceRequestInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyMroServiceRequestInputEnvelope>;
};

export type CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyMroWorkOrderInputEnvelope>;
};

export type CraftServiceRequestCreateNestedManyWithoutUserProfileInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyUserProfileInputEnvelope>;
};

export type CraftServiceRequestCreateOrConnectWithoutCraftInput = {
  create: CraftServiceRequestCreateWithoutCraftInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestCreateOrConnectWithoutMroOrganizationInput = {
  create: CraftServiceRequestCreateWithoutMroOrganizationInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestCreateOrConnectWithoutMroServiceRequestInput = {
  create: CraftServiceRequestCreateWithoutMroServiceRequestInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestCreateOrConnectWithoutMroWorkOrderInput = {
  create: CraftServiceRequestCreateWithoutMroWorkOrderInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestCreateOrConnectWithoutUserProfileInput = {
  create: CraftServiceRequestCreateWithoutUserProfileInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestCreateWithoutCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutCraftServiceRequestsInput>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCraftServiceRequestsInput>;
};

export type CraftServiceRequestCreateWithoutMroOrganizationInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutCraftServiceRequestsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutCraftServiceRequestsInput>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCraftServiceRequestsInput>;
};

export type CraftServiceRequestCreateWithoutMroServiceRequestInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutCraftServiceRequestsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutCraftServiceRequestsInput>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCraftServiceRequestsInput>;
};

export type CraftServiceRequestCreateWithoutMroWorkOrderInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutCraftServiceRequestsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutCraftServiceRequestsInput>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCraftServiceRequestsInput>;
};

export type CraftServiceRequestCreateWithoutUserProfileInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutCraftServiceRequestsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutCraftServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutCraftServiceRequestsInput>;
  status: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CraftServiceRequestListRelationFilter = {
  every?: InputMaybe<CraftServiceRequestWhereInput>;
  none?: InputMaybe<CraftServiceRequestWhereInput>;
  some?: InputMaybe<CraftServiceRequestWhereInput>;
};

export type CraftServiceRequestMaxAggregate = {
  __typename?: 'CraftServiceRequestMaxAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroServiceRequestId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type CraftServiceRequestMinAggregate = {
  __typename?: 'CraftServiceRequestMinAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroServiceRequestId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type CraftServiceRequestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CraftServiceRequestScalarWhereInput = {
  AND?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  NOT?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  estimateTokens?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceTokens?: InputMaybe<JsonNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequestId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type CraftServiceRequestUpdateInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutCraftServiceRequestsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutCraftServiceRequestsNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCraftServiceRequestsNestedInput>;
};

export type CraftServiceRequestUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CraftServiceRequestUpdateManyWithWhereWithoutCraftInput = {
  data: CraftServiceRequestUpdateManyMutationInput;
  where: CraftServiceRequestScalarWhereInput;
};

export type CraftServiceRequestUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: CraftServiceRequestUpdateManyMutationInput;
  where: CraftServiceRequestScalarWhereInput;
};

export type CraftServiceRequestUpdateManyWithWhereWithoutMroServiceRequestInput = {
  data: CraftServiceRequestUpdateManyMutationInput;
  where: CraftServiceRequestScalarWhereInput;
};

export type CraftServiceRequestUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: CraftServiceRequestUpdateManyMutationInput;
  where: CraftServiceRequestScalarWhereInput;
};

export type CraftServiceRequestUpdateManyWithWhereWithoutUserProfileInput = {
  data: CraftServiceRequestUpdateManyMutationInput;
  where: CraftServiceRequestScalarWhereInput;
};

export type CraftServiceRequestUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutCraftInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftServiceRequestUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<CraftServiceRequestUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<CraftServiceRequestUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftServiceRequestUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<CraftServiceRequestUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<CraftServiceRequestUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type CraftServiceRequestUpdateManyWithoutMroServiceRequestNestedInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutMroServiceRequestInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutMroServiceRequestInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyMroServiceRequestInputEnvelope>;
  delete?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftServiceRequestUpdateWithWhereUniqueWithoutMroServiceRequestInput>>;
  updateMany?: InputMaybe<Array<CraftServiceRequestUpdateManyWithWhereWithoutMroServiceRequestInput>>;
  upsert?: InputMaybe<Array<CraftServiceRequestUpsertWithWhereUniqueWithoutMroServiceRequestInput>>;
};

export type CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftServiceRequestUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<CraftServiceRequestUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<CraftServiceRequestUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type CraftServiceRequestUpdateManyWithoutUserProfileNestedInput = {
  connect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftServiceRequestCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<CraftServiceRequestCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<CraftServiceRequestCreateManyUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftServiceRequestUpdateWithWhereUniqueWithoutUserProfileInput>>;
  updateMany?: InputMaybe<Array<CraftServiceRequestUpdateManyWithWhereWithoutUserProfileInput>>;
  upsert?: InputMaybe<Array<CraftServiceRequestUpsertWithWhereUniqueWithoutUserProfileInput>>;
};

export type CraftServiceRequestUpdateWithWhereUniqueWithoutCraftInput = {
  data: CraftServiceRequestUpdateWithoutCraftInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: CraftServiceRequestUpdateWithoutMroOrganizationInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpdateWithWhereUniqueWithoutMroServiceRequestInput = {
  data: CraftServiceRequestUpdateWithoutMroServiceRequestInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: CraftServiceRequestUpdateWithoutMroWorkOrderInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpdateWithWhereUniqueWithoutUserProfileInput = {
  data: CraftServiceRequestUpdateWithoutUserProfileInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpdateWithoutCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutCraftServiceRequestsNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCraftServiceRequestsNestedInput>;
};

export type CraftServiceRequestUpdateWithoutMroOrganizationInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutCraftServiceRequestsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutCraftServiceRequestsNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCraftServiceRequestsNestedInput>;
};

export type CraftServiceRequestUpdateWithoutMroServiceRequestInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutCraftServiceRequestsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutCraftServiceRequestsNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCraftServiceRequestsNestedInput>;
};

export type CraftServiceRequestUpdateWithoutMroWorkOrderInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutCraftServiceRequestsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutCraftServiceRequestsNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCraftServiceRequestsNestedInput>;
};

export type CraftServiceRequestUpdateWithoutUserProfileInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutCraftServiceRequestsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  estimateTokens?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<Scalars['JSON']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutCraftServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutCraftServiceRequestsNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CraftServiceRequestUpsertWithWhereUniqueWithoutCraftInput = {
  create: CraftServiceRequestCreateWithoutCraftInput;
  update: CraftServiceRequestUpdateWithoutCraftInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: CraftServiceRequestCreateWithoutMroOrganizationInput;
  update: CraftServiceRequestUpdateWithoutMroOrganizationInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpsertWithWhereUniqueWithoutMroServiceRequestInput = {
  create: CraftServiceRequestCreateWithoutMroServiceRequestInput;
  update: CraftServiceRequestUpdateWithoutMroServiceRequestInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: CraftServiceRequestCreateWithoutMroWorkOrderInput;
  update: CraftServiceRequestUpdateWithoutMroWorkOrderInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestUpsertWithWhereUniqueWithoutUserProfileInput = {
  create: CraftServiceRequestCreateWithoutUserProfileInput;
  update: CraftServiceRequestUpdateWithoutUserProfileInput;
  where: CraftServiceRequestWhereUniqueInput;
};

export type CraftServiceRequestWhereInput = {
  AND?: InputMaybe<Array<CraftServiceRequestWhereInput>>;
  NOT?: InputMaybe<Array<CraftServiceRequestWhereInput>>;
  OR?: InputMaybe<Array<CraftServiceRequestWhereInput>>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  estimateTokens?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceTokens?: InputMaybe<JsonNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequest?: InputMaybe<MroServiceRequestNullableScalarRelationFilter>;
  mroServiceRequestId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type CraftServiceRequestWhereUniqueInput = {
  AND?: InputMaybe<Array<CraftServiceRequestWhereInput>>;
  NOT?: InputMaybe<Array<CraftServiceRequestWhereInput>>;
  OR?: InputMaybe<Array<CraftServiceRequestWhereInput>>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  estimateTokens?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  invoiceTokens?: InputMaybe<JsonNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequest?: InputMaybe<MroServiceRequestNullableScalarRelationFilter>;
  mroServiceRequestId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type CraftSubscription = {
  __typename?: 'CraftSubscription';
  billingDate: Scalars['String'];
  cost: Scalars['String'];
  id: Scalars['String'];
  interval: Scalars['String'];
  planName: Scalars['String'];
  quantity: Scalars['String'];
};

export type CraftSumAggregate = {
  __typename?: 'CraftSumAggregate';
  fuelCapacity?: Maybe<Scalars['Float']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export enum CraftType {
  Multiengine = 'MULTIENGINE',
  Singleengine = 'SINGLEENGINE'
}

export type CraftUpdateManyMutationInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  loggingOption?: InputMaybe<LogType>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateManyWithWhereWithoutOrganizationInput = {
  data: CraftUpdateManyMutationInput;
  where: CraftScalarWhereInput;
};

export type CraftUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<CraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CraftCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<CraftCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<CraftCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<CraftWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CraftScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CraftWhereUniqueInput>>;
  set?: InputMaybe<Array<CraftWhereUniqueInput>>;
  update?: InputMaybe<Array<CraftUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<CraftUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<CraftUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type CraftUpdateOneRequiredWithoutFlightsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<CraftCreateWithoutFlightsInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutFlightsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutFlightsInput>;
};

export type CraftUpdateOneRequiredWithoutLogBooksNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutLogBooksInput>;
  create?: InputMaybe<CraftCreateWithoutLogBooksInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutLogBooksInput>;
  upsert?: InputMaybe<CraftUpsertWithoutLogBooksInput>;
};

export type CraftUpdateOneRequiredWithoutSquawksNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutSquawksInput>;
  create?: InputMaybe<CraftCreateWithoutSquawksInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutSquawksInput>;
  upsert?: InputMaybe<CraftUpsertWithoutSquawksInput>;
};

export type CraftUpdateOneRequiredWithoutUsageRecordsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutUsageRecordsInput>;
  create?: InputMaybe<CraftCreateWithoutUsageRecordsInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutUsageRecordsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutUsageRecordsInput>;
};

export type CraftUpdateOneWithoutAnnouncementsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutAnnouncementsInput>;
  create?: InputMaybe<CraftCreateWithoutAnnouncementsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutAnnouncementsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutAnnouncementsInput>;
};

export type CraftUpdateOneWithoutComponentsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutComponentsInput>;
  create?: InputMaybe<CraftCreateWithoutComponentsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutComponentsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutComponentsInput>;
};

export type CraftUpdateOneWithoutCraftServiceRequestsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<CraftCreateWithoutCraftServiceRequestsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutCraftServiceRequestsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutCraftServiceRequestsInput>;
};

export type CraftUpdateOneWithoutDocumentsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<CraftCreateWithoutDocumentsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutDocumentsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutDocumentsInput>;
};

export type CraftUpdateOneWithoutInspectionGroupsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutInspectionGroupsInput>;
  create?: InputMaybe<CraftCreateWithoutInspectionGroupsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutInspectionGroupsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutInspectionGroupsInput>;
};

export type CraftUpdateOneWithoutInspectionsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutInspectionsInput>;
  create?: InputMaybe<CraftCreateWithoutInspectionsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutInspectionsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutInspectionsInput>;
};

export type CraftUpdateOneWithoutIntervalsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutIntervalsInput>;
  create?: InputMaybe<CraftCreateWithoutIntervalsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutIntervalsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutIntervalsInput>;
};

export type CraftUpdateOneWithoutMaintenanceRecordsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutMaintenanceRecordsInput>;
  create?: InputMaybe<CraftCreateWithoutMaintenanceRecordsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutMaintenanceRecordsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutMaintenanceRecordsInput>;
};

export type CraftUpdateOneWithoutMroCraftNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutMroCraftInput>;
  create?: InputMaybe<CraftCreateWithoutMroCraftInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutMroCraftInput>;
  upsert?: InputMaybe<CraftUpsertWithoutMroCraftInput>;
};

export type CraftUpdateOneWithoutReservationsNestedInput = {
  connect?: InputMaybe<CraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CraftCreateOrConnectWithoutReservationsInput>;
  create?: InputMaybe<CraftCreateWithoutReservationsInput>;
  delete?: InputMaybe<CraftWhereInput>;
  disconnect?: InputMaybe<CraftWhereInput>;
  update?: InputMaybe<CraftUpdateToOneWithWhereWithoutReservationsInput>;
  upsert?: InputMaybe<CraftUpsertWithoutReservationsInput>;
};

export type CraftUpdateToOneWithWhereWithoutAnnouncementsInput = {
  data: CraftUpdateWithoutAnnouncementsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutComponentsInput = {
  data: CraftUpdateWithoutComponentsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutCraftServiceRequestsInput = {
  data: CraftUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutDocumentsInput = {
  data: CraftUpdateWithoutDocumentsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutFlightsInput = {
  data: CraftUpdateWithoutFlightsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutInspectionGroupsInput = {
  data: CraftUpdateWithoutInspectionGroupsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutInspectionsInput = {
  data: CraftUpdateWithoutInspectionsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutIntervalsInput = {
  data: CraftUpdateWithoutIntervalsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutLogBooksInput = {
  data: CraftUpdateWithoutLogBooksInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutMaintenanceRecordsInput = {
  data: CraftUpdateWithoutMaintenanceRecordsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutMroCraftInput = {
  data: CraftUpdateWithoutMroCraftInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutReservationsInput = {
  data: CraftUpdateWithoutReservationsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutSquawksInput = {
  data: CraftUpdateWithoutSquawksInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateToOneWithWhereWithoutUsageRecordsInput = {
  data: CraftUpdateWithoutUsageRecordsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: CraftUpdateWithoutOrganizationInput;
  where: CraftWhereUniqueInput;
};

export type CraftUpdateWithoutAnnouncementsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutComponentsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutCraftServiceRequestsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutDocumentsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutFlightsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutInspectionGroupsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutInspectionsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutIntervalsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutLogBooksInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutMaintenanceRecordsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutMroCraftInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutOrganizationInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutReservationsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutSquawksInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpdateWithoutUsageRecordsInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CraftUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: CraftCreateWithoutOrganizationInput;
  update: CraftUpdateWithoutOrganizationInput;
  where: CraftWhereUniqueInput;
};

export type CraftUpsertWithoutAnnouncementsInput = {
  create: CraftCreateWithoutAnnouncementsInput;
  update: CraftUpdateWithoutAnnouncementsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutComponentsInput = {
  create: CraftCreateWithoutComponentsInput;
  update: CraftUpdateWithoutComponentsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutCraftServiceRequestsInput = {
  create: CraftCreateWithoutCraftServiceRequestsInput;
  update: CraftUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutDocumentsInput = {
  create: CraftCreateWithoutDocumentsInput;
  update: CraftUpdateWithoutDocumentsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutFlightsInput = {
  create: CraftCreateWithoutFlightsInput;
  update: CraftUpdateWithoutFlightsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutInspectionGroupsInput = {
  create: CraftCreateWithoutInspectionGroupsInput;
  update: CraftUpdateWithoutInspectionGroupsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutInspectionsInput = {
  create: CraftCreateWithoutInspectionsInput;
  update: CraftUpdateWithoutInspectionsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutIntervalsInput = {
  create: CraftCreateWithoutIntervalsInput;
  update: CraftUpdateWithoutIntervalsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutLogBooksInput = {
  create: CraftCreateWithoutLogBooksInput;
  update: CraftUpdateWithoutLogBooksInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutMaintenanceRecordsInput = {
  create: CraftCreateWithoutMaintenanceRecordsInput;
  update: CraftUpdateWithoutMaintenanceRecordsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutMroCraftInput = {
  create: CraftCreateWithoutMroCraftInput;
  update: CraftUpdateWithoutMroCraftInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutReservationsInput = {
  create: CraftCreateWithoutReservationsInput;
  update: CraftUpdateWithoutReservationsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutSquawksInput = {
  create: CraftCreateWithoutSquawksInput;
  update: CraftUpdateWithoutSquawksInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftUpsertWithoutUsageRecordsInput = {
  create: CraftCreateWithoutUsageRecordsInput;
  update: CraftUpdateWithoutUsageRecordsInput;
  where?: InputMaybe<CraftWhereInput>;
};

export type CraftWhereInput = {
  AND?: InputMaybe<Array<CraftWhereInput>>;
  NOT?: InputMaybe<Array<CraftWhereInput>>;
  OR?: InputMaybe<Array<CraftWhereInput>>;
  airSyncId?: InputMaybe<StringNullableFilter>;
  announcements?: InputMaybe<AnnouncementListRelationFilter>;
  components?: InputMaybe<ComponentListRelationFilter>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  fuelCapacity?: InputMaybe<FloatNullableFilter>;
  fuelUnit?: InputMaybe<EnumVolumeMeasurementFilter>;
  homeBase?: InputMaybe<StringNullableFilter>;
  hourlyRate?: InputMaybe<FloatNullableFilter>;
  hourlyRateMethod?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspectionGroups?: InputMaybe<InspectionGroupListRelationFilter>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  integrationInfo?: InputMaybe<JsonNullableFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logBooks?: InputMaybe<LogBookListRelationFilter>;
  loggingOption?: InputMaybe<EnumLogTypeFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  mroCraft?: InputMaybe<MroCraftListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  oilUnit?: InputMaybe<EnumVolumeMeasurementFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<FloatNullableFilter>;
  regAddress?: InputMaybe<StringNullableFilter>;
  reservations?: InputMaybe<ReservationListRelationFilter>;
  shareOptions?: InputMaybe<JsonNullableFilter>;
  shareStatus?: InputMaybe<StringNullableFilter>;
  shareToken?: InputMaybe<StringNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  tailNumber?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCraftTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usageRecords?: InputMaybe<UsageRecordListRelationFilter>;
  year?: InputMaybe<FloatNullableFilter>;
};

export type CraftWhereUniqueInput = {
  AND?: InputMaybe<Array<CraftWhereInput>>;
  NOT?: InputMaybe<Array<CraftWhereInput>>;
  OR?: InputMaybe<Array<CraftWhereInput>>;
  airSyncId?: InputMaybe<StringNullableFilter>;
  announcements?: InputMaybe<AnnouncementListRelationFilter>;
  components?: InputMaybe<ComponentListRelationFilter>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  fuelCapacity?: InputMaybe<FloatNullableFilter>;
  fuelUnit?: InputMaybe<EnumVolumeMeasurementFilter>;
  homeBase?: InputMaybe<StringNullableFilter>;
  hourlyRate?: InputMaybe<FloatNullableFilter>;
  hourlyRateMethod?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupListRelationFilter>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  integrationInfo?: InputMaybe<JsonNullableFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookListRelationFilter>;
  loggingOption?: InputMaybe<EnumLogTypeFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  mroCraft?: InputMaybe<MroCraftListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  oilUnit?: InputMaybe<EnumVolumeMeasurementFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<FloatNullableFilter>;
  regAddress?: InputMaybe<StringNullableFilter>;
  reservations?: InputMaybe<ReservationListRelationFilter>;
  shareOptions?: InputMaybe<JsonNullableFilter>;
  shareStatus?: InputMaybe<StringNullableFilter>;
  shareToken?: InputMaybe<StringNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  tailNumber?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumCraftTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usageRecords?: InputMaybe<UsageRecordListRelationFilter>;
  year?: InputMaybe<FloatNullableFilter>;
};

export type CreateCraftInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  engineCount?: InputMaybe<Scalars['Int']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  intervalsCraft?: InputMaybe<Array<IntervalsForCraft>>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutCraftsInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type CreateJascCategoryInput = {
  code: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  jascSystems?: InputMaybe<JascSystemCreateNestedManyWithoutJascCategoryInput>;
  name: Scalars['String'];
};

export type CreateJascSystemInput = {
  code: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  jascCategory?: InputMaybe<JascCategoryCreateNestedOneWithoutJascSystemsInput>;
  logEntry?: InputMaybe<LogEntryCreateNestedManyWithoutSystemsAffectedInput>;
  name: Scalars['String'];
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutSystemsAffectedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CreateMroWorkOrderFromTemplateInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  /** Reference template ID */
  mroWorkOrderTemplateId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type CreateOrganizationInput = {
  name: Scalars['String'];
};

export type CreateSerializedPartsInput = {
  /** Create multiple Serialized Parts Input */
  serializedParts: Array<MroSerializedPartCreateInput>;
};

export type CreateSquawkInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type CreateWorkOrderTemplateInput = {
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderTemplateInput>;
  /** Reference work order ID */
  mroWorkOrderId: Scalars['String'];
  title: Scalars['String'];
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type DigitalSignature = {
  __typename?: 'DigitalSignature';
  _count: DigitalSignatureCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageOfSignature?: Maybe<Attachment>;
  imageOfSignatureId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  logEntries?: Maybe<Array<LogEntry>>;
  metadata?: Maybe<Scalars['JSON']>;
  signature: Scalars['String'];
  signedAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type DigitalSignatureCount = {
  __typename?: 'DigitalSignatureCount';
  logEntries: Scalars['Int'];
};

export type DigitalSignatureCreateManyImageOfSignatureInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature: Scalars['String'];
  signedAt: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type DigitalSignatureCreateManyImageOfSignatureInputEnvelope = {
  data: Array<DigitalSignatureCreateManyImageOfSignatureInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DigitalSignatureCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageOfSignatureId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature: Scalars['String'];
  signedAt: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DigitalSignatureCreateManyUserInputEnvelope = {
  data: Array<DigitalSignatureCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DigitalSignatureCreateNestedManyWithoutImageOfSignatureInput = {
  connect?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DigitalSignatureCreateOrConnectWithoutImageOfSignatureInput>>;
  create?: InputMaybe<Array<DigitalSignatureCreateWithoutImageOfSignatureInput>>;
  createMany?: InputMaybe<DigitalSignatureCreateManyImageOfSignatureInputEnvelope>;
};

export type DigitalSignatureCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DigitalSignatureCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DigitalSignatureCreateWithoutUserInput>>;
  createMany?: InputMaybe<DigitalSignatureCreateManyUserInputEnvelope>;
};

export type DigitalSignatureCreateNestedOneWithoutLogEntriesInput = {
  connect?: InputMaybe<DigitalSignatureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DigitalSignatureCreateOrConnectWithoutLogEntriesInput>;
  create?: InputMaybe<DigitalSignatureCreateWithoutLogEntriesInput>;
};

export type DigitalSignatureCreateOrConnectWithoutImageOfSignatureInput = {
  create: DigitalSignatureCreateWithoutImageOfSignatureInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureCreateOrConnectWithoutLogEntriesInput = {
  create: DigitalSignatureCreateWithoutLogEntriesInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureCreateOrConnectWithoutUserInput = {
  create: DigitalSignatureCreateWithoutUserInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureCreateWithoutImageOfSignatureInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutDigitalSignatureInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature: Scalars['String'];
  signedAt: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutDigitalSignaturesInput>;
};

export type DigitalSignatureCreateWithoutLogEntriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageOfSignature?: InputMaybe<AttachmentCreateNestedOneWithoutDigitalSignaturesInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature: Scalars['String'];
  signedAt: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutDigitalSignaturesInput>;
};

export type DigitalSignatureCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageOfSignature?: InputMaybe<AttachmentCreateNestedOneWithoutDigitalSignaturesInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutDigitalSignatureInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature: Scalars['String'];
  signedAt: Scalars['DateTime'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DigitalSignatureListRelationFilter = {
  every?: InputMaybe<DigitalSignatureWhereInput>;
  none?: InputMaybe<DigitalSignatureWhereInput>;
  some?: InputMaybe<DigitalSignatureWhereInput>;
};

export type DigitalSignatureNullableScalarRelationFilter = {
  is?: InputMaybe<DigitalSignatureWhereInput>;
  isNot?: InputMaybe<DigitalSignatureWhereInput>;
};

export type DigitalSignatureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DigitalSignatureScalarWhereInput = {
  AND?: InputMaybe<Array<DigitalSignatureScalarWhereInput>>;
  NOT?: InputMaybe<Array<DigitalSignatureScalarWhereInput>>;
  OR?: InputMaybe<Array<DigitalSignatureScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageOfSignatureId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  signature?: InputMaybe<StringFilter>;
  signedAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type DigitalSignatureUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DigitalSignatureUpdateManyWithWhereWithoutImageOfSignatureInput = {
  data: DigitalSignatureUpdateManyMutationInput;
  where: DigitalSignatureScalarWhereInput;
};

export type DigitalSignatureUpdateManyWithWhereWithoutUserInput = {
  data: DigitalSignatureUpdateManyMutationInput;
  where: DigitalSignatureScalarWhereInput;
};

export type DigitalSignatureUpdateManyWithoutImageOfSignatureNestedInput = {
  connect?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DigitalSignatureCreateOrConnectWithoutImageOfSignatureInput>>;
  create?: InputMaybe<Array<DigitalSignatureCreateWithoutImageOfSignatureInput>>;
  createMany?: InputMaybe<DigitalSignatureCreateManyImageOfSignatureInputEnvelope>;
  delete?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DigitalSignatureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  set?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  update?: InputMaybe<Array<DigitalSignatureUpdateWithWhereUniqueWithoutImageOfSignatureInput>>;
  updateMany?: InputMaybe<Array<DigitalSignatureUpdateManyWithWhereWithoutImageOfSignatureInput>>;
  upsert?: InputMaybe<Array<DigitalSignatureUpsertWithWhereUniqueWithoutImageOfSignatureInput>>;
};

export type DigitalSignatureUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DigitalSignatureCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DigitalSignatureCreateWithoutUserInput>>;
  createMany?: InputMaybe<DigitalSignatureCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DigitalSignatureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  set?: InputMaybe<Array<DigitalSignatureWhereUniqueInput>>;
  update?: InputMaybe<Array<DigitalSignatureUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<DigitalSignatureUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<DigitalSignatureUpsertWithWhereUniqueWithoutUserInput>>;
};

export type DigitalSignatureUpdateOneWithoutLogEntriesNestedInput = {
  connect?: InputMaybe<DigitalSignatureWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DigitalSignatureCreateOrConnectWithoutLogEntriesInput>;
  create?: InputMaybe<DigitalSignatureCreateWithoutLogEntriesInput>;
  delete?: InputMaybe<DigitalSignatureWhereInput>;
  disconnect?: InputMaybe<DigitalSignatureWhereInput>;
  update?: InputMaybe<DigitalSignatureUpdateToOneWithWhereWithoutLogEntriesInput>;
  upsert?: InputMaybe<DigitalSignatureUpsertWithoutLogEntriesInput>;
};

export type DigitalSignatureUpdateToOneWithWhereWithoutLogEntriesInput = {
  data: DigitalSignatureUpdateWithoutLogEntriesInput;
  where?: InputMaybe<DigitalSignatureWhereInput>;
};

export type DigitalSignatureUpdateWithWhereUniqueWithoutImageOfSignatureInput = {
  data: DigitalSignatureUpdateWithoutImageOfSignatureInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureUpdateWithWhereUniqueWithoutUserInput = {
  data: DigitalSignatureUpdateWithoutUserInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureUpdateWithoutImageOfSignatureInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutDigitalSignatureNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutDigitalSignaturesNestedInput>;
};

export type DigitalSignatureUpdateWithoutLogEntriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageOfSignature?: InputMaybe<AttachmentUpdateOneWithoutDigitalSignaturesNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutDigitalSignaturesNestedInput>;
};

export type DigitalSignatureUpdateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageOfSignature?: InputMaybe<AttachmentUpdateOneWithoutDigitalSignaturesNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutDigitalSignatureNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  signature?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DigitalSignatureUpsertWithWhereUniqueWithoutImageOfSignatureInput = {
  create: DigitalSignatureCreateWithoutImageOfSignatureInput;
  update: DigitalSignatureUpdateWithoutImageOfSignatureInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureUpsertWithWhereUniqueWithoutUserInput = {
  create: DigitalSignatureCreateWithoutUserInput;
  update: DigitalSignatureUpdateWithoutUserInput;
  where: DigitalSignatureWhereUniqueInput;
};

export type DigitalSignatureUpsertWithoutLogEntriesInput = {
  create: DigitalSignatureCreateWithoutLogEntriesInput;
  update: DigitalSignatureUpdateWithoutLogEntriesInput;
  where?: InputMaybe<DigitalSignatureWhereInput>;
};

export type DigitalSignatureWhereInput = {
  AND?: InputMaybe<Array<DigitalSignatureWhereInput>>;
  NOT?: InputMaybe<Array<DigitalSignatureWhereInput>>;
  OR?: InputMaybe<Array<DigitalSignatureWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageOfSignature?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  imageOfSignatureId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<StringNullableFilter>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  signature?: InputMaybe<StringFilter>;
  signedAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type DigitalSignatureWhereUniqueInput = {
  AND?: InputMaybe<Array<DigitalSignatureWhereInput>>;
  NOT?: InputMaybe<Array<DigitalSignatureWhereInput>>;
  OR?: InputMaybe<Array<DigitalSignatureWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fullName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  imageOfSignature?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  imageOfSignatureId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<StringNullableFilter>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  signature?: InputMaybe<StringFilter>;
  signedAt?: InputMaybe<DateTimeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type Document = {
  __typename?: 'Document';
  attachment?: Maybe<Attachment>;
  attachmentId?: Maybe<Scalars['String']>;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  favorite: Scalars['Boolean'];
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfile?: Maybe<UserOrganizationProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type DocumentCountAggregate = {
  __typename?: 'DocumentCountAggregate';
  _all: Scalars['Int'];
  attachmentId: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  favorite: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userProfileId: Scalars['Int'];
};

export type DocumentCreateInput = {
  attachment?: InputMaybe<AttachmentCreateNestedOneWithoutDocumentsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutDocumentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutDocumentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutDocumentsInput>;
};

export type DocumentCreateManyAttachmentInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type DocumentCreateManyAttachmentInputEnvelope = {
  data: Array<DocumentCreateManyAttachmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCreateManyCraftInput = {
  attachmentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type DocumentCreateManyCraftInputEnvelope = {
  data: Array<DocumentCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCreateManyOrganizationInput = {
  attachmentId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type DocumentCreateManyOrganizationInputEnvelope = {
  data: Array<DocumentCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCreateManyUserProfileInput = {
  attachmentId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentCreateManyUserProfileInputEnvelope = {
  data: Array<DocumentCreateManyUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentCreateNestedManyWithoutAttachmentInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutAttachmentInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutAttachmentInput>>;
  createMany?: InputMaybe<DocumentCreateManyAttachmentInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutCraftInput>>;
  createMany?: InputMaybe<DocumentCreateManyCraftInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<DocumentCreateManyOrganizationInputEnvelope>;
};

export type DocumentCreateNestedManyWithoutUserProfileInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<DocumentCreateManyUserProfileInputEnvelope>;
};

export type DocumentCreateOrConnectWithoutAttachmentInput = {
  create: DocumentCreateWithoutAttachmentInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutCraftInput = {
  create: DocumentCreateWithoutCraftInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutOrganizationInput = {
  create: DocumentCreateWithoutOrganizationInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateOrConnectWithoutUserProfileInput = {
  create: DocumentCreateWithoutUserProfileInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentCreateWithoutAttachmentInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutDocumentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutDocumentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutDocumentsInput>;
};

export type DocumentCreateWithoutCraftInput = {
  attachment?: InputMaybe<AttachmentCreateNestedOneWithoutDocumentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutDocumentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutDocumentsInput>;
};

export type DocumentCreateWithoutOrganizationInput = {
  attachment?: InputMaybe<AttachmentCreateNestedOneWithoutDocumentsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutDocumentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutDocumentsInput>;
};

export type DocumentCreateWithoutUserProfileInput = {
  attachment?: InputMaybe<AttachmentCreateNestedOneWithoutDocumentsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutDocumentsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutDocumentsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentListRelationFilter = {
  every?: InputMaybe<DocumentWhereInput>;
  none?: InputMaybe<DocumentWhereInput>;
  some?: InputMaybe<DocumentWhereInput>;
};

export type DocumentMaxAggregate = {
  __typename?: 'DocumentMaxAggregate';
  attachmentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type DocumentMinAggregate = {
  __typename?: 'DocumentMinAggregate';
  attachmentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type DocumentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DocumentScalarWhereInput = {
  AND?: InputMaybe<Array<DocumentScalarWhereInput>>;
  NOT?: InputMaybe<Array<DocumentScalarWhereInput>>;
  OR?: InputMaybe<Array<DocumentScalarWhereInput>>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  favorite?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type DocumentUpdateInput = {
  attachment?: InputMaybe<AttachmentUpdateOneWithoutDocumentsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutDocumentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutDocumentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutDocumentsNestedInput>;
};

export type DocumentUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentUpdateManyWithWhereWithoutAttachmentInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutCraftInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutOrganizationInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithWhereWithoutUserProfileInput = {
  data: DocumentUpdateManyMutationInput;
  where: DocumentScalarWhereInput;
};

export type DocumentUpdateManyWithoutAttachmentNestedInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutAttachmentInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutAttachmentInput>>;
  createMany?: InputMaybe<DocumentCreateManyAttachmentInputEnvelope>;
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentUpdateWithWhereUniqueWithoutAttachmentInput>>;
  updateMany?: InputMaybe<Array<DocumentUpdateManyWithWhereWithoutAttachmentInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertWithWhereUniqueWithoutAttachmentInput>>;
};

export type DocumentUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutCraftInput>>;
  createMany?: InputMaybe<DocumentCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<DocumentUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type DocumentUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<DocumentCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<DocumentUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type DocumentUpdateManyWithoutUserProfileNestedInput = {
  connect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DocumentCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<DocumentCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<DocumentCreateManyUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DocumentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  set?: InputMaybe<Array<DocumentWhereUniqueInput>>;
  update?: InputMaybe<Array<DocumentUpdateWithWhereUniqueWithoutUserProfileInput>>;
  updateMany?: InputMaybe<Array<DocumentUpdateManyWithWhereWithoutUserProfileInput>>;
  upsert?: InputMaybe<Array<DocumentUpsertWithWhereUniqueWithoutUserProfileInput>>;
};

export type DocumentUpdateWithWhereUniqueWithoutAttachmentInput = {
  data: DocumentUpdateWithoutAttachmentInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutCraftInput = {
  data: DocumentUpdateWithoutCraftInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: DocumentUpdateWithoutOrganizationInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithWhereUniqueWithoutUserProfileInput = {
  data: DocumentUpdateWithoutUserProfileInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpdateWithoutAttachmentInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutDocumentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutDocumentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutDocumentsNestedInput>;
};

export type DocumentUpdateWithoutCraftInput = {
  attachment?: InputMaybe<AttachmentUpdateOneWithoutDocumentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutDocumentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutDocumentsNestedInput>;
};

export type DocumentUpdateWithoutOrganizationInput = {
  attachment?: InputMaybe<AttachmentUpdateOneWithoutDocumentsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutDocumentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutDocumentsNestedInput>;
};

export type DocumentUpdateWithoutUserProfileInput = {
  attachment?: InputMaybe<AttachmentUpdateOneWithoutDocumentsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutDocumentsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutDocumentsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DocumentUpsertWithWhereUniqueWithoutAttachmentInput = {
  create: DocumentCreateWithoutAttachmentInput;
  update: DocumentUpdateWithoutAttachmentInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutCraftInput = {
  create: DocumentCreateWithoutCraftInput;
  update: DocumentUpdateWithoutCraftInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: DocumentCreateWithoutOrganizationInput;
  update: DocumentUpdateWithoutOrganizationInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentUpsertWithWhereUniqueWithoutUserProfileInput = {
  create: DocumentCreateWithoutUserProfileInput;
  update: DocumentUpdateWithoutUserProfileInput;
  where: DocumentWhereUniqueInput;
};

export type DocumentWhereInput = {
  AND?: InputMaybe<Array<DocumentWhereInput>>;
  NOT?: InputMaybe<Array<DocumentWhereInput>>;
  OR?: InputMaybe<Array<DocumentWhereInput>>;
  attachment?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  favorite?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type DocumentWhereUniqueInput = {
  AND?: InputMaybe<Array<DocumentWhereInput>>;
  NOT?: InputMaybe<Array<DocumentWhereInput>>;
  OR?: InputMaybe<Array<DocumentWhereInput>>;
  attachment?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  favorite?: InputMaybe<BoolFilter>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type EnumAuditOperationFilter = {
  equals?: InputMaybe<AuditOperation>;
  in?: InputMaybe<Array<AuditOperation>>;
  not?: InputMaybe<NestedEnumAuditOperationFilter>;
  notIn?: InputMaybe<Array<AuditOperation>>;
};

export type EnumCouponTypeNullableFilter = {
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<CouponType>>;
  not?: InputMaybe<NestedEnumCouponTypeNullableFilter>;
  notIn?: InputMaybe<Array<CouponType>>;
};

export type EnumCraftTypeFilter = {
  equals?: InputMaybe<CraftType>;
  in?: InputMaybe<Array<CraftType>>;
  not?: InputMaybe<NestedEnumCraftTypeFilter>;
  notIn?: InputMaybe<Array<CraftType>>;
};

export type EnumInspectionDueTypeFilter = {
  equals?: InputMaybe<InspectionDueType>;
  in?: InputMaybe<Array<InspectionDueType>>;
  not?: InputMaybe<NestedEnumInspectionDueTypeFilter>;
  notIn?: InputMaybe<Array<InspectionDueType>>;
};

export type EnumIntervalSubtypeNullableFilter = {
  equals?: InputMaybe<IntervalSubtype>;
  in?: InputMaybe<Array<IntervalSubtype>>;
  not?: InputMaybe<NestedEnumIntervalSubtypeNullableFilter>;
  notIn?: InputMaybe<Array<IntervalSubtype>>;
};

export type EnumIntervalTypeFilter = {
  equals?: InputMaybe<IntervalType>;
  in?: InputMaybe<Array<IntervalType>>;
  not?: InputMaybe<NestedEnumIntervalTypeFilter>;
  notIn?: InputMaybe<Array<IntervalType>>;
};

export type EnumLogTypeFilter = {
  equals?: InputMaybe<LogType>;
  in?: InputMaybe<Array<LogType>>;
  not?: InputMaybe<NestedEnumLogTypeFilter>;
  notIn?: InputMaybe<Array<LogType>>;
};

export type EnumMroBillableTypeFilter = {
  equals?: InputMaybe<MroBillableType>;
  in?: InputMaybe<Array<MroBillableType>>;
  not?: InputMaybe<NestedEnumMroBillableTypeFilter>;
  notIn?: InputMaybe<Array<MroBillableType>>;
};

export type EnumMroDocumentTemplateTypeFilter = {
  equals?: InputMaybe<MroDocumentTemplateType>;
  in?: InputMaybe<Array<MroDocumentTemplateType>>;
  not?: InputMaybe<NestedEnumMroDocumentTemplateTypeFilter>;
  notIn?: InputMaybe<Array<MroDocumentTemplateType>>;
};

export type EnumMroFeeTypeFilter = {
  equals?: InputMaybe<MroFeeType>;
  in?: InputMaybe<Array<MroFeeType>>;
  not?: InputMaybe<NestedEnumMroFeeTypeFilter>;
  notIn?: InputMaybe<Array<MroFeeType>>;
};

export type EnumPartConditionNullableFilter = {
  equals?: InputMaybe<PartCondition>;
  in?: InputMaybe<Array<PartCondition>>;
  not?: InputMaybe<NestedEnumPartConditionNullableFilter>;
  notIn?: InputMaybe<Array<PartCondition>>;
};

export type EnumRegisteredCraftClassNullableFilter = {
  equals?: InputMaybe<RegisteredCraftClass>;
  in?: InputMaybe<Array<RegisteredCraftClass>>;
  not?: InputMaybe<NestedEnumRegisteredCraftClassNullableFilter>;
  notIn?: InputMaybe<Array<RegisteredCraftClass>>;
};

export type EnumRegisteredCraftTypeNullableFilter = {
  equals?: InputMaybe<RegisteredCraftType>;
  in?: InputMaybe<Array<RegisteredCraftType>>;
  not?: InputMaybe<NestedEnumRegisteredCraftTypeNullableFilter>;
  notIn?: InputMaybe<Array<RegisteredCraftType>>;
};

export type EnumRegisteredEngineTypeNullableFilter = {
  equals?: InputMaybe<RegisteredEngineType>;
  in?: InputMaybe<Array<RegisteredEngineType>>;
  not?: InputMaybe<NestedEnumRegisteredEngineTypeNullableFilter>;
  notIn?: InputMaybe<Array<RegisteredEngineType>>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumRoleNullableFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleNullableFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumSeverityNullableFilter = {
  equals?: InputMaybe<Severity>;
  in?: InputMaybe<Array<Severity>>;
  not?: InputMaybe<NestedEnumSeverityNullableFilter>;
  notIn?: InputMaybe<Array<Severity>>;
};

export type EnumSignoffStatusFilter = {
  equals?: InputMaybe<SignoffStatus>;
  in?: InputMaybe<Array<SignoffStatus>>;
  not?: InputMaybe<NestedEnumSignoffStatusFilter>;
  notIn?: InputMaybe<Array<SignoffStatus>>;
};

export type EnumStatusNullableFilter = {
  equals?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  not?: InputMaybe<NestedEnumStatusNullableFilter>;
  notIn?: InputMaybe<Array<Status>>;
};

export type EnumTransactionStatusNullableFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusNullableFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type EnumVolumeMeasurementFilter = {
  equals?: InputMaybe<VolumeMeasurement>;
  in?: InputMaybe<Array<VolumeMeasurement>>;
  not?: InputMaybe<NestedEnumVolumeMeasurementFilter>;
  notIn?: InputMaybe<Array<VolumeMeasurement>>;
};

export type EstimateItemInput = {
  customerApproved: Scalars['Boolean'];
};

export type EventCountAggregate = {
  __typename?: 'EventCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type EventMaxAggregate = {
  __typename?: 'EventMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EventMinAggregate = {
  __typename?: 'EventMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FavoriteRoute = {
  __typename?: 'FavoriteRoute';
  _count: FavoriteRouteCount;
  airports: Array<Airport>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flights?: Maybe<Array<Flight>>;
  icaos?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FavoriteRouteAvgAggregate = {
  __typename?: 'FavoriteRouteAvgAggregate';
  sort?: Maybe<Scalars['Float']>;
};

export type FavoriteRouteCount = {
  __typename?: 'FavoriteRouteCount';
  airports: Scalars['Int'];
  flights: Scalars['Int'];
};

export type FavoriteRouteCountAggregate = {
  __typename?: 'FavoriteRouteCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  icaos: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  sort: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FavoriteRouteCreateInput = {
  airports?: InputMaybe<AirportCreateNestedManyWithoutFavoriteRoutesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutFavoriteRouteInput>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutFavoriteRoutesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteCreateManyOrganizationInputEnvelope = {
  data: Array<FavoriteRouteCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FavoriteRouteCreateNestedManyWithoutAirportsInput = {
  connect?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoriteRouteCreateOrConnectWithoutAirportsInput>>;
  create?: InputMaybe<Array<FavoriteRouteCreateWithoutAirportsInput>>;
};

export type FavoriteRouteCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoriteRouteCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<FavoriteRouteCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<FavoriteRouteCreateManyOrganizationInputEnvelope>;
};

export type FavoriteRouteCreateNestedOneWithoutFlightsInput = {
  connect?: InputMaybe<FavoriteRouteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FavoriteRouteCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<FavoriteRouteCreateWithoutFlightsInput>;
};

export type FavoriteRouteCreateOrConnectWithoutAirportsInput = {
  create: FavoriteRouteCreateWithoutAirportsInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteCreateOrConnectWithoutFlightsInput = {
  create: FavoriteRouteCreateWithoutFlightsInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteCreateOrConnectWithoutOrganizationInput = {
  create: FavoriteRouteCreateWithoutOrganizationInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteCreateWithoutAirportsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutFavoriteRouteInput>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutFavoriteRoutesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteCreateWithoutFlightsInput = {
  airports?: InputMaybe<AirportCreateNestedManyWithoutFavoriteRoutesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutFavoriteRoutesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteCreateWithoutOrganizationInput = {
  airports?: InputMaybe<AirportCreateNestedManyWithoutFavoriteRoutesInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutFavoriteRouteInput>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteListRelationFilter = {
  every?: InputMaybe<FavoriteRouteWhereInput>;
  none?: InputMaybe<FavoriteRouteWhereInput>;
  some?: InputMaybe<FavoriteRouteWhereInput>;
};

export type FavoriteRouteMaxAggregate = {
  __typename?: 'FavoriteRouteMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FavoriteRouteMinAggregate = {
  __typename?: 'FavoriteRouteMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FavoriteRouteNullableScalarRelationFilter = {
  is?: InputMaybe<FavoriteRouteWhereInput>;
  isNot?: InputMaybe<FavoriteRouteWhereInput>;
};

export type FavoriteRouteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum FavoriteRouteOrderByRelevanceFieldEnum {
  Icaos = 'icaos',
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name',
  OrganizationId = 'organizationId'
}

export type FavoriteRouteOrderByRelevanceInput = {
  fields: Array<FavoriteRouteOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FavoriteRouteOrderByWithRelationInput = {
  _relevance?: InputMaybe<FavoriteRouteOrderByRelevanceInput>;
  airports?: InputMaybe<AirportOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  flights?: InputMaybe<FlightOrderByRelationAggregateInput>;
  icaos?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legacyId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  sort?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type FavoriteRouteScalarWhereInput = {
  AND?: InputMaybe<Array<FavoriteRouteScalarWhereInput>>;
  NOT?: InputMaybe<Array<FavoriteRouteScalarWhereInput>>;
  OR?: InputMaybe<Array<FavoriteRouteScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  icaos?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FavoriteRouteSumAggregate = {
  __typename?: 'FavoriteRouteSumAggregate';
  sort?: Maybe<Scalars['Int']>;
};

export type FavoriteRouteUpdateInput = {
  airports?: InputMaybe<AirportUpdateManyWithoutFavoriteRoutesNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightUpdateManyWithoutFavoriteRouteNestedInput>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutFavoriteRoutesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteUpdateManyWithWhereWithoutAirportsInput = {
  data: FavoriteRouteUpdateManyMutationInput;
  where: FavoriteRouteScalarWhereInput;
};

export type FavoriteRouteUpdateManyWithWhereWithoutOrganizationInput = {
  data: FavoriteRouteUpdateManyMutationInput;
  where: FavoriteRouteScalarWhereInput;
};

export type FavoriteRouteUpdateManyWithoutAirportsNestedInput = {
  connect?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoriteRouteCreateOrConnectWithoutAirportsInput>>;
  create?: InputMaybe<Array<FavoriteRouteCreateWithoutAirportsInput>>;
  delete?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FavoriteRouteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  update?: InputMaybe<Array<FavoriteRouteUpdateWithWhereUniqueWithoutAirportsInput>>;
  updateMany?: InputMaybe<Array<FavoriteRouteUpdateManyWithWhereWithoutAirportsInput>>;
  upsert?: InputMaybe<Array<FavoriteRouteUpsertWithWhereUniqueWithoutAirportsInput>>;
};

export type FavoriteRouteUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FavoriteRouteCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<FavoriteRouteCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<FavoriteRouteCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FavoriteRouteScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  set?: InputMaybe<Array<FavoriteRouteWhereUniqueInput>>;
  update?: InputMaybe<Array<FavoriteRouteUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<FavoriteRouteUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<FavoriteRouteUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type FavoriteRouteUpdateOneWithoutFlightsNestedInput = {
  connect?: InputMaybe<FavoriteRouteWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FavoriteRouteCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<FavoriteRouteCreateWithoutFlightsInput>;
  delete?: InputMaybe<FavoriteRouteWhereInput>;
  disconnect?: InputMaybe<FavoriteRouteWhereInput>;
  update?: InputMaybe<FavoriteRouteUpdateToOneWithWhereWithoutFlightsInput>;
  upsert?: InputMaybe<FavoriteRouteUpsertWithoutFlightsInput>;
};

export type FavoriteRouteUpdateToOneWithWhereWithoutFlightsInput = {
  data: FavoriteRouteUpdateWithoutFlightsInput;
  where?: InputMaybe<FavoriteRouteWhereInput>;
};

export type FavoriteRouteUpdateWithWhereUniqueWithoutAirportsInput = {
  data: FavoriteRouteUpdateWithoutAirportsInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: FavoriteRouteUpdateWithoutOrganizationInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteUpdateWithoutAirportsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightUpdateManyWithoutFavoriteRouteNestedInput>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutFavoriteRoutesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteUpdateWithoutFlightsInput = {
  airports?: InputMaybe<AirportUpdateManyWithoutFavoriteRoutesNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutFavoriteRoutesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteUpdateWithoutOrganizationInput = {
  airports?: InputMaybe<AirportUpdateManyWithoutFavoriteRoutesNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightUpdateManyWithoutFavoriteRouteNestedInput>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FavoriteRouteUpsertWithWhereUniqueWithoutAirportsInput = {
  create: FavoriteRouteCreateWithoutAirportsInput;
  update: FavoriteRouteUpdateWithoutAirportsInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: FavoriteRouteCreateWithoutOrganizationInput;
  update: FavoriteRouteUpdateWithoutOrganizationInput;
  where: FavoriteRouteWhereUniqueInput;
};

export type FavoriteRouteUpsertWithoutFlightsInput = {
  create: FavoriteRouteCreateWithoutFlightsInput;
  update: FavoriteRouteUpdateWithoutFlightsInput;
  where?: InputMaybe<FavoriteRouteWhereInput>;
};

export type FavoriteRouteWhereInput = {
  AND?: InputMaybe<Array<FavoriteRouteWhereInput>>;
  NOT?: InputMaybe<Array<FavoriteRouteWhereInput>>;
  OR?: InputMaybe<Array<FavoriteRouteWhereInput>>;
  airports?: InputMaybe<AirportListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  icaos?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FavoriteRouteWhereUniqueInput = {
  AND?: InputMaybe<Array<FavoriteRouteWhereInput>>;
  NOT?: InputMaybe<Array<FavoriteRouteWhereInput>>;
  OR?: InputMaybe<Array<FavoriteRouteWhereInput>>;
  airports?: InputMaybe<AirportListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  icaos?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Flight = {
  __typename?: 'Flight';
  _count: FlightCount;
  attachments?: Maybe<Array<Attachment>>;
  billable?: Maybe<Scalars['Boolean']>;
  billingData?: Maybe<Scalars['JSON']>;
  consumableEntries?: Maybe<Array<ConsumableEntry>>;
  consumables?: Maybe<Array<FlightIntervals>>;
  craft: Craft;
  craftId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customPurpose?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  favoriteRoute?: Maybe<FavoriteRoute>;
  favoriteRouteId?: Maybe<Scalars['String']>;
  flightDate?: Maybe<Scalars['DateTime']>;
  flightLog?: Maybe<Scalars['String']>;
  flightTime?: Maybe<Scalars['Float']>;
  icaos?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  import?: Maybe<Import>;
  importId?: Maybe<Scalars['String']>;
  integrationData?: Maybe<Scalars['JSON']>;
  isPending?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  normalIntervals?: Maybe<Array<FlightIntervals>>;
  notes?: Maybe<Scalars['String']>;
  passengers?: Maybe<Array<UserOrganizationProfile>>;
  pilotName?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  proRataShare?: Maybe<Scalars['Boolean']>;
  purpose?: Maybe<FlightPurpose>;
  purposeId?: Maybe<Scalars['String']>;
  purposeName?: Maybe<Scalars['String']>;
  route?: Maybe<Array<Airport>>;
  soruce?: Maybe<Scalars['String']>;
  squawks?: Maybe<Array<Squawk>>;
  transactions?: Maybe<Array<Transaction>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageRecord?: Maybe<UsageRecord>;
  userId?: Maybe<Scalars['String']>;
  userProfile?: Maybe<UserOrganizationProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type FlightAvgAggregate = {
  __typename?: 'FlightAvgAggregate';
  flightTime?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

export type FlightCount = {
  __typename?: 'FlightCount';
  attachments: Scalars['Int'];
  consumableEntries: Scalars['Int'];
  passengers: Scalars['Int'];
  route: Scalars['Int'];
  squawks: Scalars['Int'];
  transactions: Scalars['Int'];
};

export type FlightCountAggregate = {
  __typename?: 'FlightCountAggregate';
  _all: Scalars['Int'];
  billable: Scalars['Int'];
  billingData: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  customPurpose: Scalars['Int'];
  deletedAt: Scalars['Int'];
  favoriteRouteId: Scalars['Int'];
  flightDate: Scalars['Int'];
  flightTime: Scalars['Int'];
  icaos: Scalars['Int'];
  id: Scalars['Int'];
  importId: Scalars['Int'];
  integrationData: Scalars['Int'];
  isPending: Scalars['Int'];
  legacyId: Scalars['Int'];
  notes: Scalars['Int'];
  position: Scalars['Int'];
  proRataShare: Scalars['Int'];
  purposeId: Scalars['Int'];
  soruce: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userProfileId: Scalars['Int'];
};

export type FlightCreateInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateManyCraftInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRouteId?: InputMaybe<Scalars['String']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purposeId?: InputMaybe<Scalars['String']>;
  soruce?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type FlightCreateManyCraftInputEnvelope = {
  data: Array<FlightCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FlightCreateManyFavoriteRouteInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  craftId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purposeId?: InputMaybe<Scalars['String']>;
  soruce?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type FlightCreateManyFavoriteRouteInputEnvelope = {
  data: Array<FlightCreateManyFavoriteRouteInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FlightCreateManyImportInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  craftId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRouteId?: InputMaybe<Scalars['String']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purposeId?: InputMaybe<Scalars['String']>;
  soruce?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type FlightCreateManyImportInputEnvelope = {
  data: Array<FlightCreateManyImportInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FlightCreateManyPurposeInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  craftId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRouteId?: InputMaybe<Scalars['String']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  soruce?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type FlightCreateManyPurposeInputEnvelope = {
  data: Array<FlightCreateManyPurposeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FlightCreateManyUserProfileInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  craftId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRouteId?: InputMaybe<Scalars['String']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  importId?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purposeId?: InputMaybe<Scalars['String']>;
  soruce?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightCreateManyUserProfileInputEnvelope = {
  data: Array<FlightCreateManyUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FlightCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutCraftInput>>;
  createMany?: InputMaybe<FlightCreateManyCraftInputEnvelope>;
};

export type FlightCreateNestedManyWithoutFavoriteRouteInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutFavoriteRouteInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutFavoriteRouteInput>>;
  createMany?: InputMaybe<FlightCreateManyFavoriteRouteInputEnvelope>;
};

export type FlightCreateNestedManyWithoutImportInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutImportInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutImportInput>>;
  createMany?: InputMaybe<FlightCreateManyImportInputEnvelope>;
};

export type FlightCreateNestedManyWithoutPassengersInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutPassengersInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutPassengersInput>>;
};

export type FlightCreateNestedManyWithoutPurposeInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutPurposeInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutPurposeInput>>;
  createMany?: InputMaybe<FlightCreateManyPurposeInputEnvelope>;
};

export type FlightCreateNestedManyWithoutRouteInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutRouteInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutRouteInput>>;
};

export type FlightCreateNestedManyWithoutSquawksInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutSquawksInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutSquawksInput>>;
};

export type FlightCreateNestedManyWithoutUserProfileInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<FlightCreateManyUserProfileInputEnvelope>;
};

export type FlightCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<FlightCreateWithoutAttachmentsInput>;
};

export type FlightCreateNestedOneWithoutConsumableEntriesInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutConsumableEntriesInput>;
  create?: InputMaybe<FlightCreateWithoutConsumableEntriesInput>;
};

export type FlightCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<FlightCreateWithoutTransactionsInput>;
};

export type FlightCreateNestedOneWithoutUsageRecordInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutUsageRecordInput>;
  create?: InputMaybe<FlightCreateWithoutUsageRecordInput>;
};

export type FlightCreateOrConnectWithoutAttachmentsInput = {
  create: FlightCreateWithoutAttachmentsInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutConsumableEntriesInput = {
  create: FlightCreateWithoutConsumableEntriesInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutCraftInput = {
  create: FlightCreateWithoutCraftInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutFavoriteRouteInput = {
  create: FlightCreateWithoutFavoriteRouteInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutImportInput = {
  create: FlightCreateWithoutImportInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutPassengersInput = {
  create: FlightCreateWithoutPassengersInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutPurposeInput = {
  create: FlightCreateWithoutPurposeInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutRouteInput = {
  create: FlightCreateWithoutRouteInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutSquawksInput = {
  create: FlightCreateWithoutSquawksInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutTransactionsInput = {
  create: FlightCreateWithoutTransactionsInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutUsageRecordInput = {
  create: FlightCreateWithoutUsageRecordInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateOrConnectWithoutUserProfileInput = {
  create: FlightCreateWithoutUserProfileInput;
  where: FlightWhereUniqueInput;
};

export type FlightCreateWithIntervalsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  intervalsForFlight: Array<IntervalsForFlight>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutAttachmentsInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutConsumableEntriesInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutCraftInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutFavoriteRouteInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutImportInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutPassengersInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutPurposeInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutRouteInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutSquawksInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutTransactionsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutUsageRecordInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutFlightsInput>;
};

export type FlightCreateWithoutUserProfileInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutFlightInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryCreateNestedManyWithoutFlightInput>;
  craft: CraftCreateNestedOneWithoutFlightsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteCreateNestedOneWithoutFlightsInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportCreateNestedOneWithoutFlightsInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeCreateNestedOneWithoutFlightsInput>;
  route?: InputMaybe<AirportCreateNestedManyWithoutFlightsInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutFlightsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutFlightInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutFlightInput>;
};

export type FlightIntervals = {
  __typename?: 'FlightIntervals';
  endValue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  startValue?: Maybe<Scalars['Float']>;
  subtype?: Maybe<Scalars['String']>;
};

export type FlightListRelationFilter = {
  every?: InputMaybe<FlightWhereInput>;
  none?: InputMaybe<FlightWhereInput>;
  some?: InputMaybe<FlightWhereInput>;
};

export type FlightMaxAggregate = {
  __typename?: 'FlightMaxAggregate';
  billable?: Maybe<Scalars['Boolean']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customPurpose?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  favoriteRouteId?: Maybe<Scalars['String']>;
  flightDate?: Maybe<Scalars['DateTime']>;
  flightTime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['String']>;
  isPending?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  proRataShare?: Maybe<Scalars['Boolean']>;
  purposeId?: Maybe<Scalars['String']>;
  soruce?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type FlightMinAggregate = {
  __typename?: 'FlightMinAggregate';
  billable?: Maybe<Scalars['Boolean']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customPurpose?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  favoriteRouteId?: Maybe<Scalars['String']>;
  flightDate?: Maybe<Scalars['DateTime']>;
  flightTime?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  importId?: Maybe<Scalars['String']>;
  isPending?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  proRataShare?: Maybe<Scalars['Boolean']>;
  purposeId?: Maybe<Scalars['String']>;
  soruce?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type FlightNullableScalarRelationFilter = {
  is?: InputMaybe<FlightWhereInput>;
  isNot?: InputMaybe<FlightWhereInput>;
};

export type FlightOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum FlightOrderByRelevanceFieldEnum {
  CraftId = 'craftId',
  CustomPurpose = 'customPurpose',
  FavoriteRouteId = 'favoriteRouteId',
  Icaos = 'icaos',
  Id = 'id',
  ImportId = 'importId',
  LegacyId = 'legacyId',
  Notes = 'notes',
  PurposeId = 'purposeId',
  Soruce = 'soruce',
  UserProfileId = 'userProfileId'
}

export type FlightOrderByRelevanceInput = {
  fields: Array<FlightOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FlightOrderByWithRelationInput = {
  _relevance?: InputMaybe<FlightOrderByRelevanceInput>;
  attachments?: InputMaybe<AttachmentOrderByRelationAggregateInput>;
  billable?: InputMaybe<SortOrderInput>;
  billingData?: InputMaybe<SortOrderInput>;
  consumableEntries?: InputMaybe<ConsumableEntryOrderByRelationAggregateInput>;
  craft?: InputMaybe<CraftOrderByWithRelationInput>;
  craftId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customPurpose?: InputMaybe<SortOrderInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  favoriteRoute?: InputMaybe<FavoriteRouteOrderByWithRelationInput>;
  favoriteRouteId?: InputMaybe<SortOrderInput>;
  flightDate?: InputMaybe<SortOrderInput>;
  flightTime?: InputMaybe<SortOrderInput>;
  icaos?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  import?: InputMaybe<ImportOrderByWithRelationInput>;
  importId?: InputMaybe<SortOrderInput>;
  integrationData?: InputMaybe<SortOrderInput>;
  isPending?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  notes?: InputMaybe<SortOrderInput>;
  passengers?: InputMaybe<UserOrganizationProfileOrderByRelationAggregateInput>;
  position?: InputMaybe<SortOrderInput>;
  proRataShare?: InputMaybe<SortOrderInput>;
  purpose?: InputMaybe<FlightPurposeOrderByWithRelationInput>;
  purposeId?: InputMaybe<SortOrderInput>;
  route?: InputMaybe<AirportOrderByRelationAggregateInput>;
  soruce?: InputMaybe<SortOrderInput>;
  squawks?: InputMaybe<SquawkOrderByRelationAggregateInput>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  usageRecord?: InputMaybe<UsageRecordOrderByWithRelationInput>;
  userProfile?: InputMaybe<UserOrganizationProfileOrderByWithRelationInput>;
  userProfileId?: InputMaybe<SortOrderInput>;
};

export type FlightPurpose = {
  __typename?: 'FlightPurpose';
  _count: FlightPurposeCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['ID'];
  isCustom?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FlightPurposeAvgAggregate = {
  __typename?: 'FlightPurposeAvgAggregate';
  sort?: Maybe<Scalars['Float']>;
};

export type FlightPurposeCount = {
  __typename?: 'FlightPurposeCount';
  flights: Scalars['Int'];
};

export type FlightPurposeCountAggregate = {
  __typename?: 'FlightPurposeCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  isCustom: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  sort: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type FlightPurposeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutPurposeInput>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutFlightPurposesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeCreateManyOrganizationInputEnvelope = {
  data: Array<FlightPurposeCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FlightPurposeCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<FlightPurposeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightPurposeCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<FlightPurposeCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<FlightPurposeCreateManyOrganizationInputEnvelope>;
};

export type FlightPurposeCreateNestedOneWithoutFlightsInput = {
  connect?: InputMaybe<FlightPurposeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightPurposeCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<FlightPurposeCreateWithoutFlightsInput>;
};

export type FlightPurposeCreateOrConnectWithoutFlightsInput = {
  create: FlightPurposeCreateWithoutFlightsInput;
  where: FlightPurposeWhereUniqueInput;
};

export type FlightPurposeCreateOrConnectWithoutOrganizationInput = {
  create: FlightPurposeCreateWithoutOrganizationInput;
  where: FlightPurposeWhereUniqueInput;
};

export type FlightPurposeCreateWithoutFlightsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutFlightPurposesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutPurposeInput>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeListRelationFilter = {
  every?: InputMaybe<FlightPurposeWhereInput>;
  none?: InputMaybe<FlightPurposeWhereInput>;
  some?: InputMaybe<FlightPurposeWhereInput>;
};

export type FlightPurposeMaxAggregate = {
  __typename?: 'FlightPurposeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FlightPurposeMinAggregate = {
  __typename?: 'FlightPurposeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isCustom?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FlightPurposeNullableScalarRelationFilter = {
  is?: InputMaybe<FlightPurposeWhereInput>;
  isNot?: InputMaybe<FlightPurposeWhereInput>;
};

export type FlightPurposeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum FlightPurposeOrderByRelevanceFieldEnum {
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name',
  OrganizationId = 'organizationId'
}

export type FlightPurposeOrderByRelevanceInput = {
  fields: Array<FlightPurposeOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type FlightPurposeOrderByWithRelationInput = {
  _relevance?: InputMaybe<FlightPurposeOrderByRelevanceInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  flights?: InputMaybe<FlightOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isCustom?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  sort?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type FlightPurposeScalarWhereInput = {
  AND?: InputMaybe<Array<FlightPurposeScalarWhereInput>>;
  NOT?: InputMaybe<Array<FlightPurposeScalarWhereInput>>;
  OR?: InputMaybe<Array<FlightPurposeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isCustom?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FlightPurposeSumAggregate = {
  __typename?: 'FlightPurposeSumAggregate';
  sort?: Maybe<Scalars['Int']>;
};

export type FlightPurposeUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightUpdateManyWithoutPurposeNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutFlightPurposesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeUpdateManyWithWhereWithoutOrganizationInput = {
  data: FlightPurposeUpdateManyMutationInput;
  where: FlightPurposeScalarWhereInput;
};

export type FlightPurposeUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<FlightPurposeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightPurposeCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<FlightPurposeCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<FlightPurposeCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<FlightPurposeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightPurposeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightPurposeWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightPurposeWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightPurposeUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<FlightPurposeUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<FlightPurposeUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type FlightPurposeUpdateOneWithoutFlightsNestedInput = {
  connect?: InputMaybe<FlightPurposeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightPurposeCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<FlightPurposeCreateWithoutFlightsInput>;
  delete?: InputMaybe<FlightPurposeWhereInput>;
  disconnect?: InputMaybe<FlightPurposeWhereInput>;
  update?: InputMaybe<FlightPurposeUpdateToOneWithWhereWithoutFlightsInput>;
  upsert?: InputMaybe<FlightPurposeUpsertWithoutFlightsInput>;
};

export type FlightPurposeUpdateToOneWithWhereWithoutFlightsInput = {
  data: FlightPurposeUpdateWithoutFlightsInput;
  where?: InputMaybe<FlightPurposeWhereInput>;
};

export type FlightPurposeUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: FlightPurposeUpdateWithoutOrganizationInput;
  where: FlightPurposeWhereUniqueInput;
};

export type FlightPurposeUpdateWithoutFlightsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutFlightPurposesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flights?: InputMaybe<FlightUpdateManyWithoutPurposeNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightPurposeUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: FlightPurposeCreateWithoutOrganizationInput;
  update: FlightPurposeUpdateWithoutOrganizationInput;
  where: FlightPurposeWhereUniqueInput;
};

export type FlightPurposeUpsertWithoutFlightsInput = {
  create: FlightPurposeCreateWithoutFlightsInput;
  update: FlightPurposeUpdateWithoutFlightsInput;
  where?: InputMaybe<FlightPurposeWhereInput>;
};

export type FlightPurposeWhereInput = {
  AND?: InputMaybe<Array<FlightPurposeWhereInput>>;
  NOT?: InputMaybe<Array<FlightPurposeWhereInput>>;
  OR?: InputMaybe<Array<FlightPurposeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isCustom?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FlightPurposeWhereUniqueInput = {
  AND?: InputMaybe<Array<FlightPurposeWhereInput>>;
  NOT?: InputMaybe<Array<FlightPurposeWhereInput>>;
  OR?: InputMaybe<Array<FlightPurposeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  id?: InputMaybe<Scalars['String']>;
  isCustom?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type FlightRoute = {
  __typename?: 'FlightRoute';
  id: Scalars['String'];
  routes: Array<Route>;
};

export type FlightScalarWhereInput = {
  AND?: InputMaybe<Array<FlightScalarWhereInput>>;
  NOT?: InputMaybe<Array<FlightScalarWhereInput>>;
  OR?: InputMaybe<Array<FlightScalarWhereInput>>;
  billable?: InputMaybe<BoolNullableFilter>;
  billingData?: InputMaybe<JsonNullableFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customPurpose?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  favoriteRouteId?: InputMaybe<StringNullableFilter>;
  flightDate?: InputMaybe<DateTimeNullableFilter>;
  flightTime?: InputMaybe<FloatNullableFilter>;
  icaos?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  importId?: InputMaybe<StringNullableFilter>;
  integrationData?: InputMaybe<JsonNullableFilter>;
  isPending?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  proRataShare?: InputMaybe<BoolNullableFilter>;
  purposeId?: InputMaybe<StringNullableFilter>;
  soruce?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type FlightSumAggregate = {
  __typename?: 'FlightSumAggregate';
  flightTime?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Int']>;
};

export type FlightUpdateInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateManyMutationInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  soruce?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type FlightUpdateManyWithWhereWithoutCraftInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutFavoriteRouteInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutImportInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutPassengersInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutPurposeInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutRouteInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutSquawksInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithWhereWithoutUserProfileInput = {
  data: FlightUpdateManyMutationInput;
  where: FlightScalarWhereInput;
};

export type FlightUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutCraftInput>>;
  createMany?: InputMaybe<FlightCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type FlightUpdateManyWithoutFavoriteRouteNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutFavoriteRouteInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutFavoriteRouteInput>>;
  createMany?: InputMaybe<FlightCreateManyFavoriteRouteInputEnvelope>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutFavoriteRouteInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutFavoriteRouteInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutFavoriteRouteInput>>;
};

export type FlightUpdateManyWithoutImportNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutImportInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutImportInput>>;
  createMany?: InputMaybe<FlightCreateManyImportInputEnvelope>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutImportInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutImportInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutImportInput>>;
};

export type FlightUpdateManyWithoutPassengersNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutPassengersInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutPassengersInput>>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutPassengersInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutPassengersInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutPassengersInput>>;
};

export type FlightUpdateManyWithoutPurposeNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutPurposeInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutPurposeInput>>;
  createMany?: InputMaybe<FlightCreateManyPurposeInputEnvelope>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutPurposeInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutPurposeInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutPurposeInput>>;
};

export type FlightUpdateManyWithoutRouteNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutRouteInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutRouteInput>>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutRouteInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutRouteInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutRouteInput>>;
};

export type FlightUpdateManyWithoutSquawksNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutSquawksInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutSquawksInput>>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutSquawksInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutSquawksInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutSquawksInput>>;
};

export type FlightUpdateManyWithoutUserProfileNestedInput = {
  connect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FlightCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<FlightCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<FlightCreateManyUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<FlightWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FlightScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FlightWhereUniqueInput>>;
  set?: InputMaybe<Array<FlightWhereUniqueInput>>;
  update?: InputMaybe<Array<FlightUpdateWithWhereUniqueWithoutUserProfileInput>>;
  updateMany?: InputMaybe<Array<FlightUpdateManyWithWhereWithoutUserProfileInput>>;
  upsert?: InputMaybe<Array<FlightUpsertWithWhereUniqueWithoutUserProfileInput>>;
};

export type FlightUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<FlightCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<FlightWhereInput>;
  disconnect?: InputMaybe<FlightWhereInput>;
  update?: InputMaybe<FlightUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<FlightUpsertWithoutAttachmentsInput>;
};

export type FlightUpdateOneWithoutConsumableEntriesNestedInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutConsumableEntriesInput>;
  create?: InputMaybe<FlightCreateWithoutConsumableEntriesInput>;
  delete?: InputMaybe<FlightWhereInput>;
  disconnect?: InputMaybe<FlightWhereInput>;
  update?: InputMaybe<FlightUpdateToOneWithWhereWithoutConsumableEntriesInput>;
  upsert?: InputMaybe<FlightUpsertWithoutConsumableEntriesInput>;
};

export type FlightUpdateOneWithoutTransactionsNestedInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<FlightCreateWithoutTransactionsInput>;
  delete?: InputMaybe<FlightWhereInput>;
  disconnect?: InputMaybe<FlightWhereInput>;
  update?: InputMaybe<FlightUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: InputMaybe<FlightUpsertWithoutTransactionsInput>;
};

export type FlightUpdateOneWithoutUsageRecordNestedInput = {
  connect?: InputMaybe<FlightWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FlightCreateOrConnectWithoutUsageRecordInput>;
  create?: InputMaybe<FlightCreateWithoutUsageRecordInput>;
  delete?: InputMaybe<FlightWhereInput>;
  disconnect?: InputMaybe<FlightWhereInput>;
  update?: InputMaybe<FlightUpdateToOneWithWhereWithoutUsageRecordInput>;
  upsert?: InputMaybe<FlightUpsertWithoutUsageRecordInput>;
};

export type FlightUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: FlightUpdateWithoutAttachmentsInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpdateToOneWithWhereWithoutConsumableEntriesInput = {
  data: FlightUpdateWithoutConsumableEntriesInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpdateToOneWithWhereWithoutTransactionsInput = {
  data: FlightUpdateWithoutTransactionsInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpdateToOneWithWhereWithoutUsageRecordInput = {
  data: FlightUpdateWithoutUsageRecordInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpdateWithIntervalsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  intervalsForFlight: Array<IntervalsForFlight>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageLogId?: InputMaybe<Scalars['String']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithWhereUniqueWithoutCraftInput = {
  data: FlightUpdateWithoutCraftInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutFavoriteRouteInput = {
  data: FlightUpdateWithoutFavoriteRouteInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutImportInput = {
  data: FlightUpdateWithoutImportInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutPassengersInput = {
  data: FlightUpdateWithoutPassengersInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutPurposeInput = {
  data: FlightUpdateWithoutPurposeInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutRouteInput = {
  data: FlightUpdateWithoutRouteInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutSquawksInput = {
  data: FlightUpdateWithoutSquawksInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithWhereUniqueWithoutUserProfileInput = {
  data: FlightUpdateWithoutUserProfileInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpdateWithoutAttachmentsInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutConsumableEntriesInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutCraftInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutFavoriteRouteInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutImportInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutPassengersInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutPurposeInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutRouteInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutSquawksInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutTransactionsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutUsageRecordInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutFlightsNestedInput>;
};

export type FlightUpdateWithoutUserProfileInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutFlightNestedInput>;
  billable?: InputMaybe<Scalars['Boolean']>;
  billingData?: InputMaybe<Scalars['JSON']>;
  consumableEntries?: InputMaybe<ConsumableEntryUpdateManyWithoutFlightNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutFlightsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customPurpose?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoute?: InputMaybe<FavoriteRouteUpdateOneWithoutFlightsNestedInput>;
  flightDate?: InputMaybe<Scalars['DateTime']>;
  flightTime?: InputMaybe<Scalars['Float']>;
  icaos?: InputMaybe<Array<Scalars['String']>>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportUpdateOneWithoutFlightsNestedInput>;
  integrationData?: InputMaybe<Scalars['JSON']>;
  isPending?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  proRataShare?: InputMaybe<Scalars['Boolean']>;
  purpose?: InputMaybe<FlightPurposeUpdateOneWithoutFlightsNestedInput>;
  route?: InputMaybe<AirportUpdateManyWithoutFlightsNestedInput>;
  soruce?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutFlightsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutFlightNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutFlightNestedInput>;
};

export type FlightUpsertWithWhereUniqueWithoutCraftInput = {
  create: FlightCreateWithoutCraftInput;
  update: FlightUpdateWithoutCraftInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutFavoriteRouteInput = {
  create: FlightCreateWithoutFavoriteRouteInput;
  update: FlightUpdateWithoutFavoriteRouteInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutImportInput = {
  create: FlightCreateWithoutImportInput;
  update: FlightUpdateWithoutImportInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutPassengersInput = {
  create: FlightCreateWithoutPassengersInput;
  update: FlightUpdateWithoutPassengersInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutPurposeInput = {
  create: FlightCreateWithoutPurposeInput;
  update: FlightUpdateWithoutPurposeInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutRouteInput = {
  create: FlightCreateWithoutRouteInput;
  update: FlightUpdateWithoutRouteInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutSquawksInput = {
  create: FlightCreateWithoutSquawksInput;
  update: FlightUpdateWithoutSquawksInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithWhereUniqueWithoutUserProfileInput = {
  create: FlightCreateWithoutUserProfileInput;
  update: FlightUpdateWithoutUserProfileInput;
  where: FlightWhereUniqueInput;
};

export type FlightUpsertWithoutAttachmentsInput = {
  create: FlightCreateWithoutAttachmentsInput;
  update: FlightUpdateWithoutAttachmentsInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpsertWithoutConsumableEntriesInput = {
  create: FlightCreateWithoutConsumableEntriesInput;
  update: FlightUpdateWithoutConsumableEntriesInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpsertWithoutTransactionsInput = {
  create: FlightCreateWithoutTransactionsInput;
  update: FlightUpdateWithoutTransactionsInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightUpsertWithoutUsageRecordInput = {
  create: FlightCreateWithoutUsageRecordInput;
  update: FlightUpdateWithoutUsageRecordInput;
  where?: InputMaybe<FlightWhereInput>;
};

export type FlightWhereInput = {
  AND?: InputMaybe<Array<FlightWhereInput>>;
  NOT?: InputMaybe<Array<FlightWhereInput>>;
  OR?: InputMaybe<Array<FlightWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  billable?: InputMaybe<BoolNullableFilter>;
  billingData?: InputMaybe<JsonNullableFilter>;
  consumableEntries?: InputMaybe<ConsumableEntryListRelationFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customPurpose?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  favoriteRoute?: InputMaybe<FavoriteRouteNullableScalarRelationFilter>;
  favoriteRouteId?: InputMaybe<StringNullableFilter>;
  flightDate?: InputMaybe<DateTimeNullableFilter>;
  flightTime?: InputMaybe<FloatNullableFilter>;
  icaos?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<StringFilter>;
  import?: InputMaybe<ImportNullableScalarRelationFilter>;
  importId?: InputMaybe<StringNullableFilter>;
  integrationData?: InputMaybe<JsonNullableFilter>;
  isPending?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  passengers?: InputMaybe<UserOrganizationProfileListRelationFilter>;
  position?: InputMaybe<IntNullableFilter>;
  proRataShare?: InputMaybe<BoolNullableFilter>;
  purpose?: InputMaybe<FlightPurposeNullableScalarRelationFilter>;
  purposeId?: InputMaybe<StringNullableFilter>;
  route?: InputMaybe<AirportListRelationFilter>;
  soruce?: InputMaybe<StringNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageRecord?: InputMaybe<UsageRecordNullableScalarRelationFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type FlightWhereUniqueInput = {
  AND?: InputMaybe<Array<FlightWhereInput>>;
  NOT?: InputMaybe<Array<FlightWhereInput>>;
  OR?: InputMaybe<Array<FlightWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  billable?: InputMaybe<BoolNullableFilter>;
  billingData?: InputMaybe<JsonNullableFilter>;
  consumableEntries?: InputMaybe<ConsumableEntryListRelationFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customPurpose?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  favoriteRoute?: InputMaybe<FavoriteRouteNullableScalarRelationFilter>;
  favoriteRouteId?: InputMaybe<StringNullableFilter>;
  flightDate?: InputMaybe<DateTimeNullableFilter>;
  flightTime?: InputMaybe<FloatNullableFilter>;
  icaos?: InputMaybe<StringNullableListFilter>;
  id?: InputMaybe<Scalars['String']>;
  import?: InputMaybe<ImportNullableScalarRelationFilter>;
  importId?: InputMaybe<StringNullableFilter>;
  integrationData?: InputMaybe<JsonNullableFilter>;
  isPending?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<StringNullableFilter>;
  passengers?: InputMaybe<UserOrganizationProfileListRelationFilter>;
  position?: InputMaybe<IntNullableFilter>;
  proRataShare?: InputMaybe<BoolNullableFilter>;
  purpose?: InputMaybe<FlightPurposeNullableScalarRelationFilter>;
  purposeId?: InputMaybe<StringNullableFilter>;
  route?: InputMaybe<AirportListRelationFilter>;
  soruce?: InputMaybe<StringNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageRecord?: InputMaybe<UsageRecordNullableScalarRelationFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FuelOilReport = {
  __typename?: 'FuelOilReport';
  Fuel_Per_Hobbs_Hour?: Maybe<Scalars['Decimal']>;
  Fuel_Per_Tach_2_Hour?: Maybe<Scalars['Decimal']>;
  Fuel_Per_Tach_Hour?: Maybe<Scalars['Decimal']>;
  Oil_Per_Hobbs_Hour?: Maybe<Scalars['Decimal']>;
  Oil_Per_Tach_2_Hour?: Maybe<Scalars['Decimal']>;
  Oil_Per_Tach_Hour?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
};

export type Import = {
  __typename?: 'Import';
  _count: ImportCount;
  attachments?: Maybe<Array<Attachment>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImportAvgAggregate = {
  __typename?: 'ImportAvgAggregate';
  position?: Maybe<Scalars['Float']>;
};

export type ImportCount = {
  __typename?: 'ImportCount';
  attachments: Scalars['Int'];
  flights: Scalars['Int'];
};

export type ImportCountAggregate = {
  __typename?: 'ImportCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  error: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  position: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ImportCreateInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutImportInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutImportInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutImportsInput>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportCreateManyOrganizationInputEnvelope = {
  data: Array<ImportCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ImportCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<ImportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImportCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<ImportCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<ImportCreateManyOrganizationInputEnvelope>;
};

export type ImportCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<ImportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImportCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<ImportCreateWithoutAttachmentsInput>;
};

export type ImportCreateNestedOneWithoutFlightsInput = {
  connect?: InputMaybe<ImportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImportCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<ImportCreateWithoutFlightsInput>;
};

export type ImportCreateOrConnectWithoutAttachmentsInput = {
  create: ImportCreateWithoutAttachmentsInput;
  where: ImportWhereUniqueInput;
};

export type ImportCreateOrConnectWithoutFlightsInput = {
  create: ImportCreateWithoutFlightsInput;
  where: ImportWhereUniqueInput;
};

export type ImportCreateOrConnectWithoutOrganizationInput = {
  create: ImportCreateWithoutOrganizationInput;
  where: ImportWhereUniqueInput;
};

export type ImportCreateWithoutAttachmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutImportInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutImportsInput>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportCreateWithoutFlightsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutImportInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutImportsInput>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportCreateWithoutOrganizationInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutImportInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutImportInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportListRelationFilter = {
  every?: InputMaybe<ImportWhereInput>;
  none?: InputMaybe<ImportWhereInput>;
  some?: InputMaybe<ImportWhereInput>;
};

export type ImportMaxAggregate = {
  __typename?: 'ImportMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImportMinAggregate = {
  __typename?: 'ImportMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ImportNullableScalarRelationFilter = {
  is?: InputMaybe<ImportWhereInput>;
  isNot?: InputMaybe<ImportWhereInput>;
};

export type ImportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ImportOrderByRelevanceFieldEnum {
  Error = 'error',
  Id = 'id',
  Name = 'name',
  OrganizationId = 'organizationId',
  Status = 'status'
}

export type ImportOrderByRelevanceInput = {
  fields: Array<ImportOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ImportOrderByWithRelationInput = {
  _relevance?: InputMaybe<ImportOrderByRelevanceInput>;
  attachments?: InputMaybe<AttachmentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  error?: InputMaybe<SortOrderInput>;
  flights?: InputMaybe<FlightOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  position?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type ImportScalarWhereInput = {
  AND?: InputMaybe<Array<ImportScalarWhereInput>>;
  NOT?: InputMaybe<Array<ImportScalarWhereInput>>;
  OR?: InputMaybe<Array<ImportScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ImportSumAggregate = {
  __typename?: 'ImportSumAggregate';
  position?: Maybe<Scalars['Int']>;
};

export type ImportUpdateInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutImportNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutImportNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutImportsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportUpdateManyWithWhereWithoutOrganizationInput = {
  data: ImportUpdateManyMutationInput;
  where: ImportScalarWhereInput;
};

export type ImportUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<ImportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ImportCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<ImportCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<ImportCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<ImportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ImportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ImportWhereUniqueInput>>;
  set?: InputMaybe<Array<ImportWhereUniqueInput>>;
  update?: InputMaybe<Array<ImportUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<ImportUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<ImportUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type ImportUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<ImportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImportCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<ImportCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<ImportWhereInput>;
  disconnect?: InputMaybe<ImportWhereInput>;
  update?: InputMaybe<ImportUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<ImportUpsertWithoutAttachmentsInput>;
};

export type ImportUpdateOneWithoutFlightsNestedInput = {
  connect?: InputMaybe<ImportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ImportCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<ImportCreateWithoutFlightsInput>;
  delete?: InputMaybe<ImportWhereInput>;
  disconnect?: InputMaybe<ImportWhereInput>;
  update?: InputMaybe<ImportUpdateToOneWithWhereWithoutFlightsInput>;
  upsert?: InputMaybe<ImportUpsertWithoutFlightsInput>;
};

export type ImportUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: ImportUpdateWithoutAttachmentsInput;
  where?: InputMaybe<ImportWhereInput>;
};

export type ImportUpdateToOneWithWhereWithoutFlightsInput = {
  data: ImportUpdateWithoutFlightsInput;
  where?: InputMaybe<ImportWhereInput>;
};

export type ImportUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: ImportUpdateWithoutOrganizationInput;
  where: ImportWhereUniqueInput;
};

export type ImportUpdateWithoutAttachmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutImportNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutImportsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportUpdateWithoutFlightsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutImportNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutImportsNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportUpdateWithoutOrganizationInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutImportNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutImportNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ImportUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: ImportCreateWithoutOrganizationInput;
  update: ImportUpdateWithoutOrganizationInput;
  where: ImportWhereUniqueInput;
};

export type ImportUpsertWithoutAttachmentsInput = {
  create: ImportCreateWithoutAttachmentsInput;
  update: ImportUpdateWithoutAttachmentsInput;
  where?: InputMaybe<ImportWhereInput>;
};

export type ImportUpsertWithoutFlightsInput = {
  create: ImportCreateWithoutFlightsInput;
  update: ImportUpdateWithoutFlightsInput;
  where?: InputMaybe<ImportWhereInput>;
};

export type ImportWhereInput = {
  AND?: InputMaybe<Array<ImportWhereInput>>;
  NOT?: InputMaybe<Array<ImportWhereInput>>;
  OR?: InputMaybe<Array<ImportWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ImportWhereUniqueInput = {
  AND?: InputMaybe<Array<ImportWhereInput>>;
  NOT?: InputMaybe<Array<ImportWhereInput>>;
  OR?: InputMaybe<Array<ImportWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Inspection = {
  __typename?: 'Inspection';
  _count: InspectionCount;
  airworthinessItem?: Maybe<Scalars['Boolean']>;
  almostDue: Scalars['Boolean'];
  amountLeft?: Maybe<Array<Scalars['String']>>;
  component?: Maybe<Component>;
  componentId?: Maybe<Scalars['String']>;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doesRepeat?: Maybe<Scalars['Boolean']>;
  due: Scalars['Boolean'];
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: Maybe<Scalars['Int']>;
  dueDateMonthsFrequency?: Maybe<Scalars['Int']>;
  dueDateSoon?: Maybe<Scalars['Int']>;
  dueInterval?: Maybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  inspectionGroup?: Maybe<InspectionGroup>;
  inspectionGroupId?: Maybe<Scalars['String']>;
  intervalDueRecords?: Maybe<Array<IntervalsOnInspections>>;
  intervals: Array<Interval>;
  lastNotficationSent?: Maybe<Scalars['DateTime']>;
  lastPerformed?: Maybe<Scalars['DateTime']>;
  lastPerformedInterval?: Maybe<Scalars['JSON']>;
  legacyId?: Maybe<Scalars['String']>;
  logBooks: LogBook;
  maintenanceRecords?: Maybe<Array<MaintenanceRecord>>;
  name: Scalars['String'];
  newestInterval?: Maybe<Interval>;
  newestIntervalDueRecord?: Maybe<IntervalsOnInspections>;
  nextDuePercentage?: Maybe<Scalars['Int']>;
  nextDueText: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InspectionAvgAggregate = {
  __typename?: 'InspectionAvgAggregate';
  dueDateDaysFrequency?: Maybe<Scalars['Float']>;
  dueDateMonthsFrequency?: Maybe<Scalars['Float']>;
  dueDateSoon?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['Float']>;
};

export type InspectionCount = {
  __typename?: 'InspectionCount';
  intervalDueRecords: Scalars['Int'];
  logBooks: Scalars['Int'];
  maintenanceRecords: Scalars['Int'];
};

export type InspectionCountAggregate = {
  __typename?: 'InspectionCountAggregate';
  _all: Scalars['Int'];
  airworthinessItem: Scalars['Int'];
  componentId: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  doesRepeat: Scalars['Int'];
  dueDate: Scalars['Int'];
  dueDateDaysFrequency: Scalars['Int'];
  dueDateMonthsFrequency: Scalars['Int'];
  dueDateSoon: Scalars['Int'];
  dueInterval: Scalars['Int'];
  dueMethod: Scalars['Int'];
  faaInfo: Scalars['Int'];
  id: Scalars['Int'];
  inspectionGroupId: Scalars['Int'];
  lastNotficationSent: Scalars['Int'];
  lastPerformed: Scalars['Int'];
  lastPerformedInterval: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  position: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InspectionCreateInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutInspectionsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupCreateNestedOneWithoutInspectionsInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutInspectionsInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateManyComponentInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroupId?: InputMaybe<Scalars['String']>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateManyComponentInputEnvelope = {
  data: Array<InspectionCreateManyComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InspectionCreateManyCraftInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroupId?: InputMaybe<Scalars['String']>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateManyCraftInputEnvelope = {
  data: Array<InspectionCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InspectionCreateManyInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroupId?: InputMaybe<Scalars['String']>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateManyInspectionGroupInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  componentId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateManyInspectionGroupInputEnvelope = {
  data: Array<InspectionCreateManyInspectionGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InspectionCreateNestedManyWithoutComponentInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutComponentInput>>;
  createMany?: InputMaybe<InspectionCreateManyComponentInputEnvelope>;
};

export type InspectionCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutCraftInput>>;
  createMany?: InputMaybe<InspectionCreateManyCraftInputEnvelope>;
};

export type InspectionCreateNestedManyWithoutInspectionGroupInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutInspectionGroupInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutInspectionGroupInput>>;
  createMany?: InputMaybe<InspectionCreateManyInspectionGroupInputEnvelope>;
};

export type InspectionCreateNestedManyWithoutLogBooksInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutLogBooksInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutLogBooksInput>>;
};

export type InspectionCreateNestedManyWithoutMaintenanceRecordsInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutMaintenanceRecordsInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutMaintenanceRecordsInput>>;
};

export type InspectionCreateNestedOneWithoutIntervalDueRecordsInput = {
  connect?: InputMaybe<InspectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InspectionCreateOrConnectWithoutIntervalDueRecordsInput>;
  create?: InputMaybe<InspectionCreateWithoutIntervalDueRecordsInput>;
};

export type InspectionCreateOrConnectWithoutComponentInput = {
  create: InspectionCreateWithoutComponentInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionCreateOrConnectWithoutCraftInput = {
  create: InspectionCreateWithoutCraftInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionCreateOrConnectWithoutInspectionGroupInput = {
  create: InspectionCreateWithoutInspectionGroupInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionCreateOrConnectWithoutIntervalDueRecordsInput = {
  create: InspectionCreateWithoutIntervalDueRecordsInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionCreateOrConnectWithoutLogBooksInput = {
  create: InspectionCreateWithoutLogBooksInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionCreateOrConnectWithoutMaintenanceRecordsInput = {
  create: InspectionCreateWithoutMaintenanceRecordsInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionCreateWithoutComponentInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupCreateNestedOneWithoutInspectionsInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutInspectionsInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateWithoutCraftInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupCreateNestedOneWithoutInspectionsInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutInspectionsInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateWithoutInspectionGroupInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutInspectionsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutInspectionsInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateWithoutIntervalDueRecordsInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutInspectionsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupCreateNestedOneWithoutInspectionsInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutInspectionsInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateWithoutLogBooksInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutInspectionsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupCreateNestedOneWithoutInspectionsInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionCreateWithoutMaintenanceRecordsInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutInspectionsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod: InspectionDueType;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupCreateNestedOneWithoutInspectionsInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutInspectionsInput>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum InspectionDueType {
  Both = 'BOTH',
  Date = 'DATE',
  Interval = 'INTERVAL',
  Unknown = 'UNKNOWN'
}

export type InspectionGroup = {
  __typename?: 'InspectionGroup';
  _count: InspectionGroupCount;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inspections: Array<Inspection>;
  legacyId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InspectionGroupAvgAggregate = {
  __typename?: 'InspectionGroupAvgAggregate';
  position?: Maybe<Scalars['Float']>;
};

export type InspectionGroupCount = {
  __typename?: 'InspectionGroupCount';
  inspections: Scalars['Int'];
};

export type InspectionGroupCountAggregate = {
  __typename?: 'InspectionGroupCountAggregate';
  _all: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  position: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InspectionGroupCreateInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionGroupsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutInspectionGroupInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupCreateManyCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupCreateManyCraftInputEnvelope = {
  data: Array<InspectionGroupCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InspectionGroupCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<InspectionGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionGroupCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<InspectionGroupCreateWithoutCraftInput>>;
  createMany?: InputMaybe<InspectionGroupCreateManyCraftInputEnvelope>;
};

export type InspectionGroupCreateNestedOneWithoutInspectionsInput = {
  connect?: InputMaybe<InspectionGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InspectionGroupCreateOrConnectWithoutInspectionsInput>;
  create?: InputMaybe<InspectionGroupCreateWithoutInspectionsInput>;
};

export type InspectionGroupCreateOrConnectWithoutCraftInput = {
  create: InspectionGroupCreateWithoutCraftInput;
  where: InspectionGroupWhereUniqueInput;
};

export type InspectionGroupCreateOrConnectWithoutInspectionsInput = {
  create: InspectionGroupCreateWithoutInspectionsInput;
  where: InspectionGroupWhereUniqueInput;
};

export type InspectionGroupCreateWithoutCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutInspectionGroupInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupCreateWithoutInspectionsInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutInspectionGroupsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupListRelationFilter = {
  every?: InputMaybe<InspectionGroupWhereInput>;
  none?: InputMaybe<InspectionGroupWhereInput>;
  some?: InputMaybe<InspectionGroupWhereInput>;
};

export type InspectionGroupMaxAggregate = {
  __typename?: 'InspectionGroupMaxAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InspectionGroupMinAggregate = {
  __typename?: 'InspectionGroupMinAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InspectionGroupNullableScalarRelationFilter = {
  is?: InputMaybe<InspectionGroupWhereInput>;
  isNot?: InputMaybe<InspectionGroupWhereInput>;
};

export type InspectionGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum InspectionGroupOrderByRelevanceFieldEnum {
  CraftId = 'craftId',
  Description = 'description',
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name'
}

export type InspectionGroupOrderByRelevanceInput = {
  fields: Array<InspectionGroupOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type InspectionGroupOrderByWithRelationInput = {
  _relevance?: InputMaybe<InspectionGroupOrderByRelevanceInput>;
  craft?: InputMaybe<CraftOrderByWithRelationInput>;
  craftId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inspections?: InputMaybe<InspectionOrderByRelationAggregateInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type InspectionGroupScalarWhereInput = {
  AND?: InputMaybe<Array<InspectionGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<InspectionGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<InspectionGroupScalarWhereInput>>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InspectionGroupSumAggregate = {
  __typename?: 'InspectionGroupSumAggregate';
  position?: Maybe<Scalars['Int']>;
};

export type InspectionGroupUpdateInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionGroupsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutInspectionGroupNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupUpdateManyWithWhereWithoutCraftInput = {
  data: InspectionGroupUpdateManyMutationInput;
  where: InspectionGroupScalarWhereInput;
};

export type InspectionGroupUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<InspectionGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionGroupCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<InspectionGroupCreateWithoutCraftInput>>;
  createMany?: InputMaybe<InspectionGroupCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<InspectionGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InspectionGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InspectionGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<InspectionGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<InspectionGroupUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<InspectionGroupUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<InspectionGroupUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type InspectionGroupUpdateOneWithoutInspectionsNestedInput = {
  connect?: InputMaybe<InspectionGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InspectionGroupCreateOrConnectWithoutInspectionsInput>;
  create?: InputMaybe<InspectionGroupCreateWithoutInspectionsInput>;
  delete?: InputMaybe<InspectionGroupWhereInput>;
  disconnect?: InputMaybe<InspectionGroupWhereInput>;
  update?: InputMaybe<InspectionGroupUpdateToOneWithWhereWithoutInspectionsInput>;
  upsert?: InputMaybe<InspectionGroupUpsertWithoutInspectionsInput>;
};

export type InspectionGroupUpdateToOneWithWhereWithoutInspectionsInput = {
  data: InspectionGroupUpdateWithoutInspectionsInput;
  where?: InputMaybe<InspectionGroupWhereInput>;
};

export type InspectionGroupUpdateWithWhereUniqueWithoutCraftInput = {
  data: InspectionGroupUpdateWithoutCraftInput;
  where: InspectionGroupWhereUniqueInput;
};

export type InspectionGroupUpdateWithoutCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutInspectionGroupNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupUpdateWithoutInspectionsInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionGroupsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionGroupUpsertWithWhereUniqueWithoutCraftInput = {
  create: InspectionGroupCreateWithoutCraftInput;
  update: InspectionGroupUpdateWithoutCraftInput;
  where: InspectionGroupWhereUniqueInput;
};

export type InspectionGroupUpsertWithoutInspectionsInput = {
  create: InspectionGroupCreateWithoutInspectionsInput;
  update: InspectionGroupUpdateWithoutInspectionsInput;
  where?: InputMaybe<InspectionGroupWhereInput>;
};

export type InspectionGroupWhereInput = {
  AND?: InputMaybe<Array<InspectionGroupWhereInput>>;
  NOT?: InputMaybe<Array<InspectionGroupWhereInput>>;
  OR?: InputMaybe<Array<InspectionGroupWhereInput>>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InspectionGroupWhereUniqueInput = {
  AND?: InputMaybe<Array<InspectionGroupWhereInput>>;
  NOT?: InputMaybe<Array<InspectionGroupWhereInput>>;
  OR?: InputMaybe<Array<InspectionGroupWhereInput>>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InspectionListRelationFilter = {
  every?: InputMaybe<InspectionWhereInput>;
  none?: InputMaybe<InspectionWhereInput>;
  some?: InputMaybe<InspectionWhereInput>;
};

export type InspectionMaxAggregate = {
  __typename?: 'InspectionMaxAggregate';
  airworthinessItem?: Maybe<Scalars['Boolean']>;
  componentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doesRepeat?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: Maybe<Scalars['Int']>;
  dueDateMonthsFrequency?: Maybe<Scalars['Int']>;
  dueDateSoon?: Maybe<Scalars['Int']>;
  dueMethod?: Maybe<InspectionDueType>;
  id?: Maybe<Scalars['String']>;
  inspectionGroupId?: Maybe<Scalars['String']>;
  lastNotficationSent?: Maybe<Scalars['DateTime']>;
  lastPerformed?: Maybe<Scalars['DateTime']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InspectionMinAggregate = {
  __typename?: 'InspectionMinAggregate';
  airworthinessItem?: Maybe<Scalars['Boolean']>;
  componentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doesRepeat?: Maybe<Scalars['Boolean']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: Maybe<Scalars['Int']>;
  dueDateMonthsFrequency?: Maybe<Scalars['Int']>;
  dueDateSoon?: Maybe<Scalars['Int']>;
  dueMethod?: Maybe<InspectionDueType>;
  id?: Maybe<Scalars['String']>;
  inspectionGroupId?: Maybe<Scalars['String']>;
  lastNotficationSent?: Maybe<Scalars['DateTime']>;
  lastPerformed?: Maybe<Scalars['DateTime']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InspectionNullableScalarRelationFilter = {
  is?: InputMaybe<InspectionWhereInput>;
  isNot?: InputMaybe<InspectionWhereInput>;
};

export type InspectionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InspectionScalarWhereInput = {
  AND?: InputMaybe<Array<InspectionScalarWhereInput>>;
  NOT?: InputMaybe<Array<InspectionScalarWhereInput>>;
  OR?: InputMaybe<Array<InspectionScalarWhereInput>>;
  airworthinessItem?: InputMaybe<BoolNullableFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  doesRepeat?: InputMaybe<BoolNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  dueDateDaysFrequency?: InputMaybe<IntNullableFilter>;
  dueDateMonthsFrequency?: InputMaybe<IntNullableFilter>;
  dueDateSoon?: InputMaybe<IntNullableFilter>;
  dueInterval?: InputMaybe<JsonNullableFilter>;
  dueMethod?: InputMaybe<EnumInspectionDueTypeFilter>;
  faaInfo?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspectionGroupId?: InputMaybe<StringNullableFilter>;
  lastNotficationSent?: InputMaybe<DateTimeNullableFilter>;
  lastPerformed?: InputMaybe<DateTimeNullableFilter>;
  lastPerformedInterval?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InspectionSumAggregate = {
  __typename?: 'InspectionSumAggregate';
  dueDateDaysFrequency?: Maybe<Scalars['Int']>;
  dueDateMonthsFrequency?: Maybe<Scalars['Int']>;
  dueDateSoon?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
};

export type InspectionUpdateInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentUpdateOneWithoutInspectionsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupUpdateOneWithoutInspectionsNestedInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutInspectionsNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateManyMutationInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateManyWithWhereWithoutComponentInput = {
  data: InspectionUpdateManyMutationInput;
  where: InspectionScalarWhereInput;
};

export type InspectionUpdateManyWithWhereWithoutCraftInput = {
  data: InspectionUpdateManyMutationInput;
  where: InspectionScalarWhereInput;
};

export type InspectionUpdateManyWithWhereWithoutInspectionGroupInput = {
  data: InspectionUpdateManyMutationInput;
  where: InspectionScalarWhereInput;
};

export type InspectionUpdateManyWithWhereWithoutLogBooksInput = {
  data: InspectionUpdateManyMutationInput;
  where: InspectionScalarWhereInput;
};

export type InspectionUpdateManyWithWhereWithoutMaintenanceRecordsInput = {
  data: InspectionUpdateManyMutationInput;
  where: InspectionScalarWhereInput;
};

export type InspectionUpdateManyWithoutComponentNestedInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutComponentInput>>;
  createMany?: InputMaybe<InspectionCreateManyComponentInputEnvelope>;
  delete?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InspectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  set?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  update?: InputMaybe<Array<InspectionUpdateWithWhereUniqueWithoutComponentInput>>;
  updateMany?: InputMaybe<Array<InspectionUpdateManyWithWhereWithoutComponentInput>>;
  upsert?: InputMaybe<Array<InspectionUpsertWithWhereUniqueWithoutComponentInput>>;
};

export type InspectionUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutCraftInput>>;
  createMany?: InputMaybe<InspectionCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InspectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  set?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  update?: InputMaybe<Array<InspectionUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<InspectionUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<InspectionUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type InspectionUpdateManyWithoutInspectionGroupNestedInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutInspectionGroupInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutInspectionGroupInput>>;
  createMany?: InputMaybe<InspectionCreateManyInspectionGroupInputEnvelope>;
  delete?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InspectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  set?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  update?: InputMaybe<Array<InspectionUpdateWithWhereUniqueWithoutInspectionGroupInput>>;
  updateMany?: InputMaybe<Array<InspectionUpdateManyWithWhereWithoutInspectionGroupInput>>;
  upsert?: InputMaybe<Array<InspectionUpsertWithWhereUniqueWithoutInspectionGroupInput>>;
};

export type InspectionUpdateManyWithoutLogBooksNestedInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutLogBooksInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutLogBooksInput>>;
  delete?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InspectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  set?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  update?: InputMaybe<Array<InspectionUpdateWithWhereUniqueWithoutLogBooksInput>>;
  updateMany?: InputMaybe<Array<InspectionUpdateManyWithWhereWithoutLogBooksInput>>;
  upsert?: InputMaybe<Array<InspectionUpsertWithWhereUniqueWithoutLogBooksInput>>;
};

export type InspectionUpdateManyWithoutMaintenanceRecordsNestedInput = {
  connect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InspectionCreateOrConnectWithoutMaintenanceRecordsInput>>;
  create?: InputMaybe<Array<InspectionCreateWithoutMaintenanceRecordsInput>>;
  delete?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InspectionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  set?: InputMaybe<Array<InspectionWhereUniqueInput>>;
  update?: InputMaybe<Array<InspectionUpdateWithWhereUniqueWithoutMaintenanceRecordsInput>>;
  updateMany?: InputMaybe<Array<InspectionUpdateManyWithWhereWithoutMaintenanceRecordsInput>>;
  upsert?: InputMaybe<Array<InspectionUpsertWithWhereUniqueWithoutMaintenanceRecordsInput>>;
};

export type InspectionUpdateOneWithoutIntervalDueRecordsNestedInput = {
  connect?: InputMaybe<InspectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InspectionCreateOrConnectWithoutIntervalDueRecordsInput>;
  create?: InputMaybe<InspectionCreateWithoutIntervalDueRecordsInput>;
  delete?: InputMaybe<InspectionWhereInput>;
  disconnect?: InputMaybe<InspectionWhereInput>;
  update?: InputMaybe<InspectionUpdateToOneWithWhereWithoutIntervalDueRecordsInput>;
  upsert?: InputMaybe<InspectionUpsertWithoutIntervalDueRecordsInput>;
};

export type InspectionUpdateToOneWithWhereWithoutIntervalDueRecordsInput = {
  data: InspectionUpdateWithoutIntervalDueRecordsInput;
  where?: InputMaybe<InspectionWhereInput>;
};

export type InspectionUpdateWithWhereUniqueWithoutComponentInput = {
  data: InspectionUpdateWithoutComponentInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpdateWithWhereUniqueWithoutCraftInput = {
  data: InspectionUpdateWithoutCraftInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpdateWithWhereUniqueWithoutInspectionGroupInput = {
  data: InspectionUpdateWithoutInspectionGroupInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpdateWithWhereUniqueWithoutLogBooksInput = {
  data: InspectionUpdateWithoutLogBooksInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpdateWithWhereUniqueWithoutMaintenanceRecordsInput = {
  data: InspectionUpdateWithoutMaintenanceRecordsInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpdateWithoutComponentInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupUpdateOneWithoutInspectionsNestedInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutInspectionsNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateWithoutCraftInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupUpdateOneWithoutInspectionsNestedInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutInspectionsNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateWithoutInspectionGroupInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentUpdateOneWithoutInspectionsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutInspectionsNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateWithoutIntervalDueRecordsInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentUpdateOneWithoutInspectionsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupUpdateOneWithoutInspectionsNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutInspectionsNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateWithoutLogBooksInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentUpdateOneWithoutInspectionsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupUpdateOneWithoutInspectionsNestedInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpdateWithoutMaintenanceRecordsInput = {
  airworthinessItem?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<ComponentUpdateOneWithoutInspectionsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutInspectionsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  doesRepeat?: InputMaybe<Scalars['Boolean']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  dueDateDaysFrequency?: InputMaybe<Scalars['Int']>;
  dueDateMonthsFrequency?: InputMaybe<Scalars['Int']>;
  dueDateSoon?: InputMaybe<Scalars['Int']>;
  dueInterval?: InputMaybe<Scalars['JSON']>;
  dueMethod?: InputMaybe<InspectionDueType>;
  faaInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupUpdateOneWithoutInspectionsNestedInput>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput>;
  lastNotficationSent?: InputMaybe<Scalars['DateTime']>;
  lastPerformed?: InputMaybe<Scalars['DateTime']>;
  lastPerformedInterval?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutInspectionsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InspectionUpsertWithWhereUniqueWithoutComponentInput = {
  create: InspectionCreateWithoutComponentInput;
  update: InspectionUpdateWithoutComponentInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpsertWithWhereUniqueWithoutCraftInput = {
  create: InspectionCreateWithoutCraftInput;
  update: InspectionUpdateWithoutCraftInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpsertWithWhereUniqueWithoutInspectionGroupInput = {
  create: InspectionCreateWithoutInspectionGroupInput;
  update: InspectionUpdateWithoutInspectionGroupInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpsertWithWhereUniqueWithoutLogBooksInput = {
  create: InspectionCreateWithoutLogBooksInput;
  update: InspectionUpdateWithoutLogBooksInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpsertWithWhereUniqueWithoutMaintenanceRecordsInput = {
  create: InspectionCreateWithoutMaintenanceRecordsInput;
  update: InspectionUpdateWithoutMaintenanceRecordsInput;
  where: InspectionWhereUniqueInput;
};

export type InspectionUpsertWithoutIntervalDueRecordsInput = {
  create: InspectionCreateWithoutIntervalDueRecordsInput;
  update: InspectionUpdateWithoutIntervalDueRecordsInput;
  where?: InputMaybe<InspectionWhereInput>;
};

export type InspectionWhereInput = {
  AND?: InputMaybe<Array<InspectionWhereInput>>;
  NOT?: InputMaybe<Array<InspectionWhereInput>>;
  OR?: InputMaybe<Array<InspectionWhereInput>>;
  airworthinessItem?: InputMaybe<BoolNullableFilter>;
  component?: InputMaybe<ComponentNullableScalarRelationFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  doesRepeat?: InputMaybe<BoolNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  dueDateDaysFrequency?: InputMaybe<IntNullableFilter>;
  dueDateMonthsFrequency?: InputMaybe<IntNullableFilter>;
  dueDateSoon?: InputMaybe<IntNullableFilter>;
  dueInterval?: InputMaybe<JsonNullableFilter>;
  dueMethod?: InputMaybe<EnumInspectionDueTypeFilter>;
  faaInfo?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspectionGroup?: InputMaybe<InspectionGroupNullableScalarRelationFilter>;
  inspectionGroupId?: InputMaybe<StringNullableFilter>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsListRelationFilter>;
  lastNotficationSent?: InputMaybe<DateTimeNullableFilter>;
  lastPerformed?: InputMaybe<DateTimeNullableFilter>;
  lastPerformedInterval?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logBooks?: InputMaybe<LogBookListRelationFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InspectionWhereUniqueInput = {
  AND?: InputMaybe<Array<InspectionWhereInput>>;
  NOT?: InputMaybe<Array<InspectionWhereInput>>;
  OR?: InputMaybe<Array<InspectionWhereInput>>;
  airworthinessItem?: InputMaybe<BoolNullableFilter>;
  component?: InputMaybe<ComponentNullableScalarRelationFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  doesRepeat?: InputMaybe<BoolNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  dueDateDaysFrequency?: InputMaybe<IntNullableFilter>;
  dueDateMonthsFrequency?: InputMaybe<IntNullableFilter>;
  dueDateSoon?: InputMaybe<IntNullableFilter>;
  dueInterval?: InputMaybe<JsonNullableFilter>;
  dueMethod?: InputMaybe<EnumInspectionDueTypeFilter>;
  faaInfo?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroup?: InputMaybe<InspectionGroupNullableScalarRelationFilter>;
  inspectionGroupId?: InputMaybe<StringNullableFilter>;
  intervalDueRecords?: InputMaybe<IntervalsOnInspectionsListRelationFilter>;
  lastNotficationSent?: InputMaybe<DateTimeNullableFilter>;
  lastPerformed?: InputMaybe<DateTimeNullableFilter>;
  lastPerformedInterval?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookListRelationFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Integration = {
  __typename?: 'Integration';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastSync?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntegrationCountAggregate = {
  __typename?: 'IntegrationCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  lastSync: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  settings: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type IntegrationCreateManyOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastSync?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntegrationCreateManyOrganizationInputEnvelope = {
  data: Array<IntegrationCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntegrationCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<IntegrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntegrationCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<IntegrationCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<IntegrationCreateManyOrganizationInputEnvelope>;
};

export type IntegrationCreateOrConnectWithoutOrganizationInput = {
  create: IntegrationCreateWithoutOrganizationInput;
  where: IntegrationWhereUniqueInput;
};

export type IntegrationCreateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastSync?: InputMaybe<Scalars['DateTime']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntegrationListRelationFilter = {
  every?: InputMaybe<IntegrationWhereInput>;
  none?: InputMaybe<IntegrationWhereInput>;
  some?: InputMaybe<IntegrationWhereInput>;
};

export type IntegrationMaxAggregate = {
  __typename?: 'IntegrationMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSync?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntegrationMinAggregate = {
  __typename?: 'IntegrationMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastSync?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntegrationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IntegrationScalarWhereInput = {
  AND?: InputMaybe<Array<IntegrationScalarWhereInput>>;
  NOT?: InputMaybe<Array<IntegrationScalarWhereInput>>;
  OR?: InputMaybe<Array<IntegrationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastSync?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  settings?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntegrationUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastSync?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntegrationUpdateManyWithWhereWithoutOrganizationInput = {
  data: IntegrationUpdateManyMutationInput;
  where: IntegrationScalarWhereInput;
};

export type IntegrationUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<IntegrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntegrationCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<IntegrationCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<IntegrationCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<IntegrationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntegrationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntegrationWhereUniqueInput>>;
  set?: InputMaybe<Array<IntegrationWhereUniqueInput>>;
  update?: InputMaybe<Array<IntegrationUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<IntegrationUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<IntegrationUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type IntegrationUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: IntegrationUpdateWithoutOrganizationInput;
  where: IntegrationWhereUniqueInput;
};

export type IntegrationUpdateWithoutOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastSync?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntegrationUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: IntegrationCreateWithoutOrganizationInput;
  update: IntegrationUpdateWithoutOrganizationInput;
  where: IntegrationWhereUniqueInput;
};

export type IntegrationWhereInput = {
  AND?: InputMaybe<Array<IntegrationWhereInput>>;
  NOT?: InputMaybe<Array<IntegrationWhereInput>>;
  OR?: InputMaybe<Array<IntegrationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastSync?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  settings?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntegrationWhereUniqueInput = {
  AND?: InputMaybe<Array<IntegrationWhereInput>>;
  NOT?: InputMaybe<Array<IntegrationWhereInput>>;
  OR?: InputMaybe<Array<IntegrationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  lastSync?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  settings?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type Interval = {
  __typename?: 'Interval';
  _count: IntervalCount;
  component?: Maybe<Component>;
  componentId?: Maybe<Scalars['String']>;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  inspectionDueRecords?: Maybe<Array<IntervalsOnInspections>>;
  inspections: Array<Inspection>;
  intervalLogs?: Maybe<Array<IntervalLog>>;
  intervalSubType?: Maybe<IntervalSubtype>;
  intervalType: IntervalType;
  isCustom: Scalars['Boolean'];
  legacyId?: Maybe<Scalars['String']>;
  logBooks?: Maybe<Array<LogBook>>;
  mroLogEntry?: Maybe<MroLogEntry>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  recentIntervalLog?: Maybe<IntervalLog>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntervalCount = {
  __typename?: 'IntervalCount';
  inspectionDueRecords: Scalars['Int'];
  intervalLogs: Scalars['Int'];
  logBooks: Scalars['Int'];
};

export type IntervalCountAggregate = {
  __typename?: 'IntervalCountAggregate';
  _all: Scalars['Int'];
  componentId: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  intervalSubType: Scalars['Int'];
  intervalType: Scalars['Int'];
  isCustom: Scalars['Int'];
  legacyId: Scalars['Int'];
  mroLogEntryId: Scalars['Int'];
  name: Scalars['Int'];
  optional: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type IntervalCreateInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutIntervalsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutIntervalsInput>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateManyComponentInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  mroLogEntryId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateManyComponentInputEnvelope = {
  data: Array<IntervalCreateManyComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalCreateManyCraftInput = {
  componentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  mroLogEntryId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateManyCraftInputEnvelope = {
  data: Array<IntervalCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalCreateManyMroLogEntryInput = {
  componentId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateManyMroLogEntryInputEnvelope = {
  data: Array<IntervalCreateManyMroLogEntryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalCreateNestedManyWithoutComponentInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutComponentInput>>;
  createMany?: InputMaybe<IntervalCreateManyComponentInputEnvelope>;
};

export type IntervalCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutCraftInput>>;
  createMany?: InputMaybe<IntervalCreateManyCraftInputEnvelope>;
};

export type IntervalCreateNestedManyWithoutLogBooksInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutLogBooksInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutLogBooksInput>>;
};

export type IntervalCreateNestedManyWithoutMroLogEntryInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutMroLogEntryInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutMroLogEntryInput>>;
  createMany?: InputMaybe<IntervalCreateManyMroLogEntryInputEnvelope>;
};

export type IntervalCreateNestedOneWithoutInspectionDueRecordsInput = {
  connect?: InputMaybe<IntervalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IntervalCreateOrConnectWithoutInspectionDueRecordsInput>;
  create?: InputMaybe<IntervalCreateWithoutInspectionDueRecordsInput>;
};

export type IntervalCreateNestedOneWithoutIntervalLogsInput = {
  connect?: InputMaybe<IntervalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IntervalCreateOrConnectWithoutIntervalLogsInput>;
  create?: InputMaybe<IntervalCreateWithoutIntervalLogsInput>;
};

export type IntervalCreateOrConnectWithoutComponentInput = {
  create: IntervalCreateWithoutComponentInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalCreateOrConnectWithoutCraftInput = {
  create: IntervalCreateWithoutCraftInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalCreateOrConnectWithoutInspectionDueRecordsInput = {
  create: IntervalCreateWithoutInspectionDueRecordsInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalCreateOrConnectWithoutIntervalLogsInput = {
  create: IntervalCreateWithoutIntervalLogsInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalCreateOrConnectWithoutLogBooksInput = {
  create: IntervalCreateWithoutLogBooksInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalCreateOrConnectWithoutMroLogEntryInput = {
  create: IntervalCreateWithoutMroLogEntryInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalCreateWithoutComponentInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutIntervalsInput>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateWithoutCraftInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutIntervalsInput>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateWithoutInspectionDueRecordsInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutIntervalsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutIntervalsInput>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateWithoutIntervalLogsInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutIntervalsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutIntervalsInput>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateWithoutLogBooksInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutIntervalsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalCreateWithoutMroLogEntryInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutIntervalsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutIntervalsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutIntervalInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutIntervalsInput>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalListRelationFilter = {
  every?: InputMaybe<IntervalWhereInput>;
  none?: InputMaybe<IntervalWhereInput>;
  some?: InputMaybe<IntervalWhereInput>;
};

export type IntervalLog = {
  __typename?: 'IntervalLog';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endValue?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  interval?: Maybe<Interval>;
  intervalId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  startValue?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageRecord?: Maybe<UsageRecord>;
  usageRecordId?: Maybe<Scalars['String']>;
};

export type IntervalLogAvgAggregate = {
  __typename?: 'IntervalLogAvgAggregate';
  endValue?: Maybe<Scalars['Decimal']>;
  startValue?: Maybe<Scalars['Decimal']>;
};

export type IntervalLogCountAggregate = {
  __typename?: 'IntervalLogCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  endValue: Scalars['Int'];
  id: Scalars['Int'];
  intervalId: Scalars['Int'];
  legacyId: Scalars['Int'];
  startValue: Scalars['Int'];
  updatedAt: Scalars['Int'];
  usageRecordId: Scalars['Int'];
};

export type IntervalLogCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalCreateNestedOneWithoutIntervalLogsInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutIntervalLogsInput>;
};

export type IntervalLogCreateManyIntervalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecordId?: InputMaybe<Scalars['String']>;
};

export type IntervalLogCreateManyIntervalInputEnvelope = {
  data: Array<IntervalLogCreateManyIntervalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalLogCreateManyUsageRecordInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  intervalId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalLogCreateManyUsageRecordInputEnvelope = {
  data: Array<IntervalLogCreateManyUsageRecordInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalLogCreateNestedManyWithoutIntervalInput = {
  connect?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalLogCreateOrConnectWithoutIntervalInput>>;
  create?: InputMaybe<Array<IntervalLogCreateWithoutIntervalInput>>;
  createMany?: InputMaybe<IntervalLogCreateManyIntervalInputEnvelope>;
};

export type IntervalLogCreateNestedManyWithoutUsageRecordInput = {
  connect?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalLogCreateOrConnectWithoutUsageRecordInput>>;
  create?: InputMaybe<Array<IntervalLogCreateWithoutUsageRecordInput>>;
  createMany?: InputMaybe<IntervalLogCreateManyUsageRecordInputEnvelope>;
};

export type IntervalLogCreateOrConnectWithoutIntervalInput = {
  create: IntervalLogCreateWithoutIntervalInput;
  where: IntervalLogWhereUniqueInput;
};

export type IntervalLogCreateOrConnectWithoutUsageRecordInput = {
  create: IntervalLogCreateWithoutUsageRecordInput;
  where: IntervalLogWhereUniqueInput;
};

export type IntervalLogCreateWithoutIntervalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordCreateNestedOneWithoutIntervalLogsInput>;
};

export type IntervalLogCreateWithoutUsageRecordInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalCreateNestedOneWithoutIntervalLogsInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalLogListRelationFilter = {
  every?: InputMaybe<IntervalLogWhereInput>;
  none?: InputMaybe<IntervalLogWhereInput>;
  some?: InputMaybe<IntervalLogWhereInput>;
};

export type IntervalLogMaxAggregate = {
  __typename?: 'IntervalLogMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endValue?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  intervalId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  startValue?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageRecordId?: Maybe<Scalars['String']>;
};

export type IntervalLogMinAggregate = {
  __typename?: 'IntervalLogMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endValue?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  intervalId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  startValue?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageRecordId?: Maybe<Scalars['String']>;
};

export type IntervalLogOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IntervalLogScalarWhereInput = {
  AND?: InputMaybe<Array<IntervalLogScalarWhereInput>>;
  NOT?: InputMaybe<Array<IntervalLogScalarWhereInput>>;
  OR?: InputMaybe<Array<IntervalLogScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endValue?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  startValue?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageRecordId?: InputMaybe<StringNullableFilter>;
};

export type IntervalLogSumAggregate = {
  __typename?: 'IntervalLogSumAggregate';
  endValue?: Maybe<Scalars['Decimal']>;
  startValue?: Maybe<Scalars['Decimal']>;
};

export type IntervalLogUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalUpdateOneWithoutIntervalLogsNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutIntervalLogsNestedInput>;
};

export type IntervalLogUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalLogUpdateManyWithWhereWithoutIntervalInput = {
  data: IntervalLogUpdateManyMutationInput;
  where: IntervalLogScalarWhereInput;
};

export type IntervalLogUpdateManyWithWhereWithoutUsageRecordInput = {
  data: IntervalLogUpdateManyMutationInput;
  where: IntervalLogScalarWhereInput;
};

export type IntervalLogUpdateManyWithoutIntervalNestedInput = {
  connect?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalLogCreateOrConnectWithoutIntervalInput>>;
  create?: InputMaybe<Array<IntervalLogCreateWithoutIntervalInput>>;
  createMany?: InputMaybe<IntervalLogCreateManyIntervalInputEnvelope>;
  delete?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalLogUpdateWithWhereUniqueWithoutIntervalInput>>;
  updateMany?: InputMaybe<Array<IntervalLogUpdateManyWithWhereWithoutIntervalInput>>;
  upsert?: InputMaybe<Array<IntervalLogUpsertWithWhereUniqueWithoutIntervalInput>>;
};

export type IntervalLogUpdateManyWithoutUsageRecordNestedInput = {
  connect?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalLogCreateOrConnectWithoutUsageRecordInput>>;
  create?: InputMaybe<Array<IntervalLogCreateWithoutUsageRecordInput>>;
  createMany?: InputMaybe<IntervalLogCreateManyUsageRecordInputEnvelope>;
  delete?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalLogScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalLogWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalLogUpdateWithWhereUniqueWithoutUsageRecordInput>>;
  updateMany?: InputMaybe<Array<IntervalLogUpdateManyWithWhereWithoutUsageRecordInput>>;
  upsert?: InputMaybe<Array<IntervalLogUpsertWithWhereUniqueWithoutUsageRecordInput>>;
};

export type IntervalLogUpdateWithWhereUniqueWithoutIntervalInput = {
  data: IntervalLogUpdateWithoutIntervalInput;
  where: IntervalLogWhereUniqueInput;
};

export type IntervalLogUpdateWithWhereUniqueWithoutUsageRecordInput = {
  data: IntervalLogUpdateWithoutUsageRecordInput;
  where: IntervalLogWhereUniqueInput;
};

export type IntervalLogUpdateWithoutIntervalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecord?: InputMaybe<UsageRecordUpdateOneWithoutIntervalLogsNestedInput>;
};

export type IntervalLogUpdateWithoutUsageRecordInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endValue?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalUpdateOneWithoutIntervalLogsNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalLogUpsertWithWhereUniqueWithoutIntervalInput = {
  create: IntervalLogCreateWithoutIntervalInput;
  update: IntervalLogUpdateWithoutIntervalInput;
  where: IntervalLogWhereUniqueInput;
};

export type IntervalLogUpsertWithWhereUniqueWithoutUsageRecordInput = {
  create: IntervalLogCreateWithoutUsageRecordInput;
  update: IntervalLogUpdateWithoutUsageRecordInput;
  where: IntervalLogWhereUniqueInput;
};

export type IntervalLogWhereInput = {
  AND?: InputMaybe<Array<IntervalLogWhereInput>>;
  NOT?: InputMaybe<Array<IntervalLogWhereInput>>;
  OR?: InputMaybe<Array<IntervalLogWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endValue?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interval?: InputMaybe<IntervalNullableScalarRelationFilter>;
  intervalId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  startValue?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageRecord?: InputMaybe<UsageRecordNullableScalarRelationFilter>;
  usageRecordId?: InputMaybe<StringNullableFilter>;
};

export type IntervalLogWhereUniqueInput = {
  AND?: InputMaybe<Array<IntervalLogWhereInput>>;
  NOT?: InputMaybe<Array<IntervalLogWhereInput>>;
  OR?: InputMaybe<Array<IntervalLogWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endValue?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalNullableScalarRelationFilter>;
  intervalId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  startValue?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageRecord?: InputMaybe<UsageRecordNullableScalarRelationFilter>;
  usageRecordId?: InputMaybe<StringNullableFilter>;
};

export type IntervalMaxAggregate = {
  __typename?: 'IntervalMaxAggregate';
  componentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intervalSubType?: Maybe<IntervalSubtype>;
  intervalType?: Maybe<IntervalType>;
  isCustom?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntervalMinAggregate = {
  __typename?: 'IntervalMinAggregate';
  componentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  intervalSubType?: Maybe<IntervalSubtype>;
  intervalType?: Maybe<IntervalType>;
  isCustom?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optional?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntervalNullableScalarRelationFilter = {
  is?: InputMaybe<IntervalWhereInput>;
  isNot?: InputMaybe<IntervalWhereInput>;
};

export type IntervalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type IntervalScalarWhereInput = {
  AND?: InputMaybe<Array<IntervalScalarWhereInput>>;
  NOT?: InputMaybe<Array<IntervalScalarWhereInput>>;
  OR?: InputMaybe<Array<IntervalScalarWhereInput>>;
  componentId?: InputMaybe<StringNullableFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalSubType?: InputMaybe<EnumIntervalSubtypeNullableFilter>;
  intervalType?: InputMaybe<EnumIntervalTypeFilter>;
  isCustom?: InputMaybe<BoolFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  optional?: InputMaybe<BoolNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum IntervalSubtype {
  Actt = 'ACTT',
  Cycles = 'CYCLES',
  Fuel = 'FUEL',
  Hobbs = 'HOBBS',
  Oil = 'OIL',
  Other = 'OTHER',
  Tach = 'TACH',
  Tachtwo = 'TACHTWO'
}

export enum IntervalType {
  Consumable = 'CONSUMABLE',
  Normal = 'NORMAL'
}

export type IntervalUpdateInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutIntervalsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutIntervalsNestedInput>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateManyWithWhereWithoutComponentInput = {
  data: IntervalUpdateManyMutationInput;
  where: IntervalScalarWhereInput;
};

export type IntervalUpdateManyWithWhereWithoutCraftInput = {
  data: IntervalUpdateManyMutationInput;
  where: IntervalScalarWhereInput;
};

export type IntervalUpdateManyWithWhereWithoutLogBooksInput = {
  data: IntervalUpdateManyMutationInput;
  where: IntervalScalarWhereInput;
};

export type IntervalUpdateManyWithWhereWithoutMroLogEntryInput = {
  data: IntervalUpdateManyMutationInput;
  where: IntervalScalarWhereInput;
};

export type IntervalUpdateManyWithoutComponentNestedInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutComponentInput>>;
  createMany?: InputMaybe<IntervalCreateManyComponentInputEnvelope>;
  delete?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalUpdateWithWhereUniqueWithoutComponentInput>>;
  updateMany?: InputMaybe<Array<IntervalUpdateManyWithWhereWithoutComponentInput>>;
  upsert?: InputMaybe<Array<IntervalUpsertWithWhereUniqueWithoutComponentInput>>;
};

export type IntervalUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutCraftInput>>;
  createMany?: InputMaybe<IntervalCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<IntervalUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<IntervalUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type IntervalUpdateManyWithoutLogBooksNestedInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutLogBooksInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutLogBooksInput>>;
  delete?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalUpdateWithWhereUniqueWithoutLogBooksInput>>;
  updateMany?: InputMaybe<Array<IntervalUpdateManyWithWhereWithoutLogBooksInput>>;
  upsert?: InputMaybe<Array<IntervalUpsertWithWhereUniqueWithoutLogBooksInput>>;
};

export type IntervalUpdateManyWithoutMroLogEntryNestedInput = {
  connect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalCreateOrConnectWithoutMroLogEntryInput>>;
  create?: InputMaybe<Array<IntervalCreateWithoutMroLogEntryInput>>;
  createMany?: InputMaybe<IntervalCreateManyMroLogEntryInputEnvelope>;
  delete?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalUpdateWithWhereUniqueWithoutMroLogEntryInput>>;
  updateMany?: InputMaybe<Array<IntervalUpdateManyWithWhereWithoutMroLogEntryInput>>;
  upsert?: InputMaybe<Array<IntervalUpsertWithWhereUniqueWithoutMroLogEntryInput>>;
};

export type IntervalUpdateOneWithoutInspectionDueRecordsNestedInput = {
  connect?: InputMaybe<IntervalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IntervalCreateOrConnectWithoutInspectionDueRecordsInput>;
  create?: InputMaybe<IntervalCreateWithoutInspectionDueRecordsInput>;
  delete?: InputMaybe<IntervalWhereInput>;
  disconnect?: InputMaybe<IntervalWhereInput>;
  update?: InputMaybe<IntervalUpdateToOneWithWhereWithoutInspectionDueRecordsInput>;
  upsert?: InputMaybe<IntervalUpsertWithoutInspectionDueRecordsInput>;
};

export type IntervalUpdateOneWithoutIntervalLogsNestedInput = {
  connect?: InputMaybe<IntervalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IntervalCreateOrConnectWithoutIntervalLogsInput>;
  create?: InputMaybe<IntervalCreateWithoutIntervalLogsInput>;
  delete?: InputMaybe<IntervalWhereInput>;
  disconnect?: InputMaybe<IntervalWhereInput>;
  update?: InputMaybe<IntervalUpdateToOneWithWhereWithoutIntervalLogsInput>;
  upsert?: InputMaybe<IntervalUpsertWithoutIntervalLogsInput>;
};

export type IntervalUpdateToOneWithWhereWithoutInspectionDueRecordsInput = {
  data: IntervalUpdateWithoutInspectionDueRecordsInput;
  where?: InputMaybe<IntervalWhereInput>;
};

export type IntervalUpdateToOneWithWhereWithoutIntervalLogsInput = {
  data: IntervalUpdateWithoutIntervalLogsInput;
  where?: InputMaybe<IntervalWhereInput>;
};

export type IntervalUpdateWithWhereUniqueWithoutComponentInput = {
  data: IntervalUpdateWithoutComponentInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpdateWithWhereUniqueWithoutCraftInput = {
  data: IntervalUpdateWithoutCraftInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpdateWithWhereUniqueWithoutLogBooksInput = {
  data: IntervalUpdateWithoutLogBooksInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpdateWithWhereUniqueWithoutMroLogEntryInput = {
  data: IntervalUpdateWithoutMroLogEntryInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpdateWithoutComponentInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutIntervalsNestedInput>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateWithoutCraftInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutIntervalsNestedInput>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateWithoutInspectionDueRecordsInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutIntervalsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutIntervalsNestedInput>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateWithoutIntervalLogsInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutIntervalsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutIntervalsNestedInput>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateWithoutLogBooksInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutIntervalsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpdateWithoutMroLogEntryInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutIntervalsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutIntervalsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutIntervalNestedInput>;
  intervalSubType?: InputMaybe<IntervalSubtype>;
  intervalType?: InputMaybe<IntervalType>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  optional?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalUpsertWithWhereUniqueWithoutComponentInput = {
  create: IntervalCreateWithoutComponentInput;
  update: IntervalUpdateWithoutComponentInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpsertWithWhereUniqueWithoutCraftInput = {
  create: IntervalCreateWithoutCraftInput;
  update: IntervalUpdateWithoutCraftInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpsertWithWhereUniqueWithoutLogBooksInput = {
  create: IntervalCreateWithoutLogBooksInput;
  update: IntervalUpdateWithoutLogBooksInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpsertWithWhereUniqueWithoutMroLogEntryInput = {
  create: IntervalCreateWithoutMroLogEntryInput;
  update: IntervalUpdateWithoutMroLogEntryInput;
  where: IntervalWhereUniqueInput;
};

export type IntervalUpsertWithoutInspectionDueRecordsInput = {
  create: IntervalCreateWithoutInspectionDueRecordsInput;
  update: IntervalUpdateWithoutInspectionDueRecordsInput;
  where?: InputMaybe<IntervalWhereInput>;
};

export type IntervalUpsertWithoutIntervalLogsInput = {
  create: IntervalCreateWithoutIntervalLogsInput;
  update: IntervalUpdateWithoutIntervalLogsInput;
  where?: InputMaybe<IntervalWhereInput>;
};

export type IntervalWhereInput = {
  AND?: InputMaybe<Array<IntervalWhereInput>>;
  NOT?: InputMaybe<Array<IntervalWhereInput>>;
  OR?: InputMaybe<Array<IntervalWhereInput>>;
  component?: InputMaybe<ComponentNullableScalarRelationFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsListRelationFilter>;
  intervalLogs?: InputMaybe<IntervalLogListRelationFilter>;
  intervalSubType?: InputMaybe<EnumIntervalSubtypeNullableFilter>;
  intervalType?: InputMaybe<EnumIntervalTypeFilter>;
  isCustom?: InputMaybe<BoolFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logBooks?: InputMaybe<LogBookListRelationFilter>;
  mroLogEntry?: InputMaybe<MroLogEntryNullableScalarRelationFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  optional?: InputMaybe<BoolNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntervalWhereUniqueInput = {
  AND?: InputMaybe<Array<IntervalWhereInput>>;
  NOT?: InputMaybe<Array<IntervalWhereInput>>;
  OR?: InputMaybe<Array<IntervalWhereInput>>;
  component?: InputMaybe<ComponentNullableScalarRelationFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspectionDueRecords?: InputMaybe<IntervalsOnInspectionsListRelationFilter>;
  intervalLogs?: InputMaybe<IntervalLogListRelationFilter>;
  intervalSubType?: InputMaybe<EnumIntervalSubtypeNullableFilter>;
  intervalType?: InputMaybe<EnumIntervalTypeFilter>;
  isCustom?: InputMaybe<BoolFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookListRelationFilter>;
  mroLogEntry?: InputMaybe<MroLogEntryNullableScalarRelationFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  optional?: InputMaybe<BoolNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntervalsForCraft = {
  id?: InputMaybe<Scalars['String']>;
  intervalSubType?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type IntervalsForFlight = {
  endValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  intervalSubType?: InputMaybe<Scalars['String']>;
  intervalType: Scalars['String'];
  name: Scalars['String'];
  startValue?: InputMaybe<Scalars['Float']>;
  subtype?: InputMaybe<Scalars['String']>;
};

export type IntervalsOnInspections = {
  __typename?: 'IntervalsOnInspections';
  craft: Craft;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  inspection?: Maybe<Inspection>;
  inspectionId: Scalars['String'];
  inspections: Array<Inspection>;
  interval?: Maybe<Interval>;
  intervalId: Scalars['String'];
  legacyId?: Maybe<Scalars['String']>;
  logEntries: Array<LogEntry>;
  squawks: Array<Squawk>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsAvgAggregate = {
  __typename?: 'IntervalsOnInspectionsAvgAggregate';
  dueAt?: Maybe<Scalars['Decimal']>;
};

export type IntervalsOnInspectionsCountAggregate = {
  __typename?: 'IntervalsOnInspectionsCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  dueAt: Scalars['Int'];
  id: Scalars['Int'];
  inspectionId: Scalars['Int'];
  intervalId: Scalars['Int'];
  legacyId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type IntervalsOnInspectionsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  inspection?: InputMaybe<InspectionCreateNestedOneWithoutIntervalDueRecordsInput>;
  interval?: InputMaybe<IntervalCreateNestedOneWithoutInspectionDueRecordsInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsCreateManyInspectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  intervalId: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsCreateManyInspectionInputEnvelope = {
  data: Array<IntervalsOnInspectionsCreateManyInspectionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalsOnInspectionsCreateManyIntervalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionId: Scalars['String'];
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsCreateManyIntervalInputEnvelope = {
  data: Array<IntervalsOnInspectionsCreateManyIntervalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type IntervalsOnInspectionsCreateNestedManyWithoutInspectionInput = {
  connect?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalsOnInspectionsCreateOrConnectWithoutInspectionInput>>;
  create?: InputMaybe<Array<IntervalsOnInspectionsCreateWithoutInspectionInput>>;
  createMany?: InputMaybe<IntervalsOnInspectionsCreateManyInspectionInputEnvelope>;
};

export type IntervalsOnInspectionsCreateNestedManyWithoutIntervalInput = {
  connect?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalsOnInspectionsCreateOrConnectWithoutIntervalInput>>;
  create?: InputMaybe<Array<IntervalsOnInspectionsCreateWithoutIntervalInput>>;
  createMany?: InputMaybe<IntervalsOnInspectionsCreateManyIntervalInputEnvelope>;
};

export type IntervalsOnInspectionsCreateOrConnectWithoutInspectionInput = {
  create: IntervalsOnInspectionsCreateWithoutInspectionInput;
  where: IntervalsOnInspectionsWhereUniqueInput;
};

export type IntervalsOnInspectionsCreateOrConnectWithoutIntervalInput = {
  create: IntervalsOnInspectionsCreateWithoutIntervalInput;
  where: IntervalsOnInspectionsWhereUniqueInput;
};

export type IntervalsOnInspectionsCreateWithoutInspectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalCreateNestedOneWithoutInspectionDueRecordsInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsCreateWithoutIntervalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  inspection?: InputMaybe<InspectionCreateNestedOneWithoutIntervalDueRecordsInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsListRelationFilter = {
  every?: InputMaybe<IntervalsOnInspectionsWhereInput>;
  none?: InputMaybe<IntervalsOnInspectionsWhereInput>;
  some?: InputMaybe<IntervalsOnInspectionsWhereInput>;
};

export type IntervalsOnInspectionsMaxAggregate = {
  __typename?: 'IntervalsOnInspectionsMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  inspectionId?: Maybe<Scalars['String']>;
  intervalId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsMinAggregate = {
  __typename?: 'IntervalsOnInspectionsMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  inspectionId?: Maybe<Scalars['String']>;
  intervalId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsScalarWhereInput = {
  AND?: InputMaybe<Array<IntervalsOnInspectionsScalarWhereInput>>;
  NOT?: InputMaybe<Array<IntervalsOnInspectionsScalarWhereInput>>;
  OR?: InputMaybe<Array<IntervalsOnInspectionsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  dueAt?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspectionId?: InputMaybe<StringFilter>;
  intervalId?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntervalsOnInspectionsSumAggregate = {
  __typename?: 'IntervalsOnInspectionsSumAggregate';
  dueAt?: Maybe<Scalars['Decimal']>;
};

export type IntervalsOnInspectionsUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  inspection?: InputMaybe<InspectionUpdateOneWithoutIntervalDueRecordsNestedInput>;
  interval?: InputMaybe<IntervalUpdateOneWithoutInspectionDueRecordsNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsUpdateManyWithWhereWithoutInspectionInput = {
  data: IntervalsOnInspectionsUpdateManyMutationInput;
  where: IntervalsOnInspectionsScalarWhereInput;
};

export type IntervalsOnInspectionsUpdateManyWithWhereWithoutIntervalInput = {
  data: IntervalsOnInspectionsUpdateManyMutationInput;
  where: IntervalsOnInspectionsScalarWhereInput;
};

export type IntervalsOnInspectionsUpdateManyWithoutInspectionNestedInput = {
  connect?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalsOnInspectionsCreateOrConnectWithoutInspectionInput>>;
  create?: InputMaybe<Array<IntervalsOnInspectionsCreateWithoutInspectionInput>>;
  createMany?: InputMaybe<IntervalsOnInspectionsCreateManyInspectionInputEnvelope>;
  delete?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalsOnInspectionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalsOnInspectionsUpdateWithWhereUniqueWithoutInspectionInput>>;
  updateMany?: InputMaybe<Array<IntervalsOnInspectionsUpdateManyWithWhereWithoutInspectionInput>>;
  upsert?: InputMaybe<Array<IntervalsOnInspectionsUpsertWithWhereUniqueWithoutInspectionInput>>;
};

export type IntervalsOnInspectionsUpdateManyWithoutIntervalNestedInput = {
  connect?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<IntervalsOnInspectionsCreateOrConnectWithoutIntervalInput>>;
  create?: InputMaybe<Array<IntervalsOnInspectionsCreateWithoutIntervalInput>>;
  createMany?: InputMaybe<IntervalsOnInspectionsCreateManyIntervalInputEnvelope>;
  delete?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<IntervalsOnInspectionsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  set?: InputMaybe<Array<IntervalsOnInspectionsWhereUniqueInput>>;
  update?: InputMaybe<Array<IntervalsOnInspectionsUpdateWithWhereUniqueWithoutIntervalInput>>;
  updateMany?: InputMaybe<Array<IntervalsOnInspectionsUpdateManyWithWhereWithoutIntervalInput>>;
  upsert?: InputMaybe<Array<IntervalsOnInspectionsUpsertWithWhereUniqueWithoutIntervalInput>>;
};

export type IntervalsOnInspectionsUpdateWithWhereUniqueWithoutInspectionInput = {
  data: IntervalsOnInspectionsUpdateWithoutInspectionInput;
  where: IntervalsOnInspectionsWhereUniqueInput;
};

export type IntervalsOnInspectionsUpdateWithWhereUniqueWithoutIntervalInput = {
  data: IntervalsOnInspectionsUpdateWithoutIntervalInput;
  where: IntervalsOnInspectionsWhereUniqueInput;
};

export type IntervalsOnInspectionsUpdateWithoutInspectionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalUpdateOneWithoutInspectionDueRecordsNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsUpdateWithoutIntervalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  dueAt?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  inspection?: InputMaybe<InspectionUpdateOneWithoutIntervalDueRecordsNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type IntervalsOnInspectionsUpsertWithWhereUniqueWithoutInspectionInput = {
  create: IntervalsOnInspectionsCreateWithoutInspectionInput;
  update: IntervalsOnInspectionsUpdateWithoutInspectionInput;
  where: IntervalsOnInspectionsWhereUniqueInput;
};

export type IntervalsOnInspectionsUpsertWithWhereUniqueWithoutIntervalInput = {
  create: IntervalsOnInspectionsCreateWithoutIntervalInput;
  update: IntervalsOnInspectionsUpdateWithoutIntervalInput;
  where: IntervalsOnInspectionsWhereUniqueInput;
};

export type IntervalsOnInspectionsWhereInput = {
  AND?: InputMaybe<Array<IntervalsOnInspectionsWhereInput>>;
  NOT?: InputMaybe<Array<IntervalsOnInspectionsWhereInput>>;
  OR?: InputMaybe<Array<IntervalsOnInspectionsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  dueAt?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspection?: InputMaybe<InspectionNullableScalarRelationFilter>;
  inspectionId?: InputMaybe<StringFilter>;
  interval?: InputMaybe<IntervalNullableScalarRelationFilter>;
  intervalId?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type IntervalsOnInspectionsWhereUniqueInput = {
  AND?: InputMaybe<Array<IntervalsOnInspectionsWhereInput>>;
  NOT?: InputMaybe<Array<IntervalsOnInspectionsWhereInput>>;
  OR?: InputMaybe<Array<IntervalsOnInspectionsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  dueAt?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspection?: InputMaybe<InspectionNullableScalarRelationFilter>;
  inspectionId?: InputMaybe<StringFilter>;
  interval?: InputMaybe<IntervalNullableScalarRelationFilter>;
  intervalId?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type JascCategory = {
  __typename?: 'JascCategory';
  _count: JascCategoryCount;
  code: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  jascSystems?: Maybe<Array<JascSystem>>;
  name: Scalars['String'];
};

export type JascCategoryAvgAggregate = {
  __typename?: 'JascCategoryAvgAggregate';
  code?: Maybe<Scalars['Float']>;
};

export type JascCategoryCount = {
  __typename?: 'JascCategoryCount';
  jascSystems: Scalars['Int'];
};

export type JascCategoryCountAggregate = {
  __typename?: 'JascCategoryCountAggregate';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
};

export type JascCategoryCreateNestedOneWithoutJascSystemsInput = {
  connect?: InputMaybe<JascCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<JascCategoryCreateOrConnectWithoutJascSystemsInput>;
  create?: InputMaybe<JascCategoryCreateWithoutJascSystemsInput>;
};

export type JascCategoryCreateOrConnectWithoutJascSystemsInput = {
  create: JascCategoryCreateWithoutJascSystemsInput;
  where: JascCategoryWhereUniqueInput;
};

export type JascCategoryCreateWithoutJascSystemsInput = {
  code: Scalars['Int'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type JascCategoryMaxAggregate = {
  __typename?: 'JascCategoryMaxAggregate';
  code?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type JascCategoryMinAggregate = {
  __typename?: 'JascCategoryMinAggregate';
  code?: Maybe<Scalars['Int']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type JascCategoryNullableScalarRelationFilter = {
  is?: InputMaybe<JascCategoryWhereInput>;
  isNot?: InputMaybe<JascCategoryWhereInput>;
};

export type JascCategorySumAggregate = {
  __typename?: 'JascCategorySumAggregate';
  code?: Maybe<Scalars['Int']>;
};

export type JascCategoryUpdateOneWithoutJascSystemsNestedInput = {
  connect?: InputMaybe<JascCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<JascCategoryCreateOrConnectWithoutJascSystemsInput>;
  create?: InputMaybe<JascCategoryCreateWithoutJascSystemsInput>;
  delete?: InputMaybe<JascCategoryWhereInput>;
  disconnect?: InputMaybe<JascCategoryWhereInput>;
  update?: InputMaybe<JascCategoryUpdateToOneWithWhereWithoutJascSystemsInput>;
  upsert?: InputMaybe<JascCategoryUpsertWithoutJascSystemsInput>;
};

export type JascCategoryUpdateToOneWithWhereWithoutJascSystemsInput = {
  data: JascCategoryUpdateWithoutJascSystemsInput;
  where?: InputMaybe<JascCategoryWhereInput>;
};

export type JascCategoryUpdateWithoutJascSystemsInput = {
  code?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type JascCategoryUpsertWithoutJascSystemsInput = {
  create: JascCategoryCreateWithoutJascSystemsInput;
  update: JascCategoryUpdateWithoutJascSystemsInput;
  where?: InputMaybe<JascCategoryWhereInput>;
};

export type JascCategoryWhereInput = {
  AND?: InputMaybe<Array<JascCategoryWhereInput>>;
  NOT?: InputMaybe<Array<JascCategoryWhereInput>>;
  OR?: InputMaybe<Array<JascCategoryWhereInput>>;
  code?: InputMaybe<IntFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  jascSystems?: InputMaybe<JascSystemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
};

export type JascCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<JascCategoryWhereInput>>;
  NOT?: InputMaybe<Array<JascCategoryWhereInput>>;
  OR?: InputMaybe<Array<JascCategoryWhereInput>>;
  code?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  jascSystems?: InputMaybe<JascSystemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
};

export type JascSystem = {
  __typename?: 'JascSystem';
  _count: JascSystemCount;
  code: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  jascCategory?: Maybe<JascCategory>;
  jascCategoryId?: Maybe<Scalars['String']>;
  logEntry?: Maybe<Array<LogEntry>>;
  name: Scalars['String'];
  squawks?: Maybe<Array<Squawk>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type JascSystemAvgAggregate = {
  __typename?: 'JascSystemAvgAggregate';
  code?: Maybe<Scalars['Float']>;
};

export type JascSystemCount = {
  __typename?: 'JascSystemCount';
  logEntry: Scalars['Int'];
  squawks: Scalars['Int'];
};

export type JascSystemCountAggregate = {
  __typename?: 'JascSystemCountAggregate';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  jascCategoryId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type JascSystemCreateManyJascCategoryInput = {
  code: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemCreateManyJascCategoryInputEnvelope = {
  data: Array<JascSystemCreateManyJascCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type JascSystemCreateNestedManyWithoutJascCategoryInput = {
  connect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JascSystemCreateOrConnectWithoutJascCategoryInput>>;
  create?: InputMaybe<Array<JascSystemCreateWithoutJascCategoryInput>>;
  createMany?: InputMaybe<JascSystemCreateManyJascCategoryInputEnvelope>;
};

export type JascSystemCreateNestedManyWithoutLogEntryInput = {
  connect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JascSystemCreateOrConnectWithoutLogEntryInput>>;
  create?: InputMaybe<Array<JascSystemCreateWithoutLogEntryInput>>;
};

export type JascSystemCreateNestedManyWithoutSquawksInput = {
  connect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JascSystemCreateOrConnectWithoutSquawksInput>>;
  create?: InputMaybe<Array<JascSystemCreateWithoutSquawksInput>>;
};

export type JascSystemCreateOrConnectWithoutJascCategoryInput = {
  create: JascSystemCreateWithoutJascCategoryInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemCreateOrConnectWithoutLogEntryInput = {
  create: JascSystemCreateWithoutLogEntryInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemCreateOrConnectWithoutSquawksInput = {
  create: JascSystemCreateWithoutSquawksInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemCreateWithoutJascCategoryInput = {
  code: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryCreateNestedManyWithoutSystemsAffectedInput>;
  name: Scalars['String'];
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutSystemsAffectedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemCreateWithoutLogEntryInput = {
  code: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  jascCategory?: InputMaybe<JascCategoryCreateNestedOneWithoutJascSystemsInput>;
  name: Scalars['String'];
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutSystemsAffectedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemCreateWithoutSquawksInput = {
  code: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  jascCategory?: InputMaybe<JascCategoryCreateNestedOneWithoutJascSystemsInput>;
  logEntry?: InputMaybe<LogEntryCreateNestedManyWithoutSystemsAffectedInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemListRelationFilter = {
  every?: InputMaybe<JascSystemWhereInput>;
  none?: InputMaybe<JascSystemWhereInput>;
  some?: InputMaybe<JascSystemWhereInput>;
};

export type JascSystemMaxAggregate = {
  __typename?: 'JascSystemMaxAggregate';
  code?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  jascCategoryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type JascSystemMinAggregate = {
  __typename?: 'JascSystemMinAggregate';
  code?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  jascCategoryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type JascSystemScalarWhereInput = {
  AND?: InputMaybe<Array<JascSystemScalarWhereInput>>;
  NOT?: InputMaybe<Array<JascSystemScalarWhereInput>>;
  OR?: InputMaybe<Array<JascSystemScalarWhereInput>>;
  code?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  jascCategoryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type JascSystemSumAggregate = {
  __typename?: 'JascSystemSumAggregate';
  code?: Maybe<Scalars['Int']>;
};

export type JascSystemUpdateManyMutationInput = {
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemUpdateManyWithWhereWithoutJascCategoryInput = {
  data: JascSystemUpdateManyMutationInput;
  where: JascSystemScalarWhereInput;
};

export type JascSystemUpdateManyWithWhereWithoutLogEntryInput = {
  data: JascSystemUpdateManyMutationInput;
  where: JascSystemScalarWhereInput;
};

export type JascSystemUpdateManyWithWhereWithoutSquawksInput = {
  data: JascSystemUpdateManyMutationInput;
  where: JascSystemScalarWhereInput;
};

export type JascSystemUpdateManyWithoutJascCategoryNestedInput = {
  connect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JascSystemCreateOrConnectWithoutJascCategoryInput>>;
  create?: InputMaybe<Array<JascSystemCreateWithoutJascCategoryInput>>;
  createMany?: InputMaybe<JascSystemCreateManyJascCategoryInputEnvelope>;
  delete?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<JascSystemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  set?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  update?: InputMaybe<Array<JascSystemUpdateWithWhereUniqueWithoutJascCategoryInput>>;
  updateMany?: InputMaybe<Array<JascSystemUpdateManyWithWhereWithoutJascCategoryInput>>;
  upsert?: InputMaybe<Array<JascSystemUpsertWithWhereUniqueWithoutJascCategoryInput>>;
};

export type JascSystemUpdateManyWithoutLogEntryNestedInput = {
  connect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JascSystemCreateOrConnectWithoutLogEntryInput>>;
  create?: InputMaybe<Array<JascSystemCreateWithoutLogEntryInput>>;
  delete?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<JascSystemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  set?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  update?: InputMaybe<Array<JascSystemUpdateWithWhereUniqueWithoutLogEntryInput>>;
  updateMany?: InputMaybe<Array<JascSystemUpdateManyWithWhereWithoutLogEntryInput>>;
  upsert?: InputMaybe<Array<JascSystemUpsertWithWhereUniqueWithoutLogEntryInput>>;
};

export type JascSystemUpdateManyWithoutSquawksNestedInput = {
  connect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JascSystemCreateOrConnectWithoutSquawksInput>>;
  create?: InputMaybe<Array<JascSystemCreateWithoutSquawksInput>>;
  delete?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<JascSystemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  set?: InputMaybe<Array<JascSystemWhereUniqueInput>>;
  update?: InputMaybe<Array<JascSystemUpdateWithWhereUniqueWithoutSquawksInput>>;
  updateMany?: InputMaybe<Array<JascSystemUpdateManyWithWhereWithoutSquawksInput>>;
  upsert?: InputMaybe<Array<JascSystemUpsertWithWhereUniqueWithoutSquawksInput>>;
};

export type JascSystemUpdateWithWhereUniqueWithoutJascCategoryInput = {
  data: JascSystemUpdateWithoutJascCategoryInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemUpdateWithWhereUniqueWithoutLogEntryInput = {
  data: JascSystemUpdateWithoutLogEntryInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemUpdateWithWhereUniqueWithoutSquawksInput = {
  data: JascSystemUpdateWithoutSquawksInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemUpdateWithoutJascCategoryInput = {
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  logEntry?: InputMaybe<LogEntryUpdateManyWithoutSystemsAffectedNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutSystemsAffectedNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemUpdateWithoutLogEntryInput = {
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  jascCategory?: InputMaybe<JascCategoryUpdateOneWithoutJascSystemsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutSystemsAffectedNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemUpdateWithoutSquawksInput = {
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  jascCategory?: InputMaybe<JascCategoryUpdateOneWithoutJascSystemsNestedInput>;
  logEntry?: InputMaybe<LogEntryUpdateManyWithoutSystemsAffectedNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type JascSystemUpsertWithWhereUniqueWithoutJascCategoryInput = {
  create: JascSystemCreateWithoutJascCategoryInput;
  update: JascSystemUpdateWithoutJascCategoryInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemUpsertWithWhereUniqueWithoutLogEntryInput = {
  create: JascSystemCreateWithoutLogEntryInput;
  update: JascSystemUpdateWithoutLogEntryInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemUpsertWithWhereUniqueWithoutSquawksInput = {
  create: JascSystemCreateWithoutSquawksInput;
  update: JascSystemUpdateWithoutSquawksInput;
  where: JascSystemWhereUniqueInput;
};

export type JascSystemWhereInput = {
  AND?: InputMaybe<Array<JascSystemWhereInput>>;
  NOT?: InputMaybe<Array<JascSystemWhereInput>>;
  OR?: InputMaybe<Array<JascSystemWhereInput>>;
  code?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  jascCategory?: InputMaybe<JascCategoryNullableScalarRelationFilter>;
  jascCategoryId?: InputMaybe<StringNullableFilter>;
  logEntry?: InputMaybe<LogEntryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type JascSystemWhereUniqueInput = {
  AND?: InputMaybe<Array<JascSystemWhereInput>>;
  NOT?: InputMaybe<Array<JascSystemWhereInput>>;
  OR?: InputMaybe<Array<JascSystemWhereInput>>;
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  jascCategory?: InputMaybe<JascCategoryNullableScalarRelationFilter>;
  jascCategoryId?: InputMaybe<StringNullableFilter>;
  logEntry?: InputMaybe<LogEntryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type LastAirport = {
  __typename?: 'LastAirport';
  icao?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type LogBook = {
  __typename?: 'LogBook';
  _count: LogBookCount;
  components?: Maybe<Array<Component>>;
  craft: Craft;
  craftId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inspections?: Maybe<Array<Inspection>>;
  intervals?: Maybe<Array<Interval>>;
  lastEntry?: Maybe<LogEntry>;
  legacyId?: Maybe<Scalars['String']>;
  logEntries?: Maybe<Array<LogEntry>>;
  name: Scalars['String'];
  serialNumber?: Maybe<Scalars['String']>;
  totalEntries?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LogBookCount = {
  __typename?: 'LogBookCount';
  components: Scalars['Int'];
  inspections: Scalars['Int'];
  intervals: Scalars['Int'];
  logEntries: Scalars['Int'];
};

export type LogBookCountAggregate = {
  __typename?: 'LogBookCountAggregate';
  _all: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  serialNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LogBookCreateInput = {
  components?: InputMaybe<ComponentCreateNestedManyWithoutLogBookInput>;
  craft: CraftCreateNestedOneWithoutLogBooksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutLogBooksInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutLogBooksInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutLogBookInput>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookCreateManyCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookCreateManyCraftInputEnvelope = {
  data: Array<LogBookCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LogBookCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogBookCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<LogBookCreateWithoutCraftInput>>;
  createMany?: InputMaybe<LogBookCreateManyCraftInputEnvelope>;
};

export type LogBookCreateNestedManyWithoutInspectionsInput = {
  connect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogBookCreateOrConnectWithoutInspectionsInput>>;
  create?: InputMaybe<Array<LogBookCreateWithoutInspectionsInput>>;
};

export type LogBookCreateNestedManyWithoutIntervalsInput = {
  connect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogBookCreateOrConnectWithoutIntervalsInput>>;
  create?: InputMaybe<Array<LogBookCreateWithoutIntervalsInput>>;
};

export type LogBookCreateNestedOneWithoutComponentsInput = {
  connect?: InputMaybe<LogBookWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LogBookCreateOrConnectWithoutComponentsInput>;
  create?: InputMaybe<LogBookCreateWithoutComponentsInput>;
};

export type LogBookCreateNestedOneWithoutLogEntriesInput = {
  connect?: InputMaybe<LogBookWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LogBookCreateOrConnectWithoutLogEntriesInput>;
  create?: InputMaybe<LogBookCreateWithoutLogEntriesInput>;
};

export type LogBookCreateOrConnectWithoutComponentsInput = {
  create: LogBookCreateWithoutComponentsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookCreateOrConnectWithoutCraftInput = {
  create: LogBookCreateWithoutCraftInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookCreateOrConnectWithoutInspectionsInput = {
  create: LogBookCreateWithoutInspectionsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookCreateOrConnectWithoutIntervalsInput = {
  create: LogBookCreateWithoutIntervalsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookCreateOrConnectWithoutLogEntriesInput = {
  create: LogBookCreateWithoutLogEntriesInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookCreateWithoutComponentsInput = {
  craft: CraftCreateNestedOneWithoutLogBooksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutLogBooksInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutLogBooksInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutLogBookInput>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookCreateWithoutCraftInput = {
  components?: InputMaybe<ComponentCreateNestedManyWithoutLogBookInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutLogBooksInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutLogBooksInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutLogBookInput>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookCreateWithoutInspectionsInput = {
  components?: InputMaybe<ComponentCreateNestedManyWithoutLogBookInput>;
  craft: CraftCreateNestedOneWithoutLogBooksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutLogBooksInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutLogBookInput>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookCreateWithoutIntervalsInput = {
  components?: InputMaybe<ComponentCreateNestedManyWithoutLogBookInput>;
  craft: CraftCreateNestedOneWithoutLogBooksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutLogBooksInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutLogBookInput>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookCreateWithoutLogEntriesInput = {
  components?: InputMaybe<ComponentCreateNestedManyWithoutLogBookInput>;
  craft: CraftCreateNestedOneWithoutLogBooksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutLogBooksInput>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutLogBooksInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookListRelationFilter = {
  every?: InputMaybe<LogBookWhereInput>;
  none?: InputMaybe<LogBookWhereInput>;
  some?: InputMaybe<LogBookWhereInput>;
};

export type LogBookMaxAggregate = {
  __typename?: 'LogBookMaxAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LogBookMinAggregate = {
  __typename?: 'LogBookMinAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LogBookNullableScalarRelationFilter = {
  is?: InputMaybe<LogBookWhereInput>;
  isNot?: InputMaybe<LogBookWhereInput>;
};

export type LogBookOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LogBookScalarWhereInput = {
  AND?: InputMaybe<Array<LogBookScalarWhereInput>>;
  NOT?: InputMaybe<Array<LogBookScalarWhereInput>>;
  OR?: InputMaybe<Array<LogBookScalarWhereInput>>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LogBookUpdateInput = {
  components?: InputMaybe<ComponentUpdateManyWithoutLogBookNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutLogBooksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutLogBooksNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutLogBooksNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutLogBookNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpdateManyWithWhereWithoutCraftInput = {
  data: LogBookUpdateManyMutationInput;
  where: LogBookScalarWhereInput;
};

export type LogBookUpdateManyWithWhereWithoutInspectionsInput = {
  data: LogBookUpdateManyMutationInput;
  where: LogBookScalarWhereInput;
};

export type LogBookUpdateManyWithWhereWithoutIntervalsInput = {
  data: LogBookUpdateManyMutationInput;
  where: LogBookScalarWhereInput;
};

export type LogBookUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogBookCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<LogBookCreateWithoutCraftInput>>;
  createMany?: InputMaybe<LogBookCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogBookScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  set?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  update?: InputMaybe<Array<LogBookUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<LogBookUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<LogBookUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type LogBookUpdateManyWithoutInspectionsNestedInput = {
  connect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogBookCreateOrConnectWithoutInspectionsInput>>;
  create?: InputMaybe<Array<LogBookCreateWithoutInspectionsInput>>;
  delete?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogBookScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  set?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  update?: InputMaybe<Array<LogBookUpdateWithWhereUniqueWithoutInspectionsInput>>;
  updateMany?: InputMaybe<Array<LogBookUpdateManyWithWhereWithoutInspectionsInput>>;
  upsert?: InputMaybe<Array<LogBookUpsertWithWhereUniqueWithoutInspectionsInput>>;
};

export type LogBookUpdateManyWithoutIntervalsNestedInput = {
  connect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogBookCreateOrConnectWithoutIntervalsInput>>;
  create?: InputMaybe<Array<LogBookCreateWithoutIntervalsInput>>;
  delete?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogBookScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  set?: InputMaybe<Array<LogBookWhereUniqueInput>>;
  update?: InputMaybe<Array<LogBookUpdateWithWhereUniqueWithoutIntervalsInput>>;
  updateMany?: InputMaybe<Array<LogBookUpdateManyWithWhereWithoutIntervalsInput>>;
  upsert?: InputMaybe<Array<LogBookUpsertWithWhereUniqueWithoutIntervalsInput>>;
};

export type LogBookUpdateOneWithoutComponentsNestedInput = {
  connect?: InputMaybe<LogBookWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LogBookCreateOrConnectWithoutComponentsInput>;
  create?: InputMaybe<LogBookCreateWithoutComponentsInput>;
  delete?: InputMaybe<LogBookWhereInput>;
  disconnect?: InputMaybe<LogBookWhereInput>;
  update?: InputMaybe<LogBookUpdateToOneWithWhereWithoutComponentsInput>;
  upsert?: InputMaybe<LogBookUpsertWithoutComponentsInput>;
};

export type LogBookUpdateOneWithoutLogEntriesNestedInput = {
  connect?: InputMaybe<LogBookWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LogBookCreateOrConnectWithoutLogEntriesInput>;
  create?: InputMaybe<LogBookCreateWithoutLogEntriesInput>;
  delete?: InputMaybe<LogBookWhereInput>;
  disconnect?: InputMaybe<LogBookWhereInput>;
  update?: InputMaybe<LogBookUpdateToOneWithWhereWithoutLogEntriesInput>;
  upsert?: InputMaybe<LogBookUpsertWithoutLogEntriesInput>;
};

export type LogBookUpdateToOneWithWhereWithoutComponentsInput = {
  data: LogBookUpdateWithoutComponentsInput;
  where?: InputMaybe<LogBookWhereInput>;
};

export type LogBookUpdateToOneWithWhereWithoutLogEntriesInput = {
  data: LogBookUpdateWithoutLogEntriesInput;
  where?: InputMaybe<LogBookWhereInput>;
};

export type LogBookUpdateWithWhereUniqueWithoutCraftInput = {
  data: LogBookUpdateWithoutCraftInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookUpdateWithWhereUniqueWithoutInspectionsInput = {
  data: LogBookUpdateWithoutInspectionsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookUpdateWithWhereUniqueWithoutIntervalsInput = {
  data: LogBookUpdateWithoutIntervalsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookUpdateWithoutComponentsInput = {
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutLogBooksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutLogBooksNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutLogBooksNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutLogBookNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpdateWithoutCraftInput = {
  components?: InputMaybe<ComponentUpdateManyWithoutLogBookNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutLogBooksNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutLogBooksNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutLogBookNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpdateWithoutInspectionsInput = {
  components?: InputMaybe<ComponentUpdateManyWithoutLogBookNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutLogBooksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutLogBooksNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutLogBookNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpdateWithoutIntervalsInput = {
  components?: InputMaybe<ComponentUpdateManyWithoutLogBookNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutLogBooksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutLogBooksNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutLogBookNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpdateWithoutLogEntriesInput = {
  components?: InputMaybe<ComponentUpdateManyWithoutLogBookNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutLogBooksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutLogBooksNestedInput>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutLogBooksNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogBookUpsertWithWhereUniqueWithoutCraftInput = {
  create: LogBookCreateWithoutCraftInput;
  update: LogBookUpdateWithoutCraftInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookUpsertWithWhereUniqueWithoutInspectionsInput = {
  create: LogBookCreateWithoutInspectionsInput;
  update: LogBookUpdateWithoutInspectionsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookUpsertWithWhereUniqueWithoutIntervalsInput = {
  create: LogBookCreateWithoutIntervalsInput;
  update: LogBookUpdateWithoutIntervalsInput;
  where: LogBookWhereUniqueInput;
};

export type LogBookUpsertWithoutComponentsInput = {
  create: LogBookCreateWithoutComponentsInput;
  update: LogBookUpdateWithoutComponentsInput;
  where?: InputMaybe<LogBookWhereInput>;
};

export type LogBookUpsertWithoutLogEntriesInput = {
  create: LogBookCreateWithoutLogEntriesInput;
  update: LogBookUpdateWithoutLogEntriesInput;
  where?: InputMaybe<LogBookWhereInput>;
};

export type LogBookWhereInput = {
  AND?: InputMaybe<Array<LogBookWhereInput>>;
  NOT?: InputMaybe<Array<LogBookWhereInput>>;
  OR?: InputMaybe<Array<LogBookWhereInput>>;
  components?: InputMaybe<ComponentListRelationFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LogBookWhereUniqueInput = {
  AND?: InputMaybe<Array<LogBookWhereInput>>;
  NOT?: InputMaybe<Array<LogBookWhereInput>>;
  OR?: InputMaybe<Array<LogBookWhereInput>>;
  components?: InputMaybe<ComponentListRelationFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  _count: LogEntryCount;
  attachments?: Maybe<Array<Attachment>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  didGetPrinted?: Maybe<Scalars['Boolean']>;
  digitalSignature?: Maybe<DigitalSignature>;
  digitalSignatureId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intervalValues?: Maybe<Scalars['JSON']>;
  legacyId?: Maybe<Scalars['String']>;
  licenseInfo?: Maybe<Scalars['JSON']>;
  logBook?: Maybe<LogBook>;
  logBookId?: Maybe<Scalars['String']>;
  logDate?: Maybe<Scalars['DateTime']>;
  logEntryRecords?: Maybe<Array<LogEntryRecord>>;
  maintenanceRecords: Array<MaintenanceRecord>;
  position?: Maybe<Scalars['Int']>;
  printedAt?: Maybe<Scalars['DateTime']>;
  signOffInfo: Scalars['String'];
  signedOffAt?: Maybe<Scalars['DateTime']>;
  signedOffBy?: Maybe<Scalars['String']>;
  signedUser?: Maybe<User>;
  signedUserId?: Maybe<Scalars['String']>;
  systemsAffected: Array<JascSystem>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfile?: Maybe<UserOrganizationProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type LogEntryAvgAggregate = {
  __typename?: 'LogEntryAvgAggregate';
  position?: Maybe<Scalars['Float']>;
};

export type LogEntryCount = {
  __typename?: 'LogEntryCount';
  attachments: Scalars['Int'];
  logEntryRecords: Scalars['Int'];
  maintenanceRecords: Scalars['Int'];
  systemsAffected: Scalars['Int'];
};

export type LogEntryCountAggregate = {
  __typename?: 'LogEntryCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  didGetPrinted: Scalars['Int'];
  digitalSignatureId: Scalars['Int'];
  id: Scalars['Int'];
  intervalValues: Scalars['Int'];
  legacyId: Scalars['Int'];
  licenseInfo: Scalars['Int'];
  logBookId: Scalars['Int'];
  logDate: Scalars['Int'];
  position: Scalars['Int'];
  printedAt: Scalars['Int'];
  signedOffAt: Scalars['Int'];
  signedOffBy: Scalars['Int'];
  signedUserId: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userProfileId: Scalars['Int'];
};

export type LogEntryCreateInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateManyDigitalSignatureInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBookId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUserId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type LogEntryCreateManyDigitalSignatureInputEnvelope = {
  data: Array<LogEntryCreateManyDigitalSignatureInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LogEntryCreateManyLogBookInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignatureId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUserId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type LogEntryCreateManyLogBookInputEnvelope = {
  data: Array<LogEntryCreateManyLogBookInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LogEntryCreateManySignedUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignatureId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBookId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type LogEntryCreateManySignedUserInputEnvelope = {
  data: Array<LogEntryCreateManySignedUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LogEntryCreateManyUserProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignatureId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBookId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUserId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryCreateManyUserProfileInputEnvelope = {
  data: Array<LogEntryCreateManyUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LogEntryCreateNestedManyWithoutDigitalSignatureInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutDigitalSignatureInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutDigitalSignatureInput>>;
  createMany?: InputMaybe<LogEntryCreateManyDigitalSignatureInputEnvelope>;
};

export type LogEntryCreateNestedManyWithoutLogBookInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutLogBookInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutLogBookInput>>;
  createMany?: InputMaybe<LogEntryCreateManyLogBookInputEnvelope>;
};

export type LogEntryCreateNestedManyWithoutMaintenanceRecordsInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutMaintenanceRecordsInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutMaintenanceRecordsInput>>;
};

export type LogEntryCreateNestedManyWithoutSignedUserInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutSignedUserInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutSignedUserInput>>;
  createMany?: InputMaybe<LogEntryCreateManySignedUserInputEnvelope>;
};

export type LogEntryCreateNestedManyWithoutSystemsAffectedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutSystemsAffectedInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutSystemsAffectedInput>>;
};

export type LogEntryCreateNestedManyWithoutUserProfileInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<LogEntryCreateManyUserProfileInputEnvelope>;
};

export type LogEntryCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<LogEntryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LogEntryCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<LogEntryCreateWithoutAttachmentsInput>;
};

export type LogEntryCreateOrConnectWithoutAttachmentsInput = {
  create: LogEntryCreateWithoutAttachmentsInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateOrConnectWithoutDigitalSignatureInput = {
  create: LogEntryCreateWithoutDigitalSignatureInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateOrConnectWithoutLogBookInput = {
  create: LogEntryCreateWithoutLogBookInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateOrConnectWithoutMaintenanceRecordsInput = {
  create: LogEntryCreateWithoutMaintenanceRecordsInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateOrConnectWithoutSignedUserInput = {
  create: LogEntryCreateWithoutSignedUserInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateOrConnectWithoutSystemsAffectedInput = {
  create: LogEntryCreateWithoutSystemsAffectedInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateOrConnectWithoutUserProfileInput = {
  create: LogEntryCreateWithoutUserProfileInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryCreateWithoutAttachmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateWithoutDigitalSignatureInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateWithoutLogBookInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateWithoutMaintenanceRecordsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateWithoutSignedUserInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateWithoutSystemsAffectedInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput>;
};

export type LogEntryCreateWithoutUserProfileInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutLogEntryInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureCreateNestedOneWithoutLogEntriesInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookCreateNestedOneWithoutLogEntriesInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordCreateNestedManyWithoutLogEntryInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutLogEntriesInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserCreateNestedOneWithoutLogEntriesSignedInput>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutLogEntryInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryListRelationFilter = {
  every?: InputMaybe<LogEntryWhereInput>;
  none?: InputMaybe<LogEntryWhereInput>;
  some?: InputMaybe<LogEntryWhereInput>;
};

export type LogEntryMaxAggregate = {
  __typename?: 'LogEntryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  didGetPrinted?: Maybe<Scalars['Boolean']>;
  digitalSignatureId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logBookId?: Maybe<Scalars['String']>;
  logDate?: Maybe<Scalars['DateTime']>;
  position?: Maybe<Scalars['Int']>;
  printedAt?: Maybe<Scalars['DateTime']>;
  signedOffAt?: Maybe<Scalars['DateTime']>;
  signedOffBy?: Maybe<Scalars['String']>;
  signedUserId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type LogEntryMinAggregate = {
  __typename?: 'LogEntryMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  didGetPrinted?: Maybe<Scalars['Boolean']>;
  digitalSignatureId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logBookId?: Maybe<Scalars['String']>;
  logDate?: Maybe<Scalars['DateTime']>;
  position?: Maybe<Scalars['Int']>;
  printedAt?: Maybe<Scalars['DateTime']>;
  signedOffAt?: Maybe<Scalars['DateTime']>;
  signedOffBy?: Maybe<Scalars['String']>;
  signedUserId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type LogEntryNullableScalarRelationFilter = {
  is?: InputMaybe<LogEntryWhereInput>;
  isNot?: InputMaybe<LogEntryWhereInput>;
};

export type LogEntryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LogEntryRecord = {
  __typename?: 'LogEntryRecord';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  didGetPrinted?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  intervalValues?: Maybe<Scalars['JSON']>;
  legacyId?: Maybe<Scalars['String']>;
  logDate?: Maybe<Scalars['DateTime']>;
  logEntry?: Maybe<LogEntry>;
  logEntryId?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  printedAt?: Maybe<Scalars['DateTime']>;
  signedOffAt?: Maybe<Scalars['DateTime']>;
  signedOffBy?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LogEntryRecordCreateManyLogEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryRecordCreateManyLogEntryInputEnvelope = {
  data: Array<LogEntryRecordCreateManyLogEntryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LogEntryRecordCreateNestedManyWithoutLogEntryInput = {
  connect?: InputMaybe<Array<LogEntryRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryRecordCreateOrConnectWithoutLogEntryInput>>;
  create?: InputMaybe<Array<LogEntryRecordCreateWithoutLogEntryInput>>;
  createMany?: InputMaybe<LogEntryRecordCreateManyLogEntryInputEnvelope>;
};

export type LogEntryRecordCreateOrConnectWithoutLogEntryInput = {
  create: LogEntryRecordCreateWithoutLogEntryInput;
  where: LogEntryRecordWhereUniqueInput;
};

export type LogEntryRecordCreateWithoutLogEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryRecordListRelationFilter = {
  every?: InputMaybe<LogEntryRecordWhereInput>;
  none?: InputMaybe<LogEntryRecordWhereInput>;
  some?: InputMaybe<LogEntryRecordWhereInput>;
};

export type LogEntryRecordScalarWhereInput = {
  AND?: InputMaybe<Array<LogEntryRecordScalarWhereInput>>;
  NOT?: InputMaybe<Array<LogEntryRecordScalarWhereInput>>;
  OR?: InputMaybe<Array<LogEntryRecordScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  didGetPrinted?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logDate?: InputMaybe<DateTimeNullableFilter>;
  logEntryId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  printedAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffBy?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LogEntryRecordUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryRecordUpdateManyWithWhereWithoutLogEntryInput = {
  data: LogEntryRecordUpdateManyMutationInput;
  where: LogEntryRecordScalarWhereInput;
};

export type LogEntryRecordUpdateManyWithoutLogEntryNestedInput = {
  connect?: InputMaybe<Array<LogEntryRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryRecordCreateOrConnectWithoutLogEntryInput>>;
  create?: InputMaybe<Array<LogEntryRecordCreateWithoutLogEntryInput>>;
  createMany?: InputMaybe<LogEntryRecordCreateManyLogEntryInputEnvelope>;
  delete?: InputMaybe<Array<LogEntryRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryRecordUpdateWithWhereUniqueWithoutLogEntryInput>>;
  updateMany?: InputMaybe<Array<LogEntryRecordUpdateManyWithWhereWithoutLogEntryInput>>;
  upsert?: InputMaybe<Array<LogEntryRecordUpsertWithWhereUniqueWithoutLogEntryInput>>;
};

export type LogEntryRecordUpdateWithWhereUniqueWithoutLogEntryInput = {
  data: LogEntryRecordUpdateWithoutLogEntryInput;
  where: LogEntryRecordWhereUniqueInput;
};

export type LogEntryRecordUpdateWithoutLogEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryRecordUpsertWithWhereUniqueWithoutLogEntryInput = {
  create: LogEntryRecordCreateWithoutLogEntryInput;
  update: LogEntryRecordUpdateWithoutLogEntryInput;
  where: LogEntryRecordWhereUniqueInput;
};

export type LogEntryRecordWhereInput = {
  AND?: InputMaybe<Array<LogEntryRecordWhereInput>>;
  NOT?: InputMaybe<Array<LogEntryRecordWhereInput>>;
  OR?: InputMaybe<Array<LogEntryRecordWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  didGetPrinted?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logDate?: InputMaybe<DateTimeNullableFilter>;
  logEntry?: InputMaybe<LogEntryNullableScalarRelationFilter>;
  logEntryId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  printedAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffBy?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LogEntryRecordWhereUniqueInput = {
  AND?: InputMaybe<Array<LogEntryRecordWhereInput>>;
  NOT?: InputMaybe<Array<LogEntryRecordWhereInput>>;
  OR?: InputMaybe<Array<LogEntryRecordWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  didGetPrinted?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logDate?: InputMaybe<DateTimeNullableFilter>;
  logEntry?: InputMaybe<LogEntryNullableScalarRelationFilter>;
  logEntryId?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  printedAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffBy?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type LogEntryScalarWhereInput = {
  AND?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  NOT?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  OR?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  didGetPrinted?: InputMaybe<BoolNullableFilter>;
  digitalSignatureId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  licenseInfo?: InputMaybe<JsonNullableFilter>;
  logBookId?: InputMaybe<StringNullableFilter>;
  logDate?: InputMaybe<DateTimeNullableFilter>;
  position?: InputMaybe<IntNullableFilter>;
  printedAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffBy?: InputMaybe<StringNullableFilter>;
  signedUserId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type LogEntrySumAggregate = {
  __typename?: 'LogEntrySumAggregate';
  position?: Maybe<Scalars['Int']>;
};

export type LogEntryUpdateInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryUpdateManyWithWhereWithoutDigitalSignatureInput = {
  data: LogEntryUpdateManyMutationInput;
  where: LogEntryScalarWhereInput;
};

export type LogEntryUpdateManyWithWhereWithoutLogBookInput = {
  data: LogEntryUpdateManyMutationInput;
  where: LogEntryScalarWhereInput;
};

export type LogEntryUpdateManyWithWhereWithoutMaintenanceRecordsInput = {
  data: LogEntryUpdateManyMutationInput;
  where: LogEntryScalarWhereInput;
};

export type LogEntryUpdateManyWithWhereWithoutSignedUserInput = {
  data: LogEntryUpdateManyMutationInput;
  where: LogEntryScalarWhereInput;
};

export type LogEntryUpdateManyWithWhereWithoutSystemsAffectedInput = {
  data: LogEntryUpdateManyMutationInput;
  where: LogEntryScalarWhereInput;
};

export type LogEntryUpdateManyWithWhereWithoutUserProfileInput = {
  data: LogEntryUpdateManyMutationInput;
  where: LogEntryScalarWhereInput;
};

export type LogEntryUpdateManyWithoutDigitalSignatureNestedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutDigitalSignatureInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutDigitalSignatureInput>>;
  createMany?: InputMaybe<LogEntryCreateManyDigitalSignatureInputEnvelope>;
  delete?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryUpdateWithWhereUniqueWithoutDigitalSignatureInput>>;
  updateMany?: InputMaybe<Array<LogEntryUpdateManyWithWhereWithoutDigitalSignatureInput>>;
  upsert?: InputMaybe<Array<LogEntryUpsertWithWhereUniqueWithoutDigitalSignatureInput>>;
};

export type LogEntryUpdateManyWithoutLogBookNestedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutLogBookInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutLogBookInput>>;
  createMany?: InputMaybe<LogEntryCreateManyLogBookInputEnvelope>;
  delete?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryUpdateWithWhereUniqueWithoutLogBookInput>>;
  updateMany?: InputMaybe<Array<LogEntryUpdateManyWithWhereWithoutLogBookInput>>;
  upsert?: InputMaybe<Array<LogEntryUpsertWithWhereUniqueWithoutLogBookInput>>;
};

export type LogEntryUpdateManyWithoutMaintenanceRecordsNestedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutMaintenanceRecordsInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutMaintenanceRecordsInput>>;
  delete?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryUpdateWithWhereUniqueWithoutMaintenanceRecordsInput>>;
  updateMany?: InputMaybe<Array<LogEntryUpdateManyWithWhereWithoutMaintenanceRecordsInput>>;
  upsert?: InputMaybe<Array<LogEntryUpsertWithWhereUniqueWithoutMaintenanceRecordsInput>>;
};

export type LogEntryUpdateManyWithoutSignedUserNestedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutSignedUserInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutSignedUserInput>>;
  createMany?: InputMaybe<LogEntryCreateManySignedUserInputEnvelope>;
  delete?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryUpdateWithWhereUniqueWithoutSignedUserInput>>;
  updateMany?: InputMaybe<Array<LogEntryUpdateManyWithWhereWithoutSignedUserInput>>;
  upsert?: InputMaybe<Array<LogEntryUpsertWithWhereUniqueWithoutSignedUserInput>>;
};

export type LogEntryUpdateManyWithoutSystemsAffectedNestedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutSystemsAffectedInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutSystemsAffectedInput>>;
  delete?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryUpdateWithWhereUniqueWithoutSystemsAffectedInput>>;
  updateMany?: InputMaybe<Array<LogEntryUpdateManyWithWhereWithoutSystemsAffectedInput>>;
  upsert?: InputMaybe<Array<LogEntryUpsertWithWhereUniqueWithoutSystemsAffectedInput>>;
};

export type LogEntryUpdateManyWithoutUserProfileNestedInput = {
  connect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LogEntryCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<LogEntryCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<LogEntryCreateManyUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<LogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<LogEntryUpdateWithWhereUniqueWithoutUserProfileInput>>;
  updateMany?: InputMaybe<Array<LogEntryUpdateManyWithWhereWithoutUserProfileInput>>;
  upsert?: InputMaybe<Array<LogEntryUpsertWithWhereUniqueWithoutUserProfileInput>>;
};

export type LogEntryUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<LogEntryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LogEntryCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<LogEntryCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<LogEntryWhereInput>;
  disconnect?: InputMaybe<LogEntryWhereInput>;
  update?: InputMaybe<LogEntryUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<LogEntryUpsertWithoutAttachmentsInput>;
};

export type LogEntryUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: LogEntryUpdateWithoutAttachmentsInput;
  where?: InputMaybe<LogEntryWhereInput>;
};

export type LogEntryUpdateWithWhereUniqueWithoutDigitalSignatureInput = {
  data: LogEntryUpdateWithoutDigitalSignatureInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpdateWithWhereUniqueWithoutLogBookInput = {
  data: LogEntryUpdateWithoutLogBookInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpdateWithWhereUniqueWithoutMaintenanceRecordsInput = {
  data: LogEntryUpdateWithoutMaintenanceRecordsInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpdateWithWhereUniqueWithoutSignedUserInput = {
  data: LogEntryUpdateWithoutSignedUserInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpdateWithWhereUniqueWithoutSystemsAffectedInput = {
  data: LogEntryUpdateWithoutSystemsAffectedInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpdateWithWhereUniqueWithoutUserProfileInput = {
  data: LogEntryUpdateWithoutUserProfileInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpdateWithoutAttachmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateWithoutDigitalSignatureInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateWithoutLogBookInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateWithoutMaintenanceRecordsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateWithoutSignedUserInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateWithoutSystemsAffectedInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput>;
};

export type LogEntryUpdateWithoutUserProfileInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutLogEntryNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  didGetPrinted?: InputMaybe<Scalars['Boolean']>;
  digitalSignature?: InputMaybe<DigitalSignatureUpdateOneWithoutLogEntriesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<Scalars['JSON']>;
  logBook?: InputMaybe<LogBookUpdateOneWithoutLogEntriesNestedInput>;
  logDate?: InputMaybe<Scalars['DateTime']>;
  logEntryRecords?: InputMaybe<LogEntryRecordUpdateManyWithoutLogEntryNestedInput>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput>;
  position?: InputMaybe<Scalars['Int']>;
  printedAt?: InputMaybe<Scalars['DateTime']>;
  signedOffAt?: InputMaybe<Scalars['DateTime']>;
  signedOffBy?: InputMaybe<Scalars['String']>;
  signedUser?: InputMaybe<UserUpdateOneWithoutLogEntriesSignedNestedInput>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutLogEntryNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LogEntryUpsertWithWhereUniqueWithoutDigitalSignatureInput = {
  create: LogEntryCreateWithoutDigitalSignatureInput;
  update: LogEntryUpdateWithoutDigitalSignatureInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpsertWithWhereUniqueWithoutLogBookInput = {
  create: LogEntryCreateWithoutLogBookInput;
  update: LogEntryUpdateWithoutLogBookInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpsertWithWhereUniqueWithoutMaintenanceRecordsInput = {
  create: LogEntryCreateWithoutMaintenanceRecordsInput;
  update: LogEntryUpdateWithoutMaintenanceRecordsInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpsertWithWhereUniqueWithoutSignedUserInput = {
  create: LogEntryCreateWithoutSignedUserInput;
  update: LogEntryUpdateWithoutSignedUserInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpsertWithWhereUniqueWithoutSystemsAffectedInput = {
  create: LogEntryCreateWithoutSystemsAffectedInput;
  update: LogEntryUpdateWithoutSystemsAffectedInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpsertWithWhereUniqueWithoutUserProfileInput = {
  create: LogEntryCreateWithoutUserProfileInput;
  update: LogEntryUpdateWithoutUserProfileInput;
  where: LogEntryWhereUniqueInput;
};

export type LogEntryUpsertWithoutAttachmentsInput = {
  create: LogEntryCreateWithoutAttachmentsInput;
  update: LogEntryUpdateWithoutAttachmentsInput;
  where?: InputMaybe<LogEntryWhereInput>;
};

export type LogEntryWhereInput = {
  AND?: InputMaybe<Array<LogEntryWhereInput>>;
  NOT?: InputMaybe<Array<LogEntryWhereInput>>;
  OR?: InputMaybe<Array<LogEntryWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  didGetPrinted?: InputMaybe<BoolNullableFilter>;
  digitalSignature?: InputMaybe<DigitalSignatureNullableScalarRelationFilter>;
  digitalSignatureId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  licenseInfo?: InputMaybe<JsonNullableFilter>;
  logBook?: InputMaybe<LogBookNullableScalarRelationFilter>;
  logBookId?: InputMaybe<StringNullableFilter>;
  logDate?: InputMaybe<DateTimeNullableFilter>;
  logEntryRecords?: InputMaybe<LogEntryRecordListRelationFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  position?: InputMaybe<IntNullableFilter>;
  printedAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffBy?: InputMaybe<StringNullableFilter>;
  signedUser?: InputMaybe<UserNullableScalarRelationFilter>;
  signedUserId?: InputMaybe<StringNullableFilter>;
  systemsAffected?: InputMaybe<JascSystemListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type LogEntryWhereUniqueInput = {
  AND?: InputMaybe<Array<LogEntryWhereInput>>;
  NOT?: InputMaybe<Array<LogEntryWhereInput>>;
  OR?: InputMaybe<Array<LogEntryWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  didGetPrinted?: InputMaybe<BoolNullableFilter>;
  digitalSignature?: InputMaybe<DigitalSignatureNullableScalarRelationFilter>;
  digitalSignatureId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  licenseInfo?: InputMaybe<JsonNullableFilter>;
  logBook?: InputMaybe<LogBookNullableScalarRelationFilter>;
  logBookId?: InputMaybe<StringNullableFilter>;
  logDate?: InputMaybe<DateTimeNullableFilter>;
  logEntryRecords?: InputMaybe<LogEntryRecordListRelationFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  position?: InputMaybe<IntNullableFilter>;
  printedAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffAt?: InputMaybe<DateTimeNullableFilter>;
  signedOffBy?: InputMaybe<StringNullableFilter>;
  signedUser?: InputMaybe<UserNullableScalarRelationFilter>;
  signedUserId?: InputMaybe<StringNullableFilter>;
  systemsAffected?: InputMaybe<JascSystemListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export enum LogType {
  Logboth = 'LOGBOTH',
  Loghobbs = 'LOGHOBBS',
  Logtach = 'LOGTACH'
}

export type LoginInput = {
  email?: InputMaybe<Scalars['String']>;
  impersonate?: InputMaybe<Scalars['Boolean']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type MaintenanceRecord = {
  __typename?: 'MaintenanceRecord';
  _count: MaintenanceRecordCount;
  completionDate?: Maybe<Scalars['DateTime']>;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inspections?: Maybe<Array<Inspection>>;
  intervalValues?: Maybe<Scalars['JSON']>;
  legacyId?: Maybe<Scalars['String']>;
  logEntries?: Maybe<Array<LogEntry>>;
  name: Scalars['String'];
  newestInspection?: Maybe<Inspection>;
  performedBy?: Maybe<UserOrganizationProfile>;
  performedById?: Maybe<Scalars['String']>;
  severityStatus?: Maybe<Scalars['JSON']>;
  squawks?: Maybe<Array<Squawk>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCount = {
  __typename?: 'MaintenanceRecordCount';
  inspections: Scalars['Int'];
  logEntries: Scalars['Int'];
  squawks: Scalars['Int'];
};

export type MaintenanceRecordCountAggregate = {
  __typename?: 'MaintenanceRecordCountAggregate';
  _all: Scalars['Int'];
  completionDate: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  intervalValues: Scalars['Int'];
  legacyId: Scalars['Int'];
  name: Scalars['Int'];
  performedById: Scalars['Int'];
  severityStatus: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MaintenanceRecordCreateInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMaintenanceRecordsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutMaintenanceRecordsInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutMaintenanceRecordsInput>;
  name: Scalars['String'];
  performedBy?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutMatienanceRecordsInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutMaintenanceRecordsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateManyCraftInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  performedById?: InputMaybe<Scalars['String']>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateManyCraftInputEnvelope = {
  data: Array<MaintenanceRecordCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MaintenanceRecordCreateManyPerformedByInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  severityStatus?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateManyPerformedByInputEnvelope = {
  data: Array<MaintenanceRecordCreateManyPerformedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MaintenanceRecordCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutCraftInput>>;
  createMany?: InputMaybe<MaintenanceRecordCreateManyCraftInputEnvelope>;
};

export type MaintenanceRecordCreateNestedManyWithoutInspectionsInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutInspectionsInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutInspectionsInput>>;
};

export type MaintenanceRecordCreateNestedManyWithoutLogEntriesInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutLogEntriesInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutLogEntriesInput>>;
};

export type MaintenanceRecordCreateNestedManyWithoutPerformedByInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutPerformedByInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutPerformedByInput>>;
  createMany?: InputMaybe<MaintenanceRecordCreateManyPerformedByInputEnvelope>;
};

export type MaintenanceRecordCreateNestedManyWithoutSquawksInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutSquawksInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutSquawksInput>>;
};

export type MaintenanceRecordCreateOrConnectWithoutCraftInput = {
  create: MaintenanceRecordCreateWithoutCraftInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordCreateOrConnectWithoutInspectionsInput = {
  create: MaintenanceRecordCreateWithoutInspectionsInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordCreateOrConnectWithoutLogEntriesInput = {
  create: MaintenanceRecordCreateWithoutLogEntriesInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordCreateOrConnectWithoutPerformedByInput = {
  create: MaintenanceRecordCreateWithoutPerformedByInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordCreateOrConnectWithoutSquawksInput = {
  create: MaintenanceRecordCreateWithoutSquawksInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordCreateWithoutCraftInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutMaintenanceRecordsInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutMaintenanceRecordsInput>;
  name: Scalars['String'];
  performedBy?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutMatienanceRecordsInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutMaintenanceRecordsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateWithoutInspectionsInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMaintenanceRecordsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutMaintenanceRecordsInput>;
  name: Scalars['String'];
  performedBy?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutMatienanceRecordsInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutMaintenanceRecordsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateWithoutLogEntriesInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMaintenanceRecordsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutMaintenanceRecordsInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  performedBy?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutMatienanceRecordsInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutMaintenanceRecordsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateWithoutPerformedByInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMaintenanceRecordsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutMaintenanceRecordsInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutMaintenanceRecordsInput>;
  name: Scalars['String'];
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutMaintenanceRecordsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordCreateWithoutSquawksInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMaintenanceRecordsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutMaintenanceRecordsInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutMaintenanceRecordsInput>;
  name: Scalars['String'];
  performedBy?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutMatienanceRecordsInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordListRelationFilter = {
  every?: InputMaybe<MaintenanceRecordWhereInput>;
  none?: InputMaybe<MaintenanceRecordWhereInput>;
  some?: InputMaybe<MaintenanceRecordWhereInput>;
};

export type MaintenanceRecordMaxAggregate = {
  __typename?: 'MaintenanceRecordMaxAggregate';
  completionDate?: Maybe<Scalars['DateTime']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  performedById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintenanceRecordMinAggregate = {
  __typename?: 'MaintenanceRecordMinAggregate';
  completionDate?: Maybe<Scalars['DateTime']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  performedById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MaintenanceRecordOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MaintenanceRecordScalarWhereInput = {
  AND?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  NOT?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  OR?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  completionDate?: InputMaybe<DateTimeNullableFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  performedById?: InputMaybe<StringNullableFilter>;
  severityStatus?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MaintenanceRecordUpdateInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftUpdateOneWithoutMaintenanceRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutMaintenanceRecordsNestedInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutMaintenanceRecordsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  performedBy?: InputMaybe<UserOrganizationProfileUpdateOneWithoutMatienanceRecordsNestedInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutMaintenanceRecordsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpdateManyMutationInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpdateManyWithWhereWithoutCraftInput = {
  data: MaintenanceRecordUpdateManyMutationInput;
  where: MaintenanceRecordScalarWhereInput;
};

export type MaintenanceRecordUpdateManyWithWhereWithoutInspectionsInput = {
  data: MaintenanceRecordUpdateManyMutationInput;
  where: MaintenanceRecordScalarWhereInput;
};

export type MaintenanceRecordUpdateManyWithWhereWithoutLogEntriesInput = {
  data: MaintenanceRecordUpdateManyMutationInput;
  where: MaintenanceRecordScalarWhereInput;
};

export type MaintenanceRecordUpdateManyWithWhereWithoutPerformedByInput = {
  data: MaintenanceRecordUpdateManyMutationInput;
  where: MaintenanceRecordScalarWhereInput;
};

export type MaintenanceRecordUpdateManyWithWhereWithoutSquawksInput = {
  data: MaintenanceRecordUpdateManyMutationInput;
  where: MaintenanceRecordScalarWhereInput;
};

export type MaintenanceRecordUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutCraftInput>>;
  createMany?: InputMaybe<MaintenanceRecordCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<MaintenanceRecordUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<MaintenanceRecordUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<MaintenanceRecordUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type MaintenanceRecordUpdateManyWithoutInspectionsNestedInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutInspectionsInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutInspectionsInput>>;
  delete?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<MaintenanceRecordUpdateWithWhereUniqueWithoutInspectionsInput>>;
  updateMany?: InputMaybe<Array<MaintenanceRecordUpdateManyWithWhereWithoutInspectionsInput>>;
  upsert?: InputMaybe<Array<MaintenanceRecordUpsertWithWhereUniqueWithoutInspectionsInput>>;
};

export type MaintenanceRecordUpdateManyWithoutLogEntriesNestedInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutLogEntriesInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutLogEntriesInput>>;
  delete?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<MaintenanceRecordUpdateWithWhereUniqueWithoutLogEntriesInput>>;
  updateMany?: InputMaybe<Array<MaintenanceRecordUpdateManyWithWhereWithoutLogEntriesInput>>;
  upsert?: InputMaybe<Array<MaintenanceRecordUpsertWithWhereUniqueWithoutLogEntriesInput>>;
};

export type MaintenanceRecordUpdateManyWithoutPerformedByNestedInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutPerformedByInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutPerformedByInput>>;
  createMany?: InputMaybe<MaintenanceRecordCreateManyPerformedByInputEnvelope>;
  delete?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<MaintenanceRecordUpdateWithWhereUniqueWithoutPerformedByInput>>;
  updateMany?: InputMaybe<Array<MaintenanceRecordUpdateManyWithWhereWithoutPerformedByInput>>;
  upsert?: InputMaybe<Array<MaintenanceRecordUpsertWithWhereUniqueWithoutPerformedByInput>>;
};

export type MaintenanceRecordUpdateManyWithoutSquawksNestedInput = {
  connect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MaintenanceRecordCreateOrConnectWithoutSquawksInput>>;
  create?: InputMaybe<Array<MaintenanceRecordCreateWithoutSquawksInput>>;
  delete?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MaintenanceRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<MaintenanceRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<MaintenanceRecordUpdateWithWhereUniqueWithoutSquawksInput>>;
  updateMany?: InputMaybe<Array<MaintenanceRecordUpdateManyWithWhereWithoutSquawksInput>>;
  upsert?: InputMaybe<Array<MaintenanceRecordUpsertWithWhereUniqueWithoutSquawksInput>>;
};

export type MaintenanceRecordUpdateWithWhereUniqueWithoutCraftInput = {
  data: MaintenanceRecordUpdateWithoutCraftInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpdateWithWhereUniqueWithoutInspectionsInput = {
  data: MaintenanceRecordUpdateWithoutInspectionsInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpdateWithWhereUniqueWithoutLogEntriesInput = {
  data: MaintenanceRecordUpdateWithoutLogEntriesInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpdateWithWhereUniqueWithoutPerformedByInput = {
  data: MaintenanceRecordUpdateWithoutPerformedByInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpdateWithWhereUniqueWithoutSquawksInput = {
  data: MaintenanceRecordUpdateWithoutSquawksInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpdateWithoutCraftInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutMaintenanceRecordsNestedInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutMaintenanceRecordsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  performedBy?: InputMaybe<UserOrganizationProfileUpdateOneWithoutMatienanceRecordsNestedInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutMaintenanceRecordsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpdateWithoutInspectionsInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftUpdateOneWithoutMaintenanceRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutMaintenanceRecordsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  performedBy?: InputMaybe<UserOrganizationProfileUpdateOneWithoutMatienanceRecordsNestedInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutMaintenanceRecordsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpdateWithoutLogEntriesInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftUpdateOneWithoutMaintenanceRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutMaintenanceRecordsNestedInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  performedBy?: InputMaybe<UserOrganizationProfileUpdateOneWithoutMatienanceRecordsNestedInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutMaintenanceRecordsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpdateWithoutPerformedByInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftUpdateOneWithoutMaintenanceRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutMaintenanceRecordsNestedInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutMaintenanceRecordsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutMaintenanceRecordsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpdateWithoutSquawksInput = {
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craft?: InputMaybe<CraftUpdateOneWithoutMaintenanceRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutMaintenanceRecordsNestedInput>;
  intervalValues?: InputMaybe<Scalars['JSON']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutMaintenanceRecordsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  performedBy?: InputMaybe<UserOrganizationProfileUpdateOneWithoutMatienanceRecordsNestedInput>;
  severityStatus?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MaintenanceRecordUpsertWithWhereUniqueWithoutCraftInput = {
  create: MaintenanceRecordCreateWithoutCraftInput;
  update: MaintenanceRecordUpdateWithoutCraftInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpsertWithWhereUniqueWithoutInspectionsInput = {
  create: MaintenanceRecordCreateWithoutInspectionsInput;
  update: MaintenanceRecordUpdateWithoutInspectionsInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpsertWithWhereUniqueWithoutLogEntriesInput = {
  create: MaintenanceRecordCreateWithoutLogEntriesInput;
  update: MaintenanceRecordUpdateWithoutLogEntriesInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpsertWithWhereUniqueWithoutPerformedByInput = {
  create: MaintenanceRecordCreateWithoutPerformedByInput;
  update: MaintenanceRecordUpdateWithoutPerformedByInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordUpsertWithWhereUniqueWithoutSquawksInput = {
  create: MaintenanceRecordCreateWithoutSquawksInput;
  update: MaintenanceRecordUpdateWithoutSquawksInput;
  where: MaintenanceRecordWhereUniqueInput;
};

export type MaintenanceRecordWhereInput = {
  AND?: InputMaybe<Array<MaintenanceRecordWhereInput>>;
  NOT?: InputMaybe<Array<MaintenanceRecordWhereInput>>;
  OR?: InputMaybe<Array<MaintenanceRecordWhereInput>>;
  completionDate?: InputMaybe<DateTimeNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  performedBy?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  performedById?: InputMaybe<StringNullableFilter>;
  severityStatus?: InputMaybe<JsonNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MaintenanceRecordWhereUniqueInput = {
  AND?: InputMaybe<Array<MaintenanceRecordWhereInput>>;
  NOT?: InputMaybe<Array<MaintenanceRecordWhereInput>>;
  OR?: InputMaybe<Array<MaintenanceRecordWhereInput>>;
  completionDate?: InputMaybe<DateTimeNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inspections?: InputMaybe<InspectionListRelationFilter>;
  intervalValues?: InputMaybe<JsonNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  performedBy?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  performedById?: InputMaybe<StringNullableFilter>;
  severityStatus?: InputMaybe<JsonNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MigrateInfo = {
  __typename?: 'MigrateInfo';
  email?: Maybe<Scalars['String']>;
  isSetup?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type MroAddress = {
  __typename?: 'MroAddress';
  _count: MroAddressCount;
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  billingCustomers?: Maybe<Array<MroCustomer>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mroContacts?: Maybe<Array<MroContact>>;
  mroCrafts?: Maybe<Array<MroCraft>>;
  mroCustomers?: Maybe<Array<MroCustomer>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationAddress?: Maybe<Array<MroOrganization>>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartVendor?: Maybe<Array<MroPartVendor>>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  shippingCustomers?: Maybe<Array<MroCustomer>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroAddressVersion>>;
};

export type MroAddressCount = {
  __typename?: 'MroAddressCount';
  billingCustomers: Scalars['Int'];
  mroContacts: Scalars['Int'];
  mroCrafts: Scalars['Int'];
  mroCustomers: Scalars['Int'];
  mroOrganizationAddress: Scalars['Int'];
  mroPartVendor: Scalars['Int'];
  shippingCustomers: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroAddressCountAggregate = {
  __typename?: 'MroAddressCountAggregate';
  _all: Scalars['Int'];
  address: Scalars['Int'];
  address2: Scalars['Int'];
  city: Scalars['Int'];
  country: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  fax: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  phone: Scalars['Int'];
  postalCode: Scalars['Int'];
  region: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroAddressCreateManyMroOrganizationInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroAddressCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroAddressCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroAddressCreateNestedManyWithoutMroCustomersInput = {
  connect?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroAddressCreateOrConnectWithoutMroCustomersInput>>;
  create?: InputMaybe<Array<MroAddressCreateWithoutMroCustomersInput>>;
};

export type MroAddressCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroAddressCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroAddressCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroAddressCreateManyMroOrganizationInputEnvelope>;
};

export type MroAddressCreateNestedOneWithoutBillingCustomersInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutBillingCustomersInput>;
  create?: InputMaybe<MroAddressCreateWithoutBillingCustomersInput>;
};

export type MroAddressCreateNestedOneWithoutMroContactsInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroContactsInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroContactsInput>;
};

export type MroAddressCreateNestedOneWithoutMroCraftsInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroCraftsInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroCraftsInput>;
};

export type MroAddressCreateNestedOneWithoutMroOrganizationAddressInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroOrganizationAddressInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroOrganizationAddressInput>;
};

export type MroAddressCreateNestedOneWithoutMroPartVendorInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroPartVendorInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroPartVendorInput>;
};

export type MroAddressCreateNestedOneWithoutShippingCustomersInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutShippingCustomersInput>;
  create?: InputMaybe<MroAddressCreateWithoutShippingCustomersInput>;
};

export type MroAddressCreateOrConnectWithoutBillingCustomersInput = {
  create: MroAddressCreateWithoutBillingCustomersInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutMroContactsInput = {
  create: MroAddressCreateWithoutMroContactsInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutMroCraftsInput = {
  create: MroAddressCreateWithoutMroCraftsInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutMroCustomersInput = {
  create: MroAddressCreateWithoutMroCustomersInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutMroOrganizationAddressInput = {
  create: MroAddressCreateWithoutMroOrganizationAddressInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutMroOrganizationInput = {
  create: MroAddressCreateWithoutMroOrganizationInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutMroPartVendorInput = {
  create: MroAddressCreateWithoutMroPartVendorInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateOrConnectWithoutShippingCustomersInput = {
  create: MroAddressCreateWithoutShippingCustomersInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressCreateWithoutBillingCustomersInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutMroContactsInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutMroCraftsInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutMroCustomersInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutMroOrganizationAddressInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutMroOrganizationInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutMroPartVendorInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutShippingAddressInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressCreateWithoutShippingCustomersInput = {
  address: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutBillingAddressInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutAddressInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutAddressInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroAddressesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroAddressesInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationCreateNestedManyWithoutAddressInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutAddressInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionCreateNestedManyWithoutMroAddressInput>;
};

export type MroAddressListRelationFilter = {
  every?: InputMaybe<MroAddressWhereInput>;
  none?: InputMaybe<MroAddressWhereInput>;
  some?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressMaxAggregate = {
  __typename?: 'MroAddressMaxAggregate';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroAddressMinAggregate = {
  __typename?: 'MroAddressMinAggregate';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroAddressNullableScalarRelationFilter = {
  is?: InputMaybe<MroAddressWhereInput>;
  isNot?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressScalarWhereInput = {
  AND?: InputMaybe<Array<MroAddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroAddressScalarWhereInput>>;
  OR?: InputMaybe<Array<MroAddressScalarWhereInput>>;
  address?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  fax?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroAddressUpdateManyMutationInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroAddressUpdateManyWithWhereWithoutMroCustomersInput = {
  data: MroAddressUpdateManyMutationInput;
  where: MroAddressScalarWhereInput;
};

export type MroAddressUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroAddressUpdateManyMutationInput;
  where: MroAddressScalarWhereInput;
};

export type MroAddressUpdateManyWithoutMroCustomersNestedInput = {
  connect?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroAddressCreateOrConnectWithoutMroCustomersInput>>;
  create?: InputMaybe<Array<MroAddressCreateWithoutMroCustomersInput>>;
  delete?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroAddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  set?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  update?: InputMaybe<Array<MroAddressUpdateWithWhereUniqueWithoutMroCustomersInput>>;
  updateMany?: InputMaybe<Array<MroAddressUpdateManyWithWhereWithoutMroCustomersInput>>;
  upsert?: InputMaybe<Array<MroAddressUpsertWithWhereUniqueWithoutMroCustomersInput>>;
};

export type MroAddressUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroAddressCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroAddressCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroAddressCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroAddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  set?: InputMaybe<Array<MroAddressWhereUniqueInput>>;
  update?: InputMaybe<Array<MroAddressUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroAddressUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroAddressUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroAddressUpdateOneWithoutBillingCustomersNestedInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutBillingCustomersInput>;
  create?: InputMaybe<MroAddressCreateWithoutBillingCustomersInput>;
  delete?: InputMaybe<MroAddressWhereInput>;
  disconnect?: InputMaybe<MroAddressWhereInput>;
  update?: InputMaybe<MroAddressUpdateToOneWithWhereWithoutBillingCustomersInput>;
  upsert?: InputMaybe<MroAddressUpsertWithoutBillingCustomersInput>;
};

export type MroAddressUpdateOneWithoutMroContactsNestedInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroContactsInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroContactsInput>;
  delete?: InputMaybe<MroAddressWhereInput>;
  disconnect?: InputMaybe<MroAddressWhereInput>;
  update?: InputMaybe<MroAddressUpdateToOneWithWhereWithoutMroContactsInput>;
  upsert?: InputMaybe<MroAddressUpsertWithoutMroContactsInput>;
};

export type MroAddressUpdateOneWithoutMroCraftsNestedInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroCraftsInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroCraftsInput>;
  delete?: InputMaybe<MroAddressWhereInput>;
  disconnect?: InputMaybe<MroAddressWhereInput>;
  update?: InputMaybe<MroAddressUpdateToOneWithWhereWithoutMroCraftsInput>;
  upsert?: InputMaybe<MroAddressUpsertWithoutMroCraftsInput>;
};

export type MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroOrganizationAddressInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroOrganizationAddressInput>;
  delete?: InputMaybe<MroAddressWhereInput>;
  disconnect?: InputMaybe<MroAddressWhereInput>;
  update?: InputMaybe<MroAddressUpdateToOneWithWhereWithoutMroOrganizationAddressInput>;
  upsert?: InputMaybe<MroAddressUpsertWithoutMroOrganizationAddressInput>;
};

export type MroAddressUpdateOneWithoutMroPartVendorNestedInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutMroPartVendorInput>;
  create?: InputMaybe<MroAddressCreateWithoutMroPartVendorInput>;
  delete?: InputMaybe<MroAddressWhereInput>;
  disconnect?: InputMaybe<MroAddressWhereInput>;
  update?: InputMaybe<MroAddressUpdateToOneWithWhereWithoutMroPartVendorInput>;
  upsert?: InputMaybe<MroAddressUpsertWithoutMroPartVendorInput>;
};

export type MroAddressUpdateOneWithoutShippingCustomersNestedInput = {
  connect?: InputMaybe<MroAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroAddressCreateOrConnectWithoutShippingCustomersInput>;
  create?: InputMaybe<MroAddressCreateWithoutShippingCustomersInput>;
  delete?: InputMaybe<MroAddressWhereInput>;
  disconnect?: InputMaybe<MroAddressWhereInput>;
  update?: InputMaybe<MroAddressUpdateToOneWithWhereWithoutShippingCustomersInput>;
  upsert?: InputMaybe<MroAddressUpsertWithoutShippingCustomersInput>;
};

export type MroAddressUpdateToOneWithWhereWithoutBillingCustomersInput = {
  data: MroAddressUpdateWithoutBillingCustomersInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpdateToOneWithWhereWithoutMroContactsInput = {
  data: MroAddressUpdateWithoutMroContactsInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpdateToOneWithWhereWithoutMroCraftsInput = {
  data: MroAddressUpdateWithoutMroCraftsInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpdateToOneWithWhereWithoutMroOrganizationAddressInput = {
  data: MroAddressUpdateWithoutMroOrganizationAddressInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpdateToOneWithWhereWithoutMroPartVendorInput = {
  data: MroAddressUpdateWithoutMroPartVendorInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpdateToOneWithWhereWithoutShippingCustomersInput = {
  data: MroAddressUpdateWithoutShippingCustomersInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpdateWithWhereUniqueWithoutMroCustomersInput = {
  data: MroAddressUpdateWithoutMroCustomersInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroAddressUpdateWithoutMroOrganizationInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressUpdateWithoutBillingCustomersInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutMroContactsInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutMroCraftsInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutMroCustomersInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutMroOrganizationAddressInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutMroOrganizationInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutMroPartVendorInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  shippingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutShippingAddressNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpdateWithoutShippingCustomersInput = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  billingCustomers?: InputMaybe<MroCustomerUpdateManyWithoutBillingAddressNestedInput>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutAddressNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutAddressNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroAddressesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroAddressesNestedInput>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationUpdateManyWithoutAddressNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutAddressNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroAddressVersionUpdateManyWithoutMroAddressNestedInput>;
};

export type MroAddressUpsertWithWhereUniqueWithoutMroCustomersInput = {
  create: MroAddressCreateWithoutMroCustomersInput;
  update: MroAddressUpdateWithoutMroCustomersInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroAddressCreateWithoutMroOrganizationInput;
  update: MroAddressUpdateWithoutMroOrganizationInput;
  where: MroAddressWhereUniqueInput;
};

export type MroAddressUpsertWithoutBillingCustomersInput = {
  create: MroAddressCreateWithoutBillingCustomersInput;
  update: MroAddressUpdateWithoutBillingCustomersInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpsertWithoutMroContactsInput = {
  create: MroAddressCreateWithoutMroContactsInput;
  update: MroAddressUpdateWithoutMroContactsInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpsertWithoutMroCraftsInput = {
  create: MroAddressCreateWithoutMroCraftsInput;
  update: MroAddressUpdateWithoutMroCraftsInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpsertWithoutMroOrganizationAddressInput = {
  create: MroAddressCreateWithoutMroOrganizationAddressInput;
  update: MroAddressUpdateWithoutMroOrganizationAddressInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpsertWithoutMroPartVendorInput = {
  create: MroAddressCreateWithoutMroPartVendorInput;
  update: MroAddressUpdateWithoutMroPartVendorInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressUpsertWithoutShippingCustomersInput = {
  create: MroAddressCreateWithoutShippingCustomersInput;
  update: MroAddressUpdateWithoutShippingCustomersInput;
  where?: InputMaybe<MroAddressWhereInput>;
};

export type MroAddressVersion = {
  __typename?: 'MroAddressVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroAddress?: Maybe<MroAddress>;
  mroAddressId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroAddressVersionCreateManyMroAddressInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroAddressVersionCreateManyMroAddressInputEnvelope = {
  data: Array<MroAddressVersionCreateManyMroAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroAddressVersionCreateNestedManyWithoutMroAddressInput = {
  connect?: InputMaybe<Array<MroAddressVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroAddressVersionCreateOrConnectWithoutMroAddressInput>>;
  create?: InputMaybe<Array<MroAddressVersionCreateWithoutMroAddressInput>>;
  createMany?: InputMaybe<MroAddressVersionCreateManyMroAddressInputEnvelope>;
};

export type MroAddressVersionCreateOrConnectWithoutMroAddressInput = {
  create: MroAddressVersionCreateWithoutMroAddressInput;
  where: MroAddressVersionWhereUniqueInput;
};

export type MroAddressVersionCreateWithoutMroAddressInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroAddressVersionListRelationFilter = {
  every?: InputMaybe<MroAddressVersionWhereInput>;
  none?: InputMaybe<MroAddressVersionWhereInput>;
  some?: InputMaybe<MroAddressVersionWhereInput>;
};

export type MroAddressVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroAddressVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroAddressVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroAddressVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroAddressId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroAddressVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroAddressVersionUpdateManyWithWhereWithoutMroAddressInput = {
  data: MroAddressVersionUpdateManyMutationInput;
  where: MroAddressVersionScalarWhereInput;
};

export type MroAddressVersionUpdateManyWithoutMroAddressNestedInput = {
  connect?: InputMaybe<Array<MroAddressVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroAddressVersionCreateOrConnectWithoutMroAddressInput>>;
  create?: InputMaybe<Array<MroAddressVersionCreateWithoutMroAddressInput>>;
  createMany?: InputMaybe<MroAddressVersionCreateManyMroAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroAddressVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroAddressVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroAddressVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroAddressVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroAddressVersionUpdateWithWhereUniqueWithoutMroAddressInput>>;
  updateMany?: InputMaybe<Array<MroAddressVersionUpdateManyWithWhereWithoutMroAddressInput>>;
  upsert?: InputMaybe<Array<MroAddressVersionUpsertWithWhereUniqueWithoutMroAddressInput>>;
};

export type MroAddressVersionUpdateWithWhereUniqueWithoutMroAddressInput = {
  data: MroAddressVersionUpdateWithoutMroAddressInput;
  where: MroAddressVersionWhereUniqueInput;
};

export type MroAddressVersionUpdateWithoutMroAddressInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroAddressVersionUpsertWithWhereUniqueWithoutMroAddressInput = {
  create: MroAddressVersionCreateWithoutMroAddressInput;
  update: MroAddressVersionUpdateWithoutMroAddressInput;
  where: MroAddressVersionWhereUniqueInput;
};

export type MroAddressVersionWhereInput = {
  AND?: InputMaybe<Array<MroAddressVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroAddressVersionWhereInput>>;
  OR?: InputMaybe<Array<MroAddressVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroAddress?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  mroAddressId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroAddressVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroAddressVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroAddressVersionWhereInput>>;
  OR?: InputMaybe<Array<MroAddressVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroAddress?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  mroAddressId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroAddressWhereInput = {
  AND?: InputMaybe<Array<MroAddressWhereInput>>;
  NOT?: InputMaybe<Array<MroAddressWhereInput>>;
  OR?: InputMaybe<Array<MroAddressWhereInput>>;
  address?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  billingCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  fax?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroContacts?: InputMaybe<MroContactListRelationFilter>;
  mroCrafts?: InputMaybe<MroCraftListRelationFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationListRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartVendor?: InputMaybe<MroPartVendorListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  shippingCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroAddressVersionListRelationFilter>;
};

export type MroAddressWhereUniqueInput = {
  AND?: InputMaybe<Array<MroAddressWhereInput>>;
  NOT?: InputMaybe<Array<MroAddressWhereInput>>;
  OR?: InputMaybe<Array<MroAddressWhereInput>>;
  address?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  billingCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  fax?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroContacts?: InputMaybe<MroContactListRelationFilter>;
  mroCrafts?: InputMaybe<MroCraftListRelationFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationAddress?: InputMaybe<MroOrganizationListRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartVendor?: InputMaybe<MroPartVendorListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  shippingCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroAddressVersionListRelationFilter>;
};

export enum MroBillableType {
  Both = 'BOTH',
  Labor = 'LABOR',
  Parts = 'PARTS'
}

export type MroCommunicationDevice = {
  __typename?: 'MroCommunicationDevice';
  _count: MroCommunicationDeviceCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroCommunicationParticipants?: Maybe<Array<MroCommunicationParticipant>>;
  mroContact?: Maybe<MroContact>;
  mroContactId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  twilioDeviceSid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceCount = {
  __typename?: 'MroCommunicationDeviceCount';
  mroCommunicationParticipants: Scalars['Int'];
};

export type MroCommunicationDeviceCreateManyMroContactInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceCreateManyMroContactInputEnvelope = {
  data: Array<MroCommunicationDeviceCreateManyMroContactInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationDeviceCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroContactId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroCommunicationDeviceCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationDeviceCreateNestedManyWithoutMroCommunicationParticipantsInput = {
  connect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationDeviceCreateOrConnectWithoutMroCommunicationParticipantsInput>>;
  create?: InputMaybe<Array<MroCommunicationDeviceCreateWithoutMroCommunicationParticipantsInput>>;
};

export type MroCommunicationDeviceCreateNestedManyWithoutMroContactInput = {
  connect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationDeviceCreateOrConnectWithoutMroContactInput>>;
  create?: InputMaybe<Array<MroCommunicationDeviceCreateWithoutMroContactInput>>;
  createMany?: InputMaybe<MroCommunicationDeviceCreateManyMroContactInputEnvelope>;
};

export type MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationDeviceCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationDeviceCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationDeviceCreateManyMroOrganizationInputEnvelope>;
};

export type MroCommunicationDeviceCreateOrConnectWithoutMroCommunicationParticipantsInput = {
  create: MroCommunicationDeviceCreateWithoutMroCommunicationParticipantsInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceCreateOrConnectWithoutMroContactInput = {
  create: MroCommunicationDeviceCreateWithoutMroContactInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceCreateOrConnectWithoutMroOrganizationInput = {
  create: MroCommunicationDeviceCreateWithoutMroOrganizationInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceCreateWithoutMroCommunicationParticipantsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationDevicesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationDevicesInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceCreateWithoutMroContactInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationDevicesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationDevicesInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationDevicesInput>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationDevicesInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceListRelationFilter = {
  every?: InputMaybe<MroCommunicationDeviceWhereInput>;
  none?: InputMaybe<MroCommunicationDeviceWhereInput>;
  some?: InputMaybe<MroCommunicationDeviceWhereInput>;
};

export type MroCommunicationDeviceScalarWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationDeviceScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationDeviceScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationDeviceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  twilioDeviceSid?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationDeviceUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceUpdateManyWithWhereWithoutMroCommunicationParticipantsInput = {
  data: MroCommunicationDeviceUpdateManyMutationInput;
  where: MroCommunicationDeviceScalarWhereInput;
};

export type MroCommunicationDeviceUpdateManyWithWhereWithoutMroContactInput = {
  data: MroCommunicationDeviceUpdateManyMutationInput;
  where: MroCommunicationDeviceScalarWhereInput;
};

export type MroCommunicationDeviceUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroCommunicationDeviceUpdateManyMutationInput;
  where: MroCommunicationDeviceScalarWhereInput;
};

export type MroCommunicationDeviceUpdateManyWithoutMroCommunicationParticipantsNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationDeviceCreateOrConnectWithoutMroCommunicationParticipantsInput>>;
  create?: InputMaybe<Array<MroCommunicationDeviceCreateWithoutMroCommunicationParticipantsInput>>;
  delete?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationDeviceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationDeviceUpdateWithWhereUniqueWithoutMroCommunicationParticipantsInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationDeviceUpdateManyWithWhereWithoutMroCommunicationParticipantsInput>>;
  upsert?: InputMaybe<Array<MroCommunicationDeviceUpsertWithWhereUniqueWithoutMroCommunicationParticipantsInput>>;
};

export type MroCommunicationDeviceUpdateManyWithoutMroContactNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationDeviceCreateOrConnectWithoutMroContactInput>>;
  create?: InputMaybe<Array<MroCommunicationDeviceCreateWithoutMroContactInput>>;
  createMany?: InputMaybe<MroCommunicationDeviceCreateManyMroContactInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationDeviceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationDeviceUpdateWithWhereUniqueWithoutMroContactInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationDeviceUpdateManyWithWhereWithoutMroContactInput>>;
  upsert?: InputMaybe<Array<MroCommunicationDeviceUpsertWithWhereUniqueWithoutMroContactInput>>;
};

export type MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationDeviceCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationDeviceCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationDeviceCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationDeviceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationDeviceWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationDeviceUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationDeviceUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCommunicationDeviceUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroCommunicationDeviceUpdateWithWhereUniqueWithoutMroCommunicationParticipantsInput = {
  data: MroCommunicationDeviceUpdateWithoutMroCommunicationParticipantsInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceUpdateWithWhereUniqueWithoutMroContactInput = {
  data: MroCommunicationDeviceUpdateWithoutMroContactInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroCommunicationDeviceUpdateWithoutMroOrganizationInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceUpdateWithoutMroCommunicationParticipantsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationDevicesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationDevicesNestedInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceUpdateWithoutMroContactInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationDevicesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationDevicesNestedInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationDevicesNestedInput>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationDevicesNestedInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  pushToken?: InputMaybe<Scalars['String']>;
  twilioDeviceSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationDeviceUpsertWithWhereUniqueWithoutMroCommunicationParticipantsInput = {
  create: MroCommunicationDeviceCreateWithoutMroCommunicationParticipantsInput;
  update: MroCommunicationDeviceUpdateWithoutMroCommunicationParticipantsInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceUpsertWithWhereUniqueWithoutMroContactInput = {
  create: MroCommunicationDeviceCreateWithoutMroContactInput;
  update: MroCommunicationDeviceUpdateWithoutMroContactInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroCommunicationDeviceCreateWithoutMroOrganizationInput;
  update: MroCommunicationDeviceUpdateWithoutMroOrganizationInput;
  where: MroCommunicationDeviceWhereUniqueInput;
};

export type MroCommunicationDeviceWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationDeviceWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationDeviceWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationDeviceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  twilioDeviceSid?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationDeviceWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCommunicationDeviceWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationDeviceWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationDeviceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  pushToken?: InputMaybe<StringNullableFilter>;
  twilioDeviceSid?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationMessage = {
  __typename?: 'MroCommunicationMessage';
  contents?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroCommunicationParticipant?: Maybe<MroCommunicationParticipant>;
  mroCommunicationParticipantId?: Maybe<Scalars['String']>;
  mroCommunicationThread?: Maybe<MroCommunicationThread>;
  mroCommunicationThreadId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  sendGridMessageId?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageCountAggregate = {
  __typename?: 'MroCommunicationMessageCountAggregate';
  _all: Scalars['Int'];
  contents: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroCommunicationParticipantId: Scalars['Int'];
  mroCommunicationThreadId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  sendGridMessageId: Scalars['Int'];
  twilioMessageSid: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroCommunicationMessageCreateManyMroCommunicationParticipantInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreadId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageCreateManyMroCommunicationParticipantInputEnvelope = {
  data: Array<MroCommunicationMessageCreateManyMroCommunicationParticipantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationMessageCreateManyMroCommunicationThreadInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipantId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageCreateManyMroCommunicationThreadInputEnvelope = {
  data: Array<MroCommunicationMessageCreateManyMroCommunicationThreadInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationMessageCreateManyMroOrganizationInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipantId?: InputMaybe<Scalars['String']>;
  mroCommunicationThreadId?: InputMaybe<Scalars['String']>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroCommunicationMessageCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationMessageCreateNestedManyWithoutMroCommunicationParticipantInput = {
  connect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationMessageCreateOrConnectWithoutMroCommunicationParticipantInput>>;
  create?: InputMaybe<Array<MroCommunicationMessageCreateWithoutMroCommunicationParticipantInput>>;
  createMany?: InputMaybe<MroCommunicationMessageCreateManyMroCommunicationParticipantInputEnvelope>;
};

export type MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput = {
  connect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationMessageCreateOrConnectWithoutMroCommunicationThreadInput>>;
  create?: InputMaybe<Array<MroCommunicationMessageCreateWithoutMroCommunicationThreadInput>>;
  createMany?: InputMaybe<MroCommunicationMessageCreateManyMroCommunicationThreadInputEnvelope>;
};

export type MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationMessageCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationMessageCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationMessageCreateManyMroOrganizationInputEnvelope>;
};

export type MroCommunicationMessageCreateOrConnectWithoutMroCommunicationParticipantInput = {
  create: MroCommunicationMessageCreateWithoutMroCommunicationParticipantInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageCreateOrConnectWithoutMroCommunicationThreadInput = {
  create: MroCommunicationMessageCreateWithoutMroCommunicationThreadInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageCreateOrConnectWithoutMroOrganizationInput = {
  create: MroCommunicationMessageCreateWithoutMroOrganizationInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageCreateWithoutMroCommunicationParticipantInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationMessagesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationMessagesInput>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageCreateWithoutMroCommunicationThreadInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipant?: InputMaybe<MroCommunicationParticipantCreateNestedOneWithoutMroCommunicationMessagesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationMessagesInput>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageCreateWithoutMroOrganizationInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipant?: InputMaybe<MroCommunicationParticipantCreateNestedOneWithoutMroCommunicationMessagesInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationMessagesInput>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageListRelationFilter = {
  every?: InputMaybe<MroCommunicationMessageWhereInput>;
  none?: InputMaybe<MroCommunicationMessageWhereInput>;
  some?: InputMaybe<MroCommunicationMessageWhereInput>;
};

export type MroCommunicationMessageMaxAggregate = {
  __typename?: 'MroCommunicationMessageMaxAggregate';
  contents?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroCommunicationParticipantId?: Maybe<Scalars['String']>;
  mroCommunicationThreadId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  sendGridMessageId?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageMinAggregate = {
  __typename?: 'MroCommunicationMessageMinAggregate';
  contents?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroCommunicationParticipantId?: Maybe<Scalars['String']>;
  mroCommunicationThreadId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  sendGridMessageId?: Maybe<Scalars['String']>;
  twilioMessageSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageScalarWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationMessageScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationMessageScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationMessageScalarWhereInput>>;
  contents?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCommunicationParticipantId?: InputMaybe<StringNullableFilter>;
  mroCommunicationThreadId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  sendGridMessageId?: InputMaybe<StringNullableFilter>;
  twilioMessageSid?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationMessageUpdateManyMutationInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageUpdateManyWithWhereWithoutMroCommunicationParticipantInput = {
  data: MroCommunicationMessageUpdateManyMutationInput;
  where: MroCommunicationMessageScalarWhereInput;
};

export type MroCommunicationMessageUpdateManyWithWhereWithoutMroCommunicationThreadInput = {
  data: MroCommunicationMessageUpdateManyMutationInput;
  where: MroCommunicationMessageScalarWhereInput;
};

export type MroCommunicationMessageUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroCommunicationMessageUpdateManyMutationInput;
  where: MroCommunicationMessageScalarWhereInput;
};

export type MroCommunicationMessageUpdateManyWithoutMroCommunicationParticipantNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationMessageCreateOrConnectWithoutMroCommunicationParticipantInput>>;
  create?: InputMaybe<Array<MroCommunicationMessageCreateWithoutMroCommunicationParticipantInput>>;
  createMany?: InputMaybe<MroCommunicationMessageCreateManyMroCommunicationParticipantInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationMessageUpdateWithWhereUniqueWithoutMroCommunicationParticipantInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationMessageUpdateManyWithWhereWithoutMroCommunicationParticipantInput>>;
  upsert?: InputMaybe<Array<MroCommunicationMessageUpsertWithWhereUniqueWithoutMroCommunicationParticipantInput>>;
};

export type MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationMessageCreateOrConnectWithoutMroCommunicationThreadInput>>;
  create?: InputMaybe<Array<MroCommunicationMessageCreateWithoutMroCommunicationThreadInput>>;
  createMany?: InputMaybe<MroCommunicationMessageCreateManyMroCommunicationThreadInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationMessageUpdateWithWhereUniqueWithoutMroCommunicationThreadInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationMessageUpdateManyWithWhereWithoutMroCommunicationThreadInput>>;
  upsert?: InputMaybe<Array<MroCommunicationMessageUpsertWithWhereUniqueWithoutMroCommunicationThreadInput>>;
};

export type MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationMessageCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationMessageCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationMessageCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationMessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationMessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationMessageUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationMessageUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCommunicationMessageUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroCommunicationMessageUpdateWithWhereUniqueWithoutMroCommunicationParticipantInput = {
  data: MroCommunicationMessageUpdateWithoutMroCommunicationParticipantInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageUpdateWithWhereUniqueWithoutMroCommunicationThreadInput = {
  data: MroCommunicationMessageUpdateWithoutMroCommunicationThreadInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroCommunicationMessageUpdateWithoutMroOrganizationInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageUpdateWithoutMroCommunicationParticipantInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationMessagesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationMessagesNestedInput>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageUpdateWithoutMroCommunicationThreadInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipant?: InputMaybe<MroCommunicationParticipantUpdateOneWithoutMroCommunicationMessagesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationMessagesNestedInput>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageUpdateWithoutMroOrganizationInput = {
  contents?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipant?: InputMaybe<MroCommunicationParticipantUpdateOneWithoutMroCommunicationMessagesNestedInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationMessagesNestedInput>;
  sendGridMessageId?: InputMaybe<Scalars['String']>;
  twilioMessageSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationMessageUpsertWithWhereUniqueWithoutMroCommunicationParticipantInput = {
  create: MroCommunicationMessageCreateWithoutMroCommunicationParticipantInput;
  update: MroCommunicationMessageUpdateWithoutMroCommunicationParticipantInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageUpsertWithWhereUniqueWithoutMroCommunicationThreadInput = {
  create: MroCommunicationMessageCreateWithoutMroCommunicationThreadInput;
  update: MroCommunicationMessageUpdateWithoutMroCommunicationThreadInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroCommunicationMessageCreateWithoutMroOrganizationInput;
  update: MroCommunicationMessageUpdateWithoutMroOrganizationInput;
  where: MroCommunicationMessageWhereUniqueInput;
};

export type MroCommunicationMessageWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationMessageWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationMessageWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationMessageWhereInput>>;
  contents?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCommunicationParticipant?: InputMaybe<MroCommunicationParticipantNullableScalarRelationFilter>;
  mroCommunicationParticipantId?: InputMaybe<StringNullableFilter>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadNullableScalarRelationFilter>;
  mroCommunicationThreadId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  sendGridMessageId?: InputMaybe<StringNullableFilter>;
  twilioMessageSid?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationMessageWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCommunicationMessageWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationMessageWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationMessageWhereInput>>;
  contents?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipant?: InputMaybe<MroCommunicationParticipantNullableScalarRelationFilter>;
  mroCommunicationParticipantId?: InputMaybe<StringNullableFilter>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadNullableScalarRelationFilter>;
  mroCommunicationThreadId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  sendGridMessageId?: InputMaybe<StringNullableFilter>;
  twilioMessageSid?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationParticipant = {
  __typename?: 'MroCommunicationParticipant';
  _count: MroCommunicationParticipantCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroCommunicationDevices?: Maybe<Array<MroCommunicationDevice>>;
  mroCommunicationMessages?: Maybe<Array<MroCommunicationMessage>>;
  mroCommunicationThread?: Maybe<MroCommunicationThread>;
  mroCommunicationThreadId?: Maybe<Scalars['String']>;
  mroContact?: Maybe<MroContact>;
  mroContactId?: Maybe<Scalars['String']>;
  mroEmployeeProfile?: Maybe<MroEmployeeProfile>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  twilioParticipantSid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCount = {
  __typename?: 'MroCommunicationParticipantCount';
  mroCommunicationDevices: Scalars['Int'];
  mroCommunicationMessages: Scalars['Int'];
};

export type MroCommunicationParticipantCountAggregate = {
  __typename?: 'MroCommunicationParticipantCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroCommunicationThreadId: Scalars['Int'];
  mroContactId: Scalars['Int'];
  mroEmployeeProfileId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  twilioParticipantSid: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroCommunicationParticipantCreateManyMroCommunicationThreadInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroContactId?: InputMaybe<Scalars['String']>;
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateManyMroCommunicationThreadInputEnvelope = {
  data: Array<MroCommunicationParticipantCreateManyMroCommunicationThreadInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationParticipantCreateManyMroContactInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreadId?: InputMaybe<Scalars['String']>;
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateManyMroContactInputEnvelope = {
  data: Array<MroCommunicationParticipantCreateManyMroContactInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationParticipantCreateManyMroEmployeeProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreadId?: InputMaybe<Scalars['String']>;
  mroContactId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateManyMroEmployeeProfileInputEnvelope = {
  data: Array<MroCommunicationParticipantCreateManyMroEmployeeProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationParticipantCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreadId?: InputMaybe<Scalars['String']>;
  mroContactId?: InputMaybe<Scalars['String']>;
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroCommunicationParticipantCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationDevicesInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationDevicesInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroCommunicationDevicesInput>>;
};

export type MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationThreadInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroCommunicationThreadInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroCommunicationThreadInputEnvelope>;
};

export type MroCommunicationParticipantCreateNestedManyWithoutMroContactInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroContactInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroContactInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroContactInputEnvelope>;
};

export type MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroEmployeeProfileInputEnvelope>;
};

export type MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroOrganizationInputEnvelope>;
};

export type MroCommunicationParticipantCreateNestedOneWithoutMroCommunicationMessagesInput = {
  connect?: InputMaybe<MroCommunicationParticipantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationMessagesInput>;
  create?: InputMaybe<MroCommunicationParticipantCreateWithoutMroCommunicationMessagesInput>;
};

export type MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationDevicesInput = {
  create: MroCommunicationParticipantCreateWithoutMroCommunicationDevicesInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationMessagesInput = {
  create: MroCommunicationParticipantCreateWithoutMroCommunicationMessagesInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationThreadInput = {
  create: MroCommunicationParticipantCreateWithoutMroCommunicationThreadInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantCreateOrConnectWithoutMroContactInput = {
  create: MroCommunicationParticipantCreateWithoutMroContactInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantCreateOrConnectWithoutMroEmployeeProfileInput = {
  create: MroCommunicationParticipantCreateWithoutMroEmployeeProfileInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantCreateOrConnectWithoutMroOrganizationInput = {
  create: MroCommunicationParticipantCreateWithoutMroOrganizationInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantCreateWithoutMroCommunicationDevicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationParticipantInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateWithoutMroCommunicationMessagesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroCommunicationParticipantsInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateWithoutMroCommunicationThreadInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroCommunicationParticipantsInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationParticipantInput>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateWithoutMroContactInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroCommunicationParticipantsInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationParticipantInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateWithoutMroEmployeeProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroCommunicationParticipantsInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationParticipantInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroCommunicationParticipantsInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationParticipantInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroContact?: InputMaybe<MroContactCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroCommunicationParticipantsInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantListRelationFilter = {
  every?: InputMaybe<MroCommunicationParticipantWhereInput>;
  none?: InputMaybe<MroCommunicationParticipantWhereInput>;
  some?: InputMaybe<MroCommunicationParticipantWhereInput>;
};

export type MroCommunicationParticipantMaxAggregate = {
  __typename?: 'MroCommunicationParticipantMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroCommunicationThreadId?: Maybe<Scalars['String']>;
  mroContactId?: Maybe<Scalars['String']>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  twilioParticipantSid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantMinAggregate = {
  __typename?: 'MroCommunicationParticipantMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroCommunicationThreadId?: Maybe<Scalars['String']>;
  mroContactId?: Maybe<Scalars['String']>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  twilioParticipantSid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantNullableScalarRelationFilter = {
  is?: InputMaybe<MroCommunicationParticipantWhereInput>;
  isNot?: InputMaybe<MroCommunicationParticipantWhereInput>;
};

export type MroCommunicationParticipantScalarWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCommunicationThreadId?: InputMaybe<StringNullableFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  twilioParticipantSid?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationParticipantUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpdateManyWithWhereWithoutMroCommunicationDevicesInput = {
  data: MroCommunicationParticipantUpdateManyMutationInput;
  where: MroCommunicationParticipantScalarWhereInput;
};

export type MroCommunicationParticipantUpdateManyWithWhereWithoutMroCommunicationThreadInput = {
  data: MroCommunicationParticipantUpdateManyMutationInput;
  where: MroCommunicationParticipantScalarWhereInput;
};

export type MroCommunicationParticipantUpdateManyWithWhereWithoutMroContactInput = {
  data: MroCommunicationParticipantUpdateManyMutationInput;
  where: MroCommunicationParticipantScalarWhereInput;
};

export type MroCommunicationParticipantUpdateManyWithWhereWithoutMroEmployeeProfileInput = {
  data: MroCommunicationParticipantUpdateManyMutationInput;
  where: MroCommunicationParticipantScalarWhereInput;
};

export type MroCommunicationParticipantUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroCommunicationParticipantUpdateManyMutationInput;
  where: MroCommunicationParticipantScalarWhereInput;
};

export type MroCommunicationParticipantUpdateManyWithoutMroCommunicationDevicesNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationDevicesInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroCommunicationDevicesInput>>;
  delete?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroCommunicationDevicesInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationParticipantUpdateManyWithWhereWithoutMroCommunicationDevicesInput>>;
  upsert?: InputMaybe<Array<MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroCommunicationDevicesInput>>;
};

export type MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationThreadInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroCommunicationThreadInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroCommunicationThreadInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroCommunicationThreadInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationParticipantUpdateManyWithWhereWithoutMroCommunicationThreadInput>>;
  upsert?: InputMaybe<Array<MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroCommunicationThreadInput>>;
};

export type MroCommunicationParticipantUpdateManyWithoutMroContactNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroContactInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroContactInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroContactInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroContactInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationParticipantUpdateManyWithWhereWithoutMroContactInput>>;
  upsert?: InputMaybe<Array<MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroContactInput>>;
};

export type MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroEmployeeProfileInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroEmployeeProfileInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationParticipantUpdateManyWithWhereWithoutMroEmployeeProfileInput>>;
  upsert?: InputMaybe<Array<MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroEmployeeProfileInput>>;
};

export type MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationParticipantCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationParticipantCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationParticipantCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationParticipantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationParticipantWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationParticipantUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroCommunicationParticipantUpdateOneWithoutMroCommunicationMessagesNestedInput = {
  connect?: InputMaybe<MroCommunicationParticipantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCommunicationParticipantCreateOrConnectWithoutMroCommunicationMessagesInput>;
  create?: InputMaybe<MroCommunicationParticipantCreateWithoutMroCommunicationMessagesInput>;
  delete?: InputMaybe<MroCommunicationParticipantWhereInput>;
  disconnect?: InputMaybe<MroCommunicationParticipantWhereInput>;
  update?: InputMaybe<MroCommunicationParticipantUpdateToOneWithWhereWithoutMroCommunicationMessagesInput>;
  upsert?: InputMaybe<MroCommunicationParticipantUpsertWithoutMroCommunicationMessagesInput>;
};

export type MroCommunicationParticipantUpdateToOneWithWhereWithoutMroCommunicationMessagesInput = {
  data: MroCommunicationParticipantUpdateWithoutMroCommunicationMessagesInput;
  where?: InputMaybe<MroCommunicationParticipantWhereInput>;
};

export type MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroCommunicationDevicesInput = {
  data: MroCommunicationParticipantUpdateWithoutMroCommunicationDevicesInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroCommunicationThreadInput = {
  data: MroCommunicationParticipantUpdateWithoutMroCommunicationThreadInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroContactInput = {
  data: MroCommunicationParticipantUpdateWithoutMroContactInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroEmployeeProfileInput = {
  data: MroCommunicationParticipantUpdateWithoutMroEmployeeProfileInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroCommunicationParticipantUpdateWithoutMroOrganizationInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpdateWithoutMroCommunicationDevicesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationParticipantNestedInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpdateWithoutMroCommunicationMessagesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroCommunicationParticipantsNestedInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpdateWithoutMroCommunicationThreadInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroCommunicationParticipantsNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationParticipantNestedInput>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpdateWithoutMroContactInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroCommunicationParticipantsNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationParticipantNestedInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpdateWithoutMroEmployeeProfileInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroCommunicationParticipantsNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationParticipantNestedInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroCommunicationParticipantsNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationParticipantNestedInput>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroContact?: InputMaybe<MroContactUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroCommunicationParticipantsNestedInput>;
  twilioParticipantSid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroCommunicationDevicesInput = {
  create: MroCommunicationParticipantCreateWithoutMroCommunicationDevicesInput;
  update: MroCommunicationParticipantUpdateWithoutMroCommunicationDevicesInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroCommunicationThreadInput = {
  create: MroCommunicationParticipantCreateWithoutMroCommunicationThreadInput;
  update: MroCommunicationParticipantUpdateWithoutMroCommunicationThreadInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroContactInput = {
  create: MroCommunicationParticipantCreateWithoutMroContactInput;
  update: MroCommunicationParticipantUpdateWithoutMroContactInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroEmployeeProfileInput = {
  create: MroCommunicationParticipantCreateWithoutMroEmployeeProfileInput;
  update: MroCommunicationParticipantUpdateWithoutMroEmployeeProfileInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroCommunicationParticipantCreateWithoutMroOrganizationInput;
  update: MroCommunicationParticipantUpdateWithoutMroOrganizationInput;
  where: MroCommunicationParticipantWhereUniqueInput;
};

export type MroCommunicationParticipantUpsertWithoutMroCommunicationMessagesInput = {
  create: MroCommunicationParticipantCreateWithoutMroCommunicationMessagesInput;
  update: MroCommunicationParticipantUpdateWithoutMroCommunicationMessagesInput;
  where?: InputMaybe<MroCommunicationParticipantWhereInput>;
};

export type MroCommunicationParticipantWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationParticipantWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationParticipantWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationParticipantWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceListRelationFilter>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageListRelationFilter>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadNullableScalarRelationFilter>;
  mroCommunicationThreadId?: InputMaybe<StringNullableFilter>;
  mroContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  twilioParticipantSid?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationParticipantWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCommunicationParticipantWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationParticipantWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationParticipantWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceListRelationFilter>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageListRelationFilter>;
  mroCommunicationThread?: InputMaybe<MroCommunicationThreadNullableScalarRelationFilter>;
  mroCommunicationThreadId?: InputMaybe<StringNullableFilter>;
  mroContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  twilioParticipantSid?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationThread = {
  __typename?: 'MroCommunicationThread';
  _count: MroCommunicationThreadCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mroCommunicationMessages?: Maybe<Array<MroCommunicationMessage>>;
  mroCommunicationParticipants?: Maybe<Array<MroCommunicationParticipant>>;
  mroCraft?: Maybe<MroCraft>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCrafts: MroCraft;
  mroCustomer?: Maybe<MroCustomer>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroCustomers: MroCustomer;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroOrganizations: MroOrganization;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  mroWorkOrders: MroWorkOrder;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCount = {
  __typename?: 'MroCommunicationThreadCount';
  mroCommunicationMessages: Scalars['Int'];
  mroCommunicationParticipants: Scalars['Int'];
};

export type MroCommunicationThreadCountAggregate = {
  __typename?: 'MroCommunicationThreadCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  mroCraftId: Scalars['Int'];
  mroCustomerId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  notes: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  twilioConversationSid: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroCommunicationThreadCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateManyMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateManyMroCraftInputEnvelope = {
  data: Array<MroCommunicationThreadCreateManyMroCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationThreadCreateManyMroCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateManyMroCustomerInputEnvelope = {
  data: Array<MroCommunicationThreadCreateManyMroCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationThreadCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroCommunicationThreadCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationThreadCreateManyMroWorkOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroCommunicationThreadCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCommunicationThreadCreateNestedManyWithoutMroCraftInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroCraftInputEnvelope>;
};

export type MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroCustomerInputEnvelope>;
};

export type MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroOrganizationInputEnvelope>;
};

export type MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroWorkOrderInputEnvelope>;
};

export type MroCommunicationThreadCreateNestedOneWithoutMroCommunicationMessagesInput = {
  connect?: InputMaybe<MroCommunicationThreadWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCommunicationThreadCreateOrConnectWithoutMroCommunicationMessagesInput>;
  create?: InputMaybe<MroCommunicationThreadCreateWithoutMroCommunicationMessagesInput>;
};

export type MroCommunicationThreadCreateNestedOneWithoutMroCommunicationParticipantsInput = {
  connect?: InputMaybe<MroCommunicationThreadWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCommunicationThreadCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroCommunicationThreadCreateWithoutMroCommunicationParticipantsInput>;
};

export type MroCommunicationThreadCreateOrConnectWithoutMroCommunicationMessagesInput = {
  create: MroCommunicationThreadCreateWithoutMroCommunicationMessagesInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadCreateOrConnectWithoutMroCommunicationParticipantsInput = {
  create: MroCommunicationThreadCreateWithoutMroCommunicationParticipantsInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadCreateOrConnectWithoutMroCraftInput = {
  create: MroCommunicationThreadCreateWithoutMroCraftInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadCreateOrConnectWithoutMroCustomerInput = {
  create: MroCommunicationThreadCreateWithoutMroCustomerInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadCreateOrConnectWithoutMroOrganizationInput = {
  create: MroCommunicationThreadCreateWithoutMroOrganizationInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroCommunicationThreadCreateWithoutMroWorkOrderInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadCreateWithoutMroCommunicationMessagesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateWithoutMroCommunicationParticipantsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateWithoutMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateWithoutMroCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadCreateWithoutMroWorkOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroCommunicationThreadInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadListRelationFilter = {
  every?: InputMaybe<MroCommunicationThreadWhereInput>;
  none?: InputMaybe<MroCommunicationThreadWhereInput>;
  some?: InputMaybe<MroCommunicationThreadWhereInput>;
};

export type MroCommunicationThreadMaxAggregate = {
  __typename?: 'MroCommunicationThreadMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  twilioConversationSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadMinAggregate = {
  __typename?: 'MroCommunicationThreadMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  twilioConversationSid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadNullableScalarRelationFilter = {
  is?: InputMaybe<MroCommunicationThreadWhereInput>;
  isNot?: InputMaybe<MroCommunicationThreadWhereInput>;
};

export type MroCommunicationThreadScalarWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  twilioConversationSid?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationThreadUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateManyWithWhereWithoutMroCraftInput = {
  data: MroCommunicationThreadUpdateManyMutationInput;
  where: MroCommunicationThreadScalarWhereInput;
};

export type MroCommunicationThreadUpdateManyWithWhereWithoutMroCustomerInput = {
  data: MroCommunicationThreadUpdateManyMutationInput;
  where: MroCommunicationThreadScalarWhereInput;
};

export type MroCommunicationThreadUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroCommunicationThreadUpdateManyMutationInput;
  where: MroCommunicationThreadScalarWhereInput;
};

export type MroCommunicationThreadUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroCommunicationThreadUpdateManyMutationInput;
  where: MroCommunicationThreadScalarWhereInput;
};

export type MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationThreadUpdateWithWhereUniqueWithoutMroCraftInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationThreadUpdateManyWithWhereWithoutMroCraftInput>>;
  upsert?: InputMaybe<Array<MroCommunicationThreadUpsertWithWhereUniqueWithoutMroCraftInput>>;
};

export type MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroCustomerInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationThreadUpdateWithWhereUniqueWithoutMroCustomerInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationThreadUpdateManyWithWhereWithoutMroCustomerInput>>;
  upsert?: InputMaybe<Array<MroCommunicationThreadUpsertWithWhereUniqueWithoutMroCustomerInput>>;
};

export type MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationThreadUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationThreadUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCommunicationThreadUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCommunicationThreadCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroCommunicationThreadCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroCommunicationThreadCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCommunicationThreadScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCommunicationThreadWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCommunicationThreadUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroCommunicationThreadUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroCommunicationThreadUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroCommunicationThreadUpdateOneWithoutMroCommunicationMessagesNestedInput = {
  connect?: InputMaybe<MroCommunicationThreadWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCommunicationThreadCreateOrConnectWithoutMroCommunicationMessagesInput>;
  create?: InputMaybe<MroCommunicationThreadCreateWithoutMroCommunicationMessagesInput>;
  delete?: InputMaybe<MroCommunicationThreadWhereInput>;
  disconnect?: InputMaybe<MroCommunicationThreadWhereInput>;
  update?: InputMaybe<MroCommunicationThreadUpdateToOneWithWhereWithoutMroCommunicationMessagesInput>;
  upsert?: InputMaybe<MroCommunicationThreadUpsertWithoutMroCommunicationMessagesInput>;
};

export type MroCommunicationThreadUpdateOneWithoutMroCommunicationParticipantsNestedInput = {
  connect?: InputMaybe<MroCommunicationThreadWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCommunicationThreadCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroCommunicationThreadCreateWithoutMroCommunicationParticipantsInput>;
  delete?: InputMaybe<MroCommunicationThreadWhereInput>;
  disconnect?: InputMaybe<MroCommunicationThreadWhereInput>;
  update?: InputMaybe<MroCommunicationThreadUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput>;
  upsert?: InputMaybe<MroCommunicationThreadUpsertWithoutMroCommunicationParticipantsInput>;
};

export type MroCommunicationThreadUpdateToOneWithWhereWithoutMroCommunicationMessagesInput = {
  data: MroCommunicationThreadUpdateWithoutMroCommunicationMessagesInput;
  where?: InputMaybe<MroCommunicationThreadWhereInput>;
};

export type MroCommunicationThreadUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput = {
  data: MroCommunicationThreadUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroCommunicationThreadWhereInput>;
};

export type MroCommunicationThreadUpdateWithWhereUniqueWithoutMroCraftInput = {
  data: MroCommunicationThreadUpdateWithoutMroCraftInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpdateWithWhereUniqueWithoutMroCustomerInput = {
  data: MroCommunicationThreadUpdateWithoutMroCustomerInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroCommunicationThreadUpdateWithoutMroOrganizationInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroCommunicationThreadUpdateWithoutMroWorkOrderInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpdateWithoutMroCommunicationMessagesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateWithoutMroCommunicationParticipantsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateWithoutMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateWithoutMroCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpdateWithoutMroWorkOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroCommunicationThreadNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  twilioConversationSid?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCommunicationThreadUpsertWithWhereUniqueWithoutMroCraftInput = {
  create: MroCommunicationThreadCreateWithoutMroCraftInput;
  update: MroCommunicationThreadUpdateWithoutMroCraftInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpsertWithWhereUniqueWithoutMroCustomerInput = {
  create: MroCommunicationThreadCreateWithoutMroCustomerInput;
  update: MroCommunicationThreadUpdateWithoutMroCustomerInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroCommunicationThreadCreateWithoutMroOrganizationInput;
  update: MroCommunicationThreadUpdateWithoutMroOrganizationInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroCommunicationThreadCreateWithoutMroWorkOrderInput;
  update: MroCommunicationThreadUpdateWithoutMroWorkOrderInput;
  where: MroCommunicationThreadWhereUniqueInput;
};

export type MroCommunicationThreadUpsertWithoutMroCommunicationMessagesInput = {
  create: MroCommunicationThreadCreateWithoutMroCommunicationMessagesInput;
  update: MroCommunicationThreadUpdateWithoutMroCommunicationMessagesInput;
  where?: InputMaybe<MroCommunicationThreadWhereInput>;
};

export type MroCommunicationThreadUpsertWithoutMroCommunicationParticipantsInput = {
  create: MroCommunicationThreadCreateWithoutMroCommunicationParticipantsInput;
  update: MroCommunicationThreadUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroCommunicationThreadWhereInput>;
};

export type MroCommunicationThreadWhereInput = {
  AND?: InputMaybe<Array<MroCommunicationThreadWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationThreadWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationThreadWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageListRelationFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  twilioConversationSid?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCommunicationThreadWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCommunicationThreadWhereInput>>;
  NOT?: InputMaybe<Array<MroCommunicationThreadWhereInput>>;
  OR?: InputMaybe<Array<MroCommunicationThreadWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageListRelationFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  twilioConversationSid?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroComponent = {
  __typename?: 'MroComponent';
  _count: MroComponentCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mroCraft?: Maybe<MroCraft>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroLogEntries?: Maybe<Array<MroLogEntry>>;
  mroWorkOrderItemCategories?: Maybe<Array<MroWorkOrderItemCategory>>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroComponentVersion>>;
  year?: Maybe<Scalars['Int']>;
};

export type MroComponentAvgAggregate = {
  __typename?: 'MroComponentAvgAggregate';
  year?: Maybe<Scalars['Float']>;
};

export type MroComponentCount = {
  __typename?: 'MroComponentCount';
  mroLogEntries: Scalars['Int'];
  mroWorkOrderItemCategories: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroComponentCountAggregate = {
  __typename?: 'MroComponentCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  make: Scalars['Int'];
  model: Scalars['Int'];
  mroCraftId: Scalars['Int'];
  name: Scalars['Int'];
  serialNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
  year: Scalars['Int'];
};

export type MroComponentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroComponentsInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroComponentInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroComponentInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionCreateNestedManyWithoutMroComponentInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentCreateManyMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentCreateManyMroCraftInputEnvelope = {
  data: Array<MroComponentCreateManyMroCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroComponentCreateNestedManyWithoutMroCraftInput = {
  connect?: InputMaybe<Array<MroComponentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroComponentCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroComponentCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroComponentCreateManyMroCraftInputEnvelope>;
};

export type MroComponentCreateNestedOneWithoutMroLogEntriesInput = {
  connect?: InputMaybe<MroComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroComponentCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroComponentCreateWithoutMroLogEntriesInput>;
};

export type MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput = {
  connect?: InputMaybe<MroComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroComponentCreateOrConnectWithoutMroWorkOrderItemCategoriesInput>;
  create?: InputMaybe<MroComponentCreateWithoutMroWorkOrderItemCategoriesInput>;
};

export type MroComponentCreateOrConnectWithoutMroCraftInput = {
  create: MroComponentCreateWithoutMroCraftInput;
  where: MroComponentWhereUniqueInput;
};

export type MroComponentCreateOrConnectWithoutMroLogEntriesInput = {
  create: MroComponentCreateWithoutMroLogEntriesInput;
  where: MroComponentWhereUniqueInput;
};

export type MroComponentCreateOrConnectWithoutMroWorkOrderItemCategoriesInput = {
  create: MroComponentCreateWithoutMroWorkOrderItemCategoriesInput;
  where: MroComponentWhereUniqueInput;
};

export type MroComponentCreateWithoutMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroComponentInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroComponentInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionCreateNestedManyWithoutMroComponentInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentCreateWithoutMroLogEntriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroComponentsInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroComponentInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionCreateNestedManyWithoutMroComponentInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentCreateWithoutMroWorkOrderItemCategoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroComponentsInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroComponentInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionCreateNestedManyWithoutMroComponentInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentListRelationFilter = {
  every?: InputMaybe<MroComponentWhereInput>;
  none?: InputMaybe<MroComponentWhereInput>;
  some?: InputMaybe<MroComponentWhereInput>;
};

export type MroComponentMaxAggregate = {
  __typename?: 'MroComponentMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Int']>;
};

export type MroComponentMinAggregate = {
  __typename?: 'MroComponentMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Int']>;
};

export type MroComponentNullableScalarRelationFilter = {
  is?: InputMaybe<MroComponentWhereInput>;
  isNot?: InputMaybe<MroComponentWhereInput>;
};

export type MroComponentScalarWhereInput = {
  AND?: InputMaybe<Array<MroComponentScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroComponentScalarWhereInput>>;
  OR?: InputMaybe<Array<MroComponentScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  year?: InputMaybe<IntNullableFilter>;
};

export type MroComponentSumAggregate = {
  __typename?: 'MroComponentSumAggregate';
  year?: Maybe<Scalars['Int']>;
};

export type MroComponentUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroComponentsNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroComponentNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroComponentNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionUpdateManyWithoutMroComponentNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentUpdateManyWithWhereWithoutMroCraftInput = {
  data: MroComponentUpdateManyMutationInput;
  where: MroComponentScalarWhereInput;
};

export type MroComponentUpdateManyWithoutMroCraftNestedInput = {
  connect?: InputMaybe<Array<MroComponentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroComponentCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroComponentCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroComponentCreateManyMroCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroComponentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroComponentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroComponentWhereUniqueInput>>;
  set?: InputMaybe<Array<MroComponentWhereUniqueInput>>;
  update?: InputMaybe<Array<MroComponentUpdateWithWhereUniqueWithoutMroCraftInput>>;
  updateMany?: InputMaybe<Array<MroComponentUpdateManyWithWhereWithoutMroCraftInput>>;
  upsert?: InputMaybe<Array<MroComponentUpsertWithWhereUniqueWithoutMroCraftInput>>;
};

export type MroComponentUpdateOneWithoutMroLogEntriesNestedInput = {
  connect?: InputMaybe<MroComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroComponentCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroComponentCreateWithoutMroLogEntriesInput>;
  delete?: InputMaybe<MroComponentWhereInput>;
  disconnect?: InputMaybe<MroComponentWhereInput>;
  update?: InputMaybe<MroComponentUpdateToOneWithWhereWithoutMroLogEntriesInput>;
  upsert?: InputMaybe<MroComponentUpsertWithoutMroLogEntriesInput>;
};

export type MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput = {
  connect?: InputMaybe<MroComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroComponentCreateOrConnectWithoutMroWorkOrderItemCategoriesInput>;
  create?: InputMaybe<MroComponentCreateWithoutMroWorkOrderItemCategoriesInput>;
  delete?: InputMaybe<MroComponentWhereInput>;
  disconnect?: InputMaybe<MroComponentWhereInput>;
  update?: InputMaybe<MroComponentUpdateToOneWithWhereWithoutMroWorkOrderItemCategoriesInput>;
  upsert?: InputMaybe<MroComponentUpsertWithoutMroWorkOrderItemCategoriesInput>;
};

export type MroComponentUpdateToOneWithWhereWithoutMroLogEntriesInput = {
  data: MroComponentUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroComponentWhereInput>;
};

export type MroComponentUpdateToOneWithWhereWithoutMroWorkOrderItemCategoriesInput = {
  data: MroComponentUpdateWithoutMroWorkOrderItemCategoriesInput;
  where?: InputMaybe<MroComponentWhereInput>;
};

export type MroComponentUpdateWithWhereUniqueWithoutMroCraftInput = {
  data: MroComponentUpdateWithoutMroCraftInput;
  where: MroComponentWhereUniqueInput;
};

export type MroComponentUpdateWithoutMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroComponentNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroComponentNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionUpdateManyWithoutMroComponentNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentUpdateWithoutMroLogEntriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroComponentsNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroComponentNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionUpdateManyWithoutMroComponentNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentUpdateWithoutMroWorkOrderItemCategoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroComponentsNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroComponentNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroComponentVersionUpdateManyWithoutMroComponentNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroComponentUpsertWithWhereUniqueWithoutMroCraftInput = {
  create: MroComponentCreateWithoutMroCraftInput;
  update: MroComponentUpdateWithoutMroCraftInput;
  where: MroComponentWhereUniqueInput;
};

export type MroComponentUpsertWithoutMroLogEntriesInput = {
  create: MroComponentCreateWithoutMroLogEntriesInput;
  update: MroComponentUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroComponentWhereInput>;
};

export type MroComponentUpsertWithoutMroWorkOrderItemCategoriesInput = {
  create: MroComponentCreateWithoutMroWorkOrderItemCategoriesInput;
  update: MroComponentUpdateWithoutMroWorkOrderItemCategoriesInput;
  where?: InputMaybe<MroComponentWhereInput>;
};

export type MroComponentVersion = {
  __typename?: 'MroComponentVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroComponent?: Maybe<MroComponent>;
  mroComponentId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroComponentVersionCreateManyMroComponentInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroComponentVersionCreateManyMroComponentInputEnvelope = {
  data: Array<MroComponentVersionCreateManyMroComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroComponentVersionCreateNestedManyWithoutMroComponentInput = {
  connect?: InputMaybe<Array<MroComponentVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroComponentVersionCreateOrConnectWithoutMroComponentInput>>;
  create?: InputMaybe<Array<MroComponentVersionCreateWithoutMroComponentInput>>;
  createMany?: InputMaybe<MroComponentVersionCreateManyMroComponentInputEnvelope>;
};

export type MroComponentVersionCreateOrConnectWithoutMroComponentInput = {
  create: MroComponentVersionCreateWithoutMroComponentInput;
  where: MroComponentVersionWhereUniqueInput;
};

export type MroComponentVersionCreateWithoutMroComponentInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroComponentVersionListRelationFilter = {
  every?: InputMaybe<MroComponentVersionWhereInput>;
  none?: InputMaybe<MroComponentVersionWhereInput>;
  some?: InputMaybe<MroComponentVersionWhereInput>;
};

export type MroComponentVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroComponentVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroComponentVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroComponentVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroComponentVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroComponentVersionUpdateManyWithWhereWithoutMroComponentInput = {
  data: MroComponentVersionUpdateManyMutationInput;
  where: MroComponentVersionScalarWhereInput;
};

export type MroComponentVersionUpdateManyWithoutMroComponentNestedInput = {
  connect?: InputMaybe<Array<MroComponentVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroComponentVersionCreateOrConnectWithoutMroComponentInput>>;
  create?: InputMaybe<Array<MroComponentVersionCreateWithoutMroComponentInput>>;
  createMany?: InputMaybe<MroComponentVersionCreateManyMroComponentInputEnvelope>;
  delete?: InputMaybe<Array<MroComponentVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroComponentVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroComponentVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroComponentVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroComponentVersionUpdateWithWhereUniqueWithoutMroComponentInput>>;
  updateMany?: InputMaybe<Array<MroComponentVersionUpdateManyWithWhereWithoutMroComponentInput>>;
  upsert?: InputMaybe<Array<MroComponentVersionUpsertWithWhereUniqueWithoutMroComponentInput>>;
};

export type MroComponentVersionUpdateWithWhereUniqueWithoutMroComponentInput = {
  data: MroComponentVersionUpdateWithoutMroComponentInput;
  where: MroComponentVersionWhereUniqueInput;
};

export type MroComponentVersionUpdateWithoutMroComponentInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroComponentVersionUpsertWithWhereUniqueWithoutMroComponentInput = {
  create: MroComponentVersionCreateWithoutMroComponentInput;
  update: MroComponentVersionUpdateWithoutMroComponentInput;
  where: MroComponentVersionWhereUniqueInput;
};

export type MroComponentVersionWhereInput = {
  AND?: InputMaybe<Array<MroComponentVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroComponentVersionWhereInput>>;
  OR?: InputMaybe<Array<MroComponentVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroComponent?: InputMaybe<MroComponentNullableScalarRelationFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroComponentVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroComponentVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroComponentVersionWhereInput>>;
  OR?: InputMaybe<Array<MroComponentVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroComponent?: InputMaybe<MroComponentNullableScalarRelationFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroComponentWhereInput = {
  AND?: InputMaybe<Array<MroComponentWhereInput>>;
  NOT?: InputMaybe<Array<MroComponentWhereInput>>;
  OR?: InputMaybe<Array<MroComponentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroComponentVersionListRelationFilter>;
  year?: InputMaybe<IntNullableFilter>;
};

export type MroComponentWhereUniqueInput = {
  AND?: InputMaybe<Array<MroComponentWhereInput>>;
  NOT?: InputMaybe<Array<MroComponentWhereInput>>;
  OR?: InputMaybe<Array<MroComponentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroComponentVersionListRelationFilter>;
  year?: InputMaybe<IntNullableFilter>;
};

export type MroContact = {
  __typename?: 'MroContact';
  _count: MroContactCount;
  address?: Maybe<MroAddress>;
  addressId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mroCommunicationDevices?: Maybe<Array<MroCommunicationDevice>>;
  mroCommunicationParticipants?: Maybe<Array<MroCommunicationParticipant>>;
  mroCustomers?: Maybe<Array<MroCustomer>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrders?: Maybe<Array<MroWorkOrder>>;
  phoneNumbers?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroContactVersion>>;
};

export type MroContactCount = {
  __typename?: 'MroContactCount';
  mroCommunicationDevices: Scalars['Int'];
  mroCommunicationParticipants: Scalars['Int'];
  mroCustomers: Scalars['Int'];
  mroWorkOrders: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroContactCountAggregate = {
  __typename?: 'MroContactCountAggregate';
  _all: Scalars['Int'];
  addressId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  lastName: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  phoneNumbers: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroContactCreateManyAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroContactCreateManyAddressInputEnvelope = {
  data: Array<MroContactCreateManyAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroContactCreateManyMroOrganizationInput = {
  addressId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroContactCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroContactCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroContactCreateNestedManyWithoutAddressInput = {
  connect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroContactCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroContactCreateManyAddressInputEnvelope>;
};

export type MroContactCreateNestedManyWithoutMroCustomersInput = {
  connect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactCreateOrConnectWithoutMroCustomersInput>>;
  create?: InputMaybe<Array<MroContactCreateWithoutMroCustomersInput>>;
};

export type MroContactCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroContactCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroContactCreateManyMroOrganizationInputEnvelope>;
};

export type MroContactCreateNestedOneWithoutMroCommunicationDevicesInput = {
  connect?: InputMaybe<MroContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroContactCreateOrConnectWithoutMroCommunicationDevicesInput>;
  create?: InputMaybe<MroContactCreateWithoutMroCommunicationDevicesInput>;
};

export type MroContactCreateNestedOneWithoutMroCommunicationParticipantsInput = {
  connect?: InputMaybe<MroContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroContactCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroContactCreateWithoutMroCommunicationParticipantsInput>;
};

export type MroContactCreateNestedOneWithoutMroWorkOrdersInput = {
  connect?: InputMaybe<MroContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroContactCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroContactCreateWithoutMroWorkOrdersInput>;
};

export type MroContactCreateOrConnectWithoutAddressInput = {
  create: MroContactCreateWithoutAddressInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactCreateOrConnectWithoutMroCommunicationDevicesInput = {
  create: MroContactCreateWithoutMroCommunicationDevicesInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactCreateOrConnectWithoutMroCommunicationParticipantsInput = {
  create: MroContactCreateWithoutMroCommunicationParticipantsInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactCreateOrConnectWithoutMroCustomersInput = {
  create: MroContactCreateWithoutMroCustomersInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactCreateOrConnectWithoutMroOrganizationInput = {
  create: MroContactCreateWithoutMroOrganizationInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactCreateOrConnectWithoutMroWorkOrdersInput = {
  create: MroContactCreateWithoutMroWorkOrdersInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactCreateWithoutAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroContactInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroContactInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroContactsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroContactsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutPrimaryContactInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionCreateNestedManyWithoutMroContactInput>;
};

export type MroContactCreateWithoutMroCommunicationDevicesInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroContactsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroContactInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroContactsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroContactsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutPrimaryContactInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionCreateNestedManyWithoutMroContactInput>;
};

export type MroContactCreateWithoutMroCommunicationParticipantsInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroContactsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroContactInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroContactsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroContactsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutPrimaryContactInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionCreateNestedManyWithoutMroContactInput>;
};

export type MroContactCreateWithoutMroCustomersInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroContactsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroContactInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroContactInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroContactsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutPrimaryContactInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionCreateNestedManyWithoutMroContactInput>;
};

export type MroContactCreateWithoutMroOrganizationInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroContactsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroContactInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroContactInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroContactsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutPrimaryContactInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionCreateNestedManyWithoutMroContactInput>;
};

export type MroContactCreateWithoutMroWorkOrdersInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroContactsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroContactInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroContactInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroContactsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroContactsInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionCreateNestedManyWithoutMroContactInput>;
};

export type MroContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
};

export type MroContactListRelationFilter = {
  every?: InputMaybe<MroContactWhereInput>;
  none?: InputMaybe<MroContactWhereInput>;
  some?: InputMaybe<MroContactWhereInput>;
};

export type MroContactMaxAggregate = {
  __typename?: 'MroContactMaxAggregate';
  addressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroContactMinAggregate = {
  __typename?: 'MroContactMinAggregate';
  addressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroContactNullableScalarRelationFilter = {
  is?: InputMaybe<MroContactWhereInput>;
  isNot?: InputMaybe<MroContactWhereInput>;
};

export type MroContactScalarWhereInput = {
  AND?: InputMaybe<Array<MroContactScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroContactScalarWhereInput>>;
  OR?: InputMaybe<Array<MroContactScalarWhereInput>>;
  addressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroContactUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroContactUpdateManyWithWhereWithoutAddressInput = {
  data: MroContactUpdateManyMutationInput;
  where: MroContactScalarWhereInput;
};

export type MroContactUpdateManyWithWhereWithoutMroCustomersInput = {
  data: MroContactUpdateManyMutationInput;
  where: MroContactScalarWhereInput;
};

export type MroContactUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroContactUpdateManyMutationInput;
  where: MroContactScalarWhereInput;
};

export type MroContactUpdateManyWithoutAddressNestedInput = {
  connect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroContactCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroContactCreateManyAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroContactScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  set?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  update?: InputMaybe<Array<MroContactUpdateWithWhereUniqueWithoutAddressInput>>;
  updateMany?: InputMaybe<Array<MroContactUpdateManyWithWhereWithoutAddressInput>>;
  upsert?: InputMaybe<Array<MroContactUpsertWithWhereUniqueWithoutAddressInput>>;
};

export type MroContactUpdateManyWithoutMroCustomersNestedInput = {
  connect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactCreateOrConnectWithoutMroCustomersInput>>;
  create?: InputMaybe<Array<MroContactCreateWithoutMroCustomersInput>>;
  delete?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroContactScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  set?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  update?: InputMaybe<Array<MroContactUpdateWithWhereUniqueWithoutMroCustomersInput>>;
  updateMany?: InputMaybe<Array<MroContactUpdateManyWithWhereWithoutMroCustomersInput>>;
  upsert?: InputMaybe<Array<MroContactUpsertWithWhereUniqueWithoutMroCustomersInput>>;
};

export type MroContactUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroContactCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroContactCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroContactScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  set?: InputMaybe<Array<MroContactWhereUniqueInput>>;
  update?: InputMaybe<Array<MroContactUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroContactUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroContactUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroContactUpdateOneWithoutMroCommunicationDevicesNestedInput = {
  connect?: InputMaybe<MroContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroContactCreateOrConnectWithoutMroCommunicationDevicesInput>;
  create?: InputMaybe<MroContactCreateWithoutMroCommunicationDevicesInput>;
  delete?: InputMaybe<MroContactWhereInput>;
  disconnect?: InputMaybe<MroContactWhereInput>;
  update?: InputMaybe<MroContactUpdateToOneWithWhereWithoutMroCommunicationDevicesInput>;
  upsert?: InputMaybe<MroContactUpsertWithoutMroCommunicationDevicesInput>;
};

export type MroContactUpdateOneWithoutMroCommunicationParticipantsNestedInput = {
  connect?: InputMaybe<MroContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroContactCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroContactCreateWithoutMroCommunicationParticipantsInput>;
  delete?: InputMaybe<MroContactWhereInput>;
  disconnect?: InputMaybe<MroContactWhereInput>;
  update?: InputMaybe<MroContactUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput>;
  upsert?: InputMaybe<MroContactUpsertWithoutMroCommunicationParticipantsInput>;
};

export type MroContactUpdateOneWithoutMroWorkOrdersNestedInput = {
  connect?: InputMaybe<MroContactWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroContactCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroContactCreateWithoutMroWorkOrdersInput>;
  delete?: InputMaybe<MroContactWhereInput>;
  disconnect?: InputMaybe<MroContactWhereInput>;
  update?: InputMaybe<MroContactUpdateToOneWithWhereWithoutMroWorkOrdersInput>;
  upsert?: InputMaybe<MroContactUpsertWithoutMroWorkOrdersInput>;
};

export type MroContactUpdateToOneWithWhereWithoutMroCommunicationDevicesInput = {
  data: MroContactUpdateWithoutMroCommunicationDevicesInput;
  where?: InputMaybe<MroContactWhereInput>;
};

export type MroContactUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput = {
  data: MroContactUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroContactWhereInput>;
};

export type MroContactUpdateToOneWithWhereWithoutMroWorkOrdersInput = {
  data: MroContactUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroContactWhereInput>;
};

export type MroContactUpdateWithWhereUniqueWithoutAddressInput = {
  data: MroContactUpdateWithoutAddressInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactUpdateWithWhereUniqueWithoutMroCustomersInput = {
  data: MroContactUpdateWithoutMroCustomersInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroContactUpdateWithoutMroOrganizationInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactUpdateWithoutAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroContactNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroContactNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroContactsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroContactsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutPrimaryContactNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionUpdateManyWithoutMroContactNestedInput>;
};

export type MroContactUpdateWithoutMroCommunicationDevicesInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroContactsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroContactNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroContactsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroContactsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutPrimaryContactNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionUpdateManyWithoutMroContactNestedInput>;
};

export type MroContactUpdateWithoutMroCommunicationParticipantsInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroContactsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroContactNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroContactsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroContactsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutPrimaryContactNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionUpdateManyWithoutMroContactNestedInput>;
};

export type MroContactUpdateWithoutMroCustomersInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroContactsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroContactNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroContactNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroContactsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutPrimaryContactNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionUpdateManyWithoutMroContactNestedInput>;
};

export type MroContactUpdateWithoutMroOrganizationInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroContactsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroContactNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroContactNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroContactsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutPrimaryContactNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionUpdateManyWithoutMroContactNestedInput>;
};

export type MroContactUpdateWithoutMroWorkOrdersInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroContactsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroContactNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroContactNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroContactsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroContactsNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroContactVersionUpdateManyWithoutMroContactNestedInput>;
};

export type MroContactUpsertWithWhereUniqueWithoutAddressInput = {
  create: MroContactCreateWithoutAddressInput;
  update: MroContactUpdateWithoutAddressInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactUpsertWithWhereUniqueWithoutMroCustomersInput = {
  create: MroContactCreateWithoutMroCustomersInput;
  update: MroContactUpdateWithoutMroCustomersInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroContactCreateWithoutMroOrganizationInput;
  update: MroContactUpdateWithoutMroOrganizationInput;
  where: MroContactWhereUniqueInput;
};

export type MroContactUpsertWithoutMroCommunicationDevicesInput = {
  create: MroContactCreateWithoutMroCommunicationDevicesInput;
  update: MroContactUpdateWithoutMroCommunicationDevicesInput;
  where?: InputMaybe<MroContactWhereInput>;
};

export type MroContactUpsertWithoutMroCommunicationParticipantsInput = {
  create: MroContactCreateWithoutMroCommunicationParticipantsInput;
  update: MroContactUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroContactWhereInput>;
};

export type MroContactUpsertWithoutMroWorkOrdersInput = {
  create: MroContactCreateWithoutMroWorkOrdersInput;
  update: MroContactUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroContactWhereInput>;
};

export type MroContactVersion = {
  __typename?: 'MroContactVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroContact?: Maybe<MroContact>;
  mroContactId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroContactVersionCreateManyMroContactInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroContactVersionCreateManyMroContactInputEnvelope = {
  data: Array<MroContactVersionCreateManyMroContactInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroContactVersionCreateNestedManyWithoutMroContactInput = {
  connect?: InputMaybe<Array<MroContactVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactVersionCreateOrConnectWithoutMroContactInput>>;
  create?: InputMaybe<Array<MroContactVersionCreateWithoutMroContactInput>>;
  createMany?: InputMaybe<MroContactVersionCreateManyMroContactInputEnvelope>;
};

export type MroContactVersionCreateOrConnectWithoutMroContactInput = {
  create: MroContactVersionCreateWithoutMroContactInput;
  where: MroContactVersionWhereUniqueInput;
};

export type MroContactVersionCreateWithoutMroContactInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroContactVersionListRelationFilter = {
  every?: InputMaybe<MroContactVersionWhereInput>;
  none?: InputMaybe<MroContactVersionWhereInput>;
  some?: InputMaybe<MroContactVersionWhereInput>;
};

export type MroContactVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroContactVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroContactVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroContactVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroContactVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroContactVersionUpdateManyWithWhereWithoutMroContactInput = {
  data: MroContactVersionUpdateManyMutationInput;
  where: MroContactVersionScalarWhereInput;
};

export type MroContactVersionUpdateManyWithoutMroContactNestedInput = {
  connect?: InputMaybe<Array<MroContactVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroContactVersionCreateOrConnectWithoutMroContactInput>>;
  create?: InputMaybe<Array<MroContactVersionCreateWithoutMroContactInput>>;
  createMany?: InputMaybe<MroContactVersionCreateManyMroContactInputEnvelope>;
  delete?: InputMaybe<Array<MroContactVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroContactVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroContactVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroContactVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroContactVersionUpdateWithWhereUniqueWithoutMroContactInput>>;
  updateMany?: InputMaybe<Array<MroContactVersionUpdateManyWithWhereWithoutMroContactInput>>;
  upsert?: InputMaybe<Array<MroContactVersionUpsertWithWhereUniqueWithoutMroContactInput>>;
};

export type MroContactVersionUpdateWithWhereUniqueWithoutMroContactInput = {
  data: MroContactVersionUpdateWithoutMroContactInput;
  where: MroContactVersionWhereUniqueInput;
};

export type MroContactVersionUpdateWithoutMroContactInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroContactVersionUpsertWithWhereUniqueWithoutMroContactInput = {
  create: MroContactVersionCreateWithoutMroContactInput;
  update: MroContactVersionUpdateWithoutMroContactInput;
  where: MroContactVersionWhereUniqueInput;
};

export type MroContactVersionWhereInput = {
  AND?: InputMaybe<Array<MroContactVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroContactVersionWhereInput>>;
  OR?: InputMaybe<Array<MroContactVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroContactVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroContactVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroContactVersionWhereInput>>;
  OR?: InputMaybe<Array<MroContactVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  mroContactId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroContactWhereInput = {
  AND?: InputMaybe<Array<MroContactWhereInput>>;
  NOT?: InputMaybe<Array<MroContactWhereInput>>;
  OR?: InputMaybe<Array<MroContactWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceListRelationFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroContactVersionListRelationFilter>;
};

export type MroContactWhereUniqueInput = {
  AND?: InputMaybe<Array<MroContactWhereInput>>;
  NOT?: InputMaybe<Array<MroContactWhereInput>>;
  OR?: InputMaybe<Array<MroContactWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<StringFilter>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceListRelationFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroContactVersionListRelationFilter>;
};

export type MroCraft = {
  __typename?: 'MroCraft';
  _count: MroCraftCount;
  address?: Maybe<MroAddress>;
  addressId?: Maybe<Scalars['String']>;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  engineCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: Maybe<Array<MroCommunicationThread>>;
  mroComponents?: Maybe<Array<MroComponent>>;
  mroCustomer?: Maybe<MroCustomer>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroIssue: Array<MroIssue>;
  mroIssues?: Maybe<Array<MroIssue>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroServiceRequest: Array<MroServiceRequest>;
  mroServiceRequests?: Maybe<Array<MroServiceRequest>>;
  mroWorkOrder: Array<MroWorkOrder>;
  mroWorkOrders?: Maybe<Array<MroWorkOrder>>;
  ownerName?: Maybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroCraftVersion>>;
  year: Scalars['Int'];
};

export type MroCraftAvgAggregate = {
  __typename?: 'MroCraftAvgAggregate';
  engineCount?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type MroCraftCount = {
  __typename?: 'MroCraftCount';
  mroCommunicationThreads: Scalars['Int'];
  mroComponents: Scalars['Int'];
  mroIssues: Scalars['Int'];
  mroServiceRequests: Scalars['Int'];
  mroWorkOrders: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroCraftCountAggregate = {
  __typename?: 'MroCraftCountAggregate';
  _all: Scalars['Int'];
  addressId: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  engineCount: Scalars['Int'];
  id: Scalars['Int'];
  make: Scalars['Int'];
  model: Scalars['Int'];
  mroCustomerId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  ownerName: Scalars['Int'];
  tailNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
  year: Scalars['Int'];
};

export type MroCraftCreateInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateManyAddressInput = {
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year: Scalars['Int'];
};

export type MroCraftCreateManyAddressInputEnvelope = {
  data: Array<MroCraftCreateManyAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCraftCreateManyCraftInput = {
  addressId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year: Scalars['Int'];
};

export type MroCraftCreateManyCraftInputEnvelope = {
  data: Array<MroCraftCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCraftCreateManyMroCustomerInput = {
  addressId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year: Scalars['Int'];
};

export type MroCraftCreateManyMroCustomerInputEnvelope = {
  data: Array<MroCraftCreateManyMroCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCraftCreateManyMroOrganizationInput = {
  addressId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCustomerId?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year: Scalars['Int'];
};

export type MroCraftCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroCraftCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCraftCreateNestedManyWithoutAddressInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroCraftCreateManyAddressInputEnvelope>;
};

export type MroCraftCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutCraftInput>>;
  createMany?: InputMaybe<MroCraftCreateManyCraftInputEnvelope>;
};

export type MroCraftCreateNestedManyWithoutMroCustomerInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroCraftCreateManyMroCustomerInputEnvelope>;
};

export type MroCraftCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCraftCreateManyMroOrganizationInputEnvelope>;
};

export type MroCraftCreateNestedOneWithoutMroCommunicationThreadsInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroCommunicationThreadsInput>;
};

export type MroCraftCreateNestedOneWithoutMroComponentsInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroComponentsInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroComponentsInput>;
};

export type MroCraftCreateNestedOneWithoutMroIssuesInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroIssuesInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroIssuesInput>;
};

export type MroCraftCreateNestedOneWithoutMroServiceRequestsInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroServiceRequestsInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroServiceRequestsInput>;
};

export type MroCraftCreateNestedOneWithoutMroWorkOrdersInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroWorkOrdersInput>;
};

export type MroCraftCreateOrConnectWithoutAddressInput = {
  create: MroCraftCreateWithoutAddressInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutCraftInput = {
  create: MroCraftCreateWithoutCraftInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroCommunicationThreadsInput = {
  create: MroCraftCreateWithoutMroCommunicationThreadsInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroComponentsInput = {
  create: MroCraftCreateWithoutMroComponentsInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroCustomerInput = {
  create: MroCraftCreateWithoutMroCustomerInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroIssuesInput = {
  create: MroCraftCreateWithoutMroIssuesInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroOrganizationInput = {
  create: MroCraftCreateWithoutMroOrganizationInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroServiceRequestsInput = {
  create: MroCraftCreateWithoutMroServiceRequestsInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateOrConnectWithoutMroWorkOrdersInput = {
  create: MroCraftCreateWithoutMroWorkOrdersInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftCreateWithoutAddressInput = {
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutCraftInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroCommunicationThreadsInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroComponentsInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroCustomerInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroIssuesInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroOrganizationInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroServiceRequestsInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftCreateWithoutMroWorkOrdersInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroCraftsInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutMroCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make: Scalars['String'];
  model: Scalars['String'];
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCraftInput>;
  mroComponents?: InputMaybe<MroComponentCreateNestedManyWithoutMroCraftInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroCraftsInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroCraftInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCraftsInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCraftInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionCreateNestedManyWithoutMroCraftInput>;
  year: Scalars['Int'];
};

export type MroCraftInput = {
  address: AddressInput;
  make: Scalars['String'];
  model: Scalars['String'];
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber: Scalars['String'];
  year: Scalars['Int'];
};

export type MroCraftListRelationFilter = {
  every?: InputMaybe<MroCraftWhereInput>;
  none?: InputMaybe<MroCraftWhereInput>;
  some?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftMaxAggregate = {
  __typename?: 'MroCraftMaxAggregate';
  addressId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  engineCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  tailNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Int']>;
};

export type MroCraftMinAggregate = {
  __typename?: 'MroCraftMinAggregate';
  addressId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  engineCount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  tailNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  year?: Maybe<Scalars['Int']>;
};

export type MroCraftMroOrganizationIdCraftIdCompoundUniqueInput = {
  craftId: Scalars['String'];
  mroOrganizationId: Scalars['String'];
};

export type MroCraftNullableScalarRelationFilter = {
  is?: InputMaybe<MroCraftWhereInput>;
  isNot?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MroCraftScalarWhereInput = {
  AND?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  addressId?: InputMaybe<StringNullableFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  engineCount?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  make?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  ownerName?: InputMaybe<StringNullableFilter>;
  tailNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  year?: InputMaybe<IntFilter>;
};

export type MroCraftSumAggregate = {
  __typename?: 'MroCraftSumAggregate';
  engineCount?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type MroCraftUpdateInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateManyWithWhereWithoutAddressInput = {
  data: MroCraftUpdateManyMutationInput;
  where: MroCraftScalarWhereInput;
};

export type MroCraftUpdateManyWithWhereWithoutCraftInput = {
  data: MroCraftUpdateManyMutationInput;
  where: MroCraftScalarWhereInput;
};

export type MroCraftUpdateManyWithWhereWithoutMroCustomerInput = {
  data: MroCraftUpdateManyMutationInput;
  where: MroCraftScalarWhereInput;
};

export type MroCraftUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroCraftUpdateManyMutationInput;
  where: MroCraftScalarWhereInput;
};

export type MroCraftUpdateManyWithoutAddressNestedInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroCraftCreateManyAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCraftUpdateWithWhereUniqueWithoutAddressInput>>;
  updateMany?: InputMaybe<Array<MroCraftUpdateManyWithWhereWithoutAddressInput>>;
  upsert?: InputMaybe<Array<MroCraftUpsertWithWhereUniqueWithoutAddressInput>>;
};

export type MroCraftUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutCraftInput>>;
  createMany?: InputMaybe<MroCraftCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCraftUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<MroCraftUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<MroCraftUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type MroCraftUpdateManyWithoutMroCustomerNestedInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroCraftCreateManyMroCustomerInputEnvelope>;
  delete?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCraftUpdateWithWhereUniqueWithoutMroCustomerInput>>;
  updateMany?: InputMaybe<Array<MroCraftUpdateManyWithWhereWithoutMroCustomerInput>>;
  upsert?: InputMaybe<Array<MroCraftUpsertWithWhereUniqueWithoutMroCustomerInput>>;
};

export type MroCraftUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCraftCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCraftCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCraftScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCraftWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCraftUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCraftUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCraftUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroCraftUpdateOneWithoutMroCommunicationThreadsNestedInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroCommunicationThreadsInput>;
  delete?: InputMaybe<MroCraftWhereInput>;
  disconnect?: InputMaybe<MroCraftWhereInput>;
  update?: InputMaybe<MroCraftUpdateToOneWithWhereWithoutMroCommunicationThreadsInput>;
  upsert?: InputMaybe<MroCraftUpsertWithoutMroCommunicationThreadsInput>;
};

export type MroCraftUpdateOneWithoutMroComponentsNestedInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroComponentsInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroComponentsInput>;
  delete?: InputMaybe<MroCraftWhereInput>;
  disconnect?: InputMaybe<MroCraftWhereInput>;
  update?: InputMaybe<MroCraftUpdateToOneWithWhereWithoutMroComponentsInput>;
  upsert?: InputMaybe<MroCraftUpsertWithoutMroComponentsInput>;
};

export type MroCraftUpdateOneWithoutMroIssuesNestedInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroIssuesInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroIssuesInput>;
  delete?: InputMaybe<MroCraftWhereInput>;
  disconnect?: InputMaybe<MroCraftWhereInput>;
  update?: InputMaybe<MroCraftUpdateToOneWithWhereWithoutMroIssuesInput>;
  upsert?: InputMaybe<MroCraftUpsertWithoutMroIssuesInput>;
};

export type MroCraftUpdateOneWithoutMroServiceRequestsNestedInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroServiceRequestsInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroServiceRequestsInput>;
  delete?: InputMaybe<MroCraftWhereInput>;
  disconnect?: InputMaybe<MroCraftWhereInput>;
  update?: InputMaybe<MroCraftUpdateToOneWithWhereWithoutMroServiceRequestsInput>;
  upsert?: InputMaybe<MroCraftUpsertWithoutMroServiceRequestsInput>;
};

export type MroCraftUpdateOneWithoutMroWorkOrdersNestedInput = {
  connect?: InputMaybe<MroCraftWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCraftCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroCraftCreateWithoutMroWorkOrdersInput>;
  delete?: InputMaybe<MroCraftWhereInput>;
  disconnect?: InputMaybe<MroCraftWhereInput>;
  update?: InputMaybe<MroCraftUpdateToOneWithWhereWithoutMroWorkOrdersInput>;
  upsert?: InputMaybe<MroCraftUpsertWithoutMroWorkOrdersInput>;
};

export type MroCraftUpdateToOneWithWhereWithoutMroCommunicationThreadsInput = {
  data: MroCraftUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpdateToOneWithWhereWithoutMroComponentsInput = {
  data: MroCraftUpdateWithoutMroComponentsInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpdateToOneWithWhereWithoutMroIssuesInput = {
  data: MroCraftUpdateWithoutMroIssuesInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpdateToOneWithWhereWithoutMroServiceRequestsInput = {
  data: MroCraftUpdateWithoutMroServiceRequestsInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpdateToOneWithWhereWithoutMroWorkOrdersInput = {
  data: MroCraftUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpdateWithWhereUniqueWithoutAddressInput = {
  data: MroCraftUpdateWithoutAddressInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpdateWithWhereUniqueWithoutCraftInput = {
  data: MroCraftUpdateWithoutCraftInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpdateWithWhereUniqueWithoutMroCustomerInput = {
  data: MroCraftUpdateWithoutMroCustomerInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroCraftUpdateWithoutMroOrganizationInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpdateWithoutAddressInput = {
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutCraftInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroCommunicationThreadsInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroComponentsInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroCustomerInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroIssuesInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroOrganizationInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroServiceRequestsInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpdateWithoutMroWorkOrdersInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroCraftsNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutMroCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  engineCount?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCraftNestedInput>;
  mroComponents?: InputMaybe<MroComponentUpdateManyWithoutMroCraftNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroCraftsNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroCraftNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCraftsNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCraftNestedInput>;
  ownerName?: InputMaybe<Scalars['String']>;
  tailNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCraftVersionUpdateManyWithoutMroCraftNestedInput>;
  year?: InputMaybe<Scalars['Int']>;
};

export type MroCraftUpsertWithWhereUniqueWithoutAddressInput = {
  create: MroCraftCreateWithoutAddressInput;
  update: MroCraftUpdateWithoutAddressInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpsertWithWhereUniqueWithoutCraftInput = {
  create: MroCraftCreateWithoutCraftInput;
  update: MroCraftUpdateWithoutCraftInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpsertWithWhereUniqueWithoutMroCustomerInput = {
  create: MroCraftCreateWithoutMroCustomerInput;
  update: MroCraftUpdateWithoutMroCustomerInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroCraftCreateWithoutMroOrganizationInput;
  update: MroCraftUpdateWithoutMroOrganizationInput;
  where: MroCraftWhereUniqueInput;
};

export type MroCraftUpsertWithoutMroCommunicationThreadsInput = {
  create: MroCraftCreateWithoutMroCommunicationThreadsInput;
  update: MroCraftUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpsertWithoutMroComponentsInput = {
  create: MroCraftCreateWithoutMroComponentsInput;
  update: MroCraftUpdateWithoutMroComponentsInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpsertWithoutMroIssuesInput = {
  create: MroCraftCreateWithoutMroIssuesInput;
  update: MroCraftUpdateWithoutMroIssuesInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpsertWithoutMroServiceRequestsInput = {
  create: MroCraftCreateWithoutMroServiceRequestsInput;
  update: MroCraftUpdateWithoutMroServiceRequestsInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftUpsertWithoutMroWorkOrdersInput = {
  create: MroCraftCreateWithoutMroWorkOrdersInput;
  update: MroCraftUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroCraftWhereInput>;
};

export type MroCraftVersion = {
  __typename?: 'MroCraftVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroCraft?: Maybe<MroCraft>;
  mroCraftId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroCraftVersionCreateManyMroCraftInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCraftVersionCreateManyMroCraftInputEnvelope = {
  data: Array<MroCraftVersionCreateManyMroCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCraftVersionCreateNestedManyWithoutMroCraftInput = {
  connect?: InputMaybe<Array<MroCraftVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftVersionCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroCraftVersionCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroCraftVersionCreateManyMroCraftInputEnvelope>;
};

export type MroCraftVersionCreateOrConnectWithoutMroCraftInput = {
  create: MroCraftVersionCreateWithoutMroCraftInput;
  where: MroCraftVersionWhereUniqueInput;
};

export type MroCraftVersionCreateWithoutMroCraftInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCraftVersionListRelationFilter = {
  every?: InputMaybe<MroCraftVersionWhereInput>;
  none?: InputMaybe<MroCraftVersionWhereInput>;
  some?: InputMaybe<MroCraftVersionWhereInput>;
};

export type MroCraftVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroCraftVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCraftVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCraftVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroCraftVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCraftVersionUpdateManyWithWhereWithoutMroCraftInput = {
  data: MroCraftVersionUpdateManyMutationInput;
  where: MroCraftVersionScalarWhereInput;
};

export type MroCraftVersionUpdateManyWithoutMroCraftNestedInput = {
  connect?: InputMaybe<Array<MroCraftVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCraftVersionCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroCraftVersionCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroCraftVersionCreateManyMroCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroCraftVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCraftVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCraftVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCraftVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCraftVersionUpdateWithWhereUniqueWithoutMroCraftInput>>;
  updateMany?: InputMaybe<Array<MroCraftVersionUpdateManyWithWhereWithoutMroCraftInput>>;
  upsert?: InputMaybe<Array<MroCraftVersionUpsertWithWhereUniqueWithoutMroCraftInput>>;
};

export type MroCraftVersionUpdateWithWhereUniqueWithoutMroCraftInput = {
  data: MroCraftVersionUpdateWithoutMroCraftInput;
  where: MroCraftVersionWhereUniqueInput;
};

export type MroCraftVersionUpdateWithoutMroCraftInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCraftVersionUpsertWithWhereUniqueWithoutMroCraftInput = {
  create: MroCraftVersionCreateWithoutMroCraftInput;
  update: MroCraftVersionUpdateWithoutMroCraftInput;
  where: MroCraftVersionWhereUniqueInput;
};

export type MroCraftVersionWhereInput = {
  AND?: InputMaybe<Array<MroCraftVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroCraftVersionWhereInput>>;
  OR?: InputMaybe<Array<MroCraftVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroCraftVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCraftVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroCraftVersionWhereInput>>;
  OR?: InputMaybe<Array<MroCraftVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroCraftWhereInput = {
  AND?: InputMaybe<Array<MroCraftWhereInput>>;
  NOT?: InputMaybe<Array<MroCraftWhereInput>>;
  OR?: InputMaybe<Array<MroCraftWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  engineCount?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  make?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroComponents?: InputMaybe<MroComponentListRelationFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroIssues?: InputMaybe<MroIssueListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequests?: InputMaybe<MroServiceRequestListRelationFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  ownerName?: InputMaybe<StringNullableFilter>;
  tailNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroCraftVersionListRelationFilter>;
  year?: InputMaybe<IntFilter>;
};

export type MroCraftWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCraftWhereInput>>;
  NOT?: InputMaybe<Array<MroCraftWhereInput>>;
  OR?: InputMaybe<Array<MroCraftWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  engineCount?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<StringFilter>;
  model?: InputMaybe<StringFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroComponents?: InputMaybe<MroComponentListRelationFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroIssues?: InputMaybe<MroIssueListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId_craftId?: InputMaybe<MroCraftMroOrganizationIdCraftIdCompoundUniqueInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestListRelationFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  ownerName?: InputMaybe<StringNullableFilter>;
  tailNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroCraftVersionListRelationFilter>;
  year?: InputMaybe<IntFilter>;
};

export type MroCustomer = {
  __typename?: 'MroCustomer';
  _count: MroCustomerCount;
  billingAddress?: Maybe<MroAddress>;
  billingAddressId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mroAddresses?: Maybe<Array<MroAddress>>;
  mroCommunicationThreads?: Maybe<Array<MroCommunicationThread>>;
  mroContacts?: Maybe<Array<MroContact>>;
  mroCraft: Array<MroCraft>;
  mroCrafts?: Maybe<Array<MroCraft>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroServiceRequests?: Maybe<Array<MroServiceRequest>>;
  mroWorkOrders?: Maybe<Array<MroWorkOrder>>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  organizations: Array<Organization>;
  phoneNumbers?: Maybe<Scalars['JSON']>;
  primaryAddress?: Maybe<MroAddress>;
  shippingAddress?: Maybe<MroAddress>;
  shippingAddressId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroCustomerVersion>>;
};

export type MroCustomerCount = {
  __typename?: 'MroCustomerCount';
  mroAddresses: Scalars['Int'];
  mroCommunicationThreads: Scalars['Int'];
  mroContacts: Scalars['Int'];
  mroCrafts: Scalars['Int'];
  mroServiceRequests: Scalars['Int'];
  mroWorkOrders: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroCustomerCountAggregate = {
  __typename?: 'MroCustomerCountAggregate';
  _all: Scalars['Int'];
  billingAddressId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  name: Scalars['Int'];
  organizationId: Scalars['Int'];
  phoneNumbers: Scalars['Int'];
  shippingAddressId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroCustomerCreateInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateManyBillingAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddressId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCustomerCreateManyBillingAddressInputEnvelope = {
  data: Array<MroCustomerCreateManyBillingAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCustomerCreateManyMroOrganizationInput = {
  billingAddressId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddressId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCustomerCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroCustomerCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCustomerCreateManyOrganizationInput = {
  billingAddressId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddressId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCustomerCreateManyOrganizationInputEnvelope = {
  data: Array<MroCustomerCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCustomerCreateManyShippingAddressInput = {
  billingAddressId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organizationId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCustomerCreateManyShippingAddressInputEnvelope = {
  data: Array<MroCustomerCreateManyShippingAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCustomerCreateNestedManyWithoutBillingAddressInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutBillingAddressInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutBillingAddressInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyBillingAddressInputEnvelope>;
};

export type MroCustomerCreateNestedManyWithoutMroAddressesInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutMroAddressesInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutMroAddressesInput>>;
};

export type MroCustomerCreateNestedManyWithoutMroContactsInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutMroContactsInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutMroContactsInput>>;
};

export type MroCustomerCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyMroOrganizationInputEnvelope>;
};

export type MroCustomerCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyOrganizationInputEnvelope>;
};

export type MroCustomerCreateNestedManyWithoutShippingAddressInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutShippingAddressInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutShippingAddressInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyShippingAddressInputEnvelope>;
};

export type MroCustomerCreateNestedOneWithoutMroCommunicationThreadsInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroCommunicationThreadsInput>;
};

export type MroCustomerCreateNestedOneWithoutMroCraftsInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroCraftsInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroCraftsInput>;
};

export type MroCustomerCreateNestedOneWithoutMroServiceRequestsInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroServiceRequestsInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroServiceRequestsInput>;
};

export type MroCustomerCreateNestedOneWithoutMroWorkOrdersInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroWorkOrdersInput>;
};

export type MroCustomerCreateOrConnectWithoutBillingAddressInput = {
  create: MroCustomerCreateWithoutBillingAddressInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroAddressesInput = {
  create: MroCustomerCreateWithoutMroAddressesInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroCommunicationThreadsInput = {
  create: MroCustomerCreateWithoutMroCommunicationThreadsInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroContactsInput = {
  create: MroCustomerCreateWithoutMroContactsInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroCraftsInput = {
  create: MroCustomerCreateWithoutMroCraftsInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroOrganizationInput = {
  create: MroCustomerCreateWithoutMroOrganizationInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroServiceRequestsInput = {
  create: MroCustomerCreateWithoutMroServiceRequestsInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutMroWorkOrdersInput = {
  create: MroCustomerCreateWithoutMroWorkOrdersInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutOrganizationInput = {
  create: MroCustomerCreateWithoutOrganizationInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateOrConnectWithoutShippingAddressInput = {
  create: MroCustomerCreateWithoutShippingAddressInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerCreateWithoutBillingAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroAddressesInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroCommunicationThreadsInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroContactsInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroCraftsInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroOrganizationInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroServiceRequestsInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutMroWorkOrdersInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutOrganizationInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutShippingCustomersInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerCreateWithoutShippingAddressInput = {
  billingAddress?: InputMaybe<MroAddressCreateNestedOneWithoutBillingCustomersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroCustomersInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroCustomerInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroCustomersInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroCustomerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroCustomersInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroCustomerInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroCustomerInput>;
  name: Scalars['String'];
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutMroCustomersInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionCreateNestedManyWithoutMroCustomerInput>;
};

export type MroCustomerInput = {
  address: AddressInput;
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
};

export type MroCustomerListRelationFilter = {
  every?: InputMaybe<MroCustomerWhereInput>;
  none?: InputMaybe<MroCustomerWhereInput>;
  some?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerMaxAggregate = {
  __typename?: 'MroCustomerMaxAggregate';
  billingAddressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  shippingAddressId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCustomerMinAggregate = {
  __typename?: 'MroCustomerMinAggregate';
  billingAddressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  shippingAddressId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroCustomerNullableScalarRelationFilter = {
  is?: InputMaybe<MroCustomerWhereInput>;
  isNot?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MroCustomerScalarWhereInput = {
  AND?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  billingAddressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  shippingAddressId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroCustomerUpdateInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroCustomerUpdateManyWithWhereWithoutBillingAddressInput = {
  data: MroCustomerUpdateManyMutationInput;
  where: MroCustomerScalarWhereInput;
};

export type MroCustomerUpdateManyWithWhereWithoutMroAddressesInput = {
  data: MroCustomerUpdateManyMutationInput;
  where: MroCustomerScalarWhereInput;
};

export type MroCustomerUpdateManyWithWhereWithoutMroContactsInput = {
  data: MroCustomerUpdateManyMutationInput;
  where: MroCustomerScalarWhereInput;
};

export type MroCustomerUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroCustomerUpdateManyMutationInput;
  where: MroCustomerScalarWhereInput;
};

export type MroCustomerUpdateManyWithWhereWithoutOrganizationInput = {
  data: MroCustomerUpdateManyMutationInput;
  where: MroCustomerScalarWhereInput;
};

export type MroCustomerUpdateManyWithWhereWithoutShippingAddressInput = {
  data: MroCustomerUpdateManyMutationInput;
  where: MroCustomerScalarWhereInput;
};

export type MroCustomerUpdateManyWithoutBillingAddressNestedInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutBillingAddressInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutBillingAddressInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyBillingAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerUpdateWithWhereUniqueWithoutBillingAddressInput>>;
  updateMany?: InputMaybe<Array<MroCustomerUpdateManyWithWhereWithoutBillingAddressInput>>;
  upsert?: InputMaybe<Array<MroCustomerUpsertWithWhereUniqueWithoutBillingAddressInput>>;
};

export type MroCustomerUpdateManyWithoutMroAddressesNestedInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutMroAddressesInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutMroAddressesInput>>;
  delete?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerUpdateWithWhereUniqueWithoutMroAddressesInput>>;
  updateMany?: InputMaybe<Array<MroCustomerUpdateManyWithWhereWithoutMroAddressesInput>>;
  upsert?: InputMaybe<Array<MroCustomerUpsertWithWhereUniqueWithoutMroAddressesInput>>;
};

export type MroCustomerUpdateManyWithoutMroContactsNestedInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutMroContactsInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutMroContactsInput>>;
  delete?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerUpdateWithWhereUniqueWithoutMroContactsInput>>;
  updateMany?: InputMaybe<Array<MroCustomerUpdateManyWithWhereWithoutMroContactsInput>>;
  upsert?: InputMaybe<Array<MroCustomerUpsertWithWhereUniqueWithoutMroContactsInput>>;
};

export type MroCustomerUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCustomerUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCustomerUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroCustomerUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroCustomerUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<MroCustomerUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type MroCustomerUpdateManyWithoutShippingAddressNestedInput = {
  connect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerCreateOrConnectWithoutShippingAddressInput>>;
  create?: InputMaybe<Array<MroCustomerCreateWithoutShippingAddressInput>>;
  createMany?: InputMaybe<MroCustomerCreateManyShippingAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerUpdateWithWhereUniqueWithoutShippingAddressInput>>;
  updateMany?: InputMaybe<Array<MroCustomerUpdateManyWithWhereWithoutShippingAddressInput>>;
  upsert?: InputMaybe<Array<MroCustomerUpsertWithWhereUniqueWithoutShippingAddressInput>>;
};

export type MroCustomerUpdateOneWithoutMroCommunicationThreadsNestedInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroCommunicationThreadsInput>;
  delete?: InputMaybe<MroCustomerWhereInput>;
  disconnect?: InputMaybe<MroCustomerWhereInput>;
  update?: InputMaybe<MroCustomerUpdateToOneWithWhereWithoutMroCommunicationThreadsInput>;
  upsert?: InputMaybe<MroCustomerUpsertWithoutMroCommunicationThreadsInput>;
};

export type MroCustomerUpdateOneWithoutMroCraftsNestedInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroCraftsInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroCraftsInput>;
  delete?: InputMaybe<MroCustomerWhereInput>;
  disconnect?: InputMaybe<MroCustomerWhereInput>;
  update?: InputMaybe<MroCustomerUpdateToOneWithWhereWithoutMroCraftsInput>;
  upsert?: InputMaybe<MroCustomerUpsertWithoutMroCraftsInput>;
};

export type MroCustomerUpdateOneWithoutMroServiceRequestsNestedInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroServiceRequestsInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroServiceRequestsInput>;
  delete?: InputMaybe<MroCustomerWhereInput>;
  disconnect?: InputMaybe<MroCustomerWhereInput>;
  update?: InputMaybe<MroCustomerUpdateToOneWithWhereWithoutMroServiceRequestsInput>;
  upsert?: InputMaybe<MroCustomerUpsertWithoutMroServiceRequestsInput>;
};

export type MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput = {
  connect?: InputMaybe<MroCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroCustomerCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroCustomerCreateWithoutMroWorkOrdersInput>;
  delete?: InputMaybe<MroCustomerWhereInput>;
  disconnect?: InputMaybe<MroCustomerWhereInput>;
  update?: InputMaybe<MroCustomerUpdateToOneWithWhereWithoutMroWorkOrdersInput>;
  upsert?: InputMaybe<MroCustomerUpsertWithoutMroWorkOrdersInput>;
};

export type MroCustomerUpdateToOneWithWhereWithoutMroCommunicationThreadsInput = {
  data: MroCustomerUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpdateToOneWithWhereWithoutMroCraftsInput = {
  data: MroCustomerUpdateWithoutMroCraftsInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpdateToOneWithWhereWithoutMroServiceRequestsInput = {
  data: MroCustomerUpdateWithoutMroServiceRequestsInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpdateToOneWithWhereWithoutMroWorkOrdersInput = {
  data: MroCustomerUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpdateWithWhereUniqueWithoutBillingAddressInput = {
  data: MroCustomerUpdateWithoutBillingAddressInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpdateWithWhereUniqueWithoutMroAddressesInput = {
  data: MroCustomerUpdateWithoutMroAddressesInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpdateWithWhereUniqueWithoutMroContactsInput = {
  data: MroCustomerUpdateWithoutMroContactsInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroCustomerUpdateWithoutMroOrganizationInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: MroCustomerUpdateWithoutOrganizationInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpdateWithWhereUniqueWithoutShippingAddressInput = {
  data: MroCustomerUpdateWithoutShippingAddressInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpdateWithoutBillingAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroAddressesInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroCommunicationThreadsInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroContactsInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroCraftsInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroOrganizationInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroServiceRequestsInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutMroWorkOrdersInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutOrganizationInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  shippingAddress?: InputMaybe<MroAddressUpdateOneWithoutShippingCustomersNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpdateWithoutShippingAddressInput = {
  billingAddress?: InputMaybe<MroAddressUpdateOneWithoutBillingCustomersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroCustomersNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroCustomerNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroCustomersNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroCustomerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroCustomersNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroCustomerNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroCustomerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutMroCustomersNestedInput>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput>;
};

export type MroCustomerUpsertWithWhereUniqueWithoutBillingAddressInput = {
  create: MroCustomerCreateWithoutBillingAddressInput;
  update: MroCustomerUpdateWithoutBillingAddressInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpsertWithWhereUniqueWithoutMroAddressesInput = {
  create: MroCustomerCreateWithoutMroAddressesInput;
  update: MroCustomerUpdateWithoutMroAddressesInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpsertWithWhereUniqueWithoutMroContactsInput = {
  create: MroCustomerCreateWithoutMroContactsInput;
  update: MroCustomerUpdateWithoutMroContactsInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroCustomerCreateWithoutMroOrganizationInput;
  update: MroCustomerUpdateWithoutMroOrganizationInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: MroCustomerCreateWithoutOrganizationInput;
  update: MroCustomerUpdateWithoutOrganizationInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpsertWithWhereUniqueWithoutShippingAddressInput = {
  create: MroCustomerCreateWithoutShippingAddressInput;
  update: MroCustomerUpdateWithoutShippingAddressInput;
  where: MroCustomerWhereUniqueInput;
};

export type MroCustomerUpsertWithoutMroCommunicationThreadsInput = {
  create: MroCustomerCreateWithoutMroCommunicationThreadsInput;
  update: MroCustomerUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpsertWithoutMroCraftsInput = {
  create: MroCustomerCreateWithoutMroCraftsInput;
  update: MroCustomerUpdateWithoutMroCraftsInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpsertWithoutMroServiceRequestsInput = {
  create: MroCustomerCreateWithoutMroServiceRequestsInput;
  update: MroCustomerUpdateWithoutMroServiceRequestsInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerUpsertWithoutMroWorkOrdersInput = {
  create: MroCustomerCreateWithoutMroWorkOrdersInput;
  update: MroCustomerUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroCustomerWhereInput>;
};

export type MroCustomerVersion = {
  __typename?: 'MroCustomerVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroCustomer?: Maybe<MroCustomer>;
  mroCustomerId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroCustomerVersionCreateManyMroCustomerInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCustomerVersionCreateManyMroCustomerInputEnvelope = {
  data: Array<MroCustomerVersionCreateManyMroCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroCustomerVersionCreateNestedManyWithoutMroCustomerInput = {
  connect?: InputMaybe<Array<MroCustomerVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerVersionCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroCustomerVersionCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroCustomerVersionCreateManyMroCustomerInputEnvelope>;
};

export type MroCustomerVersionCreateOrConnectWithoutMroCustomerInput = {
  create: MroCustomerVersionCreateWithoutMroCustomerInput;
  where: MroCustomerVersionWhereUniqueInput;
};

export type MroCustomerVersionCreateWithoutMroCustomerInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCustomerVersionListRelationFilter = {
  every?: InputMaybe<MroCustomerVersionWhereInput>;
  none?: InputMaybe<MroCustomerVersionWhereInput>;
  some?: InputMaybe<MroCustomerVersionWhereInput>;
};

export type MroCustomerVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroCustomerVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroCustomerVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroCustomerVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroCustomerVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCustomerVersionUpdateManyWithWhereWithoutMroCustomerInput = {
  data: MroCustomerVersionUpdateManyMutationInput;
  where: MroCustomerVersionScalarWhereInput;
};

export type MroCustomerVersionUpdateManyWithoutMroCustomerNestedInput = {
  connect?: InputMaybe<Array<MroCustomerVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroCustomerVersionCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroCustomerVersionCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroCustomerVersionCreateManyMroCustomerInputEnvelope>;
  delete?: InputMaybe<Array<MroCustomerVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroCustomerVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroCustomerVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroCustomerVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroCustomerVersionUpdateWithWhereUniqueWithoutMroCustomerInput>>;
  updateMany?: InputMaybe<Array<MroCustomerVersionUpdateManyWithWhereWithoutMroCustomerInput>>;
  upsert?: InputMaybe<Array<MroCustomerVersionUpsertWithWhereUniqueWithoutMroCustomerInput>>;
};

export type MroCustomerVersionUpdateWithWhereUniqueWithoutMroCustomerInput = {
  data: MroCustomerVersionUpdateWithoutMroCustomerInput;
  where: MroCustomerVersionWhereUniqueInput;
};

export type MroCustomerVersionUpdateWithoutMroCustomerInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroCustomerVersionUpsertWithWhereUniqueWithoutMroCustomerInput = {
  create: MroCustomerVersionCreateWithoutMroCustomerInput;
  update: MroCustomerVersionUpdateWithoutMroCustomerInput;
  where: MroCustomerVersionWhereUniqueInput;
};

export type MroCustomerVersionWhereInput = {
  AND?: InputMaybe<Array<MroCustomerVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroCustomerVersionWhereInput>>;
  OR?: InputMaybe<Array<MroCustomerVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroCustomerVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCustomerVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroCustomerVersionWhereInput>>;
  OR?: InputMaybe<Array<MroCustomerVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroCustomerWhereInput = {
  AND?: InputMaybe<Array<MroCustomerWhereInput>>;
  NOT?: InputMaybe<Array<MroCustomerWhereInput>>;
  OR?: InputMaybe<Array<MroCustomerWhereInput>>;
  billingAddress?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  billingAddressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroAddresses?: InputMaybe<MroAddressListRelationFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroContacts?: InputMaybe<MroContactListRelationFilter>;
  mroCrafts?: InputMaybe<MroCraftListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequests?: InputMaybe<MroServiceRequestListRelationFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  shippingAddress?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  shippingAddressId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroCustomerVersionListRelationFilter>;
};

export type MroCustomerWhereUniqueInput = {
  AND?: InputMaybe<Array<MroCustomerWhereInput>>;
  NOT?: InputMaybe<Array<MroCustomerWhereInput>>;
  OR?: InputMaybe<Array<MroCustomerWhereInput>>;
  billingAddress?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  billingAddressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroAddresses?: InputMaybe<MroAddressListRelationFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroContacts?: InputMaybe<MroContactListRelationFilter>;
  mroCrafts?: InputMaybe<MroCraftListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequests?: InputMaybe<MroServiceRequestListRelationFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  shippingAddress?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  shippingAddressId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroCustomerVersionListRelationFilter>;
};

export type MroDocumentTemplate = {
  __typename?: 'MroDocumentTemplate';
  _count: MroDocumentTemplateCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  mroOrganizations?: Maybe<Array<MroOrganization>>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type: MroDocumentTemplateType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateCount = {
  __typename?: 'MroDocumentTemplateCount';
  mroOrganizations: Scalars['Int'];
};

export type MroDocumentTemplateCountAggregate = {
  __typename?: 'MroDocumentTemplateCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  isPublic: Scalars['Int'];
  name: Scalars['Int'];
  slug: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroDocumentTemplateCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroDocumentTemplatesInput>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MroDocumentTemplateType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput = {
  connect?: InputMaybe<Array<MroDocumentTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroDocumentTemplateCreateOrConnectWithoutMroOrganizationsInput>>;
  create?: InputMaybe<Array<MroDocumentTemplateCreateWithoutMroOrganizationsInput>>;
};

export type MroDocumentTemplateCreateOrConnectWithoutMroOrganizationsInput = {
  create: MroDocumentTemplateCreateWithoutMroOrganizationsInput;
  where: MroDocumentTemplateWhereUniqueInput;
};

export type MroDocumentTemplateCreateWithoutMroOrganizationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MroDocumentTemplateType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateListRelationFilter = {
  every?: InputMaybe<MroDocumentTemplateWhereInput>;
  none?: InputMaybe<MroDocumentTemplateWhereInput>;
  some?: InputMaybe<MroDocumentTemplateWhereInput>;
};

export type MroDocumentTemplateMaxAggregate = {
  __typename?: 'MroDocumentTemplateMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<MroDocumentTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateMinAggregate = {
  __typename?: 'MroDocumentTemplateMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<MroDocumentTemplateType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateScalarWhereInput = {
  AND?: InputMaybe<Array<MroDocumentTemplateScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroDocumentTemplateScalarWhereInput>>;
  OR?: InputMaybe<Array<MroDocumentTemplateScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublic?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumMroDocumentTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum MroDocumentTemplateType {
  Estimate = 'ESTIMATE',
  Invoice = 'INVOICE',
  LogEntry = 'LOG_ENTRY',
  Other = 'OTHER',
  PartOrder = 'PART_ORDER'
}

export type MroDocumentTemplateUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutMroDocumentTemplatesNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MroDocumentTemplateType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MroDocumentTemplateType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateUpdateManyWithWhereWithoutMroOrganizationsInput = {
  data: MroDocumentTemplateUpdateManyMutationInput;
  where: MroDocumentTemplateScalarWhereInput;
};

export type MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput = {
  connect?: InputMaybe<Array<MroDocumentTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroDocumentTemplateCreateOrConnectWithoutMroOrganizationsInput>>;
  create?: InputMaybe<Array<MroDocumentTemplateCreateWithoutMroOrganizationsInput>>;
  delete?: InputMaybe<Array<MroDocumentTemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroDocumentTemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroDocumentTemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<MroDocumentTemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<MroDocumentTemplateUpdateWithWhereUniqueWithoutMroOrganizationsInput>>;
  updateMany?: InputMaybe<Array<MroDocumentTemplateUpdateManyWithWhereWithoutMroOrganizationsInput>>;
  upsert?: InputMaybe<Array<MroDocumentTemplateUpsertWithWhereUniqueWithoutMroOrganizationsInput>>;
};

export type MroDocumentTemplateUpdateWithWhereUniqueWithoutMroOrganizationsInput = {
  data: MroDocumentTemplateUpdateWithoutMroOrganizationsInput;
  where: MroDocumentTemplateWhereUniqueInput;
};

export type MroDocumentTemplateUpdateWithoutMroOrganizationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MroDocumentTemplateType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroDocumentTemplateUpsertWithWhereUniqueWithoutMroOrganizationsInput = {
  create: MroDocumentTemplateCreateWithoutMroOrganizationsInput;
  update: MroDocumentTemplateUpdateWithoutMroOrganizationsInput;
  where: MroDocumentTemplateWhereUniqueInput;
};

export type MroDocumentTemplateWhereInput = {
  AND?: InputMaybe<Array<MroDocumentTemplateWhereInput>>;
  NOT?: InputMaybe<Array<MroDocumentTemplateWhereInput>>;
  OR?: InputMaybe<Array<MroDocumentTemplateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublic?: InputMaybe<BoolFilter>;
  mroOrganizations?: InputMaybe<MroOrganizationListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumMroDocumentTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroDocumentTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<MroDocumentTemplateWhereInput>>;
  NOT?: InputMaybe<Array<MroDocumentTemplateWhereInput>>;
  OR?: InputMaybe<Array<MroDocumentTemplateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<BoolFilter>;
  mroOrganizations?: InputMaybe<MroOrganizationListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumMroDocumentTemplateTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroEmployeeNotification = {
  __typename?: 'MroEmployeeNotification';
  _count: MroEmployeeNotificationCount;
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  mroEmployeeProfile?: Maybe<MroEmployeeProfile>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroEmployeeNotificationVersion>>;
};

export type MroEmployeeNotificationCount = {
  __typename?: 'MroEmployeeNotificationCount';
  versions: Scalars['Int'];
};

export type MroEmployeeNotificationCreateManyMroEmployeeProfileInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroEmployeeNotificationCreateManyMroEmployeeProfileInputEnvelope = {
  data: Array<MroEmployeeNotificationCreateManyMroEmployeeProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput = {
  connect?: InputMaybe<Array<MroEmployeeNotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeNotificationCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroEmployeeNotificationCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroEmployeeNotificationCreateManyMroEmployeeProfileInputEnvelope>;
};

export type MroEmployeeNotificationCreateOrConnectWithoutMroEmployeeProfileInput = {
  create: MroEmployeeNotificationCreateWithoutMroEmployeeProfileInput;
  where: MroEmployeeNotificationWhereUniqueInput;
};

export type MroEmployeeNotificationCreateWithoutMroEmployeeProfileInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEmployeeNotificationVersionCreateNestedManyWithoutMroEmployeeNotificationInput>;
};

export type MroEmployeeNotificationListRelationFilter = {
  every?: InputMaybe<MroEmployeeNotificationWhereInput>;
  none?: InputMaybe<MroEmployeeNotificationWhereInput>;
  some?: InputMaybe<MroEmployeeNotificationWhereInput>;
};

export type MroEmployeeNotificationNullableScalarRelationFilter = {
  is?: InputMaybe<MroEmployeeNotificationWhereInput>;
  isNot?: InputMaybe<MroEmployeeNotificationWhereInput>;
};

export type MroEmployeeNotificationScalarWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeNotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeNotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeNotificationScalarWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroEmployeeNotificationUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroEmployeeNotificationUpdateManyWithWhereWithoutMroEmployeeProfileInput = {
  data: MroEmployeeNotificationUpdateManyMutationInput;
  where: MroEmployeeNotificationScalarWhereInput;
};

export type MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeNotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeNotificationCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroEmployeeNotificationCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroEmployeeNotificationCreateManyMroEmployeeProfileInputEnvelope>;
  delete?: InputMaybe<Array<MroEmployeeNotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeNotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeNotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeNotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeNotificationUpdateWithWhereUniqueWithoutMroEmployeeProfileInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeNotificationUpdateManyWithWhereWithoutMroEmployeeProfileInput>>;
  upsert?: InputMaybe<Array<MroEmployeeNotificationUpsertWithWhereUniqueWithoutMroEmployeeProfileInput>>;
};

export type MroEmployeeNotificationUpdateWithWhereUniqueWithoutMroEmployeeProfileInput = {
  data: MroEmployeeNotificationUpdateWithoutMroEmployeeProfileInput;
  where: MroEmployeeNotificationWhereUniqueInput;
};

export type MroEmployeeNotificationUpdateWithoutMroEmployeeProfileInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEmployeeNotificationVersionUpdateManyWithoutMroEmployeeNotificationNestedInput>;
};

export type MroEmployeeNotificationUpsertWithWhereUniqueWithoutMroEmployeeProfileInput = {
  create: MroEmployeeNotificationCreateWithoutMroEmployeeProfileInput;
  update: MroEmployeeNotificationUpdateWithoutMroEmployeeProfileInput;
  where: MroEmployeeNotificationWhereUniqueInput;
};

export type MroEmployeeNotificationVersion = {
  __typename?: 'MroEmployeeNotificationVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroEmployeeNotification?: Maybe<MroEmployeeNotification>;
  mroEmployeeNotificationId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroEmployeeNotificationVersionCreateManyMroEmployeeNotificationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeNotificationVersionCreateManyMroEmployeeNotificationInputEnvelope = {
  data: Array<MroEmployeeNotificationVersionCreateManyMroEmployeeNotificationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEmployeeNotificationVersionCreateNestedManyWithoutMroEmployeeNotificationInput = {
  connect?: InputMaybe<Array<MroEmployeeNotificationVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeNotificationVersionCreateOrConnectWithoutMroEmployeeNotificationInput>>;
  create?: InputMaybe<Array<MroEmployeeNotificationVersionCreateWithoutMroEmployeeNotificationInput>>;
  createMany?: InputMaybe<MroEmployeeNotificationVersionCreateManyMroEmployeeNotificationInputEnvelope>;
};

export type MroEmployeeNotificationVersionCreateOrConnectWithoutMroEmployeeNotificationInput = {
  create: MroEmployeeNotificationVersionCreateWithoutMroEmployeeNotificationInput;
  where: MroEmployeeNotificationVersionWhereUniqueInput;
};

export type MroEmployeeNotificationVersionCreateWithoutMroEmployeeNotificationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeNotificationVersionListRelationFilter = {
  every?: InputMaybe<MroEmployeeNotificationVersionWhereInput>;
  none?: InputMaybe<MroEmployeeNotificationVersionWhereInput>;
  some?: InputMaybe<MroEmployeeNotificationVersionWhereInput>;
};

export type MroEmployeeNotificationVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeNotificationVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeNotificationVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeNotificationVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroEmployeeNotificationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeNotificationVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeNotificationVersionUpdateManyWithWhereWithoutMroEmployeeNotificationInput = {
  data: MroEmployeeNotificationVersionUpdateManyMutationInput;
  where: MroEmployeeNotificationVersionScalarWhereInput;
};

export type MroEmployeeNotificationVersionUpdateManyWithoutMroEmployeeNotificationNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeNotificationVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeNotificationVersionCreateOrConnectWithoutMroEmployeeNotificationInput>>;
  create?: InputMaybe<Array<MroEmployeeNotificationVersionCreateWithoutMroEmployeeNotificationInput>>;
  createMany?: InputMaybe<MroEmployeeNotificationVersionCreateManyMroEmployeeNotificationInputEnvelope>;
  delete?: InputMaybe<Array<MroEmployeeNotificationVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeNotificationVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeNotificationVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeNotificationVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeNotificationVersionUpdateWithWhereUniqueWithoutMroEmployeeNotificationInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeNotificationVersionUpdateManyWithWhereWithoutMroEmployeeNotificationInput>>;
  upsert?: InputMaybe<Array<MroEmployeeNotificationVersionUpsertWithWhereUniqueWithoutMroEmployeeNotificationInput>>;
};

export type MroEmployeeNotificationVersionUpdateWithWhereUniqueWithoutMroEmployeeNotificationInput = {
  data: MroEmployeeNotificationVersionUpdateWithoutMroEmployeeNotificationInput;
  where: MroEmployeeNotificationVersionWhereUniqueInput;
};

export type MroEmployeeNotificationVersionUpdateWithoutMroEmployeeNotificationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeNotificationVersionUpsertWithWhereUniqueWithoutMroEmployeeNotificationInput = {
  create: MroEmployeeNotificationVersionCreateWithoutMroEmployeeNotificationInput;
  update: MroEmployeeNotificationVersionUpdateWithoutMroEmployeeNotificationInput;
  where: MroEmployeeNotificationVersionWhereUniqueInput;
};

export type MroEmployeeNotificationVersionWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeNotificationVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeNotificationVersionWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeNotificationVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroEmployeeNotification?: InputMaybe<MroEmployeeNotificationNullableScalarRelationFilter>;
  mroEmployeeNotificationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeNotificationVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroEmployeeNotificationVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeNotificationVersionWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeNotificationVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroEmployeeNotification?: InputMaybe<MroEmployeeNotificationNullableScalarRelationFilter>;
  mroEmployeeNotificationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeNotificationWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeNotificationWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeNotificationWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeNotificationWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  link?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroEmployeeNotificationVersionListRelationFilter>;
};

export type MroEmployeeNotificationWhereUniqueInput = {
  AND?: InputMaybe<Array<MroEmployeeNotificationWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeNotificationWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeNotificationWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<StringNullableFilter>;
  message?: InputMaybe<StringNullableFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroEmployeeNotificationVersionListRelationFilter>;
};

export type MroEmployeeProfile = {
  __typename?: 'MroEmployeeProfile';
  _count: MroEmployeeProfileCount;
  accountSetup?: Maybe<Scalars['Boolean']>;
  airmenLicense?: Maybe<Scalars['JSON']>;
  approverParts?: Maybe<Array<MroWorkOrderPart>>;
  assignedWorkOrderItems?: Maybe<Array<MroWorkOrderItem>>;
  assignedWorkOrders?: Maybe<Array<MroWorkOrder>>;
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  currentLaborEntry?: Maybe<MroLaborEntry>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  inviteLink?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  latestActivity?: Maybe<MroLaborEntry>;
  mroCommunicationParticipants?: Maybe<Array<MroCommunicationParticipant>>;
  mroEmployeeNotifications?: Maybe<Array<MroEmployeeNotification>>;
  mroLaborEntries?: Maybe<Array<MroLaborEntry>>;
  mroLogEntries?: Maybe<Array<MroLogEntry>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartOrders?: Maybe<Array<MroPartOrder>>;
  mroRole?: Maybe<MroRole>;
  mroRoleId?: Maybe<Scalars['String']>;
  mroWorkOrderSignoffs?: Maybe<Array<MroWorkOrderSignoff>>;
  mroWorkOrders: Array<MroWorkOrder>;
  notificationSettings?: Maybe<Scalars['JSON']>;
  phone?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Attachment>;
  profilePictureId?: Maybe<Scalars['String']>;
  requestedParts?: Maybe<Array<MroWorkOrderPart>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<MroEmployeeProfileVersion>>;
};


export type MroEmployeeProfileMroWorkOrdersArgs = {
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroEmployeeProfileAvgAggregate = {
  __typename?: 'MroEmployeeProfileAvgAggregate';
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
};

export type MroEmployeeProfileCount = {
  __typename?: 'MroEmployeeProfileCount';
  approverParts: Scalars['Int'];
  assignedWorkOrderItems: Scalars['Int'];
  assignedWorkOrders: Scalars['Int'];
  mroCommunicationParticipants: Scalars['Int'];
  mroEmployeeNotifications: Scalars['Int'];
  mroLaborEntries: Scalars['Int'];
  mroLogEntries: Scalars['Int'];
  mroPartOrders: Scalars['Int'];
  mroWorkOrderSignoffs: Scalars['Int'];
  requestedParts: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroEmployeeProfileCountAggregate = {
  __typename?: 'MroEmployeeProfileCountAggregate';
  _all: Scalars['Int'];
  airmenLicense: Scalars['Int'];
  billableRate: Scalars['Int'];
  costRate: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  lastName: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroRoleId: Scalars['Int'];
  notificationSettings: Scalars['Int'];
  phone: Scalars['Int'];
  pin: Scalars['Int'];
  profileColor: Scalars['Int'];
  profilePictureId: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MroEmployeeProfileCreateInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateManyMroOrganizationInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroRoleId?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePictureId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeProfileCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroEmployeeProfileCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEmployeeProfileCreateManyMroRoleInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePictureId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeProfileCreateManyMroRoleInputEnvelope = {
  data: Array<MroEmployeeProfileCreateManyMroRoleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEmployeeProfileCreateManyUserInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroRoleId?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePictureId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroEmployeeProfileCreateManyUserInputEnvelope = {
  data: Array<MroEmployeeProfileCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutAssignedWorkOrderItemsInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutAssignedWorkOrderItemsInput>>;
};

export type MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutAssignedWorkOrdersInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutAssignedWorkOrdersInput>>;
};

export type MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroEmployeeProfileCreateManyMroOrganizationInputEnvelope>;
};

export type MroEmployeeProfileCreateNestedManyWithoutMroRoleInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutMroRoleInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutMroRoleInput>>;
  createMany?: InputMaybe<MroEmployeeProfileCreateManyMroRoleInputEnvelope>;
};

export type MroEmployeeProfileCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutUserInput>>;
  createMany?: InputMaybe<MroEmployeeProfileCreateManyUserInputEnvelope>;
};

export type MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutApproverPartsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutApproverPartsInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutMroCommunicationParticipantsInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroCommunicationParticipantsInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutMroLaborEntriesInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroLaborEntriesInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroLaborEntriesInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroLogEntriesInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutMroPartOrdersInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroPartOrdersInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroPartOrdersInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutMroWorkOrderSignoffsInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroWorkOrderSignoffsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroWorkOrderSignoffsInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutProfilePictureInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutProfilePictureInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutProfilePictureInput>;
};

export type MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutRequestedPartsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutRequestedPartsInput>;
};

export type MroEmployeeProfileCreateOrConnectWithoutApproverPartsInput = {
  create: MroEmployeeProfileCreateWithoutApproverPartsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutAssignedWorkOrderItemsInput = {
  create: MroEmployeeProfileCreateWithoutAssignedWorkOrderItemsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutAssignedWorkOrdersInput = {
  create: MroEmployeeProfileCreateWithoutAssignedWorkOrdersInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroCommunicationParticipantsInput = {
  create: MroEmployeeProfileCreateWithoutMroCommunicationParticipantsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroLaborEntriesInput = {
  create: MroEmployeeProfileCreateWithoutMroLaborEntriesInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroLogEntriesInput = {
  create: MroEmployeeProfileCreateWithoutMroLogEntriesInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroOrganizationInput = {
  create: MroEmployeeProfileCreateWithoutMroOrganizationInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroPartOrdersInput = {
  create: MroEmployeeProfileCreateWithoutMroPartOrdersInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroRoleInput = {
  create: MroEmployeeProfileCreateWithoutMroRoleInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutMroWorkOrderSignoffsInput = {
  create: MroEmployeeProfileCreateWithoutMroWorkOrderSignoffsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutProfilePictureInput = {
  create: MroEmployeeProfileCreateWithoutProfilePictureInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutRequestedPartsInput = {
  create: MroEmployeeProfileCreateWithoutRequestedPartsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateOrConnectWithoutUserInput = {
  create: MroEmployeeProfileCreateWithoutUserInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileCreateWithoutApproverPartsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutAssignedWorkOrderItemsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutAssignedWorkOrdersInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroCommunicationParticipantsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroLaborEntriesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroLogEntriesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroOrganizationInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroPartOrdersInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroRoleInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutMroWorkOrderSignoffsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutProfilePictureInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutRequestedPartsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroEmployeeProfilesInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileCreateWithoutUserInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutApproverInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutAssigneesInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutAssigneesInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutSignerInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutBuyerInput>;
  mroRole?: InputMaybe<MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentCreateNestedOneWithoutMroEmployeeProfileInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutRequesterInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput>;
};

export type MroEmployeeProfileListRelationFilter = {
  every?: InputMaybe<MroEmployeeProfileWhereInput>;
  none?: InputMaybe<MroEmployeeProfileWhereInput>;
  some?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileMaxAggregate = {
  __typename?: 'MroEmployeeProfileMaxAggregate';
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroRoleId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profilePictureId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroEmployeeProfileMinAggregate = {
  __typename?: 'MroEmployeeProfileMinAggregate';
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroRoleId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pin?: Maybe<Scalars['String']>;
  profileColor?: Maybe<Scalars['String']>;
  profilePictureId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroEmployeeProfileNullableScalarRelationFilter = {
  is?: InputMaybe<MroEmployeeProfileWhereInput>;
  isNot?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MroEmployeeProfileScalarWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  airmenLicense?: InputMaybe<JsonNullableFilter>;
  billableRate?: InputMaybe<DecimalNullableFilter>;
  costRate?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroRoleId?: InputMaybe<StringNullableFilter>;
  notificationSettings?: InputMaybe<JsonNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pin?: InputMaybe<StringNullableFilter>;
  profileColor?: InputMaybe<StringNullableFilter>;
  profilePictureId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeProfileSumAggregate = {
  __typename?: 'MroEmployeeProfileSumAggregate';
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
};

export type MroEmployeeProfileUpdateInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateManyMutationInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroEmployeeProfileUpdateManyWithWhereWithoutAssignedWorkOrderItemsInput = {
  data: MroEmployeeProfileUpdateManyMutationInput;
  where: MroEmployeeProfileScalarWhereInput;
};

export type MroEmployeeProfileUpdateManyWithWhereWithoutAssignedWorkOrdersInput = {
  data: MroEmployeeProfileUpdateManyMutationInput;
  where: MroEmployeeProfileScalarWhereInput;
};

export type MroEmployeeProfileUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroEmployeeProfileUpdateManyMutationInput;
  where: MroEmployeeProfileScalarWhereInput;
};

export type MroEmployeeProfileUpdateManyWithWhereWithoutMroRoleInput = {
  data: MroEmployeeProfileUpdateManyMutationInput;
  where: MroEmployeeProfileScalarWhereInput;
};

export type MroEmployeeProfileUpdateManyWithWhereWithoutUserInput = {
  data: MroEmployeeProfileUpdateManyMutationInput;
  where: MroEmployeeProfileScalarWhereInput;
};

export type MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutAssignedWorkOrderItemsInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutAssignedWorkOrderItemsInput>>;
  delete?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeProfileUpdateWithWhereUniqueWithoutAssignedWorkOrderItemsInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeProfileUpdateManyWithWhereWithoutAssignedWorkOrderItemsInput>>;
  upsert?: InputMaybe<Array<MroEmployeeProfileUpsertWithWhereUniqueWithoutAssignedWorkOrderItemsInput>>;
};

export type MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutAssignedWorkOrdersInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutAssignedWorkOrdersInput>>;
  delete?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeProfileUpdateWithWhereUniqueWithoutAssignedWorkOrdersInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeProfileUpdateManyWithWhereWithoutAssignedWorkOrdersInput>>;
  upsert?: InputMaybe<Array<MroEmployeeProfileUpsertWithWhereUniqueWithoutAssignedWorkOrdersInput>>;
};

export type MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroEmployeeProfileCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeProfileUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeProfileUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroEmployeeProfileUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroEmployeeProfileUpdateManyWithoutMroRoleNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutMroRoleInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutMroRoleInput>>;
  createMany?: InputMaybe<MroEmployeeProfileCreateManyMroRoleInputEnvelope>;
  delete?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeProfileUpdateWithWhereUniqueWithoutMroRoleInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeProfileUpdateManyWithWhereWithoutMroRoleInput>>;
  upsert?: InputMaybe<Array<MroEmployeeProfileUpsertWithWhereUniqueWithoutMroRoleInput>>;
};

export type MroEmployeeProfileUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileCreateWithoutUserInput>>;
  createMany?: InputMaybe<MroEmployeeProfileCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeProfileUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeProfileUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<MroEmployeeProfileUpsertWithWhereUniqueWithoutUserInput>>;
};

export type MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutApproverPartsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutApproverPartsInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutApproverPartsInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutApproverPartsInput>;
};

export type MroEmployeeProfileUpdateOneWithoutMroCommunicationParticipantsNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroCommunicationParticipantsInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutMroCommunicationParticipantsInput>;
};

export type MroEmployeeProfileUpdateOneWithoutMroLaborEntriesNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroLaborEntriesInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroLaborEntriesInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutMroLaborEntriesInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutMroLaborEntriesInput>;
};

export type MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroLogEntriesInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutMroLogEntriesInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutMroLogEntriesInput>;
};

export type MroEmployeeProfileUpdateOneWithoutMroPartOrdersNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroPartOrdersInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroPartOrdersInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutMroPartOrdersInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutMroPartOrdersInput>;
};

export type MroEmployeeProfileUpdateOneWithoutMroWorkOrderSignoffsNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutMroWorkOrderSignoffsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutMroWorkOrderSignoffsInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutMroWorkOrderSignoffsInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutMroWorkOrderSignoffsInput>;
};

export type MroEmployeeProfileUpdateOneWithoutProfilePictureNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutProfilePictureInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutProfilePictureInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutProfilePictureInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutProfilePictureInput>;
};

export type MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput = {
  connect?: InputMaybe<MroEmployeeProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroEmployeeProfileCreateOrConnectWithoutRequestedPartsInput>;
  create?: InputMaybe<MroEmployeeProfileCreateWithoutRequestedPartsInput>;
  delete?: InputMaybe<MroEmployeeProfileWhereInput>;
  disconnect?: InputMaybe<MroEmployeeProfileWhereInput>;
  update?: InputMaybe<MroEmployeeProfileUpdateToOneWithWhereWithoutRequestedPartsInput>;
  upsert?: InputMaybe<MroEmployeeProfileUpsertWithoutRequestedPartsInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutApproverPartsInput = {
  data: MroEmployeeProfileUpdateWithoutApproverPartsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput = {
  data: MroEmployeeProfileUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutMroLaborEntriesInput = {
  data: MroEmployeeProfileUpdateWithoutMroLaborEntriesInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutMroLogEntriesInput = {
  data: MroEmployeeProfileUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutMroPartOrdersInput = {
  data: MroEmployeeProfileUpdateWithoutMroPartOrdersInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutMroWorkOrderSignoffsInput = {
  data: MroEmployeeProfileUpdateWithoutMroWorkOrderSignoffsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutProfilePictureInput = {
  data: MroEmployeeProfileUpdateWithoutProfilePictureInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateToOneWithWhereWithoutRequestedPartsInput = {
  data: MroEmployeeProfileUpdateWithoutRequestedPartsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpdateWithWhereUniqueWithoutAssignedWorkOrderItemsInput = {
  data: MroEmployeeProfileUpdateWithoutAssignedWorkOrderItemsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpdateWithWhereUniqueWithoutAssignedWorkOrdersInput = {
  data: MroEmployeeProfileUpdateWithoutAssignedWorkOrdersInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroEmployeeProfileUpdateWithoutMroOrganizationInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpdateWithWhereUniqueWithoutMroRoleInput = {
  data: MroEmployeeProfileUpdateWithoutMroRoleInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpdateWithWhereUniqueWithoutUserInput = {
  data: MroEmployeeProfileUpdateWithoutUserInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpdateWithoutApproverPartsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutAssignedWorkOrderItemsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutAssignedWorkOrdersInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroCommunicationParticipantsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroLaborEntriesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroLogEntriesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroOrganizationInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroPartOrdersInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroRoleInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutMroWorkOrderSignoffsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutProfilePictureInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutRequestedPartsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpdateWithoutUserInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  approverParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutApproverNestedInput>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutAssigneesNestedInput>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutSignerNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutBuyerNestedInput>;
  mroRole?: InputMaybe<MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  pin?: InputMaybe<Scalars['String']>;
  profileColor?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<AttachmentUpdateOneWithoutMroEmployeeProfileNestedInput>;
  requestedParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutRequesterNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput>;
};

export type MroEmployeeProfileUpsertWithWhereUniqueWithoutAssignedWorkOrderItemsInput = {
  create: MroEmployeeProfileCreateWithoutAssignedWorkOrderItemsInput;
  update: MroEmployeeProfileUpdateWithoutAssignedWorkOrderItemsInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpsertWithWhereUniqueWithoutAssignedWorkOrdersInput = {
  create: MroEmployeeProfileCreateWithoutAssignedWorkOrdersInput;
  update: MroEmployeeProfileUpdateWithoutAssignedWorkOrdersInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroEmployeeProfileCreateWithoutMroOrganizationInput;
  update: MroEmployeeProfileUpdateWithoutMroOrganizationInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpsertWithWhereUniqueWithoutMroRoleInput = {
  create: MroEmployeeProfileCreateWithoutMroRoleInput;
  update: MroEmployeeProfileUpdateWithoutMroRoleInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpsertWithWhereUniqueWithoutUserInput = {
  create: MroEmployeeProfileCreateWithoutUserInput;
  update: MroEmployeeProfileUpdateWithoutUserInput;
  where: MroEmployeeProfileWhereUniqueInput;
};

export type MroEmployeeProfileUpsertWithoutApproverPartsInput = {
  create: MroEmployeeProfileCreateWithoutApproverPartsInput;
  update: MroEmployeeProfileUpdateWithoutApproverPartsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutMroCommunicationParticipantsInput = {
  create: MroEmployeeProfileCreateWithoutMroCommunicationParticipantsInput;
  update: MroEmployeeProfileUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutMroLaborEntriesInput = {
  create: MroEmployeeProfileCreateWithoutMroLaborEntriesInput;
  update: MroEmployeeProfileUpdateWithoutMroLaborEntriesInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutMroLogEntriesInput = {
  create: MroEmployeeProfileCreateWithoutMroLogEntriesInput;
  update: MroEmployeeProfileUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutMroPartOrdersInput = {
  create: MroEmployeeProfileCreateWithoutMroPartOrdersInput;
  update: MroEmployeeProfileUpdateWithoutMroPartOrdersInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutMroWorkOrderSignoffsInput = {
  create: MroEmployeeProfileCreateWithoutMroWorkOrderSignoffsInput;
  update: MroEmployeeProfileUpdateWithoutMroWorkOrderSignoffsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutProfilePictureInput = {
  create: MroEmployeeProfileCreateWithoutProfilePictureInput;
  update: MroEmployeeProfileUpdateWithoutProfilePictureInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUpsertWithoutRequestedPartsInput = {
  create: MroEmployeeProfileCreateWithoutRequestedPartsInput;
  update: MroEmployeeProfileUpdateWithoutRequestedPartsInput;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};

export type MroEmployeeProfileUserIdMroOrganizationIdCompoundUniqueInput = {
  mroOrganizationId: Scalars['String'];
  userId: Scalars['String'];
};

export type MroEmployeeProfileVersion = {
  __typename?: 'MroEmployeeProfileVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroEmployeeProfile?: Maybe<MroEmployeeProfile>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroEmployeeProfileVersionCreateManyMroEmployeeProfileInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeProfileVersionCreateManyMroEmployeeProfileInputEnvelope = {
  data: Array<MroEmployeeProfileVersionCreateManyMroEmployeeProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEmployeeProfileVersionCreateNestedManyWithoutMroEmployeeProfileInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileVersionCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileVersionCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroEmployeeProfileVersionCreateManyMroEmployeeProfileInputEnvelope>;
};

export type MroEmployeeProfileVersionCreateOrConnectWithoutMroEmployeeProfileInput = {
  create: MroEmployeeProfileVersionCreateWithoutMroEmployeeProfileInput;
  where: MroEmployeeProfileVersionWhereUniqueInput;
};

export type MroEmployeeProfileVersionCreateWithoutMroEmployeeProfileInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeProfileVersionListRelationFilter = {
  every?: InputMaybe<MroEmployeeProfileVersionWhereInput>;
  none?: InputMaybe<MroEmployeeProfileVersionWhereInput>;
  some?: InputMaybe<MroEmployeeProfileVersionWhereInput>;
};

export type MroEmployeeProfileVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeProfileVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeProfileVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeProfileVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeProfileVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeProfileVersionUpdateManyWithWhereWithoutMroEmployeeProfileInput = {
  data: MroEmployeeProfileVersionUpdateManyMutationInput;
  where: MroEmployeeProfileVersionScalarWhereInput;
};

export type MroEmployeeProfileVersionUpdateManyWithoutMroEmployeeProfileNestedInput = {
  connect?: InputMaybe<Array<MroEmployeeProfileVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEmployeeProfileVersionCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroEmployeeProfileVersionCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroEmployeeProfileVersionCreateManyMroEmployeeProfileInputEnvelope>;
  delete?: InputMaybe<Array<MroEmployeeProfileVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEmployeeProfileVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEmployeeProfileVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEmployeeProfileVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEmployeeProfileVersionUpdateWithWhereUniqueWithoutMroEmployeeProfileInput>>;
  updateMany?: InputMaybe<Array<MroEmployeeProfileVersionUpdateManyWithWhereWithoutMroEmployeeProfileInput>>;
  upsert?: InputMaybe<Array<MroEmployeeProfileVersionUpsertWithWhereUniqueWithoutMroEmployeeProfileInput>>;
};

export type MroEmployeeProfileVersionUpdateWithWhereUniqueWithoutMroEmployeeProfileInput = {
  data: MroEmployeeProfileVersionUpdateWithoutMroEmployeeProfileInput;
  where: MroEmployeeProfileVersionWhereUniqueInput;
};

export type MroEmployeeProfileVersionUpdateWithoutMroEmployeeProfileInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEmployeeProfileVersionUpsertWithWhereUniqueWithoutMroEmployeeProfileInput = {
  create: MroEmployeeProfileVersionCreateWithoutMroEmployeeProfileInput;
  update: MroEmployeeProfileVersionUpdateWithoutMroEmployeeProfileInput;
  where: MroEmployeeProfileVersionWhereUniqueInput;
};

export type MroEmployeeProfileVersionWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeProfileVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeProfileVersionWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeProfileVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeProfileVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroEmployeeProfileVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeProfileVersionWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeProfileVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEmployeeProfileWhereInput = {
  AND?: InputMaybe<Array<MroEmployeeProfileWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeProfileWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeProfileWhereInput>>;
  airmenLicense?: InputMaybe<JsonNullableFilter>;
  approverParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  billableRate?: InputMaybe<DecimalNullableFilter>;
  costRate?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationListRelationFilter>;
  mroLaborEntries?: InputMaybe<MroLaborEntryListRelationFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartOrders?: InputMaybe<MroPartOrderListRelationFilter>;
  mroRole?: InputMaybe<MroRoleNullableScalarRelationFilter>;
  mroRoleId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffListRelationFilter>;
  notificationSettings?: InputMaybe<JsonNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pin?: InputMaybe<StringNullableFilter>;
  profileColor?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  profilePictureId?: InputMaybe<StringNullableFilter>;
  requestedParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  versions?: InputMaybe<MroEmployeeProfileVersionListRelationFilter>;
};

export type MroEmployeeProfileWhereUniqueInput = {
  AND?: InputMaybe<Array<MroEmployeeProfileWhereInput>>;
  NOT?: InputMaybe<Array<MroEmployeeProfileWhereInput>>;
  OR?: InputMaybe<Array<MroEmployeeProfileWhereInput>>;
  airmenLicense?: InputMaybe<JsonNullableFilter>;
  approverParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  assignedWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  assignedWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  billableRate?: InputMaybe<DecimalNullableFilter>;
  costRate?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<StringFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroEmployeeNotifications?: InputMaybe<MroEmployeeNotificationListRelationFilter>;
  mroLaborEntries?: InputMaybe<MroLaborEntryListRelationFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartOrders?: InputMaybe<MroPartOrderListRelationFilter>;
  mroRole?: InputMaybe<MroRoleNullableScalarRelationFilter>;
  mroRoleId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffListRelationFilter>;
  notificationSettings?: InputMaybe<JsonNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  pin?: InputMaybe<StringNullableFilter>;
  profileColor?: InputMaybe<StringNullableFilter>;
  profilePicture?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  profilePictureId?: InputMaybe<Scalars['String']>;
  requestedParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userId_mroOrganizationId?: InputMaybe<MroEmployeeProfileUserIdMroOrganizationIdCompoundUniqueInput>;
  versions?: InputMaybe<MroEmployeeProfileVersionListRelationFilter>;
};

export type MroEstimate = {
  __typename?: 'MroEstimate';
  _count: MroEstimateCount;
  authorizedBy?: Maybe<Scalars['String']>;
  authorizedDate?: Maybe<Scalars['DateTime']>;
  authorizedTotal?: Maybe<Scalars['Decimal']>;
  charges?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  customerNotes?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  discounts?: Maybe<Scalars['JSON']>;
  estimateNumber?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  internalNotes?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['JSON']>;
  laborSummary?: Maybe<Scalars['JSON']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pdfLink: Scalars['String'];
  priceSummary?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroEstimateVersion>>;
};

export type MroEstimateAvgAggregate = {
  __typename?: 'MroEstimateAvgAggregate';
  authorizedTotal?: Maybe<Scalars['Decimal']>;
  estimateNumber?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Decimal']>;
};

export type MroEstimateCount = {
  __typename?: 'MroEstimateCount';
  versions: Scalars['Int'];
};

export type MroEstimateCountAggregate = {
  __typename?: 'MroEstimateCountAggregate';
  _all: Scalars['Int'];
  authorizedBy: Scalars['Int'];
  authorizedDate: Scalars['Int'];
  authorizedTotal: Scalars['Int'];
  charges: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerNotes: Scalars['Int'];
  date: Scalars['Int'];
  deletedAt: Scalars['Int'];
  discounts: Scalars['Int'];
  estimateNumber: Scalars['Int'];
  id: Scalars['Int'];
  internalNotes: Scalars['Int'];
  items: Scalars['Int'];
  laborSummary: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  notes: Scalars['Int'];
  priceSummary: Scalars['Int'];
  status: Scalars['Int'];
  total: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroEstimateCreateInput = {
  authorizedBy?: InputMaybe<Scalars['String']>;
  authorizedDate?: InputMaybe<Scalars['DateTime']>;
  authorizedTotal?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerNotes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  estimateNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroEstimatesInput>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEstimateVersionCreateNestedManyWithoutMroEstimateInput>;
};

export type MroEstimateCreateManyMroWorkOrderInput = {
  authorizedBy?: InputMaybe<Scalars['String']>;
  authorizedDate?: InputMaybe<Scalars['DateTime']>;
  authorizedTotal?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerNotes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  estimateNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroEstimateCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroEstimateCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEstimateCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroEstimateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEstimateCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroEstimateCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroEstimateCreateManyMroWorkOrderInputEnvelope>;
};

export type MroEstimateCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroEstimateCreateWithoutMroWorkOrderInput;
  where: MroEstimateWhereUniqueInput;
};

export type MroEstimateCreateWithoutMroWorkOrderInput = {
  authorizedBy?: InputMaybe<Scalars['String']>;
  authorizedDate?: InputMaybe<Scalars['DateTime']>;
  authorizedTotal?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerNotes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  estimateNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEstimateVersionCreateNestedManyWithoutMroEstimateInput>;
};

export type MroEstimateListRelationFilter = {
  every?: InputMaybe<MroEstimateWhereInput>;
  none?: InputMaybe<MroEstimateWhereInput>;
  some?: InputMaybe<MroEstimateWhereInput>;
};

export type MroEstimateMaxAggregate = {
  __typename?: 'MroEstimateMaxAggregate';
  authorizedBy?: Maybe<Scalars['String']>;
  authorizedDate?: Maybe<Scalars['DateTime']>;
  authorizedTotal?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerNotes?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateNumber?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroEstimateMinAggregate = {
  __typename?: 'MroEstimateMinAggregate';
  authorizedBy?: Maybe<Scalars['String']>;
  authorizedDate?: Maybe<Scalars['DateTime']>;
  authorizedTotal?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerNotes?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateNumber?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  internalNotes?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroEstimateNullableScalarRelationFilter = {
  is?: InputMaybe<MroEstimateWhereInput>;
  isNot?: InputMaybe<MroEstimateWhereInput>;
};

export type MroEstimateScalarWhereInput = {
  AND?: InputMaybe<Array<MroEstimateScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroEstimateScalarWhereInput>>;
  OR?: InputMaybe<Array<MroEstimateScalarWhereInput>>;
  authorizedBy?: InputMaybe<StringNullableFilter>;
  authorizedDate?: InputMaybe<DateTimeNullableFilter>;
  authorizedTotal?: InputMaybe<DecimalNullableFilter>;
  charges?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNotes?: InputMaybe<StringNullableFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discounts?: InputMaybe<JsonNullableFilter>;
  estimateNumber?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalNotes?: InputMaybe<StringNullableFilter>;
  items?: InputMaybe<JsonNullableFilter>;
  laborSummary?: InputMaybe<JsonNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  total?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroEstimateSumAggregate = {
  __typename?: 'MroEstimateSumAggregate';
  authorizedTotal?: Maybe<Scalars['Decimal']>;
  estimateNumber?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Decimal']>;
};

export type MroEstimateUpdateInput = {
  authorizedBy?: InputMaybe<Scalars['String']>;
  authorizedDate?: InputMaybe<Scalars['DateTime']>;
  authorizedTotal?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerNotes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  estimateNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroEstimatesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEstimateVersionUpdateManyWithoutMroEstimateNestedInput>;
};

export type MroEstimateUpdateManyMutationInput = {
  authorizedBy?: InputMaybe<Scalars['String']>;
  authorizedDate?: InputMaybe<Scalars['DateTime']>;
  authorizedTotal?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerNotes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  estimateNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroEstimateUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroEstimateUpdateManyMutationInput;
  where: MroEstimateScalarWhereInput;
};

export type MroEstimateUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroEstimateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEstimateCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroEstimateCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroEstimateCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroEstimateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEstimateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEstimateWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEstimateWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEstimateUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroEstimateUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroEstimateUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroEstimateUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroEstimateUpdateWithoutMroWorkOrderInput;
  where: MroEstimateWhereUniqueInput;
};

export type MroEstimateUpdateWithoutMroWorkOrderInput = {
  authorizedBy?: InputMaybe<Scalars['String']>;
  authorizedDate?: InputMaybe<Scalars['DateTime']>;
  authorizedTotal?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerNotes?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  estimateNumber?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroEstimateVersionUpdateManyWithoutMroEstimateNestedInput>;
};

export type MroEstimateUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroEstimateCreateWithoutMroWorkOrderInput;
  update: MroEstimateUpdateWithoutMroWorkOrderInput;
  where: MroEstimateWhereUniqueInput;
};

export type MroEstimateVersion = {
  __typename?: 'MroEstimateVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroEstimate?: Maybe<MroEstimate>;
  mroEstimateId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroEstimateVersionAvgAggregate = {
  __typename?: 'MroEstimateVersionAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type MroEstimateVersionCountAggregate = {
  __typename?: 'MroEstimateVersionCountAggregate';
  _all: Scalars['Int'];
  data: Scalars['Int'];
  id: Scalars['Int'];
  mroEstimateId: Scalars['Int'];
  operation: Scalars['Int'];
  timestamp: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MroEstimateVersionCreateManyMroEstimateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEstimateVersionCreateManyMroEstimateInputEnvelope = {
  data: Array<MroEstimateVersionCreateManyMroEstimateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroEstimateVersionCreateNestedManyWithoutMroEstimateInput = {
  connect?: InputMaybe<Array<MroEstimateVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEstimateVersionCreateOrConnectWithoutMroEstimateInput>>;
  create?: InputMaybe<Array<MroEstimateVersionCreateWithoutMroEstimateInput>>;
  createMany?: InputMaybe<MroEstimateVersionCreateManyMroEstimateInputEnvelope>;
};

export type MroEstimateVersionCreateOrConnectWithoutMroEstimateInput = {
  create: MroEstimateVersionCreateWithoutMroEstimateInput;
  where: MroEstimateVersionWhereUniqueInput;
};

export type MroEstimateVersionCreateWithoutMroEstimateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEstimateVersionListRelationFilter = {
  every?: InputMaybe<MroEstimateVersionWhereInput>;
  none?: InputMaybe<MroEstimateVersionWhereInput>;
  some?: InputMaybe<MroEstimateVersionWhereInput>;
};

export type MroEstimateVersionMaxAggregate = {
  __typename?: 'MroEstimateVersionMaxAggregate';
  id?: Maybe<Scalars['Int']>;
  mroEstimateId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroEstimateVersionMinAggregate = {
  __typename?: 'MroEstimateVersionMinAggregate';
  id?: Maybe<Scalars['Int']>;
  mroEstimateId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroEstimateVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroEstimateVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroEstimateVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroEstimateVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroEstimateId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEstimateVersionSumAggregate = {
  __typename?: 'MroEstimateVersionSumAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type MroEstimateVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEstimateVersionUpdateManyWithWhereWithoutMroEstimateInput = {
  data: MroEstimateVersionUpdateManyMutationInput;
  where: MroEstimateVersionScalarWhereInput;
};

export type MroEstimateVersionUpdateManyWithoutMroEstimateNestedInput = {
  connect?: InputMaybe<Array<MroEstimateVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroEstimateVersionCreateOrConnectWithoutMroEstimateInput>>;
  create?: InputMaybe<Array<MroEstimateVersionCreateWithoutMroEstimateInput>>;
  createMany?: InputMaybe<MroEstimateVersionCreateManyMroEstimateInputEnvelope>;
  delete?: InputMaybe<Array<MroEstimateVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroEstimateVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroEstimateVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroEstimateVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroEstimateVersionUpdateWithWhereUniqueWithoutMroEstimateInput>>;
  updateMany?: InputMaybe<Array<MroEstimateVersionUpdateManyWithWhereWithoutMroEstimateInput>>;
  upsert?: InputMaybe<Array<MroEstimateVersionUpsertWithWhereUniqueWithoutMroEstimateInput>>;
};

export type MroEstimateVersionUpdateWithWhereUniqueWithoutMroEstimateInput = {
  data: MroEstimateVersionUpdateWithoutMroEstimateInput;
  where: MroEstimateVersionWhereUniqueInput;
};

export type MroEstimateVersionUpdateWithoutMroEstimateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroEstimateVersionUpsertWithWhereUniqueWithoutMroEstimateInput = {
  create: MroEstimateVersionCreateWithoutMroEstimateInput;
  update: MroEstimateVersionUpdateWithoutMroEstimateInput;
  where: MroEstimateVersionWhereUniqueInput;
};

export type MroEstimateVersionWhereInput = {
  AND?: InputMaybe<Array<MroEstimateVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroEstimateVersionWhereInput>>;
  OR?: InputMaybe<Array<MroEstimateVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroEstimate?: InputMaybe<MroEstimateNullableScalarRelationFilter>;
  mroEstimateId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEstimateVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroEstimateVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroEstimateVersionWhereInput>>;
  OR?: InputMaybe<Array<MroEstimateVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroEstimate?: InputMaybe<MroEstimateNullableScalarRelationFilter>;
  mroEstimateId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroEstimateWhereInput = {
  AND?: InputMaybe<Array<MroEstimateWhereInput>>;
  NOT?: InputMaybe<Array<MroEstimateWhereInput>>;
  OR?: InputMaybe<Array<MroEstimateWhereInput>>;
  authorizedBy?: InputMaybe<StringNullableFilter>;
  authorizedDate?: InputMaybe<DateTimeNullableFilter>;
  authorizedTotal?: InputMaybe<DecimalNullableFilter>;
  charges?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNotes?: InputMaybe<StringNullableFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discounts?: InputMaybe<JsonNullableFilter>;
  estimateNumber?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalNotes?: InputMaybe<StringNullableFilter>;
  items?: InputMaybe<JsonNullableFilter>;
  laborSummary?: InputMaybe<JsonNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  total?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroEstimateVersionListRelationFilter>;
};

export type MroEstimateWhereUniqueInput = {
  AND?: InputMaybe<Array<MroEstimateWhereInput>>;
  NOT?: InputMaybe<Array<MroEstimateWhereInput>>;
  OR?: InputMaybe<Array<MroEstimateWhereInput>>;
  authorizedBy?: InputMaybe<StringNullableFilter>;
  authorizedDate?: InputMaybe<DateTimeNullableFilter>;
  authorizedTotal?: InputMaybe<DecimalNullableFilter>;
  charges?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNotes?: InputMaybe<StringNullableFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discounts?: InputMaybe<JsonNullableFilter>;
  estimateNumber?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  internalNotes?: InputMaybe<StringNullableFilter>;
  items?: InputMaybe<JsonNullableFilter>;
  laborSummary?: InputMaybe<JsonNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  total?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroEstimateVersionListRelationFilter>;
};

export enum MroFeeType {
  Both = 'BOTH',
  Labor = 'LABOR',
  Parts = 'PARTS'
}

export type MroInvoice = {
  __typename?: 'MroInvoice';
  _count: MroInvoiceCount;
  amount?: Maybe<Scalars['Decimal']>;
  charges?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  customer?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  discounts?: Maybe<Scalars['JSON']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['JSON']>;
  laborSummary?: Maybe<Scalars['JSON']>;
  mro?: Maybe<Scalars['JSON']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pdfLink: Scalars['String'];
  priceSummary?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroInvoiceVersion>>;
};

export type MroInvoiceAvgAggregate = {
  __typename?: 'MroInvoiceAvgAggregate';
  amount?: Maybe<Scalars['Decimal']>;
};

export type MroInvoiceCount = {
  __typename?: 'MroInvoiceCount';
  versions: Scalars['Int'];
};

export type MroInvoiceCountAggregate = {
  __typename?: 'MroInvoiceCountAggregate';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  charges: Scalars['Int'];
  createdAt: Scalars['Int'];
  customer: Scalars['Int'];
  deletedAt: Scalars['Int'];
  discounts: Scalars['Int'];
  dueDate: Scalars['Int'];
  id: Scalars['Int'];
  invoiceDate: Scalars['Int'];
  invoiceNumber: Scalars['Int'];
  items: Scalars['Int'];
  laborSummary: Scalars['Int'];
  mro: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  notes: Scalars['Int'];
  priceSummary: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroInvoiceCreateInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mro?: InputMaybe<Scalars['JSON']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroInvoicesInput>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroInvoiceVersionCreateNestedManyWithoutMroInvoiceInput>;
};

export type MroInvoiceCreateManyMroWorkOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mro?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroInvoiceCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroInvoiceCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroInvoiceCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroInvoiceCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroInvoiceCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroInvoiceCreateManyMroWorkOrderInputEnvelope>;
};

export type MroInvoiceCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroInvoiceCreateWithoutMroWorkOrderInput;
  where: MroInvoiceWhereUniqueInput;
};

export type MroInvoiceCreateWithoutMroWorkOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mro?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroInvoiceVersionCreateNestedManyWithoutMroInvoiceInput>;
};

export type MroInvoiceListRelationFilter = {
  every?: InputMaybe<MroInvoiceWhereInput>;
  none?: InputMaybe<MroInvoiceWhereInput>;
  some?: InputMaybe<MroInvoiceWhereInput>;
};

export type MroInvoiceMaxAggregate = {
  __typename?: 'MroInvoiceMaxAggregate';
  amount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroInvoiceMinAggregate = {
  __typename?: 'MroInvoiceMinAggregate';
  amount?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroInvoiceNullableScalarRelationFilter = {
  is?: InputMaybe<MroInvoiceWhereInput>;
  isNot?: InputMaybe<MroInvoiceWhereInput>;
};

export type MroInvoiceScalarWhereInput = {
  AND?: InputMaybe<Array<MroInvoiceScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceScalarWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceScalarWhereInput>>;
  amount?: InputMaybe<DecimalNullableFilter>;
  charges?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<JsonNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discounts?: InputMaybe<JsonNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceDate?: InputMaybe<DateTimeNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  items?: InputMaybe<JsonNullableFilter>;
  laborSummary?: InputMaybe<JsonNullableFilter>;
  mro?: InputMaybe<JsonNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroInvoiceSumAggregate = {
  __typename?: 'MroInvoiceSumAggregate';
  amount?: Maybe<Scalars['Decimal']>;
};

export type MroInvoiceTerm = {
  __typename?: 'MroInvoiceTerm';
  createdAt: Scalars['DateTime'];
  days: Scalars['Int'];
  id: Scalars['ID'];
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroInvoiceTermCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  days: Scalars['Int'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroInvoiceTermCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroInvoiceTermCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroInvoiceTermWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroInvoiceTermCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroInvoiceTermCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroInvoiceTermCreateManyMroOrganizationInputEnvelope>;
};

export type MroInvoiceTermCreateOrConnectWithoutMroOrganizationInput = {
  create: MroInvoiceTermCreateWithoutMroOrganizationInput;
  where: MroInvoiceTermWhereUniqueInput;
};

export type MroInvoiceTermCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  days: Scalars['Int'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroInvoiceTermListRelationFilter = {
  every?: InputMaybe<MroInvoiceTermWhereInput>;
  none?: InputMaybe<MroInvoiceTermWhereInput>;
  some?: InputMaybe<MroInvoiceTermWhereInput>;
};

export type MroInvoiceTermScalarWhereInput = {
  AND?: InputMaybe<Array<MroInvoiceTermScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceTermScalarWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceTermScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  days?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroInvoiceTermUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroInvoiceTermUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroInvoiceTermUpdateManyMutationInput;
  where: MroInvoiceTermScalarWhereInput;
};

export type MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroInvoiceTermWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroInvoiceTermCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroInvoiceTermCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroInvoiceTermCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroInvoiceTermWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroInvoiceTermScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroInvoiceTermWhereUniqueInput>>;
  set?: InputMaybe<Array<MroInvoiceTermWhereUniqueInput>>;
  update?: InputMaybe<Array<MroInvoiceTermUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroInvoiceTermUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroInvoiceTermUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroInvoiceTermUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroInvoiceTermUpdateWithoutMroOrganizationInput;
  where: MroInvoiceTermWhereUniqueInput;
};

export type MroInvoiceTermUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  days?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroInvoiceTermUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroInvoiceTermCreateWithoutMroOrganizationInput;
  update: MroInvoiceTermUpdateWithoutMroOrganizationInput;
  where: MroInvoiceTermWhereUniqueInput;
};

export type MroInvoiceTermWhereInput = {
  AND?: InputMaybe<Array<MroInvoiceTermWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceTermWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceTermWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  days?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroInvoiceTermWhereUniqueInput = {
  AND?: InputMaybe<Array<MroInvoiceTermWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceTermWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceTermWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  days?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroInvoiceUpdateInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mro?: InputMaybe<Scalars['JSON']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroInvoicesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroInvoiceVersionUpdateManyWithoutMroInvoiceNestedInput>;
};

export type MroInvoiceUpdateManyMutationInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mro?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroInvoiceUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroInvoiceUpdateManyMutationInput;
  where: MroInvoiceScalarWhereInput;
};

export type MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroInvoiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroInvoiceCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroInvoiceCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroInvoiceCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroInvoiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroInvoiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroInvoiceWhereUniqueInput>>;
  set?: InputMaybe<Array<MroInvoiceWhereUniqueInput>>;
  update?: InputMaybe<Array<MroInvoiceUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroInvoiceUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroInvoiceUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroInvoiceUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroInvoiceUpdateWithoutMroWorkOrderInput;
  where: MroInvoiceWhereUniqueInput;
};

export type MroInvoiceUpdateWithoutMroWorkOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  charges?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<Scalars['JSON']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  discounts?: InputMaybe<Scalars['JSON']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Scalars['JSON']>;
  laborSummary?: InputMaybe<Scalars['JSON']>;
  mro?: InputMaybe<Scalars['JSON']>;
  notes?: InputMaybe<Scalars['String']>;
  priceSummary?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroInvoiceVersionUpdateManyWithoutMroInvoiceNestedInput>;
};

export type MroInvoiceUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroInvoiceCreateWithoutMroWorkOrderInput;
  update: MroInvoiceUpdateWithoutMroWorkOrderInput;
  where: MroInvoiceWhereUniqueInput;
};

export type MroInvoiceVersion = {
  __typename?: 'MroInvoiceVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroInvoice?: Maybe<MroInvoice>;
  mroInvoiceId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroInvoiceVersionAvgAggregate = {
  __typename?: 'MroInvoiceVersionAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type MroInvoiceVersionCountAggregate = {
  __typename?: 'MroInvoiceVersionCountAggregate';
  _all: Scalars['Int'];
  data: Scalars['Int'];
  id: Scalars['Int'];
  mroInvoiceId: Scalars['Int'];
  operation: Scalars['Int'];
  timestamp: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MroInvoiceVersionCreateManyMroInvoiceInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroInvoiceVersionCreateManyMroInvoiceInputEnvelope = {
  data: Array<MroInvoiceVersionCreateManyMroInvoiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroInvoiceVersionCreateNestedManyWithoutMroInvoiceInput = {
  connect?: InputMaybe<Array<MroInvoiceVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroInvoiceVersionCreateOrConnectWithoutMroInvoiceInput>>;
  create?: InputMaybe<Array<MroInvoiceVersionCreateWithoutMroInvoiceInput>>;
  createMany?: InputMaybe<MroInvoiceVersionCreateManyMroInvoiceInputEnvelope>;
};

export type MroInvoiceVersionCreateOrConnectWithoutMroInvoiceInput = {
  create: MroInvoiceVersionCreateWithoutMroInvoiceInput;
  where: MroInvoiceVersionWhereUniqueInput;
};

export type MroInvoiceVersionCreateWithoutMroInvoiceInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroInvoiceVersionListRelationFilter = {
  every?: InputMaybe<MroInvoiceVersionWhereInput>;
  none?: InputMaybe<MroInvoiceVersionWhereInput>;
  some?: InputMaybe<MroInvoiceVersionWhereInput>;
};

export type MroInvoiceVersionMaxAggregate = {
  __typename?: 'MroInvoiceVersionMaxAggregate';
  id?: Maybe<Scalars['Int']>;
  mroInvoiceId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroInvoiceVersionMinAggregate = {
  __typename?: 'MroInvoiceVersionMinAggregate';
  id?: Maybe<Scalars['Int']>;
  mroInvoiceId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroInvoiceVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroInvoiceVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroInvoiceId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroInvoiceVersionSumAggregate = {
  __typename?: 'MroInvoiceVersionSumAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type MroInvoiceVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroInvoiceVersionUpdateManyWithWhereWithoutMroInvoiceInput = {
  data: MroInvoiceVersionUpdateManyMutationInput;
  where: MroInvoiceVersionScalarWhereInput;
};

export type MroInvoiceVersionUpdateManyWithoutMroInvoiceNestedInput = {
  connect?: InputMaybe<Array<MroInvoiceVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroInvoiceVersionCreateOrConnectWithoutMroInvoiceInput>>;
  create?: InputMaybe<Array<MroInvoiceVersionCreateWithoutMroInvoiceInput>>;
  createMany?: InputMaybe<MroInvoiceVersionCreateManyMroInvoiceInputEnvelope>;
  delete?: InputMaybe<Array<MroInvoiceVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroInvoiceVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroInvoiceVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroInvoiceVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroInvoiceVersionUpdateWithWhereUniqueWithoutMroInvoiceInput>>;
  updateMany?: InputMaybe<Array<MroInvoiceVersionUpdateManyWithWhereWithoutMroInvoiceInput>>;
  upsert?: InputMaybe<Array<MroInvoiceVersionUpsertWithWhereUniqueWithoutMroInvoiceInput>>;
};

export type MroInvoiceVersionUpdateWithWhereUniqueWithoutMroInvoiceInput = {
  data: MroInvoiceVersionUpdateWithoutMroInvoiceInput;
  where: MroInvoiceVersionWhereUniqueInput;
};

export type MroInvoiceVersionUpdateWithoutMroInvoiceInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroInvoiceVersionUpsertWithWhereUniqueWithoutMroInvoiceInput = {
  create: MroInvoiceVersionCreateWithoutMroInvoiceInput;
  update: MroInvoiceVersionUpdateWithoutMroInvoiceInput;
  where: MroInvoiceVersionWhereUniqueInput;
};

export type MroInvoiceVersionWhereInput = {
  AND?: InputMaybe<Array<MroInvoiceVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceVersionWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroInvoice?: InputMaybe<MroInvoiceNullableScalarRelationFilter>;
  mroInvoiceId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroInvoiceVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroInvoiceVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceVersionWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroInvoice?: InputMaybe<MroInvoiceNullableScalarRelationFilter>;
  mroInvoiceId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroInvoiceWhereInput = {
  AND?: InputMaybe<Array<MroInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceWhereInput>>;
  amount?: InputMaybe<DecimalNullableFilter>;
  charges?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<JsonNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discounts?: InputMaybe<JsonNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceDate?: InputMaybe<DateTimeNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  items?: InputMaybe<JsonNullableFilter>;
  laborSummary?: InputMaybe<JsonNullableFilter>;
  mro?: InputMaybe<JsonNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroInvoiceVersionListRelationFilter>;
};

export type MroInvoiceWhereUniqueInput = {
  AND?: InputMaybe<Array<MroInvoiceWhereInput>>;
  NOT?: InputMaybe<Array<MroInvoiceWhereInput>>;
  OR?: InputMaybe<Array<MroInvoiceWhereInput>>;
  amount?: InputMaybe<DecimalNullableFilter>;
  charges?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<JsonNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  discounts?: InputMaybe<JsonNullableFilter>;
  dueDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  invoiceDate?: InputMaybe<DateTimeNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  items?: InputMaybe<JsonNullableFilter>;
  laborSummary?: InputMaybe<JsonNullableFilter>;
  mro?: InputMaybe<JsonNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  priceSummary?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroInvoiceVersionListRelationFilter>;
};

export type MroIssue = {
  __typename?: 'MroIssue';
  _count: MroIssueCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mroCraft?: Maybe<MroCraft>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroUser: User;
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<MroIssueVersion>>;
};

export type MroIssueCount = {
  __typename?: 'MroIssueCount';
  versions: Scalars['Int'];
};

export type MroIssueCountAggregate = {
  __typename?: 'MroIssueCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  mroCraftId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderItemId: Scalars['Int'];
  notes: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MroIssueCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroIssuesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroIssuesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroIssuesInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroIssueInput>;
  versions?: InputMaybe<MroIssueVersionCreateNestedManyWithoutMroIssueInput>;
};

export type MroIssueCreateManyMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueCreateManyMroCraftInputEnvelope = {
  data: Array<MroIssueCreateManyMroCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroIssueCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroIssueCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroIssueCreateManyMroWorkOrderItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueCreateManyMroWorkOrderItemInputEnvelope = {
  data: Array<MroIssueCreateManyMroWorkOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroIssueCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroIssueCreateManyUserInputEnvelope = {
  data: Array<MroIssueCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroIssueCreateNestedManyWithoutMroCraftInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroIssueCreateManyMroCraftInputEnvelope>;
};

export type MroIssueCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroIssueCreateManyMroOrganizationInputEnvelope>;
};

export type MroIssueCreateNestedManyWithoutMroWorkOrderItemInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroIssueCreateManyMroWorkOrderItemInputEnvelope>;
};

export type MroIssueCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutUserInput>>;
  createMany?: InputMaybe<MroIssueCreateManyUserInputEnvelope>;
};

export type MroIssueCreateOrConnectWithoutMroCraftInput = {
  create: MroIssueCreateWithoutMroCraftInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueCreateOrConnectWithoutMroOrganizationInput = {
  create: MroIssueCreateWithoutMroOrganizationInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueCreateOrConnectWithoutMroWorkOrderItemInput = {
  create: MroIssueCreateWithoutMroWorkOrderItemInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueCreateOrConnectWithoutUserInput = {
  create: MroIssueCreateWithoutUserInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueCreateWithoutMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroIssuesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroIssuesInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroIssueInput>;
  versions?: InputMaybe<MroIssueVersionCreateNestedManyWithoutMroIssueInput>;
};

export type MroIssueCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroIssuesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroIssuesInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroIssueInput>;
  versions?: InputMaybe<MroIssueVersionCreateNestedManyWithoutMroIssueInput>;
};

export type MroIssueCreateWithoutMroWorkOrderItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroIssuesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroIssuesInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutMroIssueInput>;
  versions?: InputMaybe<MroIssueVersionCreateNestedManyWithoutMroIssueInput>;
};

export type MroIssueCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroIssuesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroIssuesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroIssuesInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroIssueVersionCreateNestedManyWithoutMroIssueInput>;
};

export type MroIssueListRelationFilter = {
  every?: InputMaybe<MroIssueWhereInput>;
  none?: InputMaybe<MroIssueWhereInput>;
  some?: InputMaybe<MroIssueWhereInput>;
};

export type MroIssueMaxAggregate = {
  __typename?: 'MroIssueMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroIssueMinAggregate = {
  __typename?: 'MroIssueMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroIssueNullableScalarRelationFilter = {
  is?: InputMaybe<MroIssueWhereInput>;
  isNot?: InputMaybe<MroIssueWhereInput>;
};

export type MroIssueOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MroIssueScalarWhereInput = {
  AND?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  OR?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroIssueUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroIssuesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroIssuesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroIssuesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroIssueNestedInput>;
  versions?: InputMaybe<MroIssueVersionUpdateManyWithoutMroIssueNestedInput>;
};

export type MroIssueUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroIssueUpdateManyWithWhereWithoutMroCraftInput = {
  data: MroIssueUpdateManyMutationInput;
  where: MroIssueScalarWhereInput;
};

export type MroIssueUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroIssueUpdateManyMutationInput;
  where: MroIssueScalarWhereInput;
};

export type MroIssueUpdateManyWithWhereWithoutMroWorkOrderItemInput = {
  data: MroIssueUpdateManyMutationInput;
  where: MroIssueScalarWhereInput;
};

export type MroIssueUpdateManyWithWhereWithoutUserInput = {
  data: MroIssueUpdateManyMutationInput;
  where: MroIssueScalarWhereInput;
};

export type MroIssueUpdateManyWithoutMroCraftNestedInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroIssueCreateManyMroCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  set?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  update?: InputMaybe<Array<MroIssueUpdateWithWhereUniqueWithoutMroCraftInput>>;
  updateMany?: InputMaybe<Array<MroIssueUpdateManyWithWhereWithoutMroCraftInput>>;
  upsert?: InputMaybe<Array<MroIssueUpsertWithWhereUniqueWithoutMroCraftInput>>;
};

export type MroIssueUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroIssueCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  set?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  update?: InputMaybe<Array<MroIssueUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroIssueUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroIssueUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroIssueCreateManyMroWorkOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  set?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  update?: InputMaybe<Array<MroIssueUpdateWithWhereUniqueWithoutMroWorkOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroIssueUpdateManyWithWhereWithoutMroWorkOrderItemInput>>;
  upsert?: InputMaybe<Array<MroIssueUpsertWithWhereUniqueWithoutMroWorkOrderItemInput>>;
};

export type MroIssueUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MroIssueCreateWithoutUserInput>>;
  createMany?: InputMaybe<MroIssueCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroIssueScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  set?: InputMaybe<Array<MroIssueWhereUniqueInput>>;
  update?: InputMaybe<Array<MroIssueUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<MroIssueUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<MroIssueUpsertWithWhereUniqueWithoutUserInput>>;
};

export type MroIssueUpdateWithWhereUniqueWithoutMroCraftInput = {
  data: MroIssueUpdateWithoutMroCraftInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroIssueUpdateWithoutMroOrganizationInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpdateWithWhereUniqueWithoutMroWorkOrderItemInput = {
  data: MroIssueUpdateWithoutMroWorkOrderItemInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpdateWithWhereUniqueWithoutUserInput = {
  data: MroIssueUpdateWithoutUserInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpdateWithoutMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroIssuesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroIssuesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroIssueNestedInput>;
  versions?: InputMaybe<MroIssueVersionUpdateManyWithoutMroIssueNestedInput>;
};

export type MroIssueUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroIssuesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroIssuesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroIssueNestedInput>;
  versions?: InputMaybe<MroIssueVersionUpdateManyWithoutMroIssueNestedInput>;
};

export type MroIssueUpdateWithoutMroWorkOrderItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroIssuesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroIssuesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutMroIssueNestedInput>;
  versions?: InputMaybe<MroIssueVersionUpdateManyWithoutMroIssueNestedInput>;
};

export type MroIssueUpdateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroIssuesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroIssuesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroIssuesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroIssueVersionUpdateManyWithoutMroIssueNestedInput>;
};

export type MroIssueUpsertWithWhereUniqueWithoutMroCraftInput = {
  create: MroIssueCreateWithoutMroCraftInput;
  update: MroIssueUpdateWithoutMroCraftInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroIssueCreateWithoutMroOrganizationInput;
  update: MroIssueUpdateWithoutMroOrganizationInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpsertWithWhereUniqueWithoutMroWorkOrderItemInput = {
  create: MroIssueCreateWithoutMroWorkOrderItemInput;
  update: MroIssueUpdateWithoutMroWorkOrderItemInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueUpsertWithWhereUniqueWithoutUserInput = {
  create: MroIssueCreateWithoutUserInput;
  update: MroIssueUpdateWithoutUserInput;
  where: MroIssueWhereUniqueInput;
};

export type MroIssueVersion = {
  __typename?: 'MroIssueVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroIssue?: Maybe<MroIssue>;
  mroIssueId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroIssueVersionCreateManyMroIssueInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueVersionCreateManyMroIssueInputEnvelope = {
  data: Array<MroIssueVersionCreateManyMroIssueInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroIssueVersionCreateNestedManyWithoutMroIssueInput = {
  connect?: InputMaybe<Array<MroIssueVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueVersionCreateOrConnectWithoutMroIssueInput>>;
  create?: InputMaybe<Array<MroIssueVersionCreateWithoutMroIssueInput>>;
  createMany?: InputMaybe<MroIssueVersionCreateManyMroIssueInputEnvelope>;
};

export type MroIssueVersionCreateOrConnectWithoutMroIssueInput = {
  create: MroIssueVersionCreateWithoutMroIssueInput;
  where: MroIssueVersionWhereUniqueInput;
};

export type MroIssueVersionCreateWithoutMroIssueInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueVersionListRelationFilter = {
  every?: InputMaybe<MroIssueVersionWhereInput>;
  none?: InputMaybe<MroIssueVersionWhereInput>;
  some?: InputMaybe<MroIssueVersionWhereInput>;
};

export type MroIssueVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroIssueVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroIssueVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroIssueVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroIssueId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroIssueVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueVersionUpdateManyWithWhereWithoutMroIssueInput = {
  data: MroIssueVersionUpdateManyMutationInput;
  where: MroIssueVersionScalarWhereInput;
};

export type MroIssueVersionUpdateManyWithoutMroIssueNestedInput = {
  connect?: InputMaybe<Array<MroIssueVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroIssueVersionCreateOrConnectWithoutMroIssueInput>>;
  create?: InputMaybe<Array<MroIssueVersionCreateWithoutMroIssueInput>>;
  createMany?: InputMaybe<MroIssueVersionCreateManyMroIssueInputEnvelope>;
  delete?: InputMaybe<Array<MroIssueVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroIssueVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroIssueVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroIssueVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroIssueVersionUpdateWithWhereUniqueWithoutMroIssueInput>>;
  updateMany?: InputMaybe<Array<MroIssueVersionUpdateManyWithWhereWithoutMroIssueInput>>;
  upsert?: InputMaybe<Array<MroIssueVersionUpsertWithWhereUniqueWithoutMroIssueInput>>;
};

export type MroIssueVersionUpdateWithWhereUniqueWithoutMroIssueInput = {
  data: MroIssueVersionUpdateWithoutMroIssueInput;
  where: MroIssueVersionWhereUniqueInput;
};

export type MroIssueVersionUpdateWithoutMroIssueInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroIssueVersionUpsertWithWhereUniqueWithoutMroIssueInput = {
  create: MroIssueVersionCreateWithoutMroIssueInput;
  update: MroIssueVersionUpdateWithoutMroIssueInput;
  where: MroIssueVersionWhereUniqueInput;
};

export type MroIssueVersionWhereInput = {
  AND?: InputMaybe<Array<MroIssueVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroIssueVersionWhereInput>>;
  OR?: InputMaybe<Array<MroIssueVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroIssue?: InputMaybe<MroIssueNullableScalarRelationFilter>;
  mroIssueId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroIssueVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroIssueVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroIssueVersionWhereInput>>;
  OR?: InputMaybe<Array<MroIssueVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroIssue?: InputMaybe<MroIssueNullableScalarRelationFilter>;
  mroIssueId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroIssueWhereInput = {
  AND?: InputMaybe<Array<MroIssueWhereInput>>;
  NOT?: InputMaybe<Array<MroIssueWhereInput>>;
  OR?: InputMaybe<Array<MroIssueWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  versions?: InputMaybe<MroIssueVersionListRelationFilter>;
};

export type MroIssueWhereUniqueInput = {
  AND?: InputMaybe<Array<MroIssueWhereInput>>;
  NOT?: InputMaybe<Array<MroIssueWhereInput>>;
  OR?: InputMaybe<Array<MroIssueWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  versions?: InputMaybe<MroIssueVersionListRelationFilter>;
};

export type MroLaborEntry = {
  __typename?: 'MroLaborEntry';
  _count: MroLaborEntryCount;
  billable?: Maybe<Scalars['Boolean']>;
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  duration: Scalars['Float'];
  endTime?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  mroEmployeeProfile?: Maybe<MroEmployeeProfile>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pauseTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroLaborEntryVersion>>;
};

export type MroLaborEntryAvgAggregate = {
  __typename?: 'MroLaborEntryAvgAggregate';
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  hours?: Maybe<Scalars['Decimal']>;
};

export type MroLaborEntryCount = {
  __typename?: 'MroLaborEntryCount';
  versions: Scalars['Int'];
};

export type MroLaborEntryCountAggregate = {
  __typename?: 'MroLaborEntryCountAggregate';
  _all: Scalars['Int'];
  billable: Scalars['Int'];
  billableRate: Scalars['Int'];
  costRate: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  endTime: Scalars['Int'];
  hours: Scalars['Int'];
  id: Scalars['Int'];
  mroEmployeeProfileId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderItemId: Scalars['Int'];
  notes: Scalars['Int'];
  pauseTime: Scalars['Int'];
  startTime: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroLaborEntryCreateInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLaborEntriesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroLaborEntriesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroLaborEntriesInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionCreateNestedManyWithoutMroLaborEntryInput>;
};

export type MroLaborEntryCreateManyMroEmployeeProfileInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLaborEntryCreateManyMroEmployeeProfileInputEnvelope = {
  data: Array<MroLaborEntryCreateManyMroEmployeeProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLaborEntryCreateManyMroOrganizationInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLaborEntryCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroLaborEntryCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLaborEntryCreateManyMroWorkOrderItemInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLaborEntryCreateManyMroWorkOrderItemInputEnvelope = {
  data: Array<MroLaborEntryCreateManyMroWorkOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLaborEntryCreateNestedManyWithoutMroEmployeeProfileInput = {
  connect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroLaborEntryCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroLaborEntryCreateManyMroEmployeeProfileInputEnvelope>;
};

export type MroLaborEntryCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroLaborEntryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroLaborEntryCreateManyMroOrganizationInputEnvelope>;
};

export type MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput = {
  connect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroLaborEntryCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroLaborEntryCreateManyMroWorkOrderItemInputEnvelope>;
};

export type MroLaborEntryCreateOrConnectWithoutMroEmployeeProfileInput = {
  create: MroLaborEntryCreateWithoutMroEmployeeProfileInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryCreateOrConnectWithoutMroOrganizationInput = {
  create: MroLaborEntryCreateWithoutMroOrganizationInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryCreateOrConnectWithoutMroWorkOrderItemInput = {
  create: MroLaborEntryCreateWithoutMroWorkOrderItemInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryCreateWithoutMroEmployeeProfileInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroLaborEntriesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroLaborEntriesInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionCreateNestedManyWithoutMroLaborEntryInput>;
};

export type MroLaborEntryCreateWithoutMroOrganizationInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLaborEntriesInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroLaborEntriesInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionCreateNestedManyWithoutMroLaborEntryInput>;
};

export type MroLaborEntryCreateWithoutMroWorkOrderItemInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLaborEntriesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroLaborEntriesInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionCreateNestedManyWithoutMroLaborEntryInput>;
};

export type MroLaborEntryListRelationFilter = {
  every?: InputMaybe<MroLaborEntryWhereInput>;
  none?: InputMaybe<MroLaborEntryWhereInput>;
  some?: InputMaybe<MroLaborEntryWhereInput>;
};

export type MroLaborEntryMaxAggregate = {
  __typename?: 'MroLaborEntryMaxAggregate';
  billable?: Maybe<Scalars['Boolean']>;
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pauseTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLaborEntryMinAggregate = {
  __typename?: 'MroLaborEntryMinAggregate';
  billable?: Maybe<Scalars['Boolean']>;
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  mroEmployeeProfileId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pauseTime?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLaborEntryNullableScalarRelationFilter = {
  is?: InputMaybe<MroLaborEntryWhereInput>;
  isNot?: InputMaybe<MroLaborEntryWhereInput>;
};

export type MroLaborEntryScalarWhereInput = {
  AND?: InputMaybe<Array<MroLaborEntryScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLaborEntryScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLaborEntryScalarWhereInput>>;
  billable?: InputMaybe<BoolNullableFilter>;
  billableRate?: InputMaybe<DecimalNullableFilter>;
  costRate?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  hours?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  pauseTime?: InputMaybe<DateTimeNullableFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroLaborEntrySumAggregate = {
  __typename?: 'MroLaborEntrySumAggregate';
  billableRate?: Maybe<Scalars['Decimal']>;
  costRate?: Maybe<Scalars['Decimal']>;
  hours?: Maybe<Scalars['Decimal']>;
};

export type MroLaborEntryUpdateInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLaborEntriesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroLaborEntriesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroLaborEntriesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionUpdateManyWithoutMroLaborEntryNestedInput>;
};

export type MroLaborEntryUpdateManyMutationInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLaborEntryUpdateManyWithWhereWithoutMroEmployeeProfileInput = {
  data: MroLaborEntryUpdateManyMutationInput;
  where: MroLaborEntryScalarWhereInput;
};

export type MroLaborEntryUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroLaborEntryUpdateManyMutationInput;
  where: MroLaborEntryScalarWhereInput;
};

export type MroLaborEntryUpdateManyWithWhereWithoutMroWorkOrderItemInput = {
  data: MroLaborEntryUpdateManyMutationInput;
  where: MroLaborEntryScalarWhereInput;
};

export type MroLaborEntryUpdateManyWithoutMroEmployeeProfileNestedInput = {
  connect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryCreateOrConnectWithoutMroEmployeeProfileInput>>;
  create?: InputMaybe<Array<MroLaborEntryCreateWithoutMroEmployeeProfileInput>>;
  createMany?: InputMaybe<MroLaborEntryCreateManyMroEmployeeProfileInputEnvelope>;
  delete?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLaborEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLaborEntryUpdateWithWhereUniqueWithoutMroEmployeeProfileInput>>;
  updateMany?: InputMaybe<Array<MroLaborEntryUpdateManyWithWhereWithoutMroEmployeeProfileInput>>;
  upsert?: InputMaybe<Array<MroLaborEntryUpsertWithWhereUniqueWithoutMroEmployeeProfileInput>>;
};

export type MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroLaborEntryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroLaborEntryCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLaborEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLaborEntryUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroLaborEntryUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroLaborEntryUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroLaborEntryCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroLaborEntryCreateManyMroWorkOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLaborEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLaborEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLaborEntryUpdateWithWhereUniqueWithoutMroWorkOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroLaborEntryUpdateManyWithWhereWithoutMroWorkOrderItemInput>>;
  upsert?: InputMaybe<Array<MroLaborEntryUpsertWithWhereUniqueWithoutMroWorkOrderItemInput>>;
};

export type MroLaborEntryUpdateWithWhereUniqueWithoutMroEmployeeProfileInput = {
  data: MroLaborEntryUpdateWithoutMroEmployeeProfileInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroLaborEntryUpdateWithoutMroOrganizationInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryUpdateWithWhereUniqueWithoutMroWorkOrderItemInput = {
  data: MroLaborEntryUpdateWithoutMroWorkOrderItemInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryUpdateWithoutMroEmployeeProfileInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroLaborEntriesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroLaborEntriesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionUpdateManyWithoutMroLaborEntryNestedInput>;
};

export type MroLaborEntryUpdateWithoutMroOrganizationInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLaborEntriesNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroLaborEntriesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionUpdateManyWithoutMroLaborEntryNestedInput>;
};

export type MroLaborEntryUpdateWithoutMroWorkOrderItemInput = {
  billable?: InputMaybe<Scalars['Boolean']>;
  billableRate?: InputMaybe<Scalars['Decimal']>;
  costRate?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  hours?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLaborEntriesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroLaborEntriesNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  pauseTime?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLaborEntryVersionUpdateManyWithoutMroLaborEntryNestedInput>;
};

export type MroLaborEntryUpsertWithWhereUniqueWithoutMroEmployeeProfileInput = {
  create: MroLaborEntryCreateWithoutMroEmployeeProfileInput;
  update: MroLaborEntryUpdateWithoutMroEmployeeProfileInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroLaborEntryCreateWithoutMroOrganizationInput;
  update: MroLaborEntryUpdateWithoutMroOrganizationInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryUpsertWithWhereUniqueWithoutMroWorkOrderItemInput = {
  create: MroLaborEntryCreateWithoutMroWorkOrderItemInput;
  update: MroLaborEntryUpdateWithoutMroWorkOrderItemInput;
  where: MroLaborEntryWhereUniqueInput;
};

export type MroLaborEntryVersion = {
  __typename?: 'MroLaborEntryVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroLaborEntry?: Maybe<MroLaborEntry>;
  mroLaborEntryId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroLaborEntryVersionAvgAggregate = {
  __typename?: 'MroLaborEntryVersionAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type MroLaborEntryVersionCountAggregate = {
  __typename?: 'MroLaborEntryVersionCountAggregate';
  _all: Scalars['Int'];
  data: Scalars['Int'];
  id: Scalars['Int'];
  mroLaborEntryId: Scalars['Int'];
  operation: Scalars['Int'];
  timestamp: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MroLaborEntryVersionCreateManyMroLaborEntryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLaborEntryVersionCreateManyMroLaborEntryInputEnvelope = {
  data: Array<MroLaborEntryVersionCreateManyMroLaborEntryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLaborEntryVersionCreateNestedManyWithoutMroLaborEntryInput = {
  connect?: InputMaybe<Array<MroLaborEntryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryVersionCreateOrConnectWithoutMroLaborEntryInput>>;
  create?: InputMaybe<Array<MroLaborEntryVersionCreateWithoutMroLaborEntryInput>>;
  createMany?: InputMaybe<MroLaborEntryVersionCreateManyMroLaborEntryInputEnvelope>;
};

export type MroLaborEntryVersionCreateOrConnectWithoutMroLaborEntryInput = {
  create: MroLaborEntryVersionCreateWithoutMroLaborEntryInput;
  where: MroLaborEntryVersionWhereUniqueInput;
};

export type MroLaborEntryVersionCreateWithoutMroLaborEntryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLaborEntryVersionListRelationFilter = {
  every?: InputMaybe<MroLaborEntryVersionWhereInput>;
  none?: InputMaybe<MroLaborEntryVersionWhereInput>;
  some?: InputMaybe<MroLaborEntryVersionWhereInput>;
};

export type MroLaborEntryVersionMaxAggregate = {
  __typename?: 'MroLaborEntryVersionMaxAggregate';
  id?: Maybe<Scalars['Int']>;
  mroLaborEntryId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroLaborEntryVersionMinAggregate = {
  __typename?: 'MroLaborEntryVersionMinAggregate';
  id?: Maybe<Scalars['Int']>;
  mroLaborEntryId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroLaborEntryVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroLaborEntryVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLaborEntryVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLaborEntryVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLaborEntryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLaborEntryVersionSumAggregate = {
  __typename?: 'MroLaborEntryVersionSumAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type MroLaborEntryVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLaborEntryVersionUpdateManyWithWhereWithoutMroLaborEntryInput = {
  data: MroLaborEntryVersionUpdateManyMutationInput;
  where: MroLaborEntryVersionScalarWhereInput;
};

export type MroLaborEntryVersionUpdateManyWithoutMroLaborEntryNestedInput = {
  connect?: InputMaybe<Array<MroLaborEntryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLaborEntryVersionCreateOrConnectWithoutMroLaborEntryInput>>;
  create?: InputMaybe<Array<MroLaborEntryVersionCreateWithoutMroLaborEntryInput>>;
  createMany?: InputMaybe<MroLaborEntryVersionCreateManyMroLaborEntryInputEnvelope>;
  delete?: InputMaybe<Array<MroLaborEntryVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLaborEntryVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLaborEntryVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLaborEntryVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLaborEntryVersionUpdateWithWhereUniqueWithoutMroLaborEntryInput>>;
  updateMany?: InputMaybe<Array<MroLaborEntryVersionUpdateManyWithWhereWithoutMroLaborEntryInput>>;
  upsert?: InputMaybe<Array<MroLaborEntryVersionUpsertWithWhereUniqueWithoutMroLaborEntryInput>>;
};

export type MroLaborEntryVersionUpdateWithWhereUniqueWithoutMroLaborEntryInput = {
  data: MroLaborEntryVersionUpdateWithoutMroLaborEntryInput;
  where: MroLaborEntryVersionWhereUniqueInput;
};

export type MroLaborEntryVersionUpdateWithoutMroLaborEntryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLaborEntryVersionUpsertWithWhereUniqueWithoutMroLaborEntryInput = {
  create: MroLaborEntryVersionCreateWithoutMroLaborEntryInput;
  update: MroLaborEntryVersionUpdateWithoutMroLaborEntryInput;
  where: MroLaborEntryVersionWhereUniqueInput;
};

export type MroLaborEntryVersionWhereInput = {
  AND?: InputMaybe<Array<MroLaborEntryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLaborEntryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLaborEntryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLaborEntry?: InputMaybe<MroLaborEntryNullableScalarRelationFilter>;
  mroLaborEntryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLaborEntryVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLaborEntryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLaborEntryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLaborEntryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroLaborEntry?: InputMaybe<MroLaborEntryNullableScalarRelationFilter>;
  mroLaborEntryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLaborEntryWhereInput = {
  AND?: InputMaybe<Array<MroLaborEntryWhereInput>>;
  NOT?: InputMaybe<Array<MroLaborEntryWhereInput>>;
  OR?: InputMaybe<Array<MroLaborEntryWhereInput>>;
  billable?: InputMaybe<BoolNullableFilter>;
  billableRate?: InputMaybe<DecimalNullableFilter>;
  costRate?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  hours?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  pauseTime?: InputMaybe<DateTimeNullableFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLaborEntryVersionListRelationFilter>;
};

export type MroLaborEntryWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLaborEntryWhereInput>>;
  NOT?: InputMaybe<Array<MroLaborEntryWhereInput>>;
  OR?: InputMaybe<Array<MroLaborEntryWhereInput>>;
  billable?: InputMaybe<BoolNullableFilter>;
  billableRate?: InputMaybe<DecimalNullableFilter>;
  costRate?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  hours?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfile?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  mroEmployeeProfileId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  pauseTime?: InputMaybe<DateTimeNullableFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLaborEntryVersionListRelationFilter>;
};

export type MroLocation = {
  __typename?: 'MroLocation';
  _count: MroLocationCount;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  fees?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrders?: Maybe<Array<MroWorkOrder>>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroLocationVersion>>;
};

export type MroLocationCount = {
  __typename?: 'MroLocationCount';
  mroWorkOrders: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroLocationCountAggregate = {
  __typename?: 'MroLocationCountAggregate';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  fees: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroLocationCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutLocationsInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroLocationInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLocationVersionCreateNestedManyWithoutMroLocationInput>;
};

export type MroLocationCreateManyMroOrganizationInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLocationCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroLocationCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLocationCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLocationCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroLocationCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroLocationCreateManyMroOrganizationInputEnvelope>;
};

export type MroLocationCreateNestedOneWithoutMroWorkOrdersInput = {
  connect?: InputMaybe<MroLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroLocationCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroLocationCreateWithoutMroWorkOrdersInput>;
};

export type MroLocationCreateOrConnectWithoutMroOrganizationInput = {
  create: MroLocationCreateWithoutMroOrganizationInput;
  where: MroLocationWhereUniqueInput;
};

export type MroLocationCreateOrConnectWithoutMroWorkOrdersInput = {
  create: MroLocationCreateWithoutMroWorkOrdersInput;
  where: MroLocationWhereUniqueInput;
};

export type MroLocationCreateWithoutMroOrganizationInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroLocationInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLocationVersionCreateNestedManyWithoutMroLocationInput>;
};

export type MroLocationCreateWithoutMroWorkOrdersInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutLocationsInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLocationVersionCreateNestedManyWithoutMroLocationInput>;
};

export type MroLocationListRelationFilter = {
  every?: InputMaybe<MroLocationWhereInput>;
  none?: InputMaybe<MroLocationWhereInput>;
  some?: InputMaybe<MroLocationWhereInput>;
};

export type MroLocationMaxAggregate = {
  __typename?: 'MroLocationMaxAggregate';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLocationMinAggregate = {
  __typename?: 'MroLocationMinAggregate';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLocationNullableScalarRelationFilter = {
  is?: InputMaybe<MroLocationWhereInput>;
  isNot?: InputMaybe<MroLocationWhereInput>;
};

export type MroLocationScalarWhereInput = {
  AND?: InputMaybe<Array<MroLocationScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLocationScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLocationScalarWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fees?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroLocationUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutLocationsNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroLocationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLocationVersionUpdateManyWithoutMroLocationNestedInput>;
};

export type MroLocationUpdateManyMutationInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLocationUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroLocationUpdateManyMutationInput;
  where: MroLocationScalarWhereInput;
};

export type MroLocationUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLocationCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroLocationCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroLocationCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroLocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLocationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLocationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLocationUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroLocationUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroLocationUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroLocationUpdateOneWithoutMroWorkOrdersNestedInput = {
  connect?: InputMaybe<MroLocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroLocationCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroLocationCreateWithoutMroWorkOrdersInput>;
  delete?: InputMaybe<MroLocationWhereInput>;
  disconnect?: InputMaybe<MroLocationWhereInput>;
  update?: InputMaybe<MroLocationUpdateToOneWithWhereWithoutMroWorkOrdersInput>;
  upsert?: InputMaybe<MroLocationUpsertWithoutMroWorkOrdersInput>;
};

export type MroLocationUpdateToOneWithWhereWithoutMroWorkOrdersInput = {
  data: MroLocationUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroLocationWhereInput>;
};

export type MroLocationUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroLocationUpdateWithoutMroOrganizationInput;
  where: MroLocationWhereUniqueInput;
};

export type MroLocationUpdateWithoutMroOrganizationInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroLocationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLocationVersionUpdateManyWithoutMroLocationNestedInput>;
};

export type MroLocationUpdateWithoutMroWorkOrdersInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fees?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutLocationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLocationVersionUpdateManyWithoutMroLocationNestedInput>;
};

export type MroLocationUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroLocationCreateWithoutMroOrganizationInput;
  update: MroLocationUpdateWithoutMroOrganizationInput;
  where: MroLocationWhereUniqueInput;
};

export type MroLocationUpsertWithoutMroWorkOrdersInput = {
  create: MroLocationCreateWithoutMroWorkOrdersInput;
  update: MroLocationUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroLocationWhereInput>;
};

export type MroLocationVersion = {
  __typename?: 'MroLocationVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroLocation?: Maybe<MroLocation>;
  mroLocationId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroLocationVersionCreateManyMroLocationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLocationVersionCreateManyMroLocationInputEnvelope = {
  data: Array<MroLocationVersionCreateManyMroLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLocationVersionCreateNestedManyWithoutMroLocationInput = {
  connect?: InputMaybe<Array<MroLocationVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLocationVersionCreateOrConnectWithoutMroLocationInput>>;
  create?: InputMaybe<Array<MroLocationVersionCreateWithoutMroLocationInput>>;
  createMany?: InputMaybe<MroLocationVersionCreateManyMroLocationInputEnvelope>;
};

export type MroLocationVersionCreateOrConnectWithoutMroLocationInput = {
  create: MroLocationVersionCreateWithoutMroLocationInput;
  where: MroLocationVersionWhereUniqueInput;
};

export type MroLocationVersionCreateWithoutMroLocationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLocationVersionListRelationFilter = {
  every?: InputMaybe<MroLocationVersionWhereInput>;
  none?: InputMaybe<MroLocationVersionWhereInput>;
  some?: InputMaybe<MroLocationVersionWhereInput>;
};

export type MroLocationVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroLocationVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLocationVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLocationVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLocationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLocationVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLocationVersionUpdateManyWithWhereWithoutMroLocationInput = {
  data: MroLocationVersionUpdateManyMutationInput;
  where: MroLocationVersionScalarWhereInput;
};

export type MroLocationVersionUpdateManyWithoutMroLocationNestedInput = {
  connect?: InputMaybe<Array<MroLocationVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLocationVersionCreateOrConnectWithoutMroLocationInput>>;
  create?: InputMaybe<Array<MroLocationVersionCreateWithoutMroLocationInput>>;
  createMany?: InputMaybe<MroLocationVersionCreateManyMroLocationInputEnvelope>;
  delete?: InputMaybe<Array<MroLocationVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLocationVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLocationVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLocationVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLocationVersionUpdateWithWhereUniqueWithoutMroLocationInput>>;
  updateMany?: InputMaybe<Array<MroLocationVersionUpdateManyWithWhereWithoutMroLocationInput>>;
  upsert?: InputMaybe<Array<MroLocationVersionUpsertWithWhereUniqueWithoutMroLocationInput>>;
};

export type MroLocationVersionUpdateWithWhereUniqueWithoutMroLocationInput = {
  data: MroLocationVersionUpdateWithoutMroLocationInput;
  where: MroLocationVersionWhereUniqueInput;
};

export type MroLocationVersionUpdateWithoutMroLocationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLocationVersionUpsertWithWhereUniqueWithoutMroLocationInput = {
  create: MroLocationVersionCreateWithoutMroLocationInput;
  update: MroLocationVersionUpdateWithoutMroLocationInput;
  where: MroLocationVersionWhereUniqueInput;
};

export type MroLocationVersionWhereInput = {
  AND?: InputMaybe<Array<MroLocationVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLocationVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLocationVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLocation?: InputMaybe<MroLocationNullableScalarRelationFilter>;
  mroLocationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLocationVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLocationVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLocationVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLocationVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroLocation?: InputMaybe<MroLocationNullableScalarRelationFilter>;
  mroLocationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLocationWhereInput = {
  AND?: InputMaybe<Array<MroLocationWhereInput>>;
  NOT?: InputMaybe<Array<MroLocationWhereInput>>;
  OR?: InputMaybe<Array<MroLocationWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fees?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLocationVersionListRelationFilter>;
};

export type MroLocationWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLocationWhereInput>>;
  NOT?: InputMaybe<Array<MroLocationWhereInput>>;
  OR?: InputMaybe<Array<MroLocationWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  fees?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLocationVersionListRelationFilter>;
};

export type MroLogEntry = {
  __typename?: 'MroLogEntry';
  _count: MroLogEntryCount;
  certificationText?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  intervals?: Maybe<Array<Interval>>;
  itemCategory?: Maybe<MroWorkOrderItemCategory>;
  itemCategoryId?: Maybe<Scalars['String']>;
  mroComponent?: Maybe<MroComponent>;
  mroComponentId?: Maybe<Scalars['String']>;
  mroLogEntryItems?: Maybe<Array<MroLogEntryItem>>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  pdfLink: Scalars['String'];
  rtsText?: Maybe<MroRtsText>;
  rtsTextId?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signer?: Maybe<MroEmployeeProfile>;
  signerId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroLogEntryVersion>>;
};

export type MroLogEntryAvgAggregate = {
  __typename?: 'MroLogEntryAvgAggregate';
  sortOrder?: Maybe<Scalars['Float']>;
};

export type MroLogEntryCount = {
  __typename?: 'MroLogEntryCount';
  intervals: Scalars['Int'];
  mroLogEntryItems: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroLogEntryCountAggregate = {
  __typename?: 'MroLogEntryCountAggregate';
  _all: Scalars['Int'];
  certificationText: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  itemCategoryId: Scalars['Int'];
  mroComponentId: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  rtsTextId: Scalars['Int'];
  signedAt: Scalars['Int'];
  signerId: Scalars['Int'];
  sortOrder: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroLogEntryCreateInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateManyItemCategoryInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroComponentId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  rtsTextId?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signerId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryCreateManyItemCategoryInputEnvelope = {
  data: Array<MroLogEntryCreateManyItemCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryCreateManyMroComponentInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategoryId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  rtsTextId?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signerId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryCreateManyMroComponentInputEnvelope = {
  data: Array<MroLogEntryCreateManyMroComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryCreateManyMroWorkOrderInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategoryId?: InputMaybe<Scalars['String']>;
  mroComponentId?: InputMaybe<Scalars['String']>;
  rtsTextId?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signerId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroLogEntryCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryCreateManyRtsTextInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategoryId?: InputMaybe<Scalars['String']>;
  mroComponentId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signerId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryCreateManyRtsTextInputEnvelope = {
  data: Array<MroLogEntryCreateManyRtsTextInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryCreateManySignerInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategoryId?: InputMaybe<Scalars['String']>;
  mroComponentId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  rtsTextId?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryCreateManySignerInputEnvelope = {
  data: Array<MroLogEntryCreateManySignerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryCreateNestedManyWithoutItemCategoryInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutItemCategoryInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutItemCategoryInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyItemCategoryInputEnvelope>;
};

export type MroLogEntryCreateNestedManyWithoutMroComponentInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutMroComponentInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutMroComponentInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyMroComponentInputEnvelope>;
};

export type MroLogEntryCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyMroWorkOrderInputEnvelope>;
};

export type MroLogEntryCreateNestedManyWithoutRtsTextInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutRtsTextInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutRtsTextInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyRtsTextInputEnvelope>;
};

export type MroLogEntryCreateNestedManyWithoutSignerInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutSignerInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutSignerInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManySignerInputEnvelope>;
};

export type MroLogEntryCreateNestedOneWithoutIntervalsInput = {
  connect?: InputMaybe<MroLogEntryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroLogEntryCreateOrConnectWithoutIntervalsInput>;
  create?: InputMaybe<MroLogEntryCreateWithoutIntervalsInput>;
};

export type MroLogEntryCreateNestedOneWithoutMroLogEntryItemsInput = {
  connect?: InputMaybe<MroLogEntryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroLogEntryCreateOrConnectWithoutMroLogEntryItemsInput>;
  create?: InputMaybe<MroLogEntryCreateWithoutMroLogEntryItemsInput>;
};

export type MroLogEntryCreateOrConnectWithoutIntervalsInput = {
  create: MroLogEntryCreateWithoutIntervalsInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateOrConnectWithoutItemCategoryInput = {
  create: MroLogEntryCreateWithoutItemCategoryInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateOrConnectWithoutMroComponentInput = {
  create: MroLogEntryCreateWithoutMroComponentInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateOrConnectWithoutMroLogEntryItemsInput = {
  create: MroLogEntryCreateWithoutMroLogEntryItemsInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroLogEntryCreateWithoutMroWorkOrderInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateOrConnectWithoutRtsTextInput = {
  create: MroLogEntryCreateWithoutRtsTextInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateOrConnectWithoutSignerInput = {
  create: MroLogEntryCreateWithoutSignerInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryCreateWithoutIntervalsInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateWithoutItemCategoryInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateWithoutMroComponentInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateWithoutMroLogEntryItemsInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateWithoutMroWorkOrderInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateWithoutRtsTextInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroLogEntriesInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryCreateWithoutSignerInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutMroLogEntryInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroLogEntriesInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput>;
  rtsText?: InputMaybe<MroRtsTextCreateNestedOneWithoutMroLogEntriesInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput>;
};

export type MroLogEntryItem = {
  __typename?: 'MroLogEntryItem';
  _count: MroLogEntryItemCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEditable: Scalars['Boolean'];
  mroLogEntry?: Maybe<MroLogEntry>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroLogEntryItemVersion>>;
};

export type MroLogEntryItemAvgAggregate = {
  __typename?: 'MroLogEntryItemAvgAggregate';
  sortOrder?: Maybe<Scalars['Float']>;
};

export type MroLogEntryItemCount = {
  __typename?: 'MroLogEntryItemCount';
  versions: Scalars['Int'];
};

export type MroLogEntryItemCountAggregate = {
  __typename?: 'MroLogEntryItemCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  isEditable: Scalars['Int'];
  mroLogEntryId: Scalars['Int'];
  mroWorkOrderItemId: Scalars['Int'];
  sortOrder: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroLogEntryItemCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutMroLogEntryItemsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroLogEntryItemsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryItemVersionCreateNestedManyWithoutMroLogEntryItemInput>;
};

export type MroLogEntryItemCreateManyMroLogEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryItemCreateManyMroLogEntryInputEnvelope = {
  data: Array<MroLogEntryItemCreateManyMroLogEntryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryItemCreateManyMroWorkOrderItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroLogEntryId?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryItemCreateManyMroWorkOrderItemInputEnvelope = {
  data: Array<MroLogEntryItemCreateManyMroWorkOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryItemCreateNestedManyWithoutMroLogEntryInput = {
  connect?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryItemCreateOrConnectWithoutMroLogEntryInput>>;
  create?: InputMaybe<Array<MroLogEntryItemCreateWithoutMroLogEntryInput>>;
  createMany?: InputMaybe<MroLogEntryItemCreateManyMroLogEntryInputEnvelope>;
};

export type MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput = {
  connect?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryItemCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroLogEntryItemCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroLogEntryItemCreateManyMroWorkOrderItemInputEnvelope>;
};

export type MroLogEntryItemCreateOrConnectWithoutMroLogEntryInput = {
  create: MroLogEntryItemCreateWithoutMroLogEntryInput;
  where: MroLogEntryItemWhereUniqueInput;
};

export type MroLogEntryItemCreateOrConnectWithoutMroWorkOrderItemInput = {
  create: MroLogEntryItemCreateWithoutMroWorkOrderItemInput;
  where: MroLogEntryItemWhereUniqueInput;
};

export type MroLogEntryItemCreateWithoutMroLogEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroLogEntryItemsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryItemVersionCreateNestedManyWithoutMroLogEntryItemInput>;
};

export type MroLogEntryItemCreateWithoutMroWorkOrderItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroLogEntry?: InputMaybe<MroLogEntryCreateNestedOneWithoutMroLogEntryItemsInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryItemVersionCreateNestedManyWithoutMroLogEntryItemInput>;
};

export type MroLogEntryItemListRelationFilter = {
  every?: InputMaybe<MroLogEntryItemWhereInput>;
  none?: InputMaybe<MroLogEntryItemWhereInput>;
  some?: InputMaybe<MroLogEntryItemWhereInput>;
};

export type MroLogEntryItemMaxAggregate = {
  __typename?: 'MroLogEntryItemMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLogEntryItemMinAggregate = {
  __typename?: 'MroLogEntryItemMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLogEntryItemNullableScalarRelationFilter = {
  is?: InputMaybe<MroLogEntryItemWhereInput>;
  isNot?: InputMaybe<MroLogEntryItemWhereInput>;
};

export type MroLogEntryItemScalarWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryItemScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEditable?: InputMaybe<BoolFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroLogEntryItemSumAggregate = {
  __typename?: 'MroLogEntryItemSumAggregate';
  sortOrder?: Maybe<Scalars['Int']>;
};

export type MroLogEntryItemUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutMroLogEntryItemsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroLogEntryItemsNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryItemVersionUpdateManyWithoutMroLogEntryItemNestedInput>;
};

export type MroLogEntryItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryItemUpdateManyWithWhereWithoutMroLogEntryInput = {
  data: MroLogEntryItemUpdateManyMutationInput;
  where: MroLogEntryItemScalarWhereInput;
};

export type MroLogEntryItemUpdateManyWithWhereWithoutMroWorkOrderItemInput = {
  data: MroLogEntryItemUpdateManyMutationInput;
  where: MroLogEntryItemScalarWhereInput;
};

export type MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryItemCreateOrConnectWithoutMroLogEntryInput>>;
  create?: InputMaybe<Array<MroLogEntryItemCreateWithoutMroLogEntryInput>>;
  createMany?: InputMaybe<MroLogEntryItemCreateManyMroLogEntryInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryItemUpdateWithWhereUniqueWithoutMroLogEntryInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryItemUpdateManyWithWhereWithoutMroLogEntryInput>>;
  upsert?: InputMaybe<Array<MroLogEntryItemUpsertWithWhereUniqueWithoutMroLogEntryInput>>;
};

export type MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryItemCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroLogEntryItemCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroLogEntryItemCreateManyMroWorkOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryItemUpdateWithWhereUniqueWithoutMroWorkOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryItemUpdateManyWithWhereWithoutMroWorkOrderItemInput>>;
  upsert?: InputMaybe<Array<MroLogEntryItemUpsertWithWhereUniqueWithoutMroWorkOrderItemInput>>;
};

export type MroLogEntryItemUpdateWithWhereUniqueWithoutMroLogEntryInput = {
  data: MroLogEntryItemUpdateWithoutMroLogEntryInput;
  where: MroLogEntryItemWhereUniqueInput;
};

export type MroLogEntryItemUpdateWithWhereUniqueWithoutMroWorkOrderItemInput = {
  data: MroLogEntryItemUpdateWithoutMroWorkOrderItemInput;
  where: MroLogEntryItemWhereUniqueInput;
};

export type MroLogEntryItemUpdateWithoutMroLogEntryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroLogEntryItemsNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryItemVersionUpdateManyWithoutMroLogEntryItemNestedInput>;
};

export type MroLogEntryItemUpdateWithoutMroWorkOrderItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<Scalars['Boolean']>;
  mroLogEntry?: InputMaybe<MroLogEntryUpdateOneWithoutMroLogEntryItemsNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryItemVersionUpdateManyWithoutMroLogEntryItemNestedInput>;
};

export type MroLogEntryItemUpsertWithWhereUniqueWithoutMroLogEntryInput = {
  create: MroLogEntryItemCreateWithoutMroLogEntryInput;
  update: MroLogEntryItemUpdateWithoutMroLogEntryInput;
  where: MroLogEntryItemWhereUniqueInput;
};

export type MroLogEntryItemUpsertWithWhereUniqueWithoutMroWorkOrderItemInput = {
  create: MroLogEntryItemCreateWithoutMroWorkOrderItemInput;
  update: MroLogEntryItemUpdateWithoutMroWorkOrderItemInput;
  where: MroLogEntryItemWhereUniqueInput;
};

export type MroLogEntryItemVersion = {
  __typename?: 'MroLogEntryItemVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroLogEntryItem?: Maybe<MroLogEntryItem>;
  mroLogEntryItemId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroLogEntryItemVersionCreateManyMroLogEntryItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryItemVersionCreateManyMroLogEntryItemInputEnvelope = {
  data: Array<MroLogEntryItemVersionCreateManyMroLogEntryItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryItemVersionCreateNestedManyWithoutMroLogEntryItemInput = {
  connect?: InputMaybe<Array<MroLogEntryItemVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryItemVersionCreateOrConnectWithoutMroLogEntryItemInput>>;
  create?: InputMaybe<Array<MroLogEntryItemVersionCreateWithoutMroLogEntryItemInput>>;
  createMany?: InputMaybe<MroLogEntryItemVersionCreateManyMroLogEntryItemInputEnvelope>;
};

export type MroLogEntryItemVersionCreateOrConnectWithoutMroLogEntryItemInput = {
  create: MroLogEntryItemVersionCreateWithoutMroLogEntryItemInput;
  where: MroLogEntryItemVersionWhereUniqueInput;
};

export type MroLogEntryItemVersionCreateWithoutMroLogEntryItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryItemVersionListRelationFilter = {
  every?: InputMaybe<MroLogEntryItemVersionWhereInput>;
  none?: InputMaybe<MroLogEntryItemVersionWhereInput>;
  some?: InputMaybe<MroLogEntryItemVersionWhereInput>;
};

export type MroLogEntryItemVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryItemVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryItemVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryItemVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLogEntryItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLogEntryItemVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryItemVersionUpdateManyWithWhereWithoutMroLogEntryItemInput = {
  data: MroLogEntryItemVersionUpdateManyMutationInput;
  where: MroLogEntryItemVersionScalarWhereInput;
};

export type MroLogEntryItemVersionUpdateManyWithoutMroLogEntryItemNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryItemVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryItemVersionCreateOrConnectWithoutMroLogEntryItemInput>>;
  create?: InputMaybe<Array<MroLogEntryItemVersionCreateWithoutMroLogEntryItemInput>>;
  createMany?: InputMaybe<MroLogEntryItemVersionCreateManyMroLogEntryItemInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryItemVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryItemVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryItemVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryItemVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryItemVersionUpdateWithWhereUniqueWithoutMroLogEntryItemInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryItemVersionUpdateManyWithWhereWithoutMroLogEntryItemInput>>;
  upsert?: InputMaybe<Array<MroLogEntryItemVersionUpsertWithWhereUniqueWithoutMroLogEntryItemInput>>;
};

export type MroLogEntryItemVersionUpdateWithWhereUniqueWithoutMroLogEntryItemInput = {
  data: MroLogEntryItemVersionUpdateWithoutMroLogEntryItemInput;
  where: MroLogEntryItemVersionWhereUniqueInput;
};

export type MroLogEntryItemVersionUpdateWithoutMroLogEntryItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryItemVersionUpsertWithWhereUniqueWithoutMroLogEntryItemInput = {
  create: MroLogEntryItemVersionCreateWithoutMroLogEntryItemInput;
  update: MroLogEntryItemVersionUpdateWithoutMroLogEntryItemInput;
  where: MroLogEntryItemVersionWhereUniqueInput;
};

export type MroLogEntryItemVersionWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryItemVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryItemVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryItemVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLogEntryItem?: InputMaybe<MroLogEntryItemNullableScalarRelationFilter>;
  mroLogEntryItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLogEntryItemVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLogEntryItemVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryItemVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryItemVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroLogEntryItem?: InputMaybe<MroLogEntryItemNullableScalarRelationFilter>;
  mroLogEntryItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLogEntryItemWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryItemWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryItemWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isEditable?: InputMaybe<BoolFilter>;
  mroLogEntry?: InputMaybe<MroLogEntryNullableScalarRelationFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLogEntryItemVersionListRelationFilter>;
};

export type MroLogEntryItemWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLogEntryItemWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryItemWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isEditable?: InputMaybe<BoolFilter>;
  mroLogEntry?: InputMaybe<MroLogEntryNullableScalarRelationFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLogEntryItemVersionListRelationFilter>;
};

export type MroLogEntryListRelationFilter = {
  every?: InputMaybe<MroLogEntryWhereInput>;
  none?: InputMaybe<MroLogEntryWhereInput>;
  some?: InputMaybe<MroLogEntryWhereInput>;
};

export type MroLogEntryMaxAggregate = {
  __typename?: 'MroLogEntryMaxAggregate';
  certificationText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  itemCategoryId?: Maybe<Scalars['String']>;
  mroComponentId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  rtsTextId?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signerId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLogEntryMinAggregate = {
  __typename?: 'MroLogEntryMinAggregate';
  certificationText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  itemCategoryId?: Maybe<Scalars['String']>;
  mroComponentId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  rtsTextId?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signerId?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroLogEntryNullableScalarRelationFilter = {
  is?: InputMaybe<MroLogEntryWhereInput>;
  isNot?: InputMaybe<MroLogEntryWhereInput>;
};

export type MroLogEntryScalarWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  certificationText?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  itemCategoryId?: InputMaybe<StringNullableFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  rtsTextId?: InputMaybe<StringNullableFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  signerId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroLogEntrySumAggregate = {
  __typename?: 'MroLogEntrySumAggregate';
  sortOrder?: Maybe<Scalars['Int']>;
};

export type MroLogEntryUpdateInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateManyMutationInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroLogEntryUpdateManyWithWhereWithoutItemCategoryInput = {
  data: MroLogEntryUpdateManyMutationInput;
  where: MroLogEntryScalarWhereInput;
};

export type MroLogEntryUpdateManyWithWhereWithoutMroComponentInput = {
  data: MroLogEntryUpdateManyMutationInput;
  where: MroLogEntryScalarWhereInput;
};

export type MroLogEntryUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroLogEntryUpdateManyMutationInput;
  where: MroLogEntryScalarWhereInput;
};

export type MroLogEntryUpdateManyWithWhereWithoutRtsTextInput = {
  data: MroLogEntryUpdateManyMutationInput;
  where: MroLogEntryScalarWhereInput;
};

export type MroLogEntryUpdateManyWithWhereWithoutSignerInput = {
  data: MroLogEntryUpdateManyMutationInput;
  where: MroLogEntryScalarWhereInput;
};

export type MroLogEntryUpdateManyWithoutItemCategoryNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutItemCategoryInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutItemCategoryInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyItemCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryUpdateWithWhereUniqueWithoutItemCategoryInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryUpdateManyWithWhereWithoutItemCategoryInput>>;
  upsert?: InputMaybe<Array<MroLogEntryUpsertWithWhereUniqueWithoutItemCategoryInput>>;
};

export type MroLogEntryUpdateManyWithoutMroComponentNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutMroComponentInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutMroComponentInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyMroComponentInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryUpdateWithWhereUniqueWithoutMroComponentInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryUpdateManyWithWhereWithoutMroComponentInput>>;
  upsert?: InputMaybe<Array<MroLogEntryUpsertWithWhereUniqueWithoutMroComponentInput>>;
};

export type MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroLogEntryUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroLogEntryUpdateManyWithoutRtsTextNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutRtsTextInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutRtsTextInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManyRtsTextInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryUpdateWithWhereUniqueWithoutRtsTextInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryUpdateManyWithWhereWithoutRtsTextInput>>;
  upsert?: InputMaybe<Array<MroLogEntryUpsertWithWhereUniqueWithoutRtsTextInput>>;
};

export type MroLogEntryUpdateManyWithoutSignerNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryCreateOrConnectWithoutSignerInput>>;
  create?: InputMaybe<Array<MroLogEntryCreateWithoutSignerInput>>;
  createMany?: InputMaybe<MroLogEntryCreateManySignerInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryUpdateWithWhereUniqueWithoutSignerInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryUpdateManyWithWhereWithoutSignerInput>>;
  upsert?: InputMaybe<Array<MroLogEntryUpsertWithWhereUniqueWithoutSignerInput>>;
};

export type MroLogEntryUpdateOneWithoutIntervalsNestedInput = {
  connect?: InputMaybe<MroLogEntryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroLogEntryCreateOrConnectWithoutIntervalsInput>;
  create?: InputMaybe<MroLogEntryCreateWithoutIntervalsInput>;
  delete?: InputMaybe<MroLogEntryWhereInput>;
  disconnect?: InputMaybe<MroLogEntryWhereInput>;
  update?: InputMaybe<MroLogEntryUpdateToOneWithWhereWithoutIntervalsInput>;
  upsert?: InputMaybe<MroLogEntryUpsertWithoutIntervalsInput>;
};

export type MroLogEntryUpdateOneWithoutMroLogEntryItemsNestedInput = {
  connect?: InputMaybe<MroLogEntryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroLogEntryCreateOrConnectWithoutMroLogEntryItemsInput>;
  create?: InputMaybe<MroLogEntryCreateWithoutMroLogEntryItemsInput>;
  delete?: InputMaybe<MroLogEntryWhereInput>;
  disconnect?: InputMaybe<MroLogEntryWhereInput>;
  update?: InputMaybe<MroLogEntryUpdateToOneWithWhereWithoutMroLogEntryItemsInput>;
  upsert?: InputMaybe<MroLogEntryUpsertWithoutMroLogEntryItemsInput>;
};

export type MroLogEntryUpdateToOneWithWhereWithoutIntervalsInput = {
  data: MroLogEntryUpdateWithoutIntervalsInput;
  where?: InputMaybe<MroLogEntryWhereInput>;
};

export type MroLogEntryUpdateToOneWithWhereWithoutMroLogEntryItemsInput = {
  data: MroLogEntryUpdateWithoutMroLogEntryItemsInput;
  where?: InputMaybe<MroLogEntryWhereInput>;
};

export type MroLogEntryUpdateWithWhereUniqueWithoutItemCategoryInput = {
  data: MroLogEntryUpdateWithoutItemCategoryInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpdateWithWhereUniqueWithoutMroComponentInput = {
  data: MroLogEntryUpdateWithoutMroComponentInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroLogEntryUpdateWithoutMroWorkOrderInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpdateWithWhereUniqueWithoutRtsTextInput = {
  data: MroLogEntryUpdateWithoutRtsTextInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpdateWithWhereUniqueWithoutSignerInput = {
  data: MroLogEntryUpdateWithoutSignerInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpdateWithoutIntervalsInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateWithoutItemCategoryInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateWithoutMroComponentInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateWithoutMroLogEntryItemsInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateWithoutMroWorkOrderInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateWithoutRtsTextInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  signer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroLogEntriesNestedInput>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpdateWithoutSignerInput = {
  certificationText?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutMroLogEntryNestedInput>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroLogEntriesNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroLogEntryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput>;
  rtsText?: InputMaybe<MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput>;
  signedAt?: InputMaybe<Scalars['DateTime']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput>;
};

export type MroLogEntryUpsertWithWhereUniqueWithoutItemCategoryInput = {
  create: MroLogEntryCreateWithoutItemCategoryInput;
  update: MroLogEntryUpdateWithoutItemCategoryInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpsertWithWhereUniqueWithoutMroComponentInput = {
  create: MroLogEntryCreateWithoutMroComponentInput;
  update: MroLogEntryUpdateWithoutMroComponentInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroLogEntryCreateWithoutMroWorkOrderInput;
  update: MroLogEntryUpdateWithoutMroWorkOrderInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpsertWithWhereUniqueWithoutRtsTextInput = {
  create: MroLogEntryCreateWithoutRtsTextInput;
  update: MroLogEntryUpdateWithoutRtsTextInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpsertWithWhereUniqueWithoutSignerInput = {
  create: MroLogEntryCreateWithoutSignerInput;
  update: MroLogEntryUpdateWithoutSignerInput;
  where: MroLogEntryWhereUniqueInput;
};

export type MroLogEntryUpsertWithoutIntervalsInput = {
  create: MroLogEntryCreateWithoutIntervalsInput;
  update: MroLogEntryUpdateWithoutIntervalsInput;
  where?: InputMaybe<MroLogEntryWhereInput>;
};

export type MroLogEntryUpsertWithoutMroLogEntryItemsInput = {
  create: MroLogEntryCreateWithoutMroLogEntryItemsInput;
  update: MroLogEntryUpdateWithoutMroLogEntryItemsInput;
  where?: InputMaybe<MroLogEntryWhereInput>;
};

export type MroLogEntryVersion = {
  __typename?: 'MroLogEntryVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroLogEntry?: Maybe<MroLogEntry>;
  mroLogEntryId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroLogEntryVersionCreateManyMroLogEntryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryVersionCreateManyMroLogEntryInputEnvelope = {
  data: Array<MroLogEntryVersionCreateManyMroLogEntryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroLogEntryVersionCreateNestedManyWithoutMroLogEntryInput = {
  connect?: InputMaybe<Array<MroLogEntryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryVersionCreateOrConnectWithoutMroLogEntryInput>>;
  create?: InputMaybe<Array<MroLogEntryVersionCreateWithoutMroLogEntryInput>>;
  createMany?: InputMaybe<MroLogEntryVersionCreateManyMroLogEntryInputEnvelope>;
};

export type MroLogEntryVersionCreateOrConnectWithoutMroLogEntryInput = {
  create: MroLogEntryVersionCreateWithoutMroLogEntryInput;
  where: MroLogEntryVersionWhereUniqueInput;
};

export type MroLogEntryVersionCreateWithoutMroLogEntryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryVersionListRelationFilter = {
  every?: InputMaybe<MroLogEntryVersionWhereInput>;
  none?: InputMaybe<MroLogEntryVersionWhereInput>;
  some?: InputMaybe<MroLogEntryVersionWhereInput>;
};

export type MroLogEntryVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLogEntryVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryVersionUpdateManyWithWhereWithoutMroLogEntryInput = {
  data: MroLogEntryVersionUpdateManyMutationInput;
  where: MroLogEntryVersionScalarWhereInput;
};

export type MroLogEntryVersionUpdateManyWithoutMroLogEntryNestedInput = {
  connect?: InputMaybe<Array<MroLogEntryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroLogEntryVersionCreateOrConnectWithoutMroLogEntryInput>>;
  create?: InputMaybe<Array<MroLogEntryVersionCreateWithoutMroLogEntryInput>>;
  createMany?: InputMaybe<MroLogEntryVersionCreateManyMroLogEntryInputEnvelope>;
  delete?: InputMaybe<Array<MroLogEntryVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroLogEntryVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroLogEntryVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroLogEntryVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroLogEntryVersionUpdateWithWhereUniqueWithoutMroLogEntryInput>>;
  updateMany?: InputMaybe<Array<MroLogEntryVersionUpdateManyWithWhereWithoutMroLogEntryInput>>;
  upsert?: InputMaybe<Array<MroLogEntryVersionUpsertWithWhereUniqueWithoutMroLogEntryInput>>;
};

export type MroLogEntryVersionUpdateWithWhereUniqueWithoutMroLogEntryInput = {
  data: MroLogEntryVersionUpdateWithoutMroLogEntryInput;
  where: MroLogEntryVersionWhereUniqueInput;
};

export type MroLogEntryVersionUpdateWithoutMroLogEntryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroLogEntryVersionUpsertWithWhereUniqueWithoutMroLogEntryInput = {
  create: MroLogEntryVersionCreateWithoutMroLogEntryInput;
  update: MroLogEntryVersionUpdateWithoutMroLogEntryInput;
  where: MroLogEntryVersionWhereUniqueInput;
};

export type MroLogEntryVersionWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroLogEntry?: InputMaybe<MroLogEntryNullableScalarRelationFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLogEntryVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLogEntryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroLogEntry?: InputMaybe<MroLogEntryNullableScalarRelationFilter>;
  mroLogEntryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroLogEntryWhereInput = {
  AND?: InputMaybe<Array<MroLogEntryWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryWhereInput>>;
  certificationText?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  itemCategoryId?: InputMaybe<StringNullableFilter>;
  mroComponent?: InputMaybe<MroComponentNullableScalarRelationFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemListRelationFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  rtsText?: InputMaybe<MroRtsTextNullableScalarRelationFilter>;
  rtsTextId?: InputMaybe<StringNullableFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  signer?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  signerId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLogEntryVersionListRelationFilter>;
};

export type MroLogEntryWhereUniqueInput = {
  AND?: InputMaybe<Array<MroLogEntryWhereInput>>;
  NOT?: InputMaybe<Array<MroLogEntryWhereInput>>;
  OR?: InputMaybe<Array<MroLogEntryWhereInput>>;
  certificationText?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  intervals?: InputMaybe<IntervalListRelationFilter>;
  itemCategory?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  itemCategoryId?: InputMaybe<StringNullableFilter>;
  mroComponent?: InputMaybe<MroComponentNullableScalarRelationFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemListRelationFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  rtsText?: InputMaybe<MroRtsTextNullableScalarRelationFilter>;
  rtsTextId?: InputMaybe<StringNullableFilter>;
  signedAt?: InputMaybe<DateTimeNullableFilter>;
  signer?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  signerId?: InputMaybe<StringNullableFilter>;
  sortOrder?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroLogEntryVersionListRelationFilter>;
};

export type MroOrganization = {
  __typename?: 'MroOrganization';
  CraftServiceRequests?: Maybe<Array<CraftServiceRequest>>;
  _count: MroOrganizationCount;
  address?: Maybe<MroAddress>;
  addressId?: Maybe<Scalars['String']>;
  blackAndWhiteIconId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  colorIconId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  defaultCostRate?: Maybe<Scalars['Decimal']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateAuthorization?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<MroLocation>>;
  mroAddresses: Array<MroAddress>;
  mroBlackAndWhiteIcon?: Maybe<Attachment>;
  mroColorIcon?: Maybe<Attachment>;
  mroCommunicationDevices?: Maybe<Array<MroCommunicationDevice>>;
  mroCommunicationMessages?: Maybe<Array<MroCommunicationMessage>>;
  mroCommunicationParticipants?: Maybe<Array<MroCommunicationParticipant>>;
  mroCommunicationThreads?: Maybe<Array<MroCommunicationThread>>;
  mroContacts: Array<MroContact>;
  mroCrafts: Array<MroCraft>;
  mroCustomers: Array<MroCustomer>;
  mroDocumentTemplates?: Maybe<Array<MroDocumentTemplate>>;
  mroEmployeeProfiles: Array<MroEmployeeProfile>;
  mroInvoiceTerms?: Maybe<Array<MroInvoiceTerm>>;
  mroIssues: Array<MroIssue>;
  mroLaborEntries: Array<MroLaborEntry>;
  mroOrganizationFees?: Maybe<Array<MroOrganizationFee>>;
  mroPartInventories?: Maybe<Array<MroPartInventory>>;
  mroPartOrders?: Maybe<Array<MroPartOrder>>;
  mroPartPriceMatrix?: Maybe<MroPartPriceMatrix>;
  mroPartVendor?: Maybe<Array<MroPartVendor>>;
  mroPartWarehouses?: Maybe<Array<MroPartWarehouse>>;
  mroParts?: Maybe<Array<MroPart>>;
  mroRTSTexts?: Maybe<Array<MroRtsText>>;
  mroReports?: Maybe<Array<MroReport>>;
  mroRoles?: Maybe<Array<MroRole>>;
  mroServiceRequests: Array<MroServiceRequest>;
  mroSettings?: Maybe<Scalars['JSON']>;
  mroWorkOrderCategories?: Maybe<Array<MroWorkOrderCategory>>;
  mroWorkOrderItemCategories?: Maybe<Array<MroWorkOrderItemCategory>>;
  mroWorkOrderItems: Array<MroWorkOrderItem>;
  mroWorkOrderTemplate?: Maybe<Array<MroWorkOrderTemplate>>;
  mroWorkOrders: Array<MroWorkOrder>;
  name: Scalars['String'];
  organizations?: Maybe<Array<Organization>>;
  partPriceMatrixId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<User>>;
  versions?: Maybe<Array<MroOrganizationVersion>>;
};


export type MroOrganizationMroLaborEntriesArgs = {
  where?: InputMaybe<MroLaborEntryWhereInput>;
};


export type MroOrganizationMroServiceRequestsArgs = {
  where?: InputMaybe<MroServiceRequestWhereInput>;
};


export type MroOrganizationMroWorkOrdersArgs = {
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroOrganizationAvgAggregate = {
  __typename?: 'MroOrganizationAvgAggregate';
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  defaultCostRate?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationCount = {
  __typename?: 'MroOrganizationCount';
  CraftServiceRequests: Scalars['Int'];
  locations: Scalars['Int'];
  mroAddresses: Scalars['Int'];
  mroCommunicationDevices: Scalars['Int'];
  mroCommunicationMessages: Scalars['Int'];
  mroCommunicationParticipants: Scalars['Int'];
  mroCommunicationThreads: Scalars['Int'];
  mroContacts: Scalars['Int'];
  mroCrafts: Scalars['Int'];
  mroCustomers: Scalars['Int'];
  mroDocumentTemplates: Scalars['Int'];
  mroEmployeeProfiles: Scalars['Int'];
  mroInvoiceTerms: Scalars['Int'];
  mroIssues: Scalars['Int'];
  mroLaborEntries: Scalars['Int'];
  mroOrganizationFees: Scalars['Int'];
  mroPartInventories: Scalars['Int'];
  mroPartOrders: Scalars['Int'];
  mroPartVendor: Scalars['Int'];
  mroPartWarehouses: Scalars['Int'];
  mroParts: Scalars['Int'];
  mroRTSTexts: Scalars['Int'];
  mroReports: Scalars['Int'];
  mroRoles: Scalars['Int'];
  mroServiceRequests: Scalars['Int'];
  mroWorkOrderCategories: Scalars['Int'];
  mroWorkOrderItemCategories: Scalars['Int'];
  mroWorkOrderItems: Scalars['Int'];
  mroWorkOrderTemplate: Scalars['Int'];
  mroWorkOrders: Scalars['Int'];
  organizations: Scalars['Int'];
  users: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroOrganizationCountAggregate = {
  __typename?: 'MroOrganizationCountAggregate';
  _all: Scalars['Int'];
  addressId: Scalars['Int'];
  blackAndWhiteIconId: Scalars['Int'];
  code: Scalars['Int'];
  colorIconId: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultBillableRate: Scalars['Int'];
  defaultCostRate: Scalars['Int'];
  deletedAt: Scalars['Int'];
  estimateAuthorization: Scalars['Int'];
  id: Scalars['Int'];
  isPublic: Scalars['Int'];
  mroSettings: Scalars['Int'];
  name: Scalars['Int'];
  partPriceMatrixId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroOrganizationCreateInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateManyAddressInput = {
  blackAndWhiteIconId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  colorIconId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  partPriceMatrixId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroOrganizationCreateManyAddressInputEnvelope = {
  data: Array<MroOrganizationCreateManyAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroOrganizationCreateManyMroBlackAndWhiteIconInput = {
  addressId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  colorIconId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  partPriceMatrixId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroOrganizationCreateManyMroBlackAndWhiteIconInputEnvelope = {
  data: Array<MroOrganizationCreateManyMroBlackAndWhiteIconInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroOrganizationCreateManyMroColorIconInput = {
  addressId?: InputMaybe<Scalars['String']>;
  blackAndWhiteIconId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  partPriceMatrixId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroOrganizationCreateManyMroColorIconInputEnvelope = {
  data: Array<MroOrganizationCreateManyMroColorIconInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroOrganizationCreateManyMroPartPriceMatrixInput = {
  addressId?: InputMaybe<Scalars['String']>;
  blackAndWhiteIconId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  colorIconId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroOrganizationCreateManyMroPartPriceMatrixInputEnvelope = {
  data: Array<MroOrganizationCreateManyMroPartPriceMatrixInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroOrganizationCreateNestedManyWithoutAddressInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyAddressInputEnvelope>;
};

export type MroOrganizationCreateNestedManyWithoutMroBlackAndWhiteIconInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroBlackAndWhiteIconInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroBlackAndWhiteIconInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyMroBlackAndWhiteIconInputEnvelope>;
};

export type MroOrganizationCreateNestedManyWithoutMroColorIconInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroColorIconInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroColorIconInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyMroColorIconInputEnvelope>;
};

export type MroOrganizationCreateNestedManyWithoutMroDocumentTemplatesInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroDocumentTemplatesInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroDocumentTemplatesInput>>;
};

export type MroOrganizationCreateNestedManyWithoutMroPartPriceMatrixInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroPartPriceMatrixInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroPartPriceMatrixInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyMroPartPriceMatrixInputEnvelope>;
};

export type MroOrganizationCreateNestedManyWithoutOrganizationsInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutOrganizationsInput>>;
};

export type MroOrganizationCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutUsersInput>>;
};

export type MroOrganizationCreateNestedOneWithoutCraftServiceRequestsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutCraftServiceRequestsInput>;
};

export type MroOrganizationCreateNestedOneWithoutLocationsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutLocationsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroAddressesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroAddressesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroAddressesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroCommunicationDevicesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationDevicesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationDevicesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroCommunicationMessagesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationMessagesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationMessagesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroCommunicationParticipantsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationParticipantsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroCommunicationThreadsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationThreadsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroContactsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroContactsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroContactsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroCraftsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCraftsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCraftsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroCustomersInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCustomersInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCustomersInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroEmployeeProfilesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroEmployeeProfilesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroEmployeeProfilesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroIssuesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroIssuesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroIssuesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroLaborEntriesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroLaborEntriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroLaborEntriesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroOrganizationFeesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroOrganizationFeesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroOrganizationFeesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroPartInventoriesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartInventoriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartInventoriesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroPartOrdersInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartOrdersInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartOrdersInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroPartVendorInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartVendorInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartVendorInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroPartWarehousesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartWarehousesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartWarehousesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroPartsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroRtsTextsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroRtsTextsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroRtsTextsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroReportsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroReportsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroReportsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroRolesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroRolesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroRolesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroServiceRequestsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroServiceRequestsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroWorkOrderCategoriesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderCategoriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderCategoriesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderItemCategoriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderItemCategoriesInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderItemsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderItemsInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroWorkOrderTemplateInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderTemplateInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderTemplateInput>;
};

export type MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrdersInput>;
};

export type MroOrganizationCreateOrConnectWithoutAddressInput = {
  create: MroOrganizationCreateWithoutAddressInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutCraftServiceRequestsInput = {
  create: MroOrganizationCreateWithoutCraftServiceRequestsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutLocationsInput = {
  create: MroOrganizationCreateWithoutLocationsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroAddressesInput = {
  create: MroOrganizationCreateWithoutMroAddressesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroBlackAndWhiteIconInput = {
  create: MroOrganizationCreateWithoutMroBlackAndWhiteIconInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroColorIconInput = {
  create: MroOrganizationCreateWithoutMroColorIconInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroCommunicationDevicesInput = {
  create: MroOrganizationCreateWithoutMroCommunicationDevicesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroCommunicationMessagesInput = {
  create: MroOrganizationCreateWithoutMroCommunicationMessagesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroCommunicationParticipantsInput = {
  create: MroOrganizationCreateWithoutMroCommunicationParticipantsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroCommunicationThreadsInput = {
  create: MroOrganizationCreateWithoutMroCommunicationThreadsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroContactsInput = {
  create: MroOrganizationCreateWithoutMroContactsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroCraftsInput = {
  create: MroOrganizationCreateWithoutMroCraftsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroCustomersInput = {
  create: MroOrganizationCreateWithoutMroCustomersInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroDocumentTemplatesInput = {
  create: MroOrganizationCreateWithoutMroDocumentTemplatesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroEmployeeProfilesInput = {
  create: MroOrganizationCreateWithoutMroEmployeeProfilesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroIssuesInput = {
  create: MroOrganizationCreateWithoutMroIssuesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroLaborEntriesInput = {
  create: MroOrganizationCreateWithoutMroLaborEntriesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroOrganizationFeesInput = {
  create: MroOrganizationCreateWithoutMroOrganizationFeesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroPartInventoriesInput = {
  create: MroOrganizationCreateWithoutMroPartInventoriesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroPartOrdersInput = {
  create: MroOrganizationCreateWithoutMroPartOrdersInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroPartPriceMatrixInput = {
  create: MroOrganizationCreateWithoutMroPartPriceMatrixInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroPartVendorInput = {
  create: MroOrganizationCreateWithoutMroPartVendorInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroPartWarehousesInput = {
  create: MroOrganizationCreateWithoutMroPartWarehousesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroPartsInput = {
  create: MroOrganizationCreateWithoutMroPartsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroRtsTextsInput = {
  create: MroOrganizationCreateWithoutMroRtsTextsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroReportsInput = {
  create: MroOrganizationCreateWithoutMroReportsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroRolesInput = {
  create: MroOrganizationCreateWithoutMroRolesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroServiceRequestsInput = {
  create: MroOrganizationCreateWithoutMroServiceRequestsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroWorkOrderCategoriesInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderCategoriesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroWorkOrderItemCategoriesInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderItemCategoriesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroWorkOrderItemsInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderItemsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroWorkOrderTemplateInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderTemplateInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutMroWorkOrdersInput = {
  create: MroOrganizationCreateWithoutMroWorkOrdersInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutOrganizationsInput = {
  create: MroOrganizationCreateWithoutOrganizationsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateOrConnectWithoutUsersInput = {
  create: MroOrganizationCreateWithoutUsersInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationCreateWithoutAddressInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutCraftServiceRequestsInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutLocationsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroAddressesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroBlackAndWhiteIconInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroColorIconInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroCommunicationDevicesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroCommunicationMessagesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroCommunicationParticipantsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroCommunicationThreadsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroContactsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroCraftsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroCustomersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroDocumentTemplatesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroEmployeeProfilesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroIssuesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroLaborEntriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroOrganizationFeesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroPartInventoriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroPartOrdersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroPartPriceMatrixInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroPartVendorInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroPartWarehousesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroPartsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroRtsTextsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroReportsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroRolesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroServiceRequestsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroWorkOrderCategoriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroWorkOrderItemCategoriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroWorkOrderItemsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroWorkOrderTemplateInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutMroWorkOrdersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutOrganizationsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserCreateNestedManyWithoutMroOrganizationsInput>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationCreateWithoutUsersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroOrganizationAddressInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationCreateNestedManyWithoutMroOrganizationInput>;
  mroAddresses?: InputMaybe<MroAddressCreateNestedManyWithoutMroOrganizationInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgBAndWIconInput>;
  mroColorIcon?: InputMaybe<AttachmentCreateNestedOneWithoutMroOrgColorIconInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantCreateNestedManyWithoutMroOrganizationInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroOrganizationInput>;
  mroContacts?: InputMaybe<MroContactCreateNestedManyWithoutMroOrganizationInput>;
  mroCrafts?: InputMaybe<MroCraftCreateNestedManyWithoutMroOrganizationInput>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutMroOrganizationInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateCreateNestedManyWithoutMroOrganizationsInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroOrganizationInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermCreateNestedManyWithoutMroOrganizationInput>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroOrganizationInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroOrganizationInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroOrganizationInput>;
  mroPartOrders?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroOrganizationInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedManyWithoutMroOrganizationInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutMroOrganizationInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextCreateNestedManyWithoutMroOrganizationInput>;
  mroReports?: InputMaybe<MroReportCreateNestedManyWithoutMroOrganizationInput>;
  mroRoles?: InputMaybe<MroRoleCreateNestedManyWithoutMroOrganizationInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestCreateNestedManyWithoutMroOrganizationInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroOrganizationInput>;
  name: Scalars['String'];
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutMroOrganizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput>;
};

export type MroOrganizationFee = {
  __typename?: 'MroOrganizationFee';
  active: Scalars['Boolean'];
  billableType: MroFeeType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDiscount: Scalars['Boolean'];
  isPercentage: Scalars['Boolean'];
  mroOrganization: MroOrganization;
  mroOrganizationId: Scalars['String'];
  name: Scalars['String'];
  onByDefault: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeAvgAggregate = {
  __typename?: 'MroOrganizationFeeAvgAggregate';
  value?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeCountAggregate = {
  __typename?: 'MroOrganizationFeeCountAggregate';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  billableType: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  isDiscount: Scalars['Int'];
  isPercentage: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  name: Scalars['Int'];
  onByDefault: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
};

export type MroOrganizationFeeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroFeeType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  mroOrganization: MroOrganizationCreateNestedOneWithoutMroOrganizationFeesInput;
  name: Scalars['String'];
  onByDefault?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeCreateManyMroOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroFeeType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  onByDefault?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroOrganizationFeeCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroOrganizationFeeCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroOrganizationFeeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationFeeCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroOrganizationFeeCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroOrganizationFeeCreateManyMroOrganizationInputEnvelope>;
};

export type MroOrganizationFeeCreateOrConnectWithoutMroOrganizationInput = {
  create: MroOrganizationFeeCreateWithoutMroOrganizationInput;
  where: MroOrganizationFeeWhereUniqueInput;
};

export type MroOrganizationFeeCreateWithoutMroOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroFeeType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  onByDefault?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeListRelationFilter = {
  every?: InputMaybe<MroOrganizationFeeWhereInput>;
  none?: InputMaybe<MroOrganizationFeeWhereInput>;
  some?: InputMaybe<MroOrganizationFeeWhereInput>;
};

export type MroOrganizationFeeMaxAggregate = {
  __typename?: 'MroOrganizationFeeMaxAggregate';
  active?: Maybe<Scalars['Boolean']>;
  billableType?: Maybe<MroFeeType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDiscount?: Maybe<Scalars['Boolean']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onByDefault?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeMinAggregate = {
  __typename?: 'MroOrganizationFeeMinAggregate';
  active?: Maybe<Scalars['Boolean']>;
  billableType?: Maybe<MroFeeType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDiscount?: Maybe<Scalars['Boolean']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onByDefault?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeScalarWhereInput = {
  AND?: InputMaybe<Array<MroOrganizationFeeScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationFeeScalarWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationFeeScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  billableType?: InputMaybe<EnumMroFeeTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDiscount?: InputMaybe<BoolFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  onByDefault?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
};

export type MroOrganizationFeeSumAggregate = {
  __typename?: 'MroOrganizationFeeSumAggregate';
  value?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroFeeType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneRequiredWithoutMroOrganizationFeesNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  onByDefault?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroFeeType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  onByDefault?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroOrganizationFeeUpdateManyMutationInput;
  where: MroOrganizationFeeScalarWhereInput;
};

export type MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationFeeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationFeeCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroOrganizationFeeCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroOrganizationFeeCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroOrganizationFeeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationFeeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationFeeWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationFeeWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationFeeUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationFeeUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroOrganizationFeeUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroOrganizationFeeUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroOrganizationFeeUpdateWithoutMroOrganizationInput;
  where: MroOrganizationFeeWhereUniqueInput;
};

export type MroOrganizationFeeUpdateWithoutMroOrganizationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroFeeType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  onByDefault?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroOrganizationFeeUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroOrganizationFeeCreateWithoutMroOrganizationInput;
  update: MroOrganizationFeeUpdateWithoutMroOrganizationInput;
  where: MroOrganizationFeeWhereUniqueInput;
};

export type MroOrganizationFeeWhereInput = {
  AND?: InputMaybe<Array<MroOrganizationFeeWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationFeeWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationFeeWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  billableType?: InputMaybe<EnumMroFeeTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDiscount?: InputMaybe<BoolFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  mroOrganization?: InputMaybe<MroOrganizationScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  onByDefault?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
};

export type MroOrganizationFeeWhereUniqueInput = {
  AND?: InputMaybe<Array<MroOrganizationFeeWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationFeeWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationFeeWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  billableType?: InputMaybe<EnumMroFeeTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<BoolFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  mroOrganization?: InputMaybe<MroOrganizationScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  onByDefault?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
};

export type MroOrganizationListRelationFilter = {
  every?: InputMaybe<MroOrganizationWhereInput>;
  none?: InputMaybe<MroOrganizationWhereInput>;
  some?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationMaxAggregate = {
  __typename?: 'MroOrganizationMaxAggregate';
  addressId?: Maybe<Scalars['String']>;
  blackAndWhiteIconId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  colorIconId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  defaultCostRate?: Maybe<Scalars['Decimal']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateAuthorization?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  partPriceMatrixId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroOrganizationMinAggregate = {
  __typename?: 'MroOrganizationMinAggregate';
  addressId?: Maybe<Scalars['String']>;
  blackAndWhiteIconId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  colorIconId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  defaultCostRate?: Maybe<Scalars['Decimal']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  estimateAuthorization?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  partPriceMatrixId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroOrganizationNullableScalarRelationFilter = {
  is?: InputMaybe<MroOrganizationWhereInput>;
  isNot?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MroOrganizationScalarRelationFilter = {
  is?: InputMaybe<MroOrganizationWhereInput>;
  isNot?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationScalarWhereInput = {
  AND?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  addressId?: InputMaybe<StringNullableFilter>;
  blackAndWhiteIconId?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  colorIconId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultBillableRate?: InputMaybe<DecimalNullableFilter>;
  defaultCostRate?: InputMaybe<DecimalNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  estimateAuthorization?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  mroSettings?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  partPriceMatrixId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroOrganizationSumAggregate = {
  __typename?: 'MroOrganizationSumAggregate';
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  defaultCostRate?: Maybe<Scalars['Decimal']>;
};

export type MroOrganizationUpdateInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateManyMutationInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroOrganizationUpdateManyWithWhereWithoutAddressInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithWhereWithoutMroBlackAndWhiteIconInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithWhereWithoutMroColorIconInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithWhereWithoutMroDocumentTemplatesInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithWhereWithoutMroPartPriceMatrixInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithWhereWithoutOrganizationsInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithWhereWithoutUsersInput = {
  data: MroOrganizationUpdateManyMutationInput;
  where: MroOrganizationScalarWhereInput;
};

export type MroOrganizationUpdateManyWithoutAddressNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutAddressInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutAddressInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutAddressInput>>;
};

export type MroOrganizationUpdateManyWithoutMroBlackAndWhiteIconNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroBlackAndWhiteIconInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroBlackAndWhiteIconInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyMroBlackAndWhiteIconInputEnvelope>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutMroBlackAndWhiteIconInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutMroBlackAndWhiteIconInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutMroBlackAndWhiteIconInput>>;
};

export type MroOrganizationUpdateManyWithoutMroColorIconNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroColorIconInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroColorIconInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyMroColorIconInputEnvelope>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutMroColorIconInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutMroColorIconInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutMroColorIconInput>>;
};

export type MroOrganizationUpdateManyWithoutMroDocumentTemplatesNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroDocumentTemplatesInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroDocumentTemplatesInput>>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutMroDocumentTemplatesInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutMroDocumentTemplatesInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutMroDocumentTemplatesInput>>;
};

export type MroOrganizationUpdateManyWithoutMroPartPriceMatrixNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutMroPartPriceMatrixInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutMroPartPriceMatrixInput>>;
  createMany?: InputMaybe<MroOrganizationCreateManyMroPartPriceMatrixInputEnvelope>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutMroPartPriceMatrixInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutMroPartPriceMatrixInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutMroPartPriceMatrixInput>>;
};

export type MroOrganizationUpdateManyWithoutOrganizationsNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutOrganizationsInput>>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutOrganizationsInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutOrganizationsInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutOrganizationsInput>>;
};

export type MroOrganizationUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<MroOrganizationCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<MroOrganizationUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type MroOrganizationUpdateOneRequiredWithoutMroOrganizationFeesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroOrganizationFeesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroOrganizationFeesInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroOrganizationFeesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroOrganizationFeesInput>;
};

export type MroOrganizationUpdateOneRequiredWithoutMroRtsTextsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroRtsTextsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroRtsTextsInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroRtsTextsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroRtsTextsInput>;
};

export type MroOrganizationUpdateOneRequiredWithoutMroReportsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroReportsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroReportsInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroReportsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroReportsInput>;
};

export type MroOrganizationUpdateOneWithoutCraftServiceRequestsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutCraftServiceRequestsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutCraftServiceRequestsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutCraftServiceRequestsInput>;
};

export type MroOrganizationUpdateOneWithoutLocationsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutLocationsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutLocationsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutLocationsInput>;
};

export type MroOrganizationUpdateOneWithoutMroAddressesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroAddressesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroAddressesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroAddressesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroAddressesInput>;
};

export type MroOrganizationUpdateOneWithoutMroCommunicationDevicesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationDevicesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationDevicesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationDevicesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroCommunicationDevicesInput>;
};

export type MroOrganizationUpdateOneWithoutMroCommunicationMessagesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationMessagesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationMessagesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationMessagesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroCommunicationMessagesInput>;
};

export type MroOrganizationUpdateOneWithoutMroCommunicationParticipantsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationParticipantsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationParticipantsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroCommunicationParticipantsInput>;
};

export type MroOrganizationUpdateOneWithoutMroCommunicationThreadsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCommunicationThreadsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationThreadsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroCommunicationThreadsInput>;
};

export type MroOrganizationUpdateOneWithoutMroContactsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroContactsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroContactsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroContactsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroContactsInput>;
};

export type MroOrganizationUpdateOneWithoutMroCraftsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCraftsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCraftsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroCraftsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroCraftsInput>;
};

export type MroOrganizationUpdateOneWithoutMroCustomersNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroCustomersInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroCustomersInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroCustomersInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroCustomersInput>;
};

export type MroOrganizationUpdateOneWithoutMroEmployeeProfilesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroEmployeeProfilesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroEmployeeProfilesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroEmployeeProfilesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroEmployeeProfilesInput>;
};

export type MroOrganizationUpdateOneWithoutMroIssuesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroIssuesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroIssuesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroIssuesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroIssuesInput>;
};

export type MroOrganizationUpdateOneWithoutMroLaborEntriesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroLaborEntriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroLaborEntriesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroLaborEntriesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroLaborEntriesInput>;
};

export type MroOrganizationUpdateOneWithoutMroPartInventoriesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartInventoriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartInventoriesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroPartInventoriesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroPartInventoriesInput>;
};

export type MroOrganizationUpdateOneWithoutMroPartOrdersNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartOrdersInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartOrdersInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroPartOrdersInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroPartOrdersInput>;
};

export type MroOrganizationUpdateOneWithoutMroPartVendorNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartVendorInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartVendorInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroPartVendorInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroPartVendorInput>;
};

export type MroOrganizationUpdateOneWithoutMroPartWarehousesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartWarehousesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartWarehousesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroPartWarehousesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroPartWarehousesInput>;
};

export type MroOrganizationUpdateOneWithoutMroPartsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroPartsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroPartsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroPartsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroPartsInput>;
};

export type MroOrganizationUpdateOneWithoutMroRolesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroRolesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroRolesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroRolesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroRolesInput>;
};

export type MroOrganizationUpdateOneWithoutMroServiceRequestsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroServiceRequestsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroServiceRequestsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroServiceRequestsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroServiceRequestsInput>;
};

export type MroOrganizationUpdateOneWithoutMroWorkOrderCategoriesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderCategoriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderCategoriesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderCategoriesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroWorkOrderCategoriesInput>;
};

export type MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderItemCategoriesInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderItemCategoriesInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderItemCategoriesInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroWorkOrderItemCategoriesInput>;
};

export type MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderItemsInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderItemsInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderItemsInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroWorkOrderItemsInput>;
};

export type MroOrganizationUpdateOneWithoutMroWorkOrderTemplateNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrderTemplateInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrderTemplateInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderTemplateInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroWorkOrderTemplateInput>;
};

export type MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput = {
  connect?: InputMaybe<MroOrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroOrganizationCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroOrganizationCreateWithoutMroWorkOrdersInput>;
  delete?: InputMaybe<MroOrganizationWhereInput>;
  disconnect?: InputMaybe<MroOrganizationWhereInput>;
  update?: InputMaybe<MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrdersInput>;
  upsert?: InputMaybe<MroOrganizationUpsertWithoutMroWorkOrdersInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutCraftServiceRequestsInput = {
  data: MroOrganizationUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutLocationsInput = {
  data: MroOrganizationUpdateWithoutLocationsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroAddressesInput = {
  data: MroOrganizationUpdateWithoutMroAddressesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationDevicesInput = {
  data: MroOrganizationUpdateWithoutMroCommunicationDevicesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationMessagesInput = {
  data: MroOrganizationUpdateWithoutMroCommunicationMessagesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationParticipantsInput = {
  data: MroOrganizationUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroCommunicationThreadsInput = {
  data: MroOrganizationUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroContactsInput = {
  data: MroOrganizationUpdateWithoutMroContactsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroCraftsInput = {
  data: MroOrganizationUpdateWithoutMroCraftsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroCustomersInput = {
  data: MroOrganizationUpdateWithoutMroCustomersInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroEmployeeProfilesInput = {
  data: MroOrganizationUpdateWithoutMroEmployeeProfilesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroIssuesInput = {
  data: MroOrganizationUpdateWithoutMroIssuesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroLaborEntriesInput = {
  data: MroOrganizationUpdateWithoutMroLaborEntriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroOrganizationFeesInput = {
  data: MroOrganizationUpdateWithoutMroOrganizationFeesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroPartInventoriesInput = {
  data: MroOrganizationUpdateWithoutMroPartInventoriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroPartOrdersInput = {
  data: MroOrganizationUpdateWithoutMroPartOrdersInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroPartVendorInput = {
  data: MroOrganizationUpdateWithoutMroPartVendorInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroPartWarehousesInput = {
  data: MroOrganizationUpdateWithoutMroPartWarehousesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroPartsInput = {
  data: MroOrganizationUpdateWithoutMroPartsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroRtsTextsInput = {
  data: MroOrganizationUpdateWithoutMroRtsTextsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroReportsInput = {
  data: MroOrganizationUpdateWithoutMroReportsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroRolesInput = {
  data: MroOrganizationUpdateWithoutMroRolesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroServiceRequestsInput = {
  data: MroOrganizationUpdateWithoutMroServiceRequestsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderCategoriesInput = {
  data: MroOrganizationUpdateWithoutMroWorkOrderCategoriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderItemCategoriesInput = {
  data: MroOrganizationUpdateWithoutMroWorkOrderItemCategoriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderItemsInput = {
  data: MroOrganizationUpdateWithoutMroWorkOrderItemsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrderTemplateInput = {
  data: MroOrganizationUpdateWithoutMroWorkOrderTemplateInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateToOneWithWhereWithoutMroWorkOrdersInput = {
  data: MroOrganizationUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutAddressInput = {
  data: MroOrganizationUpdateWithoutAddressInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutMroBlackAndWhiteIconInput = {
  data: MroOrganizationUpdateWithoutMroBlackAndWhiteIconInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutMroColorIconInput = {
  data: MroOrganizationUpdateWithoutMroColorIconInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutMroDocumentTemplatesInput = {
  data: MroOrganizationUpdateWithoutMroDocumentTemplatesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutMroPartPriceMatrixInput = {
  data: MroOrganizationUpdateWithoutMroPartPriceMatrixInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutOrganizationsInput = {
  data: MroOrganizationUpdateWithoutOrganizationsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithWhereUniqueWithoutUsersInput = {
  data: MroOrganizationUpdateWithoutUsersInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpdateWithoutAddressInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutCraftServiceRequestsInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutLocationsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroAddressesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroBlackAndWhiteIconInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroColorIconInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroCommunicationDevicesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroCommunicationMessagesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroCommunicationParticipantsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroCommunicationThreadsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroContactsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroCraftsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroCustomersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroDocumentTemplatesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroEmployeeProfilesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroIssuesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroLaborEntriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroOrganizationFeesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroPartInventoriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroPartOrdersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroPartPriceMatrixInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroPartVendorInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroPartWarehousesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroPartsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroRtsTextsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroReportsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroRolesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroServiceRequestsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroWorkOrderCategoriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroWorkOrderItemCategoriesInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroWorkOrderItemsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroWorkOrderTemplateInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutMroWorkOrdersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutOrganizationsInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  users?: InputMaybe<UserUpdateManyWithoutMroOrganizationsNestedInput>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpdateWithoutUsersInput = {
  CraftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  address?: InputMaybe<MroAddressUpdateOneWithoutMroOrganizationAddressNestedInput>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  defaultCostRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  estimateAuthorization?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<MroLocationUpdateManyWithoutMroOrganizationNestedInput>;
  mroAddresses?: InputMaybe<MroAddressUpdateManyWithoutMroOrganizationNestedInput>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgBAndWIconNestedInput>;
  mroColorIcon?: InputMaybe<AttachmentUpdateOneWithoutMroOrgColorIconNestedInput>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantUpdateManyWithoutMroOrganizationNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroOrganizationNestedInput>;
  mroContacts?: InputMaybe<MroContactUpdateManyWithoutMroOrganizationNestedInput>;
  mroCrafts?: InputMaybe<MroCraftUpdateManyWithoutMroOrganizationNestedInput>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutMroOrganizationNestedInput>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateUpdateManyWithoutMroOrganizationsNestedInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroOrganizationNestedInput>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermUpdateManyWithoutMroOrganizationNestedInput>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroOrganizationNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroOrganizationNestedInput>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartOrders?: InputMaybe<MroPartOrderUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateManyWithoutMroOrganizationNestedInput>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutMroOrganizationNestedInput>;
  mroRTSTexts?: InputMaybe<MroRtsTextUpdateManyWithoutMroOrganizationNestedInput>;
  mroReports?: InputMaybe<MroReportUpdateManyWithoutMroOrganizationNestedInput>;
  mroRoles?: InputMaybe<MroRoleUpdateManyWithoutMroOrganizationNestedInput>;
  mroServiceRequests?: InputMaybe<MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput>;
  mroSettings?: InputMaybe<Scalars['JSON']>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutMroOrganizationsNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput>;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutAddressInput = {
  create: MroOrganizationCreateWithoutAddressInput;
  update: MroOrganizationUpdateWithoutAddressInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutMroBlackAndWhiteIconInput = {
  create: MroOrganizationCreateWithoutMroBlackAndWhiteIconInput;
  update: MroOrganizationUpdateWithoutMroBlackAndWhiteIconInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutMroColorIconInput = {
  create: MroOrganizationCreateWithoutMroColorIconInput;
  update: MroOrganizationUpdateWithoutMroColorIconInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutMroDocumentTemplatesInput = {
  create: MroOrganizationCreateWithoutMroDocumentTemplatesInput;
  update: MroOrganizationUpdateWithoutMroDocumentTemplatesInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutMroPartPriceMatrixInput = {
  create: MroOrganizationCreateWithoutMroPartPriceMatrixInput;
  update: MroOrganizationUpdateWithoutMroPartPriceMatrixInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutOrganizationsInput = {
  create: MroOrganizationCreateWithoutOrganizationsInput;
  update: MroOrganizationUpdateWithoutOrganizationsInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithWhereUniqueWithoutUsersInput = {
  create: MroOrganizationCreateWithoutUsersInput;
  update: MroOrganizationUpdateWithoutUsersInput;
  where: MroOrganizationWhereUniqueInput;
};

export type MroOrganizationUpsertWithoutCraftServiceRequestsInput = {
  create: MroOrganizationCreateWithoutCraftServiceRequestsInput;
  update: MroOrganizationUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutLocationsInput = {
  create: MroOrganizationCreateWithoutLocationsInput;
  update: MroOrganizationUpdateWithoutLocationsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroAddressesInput = {
  create: MroOrganizationCreateWithoutMroAddressesInput;
  update: MroOrganizationUpdateWithoutMroAddressesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroCommunicationDevicesInput = {
  create: MroOrganizationCreateWithoutMroCommunicationDevicesInput;
  update: MroOrganizationUpdateWithoutMroCommunicationDevicesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroCommunicationMessagesInput = {
  create: MroOrganizationCreateWithoutMroCommunicationMessagesInput;
  update: MroOrganizationUpdateWithoutMroCommunicationMessagesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroCommunicationParticipantsInput = {
  create: MroOrganizationCreateWithoutMroCommunicationParticipantsInput;
  update: MroOrganizationUpdateWithoutMroCommunicationParticipantsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroCommunicationThreadsInput = {
  create: MroOrganizationCreateWithoutMroCommunicationThreadsInput;
  update: MroOrganizationUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroContactsInput = {
  create: MroOrganizationCreateWithoutMroContactsInput;
  update: MroOrganizationUpdateWithoutMroContactsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroCraftsInput = {
  create: MroOrganizationCreateWithoutMroCraftsInput;
  update: MroOrganizationUpdateWithoutMroCraftsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroCustomersInput = {
  create: MroOrganizationCreateWithoutMroCustomersInput;
  update: MroOrganizationUpdateWithoutMroCustomersInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroEmployeeProfilesInput = {
  create: MroOrganizationCreateWithoutMroEmployeeProfilesInput;
  update: MroOrganizationUpdateWithoutMroEmployeeProfilesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroIssuesInput = {
  create: MroOrganizationCreateWithoutMroIssuesInput;
  update: MroOrganizationUpdateWithoutMroIssuesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroLaborEntriesInput = {
  create: MroOrganizationCreateWithoutMroLaborEntriesInput;
  update: MroOrganizationUpdateWithoutMroLaborEntriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroOrganizationFeesInput = {
  create: MroOrganizationCreateWithoutMroOrganizationFeesInput;
  update: MroOrganizationUpdateWithoutMroOrganizationFeesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroPartInventoriesInput = {
  create: MroOrganizationCreateWithoutMroPartInventoriesInput;
  update: MroOrganizationUpdateWithoutMroPartInventoriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroPartOrdersInput = {
  create: MroOrganizationCreateWithoutMroPartOrdersInput;
  update: MroOrganizationUpdateWithoutMroPartOrdersInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroPartVendorInput = {
  create: MroOrganizationCreateWithoutMroPartVendorInput;
  update: MroOrganizationUpdateWithoutMroPartVendorInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroPartWarehousesInput = {
  create: MroOrganizationCreateWithoutMroPartWarehousesInput;
  update: MroOrganizationUpdateWithoutMroPartWarehousesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroPartsInput = {
  create: MroOrganizationCreateWithoutMroPartsInput;
  update: MroOrganizationUpdateWithoutMroPartsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroRtsTextsInput = {
  create: MroOrganizationCreateWithoutMroRtsTextsInput;
  update: MroOrganizationUpdateWithoutMroRtsTextsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroReportsInput = {
  create: MroOrganizationCreateWithoutMroReportsInput;
  update: MroOrganizationUpdateWithoutMroReportsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroRolesInput = {
  create: MroOrganizationCreateWithoutMroRolesInput;
  update: MroOrganizationUpdateWithoutMroRolesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroServiceRequestsInput = {
  create: MroOrganizationCreateWithoutMroServiceRequestsInput;
  update: MroOrganizationUpdateWithoutMroServiceRequestsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroWorkOrderCategoriesInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderCategoriesInput;
  update: MroOrganizationUpdateWithoutMroWorkOrderCategoriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroWorkOrderItemCategoriesInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderItemCategoriesInput;
  update: MroOrganizationUpdateWithoutMroWorkOrderItemCategoriesInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroWorkOrderItemsInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderItemsInput;
  update: MroOrganizationUpdateWithoutMroWorkOrderItemsInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroWorkOrderTemplateInput = {
  create: MroOrganizationCreateWithoutMroWorkOrderTemplateInput;
  update: MroOrganizationUpdateWithoutMroWorkOrderTemplateInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationUpsertWithoutMroWorkOrdersInput = {
  create: MroOrganizationCreateWithoutMroWorkOrdersInput;
  update: MroOrganizationUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroOrganizationWhereInput>;
};

export type MroOrganizationVersion = {
  __typename?: 'MroOrganizationVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroOrganizationVersionCreateManyMroOrganizationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroOrganizationVersionCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroOrganizationVersionCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroOrganizationVersionCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroOrganizationVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationVersionCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroOrganizationVersionCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroOrganizationVersionCreateManyMroOrganizationInputEnvelope>;
};

export type MroOrganizationVersionCreateOrConnectWithoutMroOrganizationInput = {
  create: MroOrganizationVersionCreateWithoutMroOrganizationInput;
  where: MroOrganizationVersionWhereUniqueInput;
};

export type MroOrganizationVersionCreateWithoutMroOrganizationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroOrganizationVersionListRelationFilter = {
  every?: InputMaybe<MroOrganizationVersionWhereInput>;
  none?: InputMaybe<MroOrganizationVersionWhereInput>;
  some?: InputMaybe<MroOrganizationVersionWhereInput>;
};

export type MroOrganizationVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroOrganizationVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroOrganizationVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroOrganizationVersionUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroOrganizationVersionUpdateManyMutationInput;
  where: MroOrganizationVersionScalarWhereInput;
};

export type MroOrganizationVersionUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroOrganizationVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroOrganizationVersionCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroOrganizationVersionCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroOrganizationVersionCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroOrganizationVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroOrganizationVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroOrganizationVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroOrganizationVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroOrganizationVersionUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroOrganizationVersionUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroOrganizationVersionUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroOrganizationVersionUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroOrganizationVersionUpdateWithoutMroOrganizationInput;
  where: MroOrganizationVersionWhereUniqueInput;
};

export type MroOrganizationVersionUpdateWithoutMroOrganizationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroOrganizationVersionUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroOrganizationVersionCreateWithoutMroOrganizationInput;
  update: MroOrganizationVersionUpdateWithoutMroOrganizationInput;
  where: MroOrganizationVersionWhereUniqueInput;
};

export type MroOrganizationVersionWhereInput = {
  AND?: InputMaybe<Array<MroOrganizationVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationVersionWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroOrganizationVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroOrganizationVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroOrganizationVersionWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroOrganizationWhereInput = {
  AND?: InputMaybe<Array<MroOrganizationWhereInput>>;
  CraftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  NOT?: InputMaybe<Array<MroOrganizationWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  blackAndWhiteIconId?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  colorIconId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultBillableRate?: InputMaybe<DecimalNullableFilter>;
  defaultCostRate?: InputMaybe<DecimalNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  estimateAuthorization?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  locations?: InputMaybe<MroLocationListRelationFilter>;
  mroAddresses?: InputMaybe<MroAddressListRelationFilter>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  mroColorIcon?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceListRelationFilter>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageListRelationFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroContacts?: InputMaybe<MroContactListRelationFilter>;
  mroCrafts?: InputMaybe<MroCraftListRelationFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateListRelationFilter>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermListRelationFilter>;
  mroIssues?: InputMaybe<MroIssueListRelationFilter>;
  mroLaborEntries?: InputMaybe<MroLaborEntryListRelationFilter>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeListRelationFilter>;
  mroPartInventories?: InputMaybe<MroPartInventoryListRelationFilter>;
  mroPartOrders?: InputMaybe<MroPartOrderListRelationFilter>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixNullableScalarRelationFilter>;
  mroPartVendor?: InputMaybe<MroPartVendorListRelationFilter>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseListRelationFilter>;
  mroParts?: InputMaybe<MroPartListRelationFilter>;
  mroRTSTexts?: InputMaybe<MroRtsTextListRelationFilter>;
  mroReports?: InputMaybe<MroReportListRelationFilter>;
  mroRoles?: InputMaybe<MroRoleListRelationFilter>;
  mroServiceRequests?: InputMaybe<MroServiceRequestListRelationFilter>;
  mroSettings?: InputMaybe<JsonNullableFilter>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryListRelationFilter>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateListRelationFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  partPriceMatrixId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  users?: InputMaybe<UserListRelationFilter>;
  versions?: InputMaybe<MroOrganizationVersionListRelationFilter>;
};

export type MroOrganizationWhereUniqueInput = {
  AND?: InputMaybe<Array<MroOrganizationWhereInput>>;
  CraftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  NOT?: InputMaybe<Array<MroOrganizationWhereInput>>;
  OR?: InputMaybe<Array<MroOrganizationWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  blackAndWhiteIconId?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  colorIconId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultBillableRate?: InputMaybe<DecimalNullableFilter>;
  defaultCostRate?: InputMaybe<DecimalNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  estimateAuthorization?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<BoolNullableFilter>;
  locations?: InputMaybe<MroLocationListRelationFilter>;
  mroAddresses?: InputMaybe<MroAddressListRelationFilter>;
  mroBlackAndWhiteIcon?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  mroColorIcon?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  mroCommunicationDevices?: InputMaybe<MroCommunicationDeviceListRelationFilter>;
  mroCommunicationMessages?: InputMaybe<MroCommunicationMessageListRelationFilter>;
  mroCommunicationParticipants?: InputMaybe<MroCommunicationParticipantListRelationFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroContacts?: InputMaybe<MroContactListRelationFilter>;
  mroCrafts?: InputMaybe<MroCraftListRelationFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroDocumentTemplates?: InputMaybe<MroDocumentTemplateListRelationFilter>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  mroInvoiceTerms?: InputMaybe<MroInvoiceTermListRelationFilter>;
  mroIssues?: InputMaybe<MroIssueListRelationFilter>;
  mroLaborEntries?: InputMaybe<MroLaborEntryListRelationFilter>;
  mroOrganizationFees?: InputMaybe<MroOrganizationFeeListRelationFilter>;
  mroPartInventories?: InputMaybe<MroPartInventoryListRelationFilter>;
  mroPartOrders?: InputMaybe<MroPartOrderListRelationFilter>;
  mroPartPriceMatrix?: InputMaybe<MroPartPriceMatrixNullableScalarRelationFilter>;
  mroPartVendor?: InputMaybe<MroPartVendorListRelationFilter>;
  mroPartWarehouses?: InputMaybe<MroPartWarehouseListRelationFilter>;
  mroParts?: InputMaybe<MroPartListRelationFilter>;
  mroRTSTexts?: InputMaybe<MroRtsTextListRelationFilter>;
  mroReports?: InputMaybe<MroReportListRelationFilter>;
  mroRoles?: InputMaybe<MroRoleListRelationFilter>;
  mroServiceRequests?: InputMaybe<MroServiceRequestListRelationFilter>;
  mroSettings?: InputMaybe<JsonNullableFilter>;
  mroWorkOrderCategories?: InputMaybe<MroWorkOrderCategoryListRelationFilter>;
  mroWorkOrderItemCategories?: InputMaybe<MroWorkOrderItemCategoryListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateListRelationFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  partPriceMatrixId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  users?: InputMaybe<UserListRelationFilter>;
  versions?: InputMaybe<MroOrganizationVersionListRelationFilter>;
};

export type MroPart = {
  __typename?: 'MroPart';
  _count: MroPartCount;
  availablePartInventories: Array<MroPartInventory>;
  availableSerializedParts: Array<MroSerializedPart>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  estimatedCost?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  isSerialized?: Maybe<Scalars['Boolean']>;
  manufacturer?: Maybe<MroPartManufacturer>;
  manufacturerId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartInventories?: Maybe<Array<MroPartInventory>>;
  mroPartOrderItems?: Maybe<Array<MroPartOrderItem>>;
  mroPartSources?: Maybe<Array<MroPartSource>>;
  mroSerializedParts?: Maybe<Array<MroSerializedPart>>;
  mroWorkOrderParts?: Maybe<Array<MroWorkOrderPart>>;
  partNumber: Scalars['String'];
  preferred?: Maybe<Scalars['Boolean']>;
  secondaryPartNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  variants: Array<MroPart>;
  variantsLeft?: Maybe<Array<MroPart>>;
  variantsRight?: Maybe<Array<MroPart>>;
  versions?: Maybe<Array<MroPartVersion>>;
};


export type MroPartEstimatedCostArgs = {
  quantity?: InputMaybe<Scalars['Int']>;
};

export type MroPartCount = {
  __typename?: 'MroPartCount';
  mroPartInventories: Scalars['Int'];
  mroPartOrderItems: Scalars['Int'];
  mroPartSources: Scalars['Int'];
  mroSerializedParts: Scalars['Int'];
  mroWorkOrderParts: Scalars['Int'];
  variantsLeft: Scalars['Int'];
  variantsRight: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroPartCountAggregate = {
  __typename?: 'MroPartCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  isSerialized: Scalars['Int'];
  manufacturerId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  partNumber: Scalars['Int'];
  preferred: Scalars['Int'];
  secondaryPartNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateManyManufacturerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartCreateManyManufacturerInputEnvelope = {
  data: Array<MroPartCreateManyManufacturerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturerId?: InputMaybe<Scalars['String']>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroPartCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartCreateNestedManyWithoutManufacturerInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutManufacturerInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutManufacturerInput>>;
  createMany?: InputMaybe<MroPartCreateManyManufacturerInputEnvelope>;
};

export type MroPartCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartCreateManyMroOrganizationInputEnvelope>;
};

export type MroPartCreateNestedManyWithoutVariantsLeftInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutVariantsLeftInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutVariantsLeftInput>>;
};

export type MroPartCreateNestedManyWithoutVariantsRightInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutVariantsRightInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutVariantsRightInput>>;
};

export type MroPartCreateNestedOneWithoutMroPartInventoriesInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroPartInventoriesInput>;
  create?: InputMaybe<MroPartCreateWithoutMroPartInventoriesInput>;
};

export type MroPartCreateNestedOneWithoutMroPartOrderItemsInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroPartOrderItemsInput>;
  create?: InputMaybe<MroPartCreateWithoutMroPartOrderItemsInput>;
};

export type MroPartCreateNestedOneWithoutMroPartSourcesInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroPartSourcesInput>;
  create?: InputMaybe<MroPartCreateWithoutMroPartSourcesInput>;
};

export type MroPartCreateNestedOneWithoutMroSerializedPartsInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroSerializedPartsInput>;
  create?: InputMaybe<MroPartCreateWithoutMroSerializedPartsInput>;
};

export type MroPartCreateNestedOneWithoutMroWorkOrderPartsInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroPartCreateWithoutMroWorkOrderPartsInput>;
};

export type MroPartCreateOrConnectWithoutManufacturerInput = {
  create: MroPartCreateWithoutManufacturerInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutMroOrganizationInput = {
  create: MroPartCreateWithoutMroOrganizationInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutMroPartInventoriesInput = {
  create: MroPartCreateWithoutMroPartInventoriesInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutMroPartOrderItemsInput = {
  create: MroPartCreateWithoutMroPartOrderItemsInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutMroPartSourcesInput = {
  create: MroPartCreateWithoutMroPartSourcesInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutMroSerializedPartsInput = {
  create: MroPartCreateWithoutMroSerializedPartsInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutMroWorkOrderPartsInput = {
  create: MroPartCreateWithoutMroWorkOrderPartsInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutVariantsLeftInput = {
  create: MroPartCreateWithoutVariantsLeftInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateOrConnectWithoutVariantsRightInput = {
  create: MroPartCreateWithoutVariantsRightInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartCreateWithoutManufacturerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutMroPartInventoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutMroPartOrderItemsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutMroPartSourcesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutMroSerializedPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutMroWorkOrderPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutVariantsLeftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsRight?: InputMaybe<MroPartCreateNestedManyWithoutVariantsLeftInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartCreateWithoutVariantsRightInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerCreateNestedOneWithoutMroPartsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartsInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartInput>;
  mroPartSources?: InputMaybe<MroPartSourceCreateNestedManyWithoutMroPartInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInput>;
  partNumber: Scalars['String'];
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartCreateNestedManyWithoutVariantsRightInput>;
  versions?: InputMaybe<MroPartVersionCreateNestedManyWithoutMroPartInput>;
};

export type MroPartInventory = {
  __typename?: 'MroPartInventory';
  _count: MroPartInventoryCount;
  bin?: Maybe<Scalars['String']>;
  condition?: Maybe<PartCondition>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lotNumber?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPart: MroPart;
  mroPartId: Scalars['String'];
  mroPartWarehouse?: Maybe<MroPartWarehouse>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  mroWorkOrderParts?: Maybe<Array<MroWorkOrderPart>>;
  notes?: Maybe<Scalars['String']>;
  partPriceUpdatedAt?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroPartInventoryVersion>>;
};

export type MroPartInventoryAvgAggregate = {
  __typename?: 'MroPartInventoryAvgAggregate';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroPartInventoryCount = {
  __typename?: 'MroPartInventoryCount';
  mroWorkOrderParts: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroPartInventoryCountAggregate = {
  __typename?: 'MroPartInventoryCountAggregate';
  _all: Scalars['Int'];
  bin: Scalars['Int'];
  condition: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  expirationDate: Scalars['Int'];
  id: Scalars['Int'];
  lotNumber: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroPartId: Scalars['Int'];
  mroPartWarehouseId: Scalars['Int'];
  notes: Scalars['Int'];
  partPriceUpdatedAt: Scalars['Int'];
  quantity: Scalars['Int'];
  status: Scalars['Int'];
  unitPrice: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartInventoryCreateInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartInventoriesInput>;
  mroPart: MroPartCreateNestedOneWithoutMroPartInventoriesInput;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroPartInventoryInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInventoryInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionCreateNestedManyWithoutMroPartInventoryInput>;
};

export type MroPartInventoryCreateManyMroOrganizationInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPartId: Scalars['String'];
  mroPartWarehouseId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartInventoryCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroPartInventoryCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartInventoryCreateManyMroPartInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroPartWarehouseId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartInventoryCreateManyMroPartInputEnvelope = {
  data: Array<MroPartInventoryCreateManyMroPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartInventoryCreateManyMroPartWarehouseInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroPartId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartInventoryCreateManyMroPartWarehouseInputEnvelope = {
  data: Array<MroPartInventoryCreateManyMroPartWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartInventoryCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartInventoryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartInventoryCreateManyMroOrganizationInputEnvelope>;
};

export type MroPartInventoryCreateNestedManyWithoutMroPartInput = {
  connect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartInventoryCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartInventoryCreateManyMroPartInputEnvelope>;
};

export type MroPartInventoryCreateNestedManyWithoutMroPartWarehouseInput = {
  connect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryCreateOrConnectWithoutMroPartWarehouseInput>>;
  create?: InputMaybe<Array<MroPartInventoryCreateWithoutMroPartWarehouseInput>>;
  createMany?: InputMaybe<MroPartInventoryCreateManyMroPartWarehouseInputEnvelope>;
};

export type MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput = {
  connect?: InputMaybe<MroPartInventoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartInventoryCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroPartInventoryCreateWithoutMroWorkOrderPartsInput>;
};

export type MroPartInventoryCreateOrConnectWithoutMroOrganizationInput = {
  create: MroPartInventoryCreateWithoutMroOrganizationInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryCreateOrConnectWithoutMroPartInput = {
  create: MroPartInventoryCreateWithoutMroPartInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryCreateOrConnectWithoutMroPartWarehouseInput = {
  create: MroPartInventoryCreateWithoutMroPartWarehouseInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryCreateOrConnectWithoutMroWorkOrderPartsInput = {
  create: MroPartInventoryCreateWithoutMroWorkOrderPartsInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryCreateWithoutMroOrganizationInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart: MroPartCreateNestedOneWithoutMroPartInventoriesInput;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroPartInventoryInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInventoryInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionCreateNestedManyWithoutMroPartInventoryInput>;
};

export type MroPartInventoryCreateWithoutMroPartInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartInventoriesInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroPartInventoryInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInventoryInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionCreateNestedManyWithoutMroPartInventoryInput>;
};

export type MroPartInventoryCreateWithoutMroPartWarehouseInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartInventoriesInput>;
  mroPart: MroPartCreateNestedOneWithoutMroPartInventoriesInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroPartInventoryInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionCreateNestedManyWithoutMroPartInventoryInput>;
};

export type MroPartInventoryCreateWithoutMroWorkOrderPartsInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartInventoriesInput>;
  mroPart: MroPartCreateNestedOneWithoutMroPartInventoriesInput;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroPartInventoryInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionCreateNestedManyWithoutMroPartInventoryInput>;
};

export type MroPartInventoryListRelationFilter = {
  every?: InputMaybe<MroPartInventoryWhereInput>;
  none?: InputMaybe<MroPartInventoryWhereInput>;
  some?: InputMaybe<MroPartInventoryWhereInput>;
};

export type MroPartInventoryMaxAggregate = {
  __typename?: 'MroPartInventoryMaxAggregate';
  bin?: Maybe<Scalars['String']>;
  condition?: Maybe<PartCondition>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partPriceUpdatedAt?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartInventoryMinAggregate = {
  __typename?: 'MroPartInventoryMinAggregate';
  bin?: Maybe<Scalars['String']>;
  condition?: Maybe<PartCondition>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partPriceUpdatedAt?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartInventoryNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartInventoryWhereInput>;
  isNot?: InputMaybe<MroPartInventoryWhereInput>;
};

export type MroPartInventoryScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartInventoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartInventoryScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartInventoryScalarWhereInput>>;
  bin?: InputMaybe<StringNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lotNumber?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartId?: InputMaybe<StringFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partPriceUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartInventorySumAggregate = {
  __typename?: 'MroPartInventorySumAggregate';
  quantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroPartInventoryUpdateInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartInventoriesNestedInput>;
  mroPart?: InputMaybe<MroPartUpdateOneRequiredWithoutMroPartInventoriesNestedInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroPartInventoryNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartInventoryNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionUpdateManyWithoutMroPartInventoryNestedInput>;
};

export type MroPartInventoryUpdateManyMutationInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartInventoryUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroPartInventoryUpdateManyMutationInput;
  where: MroPartInventoryScalarWhereInput;
};

export type MroPartInventoryUpdateManyWithWhereWithoutMroPartInput = {
  data: MroPartInventoryUpdateManyMutationInput;
  where: MroPartInventoryScalarWhereInput;
};

export type MroPartInventoryUpdateManyWithWhereWithoutMroPartWarehouseInput = {
  data: MroPartInventoryUpdateManyMutationInput;
  where: MroPartInventoryScalarWhereInput;
};

export type MroPartInventoryUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartInventoryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartInventoryCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartInventoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartInventoryUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroPartInventoryUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroPartInventoryUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroPartInventoryUpdateManyWithoutMroPartNestedInput = {
  connect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartInventoryCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartInventoryCreateManyMroPartInputEnvelope>;
  delete?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartInventoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartInventoryUpdateWithWhereUniqueWithoutMroPartInput>>;
  updateMany?: InputMaybe<Array<MroPartInventoryUpdateManyWithWhereWithoutMroPartInput>>;
  upsert?: InputMaybe<Array<MroPartInventoryUpsertWithWhereUniqueWithoutMroPartInput>>;
};

export type MroPartInventoryUpdateManyWithoutMroPartWarehouseNestedInput = {
  connect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryCreateOrConnectWithoutMroPartWarehouseInput>>;
  create?: InputMaybe<Array<MroPartInventoryCreateWithoutMroPartWarehouseInput>>;
  createMany?: InputMaybe<MroPartInventoryCreateManyMroPartWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartInventoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartInventoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartInventoryUpdateWithWhereUniqueWithoutMroPartWarehouseInput>>;
  updateMany?: InputMaybe<Array<MroPartInventoryUpdateManyWithWhereWithoutMroPartWarehouseInput>>;
  upsert?: InputMaybe<Array<MroPartInventoryUpsertWithWhereUniqueWithoutMroPartWarehouseInput>>;
};

export type MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput = {
  connect?: InputMaybe<MroPartInventoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartInventoryCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroPartInventoryCreateWithoutMroWorkOrderPartsInput>;
  delete?: InputMaybe<MroPartInventoryWhereInput>;
  disconnect?: InputMaybe<MroPartInventoryWhereInput>;
  update?: InputMaybe<MroPartInventoryUpdateToOneWithWhereWithoutMroWorkOrderPartsInput>;
  upsert?: InputMaybe<MroPartInventoryUpsertWithoutMroWorkOrderPartsInput>;
};

export type MroPartInventoryUpdateToOneWithWhereWithoutMroWorkOrderPartsInput = {
  data: MroPartInventoryUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroPartInventoryWhereInput>;
};

export type MroPartInventoryUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroPartInventoryUpdateWithoutMroOrganizationInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryUpdateWithWhereUniqueWithoutMroPartInput = {
  data: MroPartInventoryUpdateWithoutMroPartInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryUpdateWithWhereUniqueWithoutMroPartWarehouseInput = {
  data: MroPartInventoryUpdateWithoutMroPartWarehouseInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryUpdateWithoutMroOrganizationInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneRequiredWithoutMroPartInventoriesNestedInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroPartInventoryNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartInventoryNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionUpdateManyWithoutMroPartInventoryNestedInput>;
};

export type MroPartInventoryUpdateWithoutMroPartInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartInventoriesNestedInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroPartInventoryNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartInventoryNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionUpdateManyWithoutMroPartInventoryNestedInput>;
};

export type MroPartInventoryUpdateWithoutMroPartWarehouseInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartInventoriesNestedInput>;
  mroPart?: InputMaybe<MroPartUpdateOneRequiredWithoutMroPartInventoriesNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartInventoryNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionUpdateManyWithoutMroPartInventoryNestedInput>;
};

export type MroPartInventoryUpdateWithoutMroWorkOrderPartsInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartInventoriesNestedInput>;
  mroPart?: InputMaybe<MroPartUpdateOneRequiredWithoutMroPartInventoriesNestedInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroPartInventoryNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartInventoryVersionUpdateManyWithoutMroPartInventoryNestedInput>;
};

export type MroPartInventoryUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroPartInventoryCreateWithoutMroOrganizationInput;
  update: MroPartInventoryUpdateWithoutMroOrganizationInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryUpsertWithWhereUniqueWithoutMroPartInput = {
  create: MroPartInventoryCreateWithoutMroPartInput;
  update: MroPartInventoryUpdateWithoutMroPartInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryUpsertWithWhereUniqueWithoutMroPartWarehouseInput = {
  create: MroPartInventoryCreateWithoutMroPartWarehouseInput;
  update: MroPartInventoryUpdateWithoutMroPartWarehouseInput;
  where: MroPartInventoryWhereUniqueInput;
};

export type MroPartInventoryUpsertWithoutMroWorkOrderPartsInput = {
  create: MroPartInventoryCreateWithoutMroWorkOrderPartsInput;
  update: MroPartInventoryUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroPartInventoryWhereInput>;
};

export type MroPartInventoryVersion = {
  __typename?: 'MroPartInventoryVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartInventory?: Maybe<MroPartInventory>;
  mroPartInventoryId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartInventoryVersionCreateManyMroPartInventoryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartInventoryVersionCreateManyMroPartInventoryInputEnvelope = {
  data: Array<MroPartInventoryVersionCreateManyMroPartInventoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartInventoryVersionCreateNestedManyWithoutMroPartInventoryInput = {
  connect?: InputMaybe<Array<MroPartInventoryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryVersionCreateOrConnectWithoutMroPartInventoryInput>>;
  create?: InputMaybe<Array<MroPartInventoryVersionCreateWithoutMroPartInventoryInput>>;
  createMany?: InputMaybe<MroPartInventoryVersionCreateManyMroPartInventoryInputEnvelope>;
};

export type MroPartInventoryVersionCreateOrConnectWithoutMroPartInventoryInput = {
  create: MroPartInventoryVersionCreateWithoutMroPartInventoryInput;
  where: MroPartInventoryVersionWhereUniqueInput;
};

export type MroPartInventoryVersionCreateWithoutMroPartInventoryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartInventoryVersionListRelationFilter = {
  every?: InputMaybe<MroPartInventoryVersionWhereInput>;
  none?: InputMaybe<MroPartInventoryVersionWhereInput>;
  some?: InputMaybe<MroPartInventoryVersionWhereInput>;
};

export type MroPartInventoryVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartInventoryVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartInventoryVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartInventoryVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartInventoryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartInventoryVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartInventoryVersionUpdateManyWithWhereWithoutMroPartInventoryInput = {
  data: MroPartInventoryVersionUpdateManyMutationInput;
  where: MroPartInventoryVersionScalarWhereInput;
};

export type MroPartInventoryVersionUpdateManyWithoutMroPartInventoryNestedInput = {
  connect?: InputMaybe<Array<MroPartInventoryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartInventoryVersionCreateOrConnectWithoutMroPartInventoryInput>>;
  create?: InputMaybe<Array<MroPartInventoryVersionCreateWithoutMroPartInventoryInput>>;
  createMany?: InputMaybe<MroPartInventoryVersionCreateManyMroPartInventoryInputEnvelope>;
  delete?: InputMaybe<Array<MroPartInventoryVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartInventoryVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartInventoryVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartInventoryVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartInventoryVersionUpdateWithWhereUniqueWithoutMroPartInventoryInput>>;
  updateMany?: InputMaybe<Array<MroPartInventoryVersionUpdateManyWithWhereWithoutMroPartInventoryInput>>;
  upsert?: InputMaybe<Array<MroPartInventoryVersionUpsertWithWhereUniqueWithoutMroPartInventoryInput>>;
};

export type MroPartInventoryVersionUpdateWithWhereUniqueWithoutMroPartInventoryInput = {
  data: MroPartInventoryVersionUpdateWithoutMroPartInventoryInput;
  where: MroPartInventoryVersionWhereUniqueInput;
};

export type MroPartInventoryVersionUpdateWithoutMroPartInventoryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartInventoryVersionUpsertWithWhereUniqueWithoutMroPartInventoryInput = {
  create: MroPartInventoryVersionCreateWithoutMroPartInventoryInput;
  update: MroPartInventoryVersionUpdateWithoutMroPartInventoryInput;
  where: MroPartInventoryVersionWhereUniqueInput;
};

export type MroPartInventoryVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartInventoryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartInventoryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartInventoryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartInventory?: InputMaybe<MroPartInventoryNullableScalarRelationFilter>;
  mroPartInventoryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartInventoryVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartInventoryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartInventoryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartInventoryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartInventory?: InputMaybe<MroPartInventoryNullableScalarRelationFilter>;
  mroPartInventoryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartInventoryWhereInput = {
  AND?: InputMaybe<Array<MroPartInventoryWhereInput>>;
  NOT?: InputMaybe<Array<MroPartInventoryWhereInput>>;
  OR?: InputMaybe<Array<MroPartInventoryWhereInput>>;
  bin?: InputMaybe<StringNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lotNumber?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPart?: InputMaybe<MroPartScalarRelationFilter>;
  mroPartId?: InputMaybe<StringFilter>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseNullableScalarRelationFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partPriceUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartInventoryVersionListRelationFilter>;
};

export type MroPartInventoryWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartInventoryWhereInput>>;
  NOT?: InputMaybe<Array<MroPartInventoryWhereInput>>;
  OR?: InputMaybe<Array<MroPartInventoryWhereInput>>;
  bin?: InputMaybe<StringNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  lotNumber?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPart?: InputMaybe<MroPartScalarRelationFilter>;
  mroPartId?: InputMaybe<StringFilter>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseNullableScalarRelationFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partPriceUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartInventoryVersionListRelationFilter>;
};

export type MroPartListRelationFilter = {
  every?: InputMaybe<MroPartWhereInput>;
  none?: InputMaybe<MroPartWhereInput>;
  some?: InputMaybe<MroPartWhereInput>;
};

export type MroPartManufacturer = {
  __typename?: 'MroPartManufacturer';
  _count: MroPartManufacturerCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroParts?: Maybe<Array<MroPart>>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroPartManufacturerVersion>>;
};

export type MroPartManufacturerCount = {
  __typename?: 'MroPartManufacturerCount';
  mroParts: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroPartManufacturerCountAggregate = {
  __typename?: 'MroPartManufacturerCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartManufacturerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroParts?: InputMaybe<MroPartCreateNestedManyWithoutManufacturerInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartManufacturerVersionCreateNestedManyWithoutMroPartManufacturerInput>;
};

export type MroPartManufacturerCreateNestedOneWithoutMroPartsInput = {
  connect?: InputMaybe<MroPartManufacturerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartManufacturerCreateOrConnectWithoutMroPartsInput>;
  create?: InputMaybe<MroPartManufacturerCreateWithoutMroPartsInput>;
};

export type MroPartManufacturerCreateOrConnectWithoutMroPartsInput = {
  create: MroPartManufacturerCreateWithoutMroPartsInput;
  where: MroPartManufacturerWhereUniqueInput;
};

export type MroPartManufacturerCreateWithoutMroPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartManufacturerVersionCreateNestedManyWithoutMroPartManufacturerInput>;
};

export type MroPartManufacturerMaxAggregate = {
  __typename?: 'MroPartManufacturerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartManufacturerMinAggregate = {
  __typename?: 'MroPartManufacturerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartManufacturerNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartManufacturerWhereInput>;
  isNot?: InputMaybe<MroPartManufacturerWhereInput>;
};

export type MroPartManufacturerUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroParts?: InputMaybe<MroPartUpdateManyWithoutManufacturerNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartManufacturerVersionUpdateManyWithoutMroPartManufacturerNestedInput>;
};

export type MroPartManufacturerUpdateOneWithoutMroPartsNestedInput = {
  connect?: InputMaybe<MroPartManufacturerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartManufacturerCreateOrConnectWithoutMroPartsInput>;
  create?: InputMaybe<MroPartManufacturerCreateWithoutMroPartsInput>;
  delete?: InputMaybe<MroPartManufacturerWhereInput>;
  disconnect?: InputMaybe<MroPartManufacturerWhereInput>;
  update?: InputMaybe<MroPartManufacturerUpdateToOneWithWhereWithoutMroPartsInput>;
  upsert?: InputMaybe<MroPartManufacturerUpsertWithoutMroPartsInput>;
};

export type MroPartManufacturerUpdateToOneWithWhereWithoutMroPartsInput = {
  data: MroPartManufacturerUpdateWithoutMroPartsInput;
  where?: InputMaybe<MroPartManufacturerWhereInput>;
};

export type MroPartManufacturerUpdateWithoutMroPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartManufacturerVersionUpdateManyWithoutMroPartManufacturerNestedInput>;
};

export type MroPartManufacturerUpsertWithoutMroPartsInput = {
  create: MroPartManufacturerCreateWithoutMroPartsInput;
  update: MroPartManufacturerUpdateWithoutMroPartsInput;
  where?: InputMaybe<MroPartManufacturerWhereInput>;
};

export type MroPartManufacturerVersion = {
  __typename?: 'MroPartManufacturerVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartManufacturer?: Maybe<MroPartManufacturer>;
  mroPartManufacturerId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartManufacturerVersionCreateManyMroPartManufacturerInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartManufacturerVersionCreateManyMroPartManufacturerInputEnvelope = {
  data: Array<MroPartManufacturerVersionCreateManyMroPartManufacturerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartManufacturerVersionCreateNestedManyWithoutMroPartManufacturerInput = {
  connect?: InputMaybe<Array<MroPartManufacturerVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartManufacturerVersionCreateOrConnectWithoutMroPartManufacturerInput>>;
  create?: InputMaybe<Array<MroPartManufacturerVersionCreateWithoutMroPartManufacturerInput>>;
  createMany?: InputMaybe<MroPartManufacturerVersionCreateManyMroPartManufacturerInputEnvelope>;
};

export type MroPartManufacturerVersionCreateOrConnectWithoutMroPartManufacturerInput = {
  create: MroPartManufacturerVersionCreateWithoutMroPartManufacturerInput;
  where: MroPartManufacturerVersionWhereUniqueInput;
};

export type MroPartManufacturerVersionCreateWithoutMroPartManufacturerInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartManufacturerVersionListRelationFilter = {
  every?: InputMaybe<MroPartManufacturerVersionWhereInput>;
  none?: InputMaybe<MroPartManufacturerVersionWhereInput>;
  some?: InputMaybe<MroPartManufacturerVersionWhereInput>;
};

export type MroPartManufacturerVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartManufacturerVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartManufacturerVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartManufacturerVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartManufacturerId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartManufacturerVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartManufacturerVersionUpdateManyWithWhereWithoutMroPartManufacturerInput = {
  data: MroPartManufacturerVersionUpdateManyMutationInput;
  where: MroPartManufacturerVersionScalarWhereInput;
};

export type MroPartManufacturerVersionUpdateManyWithoutMroPartManufacturerNestedInput = {
  connect?: InputMaybe<Array<MroPartManufacturerVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartManufacturerVersionCreateOrConnectWithoutMroPartManufacturerInput>>;
  create?: InputMaybe<Array<MroPartManufacturerVersionCreateWithoutMroPartManufacturerInput>>;
  createMany?: InputMaybe<MroPartManufacturerVersionCreateManyMroPartManufacturerInputEnvelope>;
  delete?: InputMaybe<Array<MroPartManufacturerVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartManufacturerVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartManufacturerVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartManufacturerVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartManufacturerVersionUpdateWithWhereUniqueWithoutMroPartManufacturerInput>>;
  updateMany?: InputMaybe<Array<MroPartManufacturerVersionUpdateManyWithWhereWithoutMroPartManufacturerInput>>;
  upsert?: InputMaybe<Array<MroPartManufacturerVersionUpsertWithWhereUniqueWithoutMroPartManufacturerInput>>;
};

export type MroPartManufacturerVersionUpdateWithWhereUniqueWithoutMroPartManufacturerInput = {
  data: MroPartManufacturerVersionUpdateWithoutMroPartManufacturerInput;
  where: MroPartManufacturerVersionWhereUniqueInput;
};

export type MroPartManufacturerVersionUpdateWithoutMroPartManufacturerInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartManufacturerVersionUpsertWithWhereUniqueWithoutMroPartManufacturerInput = {
  create: MroPartManufacturerVersionCreateWithoutMroPartManufacturerInput;
  update: MroPartManufacturerVersionUpdateWithoutMroPartManufacturerInput;
  where: MroPartManufacturerVersionWhereUniqueInput;
};

export type MroPartManufacturerVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartManufacturerVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartManufacturerVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartManufacturerVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartManufacturer?: InputMaybe<MroPartManufacturerNullableScalarRelationFilter>;
  mroPartManufacturerId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartManufacturerVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartManufacturerVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartManufacturerVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartManufacturerVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartManufacturer?: InputMaybe<MroPartManufacturerNullableScalarRelationFilter>;
  mroPartManufacturerId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartManufacturerWhereInput = {
  AND?: InputMaybe<Array<MroPartManufacturerWhereInput>>;
  NOT?: InputMaybe<Array<MroPartManufacturerWhereInput>>;
  OR?: InputMaybe<Array<MroPartManufacturerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroParts?: InputMaybe<MroPartListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartManufacturerVersionListRelationFilter>;
};

export type MroPartManufacturerWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartManufacturerWhereInput>>;
  NOT?: InputMaybe<Array<MroPartManufacturerWhereInput>>;
  OR?: InputMaybe<Array<MroPartManufacturerWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroParts?: InputMaybe<MroPartListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartManufacturerVersionListRelationFilter>;
};

export type MroPartMaxAggregate = {
  __typename?: 'MroPartMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSerialized?: Maybe<Scalars['Boolean']>;
  manufacturerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  secondaryPartNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartMinAggregate = {
  __typename?: 'MroPartMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSerialized?: Maybe<Scalars['Boolean']>;
  manufacturerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  preferred?: Maybe<Scalars['Boolean']>;
  secondaryPartNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartWhereInput>;
  isNot?: InputMaybe<MroPartWhereInput>;
};

export type MroPartOrder = {
  __typename?: 'MroPartOrder';
  _count: MroPartOrderCount;
  buyer?: Maybe<MroEmployeeProfile>;
  buyerId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  issuedDate?: Maybe<Scalars['DateTime']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartOrderItems?: Maybe<Array<MroPartOrderItem>>;
  mroPartVendor?: Maybe<MroPartVendor>;
  mroPartVendorId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  pdfLink: Scalars['String'];
  purchaseDate?: Maybe<Scalars['DateTime']>;
  shippingCost?: Maybe<Scalars['Decimal']>;
  status?: Maybe<Scalars['String']>;
  trackingInfo?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroPartOrderVersion>>;
};

export type MroPartOrderAvgAggregate = {
  __typename?: 'MroPartOrderAvgAggregate';
  shippingCost?: Maybe<Scalars['Decimal']>;
};

export type MroPartOrderCount = {
  __typename?: 'MroPartOrderCount';
  mroPartOrderItems: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroPartOrderCountAggregate = {
  __typename?: 'MroPartOrderCountAggregate';
  _all: Scalars['Int'];
  buyerId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  issuedDate: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroPartVendorId: Scalars['Int'];
  notes: Scalars['Int'];
  orderNumber: Scalars['Int'];
  purchaseDate: Scalars['Int'];
  shippingCost: Scalars['Int'];
  status: Scalars['Int'];
  trackingInfo: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartOrderCreateInput = {
  buyer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroPartOrdersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartOrdersInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartOrderInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedOneWithoutMroPartOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionCreateNestedManyWithoutMroPartOrderInput>;
};

export type MroPartOrderCreateManyBuyerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroPartVendorId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderCreateManyBuyerInputEnvelope = {
  data: Array<MroPartOrderCreateManyBuyerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderCreateManyMroOrganizationInput = {
  buyerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroPartVendorId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroPartOrderCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderCreateManyMroPartVendorInput = {
  buyerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderCreateManyMroPartVendorInputEnvelope = {
  data: Array<MroPartOrderCreateManyMroPartVendorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderCreateNestedManyWithoutBuyerInput = {
  connect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderCreateOrConnectWithoutBuyerInput>>;
  create?: InputMaybe<Array<MroPartOrderCreateWithoutBuyerInput>>;
  createMany?: InputMaybe<MroPartOrderCreateManyBuyerInputEnvelope>;
};

export type MroPartOrderCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartOrderCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartOrderCreateManyMroOrganizationInputEnvelope>;
};

export type MroPartOrderCreateNestedManyWithoutMroPartVendorInput = {
  connect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderCreateOrConnectWithoutMroPartVendorInput>>;
  create?: InputMaybe<Array<MroPartOrderCreateWithoutMroPartVendorInput>>;
  createMany?: InputMaybe<MroPartOrderCreateManyMroPartVendorInputEnvelope>;
};

export type MroPartOrderCreateNestedOneWithoutMroPartOrderItemsInput = {
  connect?: InputMaybe<MroPartOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartOrderCreateOrConnectWithoutMroPartOrderItemsInput>;
  create?: InputMaybe<MroPartOrderCreateWithoutMroPartOrderItemsInput>;
};

export type MroPartOrderCreateOrConnectWithoutBuyerInput = {
  create: MroPartOrderCreateWithoutBuyerInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderCreateOrConnectWithoutMroOrganizationInput = {
  create: MroPartOrderCreateWithoutMroOrganizationInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderCreateOrConnectWithoutMroPartOrderItemsInput = {
  create: MroPartOrderCreateWithoutMroPartOrderItemsInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderCreateOrConnectWithoutMroPartVendorInput = {
  create: MroPartOrderCreateWithoutMroPartVendorInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderCreateWithoutBuyerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartOrdersInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartOrderInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedOneWithoutMroPartOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionCreateNestedManyWithoutMroPartOrderInput>;
};

export type MroPartOrderCreateWithoutMroOrganizationInput = {
  buyer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroPartOrdersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartOrderInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedOneWithoutMroPartOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionCreateNestedManyWithoutMroPartOrderInput>;
};

export type MroPartOrderCreateWithoutMroPartOrderItemsInput = {
  buyer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroPartOrdersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartOrdersInput>;
  mroPartVendor?: InputMaybe<MroPartVendorCreateNestedOneWithoutMroPartOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionCreateNestedManyWithoutMroPartOrderInput>;
};

export type MroPartOrderCreateWithoutMroPartVendorInput = {
  buyer?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroPartOrdersInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartOrdersInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroPartOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionCreateNestedManyWithoutMroPartOrderInput>;
};

export type MroPartOrderItem = {
  __typename?: 'MroPartOrderItem';
  _count: MroPartOrderItemCount;
  active?: Maybe<Scalars['Boolean']>;
  condition?: Maybe<PartCondition>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroPart?: Maybe<MroPart>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartOrder?: Maybe<MroPartOrder>;
  mroPartOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderPart?: Maybe<MroWorkOrderPart>;
  mroWorkOrderPartId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroPartOrderItemVersion>>;
};

export type MroPartOrderItemAvgAggregate = {
  __typename?: 'MroPartOrderItemAvgAggregate';
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroPartOrderItemCount = {
  __typename?: 'MroPartOrderItemCount';
  versions: Scalars['Int'];
};

export type MroPartOrderItemCountAggregate = {
  __typename?: 'MroPartOrderItemCountAggregate';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  condition: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroPartId: Scalars['Int'];
  mroPartOrderId: Scalars['Int'];
  mroWorkOrderPartId: Scalars['Int'];
  notes: Scalars['Int'];
  quantity: Scalars['Int'];
  requestedDate: Scalars['Int'];
  status: Scalars['Int'];
  unitPrice: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartOrderItemCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroPartOrderItemsInput>;
  mroPartOrder?: InputMaybe<MroPartOrderCreateNestedOneWithoutMroPartOrderItemsInput>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartCreateNestedOneWithoutMroPartOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionCreateNestedManyWithoutMroPartOrderItemInput>;
};

export type MroPartOrderItemCreateManyMroPartInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartOrderId?: InputMaybe<Scalars['String']>;
  mroWorkOrderPartId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderItemCreateManyMroPartInputEnvelope = {
  data: Array<MroPartOrderItemCreateManyMroPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderItemCreateManyMroPartOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroWorkOrderPartId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderItemCreateManyMroPartOrderInputEnvelope = {
  data: Array<MroPartOrderItemCreateManyMroPartOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderItemCreateManyMroWorkOrderPartInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroPartOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderItemCreateManyMroWorkOrderPartInputEnvelope = {
  data: Array<MroPartOrderItemCreateManyMroWorkOrderPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderItemCreateNestedManyWithoutMroPartInput = {
  connect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartOrderItemCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartOrderItemCreateManyMroPartInputEnvelope>;
};

export type MroPartOrderItemCreateNestedManyWithoutMroPartOrderInput = {
  connect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemCreateOrConnectWithoutMroPartOrderInput>>;
  create?: InputMaybe<Array<MroPartOrderItemCreateWithoutMroPartOrderInput>>;
  createMany?: InputMaybe<MroPartOrderItemCreateManyMroPartOrderInputEnvelope>;
};

export type MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput = {
  connect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemCreateOrConnectWithoutMroWorkOrderPartInput>>;
  create?: InputMaybe<Array<MroPartOrderItemCreateWithoutMroWorkOrderPartInput>>;
  createMany?: InputMaybe<MroPartOrderItemCreateManyMroWorkOrderPartInputEnvelope>;
};

export type MroPartOrderItemCreateOrConnectWithoutMroPartInput = {
  create: MroPartOrderItemCreateWithoutMroPartInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemCreateOrConnectWithoutMroPartOrderInput = {
  create: MroPartOrderItemCreateWithoutMroPartOrderInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemCreateOrConnectWithoutMroWorkOrderPartInput = {
  create: MroPartOrderItemCreateWithoutMroWorkOrderPartInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemCreateWithoutMroPartInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartOrder?: InputMaybe<MroPartOrderCreateNestedOneWithoutMroPartOrderItemsInput>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartCreateNestedOneWithoutMroPartOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionCreateNestedManyWithoutMroPartOrderItemInput>;
};

export type MroPartOrderItemCreateWithoutMroPartOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroPartOrderItemsInput>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartCreateNestedOneWithoutMroPartOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionCreateNestedManyWithoutMroPartOrderItemInput>;
};

export type MroPartOrderItemCreateWithoutMroWorkOrderPartInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroPartOrderItemsInput>;
  mroPartOrder?: InputMaybe<MroPartOrderCreateNestedOneWithoutMroPartOrderItemsInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionCreateNestedManyWithoutMroPartOrderItemInput>;
};

export type MroPartOrderItemListRelationFilter = {
  every?: InputMaybe<MroPartOrderItemWhereInput>;
  none?: InputMaybe<MroPartOrderItemWhereInput>;
  some?: InputMaybe<MroPartOrderItemWhereInput>;
};

export type MroPartOrderItemMaxAggregate = {
  __typename?: 'MroPartOrderItemMaxAggregate';
  active?: Maybe<Scalars['Boolean']>;
  condition?: Maybe<PartCondition>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderPartId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartOrderItemMinAggregate = {
  __typename?: 'MroPartOrderItemMinAggregate';
  active?: Maybe<Scalars['Boolean']>;
  condition?: Maybe<PartCondition>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderPartId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requestedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartOrderItemNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartOrderItemWhereInput>;
  isNot?: InputMaybe<MroPartOrderItemWhereInput>;
};

export type MroPartOrderItemScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderItemScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderItemScalarWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderPartId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  requestedDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartOrderItemSumAggregate = {
  __typename?: 'MroPartOrderItemSumAggregate';
  quantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroPartOrderItemUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroPartOrderItemsNestedInput>;
  mroPartOrder?: InputMaybe<MroPartOrderUpdateOneWithoutMroPartOrderItemsNestedInput>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartUpdateOneWithoutMroPartOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionUpdateManyWithoutMroPartOrderItemNestedInput>;
};

export type MroPartOrderItemUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderItemUpdateManyWithWhereWithoutMroPartInput = {
  data: MroPartOrderItemUpdateManyMutationInput;
  where: MroPartOrderItemScalarWhereInput;
};

export type MroPartOrderItemUpdateManyWithWhereWithoutMroPartOrderInput = {
  data: MroPartOrderItemUpdateManyMutationInput;
  where: MroPartOrderItemScalarWhereInput;
};

export type MroPartOrderItemUpdateManyWithWhereWithoutMroWorkOrderPartInput = {
  data: MroPartOrderItemUpdateManyMutationInput;
  where: MroPartOrderItemScalarWhereInput;
};

export type MroPartOrderItemUpdateManyWithoutMroPartNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartOrderItemCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartOrderItemCreateManyMroPartInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderItemUpdateWithWhereUniqueWithoutMroPartInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderItemUpdateManyWithWhereWithoutMroPartInput>>;
  upsert?: InputMaybe<Array<MroPartOrderItemUpsertWithWhereUniqueWithoutMroPartInput>>;
};

export type MroPartOrderItemUpdateManyWithoutMroPartOrderNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemCreateOrConnectWithoutMroPartOrderInput>>;
  create?: InputMaybe<Array<MroPartOrderItemCreateWithoutMroPartOrderInput>>;
  createMany?: InputMaybe<MroPartOrderItemCreateManyMroPartOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderItemUpdateWithWhereUniqueWithoutMroPartOrderInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderItemUpdateManyWithWhereWithoutMroPartOrderInput>>;
  upsert?: InputMaybe<Array<MroPartOrderItemUpsertWithWhereUniqueWithoutMroPartOrderInput>>;
};

export type MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemCreateOrConnectWithoutMroWorkOrderPartInput>>;
  create?: InputMaybe<Array<MroPartOrderItemCreateWithoutMroWorkOrderPartInput>>;
  createMany?: InputMaybe<MroPartOrderItemCreateManyMroWorkOrderPartInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderItemUpdateWithWhereUniqueWithoutMroWorkOrderPartInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderItemUpdateManyWithWhereWithoutMroWorkOrderPartInput>>;
  upsert?: InputMaybe<Array<MroPartOrderItemUpsertWithWhereUniqueWithoutMroWorkOrderPartInput>>;
};

export type MroPartOrderItemUpdateWithWhereUniqueWithoutMroPartInput = {
  data: MroPartOrderItemUpdateWithoutMroPartInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemUpdateWithWhereUniqueWithoutMroPartOrderInput = {
  data: MroPartOrderItemUpdateWithoutMroPartOrderInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemUpdateWithWhereUniqueWithoutMroWorkOrderPartInput = {
  data: MroPartOrderItemUpdateWithoutMroWorkOrderPartInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemUpdateWithoutMroPartInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartOrder?: InputMaybe<MroPartOrderUpdateOneWithoutMroPartOrderItemsNestedInput>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartUpdateOneWithoutMroPartOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionUpdateManyWithoutMroPartOrderItemNestedInput>;
};

export type MroPartOrderItemUpdateWithoutMroPartOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroPartOrderItemsNestedInput>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartUpdateOneWithoutMroPartOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionUpdateManyWithoutMroPartOrderItemNestedInput>;
};

export type MroPartOrderItemUpdateWithoutMroWorkOrderPartInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  condition?: InputMaybe<PartCondition>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroPartOrderItemsNestedInput>;
  mroPartOrder?: InputMaybe<MroPartOrderUpdateOneWithoutMroPartOrderItemsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requestedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderItemVersionUpdateManyWithoutMroPartOrderItemNestedInput>;
};

export type MroPartOrderItemUpsertWithWhereUniqueWithoutMroPartInput = {
  create: MroPartOrderItemCreateWithoutMroPartInput;
  update: MroPartOrderItemUpdateWithoutMroPartInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemUpsertWithWhereUniqueWithoutMroPartOrderInput = {
  create: MroPartOrderItemCreateWithoutMroPartOrderInput;
  update: MroPartOrderItemUpdateWithoutMroPartOrderInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemUpsertWithWhereUniqueWithoutMroWorkOrderPartInput = {
  create: MroPartOrderItemCreateWithoutMroWorkOrderPartInput;
  update: MroPartOrderItemUpdateWithoutMroWorkOrderPartInput;
  where: MroPartOrderItemWhereUniqueInput;
};

export type MroPartOrderItemVersion = {
  __typename?: 'MroPartOrderItemVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartOrderItem?: Maybe<MroPartOrderItem>;
  mroPartOrderItemId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartOrderItemVersionCreateManyMroPartOrderItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderItemVersionCreateManyMroPartOrderItemInputEnvelope = {
  data: Array<MroPartOrderItemVersionCreateManyMroPartOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderItemVersionCreateNestedManyWithoutMroPartOrderItemInput = {
  connect?: InputMaybe<Array<MroPartOrderItemVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemVersionCreateOrConnectWithoutMroPartOrderItemInput>>;
  create?: InputMaybe<Array<MroPartOrderItemVersionCreateWithoutMroPartOrderItemInput>>;
  createMany?: InputMaybe<MroPartOrderItemVersionCreateManyMroPartOrderItemInputEnvelope>;
};

export type MroPartOrderItemVersionCreateOrConnectWithoutMroPartOrderItemInput = {
  create: MroPartOrderItemVersionCreateWithoutMroPartOrderItemInput;
  where: MroPartOrderItemVersionWhereUniqueInput;
};

export type MroPartOrderItemVersionCreateWithoutMroPartOrderItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderItemVersionListRelationFilter = {
  every?: InputMaybe<MroPartOrderItemVersionWhereInput>;
  none?: InputMaybe<MroPartOrderItemVersionWhereInput>;
  some?: InputMaybe<MroPartOrderItemVersionWhereInput>;
};

export type MroPartOrderItemVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderItemVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderItemVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderItemVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartOrderItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartOrderItemVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderItemVersionUpdateManyWithWhereWithoutMroPartOrderItemInput = {
  data: MroPartOrderItemVersionUpdateManyMutationInput;
  where: MroPartOrderItemVersionScalarWhereInput;
};

export type MroPartOrderItemVersionUpdateManyWithoutMroPartOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderItemVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderItemVersionCreateOrConnectWithoutMroPartOrderItemInput>>;
  create?: InputMaybe<Array<MroPartOrderItemVersionCreateWithoutMroPartOrderItemInput>>;
  createMany?: InputMaybe<MroPartOrderItemVersionCreateManyMroPartOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderItemVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderItemVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderItemVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderItemVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderItemVersionUpdateWithWhereUniqueWithoutMroPartOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderItemVersionUpdateManyWithWhereWithoutMroPartOrderItemInput>>;
  upsert?: InputMaybe<Array<MroPartOrderItemVersionUpsertWithWhereUniqueWithoutMroPartOrderItemInput>>;
};

export type MroPartOrderItemVersionUpdateWithWhereUniqueWithoutMroPartOrderItemInput = {
  data: MroPartOrderItemVersionUpdateWithoutMroPartOrderItemInput;
  where: MroPartOrderItemVersionWhereUniqueInput;
};

export type MroPartOrderItemVersionUpdateWithoutMroPartOrderItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderItemVersionUpsertWithWhereUniqueWithoutMroPartOrderItemInput = {
  create: MroPartOrderItemVersionCreateWithoutMroPartOrderItemInput;
  update: MroPartOrderItemVersionUpdateWithoutMroPartOrderItemInput;
  where: MroPartOrderItemVersionWhereUniqueInput;
};

export type MroPartOrderItemVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderItemVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderItemVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderItemVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemNullableScalarRelationFilter>;
  mroPartOrderItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartOrderItemVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartOrderItemVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderItemVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderItemVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemNullableScalarRelationFilter>;
  mroPartOrderItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartOrderItemWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderItemWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderItemWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderItemWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartOrder?: InputMaybe<MroPartOrderNullableScalarRelationFilter>;
  mroPartOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartNullableScalarRelationFilter>;
  mroWorkOrderPartId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  requestedDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartOrderItemVersionListRelationFilter>;
};

export type MroPartOrderItemWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartOrderItemWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderItemWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderItemWhereInput>>;
  active?: InputMaybe<BoolNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartOrder?: InputMaybe<MroPartOrderNullableScalarRelationFilter>;
  mroPartOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartNullableScalarRelationFilter>;
  mroWorkOrderPartId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  requestedDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartOrderItemVersionListRelationFilter>;
};

export type MroPartOrderListRelationFilter = {
  every?: InputMaybe<MroPartOrderWhereInput>;
  none?: InputMaybe<MroPartOrderWhereInput>;
  some?: InputMaybe<MroPartOrderWhereInput>;
};

export type MroPartOrderMaxAggregate = {
  __typename?: 'MroPartOrderMaxAggregate';
  buyerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['DateTime']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartVendorId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['DateTime']>;
  shippingCost?: Maybe<Scalars['Decimal']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartOrderMinAggregate = {
  __typename?: 'MroPartOrderMinAggregate';
  buyerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['DateTime']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartVendorId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  purchaseDate?: Maybe<Scalars['DateTime']>;
  shippingCost?: Maybe<Scalars['Decimal']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartOrderNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartOrderWhereInput>;
  isNot?: InputMaybe<MroPartOrderWhereInput>;
};

export type MroPartOrderScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderScalarWhereInput>>;
  buyerId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  issuedDate?: InputMaybe<DateTimeNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartVendorId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  orderNumber?: InputMaybe<StringNullableFilter>;
  purchaseDate?: InputMaybe<DateTimeNullableFilter>;
  shippingCost?: InputMaybe<DecimalNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  trackingInfo?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartOrderSumAggregate = {
  __typename?: 'MroPartOrderSumAggregate';
  shippingCost?: Maybe<Scalars['Decimal']>;
};

export type MroPartOrderUpdateInput = {
  buyer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroPartOrdersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartOrdersNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartOrderNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateOneWithoutMroPartOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionUpdateManyWithoutMroPartOrderNestedInput>;
};

export type MroPartOrderUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartOrderUpdateManyWithWhereWithoutBuyerInput = {
  data: MroPartOrderUpdateManyMutationInput;
  where: MroPartOrderScalarWhereInput;
};

export type MroPartOrderUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroPartOrderUpdateManyMutationInput;
  where: MroPartOrderScalarWhereInput;
};

export type MroPartOrderUpdateManyWithWhereWithoutMroPartVendorInput = {
  data: MroPartOrderUpdateManyMutationInput;
  where: MroPartOrderScalarWhereInput;
};

export type MroPartOrderUpdateManyWithoutBuyerNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderCreateOrConnectWithoutBuyerInput>>;
  create?: InputMaybe<Array<MroPartOrderCreateWithoutBuyerInput>>;
  createMany?: InputMaybe<MroPartOrderCreateManyBuyerInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderUpdateWithWhereUniqueWithoutBuyerInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderUpdateManyWithWhereWithoutBuyerInput>>;
  upsert?: InputMaybe<Array<MroPartOrderUpsertWithWhereUniqueWithoutBuyerInput>>;
};

export type MroPartOrderUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartOrderCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartOrderCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroPartOrderUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroPartOrderUpdateManyWithoutMroPartVendorNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderCreateOrConnectWithoutMroPartVendorInput>>;
  create?: InputMaybe<Array<MroPartOrderCreateWithoutMroPartVendorInput>>;
  createMany?: InputMaybe<MroPartOrderCreateManyMroPartVendorInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderUpdateWithWhereUniqueWithoutMroPartVendorInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderUpdateManyWithWhereWithoutMroPartVendorInput>>;
  upsert?: InputMaybe<Array<MroPartOrderUpsertWithWhereUniqueWithoutMroPartVendorInput>>;
};

export type MroPartOrderUpdateOneWithoutMroPartOrderItemsNestedInput = {
  connect?: InputMaybe<MroPartOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartOrderCreateOrConnectWithoutMroPartOrderItemsInput>;
  create?: InputMaybe<MroPartOrderCreateWithoutMroPartOrderItemsInput>;
  delete?: InputMaybe<MroPartOrderWhereInput>;
  disconnect?: InputMaybe<MroPartOrderWhereInput>;
  update?: InputMaybe<MroPartOrderUpdateToOneWithWhereWithoutMroPartOrderItemsInput>;
  upsert?: InputMaybe<MroPartOrderUpsertWithoutMroPartOrderItemsInput>;
};

export type MroPartOrderUpdateToOneWithWhereWithoutMroPartOrderItemsInput = {
  data: MroPartOrderUpdateWithoutMroPartOrderItemsInput;
  where?: InputMaybe<MroPartOrderWhereInput>;
};

export type MroPartOrderUpdateWithWhereUniqueWithoutBuyerInput = {
  data: MroPartOrderUpdateWithoutBuyerInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroPartOrderUpdateWithoutMroOrganizationInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderUpdateWithWhereUniqueWithoutMroPartVendorInput = {
  data: MroPartOrderUpdateWithoutMroPartVendorInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderUpdateWithoutBuyerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartOrdersNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartOrderNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateOneWithoutMroPartOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionUpdateManyWithoutMroPartOrderNestedInput>;
};

export type MroPartOrderUpdateWithoutMroOrganizationInput = {
  buyer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroPartOrdersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartOrderNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateOneWithoutMroPartOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionUpdateManyWithoutMroPartOrderNestedInput>;
};

export type MroPartOrderUpdateWithoutMroPartOrderItemsInput = {
  buyer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroPartOrdersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartOrdersNestedInput>;
  mroPartVendor?: InputMaybe<MroPartVendorUpdateOneWithoutMroPartOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionUpdateManyWithoutMroPartOrderNestedInput>;
};

export type MroPartOrderUpdateWithoutMroPartVendorInput = {
  buyer?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroPartOrdersNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['DateTime']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartOrdersNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  purchaseDate?: InputMaybe<Scalars['DateTime']>;
  shippingCost?: InputMaybe<Scalars['Decimal']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartOrderVersionUpdateManyWithoutMroPartOrderNestedInput>;
};

export type MroPartOrderUpsertWithWhereUniqueWithoutBuyerInput = {
  create: MroPartOrderCreateWithoutBuyerInput;
  update: MroPartOrderUpdateWithoutBuyerInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroPartOrderCreateWithoutMroOrganizationInput;
  update: MroPartOrderUpdateWithoutMroOrganizationInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderUpsertWithWhereUniqueWithoutMroPartVendorInput = {
  create: MroPartOrderCreateWithoutMroPartVendorInput;
  update: MroPartOrderUpdateWithoutMroPartVendorInput;
  where: MroPartOrderWhereUniqueInput;
};

export type MroPartOrderUpsertWithoutMroPartOrderItemsInput = {
  create: MroPartOrderCreateWithoutMroPartOrderItemsInput;
  update: MroPartOrderUpdateWithoutMroPartOrderItemsInput;
  where?: InputMaybe<MroPartOrderWhereInput>;
};

export type MroPartOrderVersion = {
  __typename?: 'MroPartOrderVersion';
  MroPartOrder?: Maybe<MroPartOrder>;
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartOrderId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartOrderVersionCreateManyMroPartOrderInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderVersionCreateManyMroPartOrderInputEnvelope = {
  data: Array<MroPartOrderVersionCreateManyMroPartOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartOrderVersionCreateNestedManyWithoutMroPartOrderInput = {
  connect?: InputMaybe<Array<MroPartOrderVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderVersionCreateOrConnectWithoutMroPartOrderInput>>;
  create?: InputMaybe<Array<MroPartOrderVersionCreateWithoutMroPartOrderInput>>;
  createMany?: InputMaybe<MroPartOrderVersionCreateManyMroPartOrderInputEnvelope>;
};

export type MroPartOrderVersionCreateOrConnectWithoutMroPartOrderInput = {
  create: MroPartOrderVersionCreateWithoutMroPartOrderInput;
  where: MroPartOrderVersionWhereUniqueInput;
};

export type MroPartOrderVersionCreateWithoutMroPartOrderInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderVersionListRelationFilter = {
  every?: InputMaybe<MroPartOrderVersionWhereInput>;
  none?: InputMaybe<MroPartOrderVersionWhereInput>;
  some?: InputMaybe<MroPartOrderVersionWhereInput>;
};

export type MroPartOrderVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartOrderId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartOrderVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderVersionUpdateManyWithWhereWithoutMroPartOrderInput = {
  data: MroPartOrderVersionUpdateManyMutationInput;
  where: MroPartOrderVersionScalarWhereInput;
};

export type MroPartOrderVersionUpdateManyWithoutMroPartOrderNestedInput = {
  connect?: InputMaybe<Array<MroPartOrderVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartOrderVersionCreateOrConnectWithoutMroPartOrderInput>>;
  create?: InputMaybe<Array<MroPartOrderVersionCreateWithoutMroPartOrderInput>>;
  createMany?: InputMaybe<MroPartOrderVersionCreateManyMroPartOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroPartOrderVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartOrderVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartOrderVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartOrderVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartOrderVersionUpdateWithWhereUniqueWithoutMroPartOrderInput>>;
  updateMany?: InputMaybe<Array<MroPartOrderVersionUpdateManyWithWhereWithoutMroPartOrderInput>>;
  upsert?: InputMaybe<Array<MroPartOrderVersionUpsertWithWhereUniqueWithoutMroPartOrderInput>>;
};

export type MroPartOrderVersionUpdateWithWhereUniqueWithoutMroPartOrderInput = {
  data: MroPartOrderVersionUpdateWithoutMroPartOrderInput;
  where: MroPartOrderVersionWhereUniqueInput;
};

export type MroPartOrderVersionUpdateWithoutMroPartOrderInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartOrderVersionUpsertWithWhereUniqueWithoutMroPartOrderInput = {
  create: MroPartOrderVersionCreateWithoutMroPartOrderInput;
  update: MroPartOrderVersionUpdateWithoutMroPartOrderInput;
  where: MroPartOrderVersionWhereUniqueInput;
};

export type MroPartOrderVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderVersionWhereInput>>;
  MroPartOrder?: InputMaybe<MroPartOrderNullableScalarRelationFilter>;
  NOT?: InputMaybe<Array<MroPartOrderVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartOrderId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartOrderVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartOrderVersionWhereInput>>;
  MroPartOrder?: InputMaybe<MroPartOrderNullableScalarRelationFilter>;
  NOT?: InputMaybe<Array<MroPartOrderVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartOrderId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartOrderWhereInput = {
  AND?: InputMaybe<Array<MroPartOrderWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderWhereInput>>;
  buyer?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  buyerId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  issuedDate?: InputMaybe<DateTimeNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemListRelationFilter>;
  mroPartVendor?: InputMaybe<MroPartVendorNullableScalarRelationFilter>;
  mroPartVendorId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  orderNumber?: InputMaybe<StringNullableFilter>;
  purchaseDate?: InputMaybe<DateTimeNullableFilter>;
  shippingCost?: InputMaybe<DecimalNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  trackingInfo?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartOrderVersionListRelationFilter>;
};

export type MroPartOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartOrderWhereInput>>;
  NOT?: InputMaybe<Array<MroPartOrderWhereInput>>;
  OR?: InputMaybe<Array<MroPartOrderWhereInput>>;
  buyer?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  buyerId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<DateTimeNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemListRelationFilter>;
  mroPartVendor?: InputMaybe<MroPartVendorNullableScalarRelationFilter>;
  mroPartVendorId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  orderNumber?: InputMaybe<StringNullableFilter>;
  purchaseDate?: InputMaybe<DateTimeNullableFilter>;
  shippingCost?: InputMaybe<DecimalNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  trackingInfo?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartOrderVersionListRelationFilter>;
};

export type MroPartPriceMatrix = {
  __typename?: 'MroPartPriceMatrix';
  _count: MroPartPriceMatrixCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroOrganization?: Maybe<Array<MroOrganization>>;
  partMatrix: Scalars['JSON'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixCount = {
  __typename?: 'MroPartPriceMatrixCount';
  mroOrganization: Scalars['Int'];
};

export type MroPartPriceMatrixCountAggregate = {
  __typename?: 'MroPartPriceMatrixCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  partMatrix: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartPriceMatrixCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedManyWithoutMroPartPriceMatrixInput>;
  partMatrix: Scalars['JSON'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixCreateNestedOneWithoutMroOrganizationInput = {
  connect?: InputMaybe<MroPartPriceMatrixWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartPriceMatrixCreateOrConnectWithoutMroOrganizationInput>;
  create?: InputMaybe<MroPartPriceMatrixCreateWithoutMroOrganizationInput>;
};

export type MroPartPriceMatrixCreateOrConnectWithoutMroOrganizationInput = {
  create: MroPartPriceMatrixCreateWithoutMroOrganizationInput;
  where: MroPartPriceMatrixWhereUniqueInput;
};

export type MroPartPriceMatrixCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  partMatrix: Scalars['JSON'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixMaxAggregate = {
  __typename?: 'MroPartPriceMatrixMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixMinAggregate = {
  __typename?: 'MroPartPriceMatrixMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartPriceMatrixWhereInput>;
  isNot?: InputMaybe<MroPartPriceMatrixWhereInput>;
};

export type MroPartPriceMatrixUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateManyWithoutMroPartPriceMatrixNestedInput>;
  partMatrix?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixUpdateOneWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<MroPartPriceMatrixWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartPriceMatrixCreateOrConnectWithoutMroOrganizationInput>;
  create?: InputMaybe<MroPartPriceMatrixCreateWithoutMroOrganizationInput>;
  delete?: InputMaybe<MroPartPriceMatrixWhereInput>;
  disconnect?: InputMaybe<MroPartPriceMatrixWhereInput>;
  update?: InputMaybe<MroPartPriceMatrixUpdateToOneWithWhereWithoutMroOrganizationInput>;
  upsert?: InputMaybe<MroPartPriceMatrixUpsertWithoutMroOrganizationInput>;
};

export type MroPartPriceMatrixUpdateToOneWithWhereWithoutMroOrganizationInput = {
  data: MroPartPriceMatrixUpdateWithoutMroOrganizationInput;
  where?: InputMaybe<MroPartPriceMatrixWhereInput>;
};

export type MroPartPriceMatrixUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  partMatrix?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartPriceMatrixUpsertWithoutMroOrganizationInput = {
  create: MroPartPriceMatrixCreateWithoutMroOrganizationInput;
  update: MroPartPriceMatrixUpdateWithoutMroOrganizationInput;
  where?: InputMaybe<MroPartPriceMatrixWhereInput>;
};

export type MroPartPriceMatrixWhereInput = {
  AND?: InputMaybe<Array<MroPartPriceMatrixWhereInput>>;
  NOT?: InputMaybe<Array<MroPartPriceMatrixWhereInput>>;
  OR?: InputMaybe<Array<MroPartPriceMatrixWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationListRelationFilter>;
  partMatrix?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartPriceMatrixWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartPriceMatrixWhereInput>>;
  NOT?: InputMaybe<Array<MroPartPriceMatrixWhereInput>>;
  OR?: InputMaybe<Array<MroPartPriceMatrixWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationListRelationFilter>;
  partMatrix?: InputMaybe<JsonFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartScalarRelationFilter = {
  is?: InputMaybe<MroPartWhereInput>;
  isNot?: InputMaybe<MroPartWhereInput>;
};

export type MroPartScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isSerialized?: InputMaybe<BoolNullableFilter>;
  manufacturerId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  partNumber?: InputMaybe<StringFilter>;
  preferred?: InputMaybe<BoolNullableFilter>;
  secondaryPartNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartSource = {
  __typename?: 'MroPartSource';
  _count: MroPartSourceCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastPrice?: Maybe<Scalars['Decimal']>;
  mroPart?: Maybe<MroPart>;
  mroPartId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroPartSourceVersion>>;
};

export type MroPartSourceAvgAggregate = {
  __typename?: 'MroPartSourceAvgAggregate';
  lastPrice?: Maybe<Scalars['Decimal']>;
};

export type MroPartSourceCount = {
  __typename?: 'MroPartSourceCount';
  versions: Scalars['Int'];
};

export type MroPartSourceCountAggregate = {
  __typename?: 'MroPartSourceCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  lastPrice: Scalars['Int'];
  mroPartId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartSourceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<Scalars['Decimal']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroPartSourcesInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartSourceVersionCreateNestedManyWithoutMroPartSourceInput>;
};

export type MroPartSourceCreateManyMroPartInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartSourceCreateManyMroPartInputEnvelope = {
  data: Array<MroPartSourceCreateManyMroPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartSourceCreateNestedManyWithoutMroPartInput = {
  connect?: InputMaybe<Array<MroPartSourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartSourceCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartSourceCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartSourceCreateManyMroPartInputEnvelope>;
};

export type MroPartSourceCreateOrConnectWithoutMroPartInput = {
  create: MroPartSourceCreateWithoutMroPartInput;
  where: MroPartSourceWhereUniqueInput;
};

export type MroPartSourceCreateWithoutMroPartInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartSourceVersionCreateNestedManyWithoutMroPartSourceInput>;
};

export type MroPartSourceListRelationFilter = {
  every?: InputMaybe<MroPartSourceWhereInput>;
  none?: InputMaybe<MroPartSourceWhereInput>;
  some?: InputMaybe<MroPartSourceWhereInput>;
};

export type MroPartSourceMaxAggregate = {
  __typename?: 'MroPartSourceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPrice?: Maybe<Scalars['Decimal']>;
  mroPartId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartSourceMinAggregate = {
  __typename?: 'MroPartSourceMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastPrice?: Maybe<Scalars['Decimal']>;
  mroPartId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartSourceNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartSourceWhereInput>;
  isNot?: InputMaybe<MroPartSourceWhereInput>;
};

export type MroPartSourceScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartSourceScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartSourceScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartSourceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastPrice?: InputMaybe<DecimalNullableFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroPartSourceSumAggregate = {
  __typename?: 'MroPartSourceSumAggregate';
  lastPrice?: Maybe<Scalars['Decimal']>;
};

export type MroPartSourceUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<Scalars['Decimal']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroPartSourcesNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartSourceVersionUpdateManyWithoutMroPartSourceNestedInput>;
};

export type MroPartSourceUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<Scalars['Decimal']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartSourceUpdateManyWithWhereWithoutMroPartInput = {
  data: MroPartSourceUpdateManyMutationInput;
  where: MroPartSourceScalarWhereInput;
};

export type MroPartSourceUpdateManyWithoutMroPartNestedInput = {
  connect?: InputMaybe<Array<MroPartSourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartSourceCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartSourceCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartSourceCreateManyMroPartInputEnvelope>;
  delete?: InputMaybe<Array<MroPartSourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartSourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartSourceWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartSourceWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartSourceUpdateWithWhereUniqueWithoutMroPartInput>>;
  updateMany?: InputMaybe<Array<MroPartSourceUpdateManyWithWhereWithoutMroPartInput>>;
  upsert?: InputMaybe<Array<MroPartSourceUpsertWithWhereUniqueWithoutMroPartInput>>;
};

export type MroPartSourceUpdateWithWhereUniqueWithoutMroPartInput = {
  data: MroPartSourceUpdateWithoutMroPartInput;
  where: MroPartSourceWhereUniqueInput;
};

export type MroPartSourceUpdateWithoutMroPartInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<Scalars['Decimal']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartSourceVersionUpdateManyWithoutMroPartSourceNestedInput>;
};

export type MroPartSourceUpsertWithWhereUniqueWithoutMroPartInput = {
  create: MroPartSourceCreateWithoutMroPartInput;
  update: MroPartSourceUpdateWithoutMroPartInput;
  where: MroPartSourceWhereUniqueInput;
};

export type MroPartSourceVersion = {
  __typename?: 'MroPartSourceVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartSource?: Maybe<MroPartSource>;
  mroPartSourceId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartSourceVersionCreateManyMroPartSourceInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartSourceVersionCreateManyMroPartSourceInputEnvelope = {
  data: Array<MroPartSourceVersionCreateManyMroPartSourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartSourceVersionCreateNestedManyWithoutMroPartSourceInput = {
  connect?: InputMaybe<Array<MroPartSourceVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartSourceVersionCreateOrConnectWithoutMroPartSourceInput>>;
  create?: InputMaybe<Array<MroPartSourceVersionCreateWithoutMroPartSourceInput>>;
  createMany?: InputMaybe<MroPartSourceVersionCreateManyMroPartSourceInputEnvelope>;
};

export type MroPartSourceVersionCreateOrConnectWithoutMroPartSourceInput = {
  create: MroPartSourceVersionCreateWithoutMroPartSourceInput;
  where: MroPartSourceVersionWhereUniqueInput;
};

export type MroPartSourceVersionCreateWithoutMroPartSourceInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartSourceVersionListRelationFilter = {
  every?: InputMaybe<MroPartSourceVersionWhereInput>;
  none?: InputMaybe<MroPartSourceVersionWhereInput>;
  some?: InputMaybe<MroPartSourceVersionWhereInput>;
};

export type MroPartSourceVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartSourceVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartSourceVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartSourceVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartSourceId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartSourceVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartSourceVersionUpdateManyWithWhereWithoutMroPartSourceInput = {
  data: MroPartSourceVersionUpdateManyMutationInput;
  where: MroPartSourceVersionScalarWhereInput;
};

export type MroPartSourceVersionUpdateManyWithoutMroPartSourceNestedInput = {
  connect?: InputMaybe<Array<MroPartSourceVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartSourceVersionCreateOrConnectWithoutMroPartSourceInput>>;
  create?: InputMaybe<Array<MroPartSourceVersionCreateWithoutMroPartSourceInput>>;
  createMany?: InputMaybe<MroPartSourceVersionCreateManyMroPartSourceInputEnvelope>;
  delete?: InputMaybe<Array<MroPartSourceVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartSourceVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartSourceVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartSourceVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartSourceVersionUpdateWithWhereUniqueWithoutMroPartSourceInput>>;
  updateMany?: InputMaybe<Array<MroPartSourceVersionUpdateManyWithWhereWithoutMroPartSourceInput>>;
  upsert?: InputMaybe<Array<MroPartSourceVersionUpsertWithWhereUniqueWithoutMroPartSourceInput>>;
};

export type MroPartSourceVersionUpdateWithWhereUniqueWithoutMroPartSourceInput = {
  data: MroPartSourceVersionUpdateWithoutMroPartSourceInput;
  where: MroPartSourceVersionWhereUniqueInput;
};

export type MroPartSourceVersionUpdateWithoutMroPartSourceInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartSourceVersionUpsertWithWhereUniqueWithoutMroPartSourceInput = {
  create: MroPartSourceVersionCreateWithoutMroPartSourceInput;
  update: MroPartSourceVersionUpdateWithoutMroPartSourceInput;
  where: MroPartSourceVersionWhereUniqueInput;
};

export type MroPartSourceVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartSourceVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartSourceVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartSourceVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartSource?: InputMaybe<MroPartSourceNullableScalarRelationFilter>;
  mroPartSourceId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartSourceVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartSourceVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartSourceVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartSourceVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartSource?: InputMaybe<MroPartSourceNullableScalarRelationFilter>;
  mroPartSourceId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartSourceWhereInput = {
  AND?: InputMaybe<Array<MroPartSourceWhereInput>>;
  NOT?: InputMaybe<Array<MroPartSourceWhereInput>>;
  OR?: InputMaybe<Array<MroPartSourceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastPrice?: InputMaybe<DecimalNullableFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartSourceVersionListRelationFilter>;
};

export type MroPartSourceWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartSourceWhereInput>>;
  NOT?: InputMaybe<Array<MroPartSourceWhereInput>>;
  OR?: InputMaybe<Array<MroPartSourceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  lastPrice?: InputMaybe<DecimalNullableFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroPartSourceVersionListRelationFilter>;
};

export type MroPartUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartUpdateManyWithWhereWithoutManufacturerInput = {
  data: MroPartUpdateManyMutationInput;
  where: MroPartScalarWhereInput;
};

export type MroPartUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroPartUpdateManyMutationInput;
  where: MroPartScalarWhereInput;
};

export type MroPartUpdateManyWithWhereWithoutVariantsLeftInput = {
  data: MroPartUpdateManyMutationInput;
  where: MroPartScalarWhereInput;
};

export type MroPartUpdateManyWithWhereWithoutVariantsRightInput = {
  data: MroPartUpdateManyMutationInput;
  where: MroPartScalarWhereInput;
};

export type MroPartUpdateManyWithoutManufacturerNestedInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutManufacturerInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutManufacturerInput>>;
  createMany?: InputMaybe<MroPartCreateManyManufacturerInputEnvelope>;
  delete?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartUpdateWithWhereUniqueWithoutManufacturerInput>>;
  updateMany?: InputMaybe<Array<MroPartUpdateManyWithWhereWithoutManufacturerInput>>;
  upsert?: InputMaybe<Array<MroPartUpsertWithWhereUniqueWithoutManufacturerInput>>;
};

export type MroPartUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroPartUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroPartUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroPartUpdateManyWithoutVariantsLeftNestedInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutVariantsLeftInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutVariantsLeftInput>>;
  delete?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartUpdateWithWhereUniqueWithoutVariantsLeftInput>>;
  updateMany?: InputMaybe<Array<MroPartUpdateManyWithWhereWithoutVariantsLeftInput>>;
  upsert?: InputMaybe<Array<MroPartUpsertWithWhereUniqueWithoutVariantsLeftInput>>;
};

export type MroPartUpdateManyWithoutVariantsRightNestedInput = {
  connect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartCreateOrConnectWithoutVariantsRightInput>>;
  create?: InputMaybe<Array<MroPartCreateWithoutVariantsRightInput>>;
  delete?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartUpdateWithWhereUniqueWithoutVariantsRightInput>>;
  updateMany?: InputMaybe<Array<MroPartUpdateManyWithWhereWithoutVariantsRightInput>>;
  upsert?: InputMaybe<Array<MroPartUpsertWithWhereUniqueWithoutVariantsRightInput>>;
};

export type MroPartUpdateOneRequiredWithoutMroPartInventoriesNestedInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroPartInventoriesInput>;
  create?: InputMaybe<MroPartCreateWithoutMroPartInventoriesInput>;
  update?: InputMaybe<MroPartUpdateToOneWithWhereWithoutMroPartInventoriesInput>;
  upsert?: InputMaybe<MroPartUpsertWithoutMroPartInventoriesInput>;
};

export type MroPartUpdateOneWithoutMroPartOrderItemsNestedInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroPartOrderItemsInput>;
  create?: InputMaybe<MroPartCreateWithoutMroPartOrderItemsInput>;
  delete?: InputMaybe<MroPartWhereInput>;
  disconnect?: InputMaybe<MroPartWhereInput>;
  update?: InputMaybe<MroPartUpdateToOneWithWhereWithoutMroPartOrderItemsInput>;
  upsert?: InputMaybe<MroPartUpsertWithoutMroPartOrderItemsInput>;
};

export type MroPartUpdateOneWithoutMroPartSourcesNestedInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroPartSourcesInput>;
  create?: InputMaybe<MroPartCreateWithoutMroPartSourcesInput>;
  delete?: InputMaybe<MroPartWhereInput>;
  disconnect?: InputMaybe<MroPartWhereInput>;
  update?: InputMaybe<MroPartUpdateToOneWithWhereWithoutMroPartSourcesInput>;
  upsert?: InputMaybe<MroPartUpsertWithoutMroPartSourcesInput>;
};

export type MroPartUpdateOneWithoutMroSerializedPartsNestedInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroSerializedPartsInput>;
  create?: InputMaybe<MroPartCreateWithoutMroSerializedPartsInput>;
  delete?: InputMaybe<MroPartWhereInput>;
  disconnect?: InputMaybe<MroPartWhereInput>;
  update?: InputMaybe<MroPartUpdateToOneWithWhereWithoutMroSerializedPartsInput>;
  upsert?: InputMaybe<MroPartUpsertWithoutMroSerializedPartsInput>;
};

export type MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput = {
  connect?: InputMaybe<MroPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroPartCreateWithoutMroWorkOrderPartsInput>;
  delete?: InputMaybe<MroPartWhereInput>;
  disconnect?: InputMaybe<MroPartWhereInput>;
  update?: InputMaybe<MroPartUpdateToOneWithWhereWithoutMroWorkOrderPartsInput>;
  upsert?: InputMaybe<MroPartUpsertWithoutMroWorkOrderPartsInput>;
};

export type MroPartUpdateToOneWithWhereWithoutMroPartInventoriesInput = {
  data: MroPartUpdateWithoutMroPartInventoriesInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpdateToOneWithWhereWithoutMroPartOrderItemsInput = {
  data: MroPartUpdateWithoutMroPartOrderItemsInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpdateToOneWithWhereWithoutMroPartSourcesInput = {
  data: MroPartUpdateWithoutMroPartSourcesInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpdateToOneWithWhereWithoutMroSerializedPartsInput = {
  data: MroPartUpdateWithoutMroSerializedPartsInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpdateToOneWithWhereWithoutMroWorkOrderPartsInput = {
  data: MroPartUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpdateWithWhereUniqueWithoutManufacturerInput = {
  data: MroPartUpdateWithoutManufacturerInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroPartUpdateWithoutMroOrganizationInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpdateWithWhereUniqueWithoutVariantsLeftInput = {
  data: MroPartUpdateWithoutVariantsLeftInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpdateWithWhereUniqueWithoutVariantsRightInput = {
  data: MroPartUpdateWithoutVariantsRightInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpdateWithoutManufacturerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutMroPartInventoriesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutMroPartOrderItemsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutMroPartSourcesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutMroSerializedPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutMroWorkOrderPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutVariantsLeftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsRight?: InputMaybe<MroPartUpdateManyWithoutVariantsLeftNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpdateWithoutVariantsRightInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<Scalars['Boolean']>;
  manufacturer?: InputMaybe<MroPartManufacturerUpdateOneWithoutMroPartsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartsNestedInput>;
  mroPartInventories?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartNestedInput>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroPartNestedInput>;
  mroPartSources?: InputMaybe<MroPartSourceUpdateManyWithoutMroPartNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroPartNestedInput>;
  partNumber?: InputMaybe<Scalars['String']>;
  preferred?: InputMaybe<Scalars['Boolean']>;
  secondaryPartNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  variantsLeft?: InputMaybe<MroPartUpdateManyWithoutVariantsRightNestedInput>;
  versions?: InputMaybe<MroPartVersionUpdateManyWithoutMroPartNestedInput>;
};

export type MroPartUpsertWithWhereUniqueWithoutManufacturerInput = {
  create: MroPartCreateWithoutManufacturerInput;
  update: MroPartUpdateWithoutManufacturerInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroPartCreateWithoutMroOrganizationInput;
  update: MroPartUpdateWithoutMroOrganizationInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpsertWithWhereUniqueWithoutVariantsLeftInput = {
  create: MroPartCreateWithoutVariantsLeftInput;
  update: MroPartUpdateWithoutVariantsLeftInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpsertWithWhereUniqueWithoutVariantsRightInput = {
  create: MroPartCreateWithoutVariantsRightInput;
  update: MroPartUpdateWithoutVariantsRightInput;
  where: MroPartWhereUniqueInput;
};

export type MroPartUpsertWithoutMroPartInventoriesInput = {
  create: MroPartCreateWithoutMroPartInventoriesInput;
  update: MroPartUpdateWithoutMroPartInventoriesInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpsertWithoutMroPartOrderItemsInput = {
  create: MroPartCreateWithoutMroPartOrderItemsInput;
  update: MroPartUpdateWithoutMroPartOrderItemsInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpsertWithoutMroPartSourcesInput = {
  create: MroPartCreateWithoutMroPartSourcesInput;
  update: MroPartUpdateWithoutMroPartSourcesInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpsertWithoutMroSerializedPartsInput = {
  create: MroPartCreateWithoutMroSerializedPartsInput;
  update: MroPartUpdateWithoutMroSerializedPartsInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartUpsertWithoutMroWorkOrderPartsInput = {
  create: MroPartCreateWithoutMroWorkOrderPartsInput;
  update: MroPartUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroPartWhereInput>;
};

export type MroPartVendor = {
  __typename?: 'MroPartVendor';
  _count: MroPartVendorCount;
  address?: Maybe<MroAddress>;
  addressId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartOrder?: Maybe<Array<MroPartOrder>>;
  name?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendorCode?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<MroPartVendorVersion>>;
};

export type MroPartVendorCount = {
  __typename?: 'MroPartVendorCount';
  mroPartOrder: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroPartVendorCountAggregate = {
  __typename?: 'MroPartVendorCountAggregate';
  _all: Scalars['Int'];
  addressId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  name: Scalars['Int'];
  phoneNumbers: Scalars['Int'];
  updatedAt: Scalars['Int'];
  vendorCode: Scalars['Int'];
};

export type MroPartVendorCreateInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroPartVendorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartVendorInput>;
  mroPartOrder?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroPartVendorInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionCreateNestedManyWithoutMroPartVendorInput>;
};

export type MroPartVendorCreateManyAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorCreateManyAddressInputEnvelope = {
  data: Array<MroPartVendorCreateManyAddressInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartVendorCreateManyMroOrganizationInput = {
  addressId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroPartVendorCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartVendorCreateNestedManyWithoutAddressInput = {
  connect?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVendorCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroPartVendorCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroPartVendorCreateManyAddressInputEnvelope>;
};

export type MroPartVendorCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVendorCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartVendorCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartVendorCreateManyMroOrganizationInputEnvelope>;
};

export type MroPartVendorCreateNestedOneWithoutMroPartOrderInput = {
  connect?: InputMaybe<MroPartVendorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartVendorCreateOrConnectWithoutMroPartOrderInput>;
  create?: InputMaybe<MroPartVendorCreateWithoutMroPartOrderInput>;
};

export type MroPartVendorCreateOrConnectWithoutAddressInput = {
  create: MroPartVendorCreateWithoutAddressInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorCreateOrConnectWithoutMroOrganizationInput = {
  create: MroPartVendorCreateWithoutMroOrganizationInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorCreateOrConnectWithoutMroPartOrderInput = {
  create: MroPartVendorCreateWithoutMroPartOrderInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorCreateWithoutAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartVendorInput>;
  mroPartOrder?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroPartVendorInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionCreateNestedManyWithoutMroPartVendorInput>;
};

export type MroPartVendorCreateWithoutMroOrganizationInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroPartVendorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartOrder?: InputMaybe<MroPartOrderCreateNestedManyWithoutMroPartVendorInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionCreateNestedManyWithoutMroPartVendorInput>;
};

export type MroPartVendorCreateWithoutMroPartOrderInput = {
  address?: InputMaybe<MroAddressCreateNestedOneWithoutMroPartVendorInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartVendorInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionCreateNestedManyWithoutMroPartVendorInput>;
};

export type MroPartVendorListRelationFilter = {
  every?: InputMaybe<MroPartVendorWhereInput>;
  none?: InputMaybe<MroPartVendorWhereInput>;
  some?: InputMaybe<MroPartVendorWhereInput>;
};

export type MroPartVendorMaxAggregate = {
  __typename?: 'MroPartVendorMaxAggregate';
  addressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendorCode?: Maybe<Scalars['String']>;
};

export type MroPartVendorMinAggregate = {
  __typename?: 'MroPartVendorMinAggregate';
  addressId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendorCode?: Maybe<Scalars['String']>;
};

export type MroPartVendorNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartVendorWhereInput>;
  isNot?: InputMaybe<MroPartVendorWhereInput>;
};

export type MroPartVendorScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartVendorScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVendorScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartVendorScalarWhereInput>>;
  addressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  vendorCode?: InputMaybe<StringNullableFilter>;
};

export type MroPartVendorUpdateInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroPartVendorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartVendorNestedInput>;
  mroPartOrder?: InputMaybe<MroPartOrderUpdateManyWithoutMroPartVendorNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionUpdateManyWithoutMroPartVendorNestedInput>;
};

export type MroPartVendorUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorUpdateManyWithWhereWithoutAddressInput = {
  data: MroPartVendorUpdateManyMutationInput;
  where: MroPartVendorScalarWhereInput;
};

export type MroPartVendorUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroPartVendorUpdateManyMutationInput;
  where: MroPartVendorScalarWhereInput;
};

export type MroPartVendorUpdateManyWithoutAddressNestedInput = {
  connect?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVendorCreateOrConnectWithoutAddressInput>>;
  create?: InputMaybe<Array<MroPartVendorCreateWithoutAddressInput>>;
  createMany?: InputMaybe<MroPartVendorCreateManyAddressInputEnvelope>;
  delete?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartVendorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartVendorUpdateWithWhereUniqueWithoutAddressInput>>;
  updateMany?: InputMaybe<Array<MroPartVendorUpdateManyWithWhereWithoutAddressInput>>;
  upsert?: InputMaybe<Array<MroPartVendorUpsertWithWhereUniqueWithoutAddressInput>>;
};

export type MroPartVendorUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVendorCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartVendorCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartVendorCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartVendorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartVendorWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartVendorUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroPartVendorUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroPartVendorUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroPartVendorUpdateOneWithoutMroPartOrderNestedInput = {
  connect?: InputMaybe<MroPartVendorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartVendorCreateOrConnectWithoutMroPartOrderInput>;
  create?: InputMaybe<MroPartVendorCreateWithoutMroPartOrderInput>;
  delete?: InputMaybe<MroPartVendorWhereInput>;
  disconnect?: InputMaybe<MroPartVendorWhereInput>;
  update?: InputMaybe<MroPartVendorUpdateToOneWithWhereWithoutMroPartOrderInput>;
  upsert?: InputMaybe<MroPartVendorUpsertWithoutMroPartOrderInput>;
};

export type MroPartVendorUpdateToOneWithWhereWithoutMroPartOrderInput = {
  data: MroPartVendorUpdateWithoutMroPartOrderInput;
  where?: InputMaybe<MroPartVendorWhereInput>;
};

export type MroPartVendorUpdateWithWhereUniqueWithoutAddressInput = {
  data: MroPartVendorUpdateWithoutAddressInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroPartVendorUpdateWithoutMroOrganizationInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorUpdateWithoutAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartVendorNestedInput>;
  mroPartOrder?: InputMaybe<MroPartOrderUpdateManyWithoutMroPartVendorNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionUpdateManyWithoutMroPartVendorNestedInput>;
};

export type MroPartVendorUpdateWithoutMroOrganizationInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroPartVendorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartOrder?: InputMaybe<MroPartOrderUpdateManyWithoutMroPartVendorNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionUpdateManyWithoutMroPartVendorNestedInput>;
};

export type MroPartVendorUpdateWithoutMroPartOrderInput = {
  address?: InputMaybe<MroAddressUpdateOneWithoutMroPartVendorNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartVendorNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Scalars['JSON']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorCode?: InputMaybe<Scalars['String']>;
  versions?: InputMaybe<MroPartVendorVersionUpdateManyWithoutMroPartVendorNestedInput>;
};

export type MroPartVendorUpsertWithWhereUniqueWithoutAddressInput = {
  create: MroPartVendorCreateWithoutAddressInput;
  update: MroPartVendorUpdateWithoutAddressInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroPartVendorCreateWithoutMroOrganizationInput;
  update: MroPartVendorUpdateWithoutMroOrganizationInput;
  where: MroPartVendorWhereUniqueInput;
};

export type MroPartVendorUpsertWithoutMroPartOrderInput = {
  create: MroPartVendorCreateWithoutMroPartOrderInput;
  update: MroPartVendorUpdateWithoutMroPartOrderInput;
  where?: InputMaybe<MroPartVendorWhereInput>;
};

export type MroPartVendorVersion = {
  __typename?: 'MroPartVendorVersion';
  MroPartVendor?: Maybe<MroPartVendor>;
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartVendorId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartVendorVersionCreateManyMroPartVendorInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorVersionCreateManyMroPartVendorInputEnvelope = {
  data: Array<MroPartVendorVersionCreateManyMroPartVendorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartVendorVersionCreateNestedManyWithoutMroPartVendorInput = {
  connect?: InputMaybe<Array<MroPartVendorVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVendorVersionCreateOrConnectWithoutMroPartVendorInput>>;
  create?: InputMaybe<Array<MroPartVendorVersionCreateWithoutMroPartVendorInput>>;
  createMany?: InputMaybe<MroPartVendorVersionCreateManyMroPartVendorInputEnvelope>;
};

export type MroPartVendorVersionCreateOrConnectWithoutMroPartVendorInput = {
  create: MroPartVendorVersionCreateWithoutMroPartVendorInput;
  where: MroPartVendorVersionWhereUniqueInput;
};

export type MroPartVendorVersionCreateWithoutMroPartVendorInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorVersionListRelationFilter = {
  every?: InputMaybe<MroPartVendorVersionWhereInput>;
  none?: InputMaybe<MroPartVendorVersionWhereInput>;
  some?: InputMaybe<MroPartVendorVersionWhereInput>;
};

export type MroPartVendorVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartVendorVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVendorVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartVendorVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartVendorId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartVendorVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorVersionUpdateManyWithWhereWithoutMroPartVendorInput = {
  data: MroPartVendorVersionUpdateManyMutationInput;
  where: MroPartVendorVersionScalarWhereInput;
};

export type MroPartVendorVersionUpdateManyWithoutMroPartVendorNestedInput = {
  connect?: InputMaybe<Array<MroPartVendorVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVendorVersionCreateOrConnectWithoutMroPartVendorInput>>;
  create?: InputMaybe<Array<MroPartVendorVersionCreateWithoutMroPartVendorInput>>;
  createMany?: InputMaybe<MroPartVendorVersionCreateManyMroPartVendorInputEnvelope>;
  delete?: InputMaybe<Array<MroPartVendorVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartVendorVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartVendorVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartVendorVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartVendorVersionUpdateWithWhereUniqueWithoutMroPartVendorInput>>;
  updateMany?: InputMaybe<Array<MroPartVendorVersionUpdateManyWithWhereWithoutMroPartVendorInput>>;
  upsert?: InputMaybe<Array<MroPartVendorVersionUpsertWithWhereUniqueWithoutMroPartVendorInput>>;
};

export type MroPartVendorVersionUpdateWithWhereUniqueWithoutMroPartVendorInput = {
  data: MroPartVendorVersionUpdateWithoutMroPartVendorInput;
  where: MroPartVendorVersionWhereUniqueInput;
};

export type MroPartVendorVersionUpdateWithoutMroPartVendorInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVendorVersionUpsertWithWhereUniqueWithoutMroPartVendorInput = {
  create: MroPartVendorVersionCreateWithoutMroPartVendorInput;
  update: MroPartVendorVersionUpdateWithoutMroPartVendorInput;
  where: MroPartVendorVersionWhereUniqueInput;
};

export type MroPartVendorVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartVendorVersionWhereInput>>;
  MroPartVendor?: InputMaybe<MroPartVendorNullableScalarRelationFilter>;
  NOT?: InputMaybe<Array<MroPartVendorVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartVendorVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartVendorId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartVendorVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartVendorVersionWhereInput>>;
  MroPartVendor?: InputMaybe<MroPartVendorNullableScalarRelationFilter>;
  NOT?: InputMaybe<Array<MroPartVendorVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartVendorVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartVendorId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartVendorWhereInput = {
  AND?: InputMaybe<Array<MroPartVendorWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVendorWhereInput>>;
  OR?: InputMaybe<Array<MroPartVendorWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartOrder?: InputMaybe<MroPartOrderListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  vendorCode?: InputMaybe<StringNullableFilter>;
  versions?: InputMaybe<MroPartVendorVersionListRelationFilter>;
};

export type MroPartVendorWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartVendorWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVendorWhereInput>>;
  OR?: InputMaybe<Array<MroPartVendorWhereInput>>;
  address?: InputMaybe<MroAddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartOrder?: InputMaybe<MroPartOrderListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phoneNumbers?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  vendorCode?: InputMaybe<StringNullableFilter>;
  versions?: InputMaybe<MroPartVendorVersionListRelationFilter>;
};

export type MroPartVersion = {
  __typename?: 'MroPartVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPart?: Maybe<MroPart>;
  mroPartId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartVersionCreateManyMroPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVersionCreateManyMroPartInputEnvelope = {
  data: Array<MroPartVersionCreateManyMroPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartVersionCreateNestedManyWithoutMroPartInput = {
  connect?: InputMaybe<Array<MroPartVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVersionCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartVersionCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartVersionCreateManyMroPartInputEnvelope>;
};

export type MroPartVersionCreateOrConnectWithoutMroPartInput = {
  create: MroPartVersionCreateWithoutMroPartInput;
  where: MroPartVersionWhereUniqueInput;
};

export type MroPartVersionCreateWithoutMroPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVersionListRelationFilter = {
  every?: InputMaybe<MroPartVersionWhereInput>;
  none?: InputMaybe<MroPartVersionWhereInput>;
  some?: InputMaybe<MroPartVersionWhereInput>;
};

export type MroPartVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVersionUpdateManyWithWhereWithoutMroPartInput = {
  data: MroPartVersionUpdateManyMutationInput;
  where: MroPartVersionScalarWhereInput;
};

export type MroPartVersionUpdateManyWithoutMroPartNestedInput = {
  connect?: InputMaybe<Array<MroPartVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartVersionCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroPartVersionCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroPartVersionCreateManyMroPartInputEnvelope>;
  delete?: InputMaybe<Array<MroPartVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartVersionUpdateWithWhereUniqueWithoutMroPartInput>>;
  updateMany?: InputMaybe<Array<MroPartVersionUpdateManyWithWhereWithoutMroPartInput>>;
  upsert?: InputMaybe<Array<MroPartVersionUpsertWithWhereUniqueWithoutMroPartInput>>;
};

export type MroPartVersionUpdateWithWhereUniqueWithoutMroPartInput = {
  data: MroPartVersionUpdateWithoutMroPartInput;
  where: MroPartVersionWhereUniqueInput;
};

export type MroPartVersionUpdateWithoutMroPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartVersionUpsertWithWhereUniqueWithoutMroPartInput = {
  create: MroPartVersionCreateWithoutMroPartInput;
  update: MroPartVersionUpdateWithoutMroPartInput;
  where: MroPartVersionWhereUniqueInput;
};

export type MroPartVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartWarehouse = {
  __typename?: 'MroPartWarehouse';
  _count: MroPartWarehouseCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroPartInventory?: Maybe<Array<MroPartInventory>>;
  mroSerializedParts?: Maybe<Array<MroSerializedPart>>;
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  versions?: Maybe<Array<MroPartWarehouseVersion>>;
};

export type MroPartWarehouseCount = {
  __typename?: 'MroPartWarehouseCount';
  mroPartInventory: Scalars['Int'];
  mroSerializedParts: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroPartWarehouseCountAggregate = {
  __typename?: 'MroPartWarehouseCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroPartWarehouseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartWarehousesInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartWarehouseInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartWarehouseInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionCreateNestedManyWithoutMroPartWarehouseInput>;
};

export type MroPartWarehouseCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartWarehouseCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroPartWarehouseCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartWarehouseCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroPartWarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartWarehouseCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartWarehouseCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartWarehouseCreateManyMroOrganizationInputEnvelope>;
};

export type MroPartWarehouseCreateNestedOneWithoutMroPartInventoryInput = {
  connect?: InputMaybe<MroPartWarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartWarehouseCreateOrConnectWithoutMroPartInventoryInput>;
  create?: InputMaybe<MroPartWarehouseCreateWithoutMroPartInventoryInput>;
};

export type MroPartWarehouseCreateNestedOneWithoutMroSerializedPartsInput = {
  connect?: InputMaybe<MroPartWarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartWarehouseCreateOrConnectWithoutMroSerializedPartsInput>;
  create?: InputMaybe<MroPartWarehouseCreateWithoutMroSerializedPartsInput>;
};

export type MroPartWarehouseCreateOrConnectWithoutMroOrganizationInput = {
  create: MroPartWarehouseCreateWithoutMroOrganizationInput;
  where: MroPartWarehouseWhereUniqueInput;
};

export type MroPartWarehouseCreateOrConnectWithoutMroPartInventoryInput = {
  create: MroPartWarehouseCreateWithoutMroPartInventoryInput;
  where: MroPartWarehouseWhereUniqueInput;
};

export type MroPartWarehouseCreateOrConnectWithoutMroSerializedPartsInput = {
  create: MroPartWarehouseCreateWithoutMroSerializedPartsInput;
  where: MroPartWarehouseWhereUniqueInput;
};

export type MroPartWarehouseCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartWarehouseInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartWarehouseInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionCreateNestedManyWithoutMroPartWarehouseInput>;
};

export type MroPartWarehouseCreateWithoutMroPartInventoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartWarehousesInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartCreateNestedManyWithoutMroPartWarehouseInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionCreateNestedManyWithoutMroPartWarehouseInput>;
};

export type MroPartWarehouseCreateWithoutMroSerializedPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroPartWarehousesInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedManyWithoutMroPartWarehouseInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionCreateNestedManyWithoutMroPartWarehouseInput>;
};

export type MroPartWarehouseListRelationFilter = {
  every?: InputMaybe<MroPartWarehouseWhereInput>;
  none?: InputMaybe<MroPartWarehouseWhereInput>;
  some?: InputMaybe<MroPartWarehouseWhereInput>;
};

export type MroPartWarehouseMaxAggregate = {
  __typename?: 'MroPartWarehouseMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartWarehouseMinAggregate = {
  __typename?: 'MroPartWarehouseMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroPartWarehouseNullableScalarRelationFilter = {
  is?: InputMaybe<MroPartWarehouseWhereInput>;
  isNot?: InputMaybe<MroPartWarehouseWhereInput>;
};

export type MroPartWarehouseScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartWarehouseScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWarehouseScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartWarehouseScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MroPartWarehouseUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartWarehousesNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartWarehouseNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartWarehouseNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionUpdateManyWithoutMroPartWarehouseNestedInput>;
};

export type MroPartWarehouseUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroPartWarehouseUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroPartWarehouseUpdateManyMutationInput;
  where: MroPartWarehouseScalarWhereInput;
};

export type MroPartWarehouseUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroPartWarehouseWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartWarehouseCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroPartWarehouseCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroPartWarehouseCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroPartWarehouseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartWarehouseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartWarehouseWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartWarehouseWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartWarehouseUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroPartWarehouseUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroPartWarehouseUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroPartWarehouseUpdateOneWithoutMroPartInventoryNestedInput = {
  connect?: InputMaybe<MroPartWarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartWarehouseCreateOrConnectWithoutMroPartInventoryInput>;
  create?: InputMaybe<MroPartWarehouseCreateWithoutMroPartInventoryInput>;
  delete?: InputMaybe<MroPartWarehouseWhereInput>;
  disconnect?: InputMaybe<MroPartWarehouseWhereInput>;
  update?: InputMaybe<MroPartWarehouseUpdateToOneWithWhereWithoutMroPartInventoryInput>;
  upsert?: InputMaybe<MroPartWarehouseUpsertWithoutMroPartInventoryInput>;
};

export type MroPartWarehouseUpdateOneWithoutMroSerializedPartsNestedInput = {
  connect?: InputMaybe<MroPartWarehouseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroPartWarehouseCreateOrConnectWithoutMroSerializedPartsInput>;
  create?: InputMaybe<MroPartWarehouseCreateWithoutMroSerializedPartsInput>;
  delete?: InputMaybe<MroPartWarehouseWhereInput>;
  disconnect?: InputMaybe<MroPartWarehouseWhereInput>;
  update?: InputMaybe<MroPartWarehouseUpdateToOneWithWhereWithoutMroSerializedPartsInput>;
  upsert?: InputMaybe<MroPartWarehouseUpsertWithoutMroSerializedPartsInput>;
};

export type MroPartWarehouseUpdateToOneWithWhereWithoutMroPartInventoryInput = {
  data: MroPartWarehouseUpdateWithoutMroPartInventoryInput;
  where?: InputMaybe<MroPartWarehouseWhereInput>;
};

export type MroPartWarehouseUpdateToOneWithWhereWithoutMroSerializedPartsInput = {
  data: MroPartWarehouseUpdateWithoutMroSerializedPartsInput;
  where?: InputMaybe<MroPartWarehouseWhereInput>;
};

export type MroPartWarehouseUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroPartWarehouseUpdateWithoutMroOrganizationInput;
  where: MroPartWarehouseWhereUniqueInput;
};

export type MroPartWarehouseUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartWarehouseNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartWarehouseNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionUpdateManyWithoutMroPartWarehouseNestedInput>;
};

export type MroPartWarehouseUpdateWithoutMroPartInventoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartWarehousesNestedInput>;
  mroSerializedParts?: InputMaybe<MroSerializedPartUpdateManyWithoutMroPartWarehouseNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionUpdateManyWithoutMroPartWarehouseNestedInput>;
};

export type MroPartWarehouseUpdateWithoutMroSerializedPartsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroPartWarehousesNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateManyWithoutMroPartWarehouseNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroPartWarehouseVersionUpdateManyWithoutMroPartWarehouseNestedInput>;
};

export type MroPartWarehouseUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroPartWarehouseCreateWithoutMroOrganizationInput;
  update: MroPartWarehouseUpdateWithoutMroOrganizationInput;
  where: MroPartWarehouseWhereUniqueInput;
};

export type MroPartWarehouseUpsertWithoutMroPartInventoryInput = {
  create: MroPartWarehouseCreateWithoutMroPartInventoryInput;
  update: MroPartWarehouseUpdateWithoutMroPartInventoryInput;
  where?: InputMaybe<MroPartWarehouseWhereInput>;
};

export type MroPartWarehouseUpsertWithoutMroSerializedPartsInput = {
  create: MroPartWarehouseCreateWithoutMroSerializedPartsInput;
  update: MroPartWarehouseUpdateWithoutMroSerializedPartsInput;
  where?: InputMaybe<MroPartWarehouseWhereInput>;
};

export type MroPartWarehouseVersion = {
  __typename?: 'MroPartWarehouseVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroPartWarehouse?: Maybe<MroPartWarehouse>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroPartWarehouseVersionCreateManyMroPartWarehouseInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartWarehouseVersionCreateManyMroPartWarehouseInputEnvelope = {
  data: Array<MroPartWarehouseVersionCreateManyMroPartWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroPartWarehouseVersionCreateNestedManyWithoutMroPartWarehouseInput = {
  connect?: InputMaybe<Array<MroPartWarehouseVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartWarehouseVersionCreateOrConnectWithoutMroPartWarehouseInput>>;
  create?: InputMaybe<Array<MroPartWarehouseVersionCreateWithoutMroPartWarehouseInput>>;
  createMany?: InputMaybe<MroPartWarehouseVersionCreateManyMroPartWarehouseInputEnvelope>;
};

export type MroPartWarehouseVersionCreateOrConnectWithoutMroPartWarehouseInput = {
  create: MroPartWarehouseVersionCreateWithoutMroPartWarehouseInput;
  where: MroPartWarehouseVersionWhereUniqueInput;
};

export type MroPartWarehouseVersionCreateWithoutMroPartWarehouseInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartWarehouseVersionListRelationFilter = {
  every?: InputMaybe<MroPartWarehouseVersionWhereInput>;
  none?: InputMaybe<MroPartWarehouseVersionWhereInput>;
  some?: InputMaybe<MroPartWarehouseVersionWhereInput>;
};

export type MroPartWarehouseVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroPartWarehouseVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWarehouseVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroPartWarehouseVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartWarehouseVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartWarehouseVersionUpdateManyWithWhereWithoutMroPartWarehouseInput = {
  data: MroPartWarehouseVersionUpdateManyMutationInput;
  where: MroPartWarehouseVersionScalarWhereInput;
};

export type MroPartWarehouseVersionUpdateManyWithoutMroPartWarehouseNestedInput = {
  connect?: InputMaybe<Array<MroPartWarehouseVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroPartWarehouseVersionCreateOrConnectWithoutMroPartWarehouseInput>>;
  create?: InputMaybe<Array<MroPartWarehouseVersionCreateWithoutMroPartWarehouseInput>>;
  createMany?: InputMaybe<MroPartWarehouseVersionCreateManyMroPartWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<MroPartWarehouseVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroPartWarehouseVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroPartWarehouseVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroPartWarehouseVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroPartWarehouseVersionUpdateWithWhereUniqueWithoutMroPartWarehouseInput>>;
  updateMany?: InputMaybe<Array<MroPartWarehouseVersionUpdateManyWithWhereWithoutMroPartWarehouseInput>>;
  upsert?: InputMaybe<Array<MroPartWarehouseVersionUpsertWithWhereUniqueWithoutMroPartWarehouseInput>>;
};

export type MroPartWarehouseVersionUpdateWithWhereUniqueWithoutMroPartWarehouseInput = {
  data: MroPartWarehouseVersionUpdateWithoutMroPartWarehouseInput;
  where: MroPartWarehouseVersionWhereUniqueInput;
};

export type MroPartWarehouseVersionUpdateWithoutMroPartWarehouseInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroPartWarehouseVersionUpsertWithWhereUniqueWithoutMroPartWarehouseInput = {
  create: MroPartWarehouseVersionCreateWithoutMroPartWarehouseInput;
  update: MroPartWarehouseVersionUpdateWithoutMroPartWarehouseInput;
  where: MroPartWarehouseVersionWhereUniqueInput;
};

export type MroPartWarehouseVersionWhereInput = {
  AND?: InputMaybe<Array<MroPartWarehouseVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWarehouseVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartWarehouseVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseNullableScalarRelationFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartWarehouseVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartWarehouseVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWarehouseVersionWhereInput>>;
  OR?: InputMaybe<Array<MroPartWarehouseVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseNullableScalarRelationFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroPartWarehouseWhereInput = {
  AND?: InputMaybe<Array<MroPartWarehouseWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWarehouseWhereInput>>;
  OR?: InputMaybe<Array<MroPartWarehouseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartInventory?: InputMaybe<MroPartInventoryListRelationFilter>;
  mroSerializedParts?: InputMaybe<MroSerializedPartListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<MroPartWarehouseVersionListRelationFilter>;
};

export type MroPartWarehouseWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartWarehouseWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWarehouseWhereInput>>;
  OR?: InputMaybe<Array<MroPartWarehouseWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartInventory?: InputMaybe<MroPartInventoryListRelationFilter>;
  mroSerializedParts?: InputMaybe<MroSerializedPartListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<MroPartWarehouseVersionListRelationFilter>;
};

export type MroPartWhereInput = {
  AND?: InputMaybe<Array<MroPartWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWhereInput>>;
  OR?: InputMaybe<Array<MroPartWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isSerialized?: InputMaybe<BoolNullableFilter>;
  manufacturer?: InputMaybe<MroPartManufacturerNullableScalarRelationFilter>;
  manufacturerId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartInventories?: InputMaybe<MroPartInventoryListRelationFilter>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemListRelationFilter>;
  mroPartSources?: InputMaybe<MroPartSourceListRelationFilter>;
  mroSerializedParts?: InputMaybe<MroSerializedPartListRelationFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  partNumber?: InputMaybe<StringFilter>;
  preferred?: InputMaybe<BoolNullableFilter>;
  secondaryPartNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  variantsLeft?: InputMaybe<MroPartListRelationFilter>;
  variantsRight?: InputMaybe<MroPartListRelationFilter>;
  versions?: InputMaybe<MroPartVersionListRelationFilter>;
};

export type MroPartWhereUniqueInput = {
  AND?: InputMaybe<Array<MroPartWhereInput>>;
  NOT?: InputMaybe<Array<MroPartWhereInput>>;
  OR?: InputMaybe<Array<MroPartWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isSerialized?: InputMaybe<BoolNullableFilter>;
  manufacturer?: InputMaybe<MroPartManufacturerNullableScalarRelationFilter>;
  manufacturerId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroPartInventories?: InputMaybe<MroPartInventoryListRelationFilter>;
  mroPartOrderItems?: InputMaybe<MroPartOrderItemListRelationFilter>;
  mroPartSources?: InputMaybe<MroPartSourceListRelationFilter>;
  mroSerializedParts?: InputMaybe<MroSerializedPartListRelationFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  partNumber?: InputMaybe<StringFilter>;
  preferred?: InputMaybe<BoolNullableFilter>;
  secondaryPartNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  variantsLeft?: InputMaybe<MroPartListRelationFilter>;
  variantsRight?: InputMaybe<MroPartListRelationFilter>;
  versions?: InputMaybe<MroPartVersionListRelationFilter>;
};

export type MroRtsText = {
  __typename?: 'MroRTSText';
  _count: MroRtsTextCount;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroLogEntries?: Maybe<Array<MroLogEntry>>;
  mroOrganization: MroOrganization;
  mroOrganizationId: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroRtsTextAvgAggregate = {
  __typename?: 'MroRTSTextAvgAggregate';
  sort?: Maybe<Scalars['Float']>;
};

export type MroRtsTextCount = {
  __typename?: 'MroRTSTextCount';
  mroLogEntries: Scalars['Int'];
};

export type MroRtsTextCountAggregate = {
  __typename?: 'MroRTSTextCountAggregate';
  _all: Scalars['Int'];
  body: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  sort: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroRtsTextCreateInput = {
  body: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutRtsTextInput>;
  mroOrganization: MroOrganizationCreateNestedOneWithoutMroRtsTextsInput;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextCreateManyMroOrganizationInput = {
  body: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroRtsTextCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroRtsTextCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroRtsTextWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroRtsTextCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroRtsTextCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroRtsTextCreateManyMroOrganizationInputEnvelope>;
};

export type MroRtsTextCreateNestedOneWithoutMroLogEntriesInput = {
  connect?: InputMaybe<MroRtsTextWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroRtsTextCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroRtsTextCreateWithoutMroLogEntriesInput>;
};

export type MroRtsTextCreateOrConnectWithoutMroLogEntriesInput = {
  create: MroRtsTextCreateWithoutMroLogEntriesInput;
  where: MroRtsTextWhereUniqueInput;
};

export type MroRtsTextCreateOrConnectWithoutMroOrganizationInput = {
  create: MroRtsTextCreateWithoutMroOrganizationInput;
  where: MroRtsTextWhereUniqueInput;
};

export type MroRtsTextCreateWithoutMroLogEntriesInput = {
  body: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization: MroOrganizationCreateNestedOneWithoutMroRtsTextsInput;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextCreateWithoutMroOrganizationInput = {
  body: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutRtsTextInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextListRelationFilter = {
  every?: InputMaybe<MroRtsTextWhereInput>;
  none?: InputMaybe<MroRtsTextWhereInput>;
  some?: InputMaybe<MroRtsTextWhereInput>;
};

export type MroRtsTextMaxAggregate = {
  __typename?: 'MroRTSTextMaxAggregate';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroRtsTextMinAggregate = {
  __typename?: 'MroRTSTextMinAggregate';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroRtsTextNullableScalarRelationFilter = {
  is?: InputMaybe<MroRtsTextWhereInput>;
  isNot?: InputMaybe<MroRtsTextWhereInput>;
};

export type MroRtsTextScalarWhereInput = {
  AND?: InputMaybe<Array<MroRtsTextScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroRtsTextScalarWhereInput>>;
  OR?: InputMaybe<Array<MroRtsTextScalarWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroRtsTextSumAggregate = {
  __typename?: 'MroRTSTextSumAggregate';
  sort?: Maybe<Scalars['Int']>;
};

export type MroRtsTextUpdateInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutRtsTextNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneRequiredWithoutMroRtsTextsNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextUpdateManyMutationInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroRtsTextUpdateManyMutationInput;
  where: MroRtsTextScalarWhereInput;
};

export type MroRtsTextUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroRtsTextWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroRtsTextCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroRtsTextCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroRtsTextCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroRtsTextWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroRtsTextScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroRtsTextWhereUniqueInput>>;
  set?: InputMaybe<Array<MroRtsTextWhereUniqueInput>>;
  update?: InputMaybe<Array<MroRtsTextUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroRtsTextUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroRtsTextUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroRtsTextUpdateOneWithoutMroLogEntriesNestedInput = {
  connect?: InputMaybe<MroRtsTextWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroRtsTextCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroRtsTextCreateWithoutMroLogEntriesInput>;
  delete?: InputMaybe<MroRtsTextWhereInput>;
  disconnect?: InputMaybe<MroRtsTextWhereInput>;
  update?: InputMaybe<MroRtsTextUpdateToOneWithWhereWithoutMroLogEntriesInput>;
  upsert?: InputMaybe<MroRtsTextUpsertWithoutMroLogEntriesInput>;
};

export type MroRtsTextUpdateToOneWithWhereWithoutMroLogEntriesInput = {
  data: MroRtsTextUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroRtsTextWhereInput>;
};

export type MroRtsTextUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroRtsTextUpdateWithoutMroOrganizationInput;
  where: MroRtsTextWhereUniqueInput;
};

export type MroRtsTextUpdateWithoutMroLogEntriesInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneRequiredWithoutMroRtsTextsNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextUpdateWithoutMroOrganizationInput = {
  body?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutRtsTextNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRtsTextUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroRtsTextCreateWithoutMroOrganizationInput;
  update: MroRtsTextUpdateWithoutMroOrganizationInput;
  where: MroRtsTextWhereUniqueInput;
};

export type MroRtsTextUpsertWithoutMroLogEntriesInput = {
  create: MroRtsTextCreateWithoutMroLogEntriesInput;
  update: MroRtsTextUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroRtsTextWhereInput>;
};

export type MroRtsTextWhereInput = {
  AND?: InputMaybe<Array<MroRtsTextWhereInput>>;
  NOT?: InputMaybe<Array<MroRtsTextWhereInput>>;
  OR?: InputMaybe<Array<MroRtsTextWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroRtsTextWhereUniqueInput = {
  AND?: InputMaybe<Array<MroRtsTextWhereInput>>;
  NOT?: InputMaybe<Array<MroRtsTextWhereInput>>;
  OR?: InputMaybe<Array<MroRtsTextWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroReport = {
  __typename?: 'MroReport';
  attachment?: Maybe<Attachment>;
  attachmentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroOrganization: MroOrganization;
  mroOrganizationId: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroReportCountAggregate = {
  __typename?: 'MroReportCountAggregate';
  _all: Scalars['Int'];
  attachmentId: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Scalars['Int'];
  date: Scalars['Int'];
  deletedAt: Scalars['Int'];
  endDate: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  startDate: Scalars['Int'];
  title: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroReportCreateInput = {
  attachment?: InputMaybe<AttachmentCreateNestedOneWithoutMroReportsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization: MroOrganizationCreateNestedOneWithoutMroReportsInput;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportCreateManyAttachmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganizationId: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportCreateManyAttachmentInputEnvelope = {
  data: Array<MroReportCreateManyAttachmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroReportCreateManyMroOrganizationInput = {
  attachmentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroReportCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroReportCreateNestedManyWithoutAttachmentInput = {
  connect?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroReportCreateOrConnectWithoutAttachmentInput>>;
  create?: InputMaybe<Array<MroReportCreateWithoutAttachmentInput>>;
  createMany?: InputMaybe<MroReportCreateManyAttachmentInputEnvelope>;
};

export type MroReportCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroReportCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroReportCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroReportCreateManyMroOrganizationInputEnvelope>;
};

export type MroReportCreateOrConnectWithoutAttachmentInput = {
  create: MroReportCreateWithoutAttachmentInput;
  where: MroReportWhereUniqueInput;
};

export type MroReportCreateOrConnectWithoutMroOrganizationInput = {
  create: MroReportCreateWithoutMroOrganizationInput;
  where: MroReportWhereUniqueInput;
};

export type MroReportCreateWithoutAttachmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization: MroOrganizationCreateNestedOneWithoutMroReportsInput;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportCreateWithoutMroOrganizationInput = {
  attachment?: InputMaybe<AttachmentCreateNestedOneWithoutMroReportsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportListRelationFilter = {
  every?: InputMaybe<MroReportWhereInput>;
  none?: InputMaybe<MroReportWhereInput>;
  some?: InputMaybe<MroReportWhereInput>;
};

export type MroReportMaxAggregate = {
  __typename?: 'MroReportMaxAggregate';
  attachmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroReportMinAggregate = {
  __typename?: 'MroReportMinAggregate';
  attachmentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroReportScalarWhereInput = {
  AND?: InputMaybe<Array<MroReportScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroReportScalarWhereInput>>;
  OR?: InputMaybe<Array<MroReportScalarWhereInput>>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroReportUpdateInput = {
  attachment?: InputMaybe<AttachmentUpdateOneWithoutMroReportsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneRequiredWithoutMroReportsNestedInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportUpdateManyWithWhereWithoutAttachmentInput = {
  data: MroReportUpdateManyMutationInput;
  where: MroReportScalarWhereInput;
};

export type MroReportUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroReportUpdateManyMutationInput;
  where: MroReportScalarWhereInput;
};

export type MroReportUpdateManyWithoutAttachmentNestedInput = {
  connect?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroReportCreateOrConnectWithoutAttachmentInput>>;
  create?: InputMaybe<Array<MroReportCreateWithoutAttachmentInput>>;
  createMany?: InputMaybe<MroReportCreateManyAttachmentInputEnvelope>;
  delete?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroReportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  set?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  update?: InputMaybe<Array<MroReportUpdateWithWhereUniqueWithoutAttachmentInput>>;
  updateMany?: InputMaybe<Array<MroReportUpdateManyWithWhereWithoutAttachmentInput>>;
  upsert?: InputMaybe<Array<MroReportUpsertWithWhereUniqueWithoutAttachmentInput>>;
};

export type MroReportUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroReportCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroReportCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroReportCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroReportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  set?: InputMaybe<Array<MroReportWhereUniqueInput>>;
  update?: InputMaybe<Array<MroReportUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroReportUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroReportUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroReportUpdateWithWhereUniqueWithoutAttachmentInput = {
  data: MroReportUpdateWithoutAttachmentInput;
  where: MroReportWhereUniqueInput;
};

export type MroReportUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroReportUpdateWithoutMroOrganizationInput;
  where: MroReportWhereUniqueInput;
};

export type MroReportUpdateWithoutAttachmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneRequiredWithoutMroReportsNestedInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportUpdateWithoutMroOrganizationInput = {
  attachment?: InputMaybe<AttachmentUpdateOneWithoutMroReportsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data?: InputMaybe<Scalars['JSON']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroReportUpsertWithWhereUniqueWithoutAttachmentInput = {
  create: MroReportCreateWithoutAttachmentInput;
  update: MroReportUpdateWithoutAttachmentInput;
  where: MroReportWhereUniqueInput;
};

export type MroReportUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroReportCreateWithoutMroOrganizationInput;
  update: MroReportUpdateWithoutMroOrganizationInput;
  where: MroReportWhereUniqueInput;
};

export type MroReportWhereInput = {
  AND?: InputMaybe<Array<MroReportWhereInput>>;
  NOT?: InputMaybe<Array<MroReportWhereInput>>;
  OR?: InputMaybe<Array<MroReportWhereInput>>;
  attachment?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroReportWhereUniqueInput = {
  AND?: InputMaybe<Array<MroReportWhereInput>>;
  NOT?: InputMaybe<Array<MroReportWhereInput>>;
  OR?: InputMaybe<Array<MroReportWhereInput>>;
  attachment?: InputMaybe<AttachmentNullableScalarRelationFilter>;
  attachmentId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<JsonNullableFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroRole = {
  __typename?: 'MroRole';
  _count: MroRoleCount;
  caslRules?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroEmployeeProfiles?: Maybe<Array<MroEmployeeProfile>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroRoleCount = {
  __typename?: 'MroRoleCount';
  mroEmployeeProfiles: Scalars['Int'];
};

export type MroRoleCountAggregate = {
  __typename?: 'MroRoleCountAggregate';
  _all: Scalars['Int'];
  caslRules: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroRoleCreateInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroRoleInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroRolesInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleCreateManyMroOrganizationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroRoleCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroRoleCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroRoleCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroRoleCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroRoleCreateManyMroOrganizationInputEnvelope>;
};

export type MroRoleCreateNestedOneWithoutMroEmployeeProfilesInput = {
  connect?: InputMaybe<MroRoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroRoleCreateOrConnectWithoutMroEmployeeProfilesInput>;
  create?: InputMaybe<MroRoleCreateWithoutMroEmployeeProfilesInput>;
};

export type MroRoleCreateOrConnectWithoutMroEmployeeProfilesInput = {
  create: MroRoleCreateWithoutMroEmployeeProfilesInput;
  where: MroRoleWhereUniqueInput;
};

export type MroRoleCreateOrConnectWithoutMroOrganizationInput = {
  create: MroRoleCreateWithoutMroOrganizationInput;
  where: MroRoleWhereUniqueInput;
};

export type MroRoleCreateWithoutMroEmployeeProfilesInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroRolesInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleCreateWithoutMroOrganizationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutMroRoleInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleListRelationFilter = {
  every?: InputMaybe<MroRoleWhereInput>;
  none?: InputMaybe<MroRoleWhereInput>;
  some?: InputMaybe<MroRoleWhereInput>;
};

export type MroRoleMaxAggregate = {
  __typename?: 'MroRoleMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroRoleMinAggregate = {
  __typename?: 'MroRoleMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroRoleNullableScalarRelationFilter = {
  is?: InputMaybe<MroRoleWhereInput>;
  isNot?: InputMaybe<MroRoleWhereInput>;
};

export type MroRoleScalarWhereInput = {
  AND?: InputMaybe<Array<MroRoleScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroRoleScalarWhereInput>>;
  OR?: InputMaybe<Array<MroRoleScalarWhereInput>>;
  caslRules?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroRoleUpdateInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroRoleNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroRolesNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleUpdateManyMutationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroRoleUpdateManyMutationInput;
  where: MroRoleScalarWhereInput;
};

export type MroRoleUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroRoleCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroRoleCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroRoleCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroRoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroRoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroRoleWhereUniqueInput>>;
  set?: InputMaybe<Array<MroRoleWhereUniqueInput>>;
  update?: InputMaybe<Array<MroRoleUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroRoleUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroRoleUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroRoleUpdateOneWithoutMroEmployeeProfilesNestedInput = {
  connect?: InputMaybe<MroRoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroRoleCreateOrConnectWithoutMroEmployeeProfilesInput>;
  create?: InputMaybe<MroRoleCreateWithoutMroEmployeeProfilesInput>;
  delete?: InputMaybe<MroRoleWhereInput>;
  disconnect?: InputMaybe<MroRoleWhereInput>;
  update?: InputMaybe<MroRoleUpdateToOneWithWhereWithoutMroEmployeeProfilesInput>;
  upsert?: InputMaybe<MroRoleUpsertWithoutMroEmployeeProfilesInput>;
};

export type MroRoleUpdateToOneWithWhereWithoutMroEmployeeProfilesInput = {
  data: MroRoleUpdateWithoutMroEmployeeProfilesInput;
  where?: InputMaybe<MroRoleWhereInput>;
};

export type MroRoleUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroRoleUpdateWithoutMroOrganizationInput;
  where: MroRoleWhereUniqueInput;
};

export type MroRoleUpdateWithoutMroEmployeeProfilesInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroRolesNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleUpdateWithoutMroOrganizationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutMroRoleNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroRoleUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroRoleCreateWithoutMroOrganizationInput;
  update: MroRoleUpdateWithoutMroOrganizationInput;
  where: MroRoleWhereUniqueInput;
};

export type MroRoleUpsertWithoutMroEmployeeProfilesInput = {
  create: MroRoleCreateWithoutMroEmployeeProfilesInput;
  update: MroRoleUpdateWithoutMroEmployeeProfilesInput;
  where?: InputMaybe<MroRoleWhereInput>;
};

export type MroRoleWhereInput = {
  AND?: InputMaybe<Array<MroRoleWhereInput>>;
  NOT?: InputMaybe<Array<MroRoleWhereInput>>;
  OR?: InputMaybe<Array<MroRoleWhereInput>>;
  caslRules?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroRoleWhereUniqueInput = {
  AND?: InputMaybe<Array<MroRoleWhereInput>>;
  NOT?: InputMaybe<Array<MroRoleWhereInput>>;
  OR?: InputMaybe<Array<MroRoleWhereInput>>;
  caslRules?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroSerializedPart = {
  __typename?: 'MroSerializedPart';
  _count: MroSerializedPartCount;
  bin?: Maybe<Scalars['String']>;
  condition?: Maybe<PartCondition>;
  coreCost?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isAvailable?: Maybe<Scalars['Boolean']>;
  lotNumber?: Maybe<Scalars['String']>;
  mroPart?: Maybe<MroPart>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartWarehouse?: Maybe<MroPartWarehouse>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  mroWorkOrderParts?: Maybe<Array<MroWorkOrderPart>>;
  notes?: Maybe<Scalars['String']>;
  part: MroPart;
  partPriceUpdatedAt?: Maybe<Scalars['DateTime']>;
  serialNumber?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroSerializedPartVersion>>;
};

export type MroSerializedPartAvgAggregate = {
  __typename?: 'MroSerializedPartAvgAggregate';
  coreCost?: Maybe<Scalars['Decimal']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroSerializedPartCount = {
  __typename?: 'MroSerializedPartCount';
  mroWorkOrderParts: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroSerializedPartCountAggregate = {
  __typename?: 'MroSerializedPartCountAggregate';
  _all: Scalars['Int'];
  bin: Scalars['Int'];
  condition: Scalars['Int'];
  coreCost: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  expirationDate: Scalars['Int'];
  id: Scalars['Int'];
  isAvailable: Scalars['Int'];
  lotNumber: Scalars['Int'];
  mroPartId: Scalars['Int'];
  mroPartWarehouseId: Scalars['Int'];
  notes: Scalars['Int'];
  partPriceUpdatedAt: Scalars['Int'];
  serialNumber: Scalars['Int'];
  unitPrice: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroSerializedPartCreateInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroSerializedPartsInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroSerializedPartsInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroSerializedPartInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionCreateNestedManyWithoutMroSerializedPartInput>;
};

export type MroSerializedPartCreateManyMroPartInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPartWarehouseId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroSerializedPartCreateManyMroPartInputEnvelope = {
  data: Array<MroSerializedPartCreateManyMroPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroSerializedPartCreateManyMroPartWarehouseInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroSerializedPartCreateManyMroPartWarehouseInputEnvelope = {
  data: Array<MroSerializedPartCreateManyMroPartWarehouseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroSerializedPartCreateNestedManyWithoutMroPartInput = {
  connect?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroSerializedPartCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroSerializedPartCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroSerializedPartCreateManyMroPartInputEnvelope>;
};

export type MroSerializedPartCreateNestedManyWithoutMroPartWarehouseInput = {
  connect?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroSerializedPartCreateOrConnectWithoutMroPartWarehouseInput>>;
  create?: InputMaybe<Array<MroSerializedPartCreateWithoutMroPartWarehouseInput>>;
  createMany?: InputMaybe<MroSerializedPartCreateManyMroPartWarehouseInputEnvelope>;
};

export type MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput = {
  connect?: InputMaybe<MroSerializedPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroSerializedPartCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroSerializedPartCreateWithoutMroWorkOrderPartsInput>;
};

export type MroSerializedPartCreateOrConnectWithoutMroPartInput = {
  create: MroSerializedPartCreateWithoutMroPartInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartCreateOrConnectWithoutMroPartWarehouseInput = {
  create: MroSerializedPartCreateWithoutMroPartWarehouseInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartCreateOrConnectWithoutMroWorkOrderPartsInput = {
  create: MroSerializedPartCreateWithoutMroWorkOrderPartsInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartCreateWithoutMroPartInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroSerializedPartsInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroSerializedPartInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionCreateNestedManyWithoutMroSerializedPartInput>;
};

export type MroSerializedPartCreateWithoutMroPartWarehouseInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroSerializedPartsInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroSerializedPartInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionCreateNestedManyWithoutMroSerializedPartInput>;
};

export type MroSerializedPartCreateWithoutMroWorkOrderPartsInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroSerializedPartsInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseCreateNestedOneWithoutMroSerializedPartsInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionCreateNestedManyWithoutMroSerializedPartInput>;
};

export type MroSerializedPartListRelationFilter = {
  every?: InputMaybe<MroSerializedPartWhereInput>;
  none?: InputMaybe<MroSerializedPartWhereInput>;
  some?: InputMaybe<MroSerializedPartWhereInput>;
};

export type MroSerializedPartMaxAggregate = {
  __typename?: 'MroSerializedPartMaxAggregate';
  bin?: Maybe<Scalars['String']>;
  condition?: Maybe<PartCondition>;
  coreCost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  lotNumber?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partPriceUpdatedAt?: Maybe<Scalars['DateTime']>;
  serialNumber?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroSerializedPartMinAggregate = {
  __typename?: 'MroSerializedPartMinAggregate';
  bin?: Maybe<Scalars['String']>;
  condition?: Maybe<PartCondition>;
  coreCost?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  lotNumber?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartWarehouseId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  partPriceUpdatedAt?: Maybe<Scalars['DateTime']>;
  serialNumber?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroSerializedPartNullableScalarRelationFilter = {
  is?: InputMaybe<MroSerializedPartWhereInput>;
  isNot?: InputMaybe<MroSerializedPartWhereInput>;
};

export type MroSerializedPartScalarWhereInput = {
  AND?: InputMaybe<Array<MroSerializedPartScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroSerializedPartScalarWhereInput>>;
  OR?: InputMaybe<Array<MroSerializedPartScalarWhereInput>>;
  bin?: InputMaybe<StringNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  coreCost?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isAvailable?: InputMaybe<BoolNullableFilter>;
  lotNumber?: InputMaybe<StringNullableFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partPriceUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroSerializedPartSumAggregate = {
  __typename?: 'MroSerializedPartSumAggregate';
  coreCost?: Maybe<Scalars['Decimal']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroSerializedPartUpdateInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroSerializedPartsNestedInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroSerializedPartsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroSerializedPartNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionUpdateManyWithoutMroSerializedPartNestedInput>;
};

export type MroSerializedPartUpdateManyMutationInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroSerializedPartUpdateManyWithWhereWithoutMroPartInput = {
  data: MroSerializedPartUpdateManyMutationInput;
  where: MroSerializedPartScalarWhereInput;
};

export type MroSerializedPartUpdateManyWithWhereWithoutMroPartWarehouseInput = {
  data: MroSerializedPartUpdateManyMutationInput;
  where: MroSerializedPartScalarWhereInput;
};

export type MroSerializedPartUpdateManyWithoutMroPartNestedInput = {
  connect?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroSerializedPartCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroSerializedPartCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroSerializedPartCreateManyMroPartInputEnvelope>;
  delete?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroSerializedPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroSerializedPartUpdateWithWhereUniqueWithoutMroPartInput>>;
  updateMany?: InputMaybe<Array<MroSerializedPartUpdateManyWithWhereWithoutMroPartInput>>;
  upsert?: InputMaybe<Array<MroSerializedPartUpsertWithWhereUniqueWithoutMroPartInput>>;
};

export type MroSerializedPartUpdateManyWithoutMroPartWarehouseNestedInput = {
  connect?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroSerializedPartCreateOrConnectWithoutMroPartWarehouseInput>>;
  create?: InputMaybe<Array<MroSerializedPartCreateWithoutMroPartWarehouseInput>>;
  createMany?: InputMaybe<MroSerializedPartCreateManyMroPartWarehouseInputEnvelope>;
  delete?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroSerializedPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroSerializedPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroSerializedPartUpdateWithWhereUniqueWithoutMroPartWarehouseInput>>;
  updateMany?: InputMaybe<Array<MroSerializedPartUpdateManyWithWhereWithoutMroPartWarehouseInput>>;
  upsert?: InputMaybe<Array<MroSerializedPartUpsertWithWhereUniqueWithoutMroPartWarehouseInput>>;
};

export type MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput = {
  connect?: InputMaybe<MroSerializedPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroSerializedPartCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroSerializedPartCreateWithoutMroWorkOrderPartsInput>;
  delete?: InputMaybe<MroSerializedPartWhereInput>;
  disconnect?: InputMaybe<MroSerializedPartWhereInput>;
  update?: InputMaybe<MroSerializedPartUpdateToOneWithWhereWithoutMroWorkOrderPartsInput>;
  upsert?: InputMaybe<MroSerializedPartUpsertWithoutMroWorkOrderPartsInput>;
};

export type MroSerializedPartUpdateToOneWithWhereWithoutMroWorkOrderPartsInput = {
  data: MroSerializedPartUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroSerializedPartWhereInput>;
};

export type MroSerializedPartUpdateWithWhereUniqueWithoutMroPartInput = {
  data: MroSerializedPartUpdateWithoutMroPartInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartUpdateWithWhereUniqueWithoutMroPartWarehouseInput = {
  data: MroSerializedPartUpdateWithoutMroPartWarehouseInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartUpdateWithoutMroPartInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroSerializedPartsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroSerializedPartNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionUpdateManyWithoutMroSerializedPartNestedInput>;
};

export type MroSerializedPartUpdateWithoutMroPartWarehouseInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroSerializedPartsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroSerializedPartNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionUpdateManyWithoutMroSerializedPartNestedInput>;
};

export type MroSerializedPartUpdateWithoutMroWorkOrderPartsInput = {
  bin?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<PartCondition>;
  coreCost?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  lotNumber?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroSerializedPartsNestedInput>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseUpdateOneWithoutMroSerializedPartsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  partPriceUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroSerializedPartVersionUpdateManyWithoutMroSerializedPartNestedInput>;
};

export type MroSerializedPartUpsertWithWhereUniqueWithoutMroPartInput = {
  create: MroSerializedPartCreateWithoutMroPartInput;
  update: MroSerializedPartUpdateWithoutMroPartInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartUpsertWithWhereUniqueWithoutMroPartWarehouseInput = {
  create: MroSerializedPartCreateWithoutMroPartWarehouseInput;
  update: MroSerializedPartUpdateWithoutMroPartWarehouseInput;
  where: MroSerializedPartWhereUniqueInput;
};

export type MroSerializedPartUpsertWithoutMroWorkOrderPartsInput = {
  create: MroSerializedPartCreateWithoutMroWorkOrderPartsInput;
  update: MroSerializedPartUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroSerializedPartWhereInput>;
};

export type MroSerializedPartVersion = {
  __typename?: 'MroSerializedPartVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroSerializedPart?: Maybe<MroSerializedPart>;
  mroSerializedPartId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroSerializedPartVersionCreateManyMroSerializedPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroSerializedPartVersionCreateManyMroSerializedPartInputEnvelope = {
  data: Array<MroSerializedPartVersionCreateManyMroSerializedPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroSerializedPartVersionCreateNestedManyWithoutMroSerializedPartInput = {
  connect?: InputMaybe<Array<MroSerializedPartVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroSerializedPartVersionCreateOrConnectWithoutMroSerializedPartInput>>;
  create?: InputMaybe<Array<MroSerializedPartVersionCreateWithoutMroSerializedPartInput>>;
  createMany?: InputMaybe<MroSerializedPartVersionCreateManyMroSerializedPartInputEnvelope>;
};

export type MroSerializedPartVersionCreateOrConnectWithoutMroSerializedPartInput = {
  create: MroSerializedPartVersionCreateWithoutMroSerializedPartInput;
  where: MroSerializedPartVersionWhereUniqueInput;
};

export type MroSerializedPartVersionCreateWithoutMroSerializedPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroSerializedPartVersionListRelationFilter = {
  every?: InputMaybe<MroSerializedPartVersionWhereInput>;
  none?: InputMaybe<MroSerializedPartVersionWhereInput>;
  some?: InputMaybe<MroSerializedPartVersionWhereInput>;
};

export type MroSerializedPartVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroSerializedPartVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroSerializedPartVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroSerializedPartVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroSerializedPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroSerializedPartVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroSerializedPartVersionUpdateManyWithWhereWithoutMroSerializedPartInput = {
  data: MroSerializedPartVersionUpdateManyMutationInput;
  where: MroSerializedPartVersionScalarWhereInput;
};

export type MroSerializedPartVersionUpdateManyWithoutMroSerializedPartNestedInput = {
  connect?: InputMaybe<Array<MroSerializedPartVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroSerializedPartVersionCreateOrConnectWithoutMroSerializedPartInput>>;
  create?: InputMaybe<Array<MroSerializedPartVersionCreateWithoutMroSerializedPartInput>>;
  createMany?: InputMaybe<MroSerializedPartVersionCreateManyMroSerializedPartInputEnvelope>;
  delete?: InputMaybe<Array<MroSerializedPartVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroSerializedPartVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroSerializedPartVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroSerializedPartVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroSerializedPartVersionUpdateWithWhereUniqueWithoutMroSerializedPartInput>>;
  updateMany?: InputMaybe<Array<MroSerializedPartVersionUpdateManyWithWhereWithoutMroSerializedPartInput>>;
  upsert?: InputMaybe<Array<MroSerializedPartVersionUpsertWithWhereUniqueWithoutMroSerializedPartInput>>;
};

export type MroSerializedPartVersionUpdateWithWhereUniqueWithoutMroSerializedPartInput = {
  data: MroSerializedPartVersionUpdateWithoutMroSerializedPartInput;
  where: MroSerializedPartVersionWhereUniqueInput;
};

export type MroSerializedPartVersionUpdateWithoutMroSerializedPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroSerializedPartVersionUpsertWithWhereUniqueWithoutMroSerializedPartInput = {
  create: MroSerializedPartVersionCreateWithoutMroSerializedPartInput;
  update: MroSerializedPartVersionUpdateWithoutMroSerializedPartInput;
  where: MroSerializedPartVersionWhereUniqueInput;
};

export type MroSerializedPartVersionWhereInput = {
  AND?: InputMaybe<Array<MroSerializedPartVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroSerializedPartVersionWhereInput>>;
  OR?: InputMaybe<Array<MroSerializedPartVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroSerializedPart?: InputMaybe<MroSerializedPartNullableScalarRelationFilter>;
  mroSerializedPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroSerializedPartVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroSerializedPartVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroSerializedPartVersionWhereInput>>;
  OR?: InputMaybe<Array<MroSerializedPartVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroSerializedPart?: InputMaybe<MroSerializedPartNullableScalarRelationFilter>;
  mroSerializedPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroSerializedPartWhereInput = {
  AND?: InputMaybe<Array<MroSerializedPartWhereInput>>;
  NOT?: InputMaybe<Array<MroSerializedPartWhereInput>>;
  OR?: InputMaybe<Array<MroSerializedPartWhereInput>>;
  bin?: InputMaybe<StringNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  coreCost?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isAvailable?: InputMaybe<BoolNullableFilter>;
  lotNumber?: InputMaybe<StringNullableFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseNullableScalarRelationFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partPriceUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroSerializedPartVersionListRelationFilter>;
};

export type MroSerializedPartWhereUniqueInput = {
  AND?: InputMaybe<Array<MroSerializedPartWhereInput>>;
  NOT?: InputMaybe<Array<MroSerializedPartWhereInput>>;
  OR?: InputMaybe<Array<MroSerializedPartWhereInput>>;
  bin?: InputMaybe<StringNullableFilter>;
  condition?: InputMaybe<EnumPartConditionNullableFilter>;
  coreCost?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<BoolNullableFilter>;
  lotNumber?: InputMaybe<StringNullableFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartWarehouse?: InputMaybe<MroPartWarehouseNullableScalarRelationFilter>;
  mroPartWarehouseId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partPriceUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroSerializedPartVersionListRelationFilter>;
};

export type MroServiceRequest = {
  __typename?: 'MroServiceRequest';
  _count: MroServiceRequestCount;
  craftServiceRequests?: Maybe<Array<CraftServiceRequest>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  mroCraft?: Maybe<MroCraft>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomer?: Maybe<MroCustomer>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  serviceRequestNum?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroServiceRequestVersion>>;
  workType?: Maybe<Scalars['String']>;
};

export type MroServiceRequestAvgAggregate = {
  __typename?: 'MroServiceRequestAvgAggregate';
  serviceRequestNum?: Maybe<Scalars['Float']>;
};

export type MroServiceRequestCount = {
  __typename?: 'MroServiceRequestCount';
  craftServiceRequests: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroServiceRequestCountAggregate = {
  __typename?: 'MroServiceRequestCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  location: Scalars['Int'];
  mroCraftId: Scalars['Int'];
  mroCustomerId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  notes: Scalars['Int'];
  serviceRequestNum: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workType: Scalars['Int'];
};

export type MroServiceRequestCreateInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroServiceRequestsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateManyMroCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateManyMroCraftInputEnvelope = {
  data: Array<MroServiceRequestCreateManyMroCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroServiceRequestCreateManyMroCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateManyMroCustomerInputEnvelope = {
  data: Array<MroServiceRequestCreateManyMroCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroServiceRequestCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroServiceRequestCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroServiceRequestCreateNestedManyWithoutMroCraftInput = {
  connect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroServiceRequestCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroServiceRequestCreateManyMroCraftInputEnvelope>;
};

export type MroServiceRequestCreateNestedManyWithoutMroCustomerInput = {
  connect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroServiceRequestCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroServiceRequestCreateManyMroCustomerInputEnvelope>;
};

export type MroServiceRequestCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroServiceRequestCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroServiceRequestCreateManyMroOrganizationInputEnvelope>;
};

export type MroServiceRequestCreateNestedOneWithoutCraftServiceRequestsInput = {
  connect?: InputMaybe<MroServiceRequestWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroServiceRequestCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<MroServiceRequestCreateWithoutCraftServiceRequestsInput>;
};

export type MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput = {
  connect?: InputMaybe<MroServiceRequestWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroServiceRequestCreateOrConnectWithoutMroWorkOrderInput>;
  create?: InputMaybe<MroServiceRequestCreateWithoutMroWorkOrderInput>;
};

export type MroServiceRequestCreateOrConnectWithoutCraftServiceRequestsInput = {
  create: MroServiceRequestCreateWithoutCraftServiceRequestsInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestCreateOrConnectWithoutMroCraftInput = {
  create: MroServiceRequestCreateWithoutMroCraftInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestCreateOrConnectWithoutMroCustomerInput = {
  create: MroServiceRequestCreateWithoutMroCustomerInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestCreateOrConnectWithoutMroOrganizationInput = {
  create: MroServiceRequestCreateWithoutMroOrganizationInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroServiceRequestCreateWithoutMroWorkOrderInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestCreateWithoutCraftServiceRequestsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroServiceRequestsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateWithoutMroCraftInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateWithoutMroCustomerInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateWithoutMroOrganizationInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroServiceRequestsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroServiceRequestsInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestCreateWithoutMroWorkOrderInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroServiceRequestsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestListRelationFilter = {
  every?: InputMaybe<MroServiceRequestWhereInput>;
  none?: InputMaybe<MroServiceRequestWhereInput>;
  some?: InputMaybe<MroServiceRequestWhereInput>;
};

export type MroServiceRequestMaxAggregate = {
  __typename?: 'MroServiceRequestMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  serviceRequestNum?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workType?: Maybe<Scalars['String']>;
};

export type MroServiceRequestMinAggregate = {
  __typename?: 'MroServiceRequestMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  serviceRequestNum?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workType?: Maybe<Scalars['String']>;
};

export type MroServiceRequestNullableScalarRelationFilter = {
  is?: InputMaybe<MroServiceRequestWhereInput>;
  isNot?: InputMaybe<MroServiceRequestWhereInput>;
};

export type MroServiceRequestScalarWhereInput = {
  AND?: InputMaybe<Array<MroServiceRequestScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroServiceRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<MroServiceRequestScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  serviceRequestNum?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  workType?: InputMaybe<StringNullableFilter>;
};

export type MroServiceRequestSumAggregate = {
  __typename?: 'MroServiceRequestSumAggregate';
  serviceRequestNum?: Maybe<Scalars['Int']>;
};

export type MroServiceRequestUpdateInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroServiceRequestNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroServiceRequestNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpdateManyWithWhereWithoutMroCraftInput = {
  data: MroServiceRequestUpdateManyMutationInput;
  where: MroServiceRequestScalarWhereInput;
};

export type MroServiceRequestUpdateManyWithWhereWithoutMroCustomerInput = {
  data: MroServiceRequestUpdateManyMutationInput;
  where: MroServiceRequestScalarWhereInput;
};

export type MroServiceRequestUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroServiceRequestUpdateManyMutationInput;
  where: MroServiceRequestScalarWhereInput;
};

export type MroServiceRequestUpdateManyWithoutMroCraftNestedInput = {
  connect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroServiceRequestCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroServiceRequestCreateManyMroCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<MroServiceRequestUpdateWithWhereUniqueWithoutMroCraftInput>>;
  updateMany?: InputMaybe<Array<MroServiceRequestUpdateManyWithWhereWithoutMroCraftInput>>;
  upsert?: InputMaybe<Array<MroServiceRequestUpsertWithWhereUniqueWithoutMroCraftInput>>;
};

export type MroServiceRequestUpdateManyWithoutMroCustomerNestedInput = {
  connect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroServiceRequestCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroServiceRequestCreateManyMroCustomerInputEnvelope>;
  delete?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<MroServiceRequestUpdateWithWhereUniqueWithoutMroCustomerInput>>;
  updateMany?: InputMaybe<Array<MroServiceRequestUpdateManyWithWhereWithoutMroCustomerInput>>;
  upsert?: InputMaybe<Array<MroServiceRequestUpsertWithWhereUniqueWithoutMroCustomerInput>>;
};

export type MroServiceRequestUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroServiceRequestCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroServiceRequestCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<MroServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<MroServiceRequestUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroServiceRequestUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroServiceRequestUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroServiceRequestUpdateOneWithoutCraftServiceRequestsNestedInput = {
  connect?: InputMaybe<MroServiceRequestWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroServiceRequestCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<MroServiceRequestCreateWithoutCraftServiceRequestsInput>;
  delete?: InputMaybe<MroServiceRequestWhereInput>;
  disconnect?: InputMaybe<MroServiceRequestWhereInput>;
  update?: InputMaybe<MroServiceRequestUpdateToOneWithWhereWithoutCraftServiceRequestsInput>;
  upsert?: InputMaybe<MroServiceRequestUpsertWithoutCraftServiceRequestsInput>;
};

export type MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<MroServiceRequestWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroServiceRequestCreateOrConnectWithoutMroWorkOrderInput>;
  create?: InputMaybe<MroServiceRequestCreateWithoutMroWorkOrderInput>;
  delete?: InputMaybe<MroServiceRequestWhereInput>;
  disconnect?: InputMaybe<MroServiceRequestWhereInput>;
  update?: InputMaybe<MroServiceRequestUpdateToOneWithWhereWithoutMroWorkOrderInput>;
  upsert?: InputMaybe<MroServiceRequestUpsertWithoutMroWorkOrderInput>;
};

export type MroServiceRequestUpdateToOneWithWhereWithoutCraftServiceRequestsInput = {
  data: MroServiceRequestUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<MroServiceRequestWhereInput>;
};

export type MroServiceRequestUpdateToOneWithWhereWithoutMroWorkOrderInput = {
  data: MroServiceRequestUpdateWithoutMroWorkOrderInput;
  where?: InputMaybe<MroServiceRequestWhereInput>;
};

export type MroServiceRequestUpdateWithWhereUniqueWithoutMroCraftInput = {
  data: MroServiceRequestUpdateWithoutMroCraftInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestUpdateWithWhereUniqueWithoutMroCustomerInput = {
  data: MroServiceRequestUpdateWithoutMroCustomerInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroServiceRequestUpdateWithoutMroOrganizationInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestUpdateWithoutCraftServiceRequestsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroServiceRequestNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpdateWithoutMroCraftInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroServiceRequestNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroServiceRequestNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpdateWithoutMroCustomerInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroServiceRequestNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroServiceRequestNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpdateWithoutMroOrganizationInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroServiceRequestNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroServiceRequestNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpdateWithoutMroWorkOrderInput = {
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroServiceRequestNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroServiceRequestsNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroServiceRequestsNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestUpsertWithWhereUniqueWithoutMroCraftInput = {
  create: MroServiceRequestCreateWithoutMroCraftInput;
  update: MroServiceRequestUpdateWithoutMroCraftInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestUpsertWithWhereUniqueWithoutMroCustomerInput = {
  create: MroServiceRequestCreateWithoutMroCustomerInput;
  update: MroServiceRequestUpdateWithoutMroCustomerInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroServiceRequestCreateWithoutMroOrganizationInput;
  update: MroServiceRequestUpdateWithoutMroOrganizationInput;
  where: MroServiceRequestWhereUniqueInput;
};

export type MroServiceRequestUpsertWithoutCraftServiceRequestsInput = {
  create: MroServiceRequestCreateWithoutCraftServiceRequestsInput;
  update: MroServiceRequestUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<MroServiceRequestWhereInput>;
};

export type MroServiceRequestUpsertWithoutMroWorkOrderInput = {
  create: MroServiceRequestCreateWithoutMroWorkOrderInput;
  update: MroServiceRequestUpdateWithoutMroWorkOrderInput;
  where?: InputMaybe<MroServiceRequestWhereInput>;
};

export type MroServiceRequestVersion = {
  __typename?: 'MroServiceRequestVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroServiceRequest?: Maybe<MroServiceRequest>;
  mroServiceRequestId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroServiceRequestVersionCreateManyMroServiceRequestInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestVersionCreateManyMroServiceRequestInputEnvelope = {
  data: Array<MroServiceRequestVersionCreateManyMroServiceRequestInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput = {
  connect?: InputMaybe<Array<MroServiceRequestVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestVersionCreateOrConnectWithoutMroServiceRequestInput>>;
  create?: InputMaybe<Array<MroServiceRequestVersionCreateWithoutMroServiceRequestInput>>;
  createMany?: InputMaybe<MroServiceRequestVersionCreateManyMroServiceRequestInputEnvelope>;
};

export type MroServiceRequestVersionCreateOrConnectWithoutMroServiceRequestInput = {
  create: MroServiceRequestVersionCreateWithoutMroServiceRequestInput;
  where: MroServiceRequestVersionWhereUniqueInput;
};

export type MroServiceRequestVersionCreateWithoutMroServiceRequestInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestVersionListRelationFilter = {
  every?: InputMaybe<MroServiceRequestVersionWhereInput>;
  none?: InputMaybe<MroServiceRequestVersionWhereInput>;
  some?: InputMaybe<MroServiceRequestVersionWhereInput>;
};

export type MroServiceRequestVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroServiceRequestVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroServiceRequestVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroServiceRequestVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroServiceRequestId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroServiceRequestVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestVersionUpdateManyWithWhereWithoutMroServiceRequestInput = {
  data: MroServiceRequestVersionUpdateManyMutationInput;
  where: MroServiceRequestVersionScalarWhereInput;
};

export type MroServiceRequestVersionUpdateManyWithoutMroServiceRequestNestedInput = {
  connect?: InputMaybe<Array<MroServiceRequestVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroServiceRequestVersionCreateOrConnectWithoutMroServiceRequestInput>>;
  create?: InputMaybe<Array<MroServiceRequestVersionCreateWithoutMroServiceRequestInput>>;
  createMany?: InputMaybe<MroServiceRequestVersionCreateManyMroServiceRequestInputEnvelope>;
  delete?: InputMaybe<Array<MroServiceRequestVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroServiceRequestVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroServiceRequestVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroServiceRequestVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroServiceRequestVersionUpdateWithWhereUniqueWithoutMroServiceRequestInput>>;
  updateMany?: InputMaybe<Array<MroServiceRequestVersionUpdateManyWithWhereWithoutMroServiceRequestInput>>;
  upsert?: InputMaybe<Array<MroServiceRequestVersionUpsertWithWhereUniqueWithoutMroServiceRequestInput>>;
};

export type MroServiceRequestVersionUpdateWithWhereUniqueWithoutMroServiceRequestInput = {
  data: MroServiceRequestVersionUpdateWithoutMroServiceRequestInput;
  where: MroServiceRequestVersionWhereUniqueInput;
};

export type MroServiceRequestVersionUpdateWithoutMroServiceRequestInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroServiceRequestVersionUpsertWithWhereUniqueWithoutMroServiceRequestInput = {
  create: MroServiceRequestVersionCreateWithoutMroServiceRequestInput;
  update: MroServiceRequestVersionUpdateWithoutMroServiceRequestInput;
  where: MroServiceRequestVersionWhereUniqueInput;
};

export type MroServiceRequestVersionWhereInput = {
  AND?: InputMaybe<Array<MroServiceRequestVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroServiceRequestVersionWhereInput>>;
  OR?: InputMaybe<Array<MroServiceRequestVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroServiceRequest?: InputMaybe<MroServiceRequestNullableScalarRelationFilter>;
  mroServiceRequestId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroServiceRequestVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroServiceRequestVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroServiceRequestVersionWhereInput>>;
  OR?: InputMaybe<Array<MroServiceRequestVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroServiceRequest?: InputMaybe<MroServiceRequestNullableScalarRelationFilter>;
  mroServiceRequestId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroServiceRequestWhereInput = {
  AND?: InputMaybe<Array<MroServiceRequestWhereInput>>;
  NOT?: InputMaybe<Array<MroServiceRequestWhereInput>>;
  OR?: InputMaybe<Array<MroServiceRequestWhereInput>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  serviceRequestNum?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroServiceRequestVersionListRelationFilter>;
  workType?: InputMaybe<StringNullableFilter>;
};

export type MroServiceRequestWhereUniqueInput = {
  AND?: InputMaybe<Array<MroServiceRequestWhereInput>>;
  NOT?: InputMaybe<Array<MroServiceRequestWhereInput>>;
  OR?: InputMaybe<Array<MroServiceRequestWhereInput>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<StringNullableFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<StringNullableFilter>;
  serviceRequestNum?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroServiceRequestVersionListRelationFilter>;
  workType?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrder = {
  __typename?: 'MroWorkOrder';
  _count: MroWorkOrderCount;
  allAssignees: Array<MroEmployeeProfile>;
  arrivalDate?: Maybe<Scalars['DateTime']>;
  assignees?: Maybe<Array<MroEmployeeProfile>>;
  billableRate: Scalars['Int'];
  childAssignees: Array<MroEmployeeProfile>;
  completionDate?: Maybe<Scalars['DateTime']>;
  costRate: Scalars['Int'];
  craftServiceRequests?: Maybe<Array<CraftServiceRequest>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isEstimate: Scalars['Boolean'];
  itemCategories?: Maybe<Array<MroWorkOrderItemCategory>>;
  mroCommunicationThreads?: Maybe<Array<MroCommunicationThread>>;
  mroCraft?: Maybe<MroCraft>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomer?: Maybe<MroCustomer>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroEstimates?: Maybe<Array<MroEstimate>>;
  mroInvoices?: Maybe<Array<MroInvoice>>;
  mroLocation?: Maybe<MroLocation>;
  mroLocationId?: Maybe<Scalars['String']>;
  mroLogEntries?: Maybe<Array<MroLogEntry>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroServiceRequest?: Maybe<MroServiceRequest>;
  mroWorkOrderBillingItems?: Maybe<Array<MroWorkOrderBillingItem>>;
  mroWorkOrderCategory?: Maybe<MroWorkOrderCategory>;
  mroWorkOrderCategoryId?: Maybe<Scalars['String']>;
  mroWorkOrderIntervals?: Maybe<Array<MroWorkOrderInterval>>;
  mroWorkOrderItems?: Maybe<Array<MroWorkOrderItem>>;
  notes?: Maybe<Scalars['String']>;
  primaryConcern?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<MroContact>;
  primaryContactId?: Maybe<Scalars['String']>;
  promiseDate?: Maybe<Scalars['DateTime']>;
  serviceRequest: Array<MroServiceRequest>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroWorkOrderVersion>>;
  workOrderNum?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderAvgAggregate = {
  __typename?: 'MroWorkOrderAvgAggregate';
  workOrderNum?: Maybe<Scalars['Float']>;
};

export type MroWorkOrderBillingItem = {
  __typename?: 'MroWorkOrderBillingItem';
  active: Scalars['Boolean'];
  billableType: MroBillableType;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isDiscount: Scalars['Boolean'];
  isPercentage: Scalars['Boolean'];
  itemNumber?: Maybe<Scalars['Int']>;
  mroWorkOrder: MroWorkOrder;
  mroWorkOrderId: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemAvgAggregate = {
  __typename?: 'MroWorkOrderBillingItemAvgAggregate';
  itemNumber?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemCountAggregate = {
  __typename?: 'MroWorkOrderBillingItemCountAggregate';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  billableType: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  isDiscount: Scalars['Int'];
  isPercentage: Scalars['Int'];
  itemNumber: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
};

export type MroWorkOrderBillingItemCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroBillableType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderBillingItemsInput;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemCreateManyMroWorkOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroBillableType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroWorkOrderBillingItemCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroWorkOrderBillingItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderBillingItemCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderBillingItemCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderBillingItemCreateManyMroWorkOrderInputEnvelope>;
};

export type MroWorkOrderBillingItemCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroWorkOrderBillingItemCreateWithoutMroWorkOrderInput;
  where: MroWorkOrderBillingItemWhereUniqueInput;
};

export type MroWorkOrderBillingItemCreateWithoutMroWorkOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroBillableType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemListRelationFilter = {
  every?: InputMaybe<MroWorkOrderBillingItemWhereInput>;
  none?: InputMaybe<MroWorkOrderBillingItemWhereInput>;
  some?: InputMaybe<MroWorkOrderBillingItemWhereInput>;
};

export type MroWorkOrderBillingItemMaxAggregate = {
  __typename?: 'MroWorkOrderBillingItemMaxAggregate';
  active?: Maybe<Scalars['Boolean']>;
  billableType?: Maybe<MroBillableType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDiscount?: Maybe<Scalars['Boolean']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  itemNumber?: Maybe<Scalars['Int']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemMinAggregate = {
  __typename?: 'MroWorkOrderBillingItemMinAggregate';
  active?: Maybe<Scalars['Boolean']>;
  billableType?: Maybe<MroBillableType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDiscount?: Maybe<Scalars['Boolean']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  itemNumber?: Maybe<Scalars['Int']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderBillingItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderBillingItemScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderBillingItemScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  billableType?: InputMaybe<EnumMroBillableTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDiscount?: InputMaybe<BoolFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  itemNumber?: InputMaybe<IntNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
};

export type MroWorkOrderBillingItemSumAggregate = {
  __typename?: 'MroWorkOrderBillingItemSumAggregate';
  itemNumber?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroBillableType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderBillingItemsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroBillableType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroWorkOrderBillingItemUpdateManyMutationInput;
  where: MroWorkOrderBillingItemScalarWhereInput;
};

export type MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderBillingItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderBillingItemCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderBillingItemCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderBillingItemCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderBillingItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderBillingItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderBillingItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderBillingItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderBillingItemUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderBillingItemUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderBillingItemUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroWorkOrderBillingItemUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroWorkOrderBillingItemUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderBillingItemWhereUniqueInput;
};

export type MroWorkOrderBillingItemUpdateWithoutMroWorkOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  billableType?: InputMaybe<MroBillableType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<Scalars['Boolean']>;
  isPercentage?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type MroWorkOrderBillingItemUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroWorkOrderBillingItemCreateWithoutMroWorkOrderInput;
  update: MroWorkOrderBillingItemUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderBillingItemWhereUniqueInput;
};

export type MroWorkOrderBillingItemWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderBillingItemWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderBillingItemWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderBillingItemWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  billableType?: InputMaybe<EnumMroBillableTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDiscount?: InputMaybe<BoolFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  itemNumber?: InputMaybe<IntNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
};

export type MroWorkOrderBillingItemWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderBillingItemWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderBillingItemWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderBillingItemWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  billableType?: InputMaybe<EnumMroBillableTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isDiscount?: InputMaybe<BoolFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  itemNumber?: InputMaybe<IntNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
};

export type MroWorkOrderCategory = {
  __typename?: 'MroWorkOrderCategory';
  _count: MroWorkOrderCategoryCount;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deafultCostRate?: Maybe<Scalars['Decimal']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrders?: Maybe<Array<MroWorkOrder>>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  workType?: Maybe<Scalars['String']>;
};

export type MroWorkOrderCategoryAvgAggregate = {
  __typename?: 'MroWorkOrderCategoryAvgAggregate';
  count?: Maybe<Scalars['Float']>;
  deafultCostRate?: Maybe<Scalars['Decimal']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderCategoryCount = {
  __typename?: 'MroWorkOrderCategoryCount';
  mroWorkOrders: Scalars['Int'];
};

export type MroWorkOrderCategoryCountAggregate = {
  __typename?: 'MroWorkOrderCategoryCountAggregate';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  color: Scalars['Int'];
  count: Scalars['Int'];
  createdAt: Scalars['Int'];
  deafultCostRate: Scalars['Int'];
  defaultBillableRate: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  location: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workType: Scalars['Int'];
};

export type MroWorkOrderCategoryCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderCategoriesInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroWorkOrderCategoryInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryCreateManyMroOrganizationInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroWorkOrderCategoryCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCategoryCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroWorkOrderCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCategoryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderCategoryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderCategoryCreateManyMroOrganizationInputEnvelope>;
};

export type MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput = {
  connect?: InputMaybe<MroWorkOrderCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCategoryCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroWorkOrderCategoryCreateWithoutMroWorkOrdersInput>;
};

export type MroWorkOrderCategoryCreateOrConnectWithoutMroOrganizationInput = {
  create: MroWorkOrderCategoryCreateWithoutMroOrganizationInput;
  where: MroWorkOrderCategoryWhereUniqueInput;
};

export type MroWorkOrderCategoryCreateOrConnectWithoutMroWorkOrdersInput = {
  create: MroWorkOrderCategoryCreateWithoutMroWorkOrdersInput;
  where: MroWorkOrderCategoryWhereUniqueInput;
};

export type MroWorkOrderCategoryCreateWithoutMroOrganizationInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroWorkOrders?: InputMaybe<MroWorkOrderCreateNestedManyWithoutMroWorkOrderCategoryInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryCreateWithoutMroWorkOrdersInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderCategoriesInput>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryListRelationFilter = {
  every?: InputMaybe<MroWorkOrderCategoryWhereInput>;
  none?: InputMaybe<MroWorkOrderCategoryWhereInput>;
  some?: InputMaybe<MroWorkOrderCategoryWhereInput>;
};

export type MroWorkOrderCategoryMaxAggregate = {
  __typename?: 'MroWorkOrderCategoryMaxAggregate';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deafultCostRate?: Maybe<Scalars['Decimal']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workType?: Maybe<Scalars['String']>;
};

export type MroWorkOrderCategoryMinAggregate = {
  __typename?: 'MroWorkOrderCategoryMinAggregate';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deafultCostRate?: Maybe<Scalars['Decimal']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workType?: Maybe<Scalars['String']>;
};

export type MroWorkOrderCategoryNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderCategoryWhereInput>;
  isNot?: InputMaybe<MroWorkOrderCategoryWhereInput>;
};

export type MroWorkOrderCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderCategoryScalarWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<StringNullableFilter>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deafultCostRate?: InputMaybe<DecimalNullableFilter>;
  defaultBillableRate?: InputMaybe<DecimalNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  workType?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderCategorySumAggregate = {
  __typename?: 'MroWorkOrderCategorySumAggregate';
  count?: Maybe<Scalars['Int']>;
  deafultCostRate?: Maybe<Scalars['Decimal']>;
  defaultBillableRate?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderCategoryUpdateInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderCategoriesNestedInput>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroWorkOrderCategoryNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryUpdateManyMutationInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroWorkOrderCategoryUpdateManyMutationInput;
  where: MroWorkOrderCategoryScalarWhereInput;
};

export type MroWorkOrderCategoryUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCategoryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderCategoryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderCategoryCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderCategoryUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderCategoryUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderCategoryUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput = {
  connect?: InputMaybe<MroWorkOrderCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCategoryCreateOrConnectWithoutMroWorkOrdersInput>;
  create?: InputMaybe<MroWorkOrderCategoryCreateWithoutMroWorkOrdersInput>;
  delete?: InputMaybe<MroWorkOrderCategoryWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderCategoryWhereInput>;
  update?: InputMaybe<MroWorkOrderCategoryUpdateToOneWithWhereWithoutMroWorkOrdersInput>;
  upsert?: InputMaybe<MroWorkOrderCategoryUpsertWithoutMroWorkOrdersInput>;
};

export type MroWorkOrderCategoryUpdateToOneWithWhereWithoutMroWorkOrdersInput = {
  data: MroWorkOrderCategoryUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroWorkOrderCategoryWhereInput>;
};

export type MroWorkOrderCategoryUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroWorkOrderCategoryUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderCategoryWhereUniqueInput;
};

export type MroWorkOrderCategoryUpdateWithoutMroOrganizationInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroWorkOrders?: InputMaybe<MroWorkOrderUpdateManyWithoutMroWorkOrderCategoryNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryUpdateWithoutMroWorkOrdersInput = {
  code?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deafultCostRate?: InputMaybe<Scalars['Decimal']>;
  defaultBillableRate?: InputMaybe<Scalars['Decimal']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderCategoriesNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workType?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderCategoryUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroWorkOrderCategoryCreateWithoutMroOrganizationInput;
  update: MroWorkOrderCategoryUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderCategoryWhereUniqueInput;
};

export type MroWorkOrderCategoryUpsertWithoutMroWorkOrdersInput = {
  create: MroWorkOrderCategoryCreateWithoutMroWorkOrdersInput;
  update: MroWorkOrderCategoryUpdateWithoutMroWorkOrdersInput;
  where?: InputMaybe<MroWorkOrderCategoryWhereInput>;
};

export type MroWorkOrderCategoryWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderCategoryWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderCategoryWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderCategoryWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<StringNullableFilter>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deafultCostRate?: InputMaybe<DecimalNullableFilter>;
  defaultBillableRate?: InputMaybe<DecimalNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  workType?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderCategoryWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderCategoryWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderCategoryWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<StringNullableFilter>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deafultCostRate?: InputMaybe<DecimalNullableFilter>;
  defaultBillableRate?: InputMaybe<DecimalNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<StringNullableFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrders?: InputMaybe<MroWorkOrderListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  workType?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderCount = {
  __typename?: 'MroWorkOrderCount';
  assignees: Scalars['Int'];
  craftServiceRequests: Scalars['Int'];
  itemCategories: Scalars['Int'];
  mroCommunicationThreads: Scalars['Int'];
  mroEstimates: Scalars['Int'];
  mroInvoices: Scalars['Int'];
  mroLogEntries: Scalars['Int'];
  mroWorkOrderBillingItems: Scalars['Int'];
  mroWorkOrderIntervals: Scalars['Int'];
  mroWorkOrderItems: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroWorkOrderCountAggregate = {
  __typename?: 'MroWorkOrderCountAggregate';
  _all: Scalars['Int'];
  arrivalDate: Scalars['Int'];
  completionDate: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroCraftId: Scalars['Int'];
  mroCustomerId: Scalars['Int'];
  mroLocationId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderCategoryId: Scalars['Int'];
  notes: Scalars['Int'];
  primaryConcern: Scalars['Int'];
  primaryContactId: Scalars['Int'];
  promiseDate: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  workOrderNum: Scalars['Int'];
};

export type MroWorkOrderCreateInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyMroCraftInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroLocationId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderCategoryId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContactId?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyMroCraftInputEnvelope = {
  data: Array<MroWorkOrderCreateManyMroCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCreateManyMroCustomerInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroLocationId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderCategoryId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContactId?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyMroCustomerInputEnvelope = {
  data: Array<MroWorkOrderCreateManyMroCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCreateManyMroLocationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderCategoryId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContactId?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyMroLocationInputEnvelope = {
  data: Array<MroWorkOrderCreateManyMroLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCreateManyMroOrganizationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroLocationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderCategoryId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContactId?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroWorkOrderCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCreateManyMroWorkOrderCategoryInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroLocationId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContactId?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyMroWorkOrderCategoryInputEnvelope = {
  data: Array<MroWorkOrderCreateManyMroWorkOrderCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCreateManyPrimaryContactInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCraftId?: InputMaybe<Scalars['String']>;
  mroCustomerId?: InputMaybe<Scalars['String']>;
  mroLocationId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderCategoryId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateManyPrimaryContactInputEnvelope = {
  data: Array<MroWorkOrderCreateManyPrimaryContactInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderCreateNestedManyWithoutAssigneesInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutAssigneesInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutAssigneesInput>>;
};

export type MroWorkOrderCreateNestedManyWithoutMroCraftInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroCraftInputEnvelope>;
};

export type MroWorkOrderCreateNestedManyWithoutMroCustomerInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroCustomerInputEnvelope>;
};

export type MroWorkOrderCreateNestedManyWithoutMroLocationInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroLocationInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroLocationInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroLocationInputEnvelope>;
};

export type MroWorkOrderCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroOrganizationInputEnvelope>;
};

export type MroWorkOrderCreateNestedManyWithoutMroWorkOrderCategoryInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroWorkOrderCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroWorkOrderCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroWorkOrderCategoryInputEnvelope>;
};

export type MroWorkOrderCreateNestedManyWithoutPrimaryContactInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutPrimaryContactInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutPrimaryContactInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyPrimaryContactInputEnvelope>;
};

export type MroWorkOrderCreateNestedOneWithoutCraftServiceRequestsInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutCraftServiceRequestsInput>;
};

export type MroWorkOrderCreateNestedOneWithoutItemCategoriesInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutItemCategoriesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutItemCategoriesInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroCommunicationThreadsInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroCommunicationThreadsInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroEstimatesInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroEstimatesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroEstimatesInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroInvoicesInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroInvoicesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroInvoicesInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroLogEntriesInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroLogEntriesInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroServiceRequestInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroServiceRequestInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroWorkOrderBillingItemsInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroWorkOrderBillingItemsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroWorkOrderBillingItemsInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroWorkOrderIntervalsInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroWorkOrderIntervalsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroWorkOrderIntervalsInput>;
};

export type MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroWorkOrderItemsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroWorkOrderItemsInput>;
};

export type MroWorkOrderCreateOrConnectWithoutAssigneesInput = {
  create: MroWorkOrderCreateWithoutAssigneesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutCraftServiceRequestsInput = {
  create: MroWorkOrderCreateWithoutCraftServiceRequestsInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutItemCategoriesInput = {
  create: MroWorkOrderCreateWithoutItemCategoriesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroCommunicationThreadsInput = {
  create: MroWorkOrderCreateWithoutMroCommunicationThreadsInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroCraftInput = {
  create: MroWorkOrderCreateWithoutMroCraftInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroCustomerInput = {
  create: MroWorkOrderCreateWithoutMroCustomerInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroEstimatesInput = {
  create: MroWorkOrderCreateWithoutMroEstimatesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroInvoicesInput = {
  create: MroWorkOrderCreateWithoutMroInvoicesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroLocationInput = {
  create: MroWorkOrderCreateWithoutMroLocationInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroLogEntriesInput = {
  create: MroWorkOrderCreateWithoutMroLogEntriesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroOrganizationInput = {
  create: MroWorkOrderCreateWithoutMroOrganizationInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroServiceRequestInput = {
  create: MroWorkOrderCreateWithoutMroServiceRequestInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroWorkOrderBillingItemsInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderBillingItemsInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroWorkOrderCategoryInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderCategoryInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroWorkOrderIntervalsInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderIntervalsInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutMroWorkOrderItemsInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderItemsInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateOrConnectWithoutPrimaryContactInput = {
  create: MroWorkOrderCreateWithoutPrimaryContactInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderCreateWithoutAssigneesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutCraftServiceRequestsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutItemCategoriesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroCommunicationThreadsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroCraftInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroCustomerInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroEstimatesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroInvoicesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroLocationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroLogEntriesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroOrganizationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroServiceRequestInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroWorkOrderBillingItemsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroWorkOrderCategoryInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroWorkOrderIntervalsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutMroWorkOrderItemsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactCreateNestedOneWithoutMroWorkOrdersInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderCreateWithoutPrimaryContactInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrdersInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroWorkOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadCreateNestedManyWithoutMroWorkOrderInput>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroWorkOrdersInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroWorkOrdersInput>;
  mroEstimates?: InputMaybe<MroEstimateCreateNestedManyWithoutMroWorkOrderInput>;
  mroInvoices?: InputMaybe<MroInvoiceCreateNestedManyWithoutMroWorkOrderInput>;
  mroLocation?: InputMaybe<MroLocationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutMroWorkOrderInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrdersInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestCreateNestedOneWithoutMroWorkOrderInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryCreateNestedOneWithoutMroWorkOrdersInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderInterval = {
  __typename?: 'MroWorkOrderInterval';
  _count: MroWorkOrderIntervalCount;
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderItemCategory?: Maybe<MroWorkOrderItemCategory>;
  mroWorkOrderItemCategoryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Int']>;
  versions?: Maybe<Array<MroWorkOrderIntervalVersion>>;
};

export type MroWorkOrderIntervalAvgAggregate = {
  __typename?: 'MroWorkOrderIntervalAvgAggregate';
  value?: Maybe<Scalars['Float']>;
};

export type MroWorkOrderIntervalCount = {
  __typename?: 'MroWorkOrderIntervalCount';
  versions: Scalars['Int'];
};

export type MroWorkOrderIntervalCountAggregate = {
  __typename?: 'MroWorkOrderIntervalCountAggregate';
  _all: Scalars['Int'];
  active: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  mroWorkOrderItemCategoryId: Scalars['Int'];
  name: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
};

export type MroWorkOrderIntervalCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroWorkOrderIntervalsInput>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderIntervalsInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionCreateNestedManyWithoutMroWorkOrderIntervalInput>;
};

export type MroWorkOrderIntervalCreateManyMroWorkOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemCategoryId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderIntervalCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroWorkOrderIntervalCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderIntervalCreateManyMroWorkOrderItemCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderIntervalCreateManyMroWorkOrderItemCategoryInputEnvelope = {
  data: Array<MroWorkOrderIntervalCreateManyMroWorkOrderItemCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderIntervalCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderIntervalCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderIntervalCreateManyMroWorkOrderInputEnvelope>;
};

export type MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput = {
  connect?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderIntervalCreateOrConnectWithoutMroWorkOrderItemCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderIntervalCreateWithoutMroWorkOrderItemCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderIntervalCreateManyMroWorkOrderItemCategoryInputEnvelope>;
};

export type MroWorkOrderIntervalCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroWorkOrderIntervalCreateWithoutMroWorkOrderInput;
  where: MroWorkOrderIntervalWhereUniqueInput;
};

export type MroWorkOrderIntervalCreateOrConnectWithoutMroWorkOrderItemCategoryInput = {
  create: MroWorkOrderIntervalCreateWithoutMroWorkOrderItemCategoryInput;
  where: MroWorkOrderIntervalWhereUniqueInput;
};

export type MroWorkOrderIntervalCreateWithoutMroWorkOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderIntervalsInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionCreateNestedManyWithoutMroWorkOrderIntervalInput>;
};

export type MroWorkOrderIntervalCreateWithoutMroWorkOrderItemCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroWorkOrderIntervalsInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionCreateNestedManyWithoutMroWorkOrderIntervalInput>;
};

export type MroWorkOrderIntervalListRelationFilter = {
  every?: InputMaybe<MroWorkOrderIntervalWhereInput>;
  none?: InputMaybe<MroWorkOrderIntervalWhereInput>;
  some?: InputMaybe<MroWorkOrderIntervalWhereInput>;
};

export type MroWorkOrderIntervalMaxAggregate = {
  __typename?: 'MroWorkOrderIntervalMaxAggregate';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderItemCategoryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderIntervalMinAggregate = {
  __typename?: 'MroWorkOrderIntervalMinAggregate';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderItemCategoryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderIntervalNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderIntervalWhereInput>;
  isNot?: InputMaybe<MroWorkOrderIntervalWhereInput>;
};

export type MroWorkOrderIntervalScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderIntervalScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderIntervalScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderIntervalScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemCategoryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<IntNullableFilter>;
};

export type MroWorkOrderIntervalSumAggregate = {
  __typename?: 'MroWorkOrderIntervalSumAggregate';
  value?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderIntervalUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroWorkOrderIntervalsNestedInput>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionUpdateManyWithoutMroWorkOrderIntervalNestedInput>;
};

export type MroWorkOrderIntervalUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderIntervalUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroWorkOrderIntervalUpdateManyMutationInput;
  where: MroWorkOrderIntervalScalarWhereInput;
};

export type MroWorkOrderIntervalUpdateManyWithWhereWithoutMroWorkOrderItemCategoryInput = {
  data: MroWorkOrderIntervalUpdateManyMutationInput;
  where: MroWorkOrderIntervalScalarWhereInput;
};

export type MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderIntervalCreateOrConnectWithoutMroWorkOrderItemCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderIntervalCreateWithoutMroWorkOrderItemCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderIntervalCreateManyMroWorkOrderItemCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderIntervalUpdateWithWhereUniqueWithoutMroWorkOrderItemCategoryInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderIntervalUpdateManyWithWhereWithoutMroWorkOrderItemCategoryInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderIntervalUpsertWithWhereUniqueWithoutMroWorkOrderItemCategoryInput>>;
};

export type MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderIntervalCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderIntervalCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderIntervalCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderIntervalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderIntervalWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderIntervalUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderIntervalUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderIntervalUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroWorkOrderIntervalUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroWorkOrderIntervalUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderIntervalWhereUniqueInput;
};

export type MroWorkOrderIntervalUpdateWithWhereUniqueWithoutMroWorkOrderItemCategoryInput = {
  data: MroWorkOrderIntervalUpdateWithoutMroWorkOrderItemCategoryInput;
  where: MroWorkOrderIntervalWhereUniqueInput;
};

export type MroWorkOrderIntervalUpdateWithoutMroWorkOrderInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionUpdateManyWithoutMroWorkOrderIntervalNestedInput>;
};

export type MroWorkOrderIntervalUpdateWithoutMroWorkOrderItemCategoryInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutMroWorkOrderIntervalsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionUpdateManyWithoutMroWorkOrderIntervalNestedInput>;
};

export type MroWorkOrderIntervalUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroWorkOrderIntervalCreateWithoutMroWorkOrderInput;
  update: MroWorkOrderIntervalUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderIntervalWhereUniqueInput;
};

export type MroWorkOrderIntervalUpsertWithWhereUniqueWithoutMroWorkOrderItemCategoryInput = {
  create: MroWorkOrderIntervalCreateWithoutMroWorkOrderItemCategoryInput;
  update: MroWorkOrderIntervalUpdateWithoutMroWorkOrderItemCategoryInput;
  where: MroWorkOrderIntervalWhereUniqueInput;
};

export type MroWorkOrderIntervalVersion = {
  __typename?: 'MroWorkOrderIntervalVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrderInterval?: Maybe<MroWorkOrderInterval>;
  mroWorkOrderIntervalId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderIntervalVersionCreateManyMroWorkOrderIntervalInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderIntervalVersionCreateManyMroWorkOrderIntervalInputEnvelope = {
  data: Array<MroWorkOrderIntervalVersionCreateManyMroWorkOrderIntervalInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderIntervalVersionCreateNestedManyWithoutMroWorkOrderIntervalInput = {
  connect?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderIntervalVersionCreateOrConnectWithoutMroWorkOrderIntervalInput>>;
  create?: InputMaybe<Array<MroWorkOrderIntervalVersionCreateWithoutMroWorkOrderIntervalInput>>;
  createMany?: InputMaybe<MroWorkOrderIntervalVersionCreateManyMroWorkOrderIntervalInputEnvelope>;
};

export type MroWorkOrderIntervalVersionCreateOrConnectWithoutMroWorkOrderIntervalInput = {
  create: MroWorkOrderIntervalVersionCreateWithoutMroWorkOrderIntervalInput;
  where: MroWorkOrderIntervalVersionWhereUniqueInput;
};

export type MroWorkOrderIntervalVersionCreateWithoutMroWorkOrderIntervalInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderIntervalVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderIntervalVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderIntervalVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderIntervalVersionWhereInput>;
};

export type MroWorkOrderIntervalVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderIntervalVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderIntervalVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderIntervalVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderIntervalId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderIntervalVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderIntervalVersionUpdateManyWithWhereWithoutMroWorkOrderIntervalInput = {
  data: MroWorkOrderIntervalVersionUpdateManyMutationInput;
  where: MroWorkOrderIntervalVersionScalarWhereInput;
};

export type MroWorkOrderIntervalVersionUpdateManyWithoutMroWorkOrderIntervalNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderIntervalVersionCreateOrConnectWithoutMroWorkOrderIntervalInput>>;
  create?: InputMaybe<Array<MroWorkOrderIntervalVersionCreateWithoutMroWorkOrderIntervalInput>>;
  createMany?: InputMaybe<MroWorkOrderIntervalVersionCreateManyMroWorkOrderIntervalInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderIntervalVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderIntervalVersionUpdateWithWhereUniqueWithoutMroWorkOrderIntervalInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderIntervalVersionUpdateManyWithWhereWithoutMroWorkOrderIntervalInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderIntervalVersionUpsertWithWhereUniqueWithoutMroWorkOrderIntervalInput>>;
};

export type MroWorkOrderIntervalVersionUpdateWithWhereUniqueWithoutMroWorkOrderIntervalInput = {
  data: MroWorkOrderIntervalVersionUpdateWithoutMroWorkOrderIntervalInput;
  where: MroWorkOrderIntervalVersionWhereUniqueInput;
};

export type MroWorkOrderIntervalVersionUpdateWithoutMroWorkOrderIntervalInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderIntervalVersionUpsertWithWhereUniqueWithoutMroWorkOrderIntervalInput = {
  create: MroWorkOrderIntervalVersionCreateWithoutMroWorkOrderIntervalInput;
  update: MroWorkOrderIntervalVersionUpdateWithoutMroWorkOrderIntervalInput;
  where: MroWorkOrderIntervalVersionWhereUniqueInput;
};

export type MroWorkOrderIntervalVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderInterval?: InputMaybe<MroWorkOrderIntervalNullableScalarRelationFilter>;
  mroWorkOrderIntervalId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderIntervalVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderIntervalVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrderInterval?: InputMaybe<MroWorkOrderIntervalNullableScalarRelationFilter>;
  mroWorkOrderIntervalId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderIntervalWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderIntervalWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderIntervalWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderIntervalWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  mroWorkOrderItemCategoryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<IntNullableFilter>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionListRelationFilter>;
};

export type MroWorkOrderIntervalWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderIntervalWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderIntervalWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderIntervalWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  mroWorkOrderItemCategoryId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<IntNullableFilter>;
  versions?: InputMaybe<MroWorkOrderIntervalVersionListRelationFilter>;
};

export type MroWorkOrderItem = {
  __typename?: 'MroWorkOrderItem';
  _count: MroWorkOrderItemCount;
  assignees?: Maybe<Array<MroEmployeeProfile>>;
  attachments?: Maybe<Array<Attachment>>;
  category?: Maybe<MroWorkOrderItemCategory>;
  categoryId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<MroWorkOrderItem>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enableLogEntry?: Maybe<Scalars['Boolean']>;
  estimatedHours?: Maybe<Scalars['Decimal']>;
  flatRate?: Maybe<Scalars['Decimal']>;
  id: Scalars['ID'];
  isFlatRate: Scalars['Boolean'];
  itemNumber?: Maybe<Scalars['Int']>;
  logEntry?: Maybe<Scalars['String']>;
  mroIssues?: Maybe<Array<MroIssue>>;
  mroLaborEntries?: Maybe<Array<MroLaborEntry>>;
  mroLogEntryItems?: Maybe<Array<MroLogEntryItem>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrder: MroWorkOrder;
  mroWorkOrderId: Scalars['String'];
  mroWorkOrderParts?: Maybe<Array<MroWorkOrderPart>>;
  mroWorkOrderSignoffs?: Maybe<Array<MroWorkOrderSignoff>>;
  notes?: Maybe<Scalars['String']>;
  parent?: Maybe<MroWorkOrderItem>;
  parentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  totalLaborBillable: Scalars['Float'];
  totalLaborCost: Scalars['Float'];
  totalLaborHours: Scalars['Float'];
  totalPartsBillable: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroWorkOrderItemVersion>>;
};

export type MroWorkOrderItemAvgAggregate = {
  __typename?: 'MroWorkOrderItemAvgAggregate';
  estimatedHours?: Maybe<Scalars['Decimal']>;
  flatRate?: Maybe<Scalars['Decimal']>;
  itemNumber?: Maybe<Scalars['Float']>;
};

export type MroWorkOrderItemCategory = {
  __typename?: 'MroWorkOrderItemCategory';
  _count: MroWorkOrderItemCategoryCount;
  categoryNumber?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  modelNumber?: Maybe<Scalars['String']>;
  mroComponent?: Maybe<MroComponent>;
  mroComponentId?: Maybe<Scalars['String']>;
  mroLogEntries?: Maybe<Array<MroLogEntry>>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  mroWorkOrderIntervals?: Maybe<Array<MroWorkOrderInterval>>;
  mroWorkOrderItems?: Maybe<Array<MroWorkOrderItem>>;
  serialNumber?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroWorkOrderItemCategoryVersion>>;
};

export type MroWorkOrderItemCategoryAvgAggregate = {
  __typename?: 'MroWorkOrderItemCategoryAvgAggregate';
  categoryNumber?: Maybe<Scalars['Float']>;
  sortIndex?: Maybe<Scalars['Float']>;
};

export type MroWorkOrderItemCategoryCount = {
  __typename?: 'MroWorkOrderItemCategoryCount';
  mroLogEntries: Scalars['Int'];
  mroWorkOrderIntervals: Scalars['Int'];
  mroWorkOrderItems: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroWorkOrderItemCategoryCountAggregate = {
  __typename?: 'MroWorkOrderItemCategoryCountAggregate';
  _all: Scalars['Int'];
  categoryNumber: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  iconName: Scalars['Int'];
  id: Scalars['Int'];
  modelNumber: Scalars['Int'];
  mroComponentId: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  serialNumber: Scalars['Int'];
  sortIndex: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroWorkOrderItemCategoryCreateInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutItemCategoryInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutItemCategoriesInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryCreateManyMroComponentInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCategoryCreateManyMroComponentInputEnvelope = {
  data: Array<MroWorkOrderItemCategoryCreateManyMroComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCategoryCreateManyMroOrganizationInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponentId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCategoryCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroWorkOrderItemCategoryCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCategoryCreateManyMroWorkOrderInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponentId?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCategoryCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroWorkOrderItemCategoryCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCategoryCreateNestedManyWithoutMroComponentInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryCreateOrConnectWithoutMroComponentInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryCreateWithoutMroComponentInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryCreateManyMroComponentInputEnvelope>;
};

export type MroWorkOrderItemCategoryCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryCreateManyMroOrganizationInputEnvelope>;
};

export type MroWorkOrderItemCategoryCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryCreateManyMroWorkOrderInputEnvelope>;
};

export type MroWorkOrderItemCategoryCreateNestedOneWithoutMroLogEntriesInput = {
  connect?: InputMaybe<MroWorkOrderItemCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCategoryCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroWorkOrderItemCategoryCreateWithoutMroLogEntriesInput>;
};

export type MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderIntervalsInput = {
  connect?: InputMaybe<MroWorkOrderItemCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderIntervalsInput>;
  create?: InputMaybe<MroWorkOrderItemCategoryCreateWithoutMroWorkOrderIntervalsInput>;
};

export type MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput = {
  connect?: InputMaybe<MroWorkOrderItemCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderItemsInput>;
  create?: InputMaybe<MroWorkOrderItemCategoryCreateWithoutMroWorkOrderItemsInput>;
};

export type MroWorkOrderItemCategoryCreateOrConnectWithoutMroComponentInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroComponentInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryCreateOrConnectWithoutMroLogEntriesInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroLogEntriesInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryCreateOrConnectWithoutMroOrganizationInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroOrganizationInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroWorkOrderInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderIntervalsInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroWorkOrderIntervalsInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderItemsInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroWorkOrderItemsInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryCreateWithoutMroComponentInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutItemCategoryInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutItemCategoriesInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryCreateWithoutMroLogEntriesInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutItemCategoriesInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryCreateWithoutMroOrganizationInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutItemCategoryInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutItemCategoriesInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryCreateWithoutMroWorkOrderInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutItemCategoryInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryCreateWithoutMroWorkOrderIntervalsInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutItemCategoryInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutItemCategoriesInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryCreateWithoutMroWorkOrderItemsInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroLogEntries?: InputMaybe<MroLogEntryCreateNestedManyWithoutItemCategoryInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemCategoriesInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutItemCategoriesInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput>;
};

export type MroWorkOrderItemCategoryListRelationFilter = {
  every?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  none?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  some?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryMaxAggregate = {
  __typename?: 'MroWorkOrderItemCategoryMaxAggregate';
  categoryNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modelNumber?: Maybe<Scalars['String']>;
  mroComponentId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCategoryMinAggregate = {
  __typename?: 'MroWorkOrderItemCategoryMinAggregate';
  categoryNumber?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  modelNumber?: Maybe<Scalars['String']>;
  mroComponentId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCategoryNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  isNot?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemCategoryScalarWhereInput>>;
  categoryNumber?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modelNumber?: InputMaybe<StringNullableFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  sortIndex?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroWorkOrderItemCategorySumAggregate = {
  __typename?: 'MroWorkOrderItemCategorySumAggregate';
  categoryNumber?: Maybe<Scalars['Int']>;
  sortIndex?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderItemCategoryUpdateInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutItemCategoryNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpdateManyMutationInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCategoryUpdateManyWithWhereWithoutMroComponentInput = {
  data: MroWorkOrderItemCategoryUpdateManyMutationInput;
  where: MroWorkOrderItemCategoryScalarWhereInput;
};

export type MroWorkOrderItemCategoryUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroWorkOrderItemCategoryUpdateManyMutationInput;
  where: MroWorkOrderItemCategoryScalarWhereInput;
};

export type MroWorkOrderItemCategoryUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroWorkOrderItemCategoryUpdateManyMutationInput;
  where: MroWorkOrderItemCategoryScalarWhereInput;
};

export type MroWorkOrderItemCategoryUpdateManyWithoutMroComponentNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryCreateOrConnectWithoutMroComponentInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryCreateWithoutMroComponentInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryCreateManyMroComponentInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemCategoryUpdateWithWhereUniqueWithoutMroComponentInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemCategoryUpdateManyWithWhereWithoutMroComponentInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemCategoryUpsertWithWhereUniqueWithoutMroComponentInput>>;
};

export type MroWorkOrderItemCategoryUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemCategoryUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemCategoryUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemCategoryUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemCategoryUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemCategoryUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemCategoryUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroWorkOrderItemCategoryUpdateOneWithoutMroLogEntriesNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCategoryCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroWorkOrderItemCategoryCreateWithoutMroLogEntriesInput>;
  delete?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  update?: InputMaybe<MroWorkOrderItemCategoryUpdateToOneWithWhereWithoutMroLogEntriesInput>;
  upsert?: InputMaybe<MroWorkOrderItemCategoryUpsertWithoutMroLogEntriesInput>;
};

export type MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderIntervalsNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderIntervalsInput>;
  create?: InputMaybe<MroWorkOrderItemCategoryCreateWithoutMroWorkOrderIntervalsInput>;
  delete?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  update?: InputMaybe<MroWorkOrderItemCategoryUpdateToOneWithWhereWithoutMroWorkOrderIntervalsInput>;
  upsert?: InputMaybe<MroWorkOrderItemCategoryUpsertWithoutMroWorkOrderIntervalsInput>;
};

export type MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCategoryCreateOrConnectWithoutMroWorkOrderItemsInput>;
  create?: InputMaybe<MroWorkOrderItemCategoryCreateWithoutMroWorkOrderItemsInput>;
  delete?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
  update?: InputMaybe<MroWorkOrderItemCategoryUpdateToOneWithWhereWithoutMroWorkOrderItemsInput>;
  upsert?: InputMaybe<MroWorkOrderItemCategoryUpsertWithoutMroWorkOrderItemsInput>;
};

export type MroWorkOrderItemCategoryUpdateToOneWithWhereWithoutMroLogEntriesInput = {
  data: MroWorkOrderItemCategoryUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryUpdateToOneWithWhereWithoutMroWorkOrderIntervalsInput = {
  data: MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderIntervalsInput;
  where?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryUpdateToOneWithWhereWithoutMroWorkOrderItemsInput = {
  data: MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderItemsInput;
  where?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryUpdateWithWhereUniqueWithoutMroComponentInput = {
  data: MroWorkOrderItemCategoryUpdateWithoutMroComponentInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroWorkOrderItemCategoryUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryUpdateWithoutMroComponentInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutItemCategoryNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpdateWithoutMroLogEntriesInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpdateWithoutMroOrganizationInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutItemCategoryNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutItemCategoryNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderIntervalsInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutItemCategoryNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderItemsInput = {
  categoryNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  iconName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<Scalars['String']>;
  mroComponent?: InputMaybe<MroComponentUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutItemCategoryNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemCategoriesNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
  serialNumber?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput>;
};

export type MroWorkOrderItemCategoryUpsertWithWhereUniqueWithoutMroComponentInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroComponentInput;
  update: MroWorkOrderItemCategoryUpdateWithoutMroComponentInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroOrganizationInput;
  update: MroWorkOrderItemCategoryUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroWorkOrderInput;
  update: MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderItemCategoryWhereUniqueInput;
};

export type MroWorkOrderItemCategoryUpsertWithoutMroLogEntriesInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroLogEntriesInput;
  update: MroWorkOrderItemCategoryUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryUpsertWithoutMroWorkOrderIntervalsInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroWorkOrderIntervalsInput;
  update: MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderIntervalsInput;
  where?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryUpsertWithoutMroWorkOrderItemsInput = {
  create: MroWorkOrderItemCategoryCreateWithoutMroWorkOrderItemsInput;
  update: MroWorkOrderItemCategoryUpdateWithoutMroWorkOrderItemsInput;
  where?: InputMaybe<MroWorkOrderItemCategoryWhereInput>;
};

export type MroWorkOrderItemCategoryVersion = {
  __typename?: 'MroWorkOrderItemCategoryVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrderItemCategory?: Maybe<MroWorkOrderItemCategory>;
  mroWorkOrderItemCategoryId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderItemCategoryVersionCreateManyMroWorkOrderItemCategoryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemCategoryVersionCreateManyMroWorkOrderItemCategoryInputEnvelope = {
  data: Array<MroWorkOrderItemCategoryVersionCreateManyMroWorkOrderItemCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCategoryVersionCreateNestedManyWithoutMroWorkOrderItemCategoryInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryVersionCreateOrConnectWithoutMroWorkOrderItemCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryVersionCreateWithoutMroWorkOrderItemCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryVersionCreateManyMroWorkOrderItemCategoryInputEnvelope>;
};

export type MroWorkOrderItemCategoryVersionCreateOrConnectWithoutMroWorkOrderItemCategoryInput = {
  create: MroWorkOrderItemCategoryVersionCreateWithoutMroWorkOrderItemCategoryInput;
  where: MroWorkOrderItemCategoryVersionWhereUniqueInput;
};

export type MroWorkOrderItemCategoryVersionCreateWithoutMroWorkOrderItemCategoryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemCategoryVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderItemCategoryVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderItemCategoryVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderItemCategoryVersionWhereInput>;
};

export type MroWorkOrderItemCategoryVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemCategoryVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemCategoryVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemCategoryVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderItemCategoryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderItemCategoryVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemCategoryVersionUpdateManyWithWhereWithoutMroWorkOrderItemCategoryInput = {
  data: MroWorkOrderItemCategoryVersionUpdateManyMutationInput;
  where: MroWorkOrderItemCategoryVersionScalarWhereInput;
};

export type MroWorkOrderItemCategoryVersionUpdateManyWithoutMroWorkOrderItemCategoryNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCategoryVersionCreateOrConnectWithoutMroWorkOrderItemCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCategoryVersionCreateWithoutMroWorkOrderItemCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCategoryVersionCreateManyMroWorkOrderItemCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemCategoryVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemCategoryVersionUpdateWithWhereUniqueWithoutMroWorkOrderItemCategoryInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemCategoryVersionUpdateManyWithWhereWithoutMroWorkOrderItemCategoryInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemCategoryVersionUpsertWithWhereUniqueWithoutMroWorkOrderItemCategoryInput>>;
};

export type MroWorkOrderItemCategoryVersionUpdateWithWhereUniqueWithoutMroWorkOrderItemCategoryInput = {
  data: MroWorkOrderItemCategoryVersionUpdateWithoutMroWorkOrderItemCategoryInput;
  where: MroWorkOrderItemCategoryVersionWhereUniqueInput;
};

export type MroWorkOrderItemCategoryVersionUpdateWithoutMroWorkOrderItemCategoryInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemCategoryVersionUpsertWithWhereUniqueWithoutMroWorkOrderItemCategoryInput = {
  create: MroWorkOrderItemCategoryVersionCreateWithoutMroWorkOrderItemCategoryInput;
  update: MroWorkOrderItemCategoryVersionUpdateWithoutMroWorkOrderItemCategoryInput;
  where: MroWorkOrderItemCategoryVersionWhereUniqueInput;
};

export type MroWorkOrderItemCategoryVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  mroWorkOrderItemCategoryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderItemCategoryVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemCategoryVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrderItemCategory?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  mroWorkOrderItemCategoryId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderItemCategoryWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemCategoryWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemCategoryWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemCategoryWhereInput>>;
  categoryNumber?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  modelNumber?: InputMaybe<StringNullableFilter>;
  mroComponent?: InputMaybe<MroComponentNullableScalarRelationFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  sortIndex?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionListRelationFilter>;
};

export type MroWorkOrderItemCategoryWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemCategoryWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemCategoryWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemCategoryWhereInput>>;
  categoryNumber?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  iconName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  modelNumber?: InputMaybe<StringNullableFilter>;
  mroComponent?: InputMaybe<MroComponentNullableScalarRelationFilter>;
  mroComponentId?: InputMaybe<StringNullableFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  sortIndex?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderItemCategoryVersionListRelationFilter>;
};

export type MroWorkOrderItemCount = {
  __typename?: 'MroWorkOrderItemCount';
  assignees: Scalars['Int'];
  attachments: Scalars['Int'];
  children: Scalars['Int'];
  mroIssues: Scalars['Int'];
  mroLaborEntries: Scalars['Int'];
  mroLogEntryItems: Scalars['Int'];
  mroWorkOrderParts: Scalars['Int'];
  mroWorkOrderSignoffs: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroWorkOrderItemCountAggregate = {
  __typename?: 'MroWorkOrderItemCountAggregate';
  _all: Scalars['Int'];
  categoryId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  enableLogEntry: Scalars['Int'];
  estimatedHours: Scalars['Int'];
  flatRate: Scalars['Int'];
  id: Scalars['Int'];
  isFlatRate: Scalars['Int'];
  itemNumber: Scalars['Int'];
  logEntry: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  mroWorkOrderId: Scalars['Int'];
  notes: Scalars['Int'];
  parentId: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroWorkOrderItemCreateInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateManyCategoryInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCreateManyCategoryInputEnvelope = {
  data: Array<MroWorkOrderItemCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCreateManyMroOrganizationInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroWorkOrderId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroWorkOrderItemCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCreateManyMroWorkOrderInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroWorkOrderItemCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCreateManyParentInput = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroOrganizationId?: InputMaybe<Scalars['String']>;
  mroWorkOrderId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemCreateManyParentInputEnvelope = {
  data: Array<MroWorkOrderItemCreateManyParentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemCreateNestedManyWithoutAssigneesInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutAssigneesInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutAssigneesInput>>;
};

export type MroWorkOrderItemCreateNestedManyWithoutAttachmentsInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutAttachmentsInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutAttachmentsInput>>;
};

export type MroWorkOrderItemCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyCategoryInputEnvelope>;
};

export type MroWorkOrderItemCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyMroOrganizationInputEnvelope>;
};

export type MroWorkOrderItemCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyMroWorkOrderInputEnvelope>;
};

export type MroWorkOrderItemCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyParentInputEnvelope>;
};

export type MroWorkOrderItemCreateNestedOneWithoutChildrenInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutChildrenInput>;
};

export type MroWorkOrderItemCreateNestedOneWithoutMroIssuesInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroIssuesInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroIssuesInput>;
};

export type MroWorkOrderItemCreateNestedOneWithoutMroLaborEntriesInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroLaborEntriesInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroLaborEntriesInput>;
};

export type MroWorkOrderItemCreateNestedOneWithoutMroLogEntryItemsInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroLogEntryItemsInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroLogEntryItemsInput>;
};

export type MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroWorkOrderPartsInput>;
};

export type MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderSignoffsInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderSignoffsInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroWorkOrderSignoffsInput>;
};

export type MroWorkOrderItemCreateOrConnectWithoutAssigneesInput = {
  create: MroWorkOrderItemCreateWithoutAssigneesInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutAttachmentsInput = {
  create: MroWorkOrderItemCreateWithoutAttachmentsInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutCategoryInput = {
  create: MroWorkOrderItemCreateWithoutCategoryInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutChildrenInput = {
  create: MroWorkOrderItemCreateWithoutChildrenInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroIssuesInput = {
  create: MroWorkOrderItemCreateWithoutMroIssuesInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroLaborEntriesInput = {
  create: MroWorkOrderItemCreateWithoutMroLaborEntriesInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroLogEntryItemsInput = {
  create: MroWorkOrderItemCreateWithoutMroLogEntryItemsInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroOrganizationInput = {
  create: MroWorkOrderItemCreateWithoutMroOrganizationInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroWorkOrderItemCreateWithoutMroWorkOrderInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderPartsInput = {
  create: MroWorkOrderItemCreateWithoutMroWorkOrderPartsInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderSignoffsInput = {
  create: MroWorkOrderItemCreateWithoutMroWorkOrderSignoffsInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateOrConnectWithoutParentInput = {
  create: MroWorkOrderItemCreateWithoutParentInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemCreateWithoutAssigneesInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutAttachmentsInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutCategoryInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutChildrenInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroIssuesInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroLaborEntriesInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroLogEntryItemsInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroOrganizationInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroWorkOrderInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroWorkOrderPartsInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutMroWorkOrderSignoffsInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutChildrenInput>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemCreateWithoutParentInput = {
  assignees?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutAssignedWorkOrderItemsInput>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutMroWorkOrderItemsInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryCreateNestedOneWithoutMroWorkOrderItemsInput>;
  children?: InputMaybe<MroWorkOrderItemCreateNestedManyWithoutParentInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroWorkOrderItemsInput>;
  mroWorkOrder: MroWorkOrderCreateNestedOneWithoutMroWorkOrderItemsInput;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput>;
};

export type MroWorkOrderItemListRelationFilter = {
  every?: InputMaybe<MroWorkOrderItemWhereInput>;
  none?: InputMaybe<MroWorkOrderItemWhereInput>;
  some?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemMaxAggregate = {
  __typename?: 'MroWorkOrderItemMaxAggregate';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enableLogEntry?: Maybe<Scalars['Boolean']>;
  estimatedHours?: Maybe<Scalars['Decimal']>;
  flatRate?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  isFlatRate?: Maybe<Scalars['Boolean']>;
  itemNumber?: Maybe<Scalars['Int']>;
  logEntry?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemMinAggregate = {
  __typename?: 'MroWorkOrderItemMinAggregate';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enableLogEntry?: Maybe<Scalars['Boolean']>;
  estimatedHours?: Maybe<Scalars['Decimal']>;
  flatRate?: Maybe<Scalars['Decimal']>;
  id?: Maybe<Scalars['String']>;
  isFlatRate?: Maybe<Scalars['Boolean']>;
  itemNumber?: Maybe<Scalars['Int']>;
  logEntry?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderItemWhereInput>;
  isNot?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  categoryId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enableLogEntry?: InputMaybe<BoolNullableFilter>;
  estimatedHours?: InputMaybe<DecimalNullableFilter>;
  flatRate?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isFlatRate?: InputMaybe<BoolFilter>;
  itemNumber?: InputMaybe<IntNullableFilter>;
  logEntry?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderId?: InputMaybe<StringFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroWorkOrderItemSumAggregate = {
  __typename?: 'MroWorkOrderItemSumAggregate';
  estimatedHours?: Maybe<Scalars['Decimal']>;
  flatRate?: Maybe<Scalars['Decimal']>;
  itemNumber?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderItemUpdateInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderItemUpdateManyWithWhereWithoutAssigneesInput = {
  data: MroWorkOrderItemUpdateManyMutationInput;
  where: MroWorkOrderItemScalarWhereInput;
};

export type MroWorkOrderItemUpdateManyWithWhereWithoutAttachmentsInput = {
  data: MroWorkOrderItemUpdateManyMutationInput;
  where: MroWorkOrderItemScalarWhereInput;
};

export type MroWorkOrderItemUpdateManyWithWhereWithoutCategoryInput = {
  data: MroWorkOrderItemUpdateManyMutationInput;
  where: MroWorkOrderItemScalarWhereInput;
};

export type MroWorkOrderItemUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroWorkOrderItemUpdateManyMutationInput;
  where: MroWorkOrderItemScalarWhereInput;
};

export type MroWorkOrderItemUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroWorkOrderItemUpdateManyMutationInput;
  where: MroWorkOrderItemScalarWhereInput;
};

export type MroWorkOrderItemUpdateManyWithWhereWithoutParentInput = {
  data: MroWorkOrderItemUpdateManyMutationInput;
  where: MroWorkOrderItemScalarWhereInput;
};

export type MroWorkOrderItemUpdateManyWithoutAssigneesNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutAssigneesInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutAssigneesInput>>;
  delete?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type MroWorkOrderItemUpdateManyWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutAttachmentsInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutAttachmentsInput>>;
  delete?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemUpdateWithWhereUniqueWithoutAttachmentsInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemUpdateManyWithWhereWithoutAttachmentsInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemUpsertWithWhereUniqueWithoutAttachmentsInput>>;
};

export type MroWorkOrderItemUpdateManyWithoutCategoryNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type MroWorkOrderItemUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroWorkOrderItemUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemCreateWithoutParentInput>>;
  createMany?: InputMaybe<MroWorkOrderItemCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemUpsertWithWhereUniqueWithoutParentInput>>;
};

export type MroWorkOrderItemUpdateOneWithoutChildrenNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutChildrenInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutChildrenInput>;
  delete?: InputMaybe<MroWorkOrderItemWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemWhereInput>;
  update?: InputMaybe<MroWorkOrderItemUpdateToOneWithWhereWithoutChildrenInput>;
  upsert?: InputMaybe<MroWorkOrderItemUpsertWithoutChildrenInput>;
};

export type MroWorkOrderItemUpdateOneWithoutMroIssuesNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroIssuesInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroIssuesInput>;
  delete?: InputMaybe<MroWorkOrderItemWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemWhereInput>;
  update?: InputMaybe<MroWorkOrderItemUpdateToOneWithWhereWithoutMroIssuesInput>;
  upsert?: InputMaybe<MroWorkOrderItemUpsertWithoutMroIssuesInput>;
};

export type MroWorkOrderItemUpdateOneWithoutMroLaborEntriesNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroLaborEntriesInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroLaborEntriesInput>;
  delete?: InputMaybe<MroWorkOrderItemWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemWhereInput>;
  update?: InputMaybe<MroWorkOrderItemUpdateToOneWithWhereWithoutMroLaborEntriesInput>;
  upsert?: InputMaybe<MroWorkOrderItemUpsertWithoutMroLaborEntriesInput>;
};

export type MroWorkOrderItemUpdateOneWithoutMroLogEntryItemsNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroLogEntryItemsInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroLogEntryItemsInput>;
  delete?: InputMaybe<MroWorkOrderItemWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemWhereInput>;
  update?: InputMaybe<MroWorkOrderItemUpdateToOneWithWhereWithoutMroLogEntryItemsInput>;
  upsert?: InputMaybe<MroWorkOrderItemUpsertWithoutMroLogEntryItemsInput>;
};

export type MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderPartsInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroWorkOrderPartsInput>;
  delete?: InputMaybe<MroWorkOrderItemWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemWhereInput>;
  update?: InputMaybe<MroWorkOrderItemUpdateToOneWithWhereWithoutMroWorkOrderPartsInput>;
  upsert?: InputMaybe<MroWorkOrderItemUpsertWithoutMroWorkOrderPartsInput>;
};

export type MroWorkOrderItemUpdateOneWithoutMroWorkOrderSignoffsNestedInput = {
  connect?: InputMaybe<MroWorkOrderItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderItemCreateOrConnectWithoutMroWorkOrderSignoffsInput>;
  create?: InputMaybe<MroWorkOrderItemCreateWithoutMroWorkOrderSignoffsInput>;
  delete?: InputMaybe<MroWorkOrderItemWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderItemWhereInput>;
  update?: InputMaybe<MroWorkOrderItemUpdateToOneWithWhereWithoutMroWorkOrderSignoffsInput>;
  upsert?: InputMaybe<MroWorkOrderItemUpsertWithoutMroWorkOrderSignoffsInput>;
};

export type MroWorkOrderItemUpdateToOneWithWhereWithoutChildrenInput = {
  data: MroWorkOrderItemUpdateWithoutChildrenInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpdateToOneWithWhereWithoutMroIssuesInput = {
  data: MroWorkOrderItemUpdateWithoutMroIssuesInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpdateToOneWithWhereWithoutMroLaborEntriesInput = {
  data: MroWorkOrderItemUpdateWithoutMroLaborEntriesInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpdateToOneWithWhereWithoutMroLogEntryItemsInput = {
  data: MroWorkOrderItemUpdateWithoutMroLogEntryItemsInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpdateToOneWithWhereWithoutMroWorkOrderPartsInput = {
  data: MroWorkOrderItemUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpdateToOneWithWhereWithoutMroWorkOrderSignoffsInput = {
  data: MroWorkOrderItemUpdateWithoutMroWorkOrderSignoffsInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpdateWithWhereUniqueWithoutAssigneesInput = {
  data: MroWorkOrderItemUpdateWithoutAssigneesInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpdateWithWhereUniqueWithoutAttachmentsInput = {
  data: MroWorkOrderItemUpdateWithoutAttachmentsInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpdateWithWhereUniqueWithoutCategoryInput = {
  data: MroWorkOrderItemUpdateWithoutCategoryInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroWorkOrderItemUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroWorkOrderItemUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpdateWithWhereUniqueWithoutParentInput = {
  data: MroWorkOrderItemUpdateWithoutParentInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpdateWithoutAssigneesInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutAttachmentsInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutCategoryInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutChildrenInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroIssuesInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroLaborEntriesInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroLogEntryItemsInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroOrganizationInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroWorkOrderInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroWorkOrderPartsInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutMroWorkOrderSignoffsInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<MroWorkOrderItemUpdateOneWithoutChildrenNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpdateWithoutParentInput = {
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrderItemsNestedInput>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutMroWorkOrderItemsNestedInput>;
  category?: InputMaybe<MroWorkOrderItemCategoryUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  children?: InputMaybe<MroWorkOrderItemUpdateManyWithoutParentNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  enableLogEntry?: InputMaybe<Scalars['Boolean']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']>;
  flatRate?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<Scalars['Boolean']>;
  itemNumber?: InputMaybe<Scalars['Int']>;
  logEntry?: InputMaybe<Scalars['String']>;
  mroIssues?: InputMaybe<MroIssueUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLaborEntries?: InputMaybe<MroLaborEntryUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrder?: InputMaybe<MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput>;
};

export type MroWorkOrderItemUpsertWithWhereUniqueWithoutAssigneesInput = {
  create: MroWorkOrderItemCreateWithoutAssigneesInput;
  update: MroWorkOrderItemUpdateWithoutAssigneesInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpsertWithWhereUniqueWithoutAttachmentsInput = {
  create: MroWorkOrderItemCreateWithoutAttachmentsInput;
  update: MroWorkOrderItemUpdateWithoutAttachmentsInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpsertWithWhereUniqueWithoutCategoryInput = {
  create: MroWorkOrderItemCreateWithoutCategoryInput;
  update: MroWorkOrderItemUpdateWithoutCategoryInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroWorkOrderItemCreateWithoutMroOrganizationInput;
  update: MroWorkOrderItemUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroWorkOrderItemCreateWithoutMroWorkOrderInput;
  update: MroWorkOrderItemUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpsertWithWhereUniqueWithoutParentInput = {
  create: MroWorkOrderItemCreateWithoutParentInput;
  update: MroWorkOrderItemUpdateWithoutParentInput;
  where: MroWorkOrderItemWhereUniqueInput;
};

export type MroWorkOrderItemUpsertWithoutChildrenInput = {
  create: MroWorkOrderItemCreateWithoutChildrenInput;
  update: MroWorkOrderItemUpdateWithoutChildrenInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpsertWithoutMroIssuesInput = {
  create: MroWorkOrderItemCreateWithoutMroIssuesInput;
  update: MroWorkOrderItemUpdateWithoutMroIssuesInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpsertWithoutMroLaborEntriesInput = {
  create: MroWorkOrderItemCreateWithoutMroLaborEntriesInput;
  update: MroWorkOrderItemUpdateWithoutMroLaborEntriesInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpsertWithoutMroLogEntryItemsInput = {
  create: MroWorkOrderItemCreateWithoutMroLogEntryItemsInput;
  update: MroWorkOrderItemUpdateWithoutMroLogEntryItemsInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpsertWithoutMroWorkOrderPartsInput = {
  create: MroWorkOrderItemCreateWithoutMroWorkOrderPartsInput;
  update: MroWorkOrderItemUpdateWithoutMroWorkOrderPartsInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemUpsertWithoutMroWorkOrderSignoffsInput = {
  create: MroWorkOrderItemCreateWithoutMroWorkOrderSignoffsInput;
  update: MroWorkOrderItemUpdateWithoutMroWorkOrderSignoffsInput;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};

export type MroWorkOrderItemVersion = {
  __typename?: 'MroWorkOrderItemVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionAvgAggregate = {
  __typename?: 'MroWorkOrderItemVersionAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type MroWorkOrderItemVersionCountAggregate = {
  __typename?: 'MroWorkOrderItemVersionCountAggregate';
  _all: Scalars['Int'];
  data: Scalars['Int'];
  id: Scalars['Int'];
  mroWorkOrderItemId: Scalars['Int'];
  operation: Scalars['Int'];
  timestamp: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MroWorkOrderItemVersionCreateManyMroWorkOrderItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionCreateManyMroWorkOrderItemInputEnvelope = {
  data: Array<MroWorkOrderItemVersionCreateManyMroWorkOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderItemVersionCreateNestedManyWithoutMroWorkOrderItemInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemVersionCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemVersionCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroWorkOrderItemVersionCreateManyMroWorkOrderItemInputEnvelope>;
};

export type MroWorkOrderItemVersionCreateOrConnectWithoutMroWorkOrderItemInput = {
  create: MroWorkOrderItemVersionCreateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderItemVersionWhereUniqueInput;
};

export type MroWorkOrderItemVersionCreateWithoutMroWorkOrderItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderItemVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderItemVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderItemVersionWhereInput>;
};

export type MroWorkOrderItemVersionMaxAggregate = {
  __typename?: 'MroWorkOrderItemVersionMaxAggregate';
  id?: Maybe<Scalars['Int']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionMinAggregate = {
  __typename?: 'MroWorkOrderItemVersionMinAggregate';
  id?: Maybe<Scalars['Int']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  operation?: Maybe<AuditOperation>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderItemVersionSumAggregate = {
  __typename?: 'MroWorkOrderItemVersionSumAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderItemVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionUpdateManyWithWhereWithoutMroWorkOrderItemInput = {
  data: MroWorkOrderItemVersionUpdateManyMutationInput;
  where: MroWorkOrderItemVersionScalarWhereInput;
};

export type MroWorkOrderItemVersionUpdateManyWithoutMroWorkOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderItemVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderItemVersionCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroWorkOrderItemVersionCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroWorkOrderItemVersionCreateManyMroWorkOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderItemVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderItemVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderItemVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderItemVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderItemVersionUpdateWithWhereUniqueWithoutMroWorkOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderItemVersionUpdateManyWithWhereWithoutMroWorkOrderItemInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderItemVersionUpsertWithWhereUniqueWithoutMroWorkOrderItemInput>>;
};

export type MroWorkOrderItemVersionUpdateWithWhereUniqueWithoutMroWorkOrderItemInput = {
  data: MroWorkOrderItemVersionUpdateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderItemVersionWhereUniqueInput;
};

export type MroWorkOrderItemVersionUpdateWithoutMroWorkOrderItemInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderItemVersionUpsertWithWhereUniqueWithoutMroWorkOrderItemInput = {
  create: MroWorkOrderItemVersionCreateWithoutMroWorkOrderItemInput;
  update: MroWorkOrderItemVersionUpdateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderItemVersionWhereUniqueInput;
};

export type MroWorkOrderItemVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderItemVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderItemWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemWhereInput>>;
  assignees?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  category?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  children?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enableLogEntry?: InputMaybe<BoolNullableFilter>;
  estimatedHours?: InputMaybe<DecimalNullableFilter>;
  flatRate?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isFlatRate?: InputMaybe<BoolFilter>;
  itemNumber?: InputMaybe<IntNullableFilter>;
  logEntry?: InputMaybe<StringNullableFilter>;
  mroIssues?: InputMaybe<MroIssueListRelationFilter>;
  mroLaborEntries?: InputMaybe<MroLaborEntryListRelationFilter>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderItemVersionListRelationFilter>;
};

export type MroWorkOrderItemWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderItemWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderItemWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderItemWhereInput>>;
  assignees?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  category?: InputMaybe<MroWorkOrderItemCategoryNullableScalarRelationFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  children?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  enableLogEntry?: InputMaybe<BoolNullableFilter>;
  estimatedHours?: InputMaybe<DecimalNullableFilter>;
  flatRate?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isFlatRate?: InputMaybe<BoolFilter>;
  itemNumber?: InputMaybe<IntNullableFilter>;
  logEntry?: InputMaybe<StringNullableFilter>;
  mroIssues?: InputMaybe<MroIssueListRelationFilter>;
  mroLaborEntries?: InputMaybe<MroLaborEntryListRelationFilter>;
  mroLogEntryItems?: InputMaybe<MroLogEntryItemListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringFilter>;
  mroWorkOrderParts?: InputMaybe<MroWorkOrderPartListRelationFilter>;
  mroWorkOrderSignoffs?: InputMaybe<MroWorkOrderSignoffListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  parent?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderItemVersionListRelationFilter>;
};

export type MroWorkOrderListRelationFilter = {
  every?: InputMaybe<MroWorkOrderWhereInput>;
  none?: InputMaybe<MroWorkOrderWhereInput>;
  some?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderMaxAggregate = {
  __typename?: 'MroWorkOrderMaxAggregate';
  arrivalDate?: Maybe<Scalars['DateTime']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroLocationId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderCategoryId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  primaryConcern?: Maybe<Scalars['String']>;
  primaryContactId?: Maybe<Scalars['String']>;
  promiseDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workOrderNum?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderMinAggregate = {
  __typename?: 'MroWorkOrderMinAggregate';
  arrivalDate?: Maybe<Scalars['DateTime']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroCraftId?: Maybe<Scalars['String']>;
  mroCustomerId?: Maybe<Scalars['String']>;
  mroLocationId?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  mroWorkOrderCategoryId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  primaryConcern?: Maybe<Scalars['String']>;
  primaryContactId?: Maybe<Scalars['String']>;
  promiseDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workOrderNum?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderWhereInput>;
  isNot?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderPart = {
  __typename?: 'MroWorkOrderPart';
  _count: MroWorkOrderPartCount;
  approver?: Maybe<MroEmployeeProfile>;
  approverId?: Maybe<Scalars['String']>;
  costPrice?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroPart?: Maybe<MroPart>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartInventory?: Maybe<MroPartInventory>;
  mroPartInventoryId?: Maybe<Scalars['String']>;
  mroPartOrder?: Maybe<MroPartOrder>;
  mroPartOrderItem?: Maybe<Array<MroPartOrderItem>>;
  mroSerializedPart?: Maybe<MroSerializedPart>;
  mroSerializedPartId?: Maybe<Scalars['String']>;
  mroWorkOrder: MroWorkOrder;
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  neededDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  partDescription?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requester?: Maybe<MroEmployeeProfile>;
  requesterId?: Maybe<Scalars['String']>;
  shippingType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroWorkOrderPartVersion>>;
};

export type MroWorkOrderPartAvgAggregate = {
  __typename?: 'MroWorkOrderPartAvgAggregate';
  costPrice?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Float']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderPartCount = {
  __typename?: 'MroWorkOrderPartCount';
  mroPartOrderItem: Scalars['Int'];
  versions: Scalars['Int'];
};

export type MroWorkOrderPartCountAggregate = {
  __typename?: 'MroWorkOrderPartCountAggregate';
  _all: Scalars['Int'];
  approverId: Scalars['Int'];
  costPrice: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroPartId: Scalars['Int'];
  mroPartInventoryId: Scalars['Int'];
  mroSerializedPartId: Scalars['Int'];
  mroWorkOrderItemId: Scalars['Int'];
  neededDate: Scalars['Int'];
  notes: Scalars['Int'];
  partDescription: Scalars['Int'];
  partNumber: Scalars['Int'];
  quantity: Scalars['Int'];
  requesterId: Scalars['Int'];
  shippingType: Scalars['Int'];
  status: Scalars['Int'];
  unitPrice: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroWorkOrderPartCreateInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateManyApproverInput = {
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroPartInventoryId?: InputMaybe<Scalars['String']>;
  mroSerializedPartId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requesterId?: InputMaybe<Scalars['String']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartCreateManyApproverInputEnvelope = {
  data: Array<MroWorkOrderPartCreateManyApproverInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartCreateManyMroPartInput = {
  approverId?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartInventoryId?: InputMaybe<Scalars['String']>;
  mroSerializedPartId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requesterId?: InputMaybe<Scalars['String']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartCreateManyMroPartInputEnvelope = {
  data: Array<MroWorkOrderPartCreateManyMroPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartCreateManyMroPartInventoryInput = {
  approverId?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroSerializedPartId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requesterId?: InputMaybe<Scalars['String']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartCreateManyMroPartInventoryInputEnvelope = {
  data: Array<MroWorkOrderPartCreateManyMroPartInventoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartCreateManyMroSerializedPartInput = {
  approverId?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroPartInventoryId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requesterId?: InputMaybe<Scalars['String']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartCreateManyMroSerializedPartInputEnvelope = {
  data: Array<MroWorkOrderPartCreateManyMroSerializedPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartCreateManyMroWorkOrderItemInput = {
  approverId?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroPartInventoryId?: InputMaybe<Scalars['String']>;
  mroSerializedPartId?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requesterId?: InputMaybe<Scalars['String']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartCreateManyMroWorkOrderItemInputEnvelope = {
  data: Array<MroWorkOrderPartCreateManyMroWorkOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartCreateManyRequesterInput = {
  approverId?: InputMaybe<Scalars['String']>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartId?: InputMaybe<Scalars['String']>;
  mroPartInventoryId?: InputMaybe<Scalars['String']>;
  mroSerializedPartId?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartCreateManyRequesterInputEnvelope = {
  data: Array<MroWorkOrderPartCreateManyRequesterInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartCreateNestedManyWithoutApproverInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutApproverInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutApproverInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyApproverInputEnvelope>;
};

export type MroWorkOrderPartCreateNestedManyWithoutMroPartInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroPartInputEnvelope>;
};

export type MroWorkOrderPartCreateNestedManyWithoutMroPartInventoryInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroPartInventoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroPartInventoryInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroPartInventoryInputEnvelope>;
};

export type MroWorkOrderPartCreateNestedManyWithoutMroSerializedPartInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroSerializedPartInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroSerializedPartInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroSerializedPartInputEnvelope>;
};

export type MroWorkOrderPartCreateNestedManyWithoutMroWorkOrderItemInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroWorkOrderItemInputEnvelope>;
};

export type MroWorkOrderPartCreateNestedManyWithoutRequesterInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutRequesterInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutRequesterInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyRequesterInputEnvelope>;
};

export type MroWorkOrderPartCreateNestedOneWithoutMroPartOrderItemInput = {
  connect?: InputMaybe<MroWorkOrderPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderPartCreateOrConnectWithoutMroPartOrderItemInput>;
  create?: InputMaybe<MroWorkOrderPartCreateWithoutMroPartOrderItemInput>;
};

export type MroWorkOrderPartCreateOrConnectWithoutApproverInput = {
  create: MroWorkOrderPartCreateWithoutApproverInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateOrConnectWithoutMroPartInput = {
  create: MroWorkOrderPartCreateWithoutMroPartInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateOrConnectWithoutMroPartInventoryInput = {
  create: MroWorkOrderPartCreateWithoutMroPartInventoryInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateOrConnectWithoutMroPartOrderItemInput = {
  create: MroWorkOrderPartCreateWithoutMroPartOrderItemInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateOrConnectWithoutMroSerializedPartInput = {
  create: MroWorkOrderPartCreateWithoutMroSerializedPartInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateOrConnectWithoutMroWorkOrderItemInput = {
  create: MroWorkOrderPartCreateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateOrConnectWithoutRequesterInput = {
  create: MroWorkOrderPartCreateWithoutRequesterInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartCreateWithoutApproverInput = {
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateWithoutMroPartInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateWithoutMroPartInventoryInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateWithoutMroPartOrderItemInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateWithoutMroSerializedPartInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateWithoutMroWorkOrderItemInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutRequestedPartsInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartCreateWithoutRequesterInput = {
  approver?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutApproverPartsInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemCreateNestedManyWithoutMroWorkOrderPartInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartCreateNestedOneWithoutMroWorkOrderPartsInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderPartsInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput>;
};

export type MroWorkOrderPartListRelationFilter = {
  every?: InputMaybe<MroWorkOrderPartWhereInput>;
  none?: InputMaybe<MroWorkOrderPartWhereInput>;
  some?: InputMaybe<MroWorkOrderPartWhereInput>;
};

export type MroWorkOrderPartMaxAggregate = {
  __typename?: 'MroWorkOrderPartMaxAggregate';
  approverId?: Maybe<Scalars['String']>;
  costPrice?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartInventoryId?: Maybe<Scalars['String']>;
  mroSerializedPartId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  neededDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  partDescription?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requesterId?: Maybe<Scalars['String']>;
  shippingType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartMinAggregate = {
  __typename?: 'MroWorkOrderPartMinAggregate';
  approverId?: Maybe<Scalars['String']>;
  costPrice?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroPartId?: Maybe<Scalars['String']>;
  mroPartInventoryId?: Maybe<Scalars['String']>;
  mroSerializedPartId?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  neededDate?: Maybe<Scalars['DateTime']>;
  notes?: Maybe<Scalars['String']>;
  partDescription?: Maybe<Scalars['String']>;
  partNumber?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  requesterId?: Maybe<Scalars['String']>;
  shippingType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderPartWhereInput>;
  isNot?: InputMaybe<MroWorkOrderPartWhereInput>;
};

export type MroWorkOrderPartScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  approverId?: InputMaybe<StringNullableFilter>;
  costPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartInventoryId?: InputMaybe<StringNullableFilter>;
  mroSerializedPartId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  neededDate?: InputMaybe<DateTimeNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partDescription?: InputMaybe<StringNullableFilter>;
  partNumber?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  requesterId?: InputMaybe<StringNullableFilter>;
  shippingType?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroWorkOrderPartSumAggregate = {
  __typename?: 'MroWorkOrderPartSumAggregate';
  costPrice?: Maybe<Scalars['Decimal']>;
  quantity?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Decimal']>;
};

export type MroWorkOrderPartUpdateInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateManyMutationInput = {
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderPartUpdateManyWithWhereWithoutApproverInput = {
  data: MroWorkOrderPartUpdateManyMutationInput;
  where: MroWorkOrderPartScalarWhereInput;
};

export type MroWorkOrderPartUpdateManyWithWhereWithoutMroPartInput = {
  data: MroWorkOrderPartUpdateManyMutationInput;
  where: MroWorkOrderPartScalarWhereInput;
};

export type MroWorkOrderPartUpdateManyWithWhereWithoutMroPartInventoryInput = {
  data: MroWorkOrderPartUpdateManyMutationInput;
  where: MroWorkOrderPartScalarWhereInput;
};

export type MroWorkOrderPartUpdateManyWithWhereWithoutMroSerializedPartInput = {
  data: MroWorkOrderPartUpdateManyMutationInput;
  where: MroWorkOrderPartScalarWhereInput;
};

export type MroWorkOrderPartUpdateManyWithWhereWithoutMroWorkOrderItemInput = {
  data: MroWorkOrderPartUpdateManyMutationInput;
  where: MroWorkOrderPartScalarWhereInput;
};

export type MroWorkOrderPartUpdateManyWithWhereWithoutRequesterInput = {
  data: MroWorkOrderPartUpdateManyMutationInput;
  where: MroWorkOrderPartScalarWhereInput;
};

export type MroWorkOrderPartUpdateManyWithoutApproverNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutApproverInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutApproverInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyApproverInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartUpdateWithWhereUniqueWithoutApproverInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartUpdateManyWithWhereWithoutApproverInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartUpsertWithWhereUniqueWithoutApproverInput>>;
};

export type MroWorkOrderPartUpdateManyWithoutMroPartInventoryNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroPartInventoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroPartInventoryInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroPartInventoryInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartUpdateWithWhereUniqueWithoutMroPartInventoryInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartUpdateManyWithWhereWithoutMroPartInventoryInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartUpsertWithWhereUniqueWithoutMroPartInventoryInput>>;
};

export type MroWorkOrderPartUpdateManyWithoutMroPartNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroPartInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroPartInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroPartInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartUpdateWithWhereUniqueWithoutMroPartInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartUpdateManyWithWhereWithoutMroPartInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartUpsertWithWhereUniqueWithoutMroPartInput>>;
};

export type MroWorkOrderPartUpdateManyWithoutMroSerializedPartNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroSerializedPartInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroSerializedPartInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroSerializedPartInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartUpdateWithWhereUniqueWithoutMroSerializedPartInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartUpdateManyWithWhereWithoutMroSerializedPartInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartUpsertWithWhereUniqueWithoutMroSerializedPartInput>>;
};

export type MroWorkOrderPartUpdateManyWithoutMroWorkOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyMroWorkOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartUpdateWithWhereUniqueWithoutMroWorkOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartUpdateManyWithWhereWithoutMroWorkOrderItemInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartUpsertWithWhereUniqueWithoutMroWorkOrderItemInput>>;
};

export type MroWorkOrderPartUpdateManyWithoutRequesterNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartCreateOrConnectWithoutRequesterInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartCreateWithoutRequesterInput>>;
  createMany?: InputMaybe<MroWorkOrderPartCreateManyRequesterInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartUpdateWithWhereUniqueWithoutRequesterInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartUpdateManyWithWhereWithoutRequesterInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartUpsertWithWhereUniqueWithoutRequesterInput>>;
};

export type MroWorkOrderPartUpdateOneWithoutMroPartOrderItemNestedInput = {
  connect?: InputMaybe<MroWorkOrderPartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderPartCreateOrConnectWithoutMroPartOrderItemInput>;
  create?: InputMaybe<MroWorkOrderPartCreateWithoutMroPartOrderItemInput>;
  delete?: InputMaybe<MroWorkOrderPartWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderPartWhereInput>;
  update?: InputMaybe<MroWorkOrderPartUpdateToOneWithWhereWithoutMroPartOrderItemInput>;
  upsert?: InputMaybe<MroWorkOrderPartUpsertWithoutMroPartOrderItemInput>;
};

export type MroWorkOrderPartUpdateToOneWithWhereWithoutMroPartOrderItemInput = {
  data: MroWorkOrderPartUpdateWithoutMroPartOrderItemInput;
  where?: InputMaybe<MroWorkOrderPartWhereInput>;
};

export type MroWorkOrderPartUpdateWithWhereUniqueWithoutApproverInput = {
  data: MroWorkOrderPartUpdateWithoutApproverInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpdateWithWhereUniqueWithoutMroPartInput = {
  data: MroWorkOrderPartUpdateWithoutMroPartInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpdateWithWhereUniqueWithoutMroPartInventoryInput = {
  data: MroWorkOrderPartUpdateWithoutMroPartInventoryInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpdateWithWhereUniqueWithoutMroSerializedPartInput = {
  data: MroWorkOrderPartUpdateWithoutMroSerializedPartInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpdateWithWhereUniqueWithoutMroWorkOrderItemInput = {
  data: MroWorkOrderPartUpdateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpdateWithWhereUniqueWithoutRequesterInput = {
  data: MroWorkOrderPartUpdateWithoutRequesterInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpdateWithoutApproverInput = {
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateWithoutMroPartInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateWithoutMroPartInventoryInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateWithoutMroPartOrderItemInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateWithoutMroSerializedPartInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateWithoutMroWorkOrderItemInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  requester?: InputMaybe<MroEmployeeProfileUpdateOneWithoutRequestedPartsNestedInput>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpdateWithoutRequesterInput = {
  approver?: InputMaybe<MroEmployeeProfileUpdateOneWithoutApproverPartsNestedInput>;
  costPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartInventory?: InputMaybe<MroPartInventoryUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemUpdateManyWithoutMroWorkOrderPartNestedInput>;
  mroSerializedPart?: InputMaybe<MroSerializedPartUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderPartsNestedInput>;
  neededDate?: InputMaybe<Scalars['DateTime']>;
  notes?: InputMaybe<Scalars['String']>;
  partDescription?: InputMaybe<Scalars['String']>;
  partNumber?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shippingType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  unitPrice?: InputMaybe<Scalars['Decimal']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput>;
};

export type MroWorkOrderPartUpsertWithWhereUniqueWithoutApproverInput = {
  create: MroWorkOrderPartCreateWithoutApproverInput;
  update: MroWorkOrderPartUpdateWithoutApproverInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpsertWithWhereUniqueWithoutMroPartInput = {
  create: MroWorkOrderPartCreateWithoutMroPartInput;
  update: MroWorkOrderPartUpdateWithoutMroPartInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpsertWithWhereUniqueWithoutMroPartInventoryInput = {
  create: MroWorkOrderPartCreateWithoutMroPartInventoryInput;
  update: MroWorkOrderPartUpdateWithoutMroPartInventoryInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpsertWithWhereUniqueWithoutMroSerializedPartInput = {
  create: MroWorkOrderPartCreateWithoutMroSerializedPartInput;
  update: MroWorkOrderPartUpdateWithoutMroSerializedPartInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpsertWithWhereUniqueWithoutMroWorkOrderItemInput = {
  create: MroWorkOrderPartCreateWithoutMroWorkOrderItemInput;
  update: MroWorkOrderPartUpdateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpsertWithWhereUniqueWithoutRequesterInput = {
  create: MroWorkOrderPartCreateWithoutRequesterInput;
  update: MroWorkOrderPartUpdateWithoutRequesterInput;
  where: MroWorkOrderPartWhereUniqueInput;
};

export type MroWorkOrderPartUpsertWithoutMroPartOrderItemInput = {
  create: MroWorkOrderPartCreateWithoutMroPartOrderItemInput;
  update: MroWorkOrderPartUpdateWithoutMroPartOrderItemInput;
  where?: InputMaybe<MroWorkOrderPartWhereInput>;
};

export type MroWorkOrderPartVersion = {
  __typename?: 'MroWorkOrderPartVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrderPart?: Maybe<MroWorkOrderPart>;
  mroWorkOrderPartId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderPartVersionCreateManyMroWorkOrderPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderPartVersionCreateManyMroWorkOrderPartInputEnvelope = {
  data: Array<MroWorkOrderPartVersionCreateManyMroWorkOrderPartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderPartVersionCreateNestedManyWithoutMroWorkOrderPartInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartVersionCreateOrConnectWithoutMroWorkOrderPartInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartVersionCreateWithoutMroWorkOrderPartInput>>;
  createMany?: InputMaybe<MroWorkOrderPartVersionCreateManyMroWorkOrderPartInputEnvelope>;
};

export type MroWorkOrderPartVersionCreateOrConnectWithoutMroWorkOrderPartInput = {
  create: MroWorkOrderPartVersionCreateWithoutMroWorkOrderPartInput;
  where: MroWorkOrderPartVersionWhereUniqueInput;
};

export type MroWorkOrderPartVersionCreateWithoutMroWorkOrderPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderPartVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderPartVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderPartVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderPartVersionWhereInput>;
};

export type MroWorkOrderPartVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderPartVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderPartVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderPartVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderPartVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderPartVersionUpdateManyWithWhereWithoutMroWorkOrderPartInput = {
  data: MroWorkOrderPartVersionUpdateManyMutationInput;
  where: MroWorkOrderPartVersionScalarWhereInput;
};

export type MroWorkOrderPartVersionUpdateManyWithoutMroWorkOrderPartNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderPartVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderPartVersionCreateOrConnectWithoutMroWorkOrderPartInput>>;
  create?: InputMaybe<Array<MroWorkOrderPartVersionCreateWithoutMroWorkOrderPartInput>>;
  createMany?: InputMaybe<MroWorkOrderPartVersionCreateManyMroWorkOrderPartInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderPartVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderPartVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderPartVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderPartVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderPartVersionUpdateWithWhereUniqueWithoutMroWorkOrderPartInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderPartVersionUpdateManyWithWhereWithoutMroWorkOrderPartInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderPartVersionUpsertWithWhereUniqueWithoutMroWorkOrderPartInput>>;
};

export type MroWorkOrderPartVersionUpdateWithWhereUniqueWithoutMroWorkOrderPartInput = {
  data: MroWorkOrderPartVersionUpdateWithoutMroWorkOrderPartInput;
  where: MroWorkOrderPartVersionWhereUniqueInput;
};

export type MroWorkOrderPartVersionUpdateWithoutMroWorkOrderPartInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderPartVersionUpsertWithWhereUniqueWithoutMroWorkOrderPartInput = {
  create: MroWorkOrderPartVersionCreateWithoutMroWorkOrderPartInput;
  update: MroWorkOrderPartVersionUpdateWithoutMroWorkOrderPartInput;
  where: MroWorkOrderPartVersionWhereUniqueInput;
};

export type MroWorkOrderPartVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderPartVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderPartVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderPartVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartNullableScalarRelationFilter>;
  mroWorkOrderPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderPartVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderPartVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderPartVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderPartVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrderPart?: InputMaybe<MroWorkOrderPartNullableScalarRelationFilter>;
  mroWorkOrderPartId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderPartWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderPartWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderPartWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderPartWhereInput>>;
  approver?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  approverId?: InputMaybe<StringNullableFilter>;
  costPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartInventory?: InputMaybe<MroPartInventoryNullableScalarRelationFilter>;
  mroPartInventoryId?: InputMaybe<StringNullableFilter>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemListRelationFilter>;
  mroSerializedPart?: InputMaybe<MroSerializedPartNullableScalarRelationFilter>;
  mroSerializedPartId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  neededDate?: InputMaybe<DateTimeNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partDescription?: InputMaybe<StringNullableFilter>;
  partNumber?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  requester?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  requesterId?: InputMaybe<StringNullableFilter>;
  shippingType?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderPartVersionListRelationFilter>;
};

export type MroWorkOrderPartWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderPartWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderPartWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderPartWhereInput>>;
  approver?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  approverId?: InputMaybe<StringNullableFilter>;
  costPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroPart?: InputMaybe<MroPartNullableScalarRelationFilter>;
  mroPartId?: InputMaybe<StringNullableFilter>;
  mroPartInventory?: InputMaybe<MroPartInventoryNullableScalarRelationFilter>;
  mroPartInventoryId?: InputMaybe<StringNullableFilter>;
  mroPartOrderItem?: InputMaybe<MroPartOrderItemListRelationFilter>;
  mroSerializedPart?: InputMaybe<MroSerializedPartNullableScalarRelationFilter>;
  mroSerializedPartId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  neededDate?: InputMaybe<DateTimeNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  partDescription?: InputMaybe<StringNullableFilter>;
  partNumber?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  requester?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  requesterId?: InputMaybe<StringNullableFilter>;
  shippingType?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  unitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderPartVersionListRelationFilter>;
};

export type MroWorkOrderScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderWhereInput>;
  isNot?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  arrivalDate?: InputMaybe<DateTimeNullableFilter>;
  completionDate?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroLocationId?: InputMaybe<StringNullableFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderCategoryId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  primaryConcern?: InputMaybe<StringNullableFilter>;
  primaryContactId?: InputMaybe<StringNullableFilter>;
  promiseDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  workOrderNum?: InputMaybe<IntNullableFilter>;
};

export type MroWorkOrderSignoff = {
  __typename?: 'MroWorkOrderSignoff';
  _count: MroWorkOrderSignoffCount;
  assignee?: Maybe<MroEmployeeProfile>;
  assigneeId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  status: SignoffStatus;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<MroWorkOrderSignoffVersion>>;
};

export type MroWorkOrderSignoffCount = {
  __typename?: 'MroWorkOrderSignoffCount';
  versions: Scalars['Int'];
};

export type MroWorkOrderSignoffCountAggregate = {
  __typename?: 'MroWorkOrderSignoffCountAggregate';
  _all: Scalars['Int'];
  assigneeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroWorkOrderItemId: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroWorkOrderSignoffCreateInput = {
  assignee?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroWorkOrderSignoffsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderSignoffsInput>;
  status: SignoffStatus;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionCreateNestedManyWithoutMroWorkOrderSignoffInput>;
};

export type MroWorkOrderSignoffCreateManyAssigneeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItemId?: InputMaybe<Scalars['String']>;
  status: SignoffStatus;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderSignoffCreateManyAssigneeInputEnvelope = {
  data: Array<MroWorkOrderSignoffCreateManyAssigneeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderSignoffCreateManyMroWorkOrderItemInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  status: SignoffStatus;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderSignoffCreateManyMroWorkOrderItemInputEnvelope = {
  data: Array<MroWorkOrderSignoffCreateManyMroWorkOrderItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderSignoffCreateNestedManyWithoutAssigneeInput = {
  connect?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderSignoffCreateOrConnectWithoutAssigneeInput>>;
  create?: InputMaybe<Array<MroWorkOrderSignoffCreateWithoutAssigneeInput>>;
  createMany?: InputMaybe<MroWorkOrderSignoffCreateManyAssigneeInputEnvelope>;
};

export type MroWorkOrderSignoffCreateNestedManyWithoutMroWorkOrderItemInput = {
  connect?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderSignoffCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroWorkOrderSignoffCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroWorkOrderSignoffCreateManyMroWorkOrderItemInputEnvelope>;
};

export type MroWorkOrderSignoffCreateOrConnectWithoutAssigneeInput = {
  create: MroWorkOrderSignoffCreateWithoutAssigneeInput;
  where: MroWorkOrderSignoffWhereUniqueInput;
};

export type MroWorkOrderSignoffCreateOrConnectWithoutMroWorkOrderItemInput = {
  create: MroWorkOrderSignoffCreateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderSignoffWhereUniqueInput;
};

export type MroWorkOrderSignoffCreateWithoutAssigneeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemCreateNestedOneWithoutMroWorkOrderSignoffsInput>;
  status: SignoffStatus;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionCreateNestedManyWithoutMroWorkOrderSignoffInput>;
};

export type MroWorkOrderSignoffCreateWithoutMroWorkOrderItemInput = {
  assignee?: InputMaybe<MroEmployeeProfileCreateNestedOneWithoutMroWorkOrderSignoffsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  status: SignoffStatus;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionCreateNestedManyWithoutMroWorkOrderSignoffInput>;
};

export type MroWorkOrderSignoffListRelationFilter = {
  every?: InputMaybe<MroWorkOrderSignoffWhereInput>;
  none?: InputMaybe<MroWorkOrderSignoffWhereInput>;
  some?: InputMaybe<MroWorkOrderSignoffWhereInput>;
};

export type MroWorkOrderSignoffMaxAggregate = {
  __typename?: 'MroWorkOrderSignoffMaxAggregate';
  assigneeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  status?: Maybe<SignoffStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderSignoffMinAggregate = {
  __typename?: 'MroWorkOrderSignoffMinAggregate';
  assigneeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroWorkOrderItemId?: Maybe<Scalars['String']>;
  status?: Maybe<SignoffStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderSignoffNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderSignoffWhereInput>;
  isNot?: InputMaybe<MroWorkOrderSignoffWhereInput>;
};

export type MroWorkOrderSignoffScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderSignoffScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderSignoffScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderSignoffScalarWhereInput>>;
  assigneeId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumSignoffStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type MroWorkOrderSignoffUpdateInput = {
  assignee?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroWorkOrderSignoffsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderSignoffsNestedInput>;
  status?: InputMaybe<SignoffStatus>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionUpdateManyWithoutMroWorkOrderSignoffNestedInput>;
};

export type MroWorkOrderSignoffUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SignoffStatus>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderSignoffUpdateManyWithWhereWithoutAssigneeInput = {
  data: MroWorkOrderSignoffUpdateManyMutationInput;
  where: MroWorkOrderSignoffScalarWhereInput;
};

export type MroWorkOrderSignoffUpdateManyWithWhereWithoutMroWorkOrderItemInput = {
  data: MroWorkOrderSignoffUpdateManyMutationInput;
  where: MroWorkOrderSignoffScalarWhereInput;
};

export type MroWorkOrderSignoffUpdateManyWithoutAssigneeNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderSignoffCreateOrConnectWithoutAssigneeInput>>;
  create?: InputMaybe<Array<MroWorkOrderSignoffCreateWithoutAssigneeInput>>;
  createMany?: InputMaybe<MroWorkOrderSignoffCreateManyAssigneeInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderSignoffScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderSignoffUpdateWithWhereUniqueWithoutAssigneeInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderSignoffUpdateManyWithWhereWithoutAssigneeInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderSignoffUpsertWithWhereUniqueWithoutAssigneeInput>>;
};

export type MroWorkOrderSignoffUpdateManyWithoutMroWorkOrderItemNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderSignoffCreateOrConnectWithoutMroWorkOrderItemInput>>;
  create?: InputMaybe<Array<MroWorkOrderSignoffCreateWithoutMroWorkOrderItemInput>>;
  createMany?: InputMaybe<MroWorkOrderSignoffCreateManyMroWorkOrderItemInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderSignoffScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderSignoffWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderSignoffUpdateWithWhereUniqueWithoutMroWorkOrderItemInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderSignoffUpdateManyWithWhereWithoutMroWorkOrderItemInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderSignoffUpsertWithWhereUniqueWithoutMroWorkOrderItemInput>>;
};

export type MroWorkOrderSignoffUpdateWithWhereUniqueWithoutAssigneeInput = {
  data: MroWorkOrderSignoffUpdateWithoutAssigneeInput;
  where: MroWorkOrderSignoffWhereUniqueInput;
};

export type MroWorkOrderSignoffUpdateWithWhereUniqueWithoutMroWorkOrderItemInput = {
  data: MroWorkOrderSignoffUpdateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderSignoffWhereUniqueInput;
};

export type MroWorkOrderSignoffUpdateWithoutAssigneeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemUpdateOneWithoutMroWorkOrderSignoffsNestedInput>;
  status?: InputMaybe<SignoffStatus>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionUpdateManyWithoutMroWorkOrderSignoffNestedInput>;
};

export type MroWorkOrderSignoffUpdateWithoutMroWorkOrderItemInput = {
  assignee?: InputMaybe<MroEmployeeProfileUpdateOneWithoutMroWorkOrderSignoffsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<SignoffStatus>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionUpdateManyWithoutMroWorkOrderSignoffNestedInput>;
};

export type MroWorkOrderSignoffUpsertWithWhereUniqueWithoutAssigneeInput = {
  create: MroWorkOrderSignoffCreateWithoutAssigneeInput;
  update: MroWorkOrderSignoffUpdateWithoutAssigneeInput;
  where: MroWorkOrderSignoffWhereUniqueInput;
};

export type MroWorkOrderSignoffUpsertWithWhereUniqueWithoutMroWorkOrderItemInput = {
  create: MroWorkOrderSignoffCreateWithoutMroWorkOrderItemInput;
  update: MroWorkOrderSignoffUpdateWithoutMroWorkOrderItemInput;
  where: MroWorkOrderSignoffWhereUniqueInput;
};

export type MroWorkOrderSignoffVersion = {
  __typename?: 'MroWorkOrderSignoffVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrderSignoff?: Maybe<MroWorkOrderSignoff>;
  mroWorkOrderSignoffId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderSignoffVersionCreateManyMroWorkOrderSignoffInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderSignoffVersionCreateManyMroWorkOrderSignoffInputEnvelope = {
  data: Array<MroWorkOrderSignoffVersionCreateManyMroWorkOrderSignoffInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderSignoffVersionCreateNestedManyWithoutMroWorkOrderSignoffInput = {
  connect?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderSignoffVersionCreateOrConnectWithoutMroWorkOrderSignoffInput>>;
  create?: InputMaybe<Array<MroWorkOrderSignoffVersionCreateWithoutMroWorkOrderSignoffInput>>;
  createMany?: InputMaybe<MroWorkOrderSignoffVersionCreateManyMroWorkOrderSignoffInputEnvelope>;
};

export type MroWorkOrderSignoffVersionCreateOrConnectWithoutMroWorkOrderSignoffInput = {
  create: MroWorkOrderSignoffVersionCreateWithoutMroWorkOrderSignoffInput;
  where: MroWorkOrderSignoffVersionWhereUniqueInput;
};

export type MroWorkOrderSignoffVersionCreateWithoutMroWorkOrderSignoffInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderSignoffVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderSignoffVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderSignoffVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderSignoffVersionWhereInput>;
};

export type MroWorkOrderSignoffVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderSignoffVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderSignoffVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderSignoffVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderSignoffId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderSignoffVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderSignoffVersionUpdateManyWithWhereWithoutMroWorkOrderSignoffInput = {
  data: MroWorkOrderSignoffVersionUpdateManyMutationInput;
  where: MroWorkOrderSignoffVersionScalarWhereInput;
};

export type MroWorkOrderSignoffVersionUpdateManyWithoutMroWorkOrderSignoffNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderSignoffVersionCreateOrConnectWithoutMroWorkOrderSignoffInput>>;
  create?: InputMaybe<Array<MroWorkOrderSignoffVersionCreateWithoutMroWorkOrderSignoffInput>>;
  createMany?: InputMaybe<MroWorkOrderSignoffVersionCreateManyMroWorkOrderSignoffInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderSignoffVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderSignoffVersionUpdateWithWhereUniqueWithoutMroWorkOrderSignoffInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderSignoffVersionUpdateManyWithWhereWithoutMroWorkOrderSignoffInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderSignoffVersionUpsertWithWhereUniqueWithoutMroWorkOrderSignoffInput>>;
};

export type MroWorkOrderSignoffVersionUpdateWithWhereUniqueWithoutMroWorkOrderSignoffInput = {
  data: MroWorkOrderSignoffVersionUpdateWithoutMroWorkOrderSignoffInput;
  where: MroWorkOrderSignoffVersionWhereUniqueInput;
};

export type MroWorkOrderSignoffVersionUpdateWithoutMroWorkOrderSignoffInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderSignoffVersionUpsertWithWhereUniqueWithoutMroWorkOrderSignoffInput = {
  create: MroWorkOrderSignoffVersionCreateWithoutMroWorkOrderSignoffInput;
  update: MroWorkOrderSignoffVersionUpdateWithoutMroWorkOrderSignoffInput;
  where: MroWorkOrderSignoffVersionWhereUniqueInput;
};

export type MroWorkOrderSignoffVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderSignoff?: InputMaybe<MroWorkOrderSignoffNullableScalarRelationFilter>;
  mroWorkOrderSignoffId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderSignoffVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderSignoffVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrderSignoff?: InputMaybe<MroWorkOrderSignoffNullableScalarRelationFilter>;
  mroWorkOrderSignoffId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderSignoffWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderSignoffWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderSignoffWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderSignoffWhereInput>>;
  assignee?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  assigneeId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumSignoffStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionListRelationFilter>;
};

export type MroWorkOrderSignoffWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderSignoffWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderSignoffWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderSignoffWhereInput>>;
  assignee?: InputMaybe<MroEmployeeProfileNullableScalarRelationFilter>;
  assigneeId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroWorkOrderItem?: InputMaybe<MroWorkOrderItemNullableScalarRelationFilter>;
  mroWorkOrderItemId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumSignoffStatusFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderSignoffVersionListRelationFilter>;
};

export type MroWorkOrderSumAggregate = {
  __typename?: 'MroWorkOrderSumAggregate';
  workOrderNum?: Maybe<Scalars['Int']>;
};

export type MroWorkOrderTemplate = {
  __typename?: 'MroWorkOrderTemplate';
  _count: MroWorkOrderTemplateCount;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  templateData?: Maybe<Scalars['JSON']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  versions?: Maybe<Array<MroWorkOrderTemplateVersion>>;
};

export type MroWorkOrderTemplateCount = {
  __typename?: 'MroWorkOrderTemplateCount';
  versions: Scalars['Int'];
};

export type MroWorkOrderTemplateCountAggregate = {
  __typename?: 'MroWorkOrderTemplateCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  mroOrganizationId: Scalars['Int'];
  templateData: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type MroWorkOrderTemplateCreateManyMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  templateData?: InputMaybe<Scalars['JSON']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderTemplateCreateManyMroOrganizationInputEnvelope = {
  data: Array<MroWorkOrderTemplateCreateManyMroOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderTemplateCreateNestedManyWithoutMroOrganizationInput = {
  connect?: InputMaybe<Array<MroWorkOrderTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderTemplateCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderTemplateCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderTemplateCreateManyMroOrganizationInputEnvelope>;
};

export type MroWorkOrderTemplateCreateOrConnectWithoutMroOrganizationInput = {
  create: MroWorkOrderTemplateCreateWithoutMroOrganizationInput;
  where: MroWorkOrderTemplateWhereUniqueInput;
};

export type MroWorkOrderTemplateCreateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  templateData?: InputMaybe<Scalars['JSON']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderTemplateVersionCreateNestedManyWithoutMroWorkOrderTemplateInput>;
};

export type MroWorkOrderTemplateListRelationFilter = {
  every?: InputMaybe<MroWorkOrderTemplateWhereInput>;
  none?: InputMaybe<MroWorkOrderTemplateWhereInput>;
  some?: InputMaybe<MroWorkOrderTemplateWhereInput>;
};

export type MroWorkOrderTemplateMaxAggregate = {
  __typename?: 'MroWorkOrderTemplateMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderTemplateMinAggregate = {
  __typename?: 'MroWorkOrderTemplateMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mroOrganizationId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MroWorkOrderTemplateNullableScalarRelationFilter = {
  is?: InputMaybe<MroWorkOrderTemplateWhereInput>;
  isNot?: InputMaybe<MroWorkOrderTemplateWhereInput>;
};

export type MroWorkOrderTemplateScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderTemplateScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderTemplateScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderTemplateScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  templateData?: InputMaybe<JsonNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MroWorkOrderTemplateUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrderTemplateNestedInput>;
  templateData?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderTemplateVersionUpdateManyWithoutMroWorkOrderTemplateNestedInput>;
};

export type MroWorkOrderTemplateUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  templateData?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type MroWorkOrderTemplateUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroWorkOrderTemplateUpdateManyMutationInput;
  where: MroWorkOrderTemplateScalarWhereInput;
};

export type MroWorkOrderTemplateUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderTemplateWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderTemplateCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderTemplateCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderTemplateCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderTemplateWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderTemplateScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderTemplateWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderTemplateWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderTemplateUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderTemplateUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderTemplateUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroWorkOrderTemplateUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroWorkOrderTemplateUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderTemplateWhereUniqueInput;
};

export type MroWorkOrderTemplateUpdateWithoutMroOrganizationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  templateData?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderTemplateVersionUpdateManyWithoutMroWorkOrderTemplateNestedInput>;
};

export type MroWorkOrderTemplateUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroWorkOrderTemplateCreateWithoutMroOrganizationInput;
  update: MroWorkOrderTemplateUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderTemplateWhereUniqueInput;
};

export type MroWorkOrderTemplateVersion = {
  __typename?: 'MroWorkOrderTemplateVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrderTemplate?: Maybe<MroWorkOrderTemplate>;
  mroWorkOrderTemplateId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderTemplateVersionCreateManyMroWorkOrderTemplateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderTemplateVersionCreateManyMroWorkOrderTemplateInputEnvelope = {
  data: Array<MroWorkOrderTemplateVersionCreateManyMroWorkOrderTemplateInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderTemplateVersionCreateNestedManyWithoutMroWorkOrderTemplateInput = {
  connect?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderTemplateVersionCreateOrConnectWithoutMroWorkOrderTemplateInput>>;
  create?: InputMaybe<Array<MroWorkOrderTemplateVersionCreateWithoutMroWorkOrderTemplateInput>>;
  createMany?: InputMaybe<MroWorkOrderTemplateVersionCreateManyMroWorkOrderTemplateInputEnvelope>;
};

export type MroWorkOrderTemplateVersionCreateOrConnectWithoutMroWorkOrderTemplateInput = {
  create: MroWorkOrderTemplateVersionCreateWithoutMroWorkOrderTemplateInput;
  where: MroWorkOrderTemplateVersionWhereUniqueInput;
};

export type MroWorkOrderTemplateVersionCreateWithoutMroWorkOrderTemplateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderTemplateVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderTemplateVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderTemplateVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderTemplateVersionWhereInput>;
};

export type MroWorkOrderTemplateVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderTemplateVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderTemplateVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderTemplateVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderTemplateId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderTemplateVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderTemplateVersionUpdateManyWithWhereWithoutMroWorkOrderTemplateInput = {
  data: MroWorkOrderTemplateVersionUpdateManyMutationInput;
  where: MroWorkOrderTemplateVersionScalarWhereInput;
};

export type MroWorkOrderTemplateVersionUpdateManyWithoutMroWorkOrderTemplateNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderTemplateVersionCreateOrConnectWithoutMroWorkOrderTemplateInput>>;
  create?: InputMaybe<Array<MroWorkOrderTemplateVersionCreateWithoutMroWorkOrderTemplateInput>>;
  createMany?: InputMaybe<MroWorkOrderTemplateVersionCreateManyMroWorkOrderTemplateInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderTemplateVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderTemplateVersionUpdateWithWhereUniqueWithoutMroWorkOrderTemplateInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderTemplateVersionUpdateManyWithWhereWithoutMroWorkOrderTemplateInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderTemplateVersionUpsertWithWhereUniqueWithoutMroWorkOrderTemplateInput>>;
};

export type MroWorkOrderTemplateVersionUpdateWithWhereUniqueWithoutMroWorkOrderTemplateInput = {
  data: MroWorkOrderTemplateVersionUpdateWithoutMroWorkOrderTemplateInput;
  where: MroWorkOrderTemplateVersionWhereUniqueInput;
};

export type MroWorkOrderTemplateVersionUpdateWithoutMroWorkOrderTemplateInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderTemplateVersionUpsertWithWhereUniqueWithoutMroWorkOrderTemplateInput = {
  create: MroWorkOrderTemplateVersionCreateWithoutMroWorkOrderTemplateInput;
  update: MroWorkOrderTemplateVersionUpdateWithoutMroWorkOrderTemplateInput;
  where: MroWorkOrderTemplateVersionWhereUniqueInput;
};

export type MroWorkOrderTemplateVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateNullableScalarRelationFilter>;
  mroWorkOrderTemplateId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderTemplateVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderTemplateVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrderTemplate?: InputMaybe<MroWorkOrderTemplateNullableScalarRelationFilter>;
  mroWorkOrderTemplateId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderTemplateWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderTemplateWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderTemplateWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderTemplateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  templateData?: InputMaybe<JsonNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<MroWorkOrderTemplateVersionListRelationFilter>;
};

export type MroWorkOrderTemplateWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderTemplateWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderTemplateWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderTemplateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  templateData?: InputMaybe<JsonNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  versions?: InputMaybe<MroWorkOrderTemplateVersionListRelationFilter>;
};

export type MroWorkOrderUpdateInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateManyMutationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateManyWithWhereWithoutAssigneesInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithWhereWithoutMroCraftInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithWhereWithoutMroCustomerInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithWhereWithoutMroLocationInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithWhereWithoutMroOrganizationInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithWhereWithoutMroWorkOrderCategoryInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithWhereWithoutPrimaryContactInput = {
  data: MroWorkOrderUpdateManyMutationInput;
  where: MroWorkOrderScalarWhereInput;
};

export type MroWorkOrderUpdateManyWithoutAssigneesNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutAssigneesInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutAssigneesInput>>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutAssigneesInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutAssigneesInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutAssigneesInput>>;
};

export type MroWorkOrderUpdateManyWithoutMroCraftNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroCraftInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroCraftInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroCraftInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutMroCraftInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutMroCraftInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutMroCraftInput>>;
};

export type MroWorkOrderUpdateManyWithoutMroCustomerNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroCustomerInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroCustomerInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroCustomerInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutMroCustomerInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutMroCustomerInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutMroCustomerInput>>;
};

export type MroWorkOrderUpdateManyWithoutMroLocationNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroLocationInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroLocationInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroLocationInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutMroLocationInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutMroLocationInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutMroLocationInput>>;
};

export type MroWorkOrderUpdateManyWithoutMroOrganizationNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroOrganizationInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroOrganizationInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutMroOrganizationInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutMroOrganizationInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutMroOrganizationInput>>;
};

export type MroWorkOrderUpdateManyWithoutMroWorkOrderCategoryNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutMroWorkOrderCategoryInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutMroWorkOrderCategoryInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyMroWorkOrderCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutMroWorkOrderCategoryInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutMroWorkOrderCategoryInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutMroWorkOrderCategoryInput>>;
};

export type MroWorkOrderUpdateManyWithoutPrimaryContactNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderCreateOrConnectWithoutPrimaryContactInput>>;
  create?: InputMaybe<Array<MroWorkOrderCreateWithoutPrimaryContactInput>>;
  createMany?: InputMaybe<MroWorkOrderCreateManyPrimaryContactInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderUpdateWithWhereUniqueWithoutPrimaryContactInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderUpdateManyWithWhereWithoutPrimaryContactInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderUpsertWithWhereUniqueWithoutPrimaryContactInput>>;
};

export type MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderBillingItemsNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroWorkOrderBillingItemsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroWorkOrderBillingItemsInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroWorkOrderBillingItemsInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroWorkOrderBillingItemsInput>;
};

export type MroWorkOrderUpdateOneRequiredWithoutMroWorkOrderItemsNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroWorkOrderItemsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroWorkOrderItemsInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroWorkOrderItemsInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroWorkOrderItemsInput>;
};

export type MroWorkOrderUpdateOneWithoutCraftServiceRequestsNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutCraftServiceRequestsInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutCraftServiceRequestsInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutCraftServiceRequestsInput>;
};

export type MroWorkOrderUpdateOneWithoutItemCategoriesNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutItemCategoriesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutItemCategoriesInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutItemCategoriesInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutItemCategoriesInput>;
};

export type MroWorkOrderUpdateOneWithoutMroCommunicationThreadsNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroCommunicationThreadsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroCommunicationThreadsInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroCommunicationThreadsInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroCommunicationThreadsInput>;
};

export type MroWorkOrderUpdateOneWithoutMroEstimatesNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroEstimatesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroEstimatesInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroEstimatesInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroEstimatesInput>;
};

export type MroWorkOrderUpdateOneWithoutMroInvoicesNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroInvoicesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroInvoicesInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroInvoicesInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroInvoicesInput>;
};

export type MroWorkOrderUpdateOneWithoutMroLogEntriesNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroLogEntriesInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroLogEntriesInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroLogEntriesInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroLogEntriesInput>;
};

export type MroWorkOrderUpdateOneWithoutMroServiceRequestNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroServiceRequestInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroServiceRequestInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroServiceRequestInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroServiceRequestInput>;
};

export type MroWorkOrderUpdateOneWithoutMroWorkOrderIntervalsNestedInput = {
  connect?: InputMaybe<MroWorkOrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MroWorkOrderCreateOrConnectWithoutMroWorkOrderIntervalsInput>;
  create?: InputMaybe<MroWorkOrderCreateWithoutMroWorkOrderIntervalsInput>;
  delete?: InputMaybe<MroWorkOrderWhereInput>;
  disconnect?: InputMaybe<MroWorkOrderWhereInput>;
  update?: InputMaybe<MroWorkOrderUpdateToOneWithWhereWithoutMroWorkOrderIntervalsInput>;
  upsert?: InputMaybe<MroWorkOrderUpsertWithoutMroWorkOrderIntervalsInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutCraftServiceRequestsInput = {
  data: MroWorkOrderUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutItemCategoriesInput = {
  data: MroWorkOrderUpdateWithoutItemCategoriesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroCommunicationThreadsInput = {
  data: MroWorkOrderUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroEstimatesInput = {
  data: MroWorkOrderUpdateWithoutMroEstimatesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroInvoicesInput = {
  data: MroWorkOrderUpdateWithoutMroInvoicesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroLogEntriesInput = {
  data: MroWorkOrderUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroServiceRequestInput = {
  data: MroWorkOrderUpdateWithoutMroServiceRequestInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroWorkOrderBillingItemsInput = {
  data: MroWorkOrderUpdateWithoutMroWorkOrderBillingItemsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroWorkOrderIntervalsInput = {
  data: MroWorkOrderUpdateWithoutMroWorkOrderIntervalsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateToOneWithWhereWithoutMroWorkOrderItemsInput = {
  data: MroWorkOrderUpdateWithoutMroWorkOrderItemsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutAssigneesInput = {
  data: MroWorkOrderUpdateWithoutAssigneesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutMroCraftInput = {
  data: MroWorkOrderUpdateWithoutMroCraftInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutMroCustomerInput = {
  data: MroWorkOrderUpdateWithoutMroCustomerInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutMroLocationInput = {
  data: MroWorkOrderUpdateWithoutMroLocationInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutMroOrganizationInput = {
  data: MroWorkOrderUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutMroWorkOrderCategoryInput = {
  data: MroWorkOrderUpdateWithoutMroWorkOrderCategoryInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithWhereUniqueWithoutPrimaryContactInput = {
  data: MroWorkOrderUpdateWithoutPrimaryContactInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpdateWithoutAssigneesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutCraftServiceRequestsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutItemCategoriesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroCommunicationThreadsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroCraftInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroCustomerInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroEstimatesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroInvoicesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroLocationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroLogEntriesInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroOrganizationInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroServiceRequestInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroWorkOrderBillingItemsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroWorkOrderCategoryInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroWorkOrderIntervalsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutMroWorkOrderItemsInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpdateWithoutPrimaryContactInput = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutAssigneesInput = {
  create: MroWorkOrderCreateWithoutAssigneesInput;
  update: MroWorkOrderUpdateWithoutAssigneesInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutMroCraftInput = {
  create: MroWorkOrderCreateWithoutMroCraftInput;
  update: MroWorkOrderUpdateWithoutMroCraftInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutMroCustomerInput = {
  create: MroWorkOrderCreateWithoutMroCustomerInput;
  update: MroWorkOrderUpdateWithoutMroCustomerInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutMroLocationInput = {
  create: MroWorkOrderCreateWithoutMroLocationInput;
  update: MroWorkOrderUpdateWithoutMroLocationInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutMroOrganizationInput = {
  create: MroWorkOrderCreateWithoutMroOrganizationInput;
  update: MroWorkOrderUpdateWithoutMroOrganizationInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutMroWorkOrderCategoryInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderCategoryInput;
  update: MroWorkOrderUpdateWithoutMroWorkOrderCategoryInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithWhereUniqueWithoutPrimaryContactInput = {
  create: MroWorkOrderCreateWithoutPrimaryContactInput;
  update: MroWorkOrderUpdateWithoutPrimaryContactInput;
  where: MroWorkOrderWhereUniqueInput;
};

export type MroWorkOrderUpsertWithoutCraftServiceRequestsInput = {
  create: MroWorkOrderCreateWithoutCraftServiceRequestsInput;
  update: MroWorkOrderUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutItemCategoriesInput = {
  create: MroWorkOrderCreateWithoutItemCategoriesInput;
  update: MroWorkOrderUpdateWithoutItemCategoriesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroCommunicationThreadsInput = {
  create: MroWorkOrderCreateWithoutMroCommunicationThreadsInput;
  update: MroWorkOrderUpdateWithoutMroCommunicationThreadsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroEstimatesInput = {
  create: MroWorkOrderCreateWithoutMroEstimatesInput;
  update: MroWorkOrderUpdateWithoutMroEstimatesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroInvoicesInput = {
  create: MroWorkOrderCreateWithoutMroInvoicesInput;
  update: MroWorkOrderUpdateWithoutMroInvoicesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroLogEntriesInput = {
  create: MroWorkOrderCreateWithoutMroLogEntriesInput;
  update: MroWorkOrderUpdateWithoutMroLogEntriesInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroServiceRequestInput = {
  create: MroWorkOrderCreateWithoutMroServiceRequestInput;
  update: MroWorkOrderUpdateWithoutMroServiceRequestInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroWorkOrderBillingItemsInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderBillingItemsInput;
  update: MroWorkOrderUpdateWithoutMroWorkOrderBillingItemsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroWorkOrderIntervalsInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderIntervalsInput;
  update: MroWorkOrderUpdateWithoutMroWorkOrderIntervalsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderUpsertWithoutMroWorkOrderItemsInput = {
  create: MroWorkOrderCreateWithoutMroWorkOrderItemsInput;
  update: MroWorkOrderUpdateWithoutMroWorkOrderItemsInput;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};

export type MroWorkOrderVersion = {
  __typename?: 'MroWorkOrderVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderId?: Maybe<Scalars['String']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type MroWorkOrderVersionCreateManyMroWorkOrderInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderVersionCreateManyMroWorkOrderInputEnvelope = {
  data: Array<MroWorkOrderVersionCreateManyMroWorkOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MroWorkOrderVersionCreateNestedManyWithoutMroWorkOrderInput = {
  connect?: InputMaybe<Array<MroWorkOrderVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderVersionCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderVersionCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderVersionCreateManyMroWorkOrderInputEnvelope>;
};

export type MroWorkOrderVersionCreateOrConnectWithoutMroWorkOrderInput = {
  create: MroWorkOrderVersionCreateWithoutMroWorkOrderInput;
  where: MroWorkOrderVersionWhereUniqueInput;
};

export type MroWorkOrderVersionCreateWithoutMroWorkOrderInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderVersionListRelationFilter = {
  every?: InputMaybe<MroWorkOrderVersionWhereInput>;
  none?: InputMaybe<MroWorkOrderVersionWhereInput>;
  some?: InputMaybe<MroWorkOrderVersionWhereInput>;
};

export type MroWorkOrderVersionScalarWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderVersionUpdateManyWithWhereWithoutMroWorkOrderInput = {
  data: MroWorkOrderVersionUpdateManyMutationInput;
  where: MroWorkOrderVersionScalarWhereInput;
};

export type MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput = {
  connect?: InputMaybe<Array<MroWorkOrderVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MroWorkOrderVersionCreateOrConnectWithoutMroWorkOrderInput>>;
  create?: InputMaybe<Array<MroWorkOrderVersionCreateWithoutMroWorkOrderInput>>;
  createMany?: InputMaybe<MroWorkOrderVersionCreateManyMroWorkOrderInputEnvelope>;
  delete?: InputMaybe<Array<MroWorkOrderVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MroWorkOrderVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MroWorkOrderVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<MroWorkOrderVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<MroWorkOrderVersionUpdateWithWhereUniqueWithoutMroWorkOrderInput>>;
  updateMany?: InputMaybe<Array<MroWorkOrderVersionUpdateManyWithWhereWithoutMroWorkOrderInput>>;
  upsert?: InputMaybe<Array<MroWorkOrderVersionUpsertWithWhereUniqueWithoutMroWorkOrderInput>>;
};

export type MroWorkOrderVersionUpdateWithWhereUniqueWithoutMroWorkOrderInput = {
  data: MroWorkOrderVersionUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderVersionWhereUniqueInput;
};

export type MroWorkOrderVersionUpdateWithoutMroWorkOrderInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type MroWorkOrderVersionUpsertWithWhereUniqueWithoutMroWorkOrderInput = {
  create: MroWorkOrderVersionCreateWithoutMroWorkOrderInput;
  update: MroWorkOrderVersionUpdateWithoutMroWorkOrderInput;
  where: MroWorkOrderVersionWhereUniqueInput;
};

export type MroWorkOrderVersionWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderVersionWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderVersionWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  mroWorkOrder?: InputMaybe<MroWorkOrderNullableScalarRelationFilter>;
  mroWorkOrderId?: InputMaybe<StringNullableFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type MroWorkOrderWhereInput = {
  AND?: InputMaybe<Array<MroWorkOrderWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderWhereInput>>;
  arrivalDate?: InputMaybe<DateTimeNullableFilter>;
  assignees?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  completionDate?: InputMaybe<DateTimeNullableFilter>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryListRelationFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroEstimates?: InputMaybe<MroEstimateListRelationFilter>;
  mroInvoices?: InputMaybe<MroInvoiceListRelationFilter>;
  mroLocation?: InputMaybe<MroLocationNullableScalarRelationFilter>;
  mroLocationId?: InputMaybe<StringNullableFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequest?: InputMaybe<MroServiceRequestNullableScalarRelationFilter>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemListRelationFilter>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryNullableScalarRelationFilter>;
  mroWorkOrderCategoryId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  primaryConcern?: InputMaybe<StringNullableFilter>;
  primaryContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  primaryContactId?: InputMaybe<StringNullableFilter>;
  promiseDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderVersionListRelationFilter>;
  workOrderNum?: InputMaybe<IntNullableFilter>;
};

export type MroWorkOrderWhereUniqueInput = {
  AND?: InputMaybe<Array<MroWorkOrderWhereInput>>;
  NOT?: InputMaybe<Array<MroWorkOrderWhereInput>>;
  OR?: InputMaybe<Array<MroWorkOrderWhereInput>>;
  arrivalDate?: InputMaybe<DateTimeNullableFilter>;
  assignees?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  completionDate?: InputMaybe<DateTimeNullableFilter>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryListRelationFilter>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadListRelationFilter>;
  mroCraft?: InputMaybe<MroCraftNullableScalarRelationFilter>;
  mroCraftId?: InputMaybe<StringNullableFilter>;
  mroCustomer?: InputMaybe<MroCustomerNullableScalarRelationFilter>;
  mroCustomerId?: InputMaybe<StringNullableFilter>;
  mroEstimates?: InputMaybe<MroEstimateListRelationFilter>;
  mroInvoices?: InputMaybe<MroInvoiceListRelationFilter>;
  mroLocation?: InputMaybe<MroLocationNullableScalarRelationFilter>;
  mroLocationId?: InputMaybe<StringNullableFilter>;
  mroLogEntries?: InputMaybe<MroLogEntryListRelationFilter>;
  mroOrganization?: InputMaybe<MroOrganizationNullableScalarRelationFilter>;
  mroOrganizationId?: InputMaybe<StringNullableFilter>;
  mroServiceRequest?: InputMaybe<MroServiceRequestNullableScalarRelationFilter>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemListRelationFilter>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryNullableScalarRelationFilter>;
  mroWorkOrderCategoryId?: InputMaybe<StringNullableFilter>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalListRelationFilter>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemListRelationFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  primaryConcern?: InputMaybe<StringNullableFilter>;
  primaryContact?: InputMaybe<MroContactNullableScalarRelationFilter>;
  primaryContactId?: InputMaybe<StringNullableFilter>;
  promiseDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  versions?: InputMaybe<MroWorkOrderVersionListRelationFilter>;
  workOrderNum?: InputMaybe<IntNullableFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: UserOrganizationProfile;
  addContactToMroCustomer: MroContact;
  addConversationParticipant: MroCommunicationThread;
  addCraftToMroCustomer: MroCraft;
  addUser: UserOrganizationProfile;
  addVariant: MroPart;
  applyCouponToUser: Coupon;
  changePassword: User;
  completedWalkthrough: Scalars['String'];
  createAirport: Airport;
  createAndUpdateWoPart: MroPart;
  createAnnouncement: Announcement;
  createAnnouncementAndSendMessage: Announcement;
  createChargebeeSubscription: Scalars['String'];
  createComment: Comment;
  createComponent: Component;
  createCoupon: Coupon;
  createCraft: Craft;
  createCraftServiceRequest: CraftServiceRequest;
  createDocument: Document;
  createEstimateNum: MroEstimate;
  createFavoriteRoute: FavoriteRoute;
  createFavoriteRouteWithSort: FavoriteRoute;
  createFlight: Flight;
  createFlightPurpose: FlightPurpose;
  createFlightPurposeWithSort: FlightPurpose;
  createFlightWithIntervals: Flight;
  createGroupWithPosition: InspectionGroup;
  createImport: Import;
  createInspection: Inspection;
  createInspectionGroup: InspectionGroup;
  createInspectionWithSort: InspectionGroup;
  createInterval: Interval;
  createIntervalLog: IntervalLog;
  createIntervalsOnInspections: IntervalsOnInspections;
  createJascCategory: JascCategory;
  createJascSystem: JascSystem;
  createLogBook: LogBook;
  createLogEntry: LogEntry;
  createMaintenanceRecord: MaintenanceRecord;
  createManyInspections: Array<Inspection>;
  createMroAddress: MroPartVendor;
  createMroCommunicationThread: MroCommunicationThread;
  createMroComponent: MroComponent;
  createMroCraft: MroCraft;
  createMroCustomer: MroCustomer;
  createMroDocumentTemplate: MroDocumentTemplate;
  createMroEmployeeProfile: MroEmployeeProfile;
  createMroEmployeeProfileAndUser: MroEmployeeProfile;
  createMroEmployeeProfileWithPin: MroEmployeeProfile;
  createMroEstimate: MroEstimate;
  createMroInvoice: MroInvoice;
  createMroIssue: MroIssue;
  createMroLaborEntry: MroLaborEntry;
  createMroLocation: MroLocation;
  createMroLogEntry: MroLogEntry;
  createMroLogEntryFromCategory: MroLogEntry;
  createMroLogEntryItem: MroLogEntryItem;
  createMroOrganization: MroOrganization;
  createMroOrganizationFee: MroOrganizationFee;
  createMroPart: MroPart;
  createMroPartInventory: MroPartInventory;
  createMroPartManufacturer: MroPartManufacturer;
  createMroPartOrder: MroPartOrder;
  createMroPartOrderAndChangeWOPartStatus: MroPartOrder;
  createMroPartOrderItem: MroPartOrderItem;
  createMroPartPriceMatrix: MroPartPriceMatrix;
  createMroPartSource: MroPartSource;
  createMroPartWarehouse: MroPartWarehouse;
  createMroRTSText: MroRtsText;
  createMroReport: MroReport;
  createMroRequstWithRelations: MroServiceRequest;
  createMroRole: MroRole;
  createMroSerializedPart: MroSerializedPart;
  createMroSerializedParts: Array<MroSerializedPart>;
  createMroServiceRequest: MroServiceRequest;
  createMroWorkOrder: MroWorkOrder;
  createMroWorkOrderBillingItem: MroWorkOrderBillingItem;
  createMroWorkOrderCategory: MroWorkOrderCategory;
  createMroWorkOrderFromTemplate: MroWorkOrder;
  createMroWorkOrderInterval: MroWorkOrderInterval;
  createMroWorkOrderItem: MroWorkOrderItem;
  createMroWorkOrderItemCategory: MroWorkOrderItemCategory;
  createMroWorkOrderItemWithNumber: MroWorkOrderItem;
  createMroWorkOrderPart: MroWorkOrderPart;
  createMroWorkOrderSignoff: MroWorkOrderSignoff;
  createMroWorkOrderTemplate: MroWorkOrderTemplate;
  createOrganization: Organization;
  createRequestWithNumber: MroServiceRequest;
  createReservation: Reservation;
  createReservationAndNotify?: Maybe<Reservation>;
  createSquawk: Squawk;
  createSquawkWithNumber: Squawk;
  createTransaction: Transaction;
  createTransactionAndUpdateWallet: Transaction;
  createUsageRecord: UsageRecord;
  createUserOrganizationProfile: UserOrganizationProfile;
  createUserOrganizationRole: UserOrganizationRole;
  createWallet: Wallet;
  deleteAttachment: Attachment;
  deleteFlight: Flight;
  deleteFlightPurposeWithSort: FlightPurpose;
  deleteInspectionGroupWithSort: InspectionGroup;
  deleteInspectionWithSort: InspectionGroup;
  deleteMroPartWarehouse: MroPartWarehouse;
  deleteWorkOrderItem?: Maybe<MroWorkOrderItem>;
  disconnectAirbly: AirblySetup;
  disconnectForeflight: Scalars['String'];
  foreflightAuth: Scalars['String'];
  fulfillRequest: MroWorkOrderPart;
  getTwilioAccessToken: Scalars['String'];
  login: Auth;
  logout: Scalars['String'];
  onboardMroCustomer: MroCustomer;
  onboardOrganization: OnboardOrganization;
  pauseTimer: MroLaborEntry;
  refreshPinCode: MroEmployeeProfile;
  refreshToken: Auth;
  removeAirport: Airport;
  removeAirsyncTail: AirSyncTail;
  removeAnnouncement: Announcement;
  removeComment: Comment;
  removeComponent: Component;
  removeConversationParticipant: MroCommunicationThread;
  removeCoupon: Coupon;
  removeCouponFromUser: Scalars['Boolean'];
  removeCraft: Craft;
  removeCraftServiceRequest: CraftServiceRequest;
  removeDocument: Document;
  removeFavoriteRoute: FavoriteRoute;
  removeFavoriteRouteWithSort: FavoriteRoute;
  removeFlight: Flight;
  removeFlightPurpose: FlightPurpose;
  removeImport: Import;
  removeInspection: Inspection;
  removeInspectionGroup: InspectionGroup;
  removeInterval: Interval;
  removeIntervalLog: IntervalLog;
  removeIntervalsOnInspections: IntervalsOnInspections;
  removeJascCategory: JascCategory;
  removeJascSystem: JascSystem;
  removeLogBook: LogBook;
  removeLogEntry: LogEntry;
  removeMaintenanceRecord: MaintenanceRecord;
  removeMroAddress: MroPartVendor;
  removeMroCommunicationThread: MroCommunicationThread;
  removeMroComponent: MroComponent;
  removeMroCraft: MroCraft;
  removeMroCustomer: MroCustomer;
  removeMroDocumentTemplate: MroDocumentTemplate;
  removeMroEmployeeProfile: MroEmployeeProfile;
  removeMroEstimate: MroEstimate;
  removeMroInvoice: MroInvoice;
  removeMroIssue: MroIssue;
  removeMroLaborEntry: MroLaborEntry;
  removeMroLocation: MroLocation;
  removeMroLogEntry: MroLogEntry;
  removeMroLogEntryItem: MroLogEntryItem;
  removeMroOrganization: MroOrganization;
  removeMroOrganizationFee: MroOrganizationFee;
  removeMroPart: MroPart;
  removeMroPartInventory: MroPartInventory;
  removeMroPartManufacturer: MroPartManufacturer;
  removeMroPartOrder: MroPartOrder;
  removeMroPartOrderItem: MroPartOrderItem;
  removeMroPartPriceMatrix: MroPartPriceMatrix;
  removeMroPartSource: MroPartSource;
  removeMroPartWarehouse: MroPartWarehouse;
  removeMroRTSText: MroRtsText;
  removeMroReport: MroReport;
  removeMroRole: MroRole;
  removeMroSerializedPart: MroSerializedPart;
  removeMroServiceRequest: MroServiceRequest;
  removeMroWorkOrder: MroWorkOrder;
  removeMroWorkOrderBillingItem: MroWorkOrderBillingItem;
  removeMroWorkOrderCategory: MroWorkOrderCategory;
  removeMroWorkOrderInterval: MroWorkOrderInterval;
  removeMroWorkOrderItem: MroWorkOrderItem;
  removeMroWorkOrderItemCategory: MroWorkOrderItemCategory;
  removeMroWorkOrderPart: Scalars['Boolean'];
  removeMroWorkOrderSignoff: MroWorkOrderSignoff;
  removeMroWorkOrderTemplate: MroWorkOrderTemplate;
  removeReservation: Reservation;
  removeSquawk: Squawk;
  removeTransaction: Transaction;
  removeUsageRecord: UsageRecord;
  removeUserOrganizationProfile: UserOrganizationProfile;
  removeUserOrganizationRole: UserOrganizationRole;
  removeVariant: MroPart;
  removeWallet: Wallet;
  requestAllWorkOrderItemsParts: Scalars['String'];
  resendInvitation: Scalars['String'];
  resetPassword: Scalars['String'];
  resumeTimer: MroLaborEntry;
  sendEstimate: Scalars['String'];
  sendInvoice: Scalars['String'];
  sendPasswordResetEmail: Scalars['String'];
  sendWelcomeEmail: Scalars['String'];
  setConversationState: MroCommunicationThread;
  setSelectCraft: UserOrganizationProfile;
  setupAirbly: AirblySetup;
  setupAirsyncTails: Array<AirSyncSetup>;
  setupPasswordFromToken: Scalars['String'];
  signup: Auth;
  startTimer: MroLaborEntry;
  stopTimer: MroLaborEntry;
  switchOrganization: Auth;
  syncAirsyncLogs: AirSyncLogSync;
  updateAirport: Airport;
  updateAnnouncement: Announcement;
  updateAnnouncementAndSendMessage: Announcement;
  updateChargebeeSubscription: Scalars['String'];
  updateComment: Comment;
  updateComponent: Component;
  updateCoupon: Coupon;
  updateCraft: Craft;
  updateCraftAmountSubsciption: Scalars['String'];
  updateCraftServiceRequest: CraftServiceRequest;
  updateCrafts: Array<Craft>;
  updateDocument: Document;
  updateFavoriteRoute: FavoriteRoute;
  updateFavoriteRouteWithSort: FavoriteRoute;
  updateFlight: Flight;
  updateFlightPurpose: FlightPurpose;
  updateFlightPurposeWithSort: FlightPurpose;
  updateFlightWithIntervals: Flight;
  updateImport: Import;
  updateInspection: Inspection;
  updateInspectionGroup: InspectionGroup;
  updateInspectionGroupWithSort: InspectionGroup;
  updateInspectionWithSort: InspectionGroup;
  updateInterval: Interval;
  updateIntervalLog: IntervalLog;
  updateIntervalsOnInspections: IntervalsOnInspections;
  updateInvoiceStatus: Scalars['String'];
  updateJascCategory: JascCategory;
  updateJascSystem: JascSystem;
  updateLogBook: LogBook;
  updateLogEntry: LogEntry;
  updateMaintenanceRecord: MaintenanceRecord;
  updateMroAddress: MroPartVendor;
  updateMroCommunicationThread: MroCommunicationThread;
  updateMroComponent: MroComponent;
  updateMroCraft: MroCraft;
  updateMroCustomer: MroCustomer;
  updateMroDocumentTemplate: MroDocumentTemplate;
  updateMroEmployeeProfile: MroEmployeeProfile;
  updateMroEstimate: MroEstimate;
  updateMroEstimateStatusWithToken: Scalars['String'];
  updateMroInvoice: MroInvoice;
  updateMroIssue: MroIssue;
  updateMroLaborEntry: MroLaborEntry;
  updateMroLocation: MroLocation;
  updateMroLogEntry: MroLogEntry;
  updateMroLogEntryItem: MroLogEntryItem;
  updateMroOrganization: MroOrganization;
  updateMroOrganizationFee: MroOrganizationFee;
  updateMroPart: MroPart;
  updateMroPartInventory: MroPartInventory;
  updateMroPartManufacturer: MroPartManufacturer;
  updateMroPartOrder: MroPartOrder;
  updateMroPartOrderAndChangeWOPartStatus: MroPartOrder;
  updateMroPartOrderItem: MroPartOrderItem;
  updateMroPartPriceMatrix: MroPartPriceMatrix;
  updateMroPartSource: MroPartSource;
  updateMroPartWarehouse: MroPartWarehouse;
  updateMroRTSText: MroRtsText;
  updateMroReport: MroReport;
  updateMroRole: MroRole;
  updateMroSerializedPart: MroSerializedPart;
  updateMroServiceRequest: MroServiceRequest;
  updateMroWorkOrder: MroWorkOrder;
  updateMroWorkOrderBillingItem: MroWorkOrderBillingItem;
  updateMroWorkOrderCategory: MroWorkOrderCategory;
  updateMroWorkOrderInterval: MroWorkOrderInterval;
  updateMroWorkOrderItem: MroWorkOrderItem;
  updateMroWorkOrderItemCategory: MroWorkOrderItemCategory;
  updateMroWorkOrderPart: MroWorkOrderPart;
  updateMroWorkOrderPartStatus: Scalars['Boolean'];
  updateMroWorkOrderSignoff: MroWorkOrderSignoff;
  updateMroWorkOrderStatus: MroWorkOrder;
  updateMroWorkOrderTemplate: MroWorkOrderTemplate;
  updateMroWorkOrderWithContactInfo: MroWorkOrder;
  updateOrganization: Organization;
  updateOrganizationIcon: MroOrganization;
  updateReservation: Reservation;
  updateReservationCheckConflict: Reservation;
  updateSignoffStatus: MroWorkOrderSignoff;
  updateSquawk: Squawk;
  updateSquawkAndSendUpdate: Squawk;
  updateStripeConnect: Organization;
  updateTransaction: Transaction;
  updateTransactionAttachments: Transaction;
  updateUsageRecord: UsageRecord;
  updateUser: User;
  updateUserOrgProfileWithPassword: UserOrganizationProfile;
  updateUserOrganizationProfile: UserOrganizationProfile;
  updateUserOrganizationRole: UserOrganizationRole;
  updateUserWithPassword: User;
  updateWallet: Wallet;
  updateWorkOrderItemAndNumbers: MroWorkOrderItem;
};


export type MutationAcceptInvitationArgs = {
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationAddContactToMroCustomerArgs = {
  input: AddContactToMroCustomerInput;
};


export type MutationAddConversationParticipantArgs = {
  input: AddConversationParticipantInput;
};


export type MutationAddCraftToMroCustomerArgs = {
  input: AddCraftToMroCustomerInput;
};


export type MutationAddUserArgs = {
  input: UserOrganizationProfileCreateInput;
};


export type MutationAddVariantArgs = {
  partId: Scalars['String'];
  variantId: Scalars['String'];
};


export type MutationApplyCouponToUserArgs = {
  couponCode: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCompletedWalkthroughArgs = {
  id: Scalars['String'];
};


export type MutationCreateAirportArgs = {
  input: AirportCreateInput;
};


export type MutationCreateAndUpdateWoPartArgs = {
  input: MroPartCreateInput;
};


export type MutationCreateAnnouncementArgs = {
  input: AnnouncementCreateInput;
};


export type MutationCreateAnnouncementAndSendMessageArgs = {
  input: AnnouncementCreateInput;
};


export type MutationCreateChargebeeSubscriptionArgs = {
  input: ChargebeeSubscribeInput;
  organizationId: Scalars['String'];
  planId: Scalars['String'];
};


export type MutationCreateCommentArgs = {
  input: CommentCreateInput;
};


export type MutationCreateComponentArgs = {
  input: ComponentCreateInput;
};


export type MutationCreateCouponArgs = {
  input: CouponCreateInput;
};


export type MutationCreateCraftArgs = {
  input: CreateCraftInput;
};


export type MutationCreateCraftServiceRequestArgs = {
  input: CraftServiceRequestCreateInput;
};


export type MutationCreateDocumentArgs = {
  input: DocumentCreateInput;
};


export type MutationCreateEstimateNumArgs = {
  input: MroEstimateCreateInput;
};


export type MutationCreateFavoriteRouteArgs = {
  input: FavoriteRouteCreateInput;
};


export type MutationCreateFavoriteRouteWithSortArgs = {
  input: FavoriteRouteCreateInput;
};


export type MutationCreateFlightArgs = {
  input: FlightCreateInput;
};


export type MutationCreateFlightPurposeArgs = {
  input: FlightPurposeCreateInput;
};


export type MutationCreateFlightPurposeWithSortArgs = {
  input: FlightPurposeCreateInput;
};


export type MutationCreateFlightWithIntervalsArgs = {
  input: FlightCreateWithIntervalsInput;
};


export type MutationCreateGroupWithPositionArgs = {
  input: InspectionGroupCreateInput;
};


export type MutationCreateImportArgs = {
  input: ImportCreateInput;
};


export type MutationCreateInspectionArgs = {
  input: InspectionCreateInput;
};


export type MutationCreateInspectionGroupArgs = {
  input: InspectionGroupCreateInput;
};


export type MutationCreateInspectionWithSortArgs = {
  input: InspectionCreateInput;
};


export type MutationCreateIntervalArgs = {
  input: IntervalCreateInput;
};


export type MutationCreateIntervalLogArgs = {
  createIntervalLogInput: IntervalLogCreateInput;
};


export type MutationCreateIntervalsOnInspectionsArgs = {
  input: IntervalsOnInspectionsCreateInput;
};


export type MutationCreateJascCategoryArgs = {
  input: CreateJascCategoryInput;
};


export type MutationCreateJascSystemArgs = {
  input: CreateJascSystemInput;
};


export type MutationCreateLogBookArgs = {
  input: LogBookCreateInput;
};


export type MutationCreateLogEntryArgs = {
  input: LogEntryCreateInput;
};


export type MutationCreateMaintenanceRecordArgs = {
  input: MaintenanceRecordCreateInput;
};


export type MutationCreateManyInspectionsArgs = {
  input: InspectionCreateManyInput;
};


export type MutationCreateMroAddressArgs = {
  createMroPartVendorInput: MroPartVendorCreateInput;
};


export type MutationCreateMroCommunicationThreadArgs = {
  input: MroCommunicationThreadCreateInput;
};


export type MutationCreateMroComponentArgs = {
  input: MroComponentCreateInput;
};


export type MutationCreateMroCraftArgs = {
  input: MroCraftCreateInput;
};


export type MutationCreateMroCustomerArgs = {
  input: MroCustomerCreateInput;
};


export type MutationCreateMroDocumentTemplateArgs = {
  input: MroDocumentTemplateCreateInput;
};


export type MutationCreateMroEmployeeProfileArgs = {
  input: MroEmployeeProfileCreateInput;
};


export type MutationCreateMroEmployeeProfileAndUserArgs = {
  input: MroEmployeeProfileCreateInput;
};


export type MutationCreateMroEmployeeProfileWithPinArgs = {
  input: MroEmployeeProfileCreateInput;
};


export type MutationCreateMroEstimateArgs = {
  input: MroEstimateCreateInput;
};


export type MutationCreateMroInvoiceArgs = {
  input: MroInvoiceCreateInput;
};


export type MutationCreateMroIssueArgs = {
  createMroIssueInput: MroIssueCreateInput;
};


export type MutationCreateMroLaborEntryArgs = {
  input: MroLaborEntryCreateInput;
};


export type MutationCreateMroLocationArgs = {
  input: MroLocationCreateInput;
};


export type MutationCreateMroLogEntryArgs = {
  input: MroLogEntryCreateInput;
};


export type MutationCreateMroLogEntryFromCategoryArgs = {
  categoryId: Scalars['String'];
};


export type MutationCreateMroLogEntryItemArgs = {
  input: MroLogEntryItemCreateInput;
};


export type MutationCreateMroOrganizationArgs = {
  input: MroOrganizationCreateInput;
};


export type MutationCreateMroOrganizationFeeArgs = {
  input: MroOrganizationFeeCreateInput;
};


export type MutationCreateMroPartArgs = {
  input: MroPartCreateInput;
};


export type MutationCreateMroPartInventoryArgs = {
  input: MroPartInventoryCreateInput;
};


export type MutationCreateMroPartManufacturerArgs = {
  input: MroPartManufacturerCreateInput;
};


export type MutationCreateMroPartOrderArgs = {
  input: MroPartOrderCreateInput;
};


export type MutationCreateMroPartOrderAndChangeWoPartStatusArgs = {
  input: MroPartOrderCreateInput;
};


export type MutationCreateMroPartOrderItemArgs = {
  input: MroPartOrderItemCreateInput;
};


export type MutationCreateMroPartPriceMatrixArgs = {
  input: MroPartPriceMatrixCreateInput;
};


export type MutationCreateMroPartSourceArgs = {
  input: MroPartSourceCreateInput;
};


export type MutationCreateMroPartWarehouseArgs = {
  input: MroPartWarehouseCreateInput;
};


export type MutationCreateMroRtsTextArgs = {
  input: MroRtsTextCreateInput;
};


export type MutationCreateMroReportArgs = {
  input: MroReportCreateInput;
};


export type MutationCreateMroRequstWithRelationsArgs = {
  input: OnboardMroRequestInput;
};


export type MutationCreateMroRoleArgs = {
  input: MroRoleCreateInput;
};


export type MutationCreateMroSerializedPartArgs = {
  input: MroSerializedPartCreateInput;
};


export type MutationCreateMroSerializedPartsArgs = {
  input: CreateSerializedPartsInput;
};


export type MutationCreateMroServiceRequestArgs = {
  input: MroServiceRequestCreateInput;
};


export type MutationCreateMroWorkOrderArgs = {
  input: MroWorkOrderCreateInput;
};


export type MutationCreateMroWorkOrderBillingItemArgs = {
  input: MroWorkOrderBillingItemCreateInput;
};


export type MutationCreateMroWorkOrderCategoryArgs = {
  input: MroWorkOrderCategoryCreateInput;
};


export type MutationCreateMroWorkOrderFromTemplateArgs = {
  input: CreateMroWorkOrderFromTemplateInput;
};


export type MutationCreateMroWorkOrderIntervalArgs = {
  input: MroWorkOrderIntervalCreateInput;
};


export type MutationCreateMroWorkOrderItemArgs = {
  input: MroWorkOrderItemCreateInput;
};


export type MutationCreateMroWorkOrderItemCategoryArgs = {
  input: MroWorkOrderItemCategoryCreateInput;
};


export type MutationCreateMroWorkOrderItemWithNumberArgs = {
  input: MroWorkOrderItemCreateInput;
};


export type MutationCreateMroWorkOrderPartArgs = {
  input: MroWorkOrderPartCreateInput;
};


export type MutationCreateMroWorkOrderSignoffArgs = {
  input: MroWorkOrderSignoffCreateInput;
};


export type MutationCreateMroWorkOrderTemplateArgs = {
  input: CreateWorkOrderTemplateInput;
};


export type MutationCreateOrganizationArgs = {
  createOrganizationInput: CreateOrganizationInput;
};


export type MutationCreateRequestWithNumberArgs = {
  input: MroServiceRequestCreateInput;
  orgId: Scalars['String'];
};


export type MutationCreateReservationArgs = {
  input: ReservationCreateInput;
};


export type MutationCreateReservationAndNotifyArgs = {
  input: ReservationCreateInput;
};


export type MutationCreateSquawkArgs = {
  input: SquawkCreateInput;
};


export type MutationCreateSquawkWithNumberArgs = {
  input: CreateSquawkInput;
};


export type MutationCreateTransactionArgs = {
  input: TransactionCreateInput;
};


export type MutationCreateTransactionAndUpdateWalletArgs = {
  input: TransactionCreateInput;
};


export type MutationCreateUsageRecordArgs = {
  createUsageRecordInput: UsageRecordCreateInput;
};


export type MutationCreateUserOrganizationProfileArgs = {
  input: UserOrganizationProfileCreateInput;
};


export type MutationCreateUserOrganizationRoleArgs = {
  input: UserOrganizationRoleCreateInput;
};


export type MutationCreateWalletArgs = {
  input: WalletCreateInput;
};


export type MutationDeleteAttachmentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFlightArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFlightPurposeWithSortArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInspectionGroupWithSortArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInspectionWithSortArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMroPartWarehouseArgs = {
  partWarehouseId: Scalars['String'];
};


export type MutationDeleteWorkOrderItemArgs = {
  id: Scalars['String'];
};


export type MutationDisconnectAirblyArgs = {
  organizationId: Scalars['String'];
};


export type MutationDisconnectForeflightArgs = {
  organizationId: Scalars['String'];
};


export type MutationForeflightAuthArgs = {
  code: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationFulfillRequestArgs = {
  input: MroWorkOrderPartUpdateInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationOnboardMroCustomerArgs = {
  input: OnboardMroCustomerInput;
};


export type MutationOnboardOrganizationArgs = {
  input: OnboardOrganizationInput;
};


export type MutationPauseTimerArgs = {
  mroLaborEntryId: Scalars['String'];
};


export type MutationRefreshPinCodeArgs = {
  id: Scalars['String'];
};


export type MutationRefreshTokenArgs = {
  token: Scalars['JWT'];
};


export type MutationRemoveAirportArgs = {
  id: Scalars['String'];
};


export type MutationRemoveAirsyncTailArgs = {
  airsyncSetupInput: AirsyncSetupInput;
};


export type MutationRemoveAnnouncementArgs = {
  id: Scalars['String'];
};


export type MutationRemoveCommentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveComponentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveConversationParticipantArgs = {
  id: Scalars['String'];
};


export type MutationRemoveCouponArgs = {
  id: Scalars['String'];
};


export type MutationRemoveCraftArgs = {
  id: Scalars['String'];
};


export type MutationRemoveCraftServiceRequestArgs = {
  id: Scalars['String'];
};


export type MutationRemoveDocumentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFavoriteRouteArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFavoriteRouteWithSortArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFlightArgs = {
  id: Scalars['String'];
};


export type MutationRemoveFlightPurposeArgs = {
  id: Scalars['String'];
};


export type MutationRemoveImportArgs = {
  id: Scalars['String'];
};


export type MutationRemoveInspectionArgs = {
  id: Scalars['String'];
};


export type MutationRemoveInspectionGroupArgs = {
  id: Scalars['String'];
};


export type MutationRemoveIntervalArgs = {
  id: Scalars['String'];
};


export type MutationRemoveIntervalLogArgs = {
  id: Scalars['String'];
};


export type MutationRemoveIntervalsOnInspectionsArgs = {
  id: Scalars['String'];
};


export type MutationRemoveJascCategoryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveJascSystemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLogBookArgs = {
  id: Scalars['String'];
};


export type MutationRemoveLogEntryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMaintenanceRecordArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroAddressArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroCommunicationThreadArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroComponentArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroCraftArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroCustomerArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroDocumentTemplateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroEmployeeProfileArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroEstimateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroInvoiceArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroIssueArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroLaborEntryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroLocationArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroLogEntryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroLogEntryItemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroOrganizationArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroOrganizationFeeArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartInventoryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartManufacturerArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartOrderArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartOrderItemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartPriceMatrixArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroPartSourceArgs = {
  partSourceId: Scalars['String'];
};


export type MutationRemoveMroPartWarehouseArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroRtsTextArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroReportArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroRoleArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroSerializedPartArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroServiceRequestArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderBillingItemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderCategoryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderIntervalArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderItemArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderItemCategoryArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderPartArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderSignoffArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMroWorkOrderTemplateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveReservationArgs = {
  id: Scalars['String'];
};


export type MutationRemoveSquawkArgs = {
  id: Scalars['String'];
};


export type MutationRemoveTransactionArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUsageRecordArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUserOrganizationProfileArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUserOrganizationRoleArgs = {
  id: Scalars['String'];
};


export type MutationRemoveVariantArgs = {
  partId: Scalars['String'];
  variantId: Scalars['String'];
};


export type MutationRemoveWalletArgs = {
  id: Scalars['String'];
};


export type MutationRequestAllWorkOrderItemsPartsArgs = {
  id: Scalars['String'];
};


export type MutationResendInvitationArgs = {
  id: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  id: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationResumeTimerArgs = {
  mroLaborEntryId: Scalars['String'];
};


export type MutationSendEstimateArgs = {
  emails: Array<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationSendInvoiceArgs = {
  emails: Array<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendWelcomeEmailArgs = {
  email: Scalars['String'];
};


export type MutationSetConversationStateArgs = {
  id: Scalars['String'];
  state: Scalars['String'];
};


export type MutationSetSelectCraftArgs = {
  craftId: Scalars['String'];
};


export type MutationSetupAirblyArgs = {
  key: Scalars['String'];
  organizationId: Scalars['String'];
};


export type MutationSetupAirsyncTailsArgs = {
  airsyncSetupInputs: Array<AirsyncSetupInput>;
};


export type MutationSetupPasswordFromTokenArgs = {
  id: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationSignupArgs = {
  data: SignupInput;
};


export type MutationStartTimerArgs = {
  employeeProfileId: Scalars['String'];
  mroOrganizationId: Scalars['String'];
  workOrderItemId: Scalars['String'];
};


export type MutationStopTimerArgs = {
  mroLaborEntryId: Scalars['String'];
};


export type MutationSwitchOrganizationArgs = {
  organizationId: Scalars['String'];
};


export type MutationSyncAirsyncLogsArgs = {
  airsyncInput: AirsyncSetupInput;
};


export type MutationUpdateAirportArgs = {
  input: AirportUpdateInput;
};


export type MutationUpdateAnnouncementArgs = {
  input: AnnouncementUpdateInput;
};


export type MutationUpdateAnnouncementAndSendMessageArgs = {
  input: AnnouncementUpdateInput;
};


export type MutationUpdateChargebeeSubscriptionArgs = {
  input: ChargebeeUpdateInput;
  organizationId: Scalars['String'];
};


export type MutationUpdateCommentArgs = {
  input: CommentUpdateInput;
};


export type MutationUpdateComponentArgs = {
  input: ComponentUpdateInput;
};


export type MutationUpdateCouponArgs = {
  input: CouponUpdateInput;
};


export type MutationUpdateCraftArgs = {
  updateCraftInput: UpdateCraftInput;
};


export type MutationUpdateCraftAmountSubsciptionArgs = {
  amount: Scalars['Int'];
};


export type MutationUpdateCraftServiceRequestArgs = {
  input: CraftServiceRequestUpdateInput;
};


export type MutationUpdateCraftsArgs = {
  updateCraftInputs: Array<UpdateCraftInput>;
};


export type MutationUpdateDocumentArgs = {
  input: DocumentUpdateInput;
};


export type MutationUpdateFavoriteRouteArgs = {
  input: FavoriteRouteUpdateInput;
};


export type MutationUpdateFavoriteRouteWithSortArgs = {
  input: FavoriteRouteUpdateInput;
};


export type MutationUpdateFlightArgs = {
  input: FlightUpdateInput;
};


export type MutationUpdateFlightPurposeArgs = {
  input: FlightPurposeUpdateInput;
};


export type MutationUpdateFlightPurposeWithSortArgs = {
  input: FlightPurposeUpdateInput;
};


export type MutationUpdateFlightWithIntervalsArgs = {
  input: FlightUpdateWithIntervalsInput;
};


export type MutationUpdateImportArgs = {
  input: ImportUpdateInput;
};


export type MutationUpdateInspectionArgs = {
  input: InspectionUpdateInput;
};


export type MutationUpdateInspectionGroupArgs = {
  input: InspectionGroupUpdateInput;
};


export type MutationUpdateInspectionGroupWithSortArgs = {
  input: InspectionGroupUpdateInput;
};


export type MutationUpdateInspectionWithSortArgs = {
  input: InspectionUpdateInput;
};


export type MutationUpdateIntervalArgs = {
  input: IntervalUpdateInput;
};


export type MutationUpdateIntervalLogArgs = {
  updateIntervalLogInput: IntervalLogUpdateInput;
};


export type MutationUpdateIntervalsOnInspectionsArgs = {
  input: IntervalsOnInspectionsUpdateInput;
};


export type MutationUpdateInvoiceStatusArgs = {
  id: Scalars['String'];
  status: Scalars['String'];
};


export type MutationUpdateJascCategoryArgs = {
  input: UpdateJascCategoryInput;
};


export type MutationUpdateJascSystemArgs = {
  input: UpdateJascSystemInput;
};


export type MutationUpdateLogBookArgs = {
  input: LogBookUpdateInput;
};


export type MutationUpdateLogEntryArgs = {
  input: LogEntryUpdateInput;
};


export type MutationUpdateMaintenanceRecordArgs = {
  input: MaintenanceRecordUpdateInput;
};


export type MutationUpdateMroAddressArgs = {
  input: MroPartVendorUpdateInput;
};


export type MutationUpdateMroCommunicationThreadArgs = {
  input: MroCommunicationThreadUpdateInput;
};


export type MutationUpdateMroComponentArgs = {
  input: MroComponentUpdateInput;
};


export type MutationUpdateMroCraftArgs = {
  input: MroCraftUpdateInput;
};


export type MutationUpdateMroCustomerArgs = {
  input: MroCustomerUpdateInput;
};


export type MutationUpdateMroDocumentTemplateArgs = {
  input: MroDocumentTemplateUpdateInput;
};


export type MutationUpdateMroEmployeeProfileArgs = {
  input: MroEmployeeProfileUpdateInput;
};


export type MutationUpdateMroEstimateArgs = {
  input: MroEstimateUpdateInput;
};


export type MutationUpdateMroEstimateStatusWithTokenArgs = {
  input: UpdateEstimateWithToken;
};


export type MutationUpdateMroInvoiceArgs = {
  input: MroInvoiceUpdateInput;
};


export type MutationUpdateMroIssueArgs = {
  input: MroIssueUpdateInput;
};


export type MutationUpdateMroLaborEntryArgs = {
  input: MroLaborEntryUpdateInput;
};


export type MutationUpdateMroLocationArgs = {
  input: MroLocationUpdateInput;
};


export type MutationUpdateMroLogEntryArgs = {
  input: MroLogEntryUpdateInput;
};


export type MutationUpdateMroLogEntryItemArgs = {
  input: MroLogEntryItemUpdateInput;
};


export type MutationUpdateMroOrganizationArgs = {
  input: MroOrganizationUpdateInput;
};


export type MutationUpdateMroOrganizationFeeArgs = {
  input: MroOrganizationFeeUpdateInput;
};


export type MutationUpdateMroPartArgs = {
  input: MroPartUpdateInput;
};


export type MutationUpdateMroPartInventoryArgs = {
  input: MroPartInventoryUpdateInput;
};


export type MutationUpdateMroPartManufacturerArgs = {
  input: MroPartManufacturerUpdateInput;
};


export type MutationUpdateMroPartOrderArgs = {
  input: MroPartOrderUpdateInput;
};


export type MutationUpdateMroPartOrderAndChangeWoPartStatusArgs = {
  input: MroPartOrderUpdateInput;
};


export type MutationUpdateMroPartOrderItemArgs = {
  input: MroPartOrderItemUpdateInput;
};


export type MutationUpdateMroPartPriceMatrixArgs = {
  input: MroPartPriceMatrixUpdateInput;
};


export type MutationUpdateMroPartSourceArgs = {
  input: MroPartSourceUpdateInput;
};


export type MutationUpdateMroPartWarehouseArgs = {
  input: MroPartWarehouseUpdateInput;
};


export type MutationUpdateMroRtsTextArgs = {
  input: MroRtsTextUpdateInput;
};


export type MutationUpdateMroReportArgs = {
  input: MroReportUpdateInput;
};


export type MutationUpdateMroRoleArgs = {
  input: MroRoleUpdateInput;
};


export type MutationUpdateMroSerializedPartArgs = {
  input: MroSerializedPartUpdateInput;
};


export type MutationUpdateMroServiceRequestArgs = {
  input: MroServiceRequestUpdateInput;
};


export type MutationUpdateMroWorkOrderArgs = {
  input: MroWorkOrderUpdateInput;
};


export type MutationUpdateMroWorkOrderBillingItemArgs = {
  input: MroWorkOrderBillingItemUpdateInput;
};


export type MutationUpdateMroWorkOrderCategoryArgs = {
  input: MroWorkOrderCategoryUpdateInput;
};


export type MutationUpdateMroWorkOrderIntervalArgs = {
  input: MroWorkOrderIntervalUpdateInput;
};


export type MutationUpdateMroWorkOrderItemArgs = {
  input: MroWorkOrderItemUpdateInput;
};


export type MutationUpdateMroWorkOrderItemCategoryArgs = {
  input: MroWorkOrderItemCategoryUpdateInput;
};


export type MutationUpdateMroWorkOrderPartArgs = {
  input: MroWorkOrderPartUpdateInput;
};


export type MutationUpdateMroWorkOrderPartStatusArgs = {
  input: MroWorkOrderPartUpdateInput;
};


export type MutationUpdateMroWorkOrderSignoffArgs = {
  input: MroWorkOrderSignoffUpdateInput;
};


export type MutationUpdateMroWorkOrderStatusArgs = {
  id: Scalars['String'];
  status: Scalars['String'];
};


export type MutationUpdateMroWorkOrderTemplateArgs = {
  input: MroWorkOrderTemplateUpdateInput;
};


export type MutationUpdateMroWorkOrderWithContactInfoArgs = {
  input: UpdateMroWorkOrderWithContactInfo;
};


export type MutationUpdateOrganizationArgs = {
  input: OrganizationUpdateInput;
};


export type MutationUpdateOrganizationIconArgs = {
  blackIconId?: InputMaybe<Scalars['String']>;
  colorIconId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['String'];
};


export type MutationUpdateReservationArgs = {
  input: ReservationUpdateInput;
};


export type MutationUpdateReservationCheckConflictArgs = {
  input: ReservationUpdateInput;
};


export type MutationUpdateSignoffStatusArgs = {
  id: Scalars['String'];
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};


export type MutationUpdateSquawkArgs = {
  input: SquawkUpdateInput;
};


export type MutationUpdateSquawkAndSendUpdateArgs = {
  input: SquawkUpdateInput;
};


export type MutationUpdateStripeConnectArgs = {
  id: Scalars['String'];
};


export type MutationUpdateTransactionArgs = {
  input: TransactionUpdateInput;
};


export type MutationUpdateTransactionAttachmentsArgs = {
  attachments: TransactionsUpdateAttachmentsInput;
  id: Scalars['String'];
};


export type MutationUpdateUsageRecordArgs = {
  updateUsageRecordInput: UsageRecordUpdateInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserOrgProfileWithPasswordArgs = {
  input: UserOrganizationProfileUpdateInput;
  password: Scalars['String'];
};


export type MutationUpdateUserOrganizationProfileArgs = {
  input: UserOrganizationProfileUpdateInput;
};


export type MutationUpdateUserOrganizationRoleArgs = {
  input: UserOrganizationRoleUpdateInput;
};


export type MutationUpdateUserWithPasswordArgs = {
  input: UserUpdateInput;
  password: Scalars['String'];
};


export type MutationUpdateWalletArgs = {
  input: WalletUpdateInput;
};


export type MutationUpdateWorkOrderItemAndNumbersArgs = {
  input: MroWorkOrderItemUpdateInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type NestedEnumAuditOperationFilter = {
  equals?: InputMaybe<AuditOperation>;
  in?: InputMaybe<Array<AuditOperation>>;
  not?: InputMaybe<NestedEnumAuditOperationFilter>;
  notIn?: InputMaybe<Array<AuditOperation>>;
};

export type NestedEnumCouponTypeNullableFilter = {
  equals?: InputMaybe<CouponType>;
  in?: InputMaybe<Array<CouponType>>;
  not?: InputMaybe<NestedEnumCouponTypeNullableFilter>;
  notIn?: InputMaybe<Array<CouponType>>;
};

export type NestedEnumCraftTypeFilter = {
  equals?: InputMaybe<CraftType>;
  in?: InputMaybe<Array<CraftType>>;
  not?: InputMaybe<NestedEnumCraftTypeFilter>;
  notIn?: InputMaybe<Array<CraftType>>;
};

export type NestedEnumInspectionDueTypeFilter = {
  equals?: InputMaybe<InspectionDueType>;
  in?: InputMaybe<Array<InspectionDueType>>;
  not?: InputMaybe<NestedEnumInspectionDueTypeFilter>;
  notIn?: InputMaybe<Array<InspectionDueType>>;
};

export type NestedEnumIntervalSubtypeNullableFilter = {
  equals?: InputMaybe<IntervalSubtype>;
  in?: InputMaybe<Array<IntervalSubtype>>;
  not?: InputMaybe<NestedEnumIntervalSubtypeNullableFilter>;
  notIn?: InputMaybe<Array<IntervalSubtype>>;
};

export type NestedEnumIntervalTypeFilter = {
  equals?: InputMaybe<IntervalType>;
  in?: InputMaybe<Array<IntervalType>>;
  not?: InputMaybe<NestedEnumIntervalTypeFilter>;
  notIn?: InputMaybe<Array<IntervalType>>;
};

export type NestedEnumLogTypeFilter = {
  equals?: InputMaybe<LogType>;
  in?: InputMaybe<Array<LogType>>;
  not?: InputMaybe<NestedEnumLogTypeFilter>;
  notIn?: InputMaybe<Array<LogType>>;
};

export type NestedEnumMroBillableTypeFilter = {
  equals?: InputMaybe<MroBillableType>;
  in?: InputMaybe<Array<MroBillableType>>;
  not?: InputMaybe<NestedEnumMroBillableTypeFilter>;
  notIn?: InputMaybe<Array<MroBillableType>>;
};

export type NestedEnumMroDocumentTemplateTypeFilter = {
  equals?: InputMaybe<MroDocumentTemplateType>;
  in?: InputMaybe<Array<MroDocumentTemplateType>>;
  not?: InputMaybe<NestedEnumMroDocumentTemplateTypeFilter>;
  notIn?: InputMaybe<Array<MroDocumentTemplateType>>;
};

export type NestedEnumMroFeeTypeFilter = {
  equals?: InputMaybe<MroFeeType>;
  in?: InputMaybe<Array<MroFeeType>>;
  not?: InputMaybe<NestedEnumMroFeeTypeFilter>;
  notIn?: InputMaybe<Array<MroFeeType>>;
};

export type NestedEnumPartConditionNullableFilter = {
  equals?: InputMaybe<PartCondition>;
  in?: InputMaybe<Array<PartCondition>>;
  not?: InputMaybe<NestedEnumPartConditionNullableFilter>;
  notIn?: InputMaybe<Array<PartCondition>>;
};

export type NestedEnumRegisteredCraftClassNullableFilter = {
  equals?: InputMaybe<RegisteredCraftClass>;
  in?: InputMaybe<Array<RegisteredCraftClass>>;
  not?: InputMaybe<NestedEnumRegisteredCraftClassNullableFilter>;
  notIn?: InputMaybe<Array<RegisteredCraftClass>>;
};

export type NestedEnumRegisteredCraftTypeNullableFilter = {
  equals?: InputMaybe<RegisteredCraftType>;
  in?: InputMaybe<Array<RegisteredCraftType>>;
  not?: InputMaybe<NestedEnumRegisteredCraftTypeNullableFilter>;
  notIn?: InputMaybe<Array<RegisteredCraftType>>;
};

export type NestedEnumRegisteredEngineTypeNullableFilter = {
  equals?: InputMaybe<RegisteredEngineType>;
  in?: InputMaybe<Array<RegisteredEngineType>>;
  not?: InputMaybe<NestedEnumRegisteredEngineTypeNullableFilter>;
  notIn?: InputMaybe<Array<RegisteredEngineType>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumRoleNullableFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleNullableFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumSeverityNullableFilter = {
  equals?: InputMaybe<Severity>;
  in?: InputMaybe<Array<Severity>>;
  not?: InputMaybe<NestedEnumSeverityNullableFilter>;
  notIn?: InputMaybe<Array<Severity>>;
};

export type NestedEnumSignoffStatusFilter = {
  equals?: InputMaybe<SignoffStatus>;
  in?: InputMaybe<Array<SignoffStatus>>;
  not?: InputMaybe<NestedEnumSignoffStatusFilter>;
  notIn?: InputMaybe<Array<SignoffStatus>>;
};

export type NestedEnumStatusNullableFilter = {
  equals?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  not?: InputMaybe<NestedEnumStatusNullableFilter>;
  notIn?: InputMaybe<Array<Status>>;
};

export type NestedEnumTransactionStatusNullableFilter = {
  equals?: InputMaybe<TransactionStatus>;
  in?: InputMaybe<Array<TransactionStatus>>;
  not?: InputMaybe<NestedEnumTransactionStatusNullableFilter>;
  notIn?: InputMaybe<Array<TransactionStatus>>;
};

export type NestedEnumVolumeMeasurementFilter = {
  equals?: InputMaybe<VolumeMeasurement>;
  in?: InputMaybe<Array<VolumeMeasurement>>;
  not?: InputMaybe<NestedEnumVolumeMeasurementFilter>;
  notIn?: InputMaybe<Array<VolumeMeasurement>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type OnboardCraftInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCraftInput>;
  components?: InputMaybe<ComponentCreateNestedManyWithoutCraftInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutCraftInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutCraftInput>;
  engineCount: Scalars['Int'];
  flights?: InputMaybe<FlightCreateNestedManyWithoutCraftInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inspectionGroups?: InputMaybe<InspectionGroupCreateNestedManyWithoutCraftInput>;
  inspections?: InputMaybe<InspectionCreateNestedManyWithoutCraftInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalCreateNestedManyWithoutCraftInput>;
  intervalsCraft?: InputMaybe<Array<IntervalsForCraft>>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookCreateNestedManyWithoutCraftInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutCraftInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedManyWithoutCraftInput>;
  name: Scalars['String'];
  oilUnit?: InputMaybe<VolumeMeasurement>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutCraftInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutCraftInput>;
  tailNumber: Scalars['String'];
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordCreateNestedManyWithoutCraftInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type OnboardMroCustomerInput = {
  contact?: InputMaybe<MroContactInput>;
  craft: MroCraftInput;
  customer: MroCustomerInput;
  mroOrganizationId: Scalars['String'];
};

export type OnboardMroRequestInput = {
  craftId?: InputMaybe<Scalars['String']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutMroServiceRequestInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftCreateNestedOneWithoutMroServiceRequestsInput>;
  mroCustomer?: InputMaybe<MroCustomerCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganization?: InputMaybe<MroOrganizationCreateNestedOneWithoutMroServiceRequestsInput>;
  mroOrganizationId: Scalars['String'];
  mroWorkOrder?: InputMaybe<MroWorkOrderCreateNestedOneWithoutMroServiceRequestInput>;
  notes?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  serviceRequestNum?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroServiceRequestVersionCreateNestedManyWithoutMroServiceRequestInput>;
  workType?: InputMaybe<Scalars['String']>;
};

export type OnboardOrganization = {
  __typename?: 'OnboardOrganization';
  _count: OrganizationCount;
  accessToken?: Maybe<Scalars['String']>;
  adminPayMonthlyContribution?: Maybe<Scalars['Boolean']>;
  airblyGroupUuid?: Maybe<Scalars['String']>;
  airblyReadKey?: Maybe<Scalars['String']>;
  aircraftLimit?: Maybe<Scalars['Int']>;
  allowAnnouncements?: Maybe<Scalars['Boolean']>;
  allowComments?: Maybe<Scalars['Boolean']>;
  announcements?: Maybe<Array<Announcement>>;
  billingAddress?: Maybe<Scalars['JSON']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingEnabledByDefault?: Maybe<Scalars['Boolean']>;
  billingPhone?: Maybe<Scalars['String']>;
  cbInfo?: Maybe<Scalars['JSON']>;
  coupons?: Maybe<Array<Coupon>>;
  crafts?: Maybe<Array<Craft>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<Document>>;
  favoriteRoutes?: Maybe<Array<FavoriteRoute>>;
  flightBillingEnabled?: Maybe<Scalars['Boolean']>;
  flightPurposes?: Maybe<Array<FlightPurpose>>;
  freeAircrafts?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  imports?: Maybe<Array<Import>>;
  inspectionFreeLimit: Scalars['Int'];
  intergations?: Maybe<Array<Integration>>;
  legacyId?: Maybe<Scalars['String']>;
  monthlyContribution?: Maybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: Maybe<Scalars['Boolean']>;
  mroCustomers?: Maybe<Array<MroCustomer>>;
  mroOrganizations?: Maybe<Array<MroOrganization>>;
  myRole?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationType: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
  reservationSettings?: Maybe<Scalars['JSON']>;
  setupStatus?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['String']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  stripeConnectId?: Maybe<Scalars['String']>;
  stripeInfo?: Maybe<Scalars['JSON']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  supportedPaymentMethod: Scalars['String'];
  totalOwed: Scalars['Decimal'];
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userOrganizationProfiles?: Maybe<Array<UserOrganizationProfile>>;
  userOrganizationRoles?: Maybe<Array<UserOrganizationRole>>;
  users?: Maybe<Array<User>>;
  wallets?: Maybe<Array<Wallet>>;
};

export type OnboardOrganizationInput = {
  craft: OnboardCraftInput;
  organization: OrganizationCreateInput;
};

export type OrgInfo = {
  __typename?: 'OrgInfo';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  estimateAuthorization?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type Organization = {
  __typename?: 'Organization';
  _count: OrganizationCount;
  adminPayMonthlyContribution?: Maybe<Scalars['Boolean']>;
  airblyGroupUuid?: Maybe<Scalars['String']>;
  airblyReadKey?: Maybe<Scalars['String']>;
  aircraftLimit?: Maybe<Scalars['Int']>;
  allowAnnouncements?: Maybe<Scalars['Boolean']>;
  allowComments?: Maybe<Scalars['Boolean']>;
  announcements?: Maybe<Array<Announcement>>;
  billingAddress?: Maybe<Scalars['JSON']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingEnabledByDefault?: Maybe<Scalars['Boolean']>;
  billingPhone?: Maybe<Scalars['String']>;
  cbInfo?: Maybe<Scalars['JSON']>;
  coupons?: Maybe<Array<Coupon>>;
  crafts?: Maybe<Array<Craft>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<Document>>;
  favoriteRoutes?: Maybe<Array<FavoriteRoute>>;
  flightBillingEnabled?: Maybe<Scalars['Boolean']>;
  flightPurposes?: Maybe<Array<FlightPurpose>>;
  freeAircrafts?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  imports?: Maybe<Array<Import>>;
  inspectionFreeLimit: Scalars['Int'];
  intergations?: Maybe<Array<Integration>>;
  legacyId?: Maybe<Scalars['String']>;
  monthlyContribution?: Maybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: Maybe<Scalars['Boolean']>;
  mroCustomers?: Maybe<Array<MroCustomer>>;
  mroOrganizations?: Maybe<Array<MroOrganization>>;
  myRole?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationType: Scalars['String'];
  reservationSettings?: Maybe<Scalars['JSON']>;
  setupStatus?: Maybe<Scalars['JSON']>;
  slug?: Maybe<Scalars['String']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  stripeConnectId?: Maybe<Scalars['String']>;
  stripeInfo?: Maybe<Scalars['JSON']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  supportedPaymentMethod: Scalars['String'];
  totalOwed: Scalars['Decimal'];
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userOrganizationProfiles?: Maybe<Array<UserOrganizationProfile>>;
  userOrganizationRoles?: Maybe<Array<UserOrganizationRole>>;
  users?: Maybe<Array<User>>;
  wallets?: Maybe<Array<Wallet>>;
};

export type OrganizationAvgAggregate = {
  __typename?: 'OrganizationAvgAggregate';
  aircraftLimit?: Maybe<Scalars['Float']>;
  freeAircrafts?: Maybe<Scalars['Float']>;
  monthlyContribution?: Maybe<Scalars['Decimal']>;
};

export type OrganizationCount = {
  __typename?: 'OrganizationCount';
  announcements: Scalars['Int'];
  coupons: Scalars['Int'];
  crafts: Scalars['Int'];
  documents: Scalars['Int'];
  favoriteRoutes: Scalars['Int'];
  flightPurposes: Scalars['Int'];
  imports: Scalars['Int'];
  intergations: Scalars['Int'];
  mroCustomers: Scalars['Int'];
  mroOrganizations: Scalars['Int'];
  userOrganizationProfiles: Scalars['Int'];
  userOrganizationRoles: Scalars['Int'];
  users: Scalars['Int'];
  wallets: Scalars['Int'];
};

export type OrganizationCountAggregate = {
  __typename?: 'OrganizationCountAggregate';
  _all: Scalars['Int'];
  adminPayMonthlyContribution: Scalars['Int'];
  airblyGroupUuid: Scalars['Int'];
  airblyReadKey: Scalars['Int'];
  aircraftLimit: Scalars['Int'];
  allowAnnouncements: Scalars['Int'];
  allowComments: Scalars['Int'];
  billingAddress: Scalars['Int'];
  billingEmail: Scalars['Int'];
  billingEnabledByDefault: Scalars['Int'];
  billingPhone: Scalars['Int'];
  cbInfo: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  flightBillingEnabled: Scalars['Int'];
  freeAircrafts: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  monthlyContribution: Scalars['Int'];
  monthlyContributionEnabled: Scalars['Int'];
  name: Scalars['Int'];
  organizationType: Scalars['Int'];
  reservationSettings: Scalars['Int'];
  setupStatus: Scalars['Int'];
  slug: Scalars['Int'];
  specialBillingEnabled: Scalars['Int'];
  stripeConnectId: Scalars['Int'];
  stripeInfo: Scalars['Int'];
  stripeSubscriptionId: Scalars['Int'];
  supportedPaymentMethod: Scalars['Int'];
  trialEndsAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type OrganizationCreateInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateNestedManyWithoutCouponsInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutCouponsInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutCouponsInput>>;
};

export type OrganizationCreateNestedManyWithoutMroOrganizationsInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutMroOrganizationsInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutMroOrganizationsInput>>;
};

export type OrganizationCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutUsersInput>>;
};

export type OrganizationCreateNestedOneWithoutAnnouncementsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAnnouncementsInput>;
  create?: InputMaybe<OrganizationCreateWithoutAnnouncementsInput>;
};

export type OrganizationCreateNestedOneWithoutCraftsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCraftsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCraftsInput>;
};

export type OrganizationCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<OrganizationCreateWithoutDocumentsInput>;
};

export type OrganizationCreateNestedOneWithoutFavoriteRoutesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutFavoriteRoutesInput>;
  create?: InputMaybe<OrganizationCreateWithoutFavoriteRoutesInput>;
};

export type OrganizationCreateNestedOneWithoutFlightPurposesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutFlightPurposesInput>;
  create?: InputMaybe<OrganizationCreateWithoutFlightPurposesInput>;
};

export type OrganizationCreateNestedOneWithoutImportsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutImportsInput>;
  create?: InputMaybe<OrganizationCreateWithoutImportsInput>;
};

export type OrganizationCreateNestedOneWithoutMroCustomersInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutMroCustomersInput>;
  create?: InputMaybe<OrganizationCreateWithoutMroCustomersInput>;
};

export type OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUserOrganizationProfilesInput>;
  create?: InputMaybe<OrganizationCreateWithoutUserOrganizationProfilesInput>;
};

export type OrganizationCreateNestedOneWithoutUserOrganizationRolesInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUserOrganizationRolesInput>;
  create?: InputMaybe<OrganizationCreateWithoutUserOrganizationRolesInput>;
};

export type OrganizationCreateNestedOneWithoutWalletsInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutWalletsInput>;
  create?: InputMaybe<OrganizationCreateWithoutWalletsInput>;
};

export type OrganizationCreateOrConnectWithoutAnnouncementsInput = {
  create: OrganizationCreateWithoutAnnouncementsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCouponsInput = {
  create: OrganizationCreateWithoutCouponsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutCraftsInput = {
  create: OrganizationCreateWithoutCraftsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutDocumentsInput = {
  create: OrganizationCreateWithoutDocumentsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutFavoriteRoutesInput = {
  create: OrganizationCreateWithoutFavoriteRoutesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutFlightPurposesInput = {
  create: OrganizationCreateWithoutFlightPurposesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutImportsInput = {
  create: OrganizationCreateWithoutImportsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutMroCustomersInput = {
  create: OrganizationCreateWithoutMroCustomersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutMroOrganizationsInput = {
  create: OrganizationCreateWithoutMroOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutUserOrganizationProfilesInput = {
  create: OrganizationCreateWithoutUserOrganizationProfilesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutUserOrganizationRolesInput = {
  create: OrganizationCreateWithoutUserOrganizationRolesInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutUsersInput = {
  create: OrganizationCreateWithoutUsersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateOrConnectWithoutWalletsInput = {
  create: OrganizationCreateWithoutWalletsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationCreateWithoutAnnouncementsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutCouponsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutCraftsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutDocumentsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutFavoriteRoutesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutFlightPurposesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutImportsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutMroCustomersInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutMroOrganizationsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutUserOrganizationProfilesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutUserOrganizationRolesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutUsersInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutOrganizationInput>;
};

export type OrganizationCreateWithoutWalletsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutOrganizationInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponCreateNestedManyWithoutOrganizationsInput>;
  crafts?: InputMaybe<CraftCreateNestedManyWithoutOrganizationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutOrganizationInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteCreateNestedManyWithoutOrganizationInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeCreateNestedManyWithoutOrganizationInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportCreateNestedManyWithoutOrganizationInput>;
  intergations?: InputMaybe<IntegrationCreateNestedManyWithoutOrganizationInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerCreateNestedManyWithoutOrganizationInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutOrganizationsInput>;
  name: Scalars['String'];
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutOrganizationInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleCreateNestedManyWithoutOrganizationInput>;
  users?: InputMaybe<UserCreateNestedManyWithoutOrganizationsInput>;
};

export type OrganizationListRelationFilter = {
  every?: InputMaybe<OrganizationWhereInput>;
  none?: InputMaybe<OrganizationWhereInput>;
  some?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationMaxAggregate = {
  __typename?: 'OrganizationMaxAggregate';
  adminPayMonthlyContribution?: Maybe<Scalars['Boolean']>;
  airblyGroupUuid?: Maybe<Scalars['String']>;
  airblyReadKey?: Maybe<Scalars['String']>;
  aircraftLimit?: Maybe<Scalars['Int']>;
  allowAnnouncements?: Maybe<Scalars['Boolean']>;
  allowComments?: Maybe<Scalars['Boolean']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingEnabledByDefault?: Maybe<Scalars['Boolean']>;
  billingPhone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightBillingEnabled?: Maybe<Scalars['Boolean']>;
  freeAircrafts?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  monthlyContribution?: Maybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  stripeConnectId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  supportedPaymentMethod?: Maybe<Scalars['String']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationMinAggregate = {
  __typename?: 'OrganizationMinAggregate';
  adminPayMonthlyContribution?: Maybe<Scalars['Boolean']>;
  airblyGroupUuid?: Maybe<Scalars['String']>;
  airblyReadKey?: Maybe<Scalars['String']>;
  aircraftLimit?: Maybe<Scalars['Int']>;
  allowAnnouncements?: Maybe<Scalars['Boolean']>;
  allowComments?: Maybe<Scalars['Boolean']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingEnabledByDefault?: Maybe<Scalars['Boolean']>;
  billingPhone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightBillingEnabled?: Maybe<Scalars['Boolean']>;
  freeAircrafts?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  monthlyContribution?: Maybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  organizationType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  stripeConnectId?: Maybe<Scalars['String']>;
  stripeSubscriptionId?: Maybe<Scalars['String']>;
  supportedPaymentMethod?: Maybe<Scalars['String']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationNullableScalarRelationFilter = {
  is?: InputMaybe<OrganizationWhereInput>;
  isNot?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum OrganizationOrderByRelevanceFieldEnum {
  AirblyGroupUuid = 'airblyGroupUuid',
  AirblyReadKey = 'airblyReadKey',
  BillingEmail = 'billingEmail',
  BillingPhone = 'billingPhone',
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name',
  OrganizationType = 'organizationType',
  Slug = 'slug',
  StripeConnectId = 'stripeConnectId',
  StripeSubscriptionId = 'stripeSubscriptionId',
  SupportedPaymentMethod = 'supportedPaymentMethod'
}

export type OrganizationOrderByRelevanceInput = {
  fields: Array<OrganizationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type OrganizationOrderByWithRelationInput = {
  _relevance?: InputMaybe<OrganizationOrderByRelevanceInput>;
  adminPayMonthlyContribution?: InputMaybe<SortOrderInput>;
  airblyGroupUuid?: InputMaybe<SortOrderInput>;
  airblyReadKey?: InputMaybe<SortOrderInput>;
  aircraftLimit?: InputMaybe<SortOrderInput>;
  allowAnnouncements?: InputMaybe<SortOrderInput>;
  allowComments?: InputMaybe<SortOrderInput>;
  announcements?: InputMaybe<AnnouncementOrderByRelationAggregateInput>;
  billingAddress?: InputMaybe<SortOrderInput>;
  billingEmail?: InputMaybe<SortOrderInput>;
  billingEnabledByDefault?: InputMaybe<SortOrderInput>;
  billingPhone?: InputMaybe<SortOrderInput>;
  cbInfo?: InputMaybe<SortOrderInput>;
  coupons?: InputMaybe<CouponOrderByRelationAggregateInput>;
  crafts?: InputMaybe<CraftOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  documents?: InputMaybe<DocumentOrderByRelationAggregateInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteOrderByRelationAggregateInput>;
  flightBillingEnabled?: InputMaybe<SortOrderInput>;
  flightPurposes?: InputMaybe<FlightPurposeOrderByRelationAggregateInput>;
  freeAircrafts?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imports?: InputMaybe<ImportOrderByRelationAggregateInput>;
  intergations?: InputMaybe<IntegrationOrderByRelationAggregateInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  monthlyContribution?: InputMaybe<SortOrderInput>;
  monthlyContributionEnabled?: InputMaybe<SortOrderInput>;
  mroCustomers?: InputMaybe<MroCustomerOrderByRelationAggregateInput>;
  mroOrganizations?: InputMaybe<MroOrganizationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  organizationType?: InputMaybe<SortOrder>;
  reservationSettings?: InputMaybe<SortOrderInput>;
  setupStatus?: InputMaybe<SortOrderInput>;
  slug?: InputMaybe<SortOrderInput>;
  specialBillingEnabled?: InputMaybe<SortOrderInput>;
  stripeConnectId?: InputMaybe<SortOrderInput>;
  stripeInfo?: InputMaybe<SortOrderInput>;
  stripeSubscriptionId?: InputMaybe<SortOrderInput>;
  supportedPaymentMethod?: InputMaybe<SortOrder>;
  trialEndsAt?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileOrderByRelationAggregateInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleOrderByRelationAggregateInput>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
  wallets?: InputMaybe<WalletOrderByRelationAggregateInput>;
};

export type OrganizationScalarRelationFilter = {
  is?: InputMaybe<OrganizationWhereInput>;
  isNot?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationScalarWhereInput = {
  AND?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  OR?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  adminPayMonthlyContribution?: InputMaybe<BoolNullableFilter>;
  airblyGroupUuid?: InputMaybe<StringNullableFilter>;
  airblyReadKey?: InputMaybe<StringNullableFilter>;
  aircraftLimit?: InputMaybe<IntNullableFilter>;
  allowAnnouncements?: InputMaybe<BoolNullableFilter>;
  allowComments?: InputMaybe<BoolNullableFilter>;
  billingAddress?: InputMaybe<JsonNullableFilter>;
  billingEmail?: InputMaybe<StringNullableFilter>;
  billingEnabledByDefault?: InputMaybe<BoolNullableFilter>;
  billingPhone?: InputMaybe<StringNullableFilter>;
  cbInfo?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flightBillingEnabled?: InputMaybe<BoolNullableFilter>;
  freeAircrafts?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  monthlyContribution?: InputMaybe<DecimalNullableFilter>;
  monthlyContributionEnabled?: InputMaybe<BoolNullableFilter>;
  name?: InputMaybe<StringFilter>;
  organizationType?: InputMaybe<StringFilter>;
  reservationSettings?: InputMaybe<JsonNullableFilter>;
  setupStatus?: InputMaybe<JsonNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  specialBillingEnabled?: InputMaybe<BoolNullableFilter>;
  stripeConnectId?: InputMaybe<StringNullableFilter>;
  stripeInfo?: InputMaybe<JsonNullableFilter>;
  stripeSubscriptionId?: InputMaybe<StringNullableFilter>;
  supportedPaymentMethod?: InputMaybe<StringFilter>;
  trialEndsAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrganizationSumAggregate = {
  __typename?: 'OrganizationSumAggregate';
  aircraftLimit?: Maybe<Scalars['Int']>;
  freeAircrafts?: Maybe<Scalars['Int']>;
  monthlyContribution?: Maybe<Scalars['Decimal']>;
};

export type OrganizationUpdateInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateManyMutationInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type OrganizationUpdateManyWithWhereWithoutCouponsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutMroOrganizationsInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithWhereWithoutUsersInput = {
  data: OrganizationUpdateManyMutationInput;
  where: OrganizationScalarWhereInput;
};

export type OrganizationUpdateManyWithoutCouponsNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutCouponsInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutCouponsInput>>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutCouponsInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutCouponsInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutCouponsInput>>;
};

export type OrganizationUpdateManyWithoutMroOrganizationsNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutMroOrganizationsInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutMroOrganizationsInput>>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutMroOrganizationsInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutMroOrganizationsInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutMroOrganizationsInput>>;
};

export type OrganizationUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrganizationCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<OrganizationCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrganizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  set?: InputMaybe<Array<OrganizationWhereUniqueInput>>;
  update?: InputMaybe<Array<OrganizationUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<OrganizationUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<OrganizationUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type OrganizationUpdateOneRequiredWithoutAnnouncementsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutAnnouncementsInput>;
  create?: InputMaybe<OrganizationCreateWithoutAnnouncementsInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutAnnouncementsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutAnnouncementsInput>;
};

export type OrganizationUpdateOneWithoutCraftsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutCraftsInput>;
  create?: InputMaybe<OrganizationCreateWithoutCraftsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutCraftsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutCraftsInput>;
};

export type OrganizationUpdateOneWithoutDocumentsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<OrganizationCreateWithoutDocumentsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutDocumentsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutDocumentsInput>;
};

export type OrganizationUpdateOneWithoutFavoriteRoutesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutFavoriteRoutesInput>;
  create?: InputMaybe<OrganizationCreateWithoutFavoriteRoutesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutFavoriteRoutesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutFavoriteRoutesInput>;
};

export type OrganizationUpdateOneWithoutFlightPurposesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutFlightPurposesInput>;
  create?: InputMaybe<OrganizationCreateWithoutFlightPurposesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutFlightPurposesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutFlightPurposesInput>;
};

export type OrganizationUpdateOneWithoutImportsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutImportsInput>;
  create?: InputMaybe<OrganizationCreateWithoutImportsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutImportsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutImportsInput>;
};

export type OrganizationUpdateOneWithoutMroCustomersNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutMroCustomersInput>;
  create?: InputMaybe<OrganizationCreateWithoutMroCustomersInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutMroCustomersInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutMroCustomersInput>;
};

export type OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUserOrganizationProfilesInput>;
  create?: InputMaybe<OrganizationCreateWithoutUserOrganizationProfilesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutUserOrganizationProfilesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutUserOrganizationProfilesInput>;
};

export type OrganizationUpdateOneWithoutUserOrganizationRolesNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutUserOrganizationRolesInput>;
  create?: InputMaybe<OrganizationCreateWithoutUserOrganizationRolesInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutUserOrganizationRolesInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutUserOrganizationRolesInput>;
};

export type OrganizationUpdateOneWithoutWalletsNestedInput = {
  connect?: InputMaybe<OrganizationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrganizationCreateOrConnectWithoutWalletsInput>;
  create?: InputMaybe<OrganizationCreateWithoutWalletsInput>;
  delete?: InputMaybe<OrganizationWhereInput>;
  disconnect?: InputMaybe<OrganizationWhereInput>;
  update?: InputMaybe<OrganizationUpdateToOneWithWhereWithoutWalletsInput>;
  upsert?: InputMaybe<OrganizationUpsertWithoutWalletsInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutAnnouncementsInput = {
  data: OrganizationUpdateWithoutAnnouncementsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutCraftsInput = {
  data: OrganizationUpdateWithoutCraftsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutDocumentsInput = {
  data: OrganizationUpdateWithoutDocumentsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutFavoriteRoutesInput = {
  data: OrganizationUpdateWithoutFavoriteRoutesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutFlightPurposesInput = {
  data: OrganizationUpdateWithoutFlightPurposesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutImportsInput = {
  data: OrganizationUpdateWithoutImportsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutMroCustomersInput = {
  data: OrganizationUpdateWithoutMroCustomersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutUserOrganizationProfilesInput = {
  data: OrganizationUpdateWithoutUserOrganizationProfilesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutUserOrganizationRolesInput = {
  data: OrganizationUpdateWithoutUserOrganizationRolesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateToOneWithWhereWithoutWalletsInput = {
  data: OrganizationUpdateWithoutWalletsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpdateWithWhereUniqueWithoutCouponsInput = {
  data: OrganizationUpdateWithoutCouponsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutMroOrganizationsInput = {
  data: OrganizationUpdateWithoutMroOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithWhereUniqueWithoutUsersInput = {
  data: OrganizationUpdateWithoutUsersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpdateWithoutAnnouncementsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutCouponsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutCraftsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutDocumentsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutFavoriteRoutesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutFlightPurposesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutImportsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutMroCustomersInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutMroOrganizationsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutUserOrganizationProfilesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutUserOrganizationRolesInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutUsersInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutOrganizationNestedInput>;
};

export type OrganizationUpdateWithoutWalletsInput = {
  adminPayMonthlyContribution?: InputMaybe<Scalars['Boolean']>;
  airblyGroupUuid?: InputMaybe<Scalars['String']>;
  airblyReadKey?: InputMaybe<Scalars['String']>;
  aircraftLimit?: InputMaybe<Scalars['Int']>;
  allowAnnouncements?: InputMaybe<Scalars['Boolean']>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutOrganizationNestedInput>;
  billingAddress?: InputMaybe<Scalars['JSON']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingEnabledByDefault?: InputMaybe<Scalars['Boolean']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  cbInfo?: InputMaybe<Scalars['JSON']>;
  coupons?: InputMaybe<CouponUpdateManyWithoutOrganizationsNestedInput>;
  crafts?: InputMaybe<CraftUpdateManyWithoutOrganizationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutOrganizationNestedInput>;
  favoriteRoutes?: InputMaybe<FavoriteRouteUpdateManyWithoutOrganizationNestedInput>;
  flightBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  flightPurposes?: InputMaybe<FlightPurposeUpdateManyWithoutOrganizationNestedInput>;
  freeAircrafts?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportUpdateManyWithoutOrganizationNestedInput>;
  intergations?: InputMaybe<IntegrationUpdateManyWithoutOrganizationNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<Scalars['Decimal']>;
  monthlyContributionEnabled?: InputMaybe<Scalars['Boolean']>;
  mroCustomers?: InputMaybe<MroCustomerUpdateManyWithoutOrganizationNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutOrganizationsNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  organizationType?: InputMaybe<Scalars['String']>;
  reservationSettings?: InputMaybe<Scalars['JSON']>;
  setupStatus?: InputMaybe<Scalars['JSON']>;
  slug?: InputMaybe<Scalars['String']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  stripeConnectId?: InputMaybe<Scalars['String']>;
  stripeInfo?: InputMaybe<Scalars['JSON']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']>;
  supportedPaymentMethod?: InputMaybe<Scalars['String']>;
  trialEndsAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput>;
  users?: InputMaybe<UserUpdateManyWithoutOrganizationsNestedInput>;
};

export type OrganizationUpsertWithWhereUniqueWithoutCouponsInput = {
  create: OrganizationCreateWithoutCouponsInput;
  update: OrganizationUpdateWithoutCouponsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutMroOrganizationsInput = {
  create: OrganizationCreateWithoutMroOrganizationsInput;
  update: OrganizationUpdateWithoutMroOrganizationsInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithWhereUniqueWithoutUsersInput = {
  create: OrganizationCreateWithoutUsersInput;
  update: OrganizationUpdateWithoutUsersInput;
  where: OrganizationWhereUniqueInput;
};

export type OrganizationUpsertWithoutAnnouncementsInput = {
  create: OrganizationCreateWithoutAnnouncementsInput;
  update: OrganizationUpdateWithoutAnnouncementsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutCraftsInput = {
  create: OrganizationCreateWithoutCraftsInput;
  update: OrganizationUpdateWithoutCraftsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutDocumentsInput = {
  create: OrganizationCreateWithoutDocumentsInput;
  update: OrganizationUpdateWithoutDocumentsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutFavoriteRoutesInput = {
  create: OrganizationCreateWithoutFavoriteRoutesInput;
  update: OrganizationUpdateWithoutFavoriteRoutesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutFlightPurposesInput = {
  create: OrganizationCreateWithoutFlightPurposesInput;
  update: OrganizationUpdateWithoutFlightPurposesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutImportsInput = {
  create: OrganizationCreateWithoutImportsInput;
  update: OrganizationUpdateWithoutImportsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutMroCustomersInput = {
  create: OrganizationCreateWithoutMroCustomersInput;
  update: OrganizationUpdateWithoutMroCustomersInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutUserOrganizationProfilesInput = {
  create: OrganizationCreateWithoutUserOrganizationProfilesInput;
  update: OrganizationUpdateWithoutUserOrganizationProfilesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutUserOrganizationRolesInput = {
  create: OrganizationCreateWithoutUserOrganizationRolesInput;
  update: OrganizationUpdateWithoutUserOrganizationRolesInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationUpsertWithoutWalletsInput = {
  create: OrganizationCreateWithoutWalletsInput;
  update: OrganizationUpdateWithoutWalletsInput;
  where?: InputMaybe<OrganizationWhereInput>;
};

export type OrganizationWhereInput = {
  AND?: InputMaybe<Array<OrganizationWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationWhereInput>>;
  OR?: InputMaybe<Array<OrganizationWhereInput>>;
  adminPayMonthlyContribution?: InputMaybe<BoolNullableFilter>;
  airblyGroupUuid?: InputMaybe<StringNullableFilter>;
  airblyReadKey?: InputMaybe<StringNullableFilter>;
  aircraftLimit?: InputMaybe<IntNullableFilter>;
  allowAnnouncements?: InputMaybe<BoolNullableFilter>;
  allowComments?: InputMaybe<BoolNullableFilter>;
  announcements?: InputMaybe<AnnouncementListRelationFilter>;
  billingAddress?: InputMaybe<JsonNullableFilter>;
  billingEmail?: InputMaybe<StringNullableFilter>;
  billingEnabledByDefault?: InputMaybe<BoolNullableFilter>;
  billingPhone?: InputMaybe<StringNullableFilter>;
  cbInfo?: InputMaybe<JsonNullableFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  crafts?: InputMaybe<CraftListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  favoriteRoutes?: InputMaybe<FavoriteRouteListRelationFilter>;
  flightBillingEnabled?: InputMaybe<BoolNullableFilter>;
  flightPurposes?: InputMaybe<FlightPurposeListRelationFilter>;
  freeAircrafts?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imports?: InputMaybe<ImportListRelationFilter>;
  intergations?: InputMaybe<IntegrationListRelationFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  monthlyContribution?: InputMaybe<DecimalNullableFilter>;
  monthlyContributionEnabled?: InputMaybe<BoolNullableFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroOrganizations?: InputMaybe<MroOrganizationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organizationType?: InputMaybe<StringFilter>;
  reservationSettings?: InputMaybe<JsonNullableFilter>;
  setupStatus?: InputMaybe<JsonNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  specialBillingEnabled?: InputMaybe<BoolNullableFilter>;
  stripeConnectId?: InputMaybe<StringNullableFilter>;
  stripeInfo?: InputMaybe<JsonNullableFilter>;
  stripeSubscriptionId?: InputMaybe<StringNullableFilter>;
  supportedPaymentMethod?: InputMaybe<StringFilter>;
  trialEndsAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileListRelationFilter>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleListRelationFilter>;
  users?: InputMaybe<UserListRelationFilter>;
  wallets?: InputMaybe<WalletListRelationFilter>;
};

export type OrganizationWhereUniqueInput = {
  AND?: InputMaybe<Array<OrganizationWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationWhereInput>>;
  OR?: InputMaybe<Array<OrganizationWhereInput>>;
  adminPayMonthlyContribution?: InputMaybe<BoolNullableFilter>;
  airblyGroupUuid?: InputMaybe<StringNullableFilter>;
  airblyReadKey?: InputMaybe<StringNullableFilter>;
  aircraftLimit?: InputMaybe<IntNullableFilter>;
  allowAnnouncements?: InputMaybe<BoolNullableFilter>;
  allowComments?: InputMaybe<BoolNullableFilter>;
  announcements?: InputMaybe<AnnouncementListRelationFilter>;
  billingAddress?: InputMaybe<JsonNullableFilter>;
  billingEmail?: InputMaybe<StringNullableFilter>;
  billingEnabledByDefault?: InputMaybe<BoolNullableFilter>;
  billingPhone?: InputMaybe<StringNullableFilter>;
  cbInfo?: InputMaybe<JsonNullableFilter>;
  coupons?: InputMaybe<CouponListRelationFilter>;
  crafts?: InputMaybe<CraftListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  favoriteRoutes?: InputMaybe<FavoriteRouteListRelationFilter>;
  flightBillingEnabled?: InputMaybe<BoolNullableFilter>;
  flightPurposes?: InputMaybe<FlightPurposeListRelationFilter>;
  freeAircrafts?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  imports?: InputMaybe<ImportListRelationFilter>;
  intergations?: InputMaybe<IntegrationListRelationFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  monthlyContribution?: InputMaybe<DecimalNullableFilter>;
  monthlyContributionEnabled?: InputMaybe<BoolNullableFilter>;
  mroCustomers?: InputMaybe<MroCustomerListRelationFilter>;
  mroOrganizations?: InputMaybe<MroOrganizationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  organizationType?: InputMaybe<StringFilter>;
  reservationSettings?: InputMaybe<JsonNullableFilter>;
  setupStatus?: InputMaybe<JsonNullableFilter>;
  slug?: InputMaybe<StringNullableFilter>;
  specialBillingEnabled?: InputMaybe<BoolNullableFilter>;
  stripeConnectId?: InputMaybe<StringNullableFilter>;
  stripeInfo?: InputMaybe<JsonNullableFilter>;
  stripeSubscriptionId?: InputMaybe<StringNullableFilter>;
  supportedPaymentMethod?: InputMaybe<StringFilter>;
  trialEndsAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileListRelationFilter>;
  userOrganizationRoles?: InputMaybe<UserOrganizationRoleListRelationFilter>;
  users?: InputMaybe<UserListRelationFilter>;
  wallets?: InputMaybe<WalletListRelationFilter>;
};

export enum PartCondition {
  AsRemoved = 'AS_REMOVED',
  Core = 'CORE',
  Inspected = 'INSPECTED',
  New = 'NEW',
  Overhauled = 'OVERHAULED',
  Refurbished = 'REFURBISHED',
  Serviceable = 'SERVICEABLE',
  Used = 'USED'
}

export type Query = {
  __typename?: 'Query';
  actions: Scalars['JSON'];
  adsForCraft: Array<RegisteredAirworthyDirective>;
  airport?: Maybe<Airport>;
  airportCount?: Maybe<Scalars['Int']>;
  airports?: Maybe<Array<Airport>>;
  announcement?: Maybe<Announcement>;
  announcementCount?: Maybe<Scalars['Int']>;
  announcements?: Maybe<Array<Announcement>>;
  attachment: Attachment;
  attachments: Array<Attachment>;
  aviationWeather: Scalars['String'];
  caslRules?: Maybe<Scalars['JSON']>;
  chargebeePortal: Scalars['String'];
  chargebeeSubcriptionInfo?: Maybe<ChargebeeSubscription>;
  checkIfUserHasInvite: Scalars['Boolean'];
  comment?: Maybe<Comment>;
  commentCount?: Maybe<Scalars['Int']>;
  comments?: Maybe<Array<Comment>>;
  component?: Maybe<Component>;
  componentCount?: Maybe<Scalars['Int']>;
  components?: Maybe<Array<Component>>;
  coupon?: Maybe<Coupon>;
  couponCount?: Maybe<Scalars['Int']>;
  coupons?: Maybe<Array<Coupon>>;
  craft: Craft;
  craftServiceRequest?: Maybe<CraftServiceRequest>;
  craftServiceRequestCount?: Maybe<Scalars['Int']>;
  craftServiceRequests?: Maybe<Array<CraftServiceRequest>>;
  crafts: Array<Craft>;
  document?: Maybe<Document>;
  documentCount?: Maybe<Scalars['Int']>;
  documents?: Maybe<Array<Document>>;
  favoriteRoute?: Maybe<FavoriteRoute>;
  favoriteRouteCount?: Maybe<Scalars['Int']>;
  favoriteRoutes?: Maybe<Array<FavoriteRoute>>;
  findOrganizationAirsyncTails: Array<AirSyncTail>;
  flight?: Maybe<Flight>;
  flightCount?: Maybe<Scalars['Int']>;
  flightPurpose?: Maybe<FlightPurpose>;
  flightPurposeCount?: Maybe<Scalars['Int']>;
  flightPurposes?: Maybe<Array<FlightPurpose>>;
  flights?: Maybe<Array<Flight>>;
  foreflightLoginLink: Scalars['String'];
  fuelOilReports: Array<FuelOilReport>;
  getCouponCode: Coupon;
  getInvitation: UserOrganizationProfile;
  getMroOrganizationLocations: Array<MroLocation>;
  getMroOrganizationName: Scalars['String'];
  getPublicMroOrganizationsInfo: Array<OrgInfo>;
  hasCompletedWalkthrough: Scalars['Boolean'];
  hello: Scalars['String'];
  helloWorld: Scalars['String'];
  import?: Maybe<Import>;
  importCount?: Maybe<Scalars['Int']>;
  imports?: Maybe<Array<Import>>;
  inspection?: Maybe<Inspection>;
  inspectionCount?: Maybe<Scalars['Int']>;
  inspectionGroup?: Maybe<InspectionGroup>;
  inspectionGroupCount?: Maybe<Scalars['Int']>;
  inspectionGroups?: Maybe<Array<InspectionGroup>>;
  inspections?: Maybe<Array<Inspection>>;
  interval?: Maybe<Interval>;
  intervalCount?: Maybe<Scalars['Int']>;
  intervalLog: IntervalLog;
  intervalLogs: Array<IntervalLog>;
  intervals?: Maybe<Array<Interval>>;
  intervalsOnInspections?: Maybe<IntervalsOnInspections>;
  intervalsOnInspectionsCount?: Maybe<Scalars['Int']>;
  intervalsOnInspectionss?: Maybe<Array<IntervalsOnInspections>>;
  isSignedInToLegacy: Scalars['Boolean'];
  jascCategories: Array<JascCategory>;
  jascCategory: JascCategory;
  jascSystem: JascSystem;
  jascSystems: Array<JascSystem>;
  lastEstimate: MroEstimate;
  lastInvoice: MroInvoice;
  lastPartOrder: MroPartOrder;
  logBook?: Maybe<LogBook>;
  logBookCount?: Maybe<Scalars['Int']>;
  logBooks?: Maybe<Array<LogBook>>;
  logEntries?: Maybe<Array<LogEntry>>;
  logEntry?: Maybe<LogEntry>;
  logEntryCount?: Maybe<Scalars['Int']>;
  maintenanceRecord?: Maybe<MaintenanceRecord>;
  maintenanceRecordCount?: Maybe<Scalars['Int']>;
  maintenanceRecords?: Maybe<Array<MaintenanceRecord>>;
  me: User;
  migrateInfo: MigrateInfo;
  mroActions: Scalars['JSON'];
  mroAddress?: Maybe<MroAddress>;
  mroAddressCount?: Maybe<Scalars['Int']>;
  mroAddresss?: Maybe<Array<MroAddress>>;
  mroCommunicationThread: MroCommunicationThread;
  mroCommunicationThreads: Array<MroCommunicationThread>;
  mroComponent: MroComponent;
  mroComponents: Array<MroComponent>;
  mroCraft?: Maybe<MroCraft>;
  mroCraftCount?: Maybe<Scalars['Int']>;
  mroCrafts?: Maybe<Array<MroCraft>>;
  mroCustomer?: Maybe<MroCustomer>;
  mroCustomerCount?: Maybe<Scalars['Int']>;
  mroCustomers?: Maybe<Array<MroCustomer>>;
  mroDocumentTemplate?: Maybe<MroDocumentTemplate>;
  mroDocumentTemplateCount?: Maybe<Scalars['Int']>;
  mroDocumentTemplates?: Maybe<Array<MroDocumentTemplate>>;
  mroEmployeeProfile?: Maybe<MroEmployeeProfile>;
  mroEmployeeProfileCount?: Maybe<Scalars['Int']>;
  mroEmployeeProfiles?: Maybe<Array<MroEmployeeProfile>>;
  mroEstimate?: Maybe<MroEstimate>;
  mroEstimateCount?: Maybe<Scalars['Int']>;
  mroEstimateWithToken: MroEstimate;
  mroEstimates?: Maybe<Array<MroEstimate>>;
  mroInvoice?: Maybe<MroInvoice>;
  mroInvoiceCount?: Maybe<Scalars['Int']>;
  mroInvoiceWithToken: MroInvoice;
  mroInvoices?: Maybe<Array<MroInvoice>>;
  mroIssue: MroIssue;
  mroIssues: Array<MroIssue>;
  mroLaborEntries?: Maybe<Array<MroLaborEntry>>;
  mroLaborEntry?: Maybe<MroLaborEntry>;
  mroLaborEntryCount?: Maybe<Scalars['Int']>;
  mroLocation?: Maybe<MroLocation>;
  mroLocationCount?: Maybe<Scalars['Int']>;
  mroLocations?: Maybe<Array<MroLocation>>;
  mroLogEntries?: Maybe<Array<MroLogEntry>>;
  mroLogEntry?: Maybe<MroLogEntry>;
  mroLogEntryCount?: Maybe<Scalars['Int']>;
  mroLogEntryItem: MroLogEntryItem;
  mroLogEntryItems: Array<MroLogEntryItem>;
  mroOrganization?: Maybe<MroOrganization>;
  mroOrganizationCount?: Maybe<Scalars['Int']>;
  mroOrganizationFee?: Maybe<MroOrganizationFee>;
  mroOrganizationFeeCount?: Maybe<Scalars['Int']>;
  mroOrganizationFees?: Maybe<Array<MroOrganizationFee>>;
  mroOrganizationInfo: OrgInfo;
  mroOrganizations?: Maybe<Array<MroOrganization>>;
  mroPart?: Maybe<MroPart>;
  mroPartCount?: Maybe<Scalars['Int']>;
  mroPartInventories?: Maybe<Array<MroPartInventory>>;
  mroPartInventory?: Maybe<MroPartInventory>;
  mroPartInventoryCount?: Maybe<Scalars['Int']>;
  mroPartManufacturer?: Maybe<MroPartManufacturer>;
  mroPartManufacturerCount?: Maybe<Scalars['Int']>;
  mroPartManufacturers?: Maybe<Array<MroPartManufacturer>>;
  mroPartOrder?: Maybe<MroPartOrder>;
  mroPartOrderCount?: Maybe<Scalars['Int']>;
  mroPartOrderItem?: Maybe<MroPartOrderItem>;
  mroPartOrderItemCount?: Maybe<Scalars['Int']>;
  mroPartOrderItems?: Maybe<Array<MroPartOrderItem>>;
  mroPartOrders?: Maybe<Array<MroPartOrder>>;
  mroPartPriceMatrix?: Maybe<MroPartPriceMatrix>;
  mroPartPriceMatrixCount?: Maybe<Scalars['Int']>;
  mroPartPriceMatrixs?: Maybe<Array<MroPartPriceMatrix>>;
  mroPartSource: MroPartSource;
  mroPartSources: Array<MroPartSource>;
  mroPartVendor: MroPartVendor;
  mroPartVendors: Array<MroPartVendor>;
  mroPartWarehouse: MroPartWarehouse;
  mroPartWarehouses: Array<MroPartWarehouse>;
  mroParts?: Maybe<Array<MroPart>>;
  mroRTSText?: Maybe<MroRtsText>;
  mroRTSTextCount?: Maybe<Scalars['Int']>;
  mroRTSTexts?: Maybe<Array<MroRtsText>>;
  mroReport?: Maybe<MroReport>;
  mroReportCount?: Maybe<Scalars['Int']>;
  mroReports?: Maybe<Array<MroReport>>;
  mroRole?: Maybe<MroRole>;
  mroRoleCount?: Maybe<Scalars['Int']>;
  mroRoles?: Maybe<Array<MroRole>>;
  mroSerializedPart?: Maybe<MroSerializedPart>;
  mroSerializedPartCount?: Maybe<Scalars['Int']>;
  mroSerializedParts?: Maybe<Array<MroSerializedPart>>;
  mroServiceRequest?: Maybe<MroServiceRequest>;
  mroServiceRequestCount?: Maybe<Scalars['Int']>;
  mroServiceRequests?: Maybe<Array<MroServiceRequest>>;
  mroWorkOrder?: Maybe<MroWorkOrder>;
  mroWorkOrderBillingItem?: Maybe<MroWorkOrderBillingItem>;
  mroWorkOrderBillingItemCount?: Maybe<Scalars['Int']>;
  mroWorkOrderBillingItems?: Maybe<Array<MroWorkOrderBillingItem>>;
  mroWorkOrderCategories?: Maybe<Array<MroWorkOrderCategory>>;
  mroWorkOrderCategory?: Maybe<MroWorkOrderCategory>;
  mroWorkOrderCategoryCount?: Maybe<Scalars['Int']>;
  mroWorkOrderCount?: Maybe<Scalars['Int']>;
  mroWorkOrderInterval?: Maybe<MroWorkOrderInterval>;
  mroWorkOrderIntervalCount?: Maybe<Scalars['Int']>;
  mroWorkOrderIntervals?: Maybe<Array<MroWorkOrderInterval>>;
  mroWorkOrderItem?: Maybe<MroWorkOrderItem>;
  mroWorkOrderItemCategories: Array<MroWorkOrderItemCategory>;
  mroWorkOrderItemCategory: MroWorkOrderItemCategory;
  mroWorkOrderItemCount?: Maybe<Scalars['Int']>;
  mroWorkOrderItems?: Maybe<Array<MroWorkOrderItem>>;
  mroWorkOrderPart: MroWorkOrderPart;
  mroWorkOrderParts: Array<MroWorkOrderPart>;
  mroWorkOrderSignoff?: Maybe<MroWorkOrderSignoff>;
  mroWorkOrderSignoffCount?: Maybe<Scalars['Int']>;
  mroWorkOrderSignoffs?: Maybe<Array<MroWorkOrderSignoff>>;
  mroWorkOrderTemplate: MroWorkOrderTemplate;
  mroWorkOrderTemplates: Array<MroWorkOrderTemplate>;
  mroWorkOrders?: Maybe<Array<MroWorkOrder>>;
  organization?: Maybe<Organization>;
  organizationAuth?: Maybe<Organization>;
  organizations: Array<Organization>;
  pendingFlightCount?: Maybe<Scalars['Int']>;
  pendingFlights?: Maybe<Array<Flight>>;
  registeredAirworthyDirectives: Array<RegisteredAirworthyDirective>;
  registrations: Array<Registration>;
  reportInfo: ReportInfo;
  reportTypes: Scalars['JSON'];
  reservation?: Maybe<Reservation>;
  reservationCount?: Maybe<Scalars['Int']>;
  reservations?: Maybe<Array<Reservation>>;
  reservationsCalendarLink?: Maybe<Scalars['String']>;
  squawk?: Maybe<Squawk>;
  squawkCount?: Maybe<Scalars['Int']>;
  squawks?: Maybe<Array<Squawk>>;
  stripeDashboard: Scalars['String'];
  stripePayBalance: Scalars['String'];
  stripePayPartial: Scalars['String'];
  stripePlans: Array<StripePlan>;
  stripeSubscription: StripeSubscription;
  transaction?: Maybe<Transaction>;
  transactionCount?: Maybe<Scalars['Int']>;
  transactions?: Maybe<Array<Transaction>>;
  usageRecord: UsageRecord;
  usageRecords: Array<UsageRecord>;
  userOrganizationProfile?: Maybe<UserOrganizationProfile>;
  userOrganizationProfileCount?: Maybe<Scalars['Int']>;
  userOrganizationProfiles?: Maybe<Array<UserOrganizationProfile>>;
  userOrganizationRole?: Maybe<UserOrganizationRole>;
  userOrganizationRoleCount?: Maybe<Scalars['Int']>;
  userOrganizationRoles?: Maybe<Array<UserOrganizationRole>>;
  userWallet: Wallet;
  wallet?: Maybe<Wallet>;
  walletCount?: Maybe<Scalars['Int']>;
  wallets?: Maybe<Array<Wallet>>;
};


export type QueryAdsForCraftArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryAirportArgs = {
  id: Scalars['String'];
};


export type QueryAirportCountArgs = {
  where?: InputMaybe<AirportWhereInput>;
};


export type QueryAirportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AirportWhereInput>;
};


export type QueryAnnouncementArgs = {
  id: Scalars['String'];
};


export type QueryAnnouncementCountArgs = {
  where?: InputMaybe<AnnouncementWhereInput>;
};


export type QueryAnnouncementsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AnnouncementWhereInput>;
};


export type QueryAttachmentArgs = {
  id: Scalars['String'];
};


export type QueryAviationWeatherArgs = {
  icao: Scalars['String'];
};


export type QueryCaslRulesArgs = {
  orgType?: InputMaybe<Scalars['String']>;
};


export type QueryChargebeePortalArgs = {
  organizationId: Scalars['String'];
};


export type QueryChargebeeSubcriptionInfoArgs = {
  organizationId: Scalars['String'];
};


export type QueryCheckIfUserHasInviteArgs = {
  email: Scalars['String'];
};


export type QueryCommentArgs = {
  id: Scalars['String'];
};


export type QueryCommentCountArgs = {
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryCommentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryComponentArgs = {
  id: Scalars['String'];
};


export type QueryComponentCountArgs = {
  where?: InputMaybe<ComponentWhereInput>;
};


export type QueryComponentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ComponentWhereInput>;
};


export type QueryCouponArgs = {
  id: Scalars['String'];
};


export type QueryCouponCountArgs = {
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryCouponsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};


export type QueryCraftArgs = {
  id: Scalars['String'];
};


export type QueryCraftServiceRequestArgs = {
  id: Scalars['String'];
};


export type QueryCraftServiceRequestCountArgs = {
  where?: InputMaybe<CraftServiceRequestWhereInput>;
};


export type QueryCraftServiceRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CraftServiceRequestWhereInput>;
};


export type QueryCraftsArgs = {
  input?: InputMaybe<CraftWhereInput>;
};


export type QueryDocumentArgs = {
  id: Scalars['String'];
};


export type QueryDocumentCountArgs = {
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryFavoriteRouteArgs = {
  id: Scalars['String'];
};


export type QueryFavoriteRouteCountArgs = {
  where?: InputMaybe<FavoriteRouteWhereInput>;
};


export type QueryFavoriteRoutesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FavoriteRouteWhereInput>;
};


export type QueryFindOrganizationAirsyncTailsArgs = {
  organizationId: Scalars['String'];
};


export type QueryFlightArgs = {
  id: Scalars['String'];
};


export type QueryFlightCountArgs = {
  where?: InputMaybe<FlightWhereInput>;
};


export type QueryFlightPurposeArgs = {
  id: Scalars['String'];
};


export type QueryFlightPurposeCountArgs = {
  where?: InputMaybe<FlightPurposeWhereInput>;
};


export type QueryFlightPurposesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FlightPurposeWhereInput>;
};


export type QueryFlightsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlightOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FlightWhereInput>;
};


export type QueryFuelOilReportsArgs = {
  id: Scalars['String'];
};


export type QueryGetCouponCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetInvitationArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type QueryGetMroOrganizationLocationsArgs = {
  id: Scalars['String'];
};


export type QueryGetMroOrganizationNameArgs = {
  id: Scalars['String'];
};


export type QueryGetPublicMroOrganizationsInfoArgs = {
  where?: InputMaybe<MroOrganizationWhereInput>;
};


export type QueryHasCompletedWalkthroughArgs = {
  id: Scalars['String'];
};


export type QueryHelloArgs = {
  name: Scalars['String'];
};


export type QueryImportArgs = {
  id: Scalars['String'];
};


export type QueryImportCountArgs = {
  where?: InputMaybe<ImportWhereInput>;
};


export type QueryImportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ImportWhereInput>;
};


export type QueryInspectionArgs = {
  id: Scalars['String'];
};


export type QueryInspectionCountArgs = {
  where?: InputMaybe<InspectionWhereInput>;
};


export type QueryInspectionGroupArgs = {
  id: Scalars['String'];
};


export type QueryInspectionGroupCountArgs = {
  where?: InputMaybe<InspectionGroupWhereInput>;
};


export type QueryInspectionGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InspectionGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InspectionGroupWhereInput>;
};


export type QueryInspectionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InspectionWhereInput>;
};


export type QueryIntervalArgs = {
  id: Scalars['String'];
};


export type QueryIntervalCountArgs = {
  where?: InputMaybe<IntervalWhereInput>;
};


export type QueryIntervalLogArgs = {
  id: Scalars['String'];
};


export type QueryIntervalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IntervalWhereInput>;
};


export type QueryIntervalsOnInspectionsArgs = {
  id: Scalars['String'];
};


export type QueryIntervalsOnInspectionsCountArgs = {
  where?: InputMaybe<IntervalsOnInspectionsWhereInput>;
};


export type QueryIntervalsOnInspectionssArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IntervalsOnInspectionsWhereInput>;
};


export type QueryJascCategoryArgs = {
  id: Scalars['String'];
};


export type QueryJascSystemArgs = {
  id: Scalars['String'];
};


export type QueryLastEstimateArgs = {
  mroOrgId: Scalars['String'];
};


export type QueryLastInvoiceArgs = {
  mroOrgId: Scalars['String'];
};


export type QueryLastPartOrderArgs = {
  mroOrgId: Scalars['String'];
};


export type QueryLogBookArgs = {
  id: Scalars['String'];
};


export type QueryLogBookCountArgs = {
  where?: InputMaybe<LogBookWhereInput>;
};


export type QueryLogBooksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LogBookWhereInput>;
};


export type QueryLogEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LogEntryWhereInput>;
};


export type QueryLogEntryArgs = {
  id: Scalars['String'];
};


export type QueryLogEntryCountArgs = {
  where?: InputMaybe<LogEntryWhereInput>;
};


export type QueryMaintenanceRecordArgs = {
  id: Scalars['String'];
};


export type QueryMaintenanceRecordCountArgs = {
  where?: InputMaybe<MaintenanceRecordWhereInput>;
};


export type QueryMaintenanceRecordsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MaintenanceRecordWhereInput>;
};


export type QueryMigrateInfoArgs = {
  id: Scalars['String'];
  token: Scalars['String'];
};


export type QueryMroAddressArgs = {
  id: Scalars['String'];
};


export type QueryMroAddressCountArgs = {
  where?: InputMaybe<MroAddressWhereInput>;
};


export type QueryMroAddresssArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroAddressWhereInput>;
};


export type QueryMroCommunicationThreadArgs = {
  id: Scalars['String'];
};


export type QueryMroCommunicationThreadsArgs = {
  where?: InputMaybe<MroCommunicationThreadWhereInput>;
};


export type QueryMroComponentArgs = {
  id: Scalars['String'];
};


export type QueryMroComponentsArgs = {
  where: MroComponentWhereInput;
};


export type QueryMroCraftArgs = {
  id: Scalars['String'];
};


export type QueryMroCraftCountArgs = {
  where?: InputMaybe<MroCraftWhereInput>;
};


export type QueryMroCraftsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroCraftWhereInput>;
};


export type QueryMroCustomerArgs = {
  id: Scalars['String'];
};


export type QueryMroCustomerCountArgs = {
  where?: InputMaybe<MroCustomerWhereInput>;
};


export type QueryMroCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroCustomerWhereInput>;
};


export type QueryMroDocumentTemplateArgs = {
  id: Scalars['String'];
};


export type QueryMroDocumentTemplateCountArgs = {
  where?: InputMaybe<MroDocumentTemplateWhereInput>;
};


export type QueryMroDocumentTemplatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroDocumentTemplateWhereInput>;
};


export type QueryMroEmployeeProfileArgs = {
  id: Scalars['String'];
};


export type QueryMroEmployeeProfileCountArgs = {
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};


export type QueryMroEmployeeProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroEmployeeProfileWhereInput>;
};


export type QueryMroEstimateArgs = {
  id: Scalars['String'];
};


export type QueryMroEstimateCountArgs = {
  where?: InputMaybe<MroEstimateWhereInput>;
};


export type QueryMroEstimateWithTokenArgs = {
  id: Scalars['String'];
  token?: Scalars['String'];
};


export type QueryMroEstimatesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroEstimateWhereInput>;
};


export type QueryMroInvoiceArgs = {
  id: Scalars['String'];
};


export type QueryMroInvoiceCountArgs = {
  where?: InputMaybe<MroInvoiceWhereInput>;
};


export type QueryMroInvoiceWithTokenArgs = {
  id: Scalars['String'];
  token?: Scalars['String'];
};


export type QueryMroInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroInvoiceWhereInput>;
};


export type QueryMroIssueArgs = {
  id: Scalars['String'];
};


export type QueryMroIssuesArgs = {
  where: MroIssueWhereInput;
};


export type QueryMroLaborEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroLaborEntryWhereInput>;
};


export type QueryMroLaborEntryArgs = {
  id: Scalars['String'];
};


export type QueryMroLaborEntryCountArgs = {
  where?: InputMaybe<MroLaborEntryWhereInput>;
};


export type QueryMroLocationArgs = {
  id: Scalars['String'];
};


export type QueryMroLocationCountArgs = {
  where?: InputMaybe<MroLocationWhereInput>;
};


export type QueryMroLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroLocationWhereInput>;
};


export type QueryMroLogEntriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroLogEntryWhereInput>;
};


export type QueryMroLogEntryArgs = {
  id: Scalars['String'];
};


export type QueryMroLogEntryCountArgs = {
  where?: InputMaybe<MroLogEntryWhereInput>;
};


export type QueryMroLogEntryItemArgs = {
  id: Scalars['String'];
};


export type QueryMroOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryMroOrganizationCountArgs = {
  where?: InputMaybe<MroOrganizationWhereInput>;
};


export type QueryMroOrganizationFeeArgs = {
  id: Scalars['String'];
};


export type QueryMroOrganizationFeeCountArgs = {
  where?: InputMaybe<MroOrganizationFeeWhereInput>;
};


export type QueryMroOrganizationFeesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroOrganizationFeeWhereInput>;
};


export type QueryMroOrganizationInfoArgs = {
  id: Scalars['String'];
};


export type QueryMroOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroOrganizationWhereInput>;
};


export type QueryMroPartArgs = {
  id: Scalars['String'];
};


export type QueryMroPartCountArgs = {
  where?: InputMaybe<MroPartWhereInput>;
};


export type QueryMroPartInventoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroPartInventoryWhereInput>;
};


export type QueryMroPartInventoryArgs = {
  id: Scalars['String'];
};


export type QueryMroPartInventoryCountArgs = {
  where?: InputMaybe<MroPartInventoryWhereInput>;
};


export type QueryMroPartManufacturerArgs = {
  id: Scalars['String'];
};


export type QueryMroPartManufacturerCountArgs = {
  where?: InputMaybe<MroPartManufacturerWhereInput>;
};


export type QueryMroPartManufacturersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroPartManufacturerWhereInput>;
};


export type QueryMroPartOrderArgs = {
  id: Scalars['String'];
};


export type QueryMroPartOrderCountArgs = {
  where?: InputMaybe<MroPartOrderWhereInput>;
};


export type QueryMroPartOrderItemArgs = {
  id: Scalars['String'];
};


export type QueryMroPartOrderItemCountArgs = {
  where?: InputMaybe<MroPartOrderItemWhereInput>;
};


export type QueryMroPartOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroPartOrderItemWhereInput>;
};


export type QueryMroPartOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroPartOrderWhereInput>;
};


export type QueryMroPartPriceMatrixArgs = {
  id: Scalars['String'];
};


export type QueryMroPartPriceMatrixCountArgs = {
  where?: InputMaybe<MroPartPriceMatrixWhereInput>;
};


export type QueryMroPartPriceMatrixsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroPartPriceMatrixWhereInput>;
};


export type QueryMroPartSourceArgs = {
  partSourceId: Scalars['String'];
};


export type QueryMroPartSourcesArgs = {
  input: MroPartSourceWhereInput;
};


export type QueryMroPartVendorArgs = {
  id: Scalars['String'];
};


export type QueryMroPartVendorsArgs = {
  where: MroPartVendorWhereInput;
};


export type QueryMroPartWarehouseArgs = {
  partWarehouseId: Scalars['String'];
};


export type QueryMroPartWarehousesArgs = {
  input: MroPartWarehouseWhereInput;
};


export type QueryMroPartsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroPartWhereInput>;
};


export type QueryMroRtsTextArgs = {
  id: Scalars['String'];
};


export type QueryMroRtsTextCountArgs = {
  where?: InputMaybe<MroRtsTextWhereInput>;
};


export type QueryMroRtsTextsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroRtsTextWhereInput>;
};


export type QueryMroReportArgs = {
  id: Scalars['String'];
};


export type QueryMroReportCountArgs = {
  where?: InputMaybe<MroReportWhereInput>;
};


export type QueryMroReportsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroReportWhereInput>;
};


export type QueryMroRoleArgs = {
  id: Scalars['String'];
};


export type QueryMroRoleCountArgs = {
  where?: InputMaybe<MroRoleWhereInput>;
};


export type QueryMroRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroRoleWhereInput>;
};


export type QueryMroSerializedPartArgs = {
  id: Scalars['String'];
};


export type QueryMroSerializedPartCountArgs = {
  where?: InputMaybe<MroSerializedPartWhereInput>;
};


export type QueryMroSerializedPartsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroSerializedPartWhereInput>;
};


export type QueryMroServiceRequestArgs = {
  id: Scalars['String'];
};


export type QueryMroServiceRequestCountArgs = {
  where?: InputMaybe<MroServiceRequestWhereInput>;
};


export type QueryMroServiceRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroServiceRequestWhereInput>;
};


export type QueryMroWorkOrderArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderBillingItemArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderBillingItemCountArgs = {
  where?: InputMaybe<MroWorkOrderBillingItemWhereInput>;
};


export type QueryMroWorkOrderBillingItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroWorkOrderBillingItemWhereInput>;
};


export type QueryMroWorkOrderCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroWorkOrderCategoryWhereInput>;
};


export type QueryMroWorkOrderCategoryArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderCategoryCountArgs = {
  where?: InputMaybe<MroWorkOrderCategoryWhereInput>;
};


export type QueryMroWorkOrderCountArgs = {
  where?: InputMaybe<MroWorkOrderWhereInput>;
};


export type QueryMroWorkOrderIntervalArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderIntervalCountArgs = {
  where?: InputMaybe<MroWorkOrderIntervalWhereInput>;
};


export type QueryMroWorkOrderIntervalsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroWorkOrderIntervalWhereInput>;
};


export type QueryMroWorkOrderItemArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderItemCategoriesArgs = {
  where: MroWorkOrderItemCategoryWhereInput;
};


export type QueryMroWorkOrderItemCategoryArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderItemCountArgs = {
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};


export type QueryMroWorkOrderItemsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroWorkOrderItemWhereInput>;
};


export type QueryMroWorkOrderPartArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderPartsArgs = {
  where: MroWorkOrderPartWhereInput;
};


export type QueryMroWorkOrderSignoffArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderSignoffCountArgs = {
  where?: InputMaybe<MroWorkOrderSignoffWhereInput>;
};


export type QueryMroWorkOrderSignoffsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroWorkOrderSignoffWhereInput>;
};


export type QueryMroWorkOrderTemplateArgs = {
  id: Scalars['String'];
};


export type QueryMroWorkOrderTemplatesArgs = {
  where: MroWorkOrderTemplateWhereInput;
};


export type QueryMroWorkOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MroWorkOrderWhereInput>;
};


export type QueryOrganizationArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationAuthArgs = {
  id: Scalars['String'];
};


export type QueryOrganizationsArgs = {
  where?: InputMaybe<OrganizationWhereInput>;
};


export type QueryPendingFlightCountArgs = {
  where?: InputMaybe<FlightWhereInput>;
};


export type QueryPendingFlightsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlightOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FlightWhereInput>;
};


export type QueryRegisteredAirworthyDirectivesArgs = {
  where?: InputMaybe<RegisteredAirworthyDirectiveWhereInput>;
};


export type QueryRegistrationsArgs = {
  where?: InputMaybe<RegistrationWhereInput>;
};


export type QueryReportInfoArgs = {
  craftId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  timeframe?: InputMaybe<Scalars['String']>;
};


export type QueryReservationArgs = {
  id: Scalars['String'];
};


export type QueryReservationCountArgs = {
  where?: InputMaybe<ReservationWhereInput>;
};


export type QueryReservationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReservationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReservationWhereInput>;
};


export type QueryReservationsCalendarLinkArgs = {
  id: Scalars['String'];
};


export type QuerySquawkArgs = {
  id: Scalars['String'];
};


export type QuerySquawkCountArgs = {
  where?: InputMaybe<SquawkWhereInput>;
};


export type QuerySquawksArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SquawkWhereInput>;
};


export type QueryStripeDashboardArgs = {
  id: Scalars['String'];
};


export type QueryStripePayBalanceArgs = {
  id: Scalars['String'];
};


export type QueryStripePayPartialArgs = {
  amount: Scalars['Float'];
  id: Scalars['String'];
};


export type QueryStripePlansArgs = {
  productType: Scalars['String'];
};


export type QueryStripeSubscriptionArgs = {
  id: Scalars['String'];
};


export type QueryTransactionArgs = {
  id: Scalars['String'];
};


export type QueryTransactionCountArgs = {
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TransactionWhereInput>;
};


export type QueryUsageRecordArgs = {
  id: Scalars['String'];
};


export type QueryUserOrganizationProfileArgs = {
  id: Scalars['String'];
};


export type QueryUserOrganizationProfileCountArgs = {
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};


export type QueryUserOrganizationProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};


export type QueryUserOrganizationRoleArgs = {
  id: Scalars['String'];
};


export type QueryUserOrganizationRoleCountArgs = {
  where?: InputMaybe<UserOrganizationRoleWhereInput>;
};


export type QueryUserOrganizationRolesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserOrganizationRoleWhereInput>;
};


export type QueryUserWalletArgs = {
  userProfileId: Scalars['String'];
};


export type QueryWalletArgs = {
  id: Scalars['String'];
};


export type QueryWalletCountArgs = {
  where?: InputMaybe<WalletWhereInput>;
};


export type QueryWalletsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WalletWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RegisteredAirworthyDirective = {
  __typename?: 'RegisteredAirworthyDirective';
  adNumber?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  issueDate?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  makes?: Maybe<Scalars['String']>;
  models?: Maybe<Scalars['String']>;
  productTypes?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  subProductTypes?: Maybe<Array<Scalars['String']>>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegisteredAirworthyDirectiveCountAggregate = {
  __typename?: 'RegisteredAirworthyDirectiveCountAggregate';
  _all: Scalars['Int'];
  adNumber: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  effectiveDate: Scalars['Int'];
  id: Scalars['Int'];
  issueDate: Scalars['Int'];
  link: Scalars['Int'];
  makes: Scalars['Int'];
  models: Scalars['Int'];
  productTypes: Scalars['Int'];
  status: Scalars['Int'];
  subProductTypes: Scalars['Int'];
  subject: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type RegisteredAirworthyDirectiveMaxAggregate = {
  __typename?: 'RegisteredAirworthyDirectiveMaxAggregate';
  adNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  makes?: Maybe<Scalars['String']>;
  models?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegisteredAirworthyDirectiveMinAggregate = {
  __typename?: 'RegisteredAirworthyDirectiveMinAggregate';
  adNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['DateTime']>;
  link?: Maybe<Scalars['String']>;
  makes?: Maybe<Scalars['String']>;
  models?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RegisteredAirworthyDirectiveWhereInput = {
  AND?: InputMaybe<Array<RegisteredAirworthyDirectiveWhereInput>>;
  NOT?: InputMaybe<Array<RegisteredAirworthyDirectiveWhereInput>>;
  OR?: InputMaybe<Array<RegisteredAirworthyDirectiveWhereInput>>;
  adNumber?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  effectiveDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  issueDate?: InputMaybe<DateTimeNullableFilter>;
  link?: InputMaybe<StringNullableFilter>;
  makes?: InputMaybe<StringNullableFilter>;
  models?: InputMaybe<StringNullableFilter>;
  productTypes?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<StringNullableFilter>;
  subProductTypes?: InputMaybe<StringNullableListFilter>;
  subject?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type RegisteredCraft = {
  __typename?: 'RegisteredCraft';
  _count: RegisteredCraftCount;
  craftClass?: Maybe<RegisteredCraftClass>;
  craftType?: Maybe<RegisteredCraftType>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  manufacturer?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  numberEngines?: Maybe<Scalars['Int']>;
  numberSeats?: Maybe<Scalars['Int']>;
  registrations?: Maybe<Array<Registration>>;
  speed?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weight?: Maybe<Scalars['String']>;
};

export enum RegisteredCraftClass {
  MultiEngineLand = 'MULTI_ENGINE_LAND',
  MultiEngineSea = 'MULTI_ENGINE_SEA',
  SingleEngineLand = 'SINGLE_ENGINE_LAND',
  SingleEngineSea = 'SINGLE_ENGINE_SEA'
}

export type RegisteredCraftCount = {
  __typename?: 'RegisteredCraftCount';
  registrations: Scalars['Int'];
};

export type RegisteredCraftNullableScalarRelationFilter = {
  is?: InputMaybe<RegisteredCraftWhereInput>;
  isNot?: InputMaybe<RegisteredCraftWhereInput>;
};

export enum RegisteredCraftType {
  Balloon = 'BALLOON',
  Blimp = 'BLIMP',
  FixedWingMultiEngine = 'FIXED_WING_MULTI_ENGINE',
  FixedWingSingleEngine = 'FIXED_WING_SINGLE_ENGINE',
  Glider = 'GLIDER',
  Gyroplane = 'GYROPLANE',
  HybridLift = 'HYBRID_LIFT',
  Other = 'OTHER',
  PoweredParachute = 'POWERED_PARACHUTE',
  Rotorcraft = 'ROTORCRAFT',
  WeightShiftControl = 'WEIGHT_SHIFT_CONTROL'
}

export type RegisteredCraftWhereInput = {
  AND?: InputMaybe<Array<RegisteredCraftWhereInput>>;
  NOT?: InputMaybe<Array<RegisteredCraftWhereInput>>;
  OR?: InputMaybe<Array<RegisteredCraftWhereInput>>;
  craftClass?: InputMaybe<EnumRegisteredCraftClassNullableFilter>;
  craftType?: InputMaybe<EnumRegisteredCraftTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  manufacturer?: InputMaybe<StringNullableFilter>;
  model?: InputMaybe<StringNullableFilter>;
  numberEngines?: InputMaybe<IntNullableFilter>;
  numberSeats?: InputMaybe<IntNullableFilter>;
  registrations?: InputMaybe<RegistrationListRelationFilter>;
  speed?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  weight?: InputMaybe<StringNullableFilter>;
};

export enum RegisteredEngineType {
  Cycle_2 = 'CYCLE_2',
  Cycle_4 = 'CYCLE_4',
  Electric = 'ELECTRIC',
  None = 'NONE',
  Ramjet = 'RAMJET',
  Reciprocating = 'RECIPROCATING',
  Rotary = 'ROTARY',
  Turbofan = 'TURBOFAN',
  Turbojet = 'TURBOJET',
  Turboprop = 'TURBOPROP',
  Turboshaft = 'TURBOSHAFT',
  Unknown = 'UNKNOWN'
}

export type Registration = {
  __typename?: 'Registration';
  airWorthDate?: Maybe<Scalars['DateTime']>;
  airWorthType?: Maybe<RegisteredCraftType>;
  certIssueDate?: Maybe<Scalars['DateTime']>;
  certification?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  engMfrMdl?: Maybe<Scalars['String']>;
  engineCount?: Maybe<Scalars['Int']>;
  engineType?: Maybe<RegisteredEngineType>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fractOwner?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kitMfr?: Maybe<Scalars['String']>;
  kitModel?: Maybe<Scalars['String']>;
  lastActionDate?: Maybe<Scalars['DateTime']>;
  manufacturer?: Maybe<Scalars['String']>;
  modeSCode?: Maybe<Scalars['String']>;
  modeSCodeHex?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  nNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onAccount: Scalars['Boolean'];
  region?: Maybe<Scalars['String']>;
  registeredCraft?: Maybe<RegisteredCraft>;
  registeredCraftId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  typeReg?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  yearMfr?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RegistrationCountAggregate = {
  __typename?: 'RegistrationCountAggregate';
  _all: Scalars['Int'];
  airWorthDate: Scalars['Int'];
  airWorthType: Scalars['Int'];
  certIssueDate: Scalars['Int'];
  certification: Scalars['Int'];
  city: Scalars['Int'];
  country: Scalars['Int'];
  county: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  engMfrMdl: Scalars['Int'];
  engineType: Scalars['Int'];
  expirationDate: Scalars['Int'];
  fractOwner: Scalars['Int'];
  id: Scalars['Int'];
  kitMfr: Scalars['Int'];
  kitModel: Scalars['Int'];
  lastActionDate: Scalars['Int'];
  modeSCode: Scalars['Int'];
  modeSCodeHex: Scalars['Int'];
  nNumber: Scalars['Int'];
  name: Scalars['Int'];
  region: Scalars['Int'];
  registeredCraftId: Scalars['Int'];
  serialNumber: Scalars['Int'];
  state: Scalars['Int'];
  status: Scalars['Int'];
  street: Scalars['Int'];
  street2: Scalars['Int'];
  typeReg: Scalars['Int'];
  updatedAt: Scalars['Int'];
  yearMfr: Scalars['Int'];
  zipCode: Scalars['Int'];
};

export type RegistrationListRelationFilter = {
  every?: InputMaybe<RegistrationWhereInput>;
  none?: InputMaybe<RegistrationWhereInput>;
  some?: InputMaybe<RegistrationWhereInput>;
};

export type RegistrationMaxAggregate = {
  __typename?: 'RegistrationMaxAggregate';
  airWorthDate?: Maybe<Scalars['DateTime']>;
  airWorthType?: Maybe<RegisteredCraftType>;
  certIssueDate?: Maybe<Scalars['DateTime']>;
  certification?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  engMfrMdl?: Maybe<Scalars['String']>;
  engineType?: Maybe<RegisteredEngineType>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fractOwner?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kitMfr?: Maybe<Scalars['String']>;
  kitModel?: Maybe<Scalars['String']>;
  lastActionDate?: Maybe<Scalars['DateTime']>;
  modeSCode?: Maybe<Scalars['String']>;
  modeSCodeHex?: Maybe<Scalars['String']>;
  nNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  registeredCraftId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  typeReg?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  yearMfr?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RegistrationMinAggregate = {
  __typename?: 'RegistrationMinAggregate';
  airWorthDate?: Maybe<Scalars['DateTime']>;
  airWorthType?: Maybe<RegisteredCraftType>;
  certIssueDate?: Maybe<Scalars['DateTime']>;
  certification?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  engMfrMdl?: Maybe<Scalars['String']>;
  engineType?: Maybe<RegisteredEngineType>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  fractOwner?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  kitMfr?: Maybe<Scalars['String']>;
  kitModel?: Maybe<Scalars['String']>;
  lastActionDate?: Maybe<Scalars['DateTime']>;
  modeSCode?: Maybe<Scalars['String']>;
  modeSCodeHex?: Maybe<Scalars['String']>;
  nNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  registeredCraftId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  typeReg?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  yearMfr?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type RegistrationWhereInput = {
  AND?: InputMaybe<Array<RegistrationWhereInput>>;
  NOT?: InputMaybe<Array<RegistrationWhereInput>>;
  OR?: InputMaybe<Array<RegistrationWhereInput>>;
  airWorthDate?: InputMaybe<DateTimeNullableFilter>;
  airWorthType?: InputMaybe<EnumRegisteredCraftTypeNullableFilter>;
  certIssueDate?: InputMaybe<DateTimeNullableFilter>;
  certification?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  county?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  engMfrMdl?: InputMaybe<StringNullableFilter>;
  engineType?: InputMaybe<EnumRegisteredEngineTypeNullableFilter>;
  expirationDate?: InputMaybe<DateTimeNullableFilter>;
  fractOwner?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  kitMfr?: InputMaybe<StringNullableFilter>;
  kitModel?: InputMaybe<StringNullableFilter>;
  lastActionDate?: InputMaybe<DateTimeNullableFilter>;
  modeSCode?: InputMaybe<StringNullableFilter>;
  modeSCodeHex?: InputMaybe<StringNullableFilter>;
  nNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  region?: InputMaybe<StringNullableFilter>;
  registeredCraft?: InputMaybe<RegisteredCraftNullableScalarRelationFilter>;
  registeredCraftId?: InputMaybe<StringNullableFilter>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  street?: InputMaybe<StringNullableFilter>;
  street2?: InputMaybe<StringNullableFilter>;
  typeReg?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  yearMfr?: InputMaybe<StringNullableFilter>;
  zipCode?: InputMaybe<StringNullableFilter>;
};

export type ReportInfo = {
  __typename?: 'ReportInfo';
  currentLocation: Route;
  flightRoutes: Array<FlightRoute>;
  flightTime: Scalars['String'];
  flights: Scalars['String'];
  xcFlightTime: Scalars['String'];
  xcMiles: Scalars['String'];
};

export type Reservation = {
  __typename?: 'Reservation';
  _count: ReservationCount;
  allDay?: Maybe<Scalars['Boolean']>;
  canEdit: Scalars['Boolean'];
  copilot?: Maybe<UserOrganizationProfile>;
  copilotId?: Maybe<Scalars['String']>;
  craft?: Maybe<Craft>;
  craftId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isMaintenance?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  passengers?: Maybe<Array<UserOrganizationProfile>>;
  pilot?: Maybe<UserOrganizationProfile>;
  pilotId?: Maybe<Scalars['String']>;
  pilotName?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  timezoneFrom: Scalars['String'];
  timezoneTo: Scalars['String'];
  to?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type ReservationCount = {
  __typename?: 'ReservationCount';
  passengers: Scalars['Int'];
};

export type ReservationCountAggregate = {
  __typename?: 'ReservationCountAggregate';
  _all: Scalars['Int'];
  allDay: Scalars['Int'];
  copilotId: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  from: Scalars['Int'];
  id: Scalars['Int'];
  isMaintenance: Scalars['Int'];
  legacyId: Scalars['Int'];
  notes: Scalars['Int'];
  pilotId: Scalars['Int'];
  timezone: Scalars['Int'];
  to: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ReservationCreateInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCopilotReservationInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutReservationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengersReservationInput>;
  pilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutReservationsInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateManyCopilotInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pilotId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateManyCopilotInputEnvelope = {
  data: Array<ReservationCreateManyCopilotInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ReservationCreateManyCraftInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilotId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pilotId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateManyCraftInputEnvelope = {
  data: Array<ReservationCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ReservationCreateManyPilotInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilotId?: InputMaybe<Scalars['String']>;
  craftId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateManyPilotInputEnvelope = {
  data: Array<ReservationCreateManyPilotInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ReservationCreateNestedManyWithoutCopilotInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutCopilotInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutCopilotInput>>;
  createMany?: InputMaybe<ReservationCreateManyCopilotInputEnvelope>;
};

export type ReservationCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutCraftInput>>;
  createMany?: InputMaybe<ReservationCreateManyCraftInputEnvelope>;
};

export type ReservationCreateNestedManyWithoutPassengersInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutPassengersInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutPassengersInput>>;
};

export type ReservationCreateNestedManyWithoutPilotInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutPilotInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutPilotInput>>;
  createMany?: InputMaybe<ReservationCreateManyPilotInputEnvelope>;
};

export type ReservationCreateOrConnectWithoutCopilotInput = {
  create: ReservationCreateWithoutCopilotInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationCreateOrConnectWithoutCraftInput = {
  create: ReservationCreateWithoutCraftInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationCreateOrConnectWithoutPassengersInput = {
  create: ReservationCreateWithoutPassengersInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationCreateOrConnectWithoutPilotInput = {
  create: ReservationCreateWithoutPilotInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationCreateWithoutCopilotInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutReservationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengersReservationInput>;
  pilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutReservationsInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateWithoutCraftInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCopilotReservationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengersReservationInput>;
  pilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutReservationsInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateWithoutPassengersInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCopilotReservationInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutReservationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutReservationsInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationCreateWithoutPilotInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutCopilotReservationInput>;
  craft?: InputMaybe<CraftCreateNestedOneWithoutReservationsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutPassengersReservationInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationListRelationFilter = {
  every?: InputMaybe<ReservationWhereInput>;
  none?: InputMaybe<ReservationWhereInput>;
  some?: InputMaybe<ReservationWhereInput>;
};

export type ReservationMaxAggregate = {
  __typename?: 'ReservationMaxAggregate';
  allDay?: Maybe<Scalars['Boolean']>;
  copilotId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMaintenance?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pilotId?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReservationMinAggregate = {
  __typename?: 'ReservationMinAggregate';
  allDay?: Maybe<Scalars['Boolean']>;
  copilotId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isMaintenance?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  pilotId?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReservationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum ReservationOrderByRelevanceFieldEnum {
  CopilotId = 'copilotId',
  CraftId = 'craftId',
  Id = 'id',
  LegacyId = 'legacyId',
  Notes = 'notes',
  PilotId = 'pilotId',
  Timezone = 'timezone'
}

export type ReservationOrderByRelevanceInput = {
  fields: Array<ReservationOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type ReservationOrderByWithRelationInput = {
  _relevance?: InputMaybe<ReservationOrderByRelevanceInput>;
  allDay?: InputMaybe<SortOrderInput>;
  copilot?: InputMaybe<UserOrganizationProfileOrderByWithRelationInput>;
  copilotId?: InputMaybe<SortOrderInput>;
  craft?: InputMaybe<CraftOrderByWithRelationInput>;
  craftId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  from?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isMaintenance?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  notes?: InputMaybe<SortOrderInput>;
  passengers?: InputMaybe<UserOrganizationProfileOrderByRelationAggregateInput>;
  pilot?: InputMaybe<UserOrganizationProfileOrderByWithRelationInput>;
  pilotId?: InputMaybe<SortOrderInput>;
  timezone?: InputMaybe<SortOrderInput>;
  to?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type ReservationScalarWhereInput = {
  AND?: InputMaybe<Array<ReservationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReservationScalarWhereInput>>;
  OR?: InputMaybe<Array<ReservationScalarWhereInput>>;
  allDay?: InputMaybe<BoolNullableFilter>;
  copilotId?: InputMaybe<StringNullableFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  from?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isMaintenance?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  pilotId?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  to?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ReservationUpdateInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCopilotReservationNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutReservationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengersReservationNestedInput>;
  pilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutReservationsNestedInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationUpdateManyMutationInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationUpdateManyWithWhereWithoutCopilotInput = {
  data: ReservationUpdateManyMutationInput;
  where: ReservationScalarWhereInput;
};

export type ReservationUpdateManyWithWhereWithoutCraftInput = {
  data: ReservationUpdateManyMutationInput;
  where: ReservationScalarWhereInput;
};

export type ReservationUpdateManyWithWhereWithoutPassengersInput = {
  data: ReservationUpdateManyMutationInput;
  where: ReservationScalarWhereInput;
};

export type ReservationUpdateManyWithWhereWithoutPilotInput = {
  data: ReservationUpdateManyMutationInput;
  where: ReservationScalarWhereInput;
};

export type ReservationUpdateManyWithoutCopilotNestedInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutCopilotInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutCopilotInput>>;
  createMany?: InputMaybe<ReservationCreateManyCopilotInputEnvelope>;
  delete?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReservationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  set?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  update?: InputMaybe<Array<ReservationUpdateWithWhereUniqueWithoutCopilotInput>>;
  updateMany?: InputMaybe<Array<ReservationUpdateManyWithWhereWithoutCopilotInput>>;
  upsert?: InputMaybe<Array<ReservationUpsertWithWhereUniqueWithoutCopilotInput>>;
};

export type ReservationUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutCraftInput>>;
  createMany?: InputMaybe<ReservationCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReservationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  set?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  update?: InputMaybe<Array<ReservationUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<ReservationUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<ReservationUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type ReservationUpdateManyWithoutPassengersNestedInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutPassengersInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutPassengersInput>>;
  delete?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReservationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  set?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  update?: InputMaybe<Array<ReservationUpdateWithWhereUniqueWithoutPassengersInput>>;
  updateMany?: InputMaybe<Array<ReservationUpdateManyWithWhereWithoutPassengersInput>>;
  upsert?: InputMaybe<Array<ReservationUpsertWithWhereUniqueWithoutPassengersInput>>;
};

export type ReservationUpdateManyWithoutPilotNestedInput = {
  connect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReservationCreateOrConnectWithoutPilotInput>>;
  create?: InputMaybe<Array<ReservationCreateWithoutPilotInput>>;
  createMany?: InputMaybe<ReservationCreateManyPilotInputEnvelope>;
  delete?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReservationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  set?: InputMaybe<Array<ReservationWhereUniqueInput>>;
  update?: InputMaybe<Array<ReservationUpdateWithWhereUniqueWithoutPilotInput>>;
  updateMany?: InputMaybe<Array<ReservationUpdateManyWithWhereWithoutPilotInput>>;
  upsert?: InputMaybe<Array<ReservationUpsertWithWhereUniqueWithoutPilotInput>>;
};

export type ReservationUpdateWithWhereUniqueWithoutCopilotInput = {
  data: ReservationUpdateWithoutCopilotInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpdateWithWhereUniqueWithoutCraftInput = {
  data: ReservationUpdateWithoutCraftInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpdateWithWhereUniqueWithoutPassengersInput = {
  data: ReservationUpdateWithoutPassengersInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpdateWithWhereUniqueWithoutPilotInput = {
  data: ReservationUpdateWithoutPilotInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpdateWithoutCopilotInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  craft?: InputMaybe<CraftUpdateOneWithoutReservationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengersReservationNestedInput>;
  pilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutReservationsNestedInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationUpdateWithoutCraftInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCopilotReservationNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengersReservationNestedInput>;
  pilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutReservationsNestedInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationUpdateWithoutPassengersInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCopilotReservationNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutReservationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  pilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutReservationsNestedInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationUpdateWithoutPilotInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  copilot?: InputMaybe<UserOrganizationProfileUpdateOneWithoutCopilotReservationNestedInput>;
  craft?: InputMaybe<CraftUpdateOneWithoutReservationsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  from?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  passengers?: InputMaybe<UserOrganizationProfileUpdateManyWithoutPassengersReservationNestedInput>;
  timezone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ReservationUpsertWithWhereUniqueWithoutCopilotInput = {
  create: ReservationCreateWithoutCopilotInput;
  update: ReservationUpdateWithoutCopilotInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpsertWithWhereUniqueWithoutCraftInput = {
  create: ReservationCreateWithoutCraftInput;
  update: ReservationUpdateWithoutCraftInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpsertWithWhereUniqueWithoutPassengersInput = {
  create: ReservationCreateWithoutPassengersInput;
  update: ReservationUpdateWithoutPassengersInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationUpsertWithWhereUniqueWithoutPilotInput = {
  create: ReservationCreateWithoutPilotInput;
  update: ReservationUpdateWithoutPilotInput;
  where: ReservationWhereUniqueInput;
};

export type ReservationWhereInput = {
  AND?: InputMaybe<Array<ReservationWhereInput>>;
  NOT?: InputMaybe<Array<ReservationWhereInput>>;
  OR?: InputMaybe<Array<ReservationWhereInput>>;
  allDay?: InputMaybe<BoolNullableFilter>;
  copilot?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  copilotId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  from?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isMaintenance?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  passengers?: InputMaybe<UserOrganizationProfileListRelationFilter>;
  pilot?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  pilotId?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  to?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ReservationWhereUniqueInput = {
  AND?: InputMaybe<Array<ReservationWhereInput>>;
  NOT?: InputMaybe<Array<ReservationWhereInput>>;
  OR?: InputMaybe<Array<ReservationWhereInput>>;
  allDay?: InputMaybe<BoolNullableFilter>;
  copilot?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  copilotId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftNullableScalarRelationFilter>;
  craftId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  from?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isMaintenance?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<StringNullableFilter>;
  passengers?: InputMaybe<UserOrganizationProfileListRelationFilter>;
  pilot?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  pilotId?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  to?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export enum Role {
  Admin = 'ADMIN',
  MroAccountant = 'MRO_ACCOUNTANT',
  MroManager = 'MRO_MANAGER',
  MroPartsManager = 'MRO_PARTS_MANAGER',
  MroTechnician = 'MRO_TECHNICIAN',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

export type Route = {
  __typename?: 'Route';
  lat: Scalars['String'];
  long: Scalars['String'];
  name: Scalars['String'];
};

export enum Severity {
  Grounded = 'GROUNDED',
  Warning = 'WARNING',
  Watch = 'WATCH'
}

export enum SignoffStatus {
  AwaitingSignoff = 'AWAITING_SIGNOFF',
  Signed = 'SIGNED',
  Unassigned = 'UNASSIGNED'
}

export type SignupInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  password: Scalars['String'];
  userOrganizationProfileId?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type Squawk = {
  __typename?: 'Squawk';
  _count: SquawkCount;
  attachments?: Maybe<Array<Attachment>>;
  component?: Maybe<Component>;
  componentId?: Maybe<Scalars['String']>;
  craft: Craft;
  craftId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  flights?: Maybe<Array<Flight>>;
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  maintenanceRecords?: Maybe<Array<MaintenanceRecord>>;
  openedAt: Scalars['DateTime'];
  position?: Maybe<Scalars['Int']>;
  severity?: Maybe<Severity>;
  status?: Maybe<Status>;
  systemsAffected?: Maybe<Array<JascSystem>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfile?: Maybe<UserOrganizationProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type SquawkAvgAggregate = {
  __typename?: 'SquawkAvgAggregate';
  position?: Maybe<Scalars['Float']>;
};

export type SquawkCount = {
  __typename?: 'SquawkCount';
  attachments: Scalars['Int'];
  flights: Scalars['Int'];
  maintenanceRecords: Scalars['Int'];
  systemsAffected: Scalars['Int'];
};

export type SquawkCountAggregate = {
  __typename?: 'SquawkCountAggregate';
  _all: Scalars['Int'];
  componentId: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  openedAt: Scalars['Int'];
  position: Scalars['Int'];
  severity: Scalars['Int'];
  status: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userProfileId: Scalars['Int'];
};

export type SquawkCreateInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateManyComponentInput = {
  craftId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type SquawkCreateManyComponentInputEnvelope = {
  data: Array<SquawkCreateManyComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SquawkCreateManyCraftInput = {
  componentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type SquawkCreateManyCraftInputEnvelope = {
  data: Array<SquawkCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SquawkCreateManyUserProfileInput = {
  componentId?: InputMaybe<Scalars['String']>;
  craftId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SquawkCreateManyUserProfileInputEnvelope = {
  data: Array<SquawkCreateManyUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SquawkCreateNestedManyWithoutComponentInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutComponentInput>>;
  createMany?: InputMaybe<SquawkCreateManyComponentInputEnvelope>;
};

export type SquawkCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutCraftInput>>;
  createMany?: InputMaybe<SquawkCreateManyCraftInputEnvelope>;
};

export type SquawkCreateNestedManyWithoutFlightsInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutFlightsInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutFlightsInput>>;
};

export type SquawkCreateNestedManyWithoutMaintenanceRecordsInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutMaintenanceRecordsInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutMaintenanceRecordsInput>>;
};

export type SquawkCreateNestedManyWithoutSystemsAffectedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutSystemsAffectedInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutSystemsAffectedInput>>;
};

export type SquawkCreateNestedManyWithoutUserProfileInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<SquawkCreateManyUserProfileInputEnvelope>;
};

export type SquawkCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<SquawkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SquawkCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<SquawkCreateWithoutAttachmentsInput>;
};

export type SquawkCreateOrConnectWithoutAttachmentsInput = {
  create: SquawkCreateWithoutAttachmentsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateOrConnectWithoutComponentInput = {
  create: SquawkCreateWithoutComponentInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateOrConnectWithoutCraftInput = {
  create: SquawkCreateWithoutCraftInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateOrConnectWithoutFlightsInput = {
  create: SquawkCreateWithoutFlightsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateOrConnectWithoutMaintenanceRecordsInput = {
  create: SquawkCreateWithoutMaintenanceRecordsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateOrConnectWithoutSystemsAffectedInput = {
  create: SquawkCreateWithoutSystemsAffectedInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateOrConnectWithoutUserProfileInput = {
  create: SquawkCreateWithoutUserProfileInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkCreateWithoutAttachmentsInput = {
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateWithoutComponentInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateWithoutCraftInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateWithoutFlightsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateWithoutMaintenanceRecordsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateWithoutSystemsAffectedInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutSquawksInput>;
};

export type SquawkCreateWithoutUserProfileInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutSquawkInput>;
  component?: InputMaybe<ComponentCreateNestedOneWithoutSquawksInput>;
  craft: CraftCreateNestedOneWithoutSquawksInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutSquawksInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutSquawksInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemCreateNestedManyWithoutSquawksInput>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SquawkListRelationFilter = {
  every?: InputMaybe<SquawkWhereInput>;
  none?: InputMaybe<SquawkWhereInput>;
  some?: InputMaybe<SquawkWhereInput>;
};

export type SquawkMaxAggregate = {
  __typename?: 'SquawkMaxAggregate';
  componentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  position?: Maybe<Scalars['Int']>;
  severity?: Maybe<Severity>;
  status?: Maybe<Status>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type SquawkMinAggregate = {
  __typename?: 'SquawkMinAggregate';
  componentId?: Maybe<Scalars['String']>;
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  openedAt?: Maybe<Scalars['DateTime']>;
  position?: Maybe<Scalars['Int']>;
  severity?: Maybe<Severity>;
  status?: Maybe<Status>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type SquawkNullableScalarRelationFilter = {
  is?: InputMaybe<SquawkWhereInput>;
  isNot?: InputMaybe<SquawkWhereInput>;
};

export type SquawkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SquawkScalarWhereInput = {
  AND?: InputMaybe<Array<SquawkScalarWhereInput>>;
  NOT?: InputMaybe<Array<SquawkScalarWhereInput>>;
  OR?: InputMaybe<Array<SquawkScalarWhereInput>>;
  componentId?: InputMaybe<StringNullableFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  openedAt?: InputMaybe<DateTimeFilter>;
  position?: InputMaybe<IntNullableFilter>;
  severity?: InputMaybe<EnumSeverityNullableFilter>;
  status?: InputMaybe<EnumStatusNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type SquawkSumAggregate = {
  __typename?: 'SquawkSumAggregate';
  position?: Maybe<Scalars['Int']>;
};

export type SquawkUpdateInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SquawkUpdateManyWithWhereWithoutComponentInput = {
  data: SquawkUpdateManyMutationInput;
  where: SquawkScalarWhereInput;
};

export type SquawkUpdateManyWithWhereWithoutCraftInput = {
  data: SquawkUpdateManyMutationInput;
  where: SquawkScalarWhereInput;
};

export type SquawkUpdateManyWithWhereWithoutFlightsInput = {
  data: SquawkUpdateManyMutationInput;
  where: SquawkScalarWhereInput;
};

export type SquawkUpdateManyWithWhereWithoutMaintenanceRecordsInput = {
  data: SquawkUpdateManyMutationInput;
  where: SquawkScalarWhereInput;
};

export type SquawkUpdateManyWithWhereWithoutSystemsAffectedInput = {
  data: SquawkUpdateManyMutationInput;
  where: SquawkScalarWhereInput;
};

export type SquawkUpdateManyWithWhereWithoutUserProfileInput = {
  data: SquawkUpdateManyMutationInput;
  where: SquawkScalarWhereInput;
};

export type SquawkUpdateManyWithoutComponentNestedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutComponentInput>>;
  createMany?: InputMaybe<SquawkCreateManyComponentInputEnvelope>;
  delete?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SquawkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  set?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  update?: InputMaybe<Array<SquawkUpdateWithWhereUniqueWithoutComponentInput>>;
  updateMany?: InputMaybe<Array<SquawkUpdateManyWithWhereWithoutComponentInput>>;
  upsert?: InputMaybe<Array<SquawkUpsertWithWhereUniqueWithoutComponentInput>>;
};

export type SquawkUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutCraftInput>>;
  createMany?: InputMaybe<SquawkCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SquawkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  set?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  update?: InputMaybe<Array<SquawkUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<SquawkUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<SquawkUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type SquawkUpdateManyWithoutFlightsNestedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutFlightsInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutFlightsInput>>;
  delete?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SquawkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  set?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  update?: InputMaybe<Array<SquawkUpdateWithWhereUniqueWithoutFlightsInput>>;
  updateMany?: InputMaybe<Array<SquawkUpdateManyWithWhereWithoutFlightsInput>>;
  upsert?: InputMaybe<Array<SquawkUpsertWithWhereUniqueWithoutFlightsInput>>;
};

export type SquawkUpdateManyWithoutMaintenanceRecordsNestedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutMaintenanceRecordsInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutMaintenanceRecordsInput>>;
  delete?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SquawkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  set?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  update?: InputMaybe<Array<SquawkUpdateWithWhereUniqueWithoutMaintenanceRecordsInput>>;
  updateMany?: InputMaybe<Array<SquawkUpdateManyWithWhereWithoutMaintenanceRecordsInput>>;
  upsert?: InputMaybe<Array<SquawkUpsertWithWhereUniqueWithoutMaintenanceRecordsInput>>;
};

export type SquawkUpdateManyWithoutSystemsAffectedNestedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutSystemsAffectedInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutSystemsAffectedInput>>;
  delete?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SquawkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  set?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  update?: InputMaybe<Array<SquawkUpdateWithWhereUniqueWithoutSystemsAffectedInput>>;
  updateMany?: InputMaybe<Array<SquawkUpdateManyWithWhereWithoutSystemsAffectedInput>>;
  upsert?: InputMaybe<Array<SquawkUpsertWithWhereUniqueWithoutSystemsAffectedInput>>;
};

export type SquawkUpdateManyWithoutUserProfileNestedInput = {
  connect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SquawkCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<SquawkCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<SquawkCreateManyUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SquawkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  set?: InputMaybe<Array<SquawkWhereUniqueInput>>;
  update?: InputMaybe<Array<SquawkUpdateWithWhereUniqueWithoutUserProfileInput>>;
  updateMany?: InputMaybe<Array<SquawkUpdateManyWithWhereWithoutUserProfileInput>>;
  upsert?: InputMaybe<Array<SquawkUpsertWithWhereUniqueWithoutUserProfileInput>>;
};

export type SquawkUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<SquawkWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SquawkCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<SquawkCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<SquawkWhereInput>;
  disconnect?: InputMaybe<SquawkWhereInput>;
  update?: InputMaybe<SquawkUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<SquawkUpsertWithoutAttachmentsInput>;
};

export type SquawkUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: SquawkUpdateWithoutAttachmentsInput;
  where?: InputMaybe<SquawkWhereInput>;
};

export type SquawkUpdateWithWhereUniqueWithoutComponentInput = {
  data: SquawkUpdateWithoutComponentInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpdateWithWhereUniqueWithoutCraftInput = {
  data: SquawkUpdateWithoutCraftInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpdateWithWhereUniqueWithoutFlightsInput = {
  data: SquawkUpdateWithoutFlightsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpdateWithWhereUniqueWithoutMaintenanceRecordsInput = {
  data: SquawkUpdateWithoutMaintenanceRecordsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpdateWithWhereUniqueWithoutSystemsAffectedInput = {
  data: SquawkUpdateWithoutSystemsAffectedInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpdateWithWhereUniqueWithoutUserProfileInput = {
  data: SquawkUpdateWithoutUserProfileInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpdateWithoutAttachmentsInput = {
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateWithoutComponentInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateWithoutCraftInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateWithoutFlightsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateWithoutMaintenanceRecordsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateWithoutSystemsAffectedInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutSquawksNestedInput>;
};

export type SquawkUpdateWithoutUserProfileInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutSquawkNestedInput>;
  component?: InputMaybe<ComponentUpdateOneWithoutSquawksNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutSquawksNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutSquawksNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutSquawksNestedInput>;
  openedAt?: InputMaybe<Scalars['DateTime']>;
  position?: InputMaybe<Scalars['Int']>;
  severity?: InputMaybe<Severity>;
  status?: InputMaybe<Status>;
  systemsAffected?: InputMaybe<JascSystemUpdateManyWithoutSquawksNestedInput>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SquawkUpsertWithWhereUniqueWithoutComponentInput = {
  create: SquawkCreateWithoutComponentInput;
  update: SquawkUpdateWithoutComponentInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpsertWithWhereUniqueWithoutCraftInput = {
  create: SquawkCreateWithoutCraftInput;
  update: SquawkUpdateWithoutCraftInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpsertWithWhereUniqueWithoutFlightsInput = {
  create: SquawkCreateWithoutFlightsInput;
  update: SquawkUpdateWithoutFlightsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpsertWithWhereUniqueWithoutMaintenanceRecordsInput = {
  create: SquawkCreateWithoutMaintenanceRecordsInput;
  update: SquawkUpdateWithoutMaintenanceRecordsInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpsertWithWhereUniqueWithoutSystemsAffectedInput = {
  create: SquawkCreateWithoutSystemsAffectedInput;
  update: SquawkUpdateWithoutSystemsAffectedInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpsertWithWhereUniqueWithoutUserProfileInput = {
  create: SquawkCreateWithoutUserProfileInput;
  update: SquawkUpdateWithoutUserProfileInput;
  where: SquawkWhereUniqueInput;
};

export type SquawkUpsertWithoutAttachmentsInput = {
  create: SquawkCreateWithoutAttachmentsInput;
  update: SquawkUpdateWithoutAttachmentsInput;
  where?: InputMaybe<SquawkWhereInput>;
};

export type SquawkWhereInput = {
  AND?: InputMaybe<Array<SquawkWhereInput>>;
  NOT?: InputMaybe<Array<SquawkWhereInput>>;
  OR?: InputMaybe<Array<SquawkWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  component?: InputMaybe<ComponentNullableScalarRelationFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  openedAt?: InputMaybe<DateTimeFilter>;
  position?: InputMaybe<IntNullableFilter>;
  severity?: InputMaybe<EnumSeverityNullableFilter>;
  status?: InputMaybe<EnumStatusNullableFilter>;
  systemsAffected?: InputMaybe<JascSystemListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type SquawkWhereUniqueInput = {
  AND?: InputMaybe<Array<SquawkWhereInput>>;
  NOT?: InputMaybe<Array<SquawkWhereInput>>;
  OR?: InputMaybe<Array<SquawkWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  component?: InputMaybe<ComponentNullableScalarRelationFilter>;
  componentId?: InputMaybe<StringNullableFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  openedAt?: InputMaybe<DateTimeFilter>;
  position?: InputMaybe<IntNullableFilter>;
  severity?: InputMaybe<EnumSeverityNullableFilter>;
  status?: InputMaybe<EnumStatusNullableFilter>;
  systemsAffected?: InputMaybe<JascSystemListRelationFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export enum Status {
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Planned = 'PLANNED',
  Resolved = 'RESOLVED',
  Stalled = 'STALLED'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type StripePlan = {
  __typename?: 'StripePlan';
  cost: Scalars['String'];
  id: Scalars['String'];
  interval: Scalars['String'];
  intervalLength: Scalars['String'];
  isTrial: Scalars['Boolean'];
  link: Scalars['String'];
  planName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  billingDate: Scalars['String'];
  cost: Scalars['String'];
  craftCost?: Maybe<Scalars['String']>;
  craftProrateCost?: Maybe<Scalars['String']>;
  craftSubscription?: Maybe<CraftSubscription>;
  customerPortalUrl: Scalars['String'];
  id: Scalars['String'];
  interval: Scalars['String'];
  isPendingCancel?: Maybe<Scalars['Boolean']>;
  planName: Scalars['String'];
};

export type Transaction = {
  __typename?: 'Transaction';
  _count: TransactionCount;
  attachments?: Maybe<Array<Attachment>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  flight?: Maybe<Flight>;
  flightId?: Maybe<Scalars['String']>;
  formattedValue: Scalars['String'];
  id: Scalars['ID'];
  inputData?: Maybe<Scalars['JSON']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  pilotName: Scalars['String'];
  status?: Maybe<TransactionStatus>;
  timestamp?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
  version?: Maybe<Array<TransactionVersion>>;
  wallet?: Maybe<Wallet>;
  walletId?: Maybe<Scalars['String']>;
};

export type TransactionAvgAggregate = {
  __typename?: 'TransactionAvgAggregate';
  value?: Maybe<Scalars['Decimal']>;
};

export type TransactionCount = {
  __typename?: 'TransactionCount';
  attachments: Scalars['Int'];
  version: Scalars['Int'];
};

export type TransactionCountAggregate = {
  __typename?: 'TransactionCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  flightId: Scalars['Int'];
  id: Scalars['Int'];
  inputData: Scalars['Int'];
  isDeposit: Scalars['Int'];
  legacyId: Scalars['Int'];
  metadata: Scalars['Int'];
  status: Scalars['Int'];
  timestamp: Scalars['Int'];
  updatedAt: Scalars['Int'];
  value: Scalars['Int'];
  walletId: Scalars['Int'];
};

export type TransactionCreateInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutTransactionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutTransactionsInput>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionCreateNestedManyWithoutTransactionInput>;
  wallet?: InputMaybe<WalletCreateNestedOneWithoutTransactionsInput>;
};

export type TransactionCreateManyFlightInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  walletId?: InputMaybe<Scalars['String']>;
};

export type TransactionCreateManyFlightInputEnvelope = {
  data: Array<TransactionCreateManyFlightInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransactionCreateManyWalletInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type TransactionCreateManyWalletInputEnvelope = {
  data: Array<TransactionCreateManyWalletInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransactionCreateNestedManyWithoutFlightInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutFlightInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutFlightInput>>;
  createMany?: InputMaybe<TransactionCreateManyFlightInputEnvelope>;
};

export type TransactionCreateNestedManyWithoutWalletInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutWalletInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutWalletInput>>;
  createMany?: InputMaybe<TransactionCreateManyWalletInputEnvelope>;
};

export type TransactionCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<TransactionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<TransactionCreateWithoutAttachmentsInput>;
};

export type TransactionCreateOrConnectWithoutAttachmentsInput = {
  create: TransactionCreateWithoutAttachmentsInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutFlightInput = {
  create: TransactionCreateWithoutFlightInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateOrConnectWithoutWalletInput = {
  create: TransactionCreateWithoutWalletInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionCreateWithoutAttachmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutTransactionsInput>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionCreateNestedManyWithoutTransactionInput>;
  wallet?: InputMaybe<WalletCreateNestedOneWithoutTransactionsInput>;
};

export type TransactionCreateWithoutFlightInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutTransactionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionCreateNestedManyWithoutTransactionInput>;
  wallet?: InputMaybe<WalletCreateNestedOneWithoutTransactionsInput>;
};

export type TransactionCreateWithoutWalletInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutTransactionInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutTransactionsInput>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionCreateNestedManyWithoutTransactionInput>;
};

export type TransactionListRelationFilter = {
  every?: InputMaybe<TransactionWhereInput>;
  none?: InputMaybe<TransactionWhereInput>;
  some?: InputMaybe<TransactionWhereInput>;
};

export type TransactionMaxAggregate = {
  __typename?: 'TransactionMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  status?: Maybe<TransactionStatus>;
  timestamp?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
  walletId?: Maybe<Scalars['String']>;
};

export type TransactionMinAggregate = {
  __typename?: 'TransactionMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDeposit?: Maybe<Scalars['Boolean']>;
  legacyId?: Maybe<Scalars['String']>;
  status?: Maybe<TransactionStatus>;
  timestamp?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Decimal']>;
  walletId?: Maybe<Scalars['String']>;
};

export type TransactionNullableScalarRelationFilter = {
  is?: InputMaybe<TransactionWhereInput>;
  isNot?: InputMaybe<TransactionWhereInput>;
};

export type TransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum TransactionOrderByRelevanceFieldEnum {
  FlightId = 'flightId',
  Id = 'id',
  LegacyId = 'legacyId',
  WalletId = 'walletId'
}

export type TransactionOrderByRelevanceInput = {
  fields: Array<TransactionOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type TransactionOrderByWithRelationInput = {
  _relevance?: InputMaybe<TransactionOrderByRelevanceInput>;
  attachments?: InputMaybe<AttachmentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  flight?: InputMaybe<FlightOrderByWithRelationInput>;
  flightId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inputData?: InputMaybe<SortOrderInput>;
  isDeposit?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrderInput>;
  timestamp?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  value?: InputMaybe<SortOrderInput>;
  version?: InputMaybe<TransactionVersionOrderByRelationAggregateInput>;
  wallet?: InputMaybe<WalletOrderByWithRelationInput>;
  walletId?: InputMaybe<SortOrderInput>;
};

export type TransactionScalarWhereInput = {
  AND?: InputMaybe<Array<TransactionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<TransactionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inputData?: InputMaybe<JsonNullableFilter>;
  isDeposit?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumTransactionStatusNullableFilter>;
  timestamp?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
  walletId?: InputMaybe<StringNullableFilter>;
};

export enum TransactionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type TransactionSumAggregate = {
  __typename?: 'TransactionSumAggregate';
  value?: Maybe<Scalars['Decimal']>;
};

export type TransactionUpdateInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutTransactionNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutTransactionsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionUpdateManyWithoutTransactionNestedInput>;
  wallet?: InputMaybe<WalletUpdateOneWithoutTransactionsNestedInput>;
};

export type TransactionUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
};

export type TransactionUpdateManyWithWhereWithoutFlightInput = {
  data: TransactionUpdateManyMutationInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithWhereWithoutWalletInput = {
  data: TransactionUpdateManyMutationInput;
  where: TransactionScalarWhereInput;
};

export type TransactionUpdateManyWithoutFlightNestedInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutFlightInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutFlightInput>>;
  createMany?: InputMaybe<TransactionCreateManyFlightInputEnvelope>;
  delete?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionUpdateWithWhereUniqueWithoutFlightInput>>;
  updateMany?: InputMaybe<Array<TransactionUpdateManyWithWhereWithoutFlightInput>>;
  upsert?: InputMaybe<Array<TransactionUpsertWithWhereUniqueWithoutFlightInput>>;
};

export type TransactionUpdateManyWithoutWalletNestedInput = {
  connect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionCreateOrConnectWithoutWalletInput>>;
  create?: InputMaybe<Array<TransactionCreateWithoutWalletInput>>;
  createMany?: InputMaybe<TransactionCreateManyWalletInputEnvelope>;
  delete?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionUpdateWithWhereUniqueWithoutWalletInput>>;
  updateMany?: InputMaybe<Array<TransactionUpdateManyWithWhereWithoutWalletInput>>;
  upsert?: InputMaybe<Array<TransactionUpsertWithWhereUniqueWithoutWalletInput>>;
};

export type TransactionUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<TransactionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TransactionCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<TransactionCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<TransactionWhereInput>;
  disconnect?: InputMaybe<TransactionWhereInput>;
  update?: InputMaybe<TransactionUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<TransactionUpsertWithoutAttachmentsInput>;
};

export type TransactionUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: TransactionUpdateWithoutAttachmentsInput;
  where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionUpdateWithWhereUniqueWithoutFlightInput = {
  data: TransactionUpdateWithoutFlightInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithWhereUniqueWithoutWalletInput = {
  data: TransactionUpdateWithoutWalletInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpdateWithoutAttachmentsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutTransactionsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionUpdateManyWithoutTransactionNestedInput>;
  wallet?: InputMaybe<WalletUpdateOneWithoutTransactionsNestedInput>;
};

export type TransactionUpdateWithoutFlightInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutTransactionNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionUpdateManyWithoutTransactionNestedInput>;
  wallet?: InputMaybe<WalletUpdateOneWithoutTransactionsNestedInput>;
};

export type TransactionUpdateWithoutWalletInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutTransactionNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutTransactionsNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<Scalars['JSON']>;
  isDeposit?: InputMaybe<Scalars['Boolean']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<TransactionStatus>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Decimal']>;
  version?: InputMaybe<TransactionVersionUpdateManyWithoutTransactionNestedInput>;
};

export type TransactionUpsertWithWhereUniqueWithoutFlightInput = {
  create: TransactionCreateWithoutFlightInput;
  update: TransactionUpdateWithoutFlightInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithWhereUniqueWithoutWalletInput = {
  create: TransactionCreateWithoutWalletInput;
  update: TransactionUpdateWithoutWalletInput;
  where: TransactionWhereUniqueInput;
};

export type TransactionUpsertWithoutAttachmentsInput = {
  create: TransactionCreateWithoutAttachmentsInput;
  update: TransactionUpdateWithoutAttachmentsInput;
  where?: InputMaybe<TransactionWhereInput>;
};

export type TransactionVersion = {
  __typename?: 'TransactionVersion';
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type TransactionVersionCreateManyTransactionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type TransactionVersionCreateManyTransactionInputEnvelope = {
  data: Array<TransactionVersionCreateManyTransactionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TransactionVersionCreateNestedManyWithoutTransactionInput = {
  connect?: InputMaybe<Array<TransactionVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionVersionCreateOrConnectWithoutTransactionInput>>;
  create?: InputMaybe<Array<TransactionVersionCreateWithoutTransactionInput>>;
  createMany?: InputMaybe<TransactionVersionCreateManyTransactionInputEnvelope>;
};

export type TransactionVersionCreateOrConnectWithoutTransactionInput = {
  create: TransactionVersionCreateWithoutTransactionInput;
  where: TransactionVersionWhereUniqueInput;
};

export type TransactionVersionCreateWithoutTransactionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation: AuditOperation;
  timestamp: Scalars['DateTime'];
  userId?: InputMaybe<Scalars['String']>;
};

export type TransactionVersionListRelationFilter = {
  every?: InputMaybe<TransactionVersionWhereInput>;
  none?: InputMaybe<TransactionVersionWhereInput>;
  some?: InputMaybe<TransactionVersionWhereInput>;
};

export type TransactionVersionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TransactionVersionScalarWhereInput = {
  AND?: InputMaybe<Array<TransactionVersionScalarWhereInput>>;
  NOT?: InputMaybe<Array<TransactionVersionScalarWhereInput>>;
  OR?: InputMaybe<Array<TransactionVersionScalarWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type TransactionVersionUpdateManyMutationInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type TransactionVersionUpdateManyWithWhereWithoutTransactionInput = {
  data: TransactionVersionUpdateManyMutationInput;
  where: TransactionVersionScalarWhereInput;
};

export type TransactionVersionUpdateManyWithoutTransactionNestedInput = {
  connect?: InputMaybe<Array<TransactionVersionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TransactionVersionCreateOrConnectWithoutTransactionInput>>;
  create?: InputMaybe<Array<TransactionVersionCreateWithoutTransactionInput>>;
  createMany?: InputMaybe<TransactionVersionCreateManyTransactionInputEnvelope>;
  delete?: InputMaybe<Array<TransactionVersionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TransactionVersionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TransactionVersionWhereUniqueInput>>;
  set?: InputMaybe<Array<TransactionVersionWhereUniqueInput>>;
  update?: InputMaybe<Array<TransactionVersionUpdateWithWhereUniqueWithoutTransactionInput>>;
  updateMany?: InputMaybe<Array<TransactionVersionUpdateManyWithWhereWithoutTransactionInput>>;
  upsert?: InputMaybe<Array<TransactionVersionUpsertWithWhereUniqueWithoutTransactionInput>>;
};

export type TransactionVersionUpdateWithWhereUniqueWithoutTransactionInput = {
  data: TransactionVersionUpdateWithoutTransactionInput;
  where: TransactionVersionWhereUniqueInput;
};

export type TransactionVersionUpdateWithoutTransactionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  operation?: InputMaybe<AuditOperation>;
  timestamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type TransactionVersionUpsertWithWhereUniqueWithoutTransactionInput = {
  create: TransactionVersionCreateWithoutTransactionInput;
  update: TransactionVersionUpdateWithoutTransactionInput;
  where: TransactionVersionWhereUniqueInput;
};

export type TransactionVersionWhereInput = {
  AND?: InputMaybe<Array<TransactionVersionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionVersionWhereInput>>;
  OR?: InputMaybe<Array<TransactionVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<IntFilter>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  transaction?: InputMaybe<TransactionNullableScalarRelationFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type TransactionVersionWhereUniqueInput = {
  AND?: InputMaybe<Array<TransactionVersionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionVersionWhereInput>>;
  OR?: InputMaybe<Array<TransactionVersionWhereInput>>;
  data?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<EnumAuditOperationFilter>;
  timestamp?: InputMaybe<DateTimeFilter>;
  transaction?: InputMaybe<TransactionNullableScalarRelationFilter>;
  transactionId?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type TransactionWhereInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inputData?: InputMaybe<JsonNullableFilter>;
  isDeposit?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumTransactionStatusNullableFilter>;
  timestamp?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
  version?: InputMaybe<TransactionVersionListRelationFilter>;
  wallet?: InputMaybe<WalletNullableScalarRelationFilter>;
  walletId?: InputMaybe<StringNullableFilter>;
};

export type TransactionWhereUniqueInput = {
  AND?: InputMaybe<Array<TransactionWhereInput>>;
  NOT?: InputMaybe<Array<TransactionWhereInput>>;
  OR?: InputMaybe<Array<TransactionWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inputData?: InputMaybe<JsonNullableFilter>;
  isDeposit?: InputMaybe<BoolNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  status?: InputMaybe<EnumTransactionStatusNullableFilter>;
  timestamp?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<DecimalNullableFilter>;
  version?: InputMaybe<TransactionVersionListRelationFilter>;
  wallet?: InputMaybe<WalletNullableScalarRelationFilter>;
  walletId?: InputMaybe<StringNullableFilter>;
};

export type TransactionsUpdateAttachmentsInput = {
  attachmentsConnect?: InputMaybe<Array<Scalars['String']>>;
  attachmentsDisconnect?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateCraftInput = {
  airSyncId?: InputMaybe<Scalars['String']>;
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCraftNestedInput>;
  components?: InputMaybe<ComponentUpdateManyWithoutCraftNestedInput>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutCraftNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutCraftNestedInput>;
  flights?: InputMaybe<FlightUpdateManyWithoutCraftNestedInput>;
  fuelCapacity?: InputMaybe<Scalars['Float']>;
  fuelUnit?: InputMaybe<VolumeMeasurement>;
  homeBase?: InputMaybe<Scalars['String']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  hourlyRateMethod?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  initialHobbs?: InputMaybe<Scalars['Float']>;
  initialTach?: InputMaybe<Scalars['Float']>;
  initialTach2?: InputMaybe<Scalars['Float']>;
  inspectionGroups?: InputMaybe<InspectionGroupUpdateManyWithoutCraftNestedInput>;
  inspections?: InputMaybe<InspectionUpdateManyWithoutCraftNestedInput>;
  integrationInfo?: InputMaybe<Scalars['JSON']>;
  intervals?: InputMaybe<IntervalUpdateManyWithoutCraftNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  logBooks?: InputMaybe<LogBookUpdateManyWithoutCraftNestedInput>;
  loggingOption?: InputMaybe<LogType>;
  maintenanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutCraftNestedInput>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  mroCraft?: InputMaybe<MroCraftUpdateManyWithoutCraftNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  oilUnit?: InputMaybe<VolumeMeasurement>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutCraftsNestedInput>;
  position?: InputMaybe<Scalars['Float']>;
  regAddress?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutCraftNestedInput>;
  shareOptions?: InputMaybe<Scalars['JSON']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  shareToken?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutCraftNestedInput>;
  tailNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CraftType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageRecords?: InputMaybe<UsageRecordUpdateManyWithoutCraftNestedInput>;
  year?: InputMaybe<Scalars['Float']>;
};

export type UpdateEstimateWithToken = {
  authorizedBy: Scalars['String'];
  authorizedTotal: Scalars['Float'];
  id: Scalars['String'];
  items: Array<EstimateItemInput>;
  notes: Scalars['String'];
  status: Scalars['String'];
  token: Scalars['String'];
};

export type UpdateJascCategoryInput = {
  code?: InputMaybe<Scalars['Int']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  jascSystems?: InputMaybe<JascSystemUpdateManyWithoutJascCategoryNestedInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateJascSystemInput = {
  code?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  jascCategory?: InputMaybe<JascCategoryUpdateOneWithoutJascSystemsNestedInput>;
  logEntry?: InputMaybe<LogEntryUpdateManyWithoutSystemsAffectedNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutSystemsAffectedNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateMroWorkOrderWithContactInfo = {
  arrivalDate?: InputMaybe<Scalars['DateTime']>;
  assignees?: InputMaybe<MroEmployeeProfileUpdateManyWithoutAssignedWorkOrdersNestedInput>;
  completionDate?: InputMaybe<Scalars['DateTime']>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutMroWorkOrderNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /** Updated Email Contact */
  email?: InputMaybe<Scalars['String']>;
  /** Updated First Name Contact */
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  itemCategories?: InputMaybe<MroWorkOrderItemCategoryUpdateManyWithoutMroWorkOrderNestedInput>;
  /** Updated Last Name Contact */
  lastName?: InputMaybe<Scalars['String']>;
  mroCommunicationThreads?: InputMaybe<MroCommunicationThreadUpdateManyWithoutMroWorkOrderNestedInput>;
  mroCraft?: InputMaybe<MroCraftUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroCustomer?: InputMaybe<MroCustomerUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroEstimates?: InputMaybe<MroEstimateUpdateManyWithoutMroWorkOrderNestedInput>;
  mroInvoices?: InputMaybe<MroInvoiceUpdateManyWithoutMroWorkOrderNestedInput>;
  mroLocation?: InputMaybe<MroLocationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroLogEntries?: InputMaybe<MroLogEntryUpdateManyWithoutMroWorkOrderNestedInput>;
  mroOrganization?: InputMaybe<MroOrganizationUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroServiceRequest?: InputMaybe<MroServiceRequestUpdateOneWithoutMroWorkOrderNestedInput>;
  mroWorkOrderBillingItems?: InputMaybe<MroWorkOrderBillingItemUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderCategory?: InputMaybe<MroWorkOrderCategoryUpdateOneWithoutMroWorkOrdersNestedInput>;
  mroWorkOrderIntervals?: InputMaybe<MroWorkOrderIntervalUpdateManyWithoutMroWorkOrderNestedInput>;
  mroWorkOrderItems?: InputMaybe<MroWorkOrderItemUpdateManyWithoutMroWorkOrderNestedInput>;
  notes?: InputMaybe<Scalars['String']>;
  /** Updated Phone Contact */
  phone?: InputMaybe<Scalars['String']>;
  primaryConcern?: InputMaybe<Scalars['String']>;
  primaryContact?: InputMaybe<MroContactUpdateOneWithoutMroWorkOrdersNestedInput>;
  promiseDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  versions?: InputMaybe<MroWorkOrderVersionUpdateManyWithoutMroWorkOrderNestedInput>;
  workOrderNum?: InputMaybe<Scalars['Int']>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
};

export type UsageRecord = {
  __typename?: 'UsageRecord';
  _count: UsageRecordCount;
  attachments?: Maybe<Array<Attachment>>;
  craft: Craft;
  craftId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flight?: Maybe<Flight>;
  flightId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intervalLogs?: Maybe<Array<IntervalLog>>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsageRecordCount = {
  __typename?: 'UsageRecordCount';
  attachments: Scalars['Int'];
  intervalLogs: Scalars['Int'];
};

export type UsageRecordCountAggregate = {
  __typename?: 'UsageRecordCountAggregate';
  _all: Scalars['Int'];
  craftId: Scalars['Int'];
  createdAt: Scalars['Int'];
  date: Scalars['Int'];
  deletedAt: Scalars['Int'];
  flightId: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  notes: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type UsageRecordCreateInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUsageRecordInput>;
  craft: CraftCreateNestedOneWithoutUsageRecordsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutUsageRecordInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutUsageRecordInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordCreateManyCraftInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordCreateManyCraftInputEnvelope = {
  data: Array<UsageRecordCreateManyCraftInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UsageRecordCreateNestedManyWithoutCraftInput = {
  connect?: InputMaybe<Array<UsageRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UsageRecordCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<UsageRecordCreateWithoutCraftInput>>;
  createMany?: InputMaybe<UsageRecordCreateManyCraftInputEnvelope>;
};

export type UsageRecordCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<UsageRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsageRecordCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<UsageRecordCreateWithoutAttachmentsInput>;
};

export type UsageRecordCreateNestedOneWithoutFlightInput = {
  connect?: InputMaybe<UsageRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsageRecordCreateOrConnectWithoutFlightInput>;
  create?: InputMaybe<UsageRecordCreateWithoutFlightInput>;
};

export type UsageRecordCreateNestedOneWithoutIntervalLogsInput = {
  connect?: InputMaybe<UsageRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsageRecordCreateOrConnectWithoutIntervalLogsInput>;
  create?: InputMaybe<UsageRecordCreateWithoutIntervalLogsInput>;
};

export type UsageRecordCreateOrConnectWithoutAttachmentsInput = {
  create: UsageRecordCreateWithoutAttachmentsInput;
  where: UsageRecordWhereUniqueInput;
};

export type UsageRecordCreateOrConnectWithoutCraftInput = {
  create: UsageRecordCreateWithoutCraftInput;
  where: UsageRecordWhereUniqueInput;
};

export type UsageRecordCreateOrConnectWithoutFlightInput = {
  create: UsageRecordCreateWithoutFlightInput;
  where: UsageRecordWhereUniqueInput;
};

export type UsageRecordCreateOrConnectWithoutIntervalLogsInput = {
  create: UsageRecordCreateWithoutIntervalLogsInput;
  where: UsageRecordWhereUniqueInput;
};

export type UsageRecordCreateWithoutAttachmentsInput = {
  craft: CraftCreateNestedOneWithoutUsageRecordsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutUsageRecordInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutUsageRecordInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordCreateWithoutCraftInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUsageRecordInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutUsageRecordInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutUsageRecordInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordCreateWithoutFlightInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUsageRecordInput>;
  craft: CraftCreateNestedOneWithoutUsageRecordsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogCreateNestedManyWithoutUsageRecordInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordCreateWithoutIntervalLogsInput = {
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUsageRecordInput>;
  craft: CraftCreateNestedOneWithoutUsageRecordsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightCreateNestedOneWithoutUsageRecordInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordListRelationFilter = {
  every?: InputMaybe<UsageRecordWhereInput>;
  none?: InputMaybe<UsageRecordWhereInput>;
  some?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordMaxAggregate = {
  __typename?: 'UsageRecordMaxAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsageRecordMinAggregate = {
  __typename?: 'UsageRecordMinAggregate';
  craftId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  flightId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UsageRecordNullableScalarRelationFilter = {
  is?: InputMaybe<UsageRecordWhereInput>;
  isNot?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UsageRecordOrderByRelevanceFieldEnum {
  CraftId = 'craftId',
  FlightId = 'flightId',
  Id = 'id',
  LegacyId = 'legacyId',
  Notes = 'notes'
}

export type UsageRecordOrderByRelevanceInput = {
  fields: Array<UsageRecordOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UsageRecordOrderByWithRelationInput = {
  _relevance?: InputMaybe<UsageRecordOrderByRelevanceInput>;
  attachments?: InputMaybe<AttachmentOrderByRelationAggregateInput>;
  craft?: InputMaybe<CraftOrderByWithRelationInput>;
  craftId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrderInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  flight?: InputMaybe<FlightOrderByWithRelationInput>;
  flightId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  intervalLogs?: InputMaybe<IntervalLogOrderByRelationAggregateInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  notes?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type UsageRecordScalarWhereInput = {
  AND?: InputMaybe<Array<UsageRecordScalarWhereInput>>;
  NOT?: InputMaybe<Array<UsageRecordScalarWhereInput>>;
  OR?: InputMaybe<Array<UsageRecordScalarWhereInput>>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type UsageRecordUpdateInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUsageRecordNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutUsageRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutUsageRecordNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutUsageRecordNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordUpdateManyMutationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordUpdateManyWithWhereWithoutCraftInput = {
  data: UsageRecordUpdateManyMutationInput;
  where: UsageRecordScalarWhereInput;
};

export type UsageRecordUpdateManyWithoutCraftNestedInput = {
  connect?: InputMaybe<Array<UsageRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UsageRecordCreateOrConnectWithoutCraftInput>>;
  create?: InputMaybe<Array<UsageRecordCreateWithoutCraftInput>>;
  createMany?: InputMaybe<UsageRecordCreateManyCraftInputEnvelope>;
  delete?: InputMaybe<Array<UsageRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UsageRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UsageRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<UsageRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<UsageRecordUpdateWithWhereUniqueWithoutCraftInput>>;
  updateMany?: InputMaybe<Array<UsageRecordUpdateManyWithWhereWithoutCraftInput>>;
  upsert?: InputMaybe<Array<UsageRecordUpsertWithWhereUniqueWithoutCraftInput>>;
};

export type UsageRecordUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<UsageRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsageRecordCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<UsageRecordCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<UsageRecordWhereInput>;
  disconnect?: InputMaybe<UsageRecordWhereInput>;
  update?: InputMaybe<UsageRecordUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<UsageRecordUpsertWithoutAttachmentsInput>;
};

export type UsageRecordUpdateOneWithoutFlightNestedInput = {
  connect?: InputMaybe<UsageRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsageRecordCreateOrConnectWithoutFlightInput>;
  create?: InputMaybe<UsageRecordCreateWithoutFlightInput>;
  delete?: InputMaybe<UsageRecordWhereInput>;
  disconnect?: InputMaybe<UsageRecordWhereInput>;
  update?: InputMaybe<UsageRecordUpdateToOneWithWhereWithoutFlightInput>;
  upsert?: InputMaybe<UsageRecordUpsertWithoutFlightInput>;
};

export type UsageRecordUpdateOneWithoutIntervalLogsNestedInput = {
  connect?: InputMaybe<UsageRecordWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UsageRecordCreateOrConnectWithoutIntervalLogsInput>;
  create?: InputMaybe<UsageRecordCreateWithoutIntervalLogsInput>;
  delete?: InputMaybe<UsageRecordWhereInput>;
  disconnect?: InputMaybe<UsageRecordWhereInput>;
  update?: InputMaybe<UsageRecordUpdateToOneWithWhereWithoutIntervalLogsInput>;
  upsert?: InputMaybe<UsageRecordUpsertWithoutIntervalLogsInput>;
};

export type UsageRecordUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: UsageRecordUpdateWithoutAttachmentsInput;
  where?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordUpdateToOneWithWhereWithoutFlightInput = {
  data: UsageRecordUpdateWithoutFlightInput;
  where?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordUpdateToOneWithWhereWithoutIntervalLogsInput = {
  data: UsageRecordUpdateWithoutIntervalLogsInput;
  where?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordUpdateWithWhereUniqueWithoutCraftInput = {
  data: UsageRecordUpdateWithoutCraftInput;
  where: UsageRecordWhereUniqueInput;
};

export type UsageRecordUpdateWithoutAttachmentsInput = {
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutUsageRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutUsageRecordNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutUsageRecordNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordUpdateWithoutCraftInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUsageRecordNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutUsageRecordNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutUsageRecordNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordUpdateWithoutFlightInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUsageRecordNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutUsageRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogUpdateManyWithoutUsageRecordNestedInput>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordUpdateWithoutIntervalLogsInput = {
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUsageRecordNestedInput>;
  craft?: InputMaybe<CraftUpdateOneRequiredWithoutUsageRecordsNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  date?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  flight?: InputMaybe<FlightUpdateOneWithoutUsageRecordNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UsageRecordUpsertWithWhereUniqueWithoutCraftInput = {
  create: UsageRecordCreateWithoutCraftInput;
  update: UsageRecordUpdateWithoutCraftInput;
  where: UsageRecordWhereUniqueInput;
};

export type UsageRecordUpsertWithoutAttachmentsInput = {
  create: UsageRecordCreateWithoutAttachmentsInput;
  update: UsageRecordUpdateWithoutAttachmentsInput;
  where?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordUpsertWithoutFlightInput = {
  create: UsageRecordCreateWithoutFlightInput;
  update: UsageRecordUpdateWithoutFlightInput;
  where?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordUpsertWithoutIntervalLogsInput = {
  create: UsageRecordCreateWithoutIntervalLogsInput;
  update: UsageRecordUpdateWithoutIntervalLogsInput;
  where?: InputMaybe<UsageRecordWhereInput>;
};

export type UsageRecordWhereInput = {
  AND?: InputMaybe<Array<UsageRecordWhereInput>>;
  NOT?: InputMaybe<Array<UsageRecordWhereInput>>;
  OR?: InputMaybe<Array<UsageRecordWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  intervalLogs?: InputMaybe<IntervalLogListRelationFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type UsageRecordWhereUniqueInput = {
  AND?: InputMaybe<Array<UsageRecordWhereInput>>;
  NOT?: InputMaybe<Array<UsageRecordWhereInput>>;
  OR?: InputMaybe<Array<UsageRecordWhereInput>>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  craft?: InputMaybe<CraftScalarRelationFilter>;
  craftId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  flight?: InputMaybe<FlightNullableScalarRelationFilter>;
  flightId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  intervalLogs?: InputMaybe<IntervalLogListRelationFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type User = {
  __typename?: 'User';
  _count: UserCount;
  airmenLicense?: Maybe<Scalars['JSON']>;
  attachments?: Maybe<Array<Attachment>>;
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['DateTime'];
  dateFormat?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  digitalSignatures?: Maybe<Array<DigitalSignature>>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPasswordSet?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logEntriesSigned?: Maybe<Array<LogEntry>>;
  metadata?: Maybe<Scalars['JSON']>;
  mroEmployeeProfiles?: Maybe<Array<MroEmployeeProfile>>;
  mroIssue?: Maybe<Array<MroIssue>>;
  mroOrganizations?: Maybe<Array<MroOrganization>>;
  organizations?: Maybe<Array<Organization>>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: Maybe<Scalars['String']>;
  selectedOrganizationProfile?: Maybe<UserOrganizationProfile>;
  shareStatus?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userOrganizationProfiles?: Maybe<Array<UserOrganizationProfile>>;
};


export type UserCouponArgs = {
  input?: InputMaybe<OrganizationWhereInput>;
};


export type UserOrganizationsArgs = {
  input?: InputMaybe<OrganizationWhereInput>;
};


export type UserUserOrganizationProfilesArgs = {
  input?: InputMaybe<OrganizationWhereInput>;
};

export type UserCount = {
  __typename?: 'UserCount';
  attachments: Scalars['Int'];
  digitalSignatures: Scalars['Int'];
  logEntriesSigned: Scalars['Int'];
  mroEmployeeProfiles: Scalars['Int'];
  mroIssue: Scalars['Int'];
  mroOrganizations: Scalars['Int'];
  organizations: Scalars['Int'];
  userOrganizationProfiles: Scalars['Int'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int'];
  airmenLicense: Scalars['Int'];
  createdAt: Scalars['Int'];
  dateFormat: Scalars['Int'];
  deletedAt: Scalars['Int'];
  email: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  isPasswordSet: Scalars['Int'];
  lastName: Scalars['Int'];
  legacyId: Scalars['Int'];
  metadata: Scalars['Int'];
  password: Scalars['Int'];
  role: Scalars['Int'];
  selectedOrganizationId: Scalars['Int'];
  shareStatus: Scalars['Int'];
  timezone: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type UserCreateNestedManyWithoutMroOrganizationsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutMroOrganizationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutMroOrganizationsInput>>;
};

export type UserCreateNestedManyWithoutOrganizationsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutOrganizationsInput>>;
};

export type UserCreateNestedOneWithoutAttachmentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<UserCreateWithoutAttachmentsInput>;
};

export type UserCreateNestedOneWithoutDigitalSignaturesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDigitalSignaturesInput>;
  create?: InputMaybe<UserCreateWithoutDigitalSignaturesInput>;
};

export type UserCreateNestedOneWithoutLogEntriesSignedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLogEntriesSignedInput>;
  create?: InputMaybe<UserCreateWithoutLogEntriesSignedInput>;
};

export type UserCreateNestedOneWithoutMroEmployeeProfilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMroEmployeeProfilesInput>;
  create?: InputMaybe<UserCreateWithoutMroEmployeeProfilesInput>;
};

export type UserCreateNestedOneWithoutMroIssueInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMroIssueInput>;
  create?: InputMaybe<UserCreateWithoutMroIssueInput>;
};

export type UserCreateNestedOneWithoutUserOrganizationProfilesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserOrganizationProfilesInput>;
  create?: InputMaybe<UserCreateWithoutUserOrganizationProfilesInput>;
};

export type UserCreateOrConnectWithoutAttachmentsInput = {
  create: UserCreateWithoutAttachmentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDigitalSignaturesInput = {
  create: UserCreateWithoutDigitalSignaturesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutLogEntriesSignedInput = {
  create: UserCreateWithoutLogEntriesSignedInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMroEmployeeProfilesInput = {
  create: UserCreateWithoutMroEmployeeProfilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMroIssueInput = {
  create: UserCreateWithoutMroIssueInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMroOrganizationsInput = {
  create: UserCreateWithoutMroOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutOrganizationsInput = {
  create: UserCreateWithoutOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserOrganizationProfilesInput = {
  create: UserCreateWithoutUserOrganizationProfilesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAttachmentsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutDigitalSignaturesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutLogEntriesSignedInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMroEmployeeProfilesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMroIssueInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMroOrganizationsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutOrganizationsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserOrganizationProfilesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureCreateNestedManyWithoutUserInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryCreateNestedManyWithoutSignedUserInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileCreateNestedManyWithoutUserInput>;
  mroIssue?: InputMaybe<MroIssueCreateNestedManyWithoutUserInput>;
  mroOrganizations?: InputMaybe<MroOrganizationCreateNestedManyWithoutUsersInput>;
  organizations?: InputMaybe<OrganizationCreateNestedManyWithoutUsersInput>;
  password: Scalars['String'];
  role: Role;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  dateFormat?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPasswordSet?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  selectedOrganizationId?: Maybe<Scalars['String']>;
  shareStatus?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  dateFormat?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPasswordSet?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  selectedOrganizationId?: Maybe<Scalars['String']>;
  shareStatus?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserNullableScalarRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserOrderByRelevanceFieldEnum {
  DateFormat = 'dateFormat',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  LegacyId = 'legacyId',
  Password = 'password',
  SelectedOrganizationId = 'selectedOrganizationId',
  ShareStatus = 'shareStatus',
  Timezone = 'timezone'
}

export type UserOrderByRelevanceInput = {
  fields: Array<UserOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserOrderByWithRelationInput = {
  _relevance?: InputMaybe<UserOrderByRelevanceInput>;
  airmenLicense?: InputMaybe<SortOrderInput>;
  attachments?: InputMaybe<AttachmentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  dateFormat?: InputMaybe<SortOrderInput>;
  deletedAt?: InputMaybe<SortOrderInput>;
  digitalSignatures?: InputMaybe<DigitalSignatureOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isPasswordSet?: InputMaybe<SortOrderInput>;
  lastName?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  logEntriesSigned?: InputMaybe<LogEntryOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileOrderByRelationAggregateInput>;
  mroIssue?: InputMaybe<MroIssueOrderByRelationAggregateInput>;
  mroOrganizations?: InputMaybe<MroOrganizationOrderByRelationAggregateInput>;
  organizations?: InputMaybe<OrganizationOrderByRelationAggregateInput>;
  password?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  selectedOrganizationId?: InputMaybe<SortOrderInput>;
  shareStatus?: InputMaybe<SortOrderInput>;
  timezone?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileOrderByRelationAggregateInput>;
};

export type UserOrganizationProfile = {
  __typename?: 'UserOrganizationProfile';
  _count: UserOrganizationProfileCount;
  announcements?: Maybe<Array<Announcement>>;
  comments?: Maybe<Array<Comment>>;
  consumableEntry?: Maybe<Array<ConsumableEntry>>;
  copilotReservation?: Maybe<Array<Reservation>>;
  craftIdsAccess?: Maybe<Array<Scalars['String']>>;
  craftServiceRequests?: Maybe<Array<CraftServiceRequest>>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  documents?: Maybe<Array<Document>>;
  emailInvite?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  flights?: Maybe<Array<Flight>>;
  foreflightInfo?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  inviteAttachments?: Maybe<Array<Attachment>>;
  inviteId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  logEntries?: Maybe<Array<LogEntry>>;
  matienanceRecords?: Maybe<Array<MaintenanceRecord>>;
  metadata?: Maybe<Scalars['JSON']>;
  nameInvite?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<Scalars['JSON']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  passengerFlights?: Maybe<Array<Flight>>;
  passengersReservation?: Maybe<Array<Reservation>>;
  phone?: Maybe<Scalars['String']>;
  phoneInvite?: Maybe<Scalars['String']>;
  reservations?: Maybe<Array<Reservation>>;
  role?: Maybe<Role>;
  selectedCraftId?: Maybe<Scalars['String']>;
  specialBilling?: Maybe<Scalars['Decimal']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  squawks?: Maybe<Array<Squawk>>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userNoteAccess?: Maybe<Scalars['Boolean']>;
  userNotes?: Maybe<Scalars['String']>;
  userOrganizationRole?: Maybe<UserOrganizationRole>;
  userOrganizationRoleId?: Maybe<Scalars['String']>;
  wallets?: Maybe<Array<Wallet>>;
};

export type UserOrganizationProfileAvgAggregate = {
  __typename?: 'UserOrganizationProfileAvgAggregate';
  specialBilling?: Maybe<Scalars['Decimal']>;
};

export type UserOrganizationProfileCount = {
  __typename?: 'UserOrganizationProfileCount';
  announcements: Scalars['Int'];
  comments: Scalars['Int'];
  consumableEntry: Scalars['Int'];
  copilotReservation: Scalars['Int'];
  craftServiceRequests: Scalars['Int'];
  documents: Scalars['Int'];
  flights: Scalars['Int'];
  inviteAttachments: Scalars['Int'];
  logEntries: Scalars['Int'];
  matienanceRecords: Scalars['Int'];
  passengerFlights: Scalars['Int'];
  passengersReservation: Scalars['Int'];
  reservations: Scalars['Int'];
  squawks: Scalars['Int'];
  wallets: Scalars['Int'];
};

export type UserOrganizationProfileCountAggregate = {
  __typename?: 'UserOrganizationProfileCountAggregate';
  _all: Scalars['Int'];
  craftIdsAccess: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  emailInvite: Scalars['Int'];
  foreflightInfo: Scalars['Int'];
  id: Scalars['Int'];
  inviteId: Scalars['Int'];
  legacyId: Scalars['Int'];
  metadata: Scalars['Int'];
  nameInvite: Scalars['Int'];
  notificationSettings: Scalars['Int'];
  organizationId: Scalars['Int'];
  phone: Scalars['Int'];
  phoneInvite: Scalars['Int'];
  role: Scalars['Int'];
  selectedCraftId: Scalars['Int'];
  specialBilling: Scalars['Int'];
  specialBillingEnabled: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
  userNoteAccess: Scalars['Int'];
  userNotes: Scalars['Int'];
  userOrganizationRoleId: Scalars['Int'];
};

export type UserOrganizationProfileCreateInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateManyOrganizationInput = {
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailInvite?: InputMaybe<Scalars['String']>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRoleId?: InputMaybe<Scalars['String']>;
};

export type UserOrganizationProfileCreateManyOrganizationInputEnvelope = {
  data: Array<UserOrganizationProfileCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserOrganizationProfileCreateManyUserInput = {
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailInvite?: InputMaybe<Scalars['String']>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organizationId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRoleId?: InputMaybe<Scalars['String']>;
};

export type UserOrganizationProfileCreateManyUserInputEnvelope = {
  data: Array<UserOrganizationProfileCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserOrganizationProfileCreateManyUserOrganizationRoleInput = {
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailInvite?: InputMaybe<Scalars['String']>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organizationId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
};

export type UserOrganizationProfileCreateManyUserOrganizationRoleInputEnvelope = {
  data: Array<UserOrganizationProfileCreateManyUserOrganizationRoleInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserOrganizationProfileCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<UserOrganizationProfileCreateManyOrganizationInputEnvelope>;
};

export type UserOrganizationProfileCreateNestedManyWithoutPassengerFlightsInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutPassengerFlightsInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutPassengerFlightsInput>>;
};

export type UserOrganizationProfileCreateNestedManyWithoutPassengersReservationInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutPassengersReservationInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutPassengersReservationInput>>;
};

export type UserOrganizationProfileCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserOrganizationProfileCreateManyUserInputEnvelope>;
};

export type UserOrganizationProfileCreateNestedManyWithoutUserOrganizationRoleInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutUserOrganizationRoleInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutUserOrganizationRoleInput>>;
  createMany?: InputMaybe<UserOrganizationProfileCreateManyUserOrganizationRoleInputEnvelope>;
};

export type UserOrganizationProfileCreateNestedOneWithoutAnnouncementsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutAnnouncementsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutAnnouncementsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutCommentsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutConsumableEntryInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutConsumableEntryInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutConsumableEntryInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutCopilotReservationInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutCopilotReservationInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutCopilotReservationInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutCraftServiceRequestsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutCraftServiceRequestsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutDocumentsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutDocumentsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutFlightsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutFlightsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutInviteAttachmentsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutInviteAttachmentsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutInviteAttachmentsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutLogEntriesInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutLogEntriesInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutLogEntriesInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutMatienanceRecordsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutMatienanceRecordsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutMatienanceRecordsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutReservationsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutReservationsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutReservationsInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutSquawksInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutSquawksInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutSquawksInput>;
};

export type UserOrganizationProfileCreateNestedOneWithoutWalletsInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutWalletsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutWalletsInput>;
};

export type UserOrganizationProfileCreateOrConnectWithoutAnnouncementsInput = {
  create: UserOrganizationProfileCreateWithoutAnnouncementsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutCommentsInput = {
  create: UserOrganizationProfileCreateWithoutCommentsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutConsumableEntryInput = {
  create: UserOrganizationProfileCreateWithoutConsumableEntryInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutCopilotReservationInput = {
  create: UserOrganizationProfileCreateWithoutCopilotReservationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutCraftServiceRequestsInput = {
  create: UserOrganizationProfileCreateWithoutCraftServiceRequestsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutDocumentsInput = {
  create: UserOrganizationProfileCreateWithoutDocumentsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutFlightsInput = {
  create: UserOrganizationProfileCreateWithoutFlightsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutInviteAttachmentsInput = {
  create: UserOrganizationProfileCreateWithoutInviteAttachmentsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutLogEntriesInput = {
  create: UserOrganizationProfileCreateWithoutLogEntriesInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutMatienanceRecordsInput = {
  create: UserOrganizationProfileCreateWithoutMatienanceRecordsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutOrganizationInput = {
  create: UserOrganizationProfileCreateWithoutOrganizationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutPassengerFlightsInput = {
  create: UserOrganizationProfileCreateWithoutPassengerFlightsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutPassengersReservationInput = {
  create: UserOrganizationProfileCreateWithoutPassengersReservationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutReservationsInput = {
  create: UserOrganizationProfileCreateWithoutReservationsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutSquawksInput = {
  create: UserOrganizationProfileCreateWithoutSquawksInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutUserInput = {
  create: UserOrganizationProfileCreateWithoutUserInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutUserOrganizationRoleInput = {
  create: UserOrganizationProfileCreateWithoutUserOrganizationRoleInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateOrConnectWithoutWalletsInput = {
  create: UserOrganizationProfileCreateWithoutWalletsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileCreateWithoutAnnouncementsInput = {
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutCommentsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutConsumableEntryInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutCopilotReservationInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutCraftServiceRequestsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutDocumentsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutFlightsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutInviteAttachmentsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutLogEntriesInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutMatienanceRecordsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutOrganizationInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutPassengerFlightsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutPassengersReservationInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutReservationsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutSquawksInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutUserInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutUserOrganizationRoleInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  wallets?: InputMaybe<WalletCreateNestedManyWithoutUserProfileInput>;
};

export type UserOrganizationProfileCreateWithoutWalletsInput = {
  announcements?: InputMaybe<AnnouncementCreateNestedManyWithoutCreatorInput>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCreatorInput>;
  consumableEntry?: InputMaybe<ConsumableEntryCreateNestedManyWithoutUserOrgProfileInput>;
  copilotReservation?: InputMaybe<ReservationCreateNestedManyWithoutCopilotInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestCreateNestedManyWithoutUserProfileInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentCreateNestedManyWithoutUserProfileInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightCreateNestedManyWithoutUserProfileInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentCreateNestedManyWithoutUserOrganizationProfileInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryCreateNestedManyWithoutUserProfileInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordCreateNestedManyWithoutPerformedByInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationProfilesInput>;
  passengerFlights?: InputMaybe<FlightCreateNestedManyWithoutPassengersInput>;
  passengersReservation?: InputMaybe<ReservationCreateNestedManyWithoutPassengersInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationCreateNestedManyWithoutPilotInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkCreateNestedManyWithoutUserProfileInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserOrganizationProfilesInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput>;
};

export type UserOrganizationProfileListRelationFilter = {
  every?: InputMaybe<UserOrganizationProfileWhereInput>;
  none?: InputMaybe<UserOrganizationProfileWhereInput>;
  some?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileMaxAggregate = {
  __typename?: 'UserOrganizationProfileMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailInvite?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  nameInvite?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneInvite?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  selectedCraftId?: Maybe<Scalars['String']>;
  specialBilling?: Maybe<Scalars['Decimal']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  userNoteAccess?: Maybe<Scalars['Boolean']>;
  userNotes?: Maybe<Scalars['String']>;
  userOrganizationRoleId?: Maybe<Scalars['String']>;
};

export type UserOrganizationProfileMinAggregate = {
  __typename?: 'UserOrganizationProfileMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  emailInvite?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  inviteId?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  nameInvite?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneInvite?: Maybe<Scalars['String']>;
  role?: Maybe<Role>;
  selectedCraftId?: Maybe<Scalars['String']>;
  specialBilling?: Maybe<Scalars['Decimal']>;
  specialBillingEnabled?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  userNoteAccess?: Maybe<Scalars['Boolean']>;
  userNotes?: Maybe<Scalars['String']>;
  userOrganizationRoleId?: Maybe<Scalars['String']>;
};

export type UserOrganizationProfileNullableScalarRelationFilter = {
  is?: InputMaybe<UserOrganizationProfileWhereInput>;
  isNot?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserOrganizationProfileOrderByRelevanceFieldEnum {
  CraftIdsAccess = 'craftIdsAccess',
  EmailInvite = 'emailInvite',
  Id = 'id',
  InviteId = 'inviteId',
  LegacyId = 'legacyId',
  NameInvite = 'nameInvite',
  OrganizationId = 'organizationId',
  Phone = 'phone',
  PhoneInvite = 'phoneInvite',
  SelectedCraftId = 'selectedCraftId',
  Status = 'status',
  UserId = 'userId',
  UserNotes = 'userNotes',
  UserOrganizationRoleId = 'userOrganizationRoleId'
}

export type UserOrganizationProfileOrderByRelevanceInput = {
  fields: Array<UserOrganizationProfileOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserOrganizationProfileOrderByWithRelationInput = {
  _relevance?: InputMaybe<UserOrganizationProfileOrderByRelevanceInput>;
  announcements?: InputMaybe<AnnouncementOrderByRelationAggregateInput>;
  comments?: InputMaybe<CommentOrderByRelationAggregateInput>;
  consumableEntry?: InputMaybe<ConsumableEntryOrderByRelationAggregateInput>;
  copilotReservation?: InputMaybe<ReservationOrderByRelationAggregateInput>;
  craftIdsAccess?: InputMaybe<SortOrder>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  documents?: InputMaybe<DocumentOrderByRelationAggregateInput>;
  emailInvite?: InputMaybe<SortOrderInput>;
  flights?: InputMaybe<FlightOrderByRelationAggregateInput>;
  foreflightInfo?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  inviteAttachments?: InputMaybe<AttachmentOrderByRelationAggregateInput>;
  inviteId?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  logEntries?: InputMaybe<LogEntryOrderByRelationAggregateInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  nameInvite?: InputMaybe<SortOrderInput>;
  notificationSettings?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  passengerFlights?: InputMaybe<FlightOrderByRelationAggregateInput>;
  passengersReservation?: InputMaybe<ReservationOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrderInput>;
  phoneInvite?: InputMaybe<SortOrderInput>;
  reservations?: InputMaybe<ReservationOrderByRelationAggregateInput>;
  role?: InputMaybe<SortOrderInput>;
  selectedCraftId?: InputMaybe<SortOrderInput>;
  specialBilling?: InputMaybe<SortOrderInput>;
  specialBillingEnabled?: InputMaybe<SortOrderInput>;
  squawks?: InputMaybe<SquawkOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  userNoteAccess?: InputMaybe<SortOrderInput>;
  userNotes?: InputMaybe<SortOrderInput>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleOrderByWithRelationInput>;
  userOrganizationRoleId?: InputMaybe<SortOrderInput>;
  wallets?: InputMaybe<WalletOrderByRelationAggregateInput>;
};

export type UserOrganizationProfileScalarRelationFilter = {
  is?: InputMaybe<UserOrganizationProfileWhereInput>;
  isNot?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileScalarWhereInput = {
  AND?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  OR?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  craftIdsAccess?: InputMaybe<StringNullableListFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  emailInvite?: InputMaybe<StringNullableFilter>;
  foreflightInfo?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inviteId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  nameInvite?: InputMaybe<StringNullableFilter>;
  notificationSettings?: InputMaybe<JsonNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  phoneInvite?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumRoleNullableFilter>;
  selectedCraftId?: InputMaybe<StringNullableFilter>;
  specialBilling?: InputMaybe<DecimalNullableFilter>;
  specialBillingEnabled?: InputMaybe<BoolNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userNoteAccess?: InputMaybe<BoolNullableFilter>;
  userNotes?: InputMaybe<StringNullableFilter>;
  userOrganizationRoleId?: InputMaybe<StringNullableFilter>;
};

export type UserOrganizationProfileSumAggregate = {
  __typename?: 'UserOrganizationProfileSumAggregate';
  specialBilling?: Maybe<Scalars['Decimal']>;
};

export type UserOrganizationProfileUpdateInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateManyMutationInput = {
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailInvite?: InputMaybe<Scalars['String']>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
};

export type UserOrganizationProfileUpdateManyWithWhereWithoutOrganizationInput = {
  data: UserOrganizationProfileUpdateManyMutationInput;
  where: UserOrganizationProfileScalarWhereInput;
};

export type UserOrganizationProfileUpdateManyWithWhereWithoutPassengerFlightsInput = {
  data: UserOrganizationProfileUpdateManyMutationInput;
  where: UserOrganizationProfileScalarWhereInput;
};

export type UserOrganizationProfileUpdateManyWithWhereWithoutPassengersReservationInput = {
  data: UserOrganizationProfileUpdateManyMutationInput;
  where: UserOrganizationProfileScalarWhereInput;
};

export type UserOrganizationProfileUpdateManyWithWhereWithoutUserInput = {
  data: UserOrganizationProfileUpdateManyMutationInput;
  where: UserOrganizationProfileScalarWhereInput;
};

export type UserOrganizationProfileUpdateManyWithWhereWithoutUserOrganizationRoleInput = {
  data: UserOrganizationProfileUpdateManyMutationInput;
  where: UserOrganizationProfileScalarWhereInput;
};

export type UserOrganizationProfileUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<UserOrganizationProfileCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserOrganizationProfileUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<UserOrganizationProfileUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<UserOrganizationProfileUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type UserOrganizationProfileUpdateManyWithoutPassengerFlightsNestedInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutPassengerFlightsInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutPassengerFlightsInput>>;
  delete?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserOrganizationProfileUpdateWithWhereUniqueWithoutPassengerFlightsInput>>;
  updateMany?: InputMaybe<Array<UserOrganizationProfileUpdateManyWithWhereWithoutPassengerFlightsInput>>;
  upsert?: InputMaybe<Array<UserOrganizationProfileUpsertWithWhereUniqueWithoutPassengerFlightsInput>>;
};

export type UserOrganizationProfileUpdateManyWithoutPassengersReservationNestedInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutPassengersReservationInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutPassengersReservationInput>>;
  delete?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserOrganizationProfileUpdateWithWhereUniqueWithoutPassengersReservationInput>>;
  updateMany?: InputMaybe<Array<UserOrganizationProfileUpdateManyWithWhereWithoutPassengersReservationInput>>;
  upsert?: InputMaybe<Array<UserOrganizationProfileUpsertWithWhereUniqueWithoutPassengersReservationInput>>;
};

export type UserOrganizationProfileUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserOrganizationProfileCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserOrganizationProfileUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserOrganizationProfileUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserOrganizationProfileUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserOrganizationProfileUpdateManyWithoutUserOrganizationRoleNestedInput = {
  connect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationProfileCreateOrConnectWithoutUserOrganizationRoleInput>>;
  create?: InputMaybe<Array<UserOrganizationProfileCreateWithoutUserOrganizationRoleInput>>;
  createMany?: InputMaybe<UserOrganizationProfileCreateManyUserOrganizationRoleInputEnvelope>;
  delete?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserOrganizationProfileScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  set?: InputMaybe<Array<UserOrganizationProfileWhereUniqueInput>>;
  update?: InputMaybe<Array<UserOrganizationProfileUpdateWithWhereUniqueWithoutUserOrganizationRoleInput>>;
  updateMany?: InputMaybe<Array<UserOrganizationProfileUpdateManyWithWhereWithoutUserOrganizationRoleInput>>;
  upsert?: InputMaybe<Array<UserOrganizationProfileUpsertWithWhereUniqueWithoutUserOrganizationRoleInput>>;
};

export type UserOrganizationProfileUpdateOneRequiredWithoutAnnouncementsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutAnnouncementsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutAnnouncementsInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutAnnouncementsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutAnnouncementsInput>;
};

export type UserOrganizationProfileUpdateOneRequiredWithoutCommentsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutCommentsInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutCommentsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutConsumableEntryNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutConsumableEntryInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutConsumableEntryInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutConsumableEntryInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutConsumableEntryInput>;
};

export type UserOrganizationProfileUpdateOneWithoutCopilotReservationNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutCopilotReservationInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutCopilotReservationInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutCopilotReservationInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutCopilotReservationInput>;
};

export type UserOrganizationProfileUpdateOneWithoutCraftServiceRequestsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutCraftServiceRequestsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutCraftServiceRequestsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutCraftServiceRequestsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutCraftServiceRequestsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutDocumentsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutDocumentsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutDocumentsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutDocumentsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutDocumentsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutFlightsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutFlightsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutFlightsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutFlightsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutFlightsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutInviteAttachmentsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutInviteAttachmentsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutInviteAttachmentsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutInviteAttachmentsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutInviteAttachmentsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutLogEntriesNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutLogEntriesInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutLogEntriesInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutLogEntriesInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutLogEntriesInput>;
};

export type UserOrganizationProfileUpdateOneWithoutMatienanceRecordsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutMatienanceRecordsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutMatienanceRecordsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutMatienanceRecordsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutMatienanceRecordsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutReservationsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutReservationsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutReservationsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutReservationsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutReservationsInput>;
};

export type UserOrganizationProfileUpdateOneWithoutSquawksNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutSquawksInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutSquawksInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutSquawksInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutSquawksInput>;
};

export type UserOrganizationProfileUpdateOneWithoutWalletsNestedInput = {
  connect?: InputMaybe<UserOrganizationProfileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationProfileCreateOrConnectWithoutWalletsInput>;
  create?: InputMaybe<UserOrganizationProfileCreateWithoutWalletsInput>;
  delete?: InputMaybe<UserOrganizationProfileWhereInput>;
  disconnect?: InputMaybe<UserOrganizationProfileWhereInput>;
  update?: InputMaybe<UserOrganizationProfileUpdateToOneWithWhereWithoutWalletsInput>;
  upsert?: InputMaybe<UserOrganizationProfileUpsertWithoutWalletsInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutAnnouncementsInput = {
  data: UserOrganizationProfileUpdateWithoutAnnouncementsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutCommentsInput = {
  data: UserOrganizationProfileUpdateWithoutCommentsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutConsumableEntryInput = {
  data: UserOrganizationProfileUpdateWithoutConsumableEntryInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutCopilotReservationInput = {
  data: UserOrganizationProfileUpdateWithoutCopilotReservationInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutCraftServiceRequestsInput = {
  data: UserOrganizationProfileUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutDocumentsInput = {
  data: UserOrganizationProfileUpdateWithoutDocumentsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutFlightsInput = {
  data: UserOrganizationProfileUpdateWithoutFlightsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutInviteAttachmentsInput = {
  data: UserOrganizationProfileUpdateWithoutInviteAttachmentsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutLogEntriesInput = {
  data: UserOrganizationProfileUpdateWithoutLogEntriesInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutMatienanceRecordsInput = {
  data: UserOrganizationProfileUpdateWithoutMatienanceRecordsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutReservationsInput = {
  data: UserOrganizationProfileUpdateWithoutReservationsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutSquawksInput = {
  data: UserOrganizationProfileUpdateWithoutSquawksInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateToOneWithWhereWithoutWalletsInput = {
  data: UserOrganizationProfileUpdateWithoutWalletsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: UserOrganizationProfileUpdateWithoutOrganizationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpdateWithWhereUniqueWithoutPassengerFlightsInput = {
  data: UserOrganizationProfileUpdateWithoutPassengerFlightsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpdateWithWhereUniqueWithoutPassengersReservationInput = {
  data: UserOrganizationProfileUpdateWithoutPassengersReservationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpdateWithWhereUniqueWithoutUserInput = {
  data: UserOrganizationProfileUpdateWithoutUserInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpdateWithWhereUniqueWithoutUserOrganizationRoleInput = {
  data: UserOrganizationProfileUpdateWithoutUserOrganizationRoleInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpdateWithoutAnnouncementsInput = {
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutCommentsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutConsumableEntryInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutCopilotReservationInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutCraftServiceRequestsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutDocumentsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutFlightsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutInviteAttachmentsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutLogEntriesInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutMatienanceRecordsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutOrganizationInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutPassengerFlightsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutPassengersReservationInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutReservationsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutSquawksInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutUserInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutUserOrganizationRoleInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  wallets?: InputMaybe<WalletUpdateManyWithoutUserProfileNestedInput>;
};

export type UserOrganizationProfileUpdateWithoutWalletsInput = {
  announcements?: InputMaybe<AnnouncementUpdateManyWithoutCreatorNestedInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCreatorNestedInput>;
  consumableEntry?: InputMaybe<ConsumableEntryUpdateManyWithoutUserOrgProfileNestedInput>;
  copilotReservation?: InputMaybe<ReservationUpdateManyWithoutCopilotNestedInput>;
  craftIdsAccess?: InputMaybe<Array<Scalars['String']>>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestUpdateManyWithoutUserProfileNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  documents?: InputMaybe<DocumentUpdateManyWithoutUserProfileNestedInput>;
  emailInvite?: InputMaybe<Scalars['String']>;
  flights?: InputMaybe<FlightUpdateManyWithoutUserProfileNestedInput>;
  foreflightInfo?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentUpdateManyWithoutUserOrganizationProfileNestedInput>;
  inviteId?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryUpdateManyWithoutUserProfileNestedInput>;
  matienanceRecords?: InputMaybe<MaintenanceRecordUpdateManyWithoutPerformedByNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  nameInvite?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<Scalars['JSON']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  passengerFlights?: InputMaybe<FlightUpdateManyWithoutPassengersNestedInput>;
  passengersReservation?: InputMaybe<ReservationUpdateManyWithoutPassengersNestedInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneInvite?: InputMaybe<Scalars['String']>;
  reservations?: InputMaybe<ReservationUpdateManyWithoutPilotNestedInput>;
  role?: InputMaybe<Role>;
  selectedCraftId?: InputMaybe<Scalars['String']>;
  specialBilling?: InputMaybe<Scalars['Decimal']>;
  specialBillingEnabled?: InputMaybe<Scalars['Boolean']>;
  squawks?: InputMaybe<SquawkUpdateManyWithoutUserProfileNestedInput>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserUpdateOneWithoutUserOrganizationProfilesNestedInput>;
  userNoteAccess?: InputMaybe<Scalars['Boolean']>;
  userNotes?: InputMaybe<Scalars['String']>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput>;
};

export type UserOrganizationProfileUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: UserOrganizationProfileCreateWithoutOrganizationInput;
  update: UserOrganizationProfileUpdateWithoutOrganizationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpsertWithWhereUniqueWithoutPassengerFlightsInput = {
  create: UserOrganizationProfileCreateWithoutPassengerFlightsInput;
  update: UserOrganizationProfileUpdateWithoutPassengerFlightsInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpsertWithWhereUniqueWithoutPassengersReservationInput = {
  create: UserOrganizationProfileCreateWithoutPassengersReservationInput;
  update: UserOrganizationProfileUpdateWithoutPassengersReservationInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpsertWithWhereUniqueWithoutUserInput = {
  create: UserOrganizationProfileCreateWithoutUserInput;
  update: UserOrganizationProfileUpdateWithoutUserInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpsertWithWhereUniqueWithoutUserOrganizationRoleInput = {
  create: UserOrganizationProfileCreateWithoutUserOrganizationRoleInput;
  update: UserOrganizationProfileUpdateWithoutUserOrganizationRoleInput;
  where: UserOrganizationProfileWhereUniqueInput;
};

export type UserOrganizationProfileUpsertWithoutAnnouncementsInput = {
  create: UserOrganizationProfileCreateWithoutAnnouncementsInput;
  update: UserOrganizationProfileUpdateWithoutAnnouncementsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutCommentsInput = {
  create: UserOrganizationProfileCreateWithoutCommentsInput;
  update: UserOrganizationProfileUpdateWithoutCommentsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutConsumableEntryInput = {
  create: UserOrganizationProfileCreateWithoutConsumableEntryInput;
  update: UserOrganizationProfileUpdateWithoutConsumableEntryInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutCopilotReservationInput = {
  create: UserOrganizationProfileCreateWithoutCopilotReservationInput;
  update: UserOrganizationProfileUpdateWithoutCopilotReservationInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutCraftServiceRequestsInput = {
  create: UserOrganizationProfileCreateWithoutCraftServiceRequestsInput;
  update: UserOrganizationProfileUpdateWithoutCraftServiceRequestsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutDocumentsInput = {
  create: UserOrganizationProfileCreateWithoutDocumentsInput;
  update: UserOrganizationProfileUpdateWithoutDocumentsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutFlightsInput = {
  create: UserOrganizationProfileCreateWithoutFlightsInput;
  update: UserOrganizationProfileUpdateWithoutFlightsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutInviteAttachmentsInput = {
  create: UserOrganizationProfileCreateWithoutInviteAttachmentsInput;
  update: UserOrganizationProfileUpdateWithoutInviteAttachmentsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutLogEntriesInput = {
  create: UserOrganizationProfileCreateWithoutLogEntriesInput;
  update: UserOrganizationProfileUpdateWithoutLogEntriesInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutMatienanceRecordsInput = {
  create: UserOrganizationProfileCreateWithoutMatienanceRecordsInput;
  update: UserOrganizationProfileUpdateWithoutMatienanceRecordsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutReservationsInput = {
  create: UserOrganizationProfileCreateWithoutReservationsInput;
  update: UserOrganizationProfileUpdateWithoutReservationsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutSquawksInput = {
  create: UserOrganizationProfileCreateWithoutSquawksInput;
  update: UserOrganizationProfileUpdateWithoutSquawksInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileUpsertWithoutWalletsInput = {
  create: UserOrganizationProfileCreateWithoutWalletsInput;
  update: UserOrganizationProfileUpdateWithoutWalletsInput;
  where?: InputMaybe<UserOrganizationProfileWhereInput>;
};

export type UserOrganizationProfileWhereInput = {
  AND?: InputMaybe<Array<UserOrganizationProfileWhereInput>>;
  NOT?: InputMaybe<Array<UserOrganizationProfileWhereInput>>;
  OR?: InputMaybe<Array<UserOrganizationProfileWhereInput>>;
  announcements?: InputMaybe<AnnouncementListRelationFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  consumableEntry?: InputMaybe<ConsumableEntryListRelationFilter>;
  copilotReservation?: InputMaybe<ReservationListRelationFilter>;
  craftIdsAccess?: InputMaybe<StringNullableListFilter>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  emailInvite?: InputMaybe<StringNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  foreflightInfo?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  inviteAttachments?: InputMaybe<AttachmentListRelationFilter>;
  inviteId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  matienanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  nameInvite?: InputMaybe<StringNullableFilter>;
  notificationSettings?: InputMaybe<JsonNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  passengerFlights?: InputMaybe<FlightListRelationFilter>;
  passengersReservation?: InputMaybe<ReservationListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  phoneInvite?: InputMaybe<StringNullableFilter>;
  reservations?: InputMaybe<ReservationListRelationFilter>;
  role?: InputMaybe<EnumRoleNullableFilter>;
  selectedCraftId?: InputMaybe<StringNullableFilter>;
  specialBilling?: InputMaybe<DecimalNullableFilter>;
  specialBillingEnabled?: InputMaybe<BoolNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userNoteAccess?: InputMaybe<BoolNullableFilter>;
  userNotes?: InputMaybe<StringNullableFilter>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleNullableScalarRelationFilter>;
  userOrganizationRoleId?: InputMaybe<StringNullableFilter>;
  wallets?: InputMaybe<WalletListRelationFilter>;
};

export type UserOrganizationProfileWhereUniqueInput = {
  AND?: InputMaybe<Array<UserOrganizationProfileWhereInput>>;
  NOT?: InputMaybe<Array<UserOrganizationProfileWhereInput>>;
  OR?: InputMaybe<Array<UserOrganizationProfileWhereInput>>;
  announcements?: InputMaybe<AnnouncementListRelationFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  consumableEntry?: InputMaybe<ConsumableEntryListRelationFilter>;
  copilotReservation?: InputMaybe<ReservationListRelationFilter>;
  craftIdsAccess?: InputMaybe<StringNullableListFilter>;
  craftServiceRequests?: InputMaybe<CraftServiceRequestListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  documents?: InputMaybe<DocumentListRelationFilter>;
  emailInvite?: InputMaybe<StringNullableFilter>;
  flights?: InputMaybe<FlightListRelationFilter>;
  foreflightInfo?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  inviteAttachments?: InputMaybe<AttachmentListRelationFilter>;
  inviteId?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntries?: InputMaybe<LogEntryListRelationFilter>;
  matienanceRecords?: InputMaybe<MaintenanceRecordListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  nameInvite?: InputMaybe<StringNullableFilter>;
  notificationSettings?: InputMaybe<JsonNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  passengerFlights?: InputMaybe<FlightListRelationFilter>;
  passengersReservation?: InputMaybe<ReservationListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  phoneInvite?: InputMaybe<StringNullableFilter>;
  reservations?: InputMaybe<ReservationListRelationFilter>;
  role?: InputMaybe<EnumRoleNullableFilter>;
  selectedCraftId?: InputMaybe<StringNullableFilter>;
  specialBilling?: InputMaybe<DecimalNullableFilter>;
  specialBillingEnabled?: InputMaybe<BoolNullableFilter>;
  squawks?: InputMaybe<SquawkListRelationFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  user?: InputMaybe<UserNullableScalarRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  userNoteAccess?: InputMaybe<BoolNullableFilter>;
  userNotes?: InputMaybe<StringNullableFilter>;
  userOrganizationRole?: InputMaybe<UserOrganizationRoleNullableScalarRelationFilter>;
  userOrganizationRoleId?: InputMaybe<StringNullableFilter>;
  wallets?: InputMaybe<WalletListRelationFilter>;
};

export type UserOrganizationRole = {
  __typename?: 'UserOrganizationRole';
  _count: UserOrganizationRoleCount;
  caslRules?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  userOrganizationProfiles?: Maybe<Array<UserOrganizationProfile>>;
};

export type UserOrganizationRoleAvgAggregate = {
  __typename?: 'UserOrganizationRoleAvgAggregate';
  sort?: Maybe<Scalars['Float']>;
};

export type UserOrganizationRoleCount = {
  __typename?: 'UserOrganizationRoleCount';
  userOrganizationProfiles: Scalars['Int'];
};

export type UserOrganizationRoleCountAggregate = {
  __typename?: 'UserOrganizationRoleCountAggregate';
  _all: Scalars['Int'];
  caslRules: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  legacyId: Scalars['Int'];
  organizationId: Scalars['Int'];
  sort: Scalars['Int'];
  title: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type UserOrganizationRoleCreateInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationRolesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserOrganizationRoleInput>;
};

export type UserOrganizationRoleCreateManyOrganizationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserOrganizationRoleCreateManyOrganizationInputEnvelope = {
  data: Array<UserOrganizationRoleCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserOrganizationRoleCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<UserOrganizationRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationRoleCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<UserOrganizationRoleCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<UserOrganizationRoleCreateManyOrganizationInputEnvelope>;
};

export type UserOrganizationRoleCreateNestedOneWithoutUserOrganizationProfilesInput = {
  connect?: InputMaybe<UserOrganizationRoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationRoleCreateOrConnectWithoutUserOrganizationProfilesInput>;
  create?: InputMaybe<UserOrganizationRoleCreateWithoutUserOrganizationProfilesInput>;
};

export type UserOrganizationRoleCreateOrConnectWithoutOrganizationInput = {
  create: UserOrganizationRoleCreateWithoutOrganizationInput;
  where: UserOrganizationRoleWhereUniqueInput;
};

export type UserOrganizationRoleCreateOrConnectWithoutUserOrganizationProfilesInput = {
  create: UserOrganizationRoleCreateWithoutUserOrganizationProfilesInput;
  where: UserOrganizationRoleWhereUniqueInput;
};

export type UserOrganizationRoleCreateWithoutOrganizationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileCreateNestedManyWithoutUserOrganizationRoleInput>;
};

export type UserOrganizationRoleCreateWithoutUserOrganizationProfilesInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutUserOrganizationRolesInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserOrganizationRoleListRelationFilter = {
  every?: InputMaybe<UserOrganizationRoleWhereInput>;
  none?: InputMaybe<UserOrganizationRoleWhereInput>;
  some?: InputMaybe<UserOrganizationRoleWhereInput>;
};

export type UserOrganizationRoleMaxAggregate = {
  __typename?: 'UserOrganizationRoleMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserOrganizationRoleMinAggregate = {
  __typename?: 'UserOrganizationRoleMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserOrganizationRoleNullableScalarRelationFilter = {
  is?: InputMaybe<UserOrganizationRoleWhereInput>;
  isNot?: InputMaybe<UserOrganizationRoleWhereInput>;
};

export type UserOrganizationRoleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum UserOrganizationRoleOrderByRelevanceFieldEnum {
  Id = 'id',
  LegacyId = 'legacyId',
  OrganizationId = 'organizationId',
  Title = 'title'
}

export type UserOrganizationRoleOrderByRelevanceInput = {
  fields: Array<UserOrganizationRoleOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type UserOrganizationRoleOrderByWithRelationInput = {
  _relevance?: InputMaybe<UserOrganizationRoleOrderByRelevanceInput>;
  caslRules?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  legacyId?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  sort?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileOrderByRelationAggregateInput>;
};

export type UserOrganizationRoleScalarWhereInput = {
  AND?: InputMaybe<Array<UserOrganizationRoleScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserOrganizationRoleScalarWhereInput>>;
  OR?: InputMaybe<Array<UserOrganizationRoleScalarWhereInput>>;
  caslRules?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type UserOrganizationRoleSumAggregate = {
  __typename?: 'UserOrganizationRoleSumAggregate';
  sort?: Maybe<Scalars['Int']>;
};

export type UserOrganizationRoleUpdateInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationRolesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserOrganizationRoleNestedInput>;
};

export type UserOrganizationRoleUpdateManyMutationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserOrganizationRoleUpdateManyWithWhereWithoutOrganizationInput = {
  data: UserOrganizationRoleUpdateManyMutationInput;
  where: UserOrganizationRoleScalarWhereInput;
};

export type UserOrganizationRoleUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<UserOrganizationRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserOrganizationRoleCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<UserOrganizationRoleCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<UserOrganizationRoleCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<UserOrganizationRoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserOrganizationRoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserOrganizationRoleWhereUniqueInput>>;
  set?: InputMaybe<Array<UserOrganizationRoleWhereUniqueInput>>;
  update?: InputMaybe<Array<UserOrganizationRoleUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<UserOrganizationRoleUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<UserOrganizationRoleUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type UserOrganizationRoleUpdateOneWithoutUserOrganizationProfilesNestedInput = {
  connect?: InputMaybe<UserOrganizationRoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserOrganizationRoleCreateOrConnectWithoutUserOrganizationProfilesInput>;
  create?: InputMaybe<UserOrganizationRoleCreateWithoutUserOrganizationProfilesInput>;
  delete?: InputMaybe<UserOrganizationRoleWhereInput>;
  disconnect?: InputMaybe<UserOrganizationRoleWhereInput>;
  update?: InputMaybe<UserOrganizationRoleUpdateToOneWithWhereWithoutUserOrganizationProfilesInput>;
  upsert?: InputMaybe<UserOrganizationRoleUpsertWithoutUserOrganizationProfilesInput>;
};

export type UserOrganizationRoleUpdateToOneWithWhereWithoutUserOrganizationProfilesInput = {
  data: UserOrganizationRoleUpdateWithoutUserOrganizationProfilesInput;
  where?: InputMaybe<UserOrganizationRoleWhereInput>;
};

export type UserOrganizationRoleUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: UserOrganizationRoleUpdateWithoutOrganizationInput;
  where: UserOrganizationRoleWhereUniqueInput;
};

export type UserOrganizationRoleUpdateWithoutOrganizationInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserOrganizationRoleNestedInput>;
};

export type UserOrganizationRoleUpdateWithoutUserOrganizationProfilesInput = {
  caslRules?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutUserOrganizationRolesNestedInput>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserOrganizationRoleUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: UserOrganizationRoleCreateWithoutOrganizationInput;
  update: UserOrganizationRoleUpdateWithoutOrganizationInput;
  where: UserOrganizationRoleWhereUniqueInput;
};

export type UserOrganizationRoleUpsertWithoutUserOrganizationProfilesInput = {
  create: UserOrganizationRoleCreateWithoutUserOrganizationProfilesInput;
  update: UserOrganizationRoleUpdateWithoutUserOrganizationProfilesInput;
  where?: InputMaybe<UserOrganizationRoleWhereInput>;
};

export type UserOrganizationRoleWhereInput = {
  AND?: InputMaybe<Array<UserOrganizationRoleWhereInput>>;
  NOT?: InputMaybe<Array<UserOrganizationRoleWhereInput>>;
  OR?: InputMaybe<Array<UserOrganizationRoleWhereInput>>;
  caslRules?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileListRelationFilter>;
};

export type UserOrganizationRoleWhereUniqueInput = {
  AND?: InputMaybe<Array<UserOrganizationRoleWhereInput>>;
  NOT?: InputMaybe<Array<UserOrganizationRoleWhereInput>>;
  OR?: InputMaybe<Array<UserOrganizationRoleWhereInput>>;
  caslRules?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  sort?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileListRelationFilter>;
};

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  airmenLicense?: InputMaybe<JsonNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateFormat?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPasswordSet?: InputMaybe<BoolNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  password?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  selectedOrganizationId?: InputMaybe<StringNullableFilter>;
  shareStatus?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type UserUpdateInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserUpdateManyWithWhereWithoutMroOrganizationsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutOrganizationsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutMroOrganizationsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutMroOrganizationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutMroOrganizationsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutMroOrganizationsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutMroOrganizationsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutMroOrganizationsInput>>;
};

export type UserUpdateManyWithoutOrganizationsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutOrganizationsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutOrganizationsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutOrganizationsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutOrganizationsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutOrganizationsInput>>;
};

export type UserUpdateOneWithoutAttachmentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAttachmentsInput>;
  create?: InputMaybe<UserCreateWithoutAttachmentsInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutAttachmentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAttachmentsInput>;
};

export type UserUpdateOneWithoutDigitalSignaturesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDigitalSignaturesInput>;
  create?: InputMaybe<UserCreateWithoutDigitalSignaturesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutDigitalSignaturesInput>;
  upsert?: InputMaybe<UserUpsertWithoutDigitalSignaturesInput>;
};

export type UserUpdateOneWithoutLogEntriesSignedNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutLogEntriesSignedInput>;
  create?: InputMaybe<UserCreateWithoutLogEntriesSignedInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutLogEntriesSignedInput>;
  upsert?: InputMaybe<UserUpsertWithoutLogEntriesSignedInput>;
};

export type UserUpdateOneWithoutMroEmployeeProfilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMroEmployeeProfilesInput>;
  create?: InputMaybe<UserCreateWithoutMroEmployeeProfilesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutMroEmployeeProfilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutMroEmployeeProfilesInput>;
};

export type UserUpdateOneWithoutMroIssueNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMroIssueInput>;
  create?: InputMaybe<UserCreateWithoutMroIssueInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutMroIssueInput>;
  upsert?: InputMaybe<UserUpsertWithoutMroIssueInput>;
};

export type UserUpdateOneWithoutUserOrganizationProfilesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserOrganizationProfilesInput>;
  create?: InputMaybe<UserCreateWithoutUserOrganizationProfilesInput>;
  delete?: InputMaybe<UserWhereInput>;
  disconnect?: InputMaybe<UserWhereInput>;
  update?: InputMaybe<UserUpdateToOneWithWhereWithoutUserOrganizationProfilesInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserOrganizationProfilesInput>;
};

export type UserUpdateToOneWithWhereWithoutAttachmentsInput = {
  data: UserUpdateWithoutAttachmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutDigitalSignaturesInput = {
  data: UserUpdateWithoutDigitalSignaturesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutLogEntriesSignedInput = {
  data: UserUpdateWithoutLogEntriesSignedInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMroEmployeeProfilesInput = {
  data: UserUpdateWithoutMroEmployeeProfilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutMroIssueInput = {
  data: UserUpdateWithoutMroIssueInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateToOneWithWhereWithoutUserOrganizationProfilesInput = {
  data: UserUpdateWithoutUserOrganizationProfilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpdateWithWhereUniqueWithoutMroOrganizationsInput = {
  data: UserUpdateWithoutMroOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutOrganizationsInput = {
  data: UserUpdateWithoutOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAttachmentsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutDigitalSignaturesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutLogEntriesSignedInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMroEmployeeProfilesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMroIssueInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMroOrganizationsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutOrganizationsInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserOrganizationProfilesInput = {
  airmenLicense?: InputMaybe<Scalars['JSON']>;
  attachments?: InputMaybe<AttachmentUpdateManyWithoutUserNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dateFormat?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  digitalSignatures?: InputMaybe<DigitalSignatureUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryUpdateManyWithoutSignedUserNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileUpdateManyWithoutUserNestedInput>;
  mroIssue?: InputMaybe<MroIssueUpdateManyWithoutUserNestedInput>;
  mroOrganizations?: InputMaybe<MroOrganizationUpdateManyWithoutUsersNestedInput>;
  organizations?: InputMaybe<OrganizationUpdateManyWithoutUsersNestedInput>;
  password?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  selectedOrganizationId?: InputMaybe<Scalars['String']>;
  shareStatus?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserUpsertWithWhereUniqueWithoutMroOrganizationsInput = {
  create: UserCreateWithoutMroOrganizationsInput;
  update: UserUpdateWithoutMroOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutOrganizationsInput = {
  create: UserCreateWithoutOrganizationsInput;
  update: UserUpdateWithoutOrganizationsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAttachmentsInput = {
  create: UserCreateWithoutAttachmentsInput;
  update: UserUpdateWithoutAttachmentsInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutDigitalSignaturesInput = {
  create: UserCreateWithoutDigitalSignaturesInput;
  update: UserUpdateWithoutDigitalSignaturesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutLogEntriesSignedInput = {
  create: UserCreateWithoutLogEntriesSignedInput;
  update: UserUpdateWithoutLogEntriesSignedInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMroEmployeeProfilesInput = {
  create: UserCreateWithoutMroEmployeeProfilesInput;
  update: UserUpdateWithoutMroEmployeeProfilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutMroIssueInput = {
  create: UserCreateWithoutMroIssueInput;
  update: UserUpdateWithoutMroIssueInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserUpsertWithoutUserOrganizationProfilesInput = {
  create: UserCreateWithoutUserOrganizationProfilesInput;
  update: UserUpdateWithoutUserOrganizationProfilesInput;
  where?: InputMaybe<UserWhereInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  airmenLicense?: InputMaybe<JsonNullableFilter>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateFormat?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  digitalSignatures?: InputMaybe<DigitalSignatureListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isPasswordSet?: InputMaybe<BoolNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  logEntriesSigned?: InputMaybe<LogEntryListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  mroIssue?: InputMaybe<MroIssueListRelationFilter>;
  mroOrganizations?: InputMaybe<MroOrganizationListRelationFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  selectedOrganizationId?: InputMaybe<StringNullableFilter>;
  shareStatus?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileListRelationFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  airmenLicense?: InputMaybe<JsonNullableFilter>;
  attachments?: InputMaybe<AttachmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dateFormat?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  digitalSignatures?: InputMaybe<DigitalSignatureListRelationFilter>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  isPasswordSet?: InputMaybe<BoolNullableFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  logEntriesSigned?: InputMaybe<LogEntryListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  mroEmployeeProfiles?: InputMaybe<MroEmployeeProfileListRelationFilter>;
  mroIssue?: InputMaybe<MroIssueListRelationFilter>;
  mroOrganizations?: InputMaybe<MroOrganizationListRelationFilter>;
  organizations?: InputMaybe<OrganizationListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  selectedOrganizationId?: InputMaybe<StringNullableFilter>;
  shareStatus?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userOrganizationProfiles?: InputMaybe<UserOrganizationProfileListRelationFilter>;
};

export enum VolumeMeasurement {
  Gallons = 'GALLONS',
  Liters = 'LITERS',
  Pounds = 'POUNDS',
  Quarts = 'QUARTS'
}

export type Wallet = {
  __typename?: 'Wallet';
  _count: WalletCount;
  balanceCache?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  lastTxAt?: Maybe<Scalars['DateTime']>;
  legacyId?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']>;
  transactions?: Maybe<Array<Transaction>>;
  txCounterCache?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfile?: Maybe<UserOrganizationProfile>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type WalletAvgAggregate = {
  __typename?: 'WalletAvgAggregate';
  balanceCache?: Maybe<Scalars['Decimal']>;
  txCounterCache?: Maybe<Scalars['Float']>;
};

export type WalletCount = {
  __typename?: 'WalletCount';
  transactions: Scalars['Int'];
};

export type WalletCountAggregate = {
  __typename?: 'WalletCountAggregate';
  _all: Scalars['Int'];
  balanceCache: Scalars['Int'];
  createdAt: Scalars['Int'];
  deletedAt: Scalars['Int'];
  id: Scalars['Int'];
  lastTxAt: Scalars['Int'];
  legacyId: Scalars['Int'];
  organizationId: Scalars['Int'];
  txCounterCache: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userProfileId: Scalars['Int'];
};

export type WalletCreateInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutWalletsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWalletInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutWalletsInput>;
};

export type WalletCreateManyOrganizationInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfileId?: InputMaybe<Scalars['String']>;
};

export type WalletCreateManyOrganizationInputEnvelope = {
  data: Array<WalletCreateManyOrganizationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type WalletCreateManyUserProfileInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['String']>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WalletCreateManyUserProfileInputEnvelope = {
  data: Array<WalletCreateManyUserProfileInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type WalletCreateNestedManyWithoutOrganizationInput = {
  connect?: InputMaybe<Array<WalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<WalletCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<WalletCreateManyOrganizationInputEnvelope>;
};

export type WalletCreateNestedManyWithoutUserProfileInput = {
  connect?: InputMaybe<Array<WalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<WalletCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<WalletCreateManyUserProfileInputEnvelope>;
};

export type WalletCreateNestedOneWithoutTransactionsInput = {
  connect?: InputMaybe<WalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WalletCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<WalletCreateWithoutTransactionsInput>;
};

export type WalletCreateOrConnectWithoutOrganizationInput = {
  create: WalletCreateWithoutOrganizationInput;
  where: WalletWhereUniqueInput;
};

export type WalletCreateOrConnectWithoutTransactionsInput = {
  create: WalletCreateWithoutTransactionsInput;
  where: WalletWhereUniqueInput;
};

export type WalletCreateOrConnectWithoutUserProfileInput = {
  create: WalletCreateWithoutUserProfileInput;
  where: WalletWhereUniqueInput;
};

export type WalletCreateWithoutOrganizationInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWalletInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutWalletsInput>;
};

export type WalletCreateWithoutTransactionsInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutWalletsInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileCreateNestedOneWithoutWalletsInput>;
};

export type WalletCreateWithoutUserProfileInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationCreateNestedOneWithoutWalletsInput>;
  transactions?: InputMaybe<TransactionCreateNestedManyWithoutWalletInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WalletListRelationFilter = {
  every?: InputMaybe<WalletWhereInput>;
  none?: InputMaybe<WalletWhereInput>;
  some?: InputMaybe<WalletWhereInput>;
};

export type WalletMaxAggregate = {
  __typename?: 'WalletMaxAggregate';
  balanceCache?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastTxAt?: Maybe<Scalars['DateTime']>;
  legacyId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  txCounterCache?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type WalletMinAggregate = {
  __typename?: 'WalletMinAggregate';
  balanceCache?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  lastTxAt?: Maybe<Scalars['DateTime']>;
  legacyId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  txCounterCache?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfileId?: Maybe<Scalars['String']>;
};

export type WalletNullableScalarRelationFilter = {
  is?: InputMaybe<WalletWhereInput>;
  isNot?: InputMaybe<WalletWhereInput>;
};

export type WalletOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export enum WalletOrderByRelevanceFieldEnum {
  Id = 'id',
  LegacyId = 'legacyId',
  OrganizationId = 'organizationId',
  UserProfileId = 'userProfileId'
}

export type WalletOrderByRelevanceInput = {
  fields: Array<WalletOrderByRelevanceFieldEnum>;
  search: Scalars['String'];
  sort: SortOrder;
};

export type WalletOrderByWithRelationInput = {
  _relevance?: InputMaybe<WalletOrderByRelevanceInput>;
  balanceCache?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastTxAt?: InputMaybe<SortOrderInput>;
  legacyId?: InputMaybe<SortOrderInput>;
  organization?: InputMaybe<OrganizationOrderByWithRelationInput>;
  organizationId?: InputMaybe<SortOrderInput>;
  transactions?: InputMaybe<TransactionOrderByRelationAggregateInput>;
  txCounterCache?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  userProfile?: InputMaybe<UserOrganizationProfileOrderByWithRelationInput>;
  userProfileId?: InputMaybe<SortOrderInput>;
};

export type WalletScalarWhereInput = {
  AND?: InputMaybe<Array<WalletScalarWhereInput>>;
  NOT?: InputMaybe<Array<WalletScalarWhereInput>>;
  OR?: InputMaybe<Array<WalletScalarWhereInput>>;
  balanceCache?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastTxAt?: InputMaybe<DateTimeNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  txCounterCache?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type WalletSumAggregate = {
  __typename?: 'WalletSumAggregate';
  balanceCache?: Maybe<Scalars['Decimal']>;
  txCounterCache?: Maybe<Scalars['Int']>;
};

export type WalletUpdateInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutWalletsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWalletNestedInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutWalletsNestedInput>;
};

export type WalletUpdateManyMutationInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WalletUpdateManyWithWhereWithoutOrganizationInput = {
  data: WalletUpdateManyMutationInput;
  where: WalletScalarWhereInput;
};

export type WalletUpdateManyWithWhereWithoutUserProfileInput = {
  data: WalletUpdateManyMutationInput;
  where: WalletScalarWhereInput;
};

export type WalletUpdateManyWithoutOrganizationNestedInput = {
  connect?: InputMaybe<Array<WalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletCreateOrConnectWithoutOrganizationInput>>;
  create?: InputMaybe<Array<WalletCreateWithoutOrganizationInput>>;
  createMany?: InputMaybe<WalletCreateManyOrganizationInputEnvelope>;
  delete?: InputMaybe<Array<WalletWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletUpdateWithWhereUniqueWithoutOrganizationInput>>;
  updateMany?: InputMaybe<Array<WalletUpdateManyWithWhereWithoutOrganizationInput>>;
  upsert?: InputMaybe<Array<WalletUpsertWithWhereUniqueWithoutOrganizationInput>>;
};

export type WalletUpdateManyWithoutUserProfileNestedInput = {
  connect?: InputMaybe<Array<WalletWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WalletCreateOrConnectWithoutUserProfileInput>>;
  create?: InputMaybe<Array<WalletCreateWithoutUserProfileInput>>;
  createMany?: InputMaybe<WalletCreateManyUserProfileInputEnvelope>;
  delete?: InputMaybe<Array<WalletWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WalletScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WalletWhereUniqueInput>>;
  set?: InputMaybe<Array<WalletWhereUniqueInput>>;
  update?: InputMaybe<Array<WalletUpdateWithWhereUniqueWithoutUserProfileInput>>;
  updateMany?: InputMaybe<Array<WalletUpdateManyWithWhereWithoutUserProfileInput>>;
  upsert?: InputMaybe<Array<WalletUpsertWithWhereUniqueWithoutUserProfileInput>>;
};

export type WalletUpdateOneWithoutTransactionsNestedInput = {
  connect?: InputMaybe<WalletWhereUniqueInput>;
  connectOrCreate?: InputMaybe<WalletCreateOrConnectWithoutTransactionsInput>;
  create?: InputMaybe<WalletCreateWithoutTransactionsInput>;
  delete?: InputMaybe<WalletWhereInput>;
  disconnect?: InputMaybe<WalletWhereInput>;
  update?: InputMaybe<WalletUpdateToOneWithWhereWithoutTransactionsInput>;
  upsert?: InputMaybe<WalletUpsertWithoutTransactionsInput>;
};

export type WalletUpdateToOneWithWhereWithoutTransactionsInput = {
  data: WalletUpdateWithoutTransactionsInput;
  where?: InputMaybe<WalletWhereInput>;
};

export type WalletUpdateWithWhereUniqueWithoutOrganizationInput = {
  data: WalletUpdateWithoutOrganizationInput;
  where: WalletWhereUniqueInput;
};

export type WalletUpdateWithWhereUniqueWithoutUserProfileInput = {
  data: WalletUpdateWithoutUserProfileInput;
  where: WalletWhereUniqueInput;
};

export type WalletUpdateWithoutOrganizationInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWalletNestedInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutWalletsNestedInput>;
};

export type WalletUpdateWithoutTransactionsInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutWalletsNestedInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userProfile?: InputMaybe<UserOrganizationProfileUpdateOneWithoutWalletsNestedInput>;
};

export type WalletUpdateWithoutUserProfileInput = {
  balanceCache?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<Scalars['DateTime']>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationUpdateOneWithoutWalletsNestedInput>;
  transactions?: InputMaybe<TransactionUpdateManyWithoutWalletNestedInput>;
  txCounterCache?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type WalletUpsertWithWhereUniqueWithoutOrganizationInput = {
  create: WalletCreateWithoutOrganizationInput;
  update: WalletUpdateWithoutOrganizationInput;
  where: WalletWhereUniqueInput;
};

export type WalletUpsertWithWhereUniqueWithoutUserProfileInput = {
  create: WalletCreateWithoutUserProfileInput;
  update: WalletUpdateWithoutUserProfileInput;
  where: WalletWhereUniqueInput;
};

export type WalletUpsertWithoutTransactionsInput = {
  create: WalletCreateWithoutTransactionsInput;
  update: WalletUpdateWithoutTransactionsInput;
  where?: InputMaybe<WalletWhereInput>;
};

export type WalletWhereInput = {
  AND?: InputMaybe<Array<WalletWhereInput>>;
  NOT?: InputMaybe<Array<WalletWhereInput>>;
  OR?: InputMaybe<Array<WalletWhereInput>>;
  balanceCache?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastTxAt?: InputMaybe<DateTimeNullableFilter>;
  legacyId?: InputMaybe<StringNullableFilter>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  txCounterCache?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type WalletWhereUniqueInput = {
  AND?: InputMaybe<Array<WalletWhereInput>>;
  NOT?: InputMaybe<Array<WalletWhereInput>>;
  OR?: InputMaybe<Array<WalletWhereInput>>;
  balanceCache?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<Scalars['String']>;
  lastTxAt?: InputMaybe<DateTimeNullableFilter>;
  legacyId?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<OrganizationNullableScalarRelationFilter>;
  organizationId?: InputMaybe<StringNullableFilter>;
  transactions?: InputMaybe<TransactionListRelationFilter>;
  txCounterCache?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  userProfile?: InputMaybe<UserOrganizationProfileNullableScalarRelationFilter>;
  userProfileId?: InputMaybe<StringNullableFilter>;
};

export type WeatherMetar = {
  __typename?: 'WeatherMetar';
  flightRules?: Maybe<Scalars['String']>;
  temperature?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['DateTime']>;
  weatherRemarks?: Maybe<Scalars['String']>;
  windspeed?: Maybe<Scalars['Boolean']>;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: string };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', refreshToken?: any | null, redirectToken?: string | null } };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null } };

export type GetCaslRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaslRulesQuery = { __typename?: 'Query', caslRules?: any | null };

export type GetOrgSubtypeQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetOrgSubtypeQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, organizationType: string } | null };

export type MainLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type MainLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null, redirectToken?: string | null } };

export type ImpersonateLoginMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ImpersonateLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null, redirectToken?: string | null } };

export type SendResetEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail: string };

export type ResetPasswordMutationVariables = Exact<{
  id: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: string };

export type NewUserSignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type NewUserSignupMutation = { __typename?: 'Mutation', signup: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null, user: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null } } };

export type HasCompletedWalkthroughQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type HasCompletedWalkthroughQuery = { __typename?: 'Query', hasCompletedWalkthrough: boolean };

export type CompletedWalkthroughMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompletedWalkthroughMutation = { __typename?: 'Mutation', completedWalkthrough: string };

export type GetInvitationQueryVariables = Exact<{
  id: Scalars['String'];
  token: Scalars['String'];
}>;


export type GetInvitationQuery = { __typename?: 'Query', getInvitation: { __typename?: 'UserOrganizationProfile', id: string, nameInvite?: string | null, emailInvite?: string | null, organization?: { __typename?: 'Organization', name: string } | null } };

export type AcceptInvitationMutationVariables = Exact<{
  id: Scalars['String'];
  token: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'UserOrganizationProfile', user?: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, role: Role } | null } };

export type GetMigrateInfoQueryVariables = Exact<{
  id: Scalars['String'];
  token: Scalars['String'];
}>;


export type GetMigrateInfoQuery = { __typename?: 'Query', migrateInfo: { __typename?: 'MigrateInfo', name?: string | null, email?: string | null } };

export type SetupPasswordFromTokenMutationVariables = Exact<{
  id: Scalars['String'];
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type SetupPasswordFromTokenMutation = { __typename?: 'Mutation', setupPasswordFromToken: string };

export type GetCouponCodeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetCouponCodeQuery = { __typename?: 'Query', getCouponCode: { __typename?: 'Coupon', id: string, code: string, active?: boolean | null, description?: string | null } };

export type SwitchOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type SwitchOrganizationMutation = { __typename?: 'Mutation', switchOrganization: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null } };

export type CheckIfUserHasInviteQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type CheckIfUserHasInviteQuery = { __typename?: 'Query', checkIfUserHasInvite: boolean };

export type GetMroCraftsQueryVariables = Exact<{
  where: MroCraftWhereInput;
}>;


export type GetMroCraftsQuery = { __typename?: 'Query', mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string, make: string, model: string, year: number, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, promiseDate?: any | null, arrivalDate?: any | null }> | null, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null } | null }> | null };

export type GetMroCraftQueryVariables = Exact<{
  mroCraftId: Scalars['String'];
}>;


export type GetMroCraftQuery = { __typename?: 'Query', mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, make: string, model: string, ownerName?: string | null, engineCount?: number | null, year: number, createdAt: any, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, promiseDate?: any | null, arrivalDate?: any | null, workOrderNum?: number | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, name?: string | null } | null }> | null, craft?: { __typename?: 'Craft', id: string, tailNumber: string, make?: string | null, model?: string | null, year?: number | null } | null, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null } | null } | null };

export type GetMroLogEntriesQueryVariables = Exact<{
  where: MroLogEntryWhereInput;
}>;


export type GetMroLogEntriesQuery = { __typename?: 'Query', mroLogEntries?: Array<{ __typename?: 'MroLogEntry', id: string, title?: string | null, status?: string | null, signedAt?: any | null, pdfLink: string, mroWorkOrderId?: string | null, mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, name?: string | null } | null } | null, itemCategory?: { __typename?: 'MroWorkOrderItemCategory', id: string, categoryNumber?: number | null } | null, mroLogEntryItems?: Array<{ __typename?: 'MroLogEntryItem', id: string }> | null }> | null };

export type UpdateMroCraftMutationVariables = Exact<{
  input: MroCraftUpdateInput;
}>;


export type UpdateMroCraftMutation = { __typename?: 'Mutation', updateMroCraft: { __typename?: 'MroCraft', id: string } };

export type CreateMroCraftMutationVariables = Exact<{
  input: MroCraftCreateInput;
}>;


export type CreateMroCraftMutation = { __typename?: 'Mutation', createMroCraft: { __typename?: 'MroCraft', id: string } };

export type RemoveMroCraftMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroCraftMutation = { __typename?: 'Mutation', removeMroCraft: { __typename?: 'MroCraft', id: string } };

export type GetTwilioTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetTwilioTokenMutation = { __typename?: 'Mutation', getTwilioAccessToken: string };

export type CreateCustomerThreadMutationVariables = Exact<{
  input: MroCommunicationThreadCreateInput;
}>;


export type CreateCustomerThreadMutation = { __typename?: 'Mutation', createMroCommunicationThread: { __typename?: 'MroCommunicationThread', id: string, twilioConversationSid?: string | null } };

export type GetCustomerThreadsQueryVariables = Exact<{
  where: MroCommunicationThreadWhereInput;
}>;


export type GetCustomerThreadsQuery = { __typename?: 'Query', mroCommunicationThreads: Array<{ __typename?: 'MroCommunicationThread', id: string, twilioConversationSid?: string | null, createdAt: any, updatedAt?: any | null }> };

export type AddConversationParticipantMutationVariables = Exact<{
  input: AddConversationParticipantInput;
}>;


export type AddConversationParticipantMutation = { __typename?: 'Mutation', addConversationParticipant: { __typename?: 'MroCommunicationThread', id: string } };

export type LoginForServiceMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginForServiceMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null, user: { __typename?: 'User', id: string, email: string, userOrganizationProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string, organization?: { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null } | null }> | null, organizations?: Array<{ __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null }> | null } } };

export type SignupForServiceMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignupForServiceMutation = { __typename?: 'Mutation', signup: { __typename?: 'Auth', accessToken?: any | null, refreshToken?: any | null, user: { __typename?: 'User', id: string, email: string, userOrganizationProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string, organization?: { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null } | null }> | null, organizations?: Array<{ __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null }> | null } } };

export type GetServiceUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceUserQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, userOrganizationProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string, organization?: { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null } | null }> | null, organizations?: Array<{ __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null }> | null } };

export type OnboardOrgMutationVariables = Exact<{
  craft: OnboardCraftInput;
  organization: OrganizationCreateInput;
}>;


export type OnboardOrgMutation = { __typename?: 'Mutation', onboardOrganization: { __typename?: 'OnboardOrganization', accessToken?: string | null, refreshToken?: string | null, id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null } };

export type CreateCraftMutationVariables = Exact<{
  craft: CreateCraftInput;
}>;


export type CreateCraftMutation = { __typename?: 'Mutation', createCraft: { __typename?: 'Craft', id: string } };

export type LookupTailQueryVariables = Exact<{
  tailNumber: Scalars['String'];
}>;


export type LookupTailQuery = { __typename?: 'Query', registrations: Array<{ __typename?: 'Registration', id: string, nNumber?: string | null, name?: string | null, yearMfr?: string | null, street?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, country?: string | null, engineCount?: number | null, onAccount: boolean, engineType?: RegisteredEngineType | null, manufacturer?: string | null, model?: string | null }> };

export type CreateServiceRequestMutationVariables = Exact<{
  request: OnboardMroRequestInput;
}>;


export type CreateServiceRequestMutation = { __typename?: 'Mutation', createMroRequstWithRelations: { __typename?: 'MroServiceRequest', id: string } };

export type ServiceInfoFragment = { __typename?: 'User', id: string, email: string, userOrganizationProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string, organization?: { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null } | null }> | null, organizations?: Array<{ __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null }> | null };

export type OnboardInfoFragment = { __typename?: 'OnboardOrganization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null };

export type OrgInfoFragment = { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, billingAddress?: { __typename?: 'MroAddress', address: string, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null, email?: string | null, phone?: string | null } | null, mroCraft: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }>, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null }> | null, crafts?: Array<{ __typename?: 'Craft', id: string, tailNumber: string }> | null };

export type EstimateInfoFragment = { __typename?: 'MroEstimate', id: string, date?: any | null, status?: string | null, total?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, mroOrganizationId?: string | null };

export type GetServiceEstimateTokenQueryVariables = Exact<{
  id: Scalars['String'];
  token: Scalars['String'];
}>;


export type GetServiceEstimateTokenQuery = { __typename?: 'Query', mroEstimateWithToken: { __typename?: 'MroEstimate', id: string, date?: any | null, status?: string | null, total?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, mroOrganizationId?: string | null } };

export type GetServiceEstimateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetServiceEstimateQuery = { __typename?: 'Query', mroEstimate?: { __typename?: 'MroEstimate', id: string, date?: any | null, status?: string | null, total?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, mroOrganizationId?: string | null } | null };

export type GetMroOrganizationNameQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type GetMroOrganizationNameQuery = { __typename?: 'Query', getMroOrganizationName: string };

export type GetMroOrganizationLocationsQueryVariables = Exact<{
  orgId: Scalars['String'];
}>;


export type GetMroOrganizationLocationsQuery = { __typename?: 'Query', getMroOrganizationLocations: Array<{ __typename?: 'MroLocation', code?: string | null, name?: string | null, id: string }> };

export type UpdateMroEstimateWithTokenMutationVariables = Exact<{
  input: UpdateEstimateWithToken;
}>;


export type UpdateMroEstimateWithTokenMutation = { __typename?: 'Mutation', updateMroEstimateStatusWithToken: string };

export type GetMroInvoiceWithTokenQueryVariables = Exact<{
  id: Scalars['String'];
  token: Scalars['String'];
}>;


export type GetMroInvoiceWithTokenQuery = { __typename?: 'Query', mroInvoiceWithToken: { __typename?: 'MroInvoice', id: string, invoiceDate?: any | null, invoiceNumber?: string | null, dueDate?: any | null, amount?: any | null, status?: string | null, customer?: any | null, mro?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, laborSummary?: any | null, pdfLink: string, mroOrganizationId?: string | null } };

export type GetMroOrganizationInfoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroOrganizationInfoQuery = { __typename?: 'Query', mroOrganizationInfo: { __typename?: 'OrgInfo', id: string, name: string, phone?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, fax?: string | null, estimateAuthorization?: string | null, icon?: string | null } };

export type GetPublicMroOrganizationsInfoQueryVariables = Exact<{
  where?: InputMaybe<MroOrganizationWhereInput>;
}>;


export type GetPublicMroOrganizationsInfoQuery = { __typename?: 'Query', getPublicMroOrganizationsInfo: Array<{ __typename?: 'OrgInfo', id: string, name: string, phone?: string | null, address?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, fax?: string | null, icon?: string | null }> };

export type GetMroCustomersQueryVariables = Exact<{
  where: MroCustomerWhereInput;
}>;


export type GetMroCustomersQuery = { __typename?: 'Query', mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null }> | null, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, status?: string | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, status?: string | null }> | null, mroInvoices?: Array<{ __typename?: 'MroInvoice', id: string, status?: string | null }> | null }> | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null }> | null };

export type GetMroCustomerQueryVariables = Exact<{
  mroCustomerId: Scalars['String'];
}>;


export type GetMroCustomerQuery = { __typename?: 'Query', mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, phoneNumbers?: any | null, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null }> | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null }> | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string, make: string, model: string, year: number, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, promiseDate?: any | null, arrivalDate?: any | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null }> | null, craft?: { __typename?: 'Craft', id: string, tailNumber: string, make?: string | null, model?: string | null, year?: number | null } | null }> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null };

export type CreateMroCustomerAndCraftMutationVariables = Exact<{
  input: OnboardMroCustomerInput;
}>;


export type CreateMroCustomerAndCraftMutation = { __typename?: 'Mutation', onboardMroCustomer: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }> | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string }> | null, billingAddress?: { __typename?: 'MroAddress', address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, email?: string | null, phone?: string | null, title: string, id: string } | null } };

export type AddMemberToMroCustomerMutationVariables = Exact<{
  input: AddContactToMroCustomerInput;
}>;


export type AddMemberToMroCustomerMutation = { __typename?: 'Mutation', addContactToMroCustomer: { __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null } };

export type GetMroInvoicesQueryVariables = Exact<{
  where: MroInvoiceWhereInput;
}>;


export type GetMroInvoicesQuery = { __typename?: 'Query', mroInvoices?: Array<{ __typename?: 'MroInvoice', id: string, invoiceDate?: any | null, invoiceNumber?: string | null, dueDate?: any | null, amount?: any | null, status?: string | null, customer?: any | null, mro?: any | null, items?: any | null, charges?: any | null, priceSummary?: any | null, laborSummary?: any | null, pdfLink: string }> | null };

export type AddCraftToMroCustomerMutationVariables = Exact<{
  input: AddCraftToMroCustomerInput;
}>;


export type AddCraftToMroCustomerMutation = { __typename?: 'Mutation', addCraftToMroCustomer: { __typename?: 'MroCraft', id: string, tailNumber: string, year: number, make: string, model: string, ownerName?: string | null } };

export type UpdateMroCustomerMutationVariables = Exact<{
  input: MroCustomerUpdateInput;
}>;


export type UpdateMroCustomerMutation = { __typename?: 'Mutation', updateMroCustomer: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, phoneNumbers?: any | null, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string }> | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null }> | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string, make: string, model: string, year: number, mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, promiseDate?: any | null, arrivalDate?: any | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null }> | null, craft?: { __typename?: 'Craft', id: string, tailNumber: string, make?: string | null, model?: string | null, year?: number | null } | null }> | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } };

export type RemoveMroCustomerMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroCustomerMutation = { __typename?: 'Mutation', removeMroCustomer: { __typename?: 'MroCustomer', id: string } };

export type GetPendingPartRequestsQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetPendingPartRequestsQuery = { __typename?: 'Query', mroWorkOrderParts: Array<{ __typename?: 'MroWorkOrderPart', id: string, quantity?: number | null, status?: string | null, partNumber?: string | null, neededDate?: any | null, shippingType?: string | null, unitPrice?: any | null, notes?: string | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null, estimatedCost?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, notes?: string | null } | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, workOrderNum?: number | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null }, requester?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null }> };

export type GetDueSoonWorkOrdersQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetDueSoonWorkOrdersQuery = { __typename?: 'Query', mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, workOrderNum?: number | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, name: string, color?: string | null, code?: string | null } | null }> | null };

export type GetMroLaborEntriesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroLaborEntriesQuery = { __typename?: 'Query', mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, hours?: any | null, status?: string | null, startTime?: any | null, pauseTime?: any | null, endTime?: any | null, costRate?: any | null, billable?: boolean | null, billableRate?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null } } | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null }> | null };

export type GetDashboardBadgesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetDashboardBadgesQuery = { __typename?: 'Query', mroOrganization?: { __typename?: 'MroOrganization', id: string, mroWorkOrders: Array<{ __typename?: 'MroWorkOrder', id: string, status?: string | null, promiseDate?: any | null }>, mroServiceRequests: Array<{ __typename?: 'MroServiceRequest', id: string }>, mroLaborEntries: Array<{ __typename?: 'MroLaborEntry', id: string }> } | null, mroWorkOrderParts: Array<{ __typename?: 'MroWorkOrderPart', id: string }> };

export type StartTimerMutationVariables = Exact<{
  employeeProfileId: Scalars['String'];
  workOrderItemId: Scalars['String'];
  mroOrganizationId: Scalars['String'];
}>;


export type StartTimerMutation = { __typename?: 'Mutation', startTimer: { __typename?: 'MroLaborEntry', id: string, startTime?: any | null } };

export type StopTimerMutationVariables = Exact<{
  laborEntryId: Scalars['String'];
}>;


export type StopTimerMutation = { __typename?: 'Mutation', stopTimer: { __typename?: 'MroLaborEntry', id: string, startTime?: any | null, endTime?: any | null, duration: number, hours?: any | null } };

export type ResumeTimerMutationVariables = Exact<{
  laborEntryId: Scalars['String'];
}>;


export type ResumeTimerMutation = { __typename?: 'Mutation', resumeTimer: { __typename?: 'MroLaborEntry', id: string, startTime?: any | null, pauseTime?: any | null, duration: number, hours?: any | null } };

export type PauseTimerMutationVariables = Exact<{
  laborEntryId: Scalars['String'];
}>;


export type PauseTimerMutation = { __typename?: 'Mutation', pauseTimer: { __typename?: 'MroLaborEntry', id: string, startTime?: any | null, pauseTime?: any | null, duration: number, hours?: any | null } };

export type GetMroDashboardQueryVariables = Exact<{
  mroEmployeeId: Scalars['String'];
}>;


export type GetMroDashboardQuery = { __typename?: 'Query', mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, estimatedHours?: any | null, description?: string | null, totalLaborHours: number, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, status?: string | null }> | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null } | null }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, promiseDate?: any | null, workOrderNum?: number | null, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }>, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null } }> | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null, pin?: string | null, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null, currentLaborEntry?: { __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, pauseTime?: any | null, endTime?: any | null, hours?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, estimatedHours?: any | null, totalLaborHours: number, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } } | null } | null, mroWorkOrders: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, workOrderNum?: number | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, name: string, color?: string | null, code?: string | null } | null }>, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, pauseTime?: any | null, endTime?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string } } | null }> | null } | null };

export type GetMroDashboardOrdersQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroDashboardOrdersQuery = { __typename?: 'Query', mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, workOrderNum?: number | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, name: string, color?: string | null, code?: string | null } | null }> | null };

export type MroDashboardWorkOrderFragment = { __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, workOrderNum?: number | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, name: string, color?: string | null, code?: string | null } | null };

export type GetFullTaskQueryVariables = Exact<{
  mroWorkOrderItemId: Scalars['String'];
}>;


export type GetFullTaskQuery = { __typename?: 'Query', mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, estimatedHours?: any | null, description?: string | null, totalLaborHours: number, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, status?: string | null }> | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null } | null }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, promiseDate?: any | null, workOrderNum?: number | null, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }>, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null } } | null };

export type MroDashboardTaskDetailsFragment = { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, estimatedHours?: any | null, description?: string | null, totalLaborHours: number, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, status?: string | null }> | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null } | null }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, promiseDate?: any | null, workOrderNum?: number | null, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }>, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null, name?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null } };

export type GetDashboardOrdersQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetDashboardOrdersQuery = { __typename?: 'Query', mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> }> | null };

export type DashboardWorkOrderFragment = { __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> };

export type TaskDetailsFragment = { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, estimatedHours?: any | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null } | null }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, promiseDate?: any | null, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }>, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null } };

export type GetMroEmployeeDashboardQueryVariables = Exact<{
  mroEmployeeId: Scalars['String'];
}>;


export type GetMroEmployeeDashboardQuery = { __typename?: 'Query', mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, estimatedHours?: any | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null } | null }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, promiseDate?: any | null, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }>, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string }> | null } }> | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null, pin?: string | null, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null, currentLaborEntry?: { __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, pauseTime?: any | null, endTime?: any | null, hours?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, totalLaborHours: number, estimatedHours?: any | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } } | null } | null, mroWorkOrders: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, estimatedHours?: any | null, status?: string | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, model: string, make: string } | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> }>, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, pauseTime?: any | null, endTime?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string } } | null }> | null } | null };

export type GetMroEmployeesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroEmployeesQuery = { __typename?: 'Query', mroEmployeeProfiles?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, phone?: string | null, title?: string | null, profileColor?: string | null, accountSetup?: boolean | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null, latestActivity?: { __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, endTime?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string } } | null } | null }> | null };

export type GetMroEmployeeQueryVariables = Exact<{
  mroEmployeeId: Scalars['String'];
}>;


export type GetMroEmployeeQuery = { __typename?: 'Query', mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null, pin?: string | null, airmenLicense?: any | null, notificationSettings?: any | null, billableRate?: any | null, costRate?: any | null, accountSetup?: boolean | null, inviteLink?: string | null, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null, mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string } | null, latestActivity?: { __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, endTime?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } } | null } | null, mroWorkOrders: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null }>, mroRole?: { __typename?: 'MroRole', id: string, title: string } | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, endTime?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } } | null }> | null } | null };

export type UpdateMroEmployeeMutationVariables = Exact<{
  input: MroEmployeeProfileUpdateInput;
}>;


export type UpdateMroEmployeeMutation = { __typename?: 'Mutation', updateMroEmployeeProfile: { __typename?: 'MroEmployeeProfile', id: string } };

export type RemoveMroEmployeeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroEmployeeMutation = { __typename?: 'Mutation', removeMroEmployeeProfile: { __typename?: 'MroEmployeeProfile', id: string } };

export type CreateMroEmployeeMutationVariables = Exact<{
  input: MroEmployeeProfileCreateInput;
}>;


export type CreateMroEmployeeMutation = { __typename?: 'Mutation', createMroEmployeeProfileAndUser: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null, billableRate?: any | null, costRate?: any | null, mroWorkOrders: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null }>, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, startTime?: any | null, endTime?: any | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string } } | null }> | null } };

export type GetMroPartVariantsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroPartVariantsQuery = { __typename?: 'Query', mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, preferred?: boolean | null, variantsLeft?: Array<{ __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null, isSerialized?: boolean | null, preferred?: boolean | null, mroPartInventories?: Array<{ __typename?: 'MroPartInventory', id: string }> | null }> | null, variantsRight?: Array<{ __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null, isSerialized?: boolean | null, preferred?: boolean | null, mroPartInventories?: Array<{ __typename?: 'MroPartInventory', id: string }> | null }> | null } | null };

export type GetMroPartInventoriesQueryVariables = Exact<{
  where?: InputMaybe<MroPartInventoryWhereInput>;
}>;


export type GetMroPartInventoriesQuery = { __typename?: 'Query', mroPartInventories?: Array<{ __typename?: 'MroPartInventory', id: string, status?: string | null, condition?: PartCondition | null, quantity?: number | null, bin?: string | null, lotNumber?: string | null, unitPrice?: any | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null, mroPart: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null } }> | null };

export type GetMroPartInventoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroPartInventoryQuery = { __typename?: 'Query', mroPartInventory?: { __typename?: 'MroPartInventory', id: string, status?: string | null, condition?: PartCondition | null, quantity?: number | null, bin?: string | null, lotNumber?: string | null, unitPrice?: any | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null, mroPart: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null } } | null };

export type UpdateMroPartInventoryMutationVariables = Exact<{
  input: MroPartInventoryUpdateInput;
}>;


export type UpdateMroPartInventoryMutation = { __typename?: 'Mutation', updateMroPartInventory: { __typename?: 'MroPartInventory', id: string, status?: string | null, condition?: PartCondition | null, quantity?: number | null, bin?: string | null, lotNumber?: string | null, unitPrice?: any | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null, mroPart: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null } } };

export type CreatePartMutationVariables = Exact<{
  input: MroPartCreateInput;
}>;


export type CreatePartMutation = { __typename?: 'Mutation', createAndUpdateWoPart: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null } };

export type CreateInventoryMutationVariables = Exact<{
  input: MroPartInventoryCreateInput;
}>;


export type CreateInventoryMutation = { __typename?: 'Mutation', createMroPartInventory: { __typename?: 'MroPartInventory', id: string } };

export type MroPartInventoryInfoFragment = { __typename?: 'MroPartInventory', id: string, status?: string | null, condition?: PartCondition | null, quantity?: number | null, bin?: string | null, lotNumber?: string | null, unitPrice?: any | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null, mroPart: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null } };

export type MroPartSerizaledInfoFragment = { __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, bin?: string | null, lotNumber?: string | null, unitPrice?: any | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null } | null };

export type GetMroPartRequestsQueryVariables = Exact<{
  where: MroWorkOrderPartWhereInput;
}>;


export type GetMroPartRequestsQuery = { __typename?: 'Query', mroWorkOrderParts: Array<{ __typename?: 'MroWorkOrderPart', id: string, quantity?: number | null, status?: string | null, partNumber?: string | null, partDescription?: string | null, neededDate?: any | null, shippingType?: string | null, unitPrice?: any | null, notes?: string | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null, estimatedCost?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, notes?: string | null } | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, workOrderNum?: number | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null }, requester?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null }> };

export type GetMroPartOrdersQueryVariables = Exact<{
  where: MroPartOrderWhereInput;
}>;


export type GetMroPartOrdersQuery = { __typename?: 'Query', mroPartOrders?: Array<{ __typename?: 'MroPartOrder', id: string, status?: string | null, orderNumber?: string | null, trackingInfo?: any | null, createdAt: any, buyer?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null, mroPartVendor?: { __typename?: 'MroPartVendor', id: string, name?: string | null } | null, mroPartOrderItems?: Array<{ __typename?: 'MroPartOrderItem', id: string }> | null }> | null };

export type GetMroWorkOrderPartsQueryVariables = Exact<{
  where: MroWorkOrderPartWhereInput;
}>;


export type GetMroWorkOrderPartsQuery = { __typename?: 'Query', mroWorkOrderParts: Array<{ __typename?: 'MroWorkOrderPart', id: string, status?: string | null, createdAt: any }> };

export type GetMroPartsQueryVariables = Exact<{
  where?: InputMaybe<MroPartWhereInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetMroPartsQuery = { __typename?: 'Query', mroPartCount?: number | null, mroParts?: Array<{ __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null, preferred?: boolean | null, availablePartInventories: Array<{ __typename?: 'MroPartInventory', id: string, quantity?: number | null }>, availableSerializedParts: Array<{ __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null }>, mroPartInventories?: Array<{ __typename?: 'MroPartInventory', id: string, quantity?: number | null }> | null, mroSerializedParts?: Array<{ __typename?: 'MroSerializedPart', id: string, isAvailable?: boolean | null }> | null }> | null };

export type GetMroSerilizedPartsQueryVariables = Exact<{
  where: MroSerializedPartWhereInput;
}>;


export type GetMroSerilizedPartsQuery = { __typename?: 'Query', mroSerializedParts?: Array<{ __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, lotNumber?: string | null, unitPrice?: any | null, coreCost?: any | null, bin?: string | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null }> | null };

export type GetMroSerilizedPartQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroSerilizedPartQuery = { __typename?: 'Query', mroSerializedPart?: { __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, bin?: string | null, lotNumber?: string | null, unitPrice?: any | null, coreCost?: any | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, workOrderNum?: number | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null } }> | null } | null };

export type GetMroPartQueryVariables = Exact<{
  partId: Scalars['String'];
}>;


export type GetMroPartQuery = { __typename?: 'Query', mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, preferred?: boolean | null, createdAt: any, isSerialized?: boolean | null, manufacturer?: { __typename?: 'MroPartManufacturer', id: string, name: string } | null, mroPartInventories?: Array<{ __typename?: 'MroPartInventory', id: string, quantity?: number | null }> | null } | null };

export type GetMroPartRequestQueryVariables = Exact<{
  partRequestId: Scalars['String'];
}>;


export type GetMroPartRequestQuery = { __typename?: 'Query', mroWorkOrderPart: { __typename?: 'MroWorkOrderPart', id: string, status?: string | null, partNumber?: string | null, partDescription?: string | null, shippingType?: string | null, neededDate?: any | null, unitPrice?: any | null, costPrice?: any | null, quantity?: number | null, notes?: string | null, requester?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string } | null, mroSerializedPart?: { __typename?: 'MroSerializedPart', id: string, condition?: PartCondition | null, serialNumber?: string | null, unitPrice?: any | null } | null, mroPartInventory?: { __typename?: 'MroPartInventory', id: string, condition?: PartCondition | null, quantity?: number | null, unitPrice?: any | null } | null } };

export type UpdateMroPartRequestMutationVariables = Exact<{
  input: MroWorkOrderPartUpdateInput;
}>;


export type UpdateMroPartRequestMutation = { __typename?: 'Mutation', updateMroWorkOrderPart: { __typename?: 'MroWorkOrderPart', id: string, status?: string | null, partNumber?: string | null, partDescription?: string | null, shippingType?: string | null, neededDate?: any | null, unitPrice?: any | null, costPrice?: any | null, quantity?: number | null, notes?: string | null, requester?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string } | null, mroSerializedPart?: { __typename?: 'MroSerializedPart', id: string, condition?: PartCondition | null, serialNumber?: string | null, unitPrice?: any | null } | null, mroPartInventory?: { __typename?: 'MroPartInventory', id: string, condition?: PartCondition | null, quantity?: number | null, unitPrice?: any | null } | null } };

export type FulfillRequestMutationVariables = Exact<{
  input: MroWorkOrderPartUpdateInput;
}>;


export type FulfillRequestMutation = { __typename?: 'Mutation', fulfillRequest: { __typename?: 'MroWorkOrderPart', id: string, status?: string | null, partNumber?: string | null, partDescription?: string | null, shippingType?: string | null, neededDate?: any | null, unitPrice?: any | null, costPrice?: any | null, quantity?: number | null, notes?: string | null, requester?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string } | null, mroSerializedPart?: { __typename?: 'MroSerializedPart', id: string, condition?: PartCondition | null, serialNumber?: string | null, unitPrice?: any | null } | null, mroPartInventory?: { __typename?: 'MroPartInventory', id: string, condition?: PartCondition | null, quantity?: number | null, unitPrice?: any | null } | null } };

export type MroPartInfoFragment = { __typename?: 'MroWorkOrderPart', id: string, status?: string | null, partNumber?: string | null, partDescription?: string | null, shippingType?: string | null, neededDate?: any | null, unitPrice?: any | null, costPrice?: any | null, quantity?: number | null, notes?: string | null, requester?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string } | null, mroSerializedPart?: { __typename?: 'MroSerializedPart', id: string, condition?: PartCondition | null, serialNumber?: string | null, unitPrice?: any | null } | null, mroPartInventory?: { __typename?: 'MroPartInventory', id: string, condition?: PartCondition | null, quantity?: number | null, unitPrice?: any | null } | null };

export type GetMroPartWarehouseQueryVariables = Exact<{
  input: MroPartWarehouseWhereInput;
}>;


export type GetMroPartWarehouseQuery = { __typename?: 'Query', mroPartWarehouses: Array<{ __typename?: 'MroPartWarehouse', id: string, name?: string | null, createdAt: any }> };

export type UpdateMroPartMutationVariables = Exact<{
  input: MroPartUpdateInput;
}>;


export type UpdateMroPartMutation = { __typename?: 'Mutation', updateMroPart: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null } };

export type CreateSerializedPartMutationVariables = Exact<{
  input: MroSerializedPartCreateInput;
}>;


export type CreateSerializedPartMutation = { __typename?: 'Mutation', createMroSerializedPart: { __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, bin?: string | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null } };

export type CreateMroSerializedPartsMutationVariables = Exact<{
  input: CreateSerializedPartsInput;
}>;


export type CreateMroSerializedPartsMutation = { __typename?: 'Mutation', createMroSerializedParts: Array<{ __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, bin?: string | null, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null }> };

export type UpdateSerializedPartMutationVariables = Exact<{
  input: MroSerializedPartUpdateInput;
}>;


export type UpdateSerializedPartMutation = { __typename?: 'Mutation', updateMroSerializedPart: { __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, bin?: string | null } };

export type CreateMroPartOrderMutationVariables = Exact<{
  input: MroPartOrderCreateInput;
}>;


export type CreateMroPartOrderMutation = { __typename?: 'Mutation', createMroPartOrderAndChangeWOPartStatus: { __typename?: 'MroPartOrder', id: string } };

export type UpdateMroPartOrderMutationVariables = Exact<{
  input: MroPartOrderUpdateInput;
}>;


export type UpdateMroPartOrderMutation = { __typename?: 'Mutation', updateMroPartOrder: { __typename?: 'MroPartOrder', id: string } };

export type UpdateMroPartOrderAndChangeWoPartStatusMutationVariables = Exact<{
  input: MroPartOrderUpdateInput;
}>;


export type UpdateMroPartOrderAndChangeWoPartStatusMutation = { __typename?: 'Mutation', updateMroPartOrderAndChangeWOPartStatus: { __typename?: 'MroPartOrder', id: string } };

export type UpdateMroPartOrderItemMutationVariables = Exact<{
  input: MroPartOrderItemUpdateInput;
}>;


export type UpdateMroPartOrderItemMutation = { __typename?: 'Mutation', updateMroPartOrderItem: { __typename?: 'MroPartOrderItem', id: string } };

export type GetMroPartOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroPartOrderQuery = { __typename?: 'Query', mroPartOrder?: { __typename?: 'MroPartOrder', id: string, status?: string | null, orderNumber?: string | null, issuedDate?: any | null, notes?: string | null, trackingInfo?: any | null, createdAt: any, pdfLink: string, mroPartVendor?: { __typename?: 'MroPartVendor', id: string, name?: string | null, vendorCode?: string | null, phoneNumbers?: any | null, address?: { __typename?: 'MroAddress', address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null } | null, buyer?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null, mroPartOrderItems?: Array<{ __typename?: 'MroPartOrderItem', id: string, quantity?: number | null, unitPrice?: any | null, requestedDate?: any | null, status?: string | null, condition?: PartCondition | null, active?: boolean | null, notes?: string | null, mroWorkOrderPart?: { __typename?: 'MroWorkOrderPart', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, title: string, workOrderNum?: number | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, code?: string | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null } } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null, isSerialized?: boolean | null, mroPartInventories?: Array<{ __typename?: 'MroPartInventory', id: string }> | null } | null }> | null } | null };

export type GetMroPartAndInventoriesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroPartAndInventoriesQuery = { __typename?: 'Query', mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, estimatedCost?: any | null, isSerialized?: boolean | null, availableSerializedParts: Array<{ __typename?: 'MroSerializedPart', id: string, serialNumber?: string | null, isAvailable?: boolean | null, condition?: PartCondition | null, unitPrice?: any | null, bin?: string | null, lotNumber?: string | null, createdAt: any, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null }>, availablePartInventories: Array<{ __typename?: 'MroPartInventory', id: string, quantity?: number | null, bin?: string | null, lotNumber?: string | null, condition?: PartCondition | null, status?: string | null, unitPrice?: any | null, createdAt: any, mroPartWarehouse?: { __typename?: 'MroPartWarehouse', id: string, name?: string | null } | null }> } | null };

export type GetLastPartOrderQueryVariables = Exact<{
  mroOrgId: Scalars['String'];
}>;


export type GetLastPartOrderQuery = { __typename?: 'Query', lastPartOrder: { __typename?: 'MroPartOrder', id: string, orderNumber?: string | null } };

export type GetMroPartVendorsQueryVariables = Exact<{
  where: MroPartVendorWhereInput;
}>;


export type GetMroPartVendorsQuery = { __typename?: 'Query', mroPartVendors: Array<{ __typename?: 'MroPartVendor', id: string, name?: string | null, vendorCode?: string | null, phoneNumbers?: any | null, address?: { __typename?: 'MroAddress', id: string, email?: string | null, address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null }> };

export type GetMroPartManufacturersQueryVariables = Exact<{
  where: MroPartManufacturerWhereInput;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetMroPartManufacturersQuery = { __typename?: 'Query', mroPartManufacturers?: Array<{ __typename?: 'MroPartManufacturer', id: string, name: string, createdAt: any }> | null };

export type GetMroOrgnizationPartPriceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroOrgnizationPartPriceQuery = { __typename?: 'Query', mroOrganization?: { __typename?: 'MroOrganization', id: string, mroPartPriceMatrix?: { __typename?: 'MroPartPriceMatrix', id: string, partMatrix: any } | null } | null };

export type GetMroReportsQueryVariables = Exact<{
  where?: InputMaybe<MroReportWhereInput>;
}>;


export type GetMroReportsQuery = { __typename?: 'Query', mroReports?: Array<{ __typename?: 'MroReport', id: string, title: string, createdAt: any }> | null };

export type GetMroReportQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroReportQuery = { __typename?: 'Query', mroReport?: { __typename?: 'MroReport', id: string, title: string } | null };

export type GetMroReportTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMroReportTypesQuery = { __typename?: 'Query', reportTypes: any };

export type CreateMroReportMutationVariables = Exact<{
  input: MroReportCreateInput;
}>;


export type CreateMroReportMutation = { __typename?: 'Mutation', createMroReport: { __typename?: 'MroReport', id: string } };

export type UpdateMroReportMutationVariables = Exact<{
  input: MroReportUpdateInput;
}>;


export type UpdateMroReportMutation = { __typename?: 'Mutation', updateMroReport: { __typename?: 'MroReport', id: string } };

export type GetServiceRequestQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetServiceRequestQuery = { __typename?: 'Query', mroServiceRequest?: { __typename?: 'MroServiceRequest', id: string, title: string, notes?: string | null, description?: string | null, status?: string | null, createdAt: any, mroWorkOrderId?: string | null, location?: string | null, craftServiceRequests?: Array<{ __typename?: 'CraftServiceRequest', id: string }> | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, make: string, model: string, year: number, engineCount?: number | null } | null, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null }> | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string, engineCount?: number | null }> | null } | null } | null };

export type GetServiceRequestsQueryVariables = Exact<{
  where: MroServiceRequestWhereInput;
}>;


export type GetServiceRequestsQuery = { __typename?: 'Query', mroServiceRequests?: Array<{ __typename?: 'MroServiceRequest', id: string, title: string, notes?: string | null, status?: string | null, createdAt: any, mroWorkOrderId?: string | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, make: string, model: string } | null, mroCustomer?: { __typename?: 'MroCustomer', name: string } | null }> | null };

export type UpdateServiceRequestMutationVariables = Exact<{
  input: MroServiceRequestUpdateInput;
}>;


export type UpdateServiceRequestMutation = { __typename?: 'Mutation', updateMroServiceRequest: { __typename?: 'MroServiceRequest', id: string } };

export type GetMroRoleDataQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroRoleDataQuery = { __typename?: 'Query', mroActions: any, mroOrganization?: { __typename?: 'MroOrganization', id: string, mroRoles?: Array<{ __typename?: 'MroRole', id: string, title: string, caslRules?: any | null, createdAt: any }> | null } | null };

export type GetMroCaslRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMroCaslRulesQuery = { __typename?: 'Query', caslRules?: any | null };

export type UpdateMroRoleMutationVariables = Exact<{
  input: MroRoleUpdateInput;
}>;


export type UpdateMroRoleMutation = { __typename?: 'Mutation', updateMroRole: { __typename?: 'MroRole', id: string, title: string, caslRules?: any | null, createdAt: any } };

export type CreateMroRoleMutationVariables = Exact<{
  input: MroRoleCreateInput;
}>;


export type CreateMroRoleMutation = { __typename?: 'Mutation', createMroRole: { __typename?: 'MroRole', id: string, title: string, caslRules?: any | null, createdAt: any } };

export type GetMroRolesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroRolesQuery = { __typename?: 'Query', mroOrganization?: { __typename?: 'MroOrganization', id: string, mroRoles?: Array<{ __typename?: 'MroRole', id: string, title: string, caslRules?: any | null, createdAt: any }> | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'User', id: string } };

export type GetMroWorkOrderTemplatesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroWorkOrderTemplatesQuery = { __typename?: 'Query', mroWorkOrderTemplates: Array<{ __typename?: 'MroWorkOrderTemplate', id: string, title: string, createdAt: any, templateData?: any | null }> };

export type UpdateMroWorkOrderTemplateMutationVariables = Exact<{
  input: MroWorkOrderTemplateUpdateInput;
}>;


export type UpdateMroWorkOrderTemplateMutation = { __typename?: 'Mutation', updateMroWorkOrderTemplate: { __typename?: 'MroWorkOrderTemplate', id: string } };

export type RemoveMroWorkOrderTemplateMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroWorkOrderTemplateMutation = { __typename?: 'Mutation', removeMroWorkOrderTemplate: { __typename?: 'MroWorkOrderTemplate', id: string } };

export type GetMroOrganizationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroOrganizationQuery = { __typename?: 'Query', mroOrganization?: { __typename?: 'MroOrganization', id: string, name: string, defaultBillableRate?: any | null, defaultCostRate?: any | null, estimateAuthorization?: string | null, address?: { __typename?: 'MroAddress', id: string, address: string, city?: string | null, region?: string | null, postalCode?: string | null, fax?: string | null, phone?: string | null } | null } | null };

export type UpdateOrganizationIconMutationVariables = Exact<{
  organizationId: Scalars['String'];
  colorIconId?: InputMaybe<Scalars['String']>;
  blackIconId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateOrganizationIconMutation = { __typename?: 'Mutation', updateOrganizationIcon: { __typename?: 'MroOrganization', id: string } };

export type UpdateMroOrganizationMutationVariables = Exact<{
  input: MroOrganizationUpdateInput;
}>;


export type UpdateMroOrganizationMutation = { __typename?: 'Mutation', updateMroOrganization: { __typename?: 'MroOrganization', id: string } };

export type CreateMroPartWarehouseMutationVariables = Exact<{
  input: MroPartWarehouseCreateInput;
}>;


export type CreateMroPartWarehouseMutation = { __typename?: 'Mutation', createMroPartWarehouse: { __typename?: 'MroPartWarehouse', id: string } };

export type UpdateMroPartWarehouseMutationVariables = Exact<{
  input: MroPartWarehouseUpdateInput;
}>;


export type UpdateMroPartWarehouseMutation = { __typename?: 'Mutation', updateMroPartWarehouse: { __typename?: 'MroPartWarehouse', id: string } };

export type RemoveMroPartWarehouseMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroPartWarehouseMutation = { __typename?: 'Mutation', removeMroPartWarehouse: { __typename?: 'MroPartWarehouse', id: string } };

export type GetMroOrganizationIconsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroOrganizationIconsQuery = { __typename?: 'Query', mroOrganization?: { __typename?: 'MroOrganization', mroColorIcon?: { __typename?: 'Attachment', id: string, signedUrl: string } | null, mroBlackAndWhiteIcon?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null };

export type UpdateMroLocationMutationVariables = Exact<{
  input: MroLocationUpdateInput;
}>;


export type UpdateMroLocationMutation = { __typename?: 'Mutation', updateMroLocation: { __typename?: 'MroLocation', id: string } };

export type CreateMroLocationMutationVariables = Exact<{
  input: MroLocationCreateInput;
}>;


export type CreateMroLocationMutation = { __typename?: 'Mutation', createMroLocation: { __typename?: 'MroLocation', id: string } };

export type RemoveMroLocationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroLocationMutation = { __typename?: 'Mutation', removeMroLocation: { __typename?: 'MroLocation', id: string } };

export type GetMroRtsTextsQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroRtsTextsQuery = { __typename?: 'Query', mroRTSTexts?: Array<{ __typename?: 'MroRTSText', id: string, title: string, createdAt: any, body: string }> | null };

export type GetMroRtsTextQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroRtsTextQuery = { __typename?: 'Query', mroRTSText?: { __typename?: 'MroRTSText', id: string, title: string, body: string } | null };

export type CreateMroRtsTextMutationVariables = Exact<{
  input: MroRtsTextCreateInput;
}>;


export type CreateMroRtsTextMutation = { __typename?: 'Mutation', createMroRTSText: { __typename?: 'MroRTSText', id: string } };

export type UpdateMroRtsTextMutationVariables = Exact<{
  input: MroRtsTextUpdateInput;
}>;


export type UpdateMroRtsTextMutation = { __typename?: 'Mutation', updateMroRTSText: { __typename?: 'MroRTSText', id: string } };

export type RemoveMroRtsTextMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroRtsTextMutation = { __typename?: 'Mutation', removeMroRTSText: { __typename?: 'MroRTSText', id: string } };

export type GetMroOrganizationFeesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetMroOrganizationFeesQuery = { __typename?: 'Query', mroOrganizationFees?: Array<{ __typename?: 'MroOrganizationFee', id: string, name: string, description?: string | null, active: boolean, isPercentage: boolean, billableType: MroFeeType, value?: any | null, createdAt: any, onByDefault: boolean }> | null };

export type GetMroOrganizationFeeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroOrganizationFeeQuery = { __typename?: 'Query', mroOrganizationFee?: { __typename?: 'MroOrganizationFee', id: string, name: string, description?: string | null, active: boolean, isPercentage: boolean, billableType: MroFeeType, value?: any | null, createdAt: any, onByDefault: boolean } | null };

export type CreateMroOrganizationFeeMutationVariables = Exact<{
  input: MroOrganizationFeeCreateInput;
}>;


export type CreateMroOrganizationFeeMutation = { __typename?: 'Mutation', createMroOrganizationFee: { __typename?: 'MroOrganizationFee', id: string } };

export type UpdateMroOrganizationFeeMutationVariables = Exact<{
  input: MroOrganizationFeeUpdateInput;
}>;


export type UpdateMroOrganizationFeeMutation = { __typename?: 'Mutation', updateMroOrganizationFee: { __typename?: 'MroOrganizationFee', id: string } };

export type RemoveMroOrganizationFeeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroOrganizationFeeMutation = { __typename?: 'Mutation', removeMroOrganizationFee: { __typename?: 'MroOrganizationFee', id: string } };

export type NewOrderCraftLookupQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type NewOrderCraftLookupQuery = { __typename?: 'Query', mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string, year: number, make: string, model: string, engineCount?: number | null }> | null };

export type NewOrderCreateCraftMutationVariables = Exact<{
  input: MroCraftCreateInput;
}>;


export type NewOrderCreateCraftMutation = { __typename?: 'Mutation', createMroCraft: { __typename?: 'MroCraft', id: string, tailNumber: string, year: number, make: string, model: string, engineCount?: number | null } };

export type CreateWorkOrderMutationVariables = Exact<{
  input: CreateMroWorkOrderFromTemplateInput;
}>;


export type CreateWorkOrderMutation = { __typename?: 'Mutation', createMroWorkOrderFromTemplate: { __typename?: 'MroWorkOrder', id: string, title: string, notes?: string | null, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null } };

export type NewOrderCustomersQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
  tailNumber: Scalars['String'];
}>;


export type NewOrderCustomersQuery = { __typename?: 'Query', mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null }> | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string, engineCount?: number | null }> | null, billingAddress?: { __typename?: 'MroAddress', address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, email?: string | null, phone?: string | null, title: string, id: string } | null }> | null };

export type NewOrderEmployeesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type NewOrderEmployeesQuery = { __typename?: 'Query', mroEmployeeProfiles?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string }> | null };

export type MroCustomerLookupQueryVariables = Exact<{
  where: MroCustomerWhereInput;
}>;


export type MroCustomerLookupQuery = { __typename?: 'Query', mroCustomers?: Array<{ __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null }> | null, mroCrafts?: Array<{ __typename?: 'MroCraft', id: string, tailNumber: string }> | null, billingAddress?: { __typename?: 'MroAddress', address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, email?: string | null, phone?: string | null, title: string, id: string } | null }> | null };

export type MroWorkOrderTemplatesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type MroWorkOrderTemplatesQuery = { __typename?: 'Query', mroWorkOrderTemplates: Array<{ __typename?: 'MroWorkOrderTemplate', id: string, title: string }> };

export type GetMroComponentsQueryVariables = Exact<{
  mroCraftId: Scalars['String'];
}>;


export type GetMroComponentsQuery = { __typename?: 'Query', mroComponents: Array<{ __typename?: 'MroComponent', id: string, name?: string | null, serialNumber?: string | null, make?: string | null, model?: string | null, year?: number | null, mroWorkOrderItemCategories?: Array<{ __typename?: 'MroWorkOrderItemCategory', id: string, title: string }> | null }> };

export type LastEstimateQueryVariables = Exact<{
  mroOrgId: Scalars['String'];
}>;


export type LastEstimateQuery = { __typename?: 'Query', lastEstimate: { __typename?: 'MroEstimate', id: string, estimateNumber?: number | null } };

export type SendEstimateMutationVariables = Exact<{
  id: Scalars['String'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendEstimateMutation = { __typename?: 'Mutation', sendEstimate: string };

export type CreateMroEstimateMutationVariables = Exact<{
  input: MroEstimateCreateInput;
}>;


export type CreateMroEstimateMutation = { __typename?: 'Mutation', createEstimateNum: { __typename?: 'MroEstimate', id: string, date?: any | null, status?: string | null, total?: any | null, items?: any | null } };

export type GetMroEstimateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroEstimateQuery = { __typename?: 'Query', mroEstimate?: { __typename?: 'MroEstimate', id: string, date?: any | null, status?: string | null, estimateNumber?: number | null, total?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, laborSummary?: any | null, authorizedTotal?: any | null, pdfLink: string, customerNotes?: string | null, mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, primaryContact?: { __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null } | null, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, phoneNumbers?: any | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null }> | null, billingAddress?: { __typename?: 'MroAddress', address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null } | null };

export type UpdateMroEstimateMutationVariables = Exact<{
  input: MroEstimateUpdateInput;
}>;


export type UpdateMroEstimateMutation = { __typename?: 'Mutation', updateMroEstimate: { __typename?: 'MroEstimate', id: string } };

export type GetMroWorkOrderIntervalsQueryVariables = Exact<{
  where: MroWorkOrderIntervalWhereInput;
}>;


export type GetMroWorkOrderIntervalsQuery = { __typename?: 'Query', mroWorkOrderIntervals?: Array<{ __typename?: 'MroWorkOrderInterval', id: string, name?: string | null, value?: number | null, active: boolean }> | null };

export type GetMroWorkOrderIntervalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroWorkOrderIntervalQuery = { __typename?: 'Query', mroWorkOrderInterval?: { __typename?: 'MroWorkOrderInterval', id: string, name?: string | null, value?: number | null, active: boolean } | null };

export type CreateMroWorkOrderIntervalMutationVariables = Exact<{
  input: MroWorkOrderIntervalCreateInput;
}>;


export type CreateMroWorkOrderIntervalMutation = { __typename?: 'Mutation', createMroWorkOrderInterval: { __typename?: 'MroWorkOrderInterval', id: string } };

export type UpdateMroWorkOrderIntervalMutationVariables = Exact<{
  input: MroWorkOrderIntervalUpdateInput;
}>;


export type UpdateMroWorkOrderIntervalMutation = { __typename?: 'Mutation', updateMroWorkOrderInterval: { __typename?: 'MroWorkOrderInterval', id: string } };

export type DeleteMroWorkOrderIntervalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMroWorkOrderIntervalMutation = { __typename?: 'Mutation', removeMroWorkOrderInterval: { __typename?: 'MroWorkOrderInterval', id: string } };

export type GetMroInvoiceQueryVariables = Exact<{
  mroInvoiceId: Scalars['String'];
}>;


export type GetMroInvoiceQuery = { __typename?: 'Query', mroInvoice?: { __typename?: 'MroInvoice', id: string, invoiceDate?: any | null, invoiceNumber?: string | null, dueDate?: any | null, amount?: any | null, status?: string | null, customer?: any | null, mro?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, laborSummary?: any | null, notes?: string | null, pdfLink: string, mroOrganizationId?: string | null } | null };

export type UpdateMroInvoiceMutationVariables = Exact<{
  input: MroInvoiceUpdateInput;
}>;


export type UpdateMroInvoiceMutation = { __typename?: 'Mutation', updateMroInvoice: { __typename?: 'MroInvoice', id: string } };

export type LastInvoiceQueryVariables = Exact<{
  mroOrgId: Scalars['String'];
}>;


export type LastInvoiceQuery = { __typename?: 'Query', lastInvoice: { __typename?: 'MroInvoice', dueDate?: any | null, id: string, invoiceNumber?: string | null } };

export type SendInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendInvoiceMutation = { __typename?: 'Mutation', sendInvoice: string };

export type GetOrganizationRateQueryVariables = Exact<{
  mroWorkOrderId: Scalars['String'];
}>;


export type GetOrganizationRateQuery = { __typename?: 'Query', mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, billableRate: number } | null };

export type CreateMroInvoiceMutationVariables = Exact<{
  input: MroInvoiceCreateInput;
}>;


export type CreateMroInvoiceMutation = { __typename?: 'Mutation', createMroInvoice: { __typename?: 'MroInvoice', id: string, invoiceDate?: any | null, invoiceNumber?: string | null, dueDate?: any | null, amount?: any | null, status?: string | null, customer?: any | null, mro?: any | null, items?: any | null, charges?: any | null, priceSummary?: any | null, laborSummary?: any | null } };

export type UpdateInvoiceStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
}>;


export type UpdateInvoiceStatusMutation = { __typename?: 'Mutation', updateInvoiceStatus: string };

export type GetWorkOrderBillingQueryVariables = Exact<{
  mroWorkOrderId: Scalars['String'];
}>;


export type GetWorkOrderBillingQuery = { __typename?: 'Query', mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, phoneNumbers?: any | null, billingAddress?: { __typename?: 'MroAddress', address: string, address2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null } | null, mroInvoices?: Array<{ __typename?: 'MroInvoice', id: string, invoiceDate?: any | null, invoiceNumber?: string | null, dueDate?: any | null, amount?: any | null, status?: string | null, customer?: any | null, mro?: any | null, items?: any | null, charges?: any | null, discounts?: any | null, priceSummary?: any | null, laborSummary?: any | null }> | null, mroEstimates?: Array<{ __typename?: 'MroEstimate', id: string, date?: any | null, status?: string | null, estimateNumber?: number | null, total?: any | null, items?: any | null, pdfLink: string }> | null } | null };

export type GetWorkOrderLogEntriesQueryVariables = Exact<{
  mroWorkOrderId: Scalars['String'];
}>;


export type GetWorkOrderLogEntriesQuery = { __typename?: 'Query', mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, mroLogEntries?: Array<{ __typename?: 'MroLogEntry', id: string, title?: string | null, status?: string | null, signedAt?: any | null, pdfLink: string, itemCategory?: { __typename?: 'MroWorkOrderItemCategory', id: string, categoryNumber?: number | null } | null, mroLogEntryItems?: Array<{ __typename?: 'MroLogEntryItem', id: string }> | null }> | null } | null };

export type UpdateMroLogEntryMutationVariables = Exact<{
  input: MroLogEntryUpdateInput;
}>;


export type UpdateMroLogEntryMutation = { __typename?: 'Mutation', updateMroLogEntry: { __typename?: 'MroLogEntry', id: string } };

export type CreateMroLogEntryMutationVariables = Exact<{
  input: MroLogEntryCreateInput;
}>;


export type CreateMroLogEntryMutation = { __typename?: 'Mutation', createMroLogEntry: { __typename?: 'MroLogEntry', id: string } };

export type GetMroLogEntryQueryVariables = Exact<{
  mroLogEntryId: Scalars['String'];
}>;


export type GetMroLogEntryQuery = { __typename?: 'Query', mroLogEntry?: { __typename?: 'MroLogEntry', id: string, title?: string | null, status?: string | null, certificationText?: string | null, signedAt?: any | null, createdAt: any, mroWorkOrderId?: string | null, pdfLink: string, signer?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string } | null, intervals?: Array<{ __typename?: 'Interval', id: string, name: string, intervalLogs?: Array<{ __typename?: 'IntervalLog', id: string, startValue?: any | null }> | null }> | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, name?: string | null, year?: number | null, serialNumber?: string | null } | null, itemCategory?: { __typename?: 'MroWorkOrderItemCategory', id: string, categoryNumber?: number | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, logEntry?: string | null, itemNumber?: number | null, title: string }> | null } | null, mroLogEntryItems?: Array<{ __typename?: 'MroLogEntryItem', id: string, description?: string | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, itemNumber?: number | null } | null }> | null } | null };

export type GetMroWorkOrderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroWorkOrderQuery = { __typename?: 'Query', mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, title: string, primaryConcern?: string | null, notes?: string | null, status?: string | null, arrivalDate?: any | null, promiseDate?: any | null, createdAt: any, updatedAt?: any | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }>, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, year: number, make: string, model: string, craft?: { __typename?: 'Craft', id: string, tailNumber: string, year?: number | null, make?: string | null, model?: string | null } | null } | null, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, lastName: string, firstName: string, email?: string | null, phoneNumbers?: any | null }> | null } | null, primaryContact?: { __typename?: 'MroContact', id: string, firstName: string, lastName: string, email?: string | null, phoneNumbers?: any | null } | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, parentId?: string | null, description?: string | null, notes?: string | null, enableLogEntry?: boolean | null, logEntry?: string | null, isFlatRate: boolean, flatRate?: any | null, estimatedHours?: any | null, totalLaborHours: number, totalLaborBillable: number, totalPartsBillable: number, children?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, estimatedHours?: any | null, totalLaborHours: number, totalPartsBillable: number, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, category?: { __typename?: 'MroWorkOrderItemCategory', id: string, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, year?: number | null, name?: string | null, serialNumber?: string | null } | null } | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, partNumber?: string | null, partDescription?: string | null, quantity?: number | null, status?: string | null, mroPart?: { __typename?: 'MroPart', partNumber: string, description?: string | null, isSerialized?: boolean | null } | null }> | null, mroWorkOrderSignoffs?: Array<{ __typename?: 'MroWorkOrderSignoff', id: string, status: SignoffStatus }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } }> | null, itemCategories?: Array<{ __typename?: 'MroWorkOrderItemCategory', id: string, title: string, sortIndex?: number | null, iconName?: string | null, categoryNumber?: number | null, mroWorkOrderItems?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, parentId?: string | null, description?: string | null, notes?: string | null, enableLogEntry?: boolean | null, logEntry?: string | null, isFlatRate: boolean, flatRate?: any | null, estimatedHours?: any | null, totalLaborHours: number, totalLaborBillable: number, totalPartsBillable: number, children?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, estimatedHours?: any | null, totalLaborHours: number, totalPartsBillable: number, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, category?: { __typename?: 'MroWorkOrderItemCategory', id: string, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, year?: number | null, name?: string | null, serialNumber?: string | null } | null } | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, partNumber?: string | null, partDescription?: string | null, quantity?: number | null, status?: string | null, mroPart?: { __typename?: 'MroPart', partNumber: string, description?: string | null, isSerialized?: boolean | null } | null }> | null, mroWorkOrderSignoffs?: Array<{ __typename?: 'MroWorkOrderSignoff', id: string, status: SignoffStatus }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } }> | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, name?: string | null, year?: number | null, serialNumber?: string | null } | null }> | null, mroServiceRequest?: { __typename?: 'MroServiceRequest', id: string, title: string, location?: string | null, notes?: string | null, createdAt: any, mroCustomer?: { __typename?: 'MroCustomer', id: string, name: string, email?: string | null, mroContacts?: Array<{ __typename?: 'MroContact', id: string, firstName: string, lastName: string, phoneNumbers?: any | null }> | null } | null } | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, name: string, color?: string | null, code?: string | null } | null } | null };

export type GetMroWorkOrdersQueryVariables = Exact<{
  where?: InputMaybe<MroWorkOrderWhereInput>;
}>;


export type GetMroWorkOrdersQuery = { __typename?: 'Query', mroWorkOrders?: Array<{ __typename?: 'MroWorkOrder', id: string, title: string, status?: string | null, workOrderNum?: number | null, arrivalDate?: any | null, promiseDate?: any | null, mroLocation?: { __typename?: 'MroLocation', id: string, code?: string | null } | null, mroWorkOrderCategory?: { __typename?: 'MroWorkOrderCategory', id: string, name: string, code?: string | null, color?: string | null } | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string, year: number, make: string, model: string, ownerName?: string | null, craft?: { __typename?: 'Craft', id: string, tailNumber: string, year?: number | null, make?: string | null, model?: string | null } | null } | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> | null, allAssignees: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePictureId?: string | null }> }> | null };

export type UpdateMroWorkOrderMutationVariables = Exact<{
  input: UpdateMroWorkOrderWithContactInfo;
}>;


export type UpdateMroWorkOrderMutation = { __typename?: 'Mutation', updateMroWorkOrderWithContactInfo: { __typename?: 'MroWorkOrder', id: string } };

export type GetMroWorkOrderItemQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroWorkOrderItemQuery = { __typename?: 'Query', mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, parentId?: string | null, description?: string | null, notes?: string | null, itemNumber?: number | null, isFlatRate: boolean, flatRate?: any | null, updatedAt?: any | null, estimatedHours?: any | null, totalLaborHours: number, enableLogEntry?: boolean | null, logEntry?: string | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, isEstimate: boolean }, category?: { __typename?: 'MroWorkOrderItemCategory', id: string, title: string } | null, children?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, estimatedHours?: any | null, totalLaborHours: number, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroLaborEntries?: Array<{ __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null }> | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, costPrice?: any | null, partDescription?: string | null, quantity?: number | null, status?: string | null, createdAt: any, partNumber?: string | null, neededDate?: any | null, notes?: string | null, shippingType?: string | null, mroPartOrder?: { __typename?: 'MroPartOrder', id: string, trackingInfo?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string } } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, signedUrl: string }> | null, mroWorkOrderSignoffs?: Array<{ __typename?: 'MroWorkOrderSignoff', id: string, title: string, status: SignoffStatus, date?: any | null, assignee?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, pin?: string | null } | null }> | null } | null };

export type GetMroWorkOrderPartQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroWorkOrderPartQuery = { __typename?: 'Query', mroWorkOrderPart: { __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, costPrice?: any | null, partDescription?: string | null, quantity?: number | null, status?: string | null, createdAt: any, partNumber?: string | null, neededDate?: any | null, notes?: string | null, shippingType?: string | null, mroPartOrder?: { __typename?: 'MroPartOrder', id: string, trackingInfo?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string } } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null } };

export type GetMroLaborEntryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroLaborEntryQuery = { __typename?: 'Query', mroLaborEntry?: { __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null } | null };

export type UpdateMroWorkOrderPartMutationVariables = Exact<{
  input: MroWorkOrderPartUpdateInput;
}>;


export type UpdateMroWorkOrderPartMutation = { __typename?: 'Mutation', updateMroWorkOrderPart: { __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, costPrice?: any | null, partDescription?: string | null, quantity?: number | null, status?: string | null, createdAt: any, partNumber?: string | null, neededDate?: any | null, notes?: string | null, shippingType?: string | null, mroPartOrder?: { __typename?: 'MroPartOrder', id: string, trackingInfo?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string } } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null } };

export type UpdateMroWorkOrderPartStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
  requesterId: Scalars['String'];
}>;


export type UpdateMroWorkOrderPartStatusMutation = { __typename?: 'Mutation', updateMroWorkOrderPartStatus: boolean };

export type CreateMroWorkOrderPartMutationVariables = Exact<{
  input: MroWorkOrderPartCreateInput;
}>;


export type CreateMroWorkOrderPartMutation = { __typename?: 'Mutation', createMroWorkOrderPart: { __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, costPrice?: any | null, partDescription?: string | null, quantity?: number | null, status?: string | null, createdAt: any, partNumber?: string | null, neededDate?: any | null, notes?: string | null, shippingType?: string | null, mroPartOrder?: { __typename?: 'MroPartOrder', id: string, trackingInfo?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string } } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null } };

export type RemoveMroWorkOrderPartMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroWorkOrderPartMutation = { __typename?: 'Mutation', removeMroWorkOrderPart: boolean };

export type UpdateMroLaborEntryMutationVariables = Exact<{
  input: MroLaborEntryUpdateInput;
}>;


export type UpdateMroLaborEntryMutation = { __typename?: 'Mutation', updateMroLaborEntry: { __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null } };

export type PartDetailsFragment = { __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, costPrice?: any | null, partDescription?: string | null, quantity?: number | null, status?: string | null, createdAt: any, partNumber?: string | null, neededDate?: any | null, notes?: string | null, shippingType?: string | null, mroPartOrder?: { __typename?: 'MroPartOrder', id: string, trackingInfo?: any | null } | null, mroWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string } } | null, mroPart?: { __typename?: 'MroPart', id: string, partNumber: string, description?: string | null, isSerialized?: boolean | null } | null };

export type LaborDetailsFragment = { __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null };

export type MroWorkOrderItemDetailsFragment = { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, parentId?: string | null, description?: string | null, notes?: string | null, enableLogEntry?: boolean | null, logEntry?: string | null, isFlatRate: boolean, flatRate?: any | null, estimatedHours?: any | null, totalLaborHours: number, totalLaborBillable: number, totalPartsBillable: number, children?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, estimatedHours?: any | null, totalLaborHours: number, totalPartsBillable: number, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, category?: { __typename?: 'MroWorkOrderItemCategory', id: string, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, year?: number | null, name?: string | null, serialNumber?: string | null } | null } | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, partNumber?: string | null, partDescription?: string | null, quantity?: number | null, status?: string | null, mroPart?: { __typename?: 'MroPart', partNumber: string, description?: string | null, isSerialized?: boolean | null } | null }> | null, mroWorkOrderSignoffs?: Array<{ __typename?: 'MroWorkOrderSignoff', id: string, status: SignoffStatus }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } };

export type UpdateMroWorkOrderItemMutationVariables = Exact<{
  input: MroWorkOrderItemUpdateInput;
}>;


export type UpdateMroWorkOrderItemMutation = { __typename?: 'Mutation', updateWorkOrderItemAndNumbers: { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, parentId?: string | null, description?: string | null, notes?: string | null, enableLogEntry?: boolean | null, logEntry?: string | null, isFlatRate: boolean, flatRate?: any | null, estimatedHours?: any | null, totalLaborHours: number, totalLaborBillable: number, totalPartsBillable: number, children?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, estimatedHours?: any | null, totalLaborHours: number, totalPartsBillable: number, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, category?: { __typename?: 'MroWorkOrderItemCategory', id: string, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, year?: number | null, name?: string | null, serialNumber?: string | null } | null } | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, partNumber?: string | null, partDescription?: string | null, quantity?: number | null, status?: string | null, mroPart?: { __typename?: 'MroPart', partNumber: string, description?: string | null, isSerialized?: boolean | null } | null }> | null, mroWorkOrderSignoffs?: Array<{ __typename?: 'MroWorkOrderSignoff', id: string, status: SignoffStatus }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } } };

export type GetMroEmployeeProfilesQueryVariables = Exact<{
  where: MroEmployeeProfileWhereInput;
}>;


export type GetMroEmployeeProfilesQuery = { __typename?: 'Query', mroEmployeeProfiles?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null, phone?: string | null, title?: string | null, costRate?: any | null, billableRate?: any | null }> | null };

export type CreateMroWorkOrderItemMutationVariables = Exact<{
  input: MroWorkOrderItemCreateInput;
}>;


export type CreateMroWorkOrderItemMutation = { __typename?: 'Mutation', createMroWorkOrderItemWithNumber: { __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, parentId?: string | null, description?: string | null, notes?: string | null, enableLogEntry?: boolean | null, logEntry?: string | null, isFlatRate: boolean, flatRate?: any | null, estimatedHours?: any | null, totalLaborHours: number, totalLaborBillable: number, totalPartsBillable: number, children?: Array<{ __typename?: 'MroWorkOrderItem', id: string, title: string, status?: string | null, itemNumber?: number | null, estimatedHours?: any | null, totalLaborHours: number, totalPartsBillable: number, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null }> | null, category?: { __typename?: 'MroWorkOrderItemCategory', id: string, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, year?: number | null, name?: string | null, serialNumber?: string | null } | null } | null, mroWorkOrderParts?: Array<{ __typename?: 'MroWorkOrderPart', id: string, unitPrice?: any | null, partNumber?: string | null, partDescription?: string | null, quantity?: number | null, status?: string | null, mroPart?: { __typename?: 'MroPart', partNumber: string, description?: string | null, isSerialized?: boolean | null } | null }> | null, mroWorkOrderSignoffs?: Array<{ __typename?: 'MroWorkOrderSignoff', id: string, status: SignoffStatus }> | null, assignees?: Array<{ __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, email: string, profileColor?: string | null, profilePictureId?: string | null }> | null, mroWorkOrder: { __typename?: 'MroWorkOrder', id: string, workOrderNum?: number | null, mroCraft?: { __typename?: 'MroCraft', id: string, tailNumber: string } | null } } };

export type CreateMroLaborEntryMutationVariables = Exact<{
  input: MroLaborEntryCreateInput;
}>;


export type CreateMroLaborEntryMutation = { __typename?: 'Mutation', createMroLaborEntry: { __typename?: 'MroLaborEntry', id: string, status?: string | null, costRate?: any | null, startTime?: any | null, endTime?: any | null, hours?: any | null, billable?: boolean | null, billableRate?: any | null, notes?: string | null, mroEmployeeProfile?: { __typename?: 'MroEmployeeProfile', id: string, firstName: string, lastName: string, profileColor?: string | null, profilePicture?: { __typename?: 'Attachment', id: string, signedUrl: string } | null } | null } };

export type GetItemCategoriesQueryVariables = Exact<{
  workOrderId: Scalars['String'];
}>;


export type GetItemCategoriesQuery = { __typename?: 'Query', mroWorkOrderItemCategories: Array<{ __typename?: 'MroWorkOrderItemCategory', id: string, title: string, sortIndex?: number | null, iconName?: string | null, categoryNumber?: number | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, name?: string | null, year?: number | null, serialNumber?: string | null } | null }> };

export type CreateCategoryMutationVariables = Exact<{
  input: MroWorkOrderItemCategoryCreateInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createMroWorkOrderItemCategory: { __typename?: 'MroWorkOrderItemCategory', id: string, title: string, sortIndex?: number | null, iconName?: string | null, categoryNumber?: number | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, name?: string | null, year?: number | null, serialNumber?: string | null } | null } };

export type UpdateCategoryMutationVariables = Exact<{
  input: MroWorkOrderItemCategoryUpdateInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateMroWorkOrderItemCategory: { __typename?: 'MroWorkOrderItemCategory', id: string, title: string, sortIndex?: number | null, iconName?: string | null, categoryNumber?: number | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, name?: string | null, year?: number | null, serialNumber?: string | null } | null } };

export type CategoryDetailsFragment = { __typename?: 'MroWorkOrderItemCategory', id: string, title: string, sortIndex?: number | null, iconName?: string | null, categoryNumber?: number | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, name?: string | null, year?: number | null, serialNumber?: string | null } | null };

export type DeleteCategoryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', removeMroWorkOrderItemCategory: { __typename?: 'MroWorkOrderItemCategory', id: string } };

export type CreateWorkOrderTemplateMutationVariables = Exact<{
  input: CreateWorkOrderTemplateInput;
}>;


export type CreateWorkOrderTemplateMutation = { __typename?: 'Mutation', createMroWorkOrderTemplate: { __typename?: 'MroWorkOrderTemplate', id: string, title: string } };

export type UpdateMroWorkOrderSignoffStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
  mroEmployeeProfileId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateMroWorkOrderSignoffStatusMutation = { __typename?: 'Mutation', updateSignoffStatus: { __typename?: 'MroWorkOrderSignoff', id: string } };

export type GetCategoryDetailsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCategoryDetailsQuery = { __typename?: 'Query', mroWorkOrderItemCategory: { __typename?: 'MroWorkOrderItemCategory', id: string, title: string, sortIndex?: number | null, iconName?: string | null, categoryNumber?: number | null, mroWorkOrderId?: string | null, mroComponent?: { __typename?: 'MroComponent', id: string, make?: string | null, model?: string | null, year?: number | null, serialNumber?: string | null } | null, mroWorkOrder?: { __typename?: 'MroWorkOrder', id: string, mroCraft?: { __typename?: 'MroCraft', id: string, mroComponents?: Array<{ __typename?: 'MroComponent', id: string, make?: string | null, name?: string | null, model?: string | null, year?: number | null, serialNumber?: string | null }> | null } | null } | null } };

export type GetLocationsQueryVariables = Exact<{
  where: MroLocationWhereInput;
}>;


export type GetLocationsQuery = { __typename?: 'Query', mroLocations?: Array<{ __typename?: 'MroLocation', id: string, name?: string | null, code?: string | null, createdAt: any }> | null };

export type UpdateWoStatusMutationVariables = Exact<{
  id: Scalars['String'];
  status: Scalars['String'];
}>;


export type UpdateWoStatusMutation = { __typename?: 'Mutation', updateMroWorkOrderStatus: { __typename?: 'MroWorkOrder', id: string } };

export type RequestAllWorkOrderItemsPartsMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RequestAllWorkOrderItemsPartsMutation = { __typename?: 'Mutation', requestAllWorkOrderItemsParts: string };

export type GetMroWorkOrderBillingItemsQueryVariables = Exact<{
  where: MroWorkOrderBillingItemWhereInput;
}>;


export type GetMroWorkOrderBillingItemsQuery = { __typename?: 'Query', mroWorkOrderBillingItems?: Array<{ __typename?: 'MroWorkOrderBillingItem', id: string, name: string, active: boolean, value?: any | null, itemNumber?: number | null, isPercentage: boolean, isDiscount: boolean, billableType: MroBillableType }> | null };

export type GetMroWorkOrderBillingItemQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMroWorkOrderBillingItemQuery = { __typename?: 'Query', mroWorkOrderBillingItem?: { __typename?: 'MroWorkOrderBillingItem', id: string, name: string, active: boolean, value?: any | null, itemNumber?: number | null, isPercentage: boolean, isDiscount: boolean, billableType: MroBillableType } | null };

export type UpdateMroWorkOrderBillingItemMutationVariables = Exact<{
  input: MroWorkOrderBillingItemUpdateInput;
}>;


export type UpdateMroWorkOrderBillingItemMutation = { __typename?: 'Mutation', updateMroWorkOrderBillingItem: { __typename?: 'MroWorkOrderBillingItem', id: string } };

export type CreateMroWorkOrderBillingItemMutationVariables = Exact<{
  input: MroWorkOrderBillingItemCreateInput;
}>;


export type CreateMroWorkOrderBillingItemMutation = { __typename?: 'Mutation', createMroWorkOrderBillingItem: { __typename?: 'MroWorkOrderBillingItem', id: string } };

export type DeleteMroWorkOrderBillingItemMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMroWorkOrderBillingItemMutation = { __typename?: 'Mutation', removeMroWorkOrderBillingItem: { __typename?: 'MroWorkOrderBillingItem', id: string } };

export type GetMroWorkOrderCategoriesQueryVariables = Exact<{
  where: MroWorkOrderCategoryWhereInput;
}>;


export type GetMroWorkOrderCategoriesQuery = { __typename?: 'Query', mroWorkOrderCategories?: Array<{ __typename?: 'MroWorkOrderCategory', id: string, name: string, location?: string | null, workType?: string | null, code?: string | null, color?: string | null }> | null };

export type DeleteMroWorkOrderItemMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMroWorkOrderItemMutation = { __typename?: 'Mutation', deleteWorkOrderItem?: { __typename?: 'MroWorkOrderItem', id: string } | null };

export type UpdateMroComponentMutationVariables = Exact<{
  input: MroComponentUpdateInput;
}>;


export type UpdateMroComponentMutation = { __typename?: 'Mutation', updateMroComponent: { __typename?: 'MroComponent', id: string } };

export type RemoveMroComponentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveMroComponentMutation = { __typename?: 'Mutation', removeMroComponent: { __typename?: 'MroComponent', id: string } };

export type GetCraftQueryVariables = Exact<{
  craftId: Scalars['String'];
  squawksWhere?: InputMaybe<SquawkWhereInput>;
}>;


export type GetCraftQuery = { __typename?: 'Query', craft: { __typename?: 'Craft', id: string, tailNumber: string, name: string, make?: string | null, model?: string | null, position?: number | null, fuelUnit: VolumeMeasurement, oilUnit: VolumeMeasurement, type: CraftType, loggingOption: LogType, regAddress?: string | null, updatedAt: any, year?: number | null, homeBase?: string | null, fuelCapacity?: number | null, isAirworthy: boolean, fuelAmount: string, intervals?: Array<{ __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, endValue?: any | null, usageRecord?: { __typename?: 'UsageRecord', id: string } | null } | null }> | null, squawks?: Array<{ __typename?: 'Squawk', id: string, severity?: Severity | null }> | null, inspections?: Array<{ __typename?: 'Inspection', id: string, almostDue: boolean, due: boolean }> | null, components?: Array<{ __typename?: 'Component', id: string, name: string }> | null, nextReservation?: { __typename?: 'Reservation', id: string, from?: any | null, to?: any | null, pilot?: { __typename?: 'UserOrganizationProfile', id: string, firstName?: string | null, lastName?: string | null } | null } | null, currentReservation?: { __typename?: 'Reservation', from?: any | null, to?: any | null, id: string, pilot?: { __typename?: 'UserOrganizationProfile', id: string, firstName?: string | null, lastName?: string | null } | null } | null } };

export type UpdateCraftMutationVariables = Exact<{
  updateCraftInput: UpdateCraftInput;
}>;


export type UpdateCraftMutation = { __typename?: 'Mutation', updateCraft: { __typename?: 'Craft', id: string, tailNumber: string, name: string, make?: string | null, model?: string | null, position?: number | null, fuelUnit: VolumeMeasurement, oilUnit: VolumeMeasurement, type: CraftType, loggingOption: LogType, regAddress?: string | null, updatedAt: any, fuelCapacity?: number | null } };

export type RemoveCraftMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveCraftMutation = { __typename?: 'Mutation', removeCraft: { __typename?: 'Craft', id: string } };

export type CreateDocumentMutationVariables = Exact<{
  input: DocumentCreateInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: { __typename?: 'Document', id: string } };

export type GetDocumentsQueryVariables = Exact<{
  where: DocumentWhereInput;
}>;


export type GetDocumentsQuery = { __typename?: 'Query', documents?: Array<{ __typename?: 'Document', id: string, name: string, favorite: boolean, createdAt: any, updatedAt?: any | null, attachment?: { __typename?: 'Attachment', id: string, signedUrl: string, fileType: string } | null }> | null };

export type GetDocumentQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, name: string, favorite: boolean, createdAt: any, updatedAt?: any | null, attachment?: { __typename?: 'Attachment', id: string, name: string, signedUrl: string, fileType: string } | null } | null };

export type UpdateDocumentMutationVariables = Exact<{
  input: DocumentUpdateInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string } };

export type RemoveDocumentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveDocumentMutation = { __typename?: 'Mutation', removeDocument: { __typename?: 'Document', id: string } };

export type GetIntervalsQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetIntervalsQuery = { __typename?: 'Query', intervals?: Array<{ __typename?: 'Interval', id: string, name: string, createdAt: any, optional?: boolean | null, isCustom: boolean, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }> | null };

export type GetIntervalQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetIntervalQuery = { __typename?: 'Query', interval?: { __typename?: 'Interval', id: string, name: string, optional?: boolean | null, isCustom: boolean, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null } | null };

export type RemoveIntervalMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveIntervalMutation = { __typename?: 'Mutation', removeInterval: { __typename?: 'Interval', id: string } };

export type UpdateIntervalMutationVariables = Exact<{
  input: IntervalUpdateInput;
}>;


export type UpdateIntervalMutation = { __typename?: 'Mutation', updateInterval: { __typename?: 'Interval', id: string, name: string, optional?: boolean | null, isCustom: boolean, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null } };

export type CreateIntervalMutationVariables = Exact<{
  input: IntervalCreateInput;
}>;


export type CreateIntervalMutation = { __typename?: 'Mutation', createInterval: { __typename?: 'Interval', id: string, name: string, optional?: boolean | null, isCustom: boolean, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null } };

export type GetLogbooksQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetLogbooksQuery = { __typename?: 'Query', logBooks?: Array<{ __typename?: 'LogBook', id: string, name: string, description?: string | null, totalEntries?: string | null, lastEntry?: { __typename?: 'LogEntry', id: string, title: string, logDate?: any | null } | null }> | null };

export type CreateLogBookMutationVariables = Exact<{
  input: LogBookCreateInput;
}>;


export type CreateLogBookMutation = { __typename?: 'Mutation', createLogBook: { __typename?: 'LogBook', id: string } };

export type UpdateLogBookMutationVariables = Exact<{
  input: LogBookUpdateInput;
}>;


export type UpdateLogBookMutation = { __typename?: 'Mutation', updateLogBook: { __typename?: 'LogBook', id: string } };

export type DeleteLogBookMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLogBookMutation = { __typename?: 'Mutation', removeLogBook: { __typename?: 'LogBook', id: string } };

export type GetLogbookQueryVariables = Exact<{
  logBookId: Scalars['String'];
}>;


export type GetLogbookQuery = { __typename?: 'Query', logBook?: { __typename?: 'LogBook', id: string, name: string, description?: string | null, components?: Array<{ __typename?: 'Component', id: string, name: string }> | null, intervals?: Array<{ __typename?: 'Interval', id: string, name: string, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }> | null, logEntries?: Array<{ __typename?: 'LogEntry', id: string, title: string, description?: string | null, logDate?: any | null, signedOffBy?: string | null }> | null } | null };

export type GetJascCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJascCategoriesQuery = { __typename?: 'Query', jascCategories: Array<{ __typename?: 'JascCategory', id: string, name: string, code: number, jascSystems?: Array<{ __typename?: 'JascSystem', id: string, name: string, code: number }> | null }> };

export type CreateLogEntryMutationVariables = Exact<{
  input: LogEntryCreateInput;
}>;


export type CreateLogEntryMutation = { __typename?: 'Mutation', createLogEntry: { __typename?: 'LogEntry', id: string, title: string, description?: string | null, logDate?: any | null } };

export type UpdateLogEntryMutationVariables = Exact<{
  input: LogEntryUpdateInput;
}>;


export type UpdateLogEntryMutation = { __typename?: 'Mutation', updateLogEntry: { __typename?: 'LogEntry', id: string } };

export type DeleteLogEntryMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLogEntryMutation = { __typename?: 'Mutation', removeLogEntry: { __typename?: 'LogEntry', id: string } };

export type GetLogEntryQueryVariables = Exact<{
  logEntryId: Scalars['String'];
}>;


export type GetLogEntryQuery = { __typename?: 'Query', logEntry?: { __typename?: 'LogEntry', id: string, title: string, description?: string | null, logDate?: any | null, intervalValues?: any | null, signedOffBy?: string | null, signedOffAt?: any | null, signOffInfo: string, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, signedUrl: string, fileType: string }> | null, logBook?: { __typename?: 'LogBook', id: string, name: string } | null, systemsAffected: Array<{ __typename?: 'JascSystem', id: string, name: string, code: number }> } | null };

export type GetMaintenanceRecordsQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetMaintenanceRecordsQuery = { __typename?: 'Query', maintenanceRecords?: Array<{ __typename?: 'MaintenanceRecord', id: string, craftId?: string | null, completionDate?: any | null, name: string, description?: string | null, createdAt: any, updatedAt?: any | null }> | null };

export type GetRequestsQueryVariables = Exact<{
  where: CraftServiceRequestWhereInput;
}>;


export type GetRequestsQuery = { __typename?: 'Query', craftServiceRequests?: Array<{ __typename?: 'CraftServiceRequest', id: string, title?: string | null, description?: string | null, status: string, createdAt: any, mroOrganizationName?: string | null, mroOrganizationPhone?: string | null, userProfile?: { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null }> | null };

export type GetRequestQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetRequestQuery = { __typename?: 'Query', craftServiceRequest?: { __typename?: 'CraftServiceRequest', id: string, title?: string | null, description?: string | null, status: string, createdAt: any, mroOrganizationName?: string | null, mroOrganizationPhone?: string | null, invoiceTokens?: any | null, estimateTokens?: any | null, userProfile?: { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, estimates?: Array<{ __typename?: 'MroEstimate', id: string, status?: string | null, estimateNumber?: number | null, pdfLink: string, date?: any | null, total?: any | null }> | null, invoices?: Array<{ __typename?: 'MroInvoice', id: string, status?: string | null, invoiceNumber?: string | null, invoiceDate?: any | null, dueDate?: any | null, amount?: any | null, priceSummary?: any | null, pdfLink: string }> | null } | null };

export type GetComponentsQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetComponentsQuery = { __typename?: 'Query', components?: Array<{ __typename?: 'Component', id: string, name: string, squawks?: Array<{ __typename?: 'Squawk', id: string, status?: Status | null }> | null }> | null };

export type UpdateComponentMutationVariables = Exact<{
  input: ComponentUpdateInput;
}>;


export type UpdateComponentMutation = { __typename?: 'Mutation', updateComponent: { __typename?: 'Component', id: string } };

export type CreateComponentMutationVariables = Exact<{
  input: ComponentCreateInput;
}>;


export type CreateComponentMutation = { __typename?: 'Mutation', createComponent: { __typename?: 'Component', id: string } };

export type RemoveComponentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveComponentMutation = { __typename?: 'Mutation', removeComponent: { __typename?: 'Component', id: string } };

export type GetSquawksQueryVariables = Exact<{
  craftId: Scalars['String'];
  where?: InputMaybe<SquawkWhereInput>;
}>;


export type GetSquawksQuery = { __typename?: 'Query', squawks?: Array<{ __typename?: 'Squawk', id: string, title: string, description?: string | null, openedAt: any, status?: Status | null, severity?: Severity | null, systemsAffected?: Array<{ __typename?: 'JascSystem', id: string, code: number, name: string }> | null, userProfile?: { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null }> | null, components?: Array<{ __typename?: 'Component', id: string, name: string }> | null };

export type GetSquawkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSquawkQuery = { __typename?: 'Query', squawk?: { __typename?: 'Squawk', id: string, title: string, description?: string | null, openedAt: any, status?: Status | null, severity?: Severity | null, systemsAffected?: Array<{ __typename?: 'JascSystem', id: string, code: number, name: string }> | null, userProfile?: { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, url: string, signedUrl: string, fileType: string }> | null, maintenanceRecords?: Array<{ __typename?: 'MaintenanceRecord', id: string, description?: string | null, completionDate?: any | null, severityStatus?: any | null, performedBy?: { __typename?: 'UserOrganizationProfile', id: string, firstName?: string | null, lastName?: string | null } | null }> | null, component?: { __typename?: 'Component', id: string } | null } | null };

export type UpdateSquawkMutationVariables = Exact<{
  input: SquawkUpdateInput;
}>;


export type UpdateSquawkMutation = { __typename?: 'Mutation', updateSquawkAndSendUpdate: { __typename?: 'Squawk', id: string } };

export type CreateSquawkMutationVariables = Exact<{
  input: CreateSquawkInput;
}>;


export type CreateSquawkMutation = { __typename?: 'Mutation', createSquawkWithNumber: { __typename?: 'Squawk', id: string } };

export type DeleteSquawkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSquawkMutation = { __typename?: 'Mutation', removeSquawk: { __typename?: 'Squawk', id: string } };

export type GetMaintenanceRecordSquawkQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMaintenanceRecordSquawkQuery = { __typename?: 'Query', maintenanceRecord?: { __typename?: 'MaintenanceRecord', id: string, name: string, completionDate?: any | null, description?: string | null, intervalValues?: any | null, severityStatus?: any | null, squawks?: Array<{ __typename?: 'Squawk', id: string, title: string }> | null, performedBy?: { __typename?: 'UserOrganizationProfile', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetInspectionsQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetInspectionsQuery = { __typename?: 'Query', craft: { __typename?: 'Craft', id: string, inspectionGroups?: Array<{ __typename?: 'InspectionGroup', id: string, name: string, description?: string | null, position?: number | null, inspections: Array<{ __typename?: 'Inspection', id: string, due: boolean, almostDue: boolean, dueDate?: any | null, name: string, description?: string | null, createdAt: any, lastPerformed?: any | null, lastPerformedInterval?: any | null, nextDueText: string, nextDuePercentage?: number | null, doesRepeat?: boolean | null, airworthinessItem?: boolean | null, dueMethod: InspectionDueType, amountLeft?: Array<string> | null, position?: number | null, newestInterval?: { __typename?: 'Interval', id: string, name: string } | null }> }> | null } };

export type GetIntervalsForCraftQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetIntervalsForCraftQuery = { __typename?: 'Query', craft: { __typename?: 'Craft', id: string, loggingOption: LogType, normalIntervals: Array<{ __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }> } };

export type GetIntervalsAndLogbooksForCraftQueryVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type GetIntervalsAndLogbooksForCraftQuery = { __typename?: 'Query', craft: { __typename?: 'Craft', id: string, loggingOption: LogType, normalIntervals: Array<{ __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }>, logBooks?: Array<{ __typename?: 'LogBook', id: string, name: string }> | null } };

export type GetInspectionGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInspectionGroupQuery = { __typename?: 'Query', inspectionGroup?: { __typename?: 'InspectionGroup', id: string, name: string, description?: string | null, position?: number | null } | null };

export type GetInspectionGroupsQueryVariables = Exact<{
  where: InspectionGroupWhereInput;
  orderBy?: InputMaybe<Array<InspectionGroupOrderByWithRelationInput> | InspectionGroupOrderByWithRelationInput>;
}>;


export type GetInspectionGroupsQuery = { __typename?: 'Query', inspectionGroups?: Array<{ __typename?: 'InspectionGroup', id: string, name: string, description?: string | null, position?: number | null }> | null };

export type CreateInspectionGroupMutationVariables = Exact<{
  input: InspectionGroupCreateInput;
}>;


export type CreateInspectionGroupMutation = { __typename?: 'Mutation', createGroupWithPosition: { __typename?: 'InspectionGroup', id: string } };

export type UpdateInspectionGroupMutationVariables = Exact<{
  input: InspectionGroupUpdateInput;
}>;


export type UpdateInspectionGroupMutation = { __typename?: 'Mutation', updateInspectionGroupWithSort: { __typename?: 'InspectionGroup', id: string } };

export type DeleteInspectionGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInspectionGroupMutation = { __typename?: 'Mutation', deleteInspectionGroupWithSort: { __typename?: 'InspectionGroup', id: string } };

export type GetAdsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAdsQuery = { __typename?: 'Query', adsForCraft: Array<{ __typename?: 'RegisteredAirworthyDirective', id: string, adNumber?: string | null, title?: string | null, description?: string | null, subject?: string | null, issueDate?: any | null, effectiveDate?: any | null, models?: string | null, link?: string | null }> };

export type GetInspectionFreeLimitQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInspectionFreeLimitQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, inspectionFreeLimit: number } | null };

export type GetInspectionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetInspectionQuery = { __typename?: 'Query', inspection?: { __typename?: 'Inspection', id: string, name: string, description?: string | null, due: boolean, dueDate?: any | null, dueMethod: InspectionDueType, lastPerformed?: any | null, lastPerformedInterval?: any | null, airworthinessItem?: boolean | null, nextDueText: string, faaInfo?: any | null, doesRepeat?: boolean | null, dueDateDaysFrequency?: number | null, dueDateMonthsFrequency?: number | null, dueDateSoon?: number | null, dueInterval?: any | null, position?: number | null, inspectionGroup?: { __typename?: 'InspectionGroup', id: string, name: string } | null, maintenanceRecords?: Array<{ __typename?: 'MaintenanceRecord', id: string, name: string, completionDate?: any | null, description?: string | null, intervalValues?: any | null }> | null, newestInterval?: { __typename?: 'Interval', id: string, name: string, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null } | null, newestIntervalDueRecord?: { __typename?: 'IntervalsOnInspections', id: string, dueAt?: any | null } | null } | null };

export type CreateInspectionMutationVariables = Exact<{
  input: InspectionCreateInput;
}>;


export type CreateInspectionMutation = { __typename?: 'Mutation', createInspectionWithSort: { __typename?: 'InspectionGroup', id: string } };

export type UpdateInspectionMutationVariables = Exact<{
  input: InspectionUpdateInput;
}>;


export type UpdateInspectionMutation = { __typename?: 'Mutation', updateInspectionWithSort: { __typename?: 'InspectionGroup', id: string } };

export type DeleteInspectionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInspectionMutation = { __typename?: 'Mutation', removeInspection: { __typename?: 'Inspection', id: string } };

export type CreateMaintenanceRecordMutationVariables = Exact<{
  input: MaintenanceRecordCreateInput;
}>;


export type CreateMaintenanceRecordMutation = { __typename?: 'Mutation', createMaintenanceRecord: { __typename?: 'MaintenanceRecord', id: string } };

export type GetMaintenanceRecordQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetMaintenanceRecordQuery = { __typename?: 'Query', maintenanceRecord?: { __typename?: 'MaintenanceRecord', id: string, name: string, completionDate?: any | null, description?: string | null, intervalValues?: any | null, newestInspection?: { __typename?: 'Inspection', id: string, dueMethod: InspectionDueType, newestInterval?: { __typename?: 'Interval', id: string, name: string } | null } | null } | null };

export type UpdateMaintenanceRecordMutationVariables = Exact<{
  input: MaintenanceRecordUpdateInput;
}>;


export type UpdateMaintenanceRecordMutation = { __typename?: 'Mutation', updateMaintenanceRecord: { __typename?: 'MaintenanceRecord', id: string } };

export type DeleteMaintenanceRecordMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMaintenanceRecordMutation = { __typename?: 'Mutation', removeMaintenanceRecord: { __typename?: 'MaintenanceRecord', id: string } };

export type UpdateIntervalsOnInspectionsMutationVariables = Exact<{
  input: IntervalsOnInspectionsUpdateInput;
}>;


export type UpdateIntervalsOnInspectionsMutation = { __typename?: 'Mutation', updateIntervalsOnInspections: { __typename?: 'IntervalsOnInspections', id: string } };

export type GetAnnouncementCountQueryVariables = Exact<{
  where?: InputMaybe<AnnouncementWhereInput>;
}>;


export type GetAnnouncementCountQuery = { __typename?: 'Query', announcementCount?: number | null };

export type GetAnnouncementsQueryVariables = Exact<{
  where?: InputMaybe<AnnouncementWhereInput>;
}>;


export type GetAnnouncementsQuery = { __typename?: 'Query', announcements?: Array<{ __typename?: 'Announcement', id: string, title: string, authorName: string, content: string, active: boolean, pinned: boolean, createdAt: any, updatedAt?: any | null }> | null };

export type GetAnnouncementQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAnnouncementQuery = { __typename?: 'Query', announcement?: { __typename?: 'Announcement', id: string, title: string, authorName: string, content: string, active: boolean, pinned: boolean, canEdit: boolean, createdAt: any, updatedAt?: any | null, comments?: Array<{ __typename?: 'Comment', id: string, authorName: string, content: string }> | null } | null };

export type CreateAnnouncementMutationVariables = Exact<{
  input: AnnouncementCreateInput;
}>;


export type CreateAnnouncementMutation = { __typename?: 'Mutation', createAnnouncementAndSendMessage: { __typename?: 'Announcement', id: string } };

export type UpdateAnnouncementMutationVariables = Exact<{
  input: AnnouncementUpdateInput;
}>;


export type UpdateAnnouncementMutation = { __typename?: 'Mutation', updateAnnouncementAndSendMessage: { __typename?: 'Announcement', id: string } };

export type DeleteAnnouncementMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAnnouncementMutation = { __typename?: 'Mutation', removeAnnouncement: { __typename?: 'Announcement', id: string } };

export type GetCraftsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']>;
}>;


export type GetCraftsQuery = { __typename?: 'Query', crafts: Array<{ __typename?: 'Craft', id: string, tailNumber: string, name: string, make?: string | null, model?: string | null, position?: number | null, fuelUnit: VolumeMeasurement, oilUnit: VolumeMeasurement, type: CraftType, loggingOption: LogType, regAddress?: string | null, updatedAt: any, isAirworthy: boolean, squawks?: Array<{ __typename?: 'Squawk', id: string, status?: Status | null }> | null, inspections?: Array<{ __typename?: 'Inspection', id: string, almostDue: boolean, due: boolean }> | null }> };

export type SetSelectCraftMutationVariables = Exact<{
  craftId: Scalars['String'];
}>;


export type SetSelectCraftMutation = { __typename?: 'Mutation', setSelectCraft: { __typename?: 'UserOrganizationProfile', id: string } };

export type FlightIntervalFragment = { __typename?: 'FlightIntervals', id?: string | null, name: string, startValue?: number | null, endValue?: number | null, subtype?: string | null, isCustom?: boolean | null, optional?: boolean | null };

export type FlightInfoFragment = { __typename?: 'Flight', id: string, flightDate?: any | null, icaos?: Array<string> | null, notes?: string | null, flightLog?: string | null, purposeName?: string | null, isPending?: boolean | null, position?: number | null, soruce?: string | null, pilotName?: string | null, userId?: string | null, route?: Array<{ __typename?: 'Airport', id: string, icao: string }> | null, normalIntervals?: Array<{ __typename?: 'FlightIntervals', id?: string | null, name: string, startValue?: number | null, endValue?: number | null, subtype?: string | null, isCustom?: boolean | null, optional?: boolean | null }> | null, craft: { __typename?: 'Craft', id: string, name: string, loggingOption: LogType } };

export type GetFlightsQueryVariables = Exact<{
  where: FlightWhereInput;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FlightOrderByWithRelationInput> | FlightOrderByWithRelationInput>;
}>;


export type GetFlightsQuery = { __typename?: 'Query', flightCount?: number | null, pendingFlightCount?: number | null, flights?: Array<{ __typename?: 'Flight', id: string, flightDate?: any | null, icaos?: Array<string> | null, notes?: string | null, flightLog?: string | null, purposeName?: string | null, isPending?: boolean | null, position?: number | null, soruce?: string | null, pilotName?: string | null, userId?: string | null, route?: Array<{ __typename?: 'Airport', id: string, icao: string }> | null, normalIntervals?: Array<{ __typename?: 'FlightIntervals', id?: string | null, name: string, startValue?: number | null, endValue?: number | null, subtype?: string | null, isCustom?: boolean | null, optional?: boolean | null }> | null, craft: { __typename?: 'Craft', id: string, name: string, loggingOption: LogType } }> | null, pendingFlights?: Array<{ __typename?: 'Flight', id: string, flightDate?: any | null, icaos?: Array<string> | null, notes?: string | null, flightLog?: string | null, purposeName?: string | null, isPending?: boolean | null, position?: number | null, soruce?: string | null, pilotName?: string | null, userId?: string | null, route?: Array<{ __typename?: 'Airport', id: string, icao: string }> | null, normalIntervals?: Array<{ __typename?: 'FlightIntervals', id?: string | null, name: string, startValue?: number | null, endValue?: number | null, subtype?: string | null, isCustom?: boolean | null, optional?: boolean | null }> | null, craft: { __typename?: 'Craft', id: string, name: string, loggingOption: LogType } }> | null };

export type GetFlightQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFlightQuery = { __typename?: 'Query', flight?: { __typename?: 'Flight', id: string, flightDate?: any | null, proRataShare?: boolean | null, position?: number | null, notes?: string | null, customPurpose?: string | null, icaos?: Array<string> | null, isPending?: boolean | null, soruce?: string | null, flightTime?: number | null, billable?: boolean | null, pilotName?: string | null, userProfileId?: string | null, userId?: string | null, consumables?: Array<{ __typename?: 'FlightIntervals', id?: string | null, name: string, startValue?: number | null, endValue?: number | null, subtype?: string | null, isCustom?: boolean | null, optional?: boolean | null }> | null, normalIntervals?: Array<{ __typename?: 'FlightIntervals', id?: string | null, name: string, startValue?: number | null, endValue?: number | null, subtype?: string | null, isCustom?: boolean | null, optional?: boolean | null }> | null, route?: Array<{ __typename?: 'Airport', id: string, icao: string }> | null, consumableEntries?: Array<{ __typename?: 'ConsumableEntry', id: string, name: string, value: any }> | null, purpose?: { __typename?: 'FlightPurpose', id: string, name: string } | null, passengers?: Array<{ __typename?: 'UserOrganizationProfile', id: string, nameInvite?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }> | null, attachments?: Array<{ __typename?: 'Attachment', id: string, name: string, url: string, signedUrl: string, fileType: string }> | null, usageRecord?: { __typename?: 'UsageRecord', id: string, intervalLogs?: Array<{ __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null, interval?: { __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null } | null }> | null } | null, craft: { __typename?: 'Craft', id: string, name: string, loggingOption: LogType, intervals?: Array<{ __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }> | null }, transactions?: Array<{ __typename?: 'Transaction', id: string, inputData?: any | null, value?: any | null, metadata?: any | null, createdAt: any, status?: TransactionStatus | null, pilotName: string }> | null } | null };

export type GetFlightImportsQueryVariables = Exact<{
  where: ImportWhereInput;
}>;


export type GetFlightImportsQuery = { __typename?: 'Query', imports?: Array<{ __typename?: 'Import', id: string, position?: number | null, name?: string | null, status?: string | null, createdAt: any, attachments?: Array<{ __typename?: 'Attachment', id: string, url: string, signedUrl: string }> | null }> | null };

export type CreateFlightMutationVariables = Exact<{
  input: FlightCreateWithIntervalsInput;
}>;


export type CreateFlightMutation = { __typename?: 'Mutation', createFlightWithIntervals: { __typename?: 'Flight', id: string } };

export type UpdateFlightMutationVariables = Exact<{
  input: FlightUpdateWithIntervalsInput;
}>;


export type UpdateFlightMutation = { __typename?: 'Mutation', updateFlightWithIntervals: { __typename?: 'Flight', id: string } };

export type DeleteFlightMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteFlightMutation = { __typename?: 'Mutation', deleteFlight: { __typename?: 'Flight', id: string } };

export type GetOrgUserProfilesQueryVariables = Exact<{
  where: UserOrganizationProfileWhereInput;
}>;


export type GetOrgUserProfilesQuery = { __typename?: 'Query', userOrganizationProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string }> | null };

export type GetAirportsQueryVariables = Exact<{
  where: AirportWhereInput;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAirportsQuery = { __typename?: 'Query', airports?: Array<{ __typename?: 'Airport', id: string, icao: string, facilityName: string, city: string, state: string }> | null };

export type GetFlightPurposesQueryVariables = Exact<{
  where: FlightPurposeWhereInput;
}>;


export type GetFlightPurposesQuery = { __typename?: 'Query', flightPurposes?: Array<{ __typename?: 'FlightPurpose', id: string, name: string, sort?: number | null, createdAt: any }> | null };

export type GetFavoriteRoutesQueryVariables = Exact<{
  where: FavoriteRouteWhereInput;
}>;


export type GetFavoriteRoutesQuery = { __typename?: 'Query', favoriteRoutes?: Array<{ __typename?: 'FavoriteRoute', id: string, name: string, icaos?: Array<string> | null, sort?: number | null, airports: Array<{ __typename?: 'Airport', id: string, icao: string }> }> | null };

export type GetFavoriteRouteQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFavoriteRouteQuery = { __typename?: 'Query', favoriteRoute?: { __typename?: 'FavoriteRoute', id: string, name: string, icaos?: Array<string> | null, sort?: number | null, airports: Array<{ __typename?: 'Airport', id: string, icao: string }> } | null };

export type GetOrganizationFlightBillingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationFlightBillingQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, flightBillingEnabled?: boolean | null } | null };

export type CreateFavoriteRouteMutationVariables = Exact<{
  input: FavoriteRouteCreateInput;
}>;


export type CreateFavoriteRouteMutation = { __typename?: 'Mutation', createFavoriteRouteWithSort: { __typename?: 'FavoriteRoute', id: string } };

export type UpdateFavoriteRouteMutationVariables = Exact<{
  input: FavoriteRouteUpdateInput;
}>;


export type UpdateFavoriteRouteMutation = { __typename?: 'Mutation', updateFavoriteRouteWithSort: { __typename?: 'FavoriteRoute', id: string } };

export type DeleteFavoriteRouteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteFavoriteRouteMutation = { __typename?: 'Mutation', removeFavoriteRouteWithSort: { __typename?: 'FavoriteRoute', id: string } };

export type GetTransactionsQueryVariables = Exact<{
  where?: InputMaybe<TransactionWhereInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TransactionOrderByWithRelationInput> | TransactionOrderByWithRelationInput>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', transactionCount?: number | null, transactions?: Array<{ __typename?: 'Transaction', inputData?: any | null, formattedValue: string, id: string, isDeposit?: boolean | null, status?: TransactionStatus | null, createdAt: any, timestamp?: any | null, wallet?: { __typename?: 'Wallet', id: string, userProfile?: { __typename?: 'UserOrganizationProfile', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null } | null }> | null };

export type GetTransactionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetTransactionQuery = { __typename?: 'Query', transaction?: { __typename?: 'Transaction', inputData?: any | null, formattedValue: string, id: string, isDeposit?: boolean | null, timestamp?: any | null, status?: TransactionStatus | null, createdAt: any, attachments?: Array<{ __typename?: 'Attachment', id: string, signedUrl: string, fileType: string, name: string }> | null, wallet?: { __typename?: 'Wallet', id: string, userProfile?: { __typename?: 'UserOrganizationProfile', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null } | null } | null };

export type GetUserWalletQueryVariables = Exact<{
  userProfileId: Scalars['String'];
}>;


export type GetUserWalletQuery = { __typename?: 'Query', userWallet: { __typename?: 'Wallet', id: string, balanceCache?: any | null, createdAt: any } };

export type GetCraftBillingInfoQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']>;
}>;


export type GetCraftBillingInfoQuery = { __typename?: 'Query', crafts: Array<{ __typename?: 'Craft', id: string, name: string, tailNumber: string, hourlyRate?: number | null, hourlyRateMethod?: string | null, loggingOption: LogType, createdAt: any }> };

export type GetOrganizationBillingInfoQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetOrganizationBillingInfoQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, monthlyContribution?: any | null, monthlyContributionEnabled?: boolean | null, flightBillingEnabled?: boolean | null, billingEnabledByDefault?: boolean | null, supportedPaymentMethod: string, adminPayMonthlyContribution?: boolean | null, specialBillingEnabled?: boolean | null, totalOwed: any, createdAt: any } | null };

export type GetOrganizationWalletsQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetOrganizationWalletsQuery = { __typename?: 'Query', wallets?: Array<{ __typename?: 'Wallet', id: string, balanceCache?: any | null, createdAt: any, userProfile?: { __typename?: 'UserOrganizationProfile', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null } | null, transactions?: Array<{ __typename?: 'Transaction', id: string }> | null }> | null };

export type UpdateCraftsMutationVariables = Exact<{
  input: Array<UpdateCraftInput> | UpdateCraftInput;
}>;


export type UpdateCraftsMutation = { __typename?: 'Mutation', updateCrafts: Array<{ __typename?: 'Craft', id: string }> };

export type CreateTransactionMutationVariables = Exact<{
  input: TransactionCreateInput;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransactionAndUpdateWallet: { __typename?: 'Transaction', id: string } };

export type UpdateTransactionAttachmentsMutationVariables = Exact<{
  attachments: TransactionsUpdateAttachmentsInput;
  id: Scalars['String'];
}>;


export type UpdateTransactionAttachmentsMutation = { __typename?: 'Mutation', updateTransactionAttachments: { __typename?: 'Transaction', id: string } };

export type StripePayBalanceQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type StripePayBalanceQuery = { __typename?: 'Query', stripePayBalance: string };

export type StripePayPartialQueryVariables = Exact<{
  id: Scalars['String'];
  amount: Scalars['Float'];
}>;


export type StripePayPartialQuery = { __typename?: 'Query', stripePayPartial: string };

export type StripeDashboardQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type StripeDashboardQuery = { __typename?: 'Query', stripeDashboard: string };

export type UpdateStripeConnectMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UpdateStripeConnectMutation = { __typename?: 'Mutation', updateStripeConnect: { __typename?: 'Organization', id: string } };

export type ForeflightAuthMutationVariables = Exact<{
  organizationId: Scalars['String'];
  code: Scalars['String'];
}>;


export type ForeflightAuthMutation = { __typename?: 'Mutation', foreflightAuth: string };

export type GetReportInfoQueryVariables = Exact<{
  id: Scalars['String'];
  timeframe: Scalars['String'];
  craftId?: InputMaybe<Scalars['String']>;
}>;


export type GetReportInfoQuery = { __typename?: 'Query', reportInfo: { __typename?: 'ReportInfo', flightTime: string, flights: string, xcMiles: string, xcFlightTime: string, currentLocation: { __typename?: 'Route', name: string, lat: string, long: string }, flightRoutes: Array<{ __typename?: 'FlightRoute', id: string, routes: Array<{ __typename?: 'Route', name: string, lat: string, long: string }> }> } };

export type FuelOilReportsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FuelOilReportsQuery = { __typename?: 'Query', fuelOilReports: Array<{ __typename?: 'FuelOilReport', name: string, Fuel_Per_Hobbs_Hour?: any | null, Oil_Per_Hobbs_Hour?: any | null, Fuel_Per_Tach_Hour?: any | null, Oil_Per_Tach_Hour?: any | null, Fuel_Per_Tach_2_Hour?: any | null, Oil_Per_Tach_2_Hour?: any | null }> };

export type PilotFragment = { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null };

export type GetReservationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetReservationQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: string, craftId?: string | null, pilotId?: string | null, createdAt: any, from?: any | null, to?: any | null, notes?: string | null, allDay?: boolean | null, isMaintenance?: boolean | null, timezone?: string | null, canEdit: boolean, pilot?: { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, craft?: { __typename?: 'Craft', id: string, craftName: string } | null } | null };

export type GetCraftsReservationExportQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetCraftsReservationExportQuery = { __typename?: 'Query', reservationsCalendarLink?: string | null };

export type GetCraftsReservationsQueryVariables = Exact<{
  organizationId: Scalars['String'];
  selectedDate?: InputMaybe<Scalars['String']>;
}>;


export type GetCraftsReservationsQuery = { __typename?: 'Query', crafts: Array<{ __typename?: 'Craft', id: string, name: string, tailNumber: string, reservations?: Array<{ __typename?: 'Reservation', id: string, craftId?: string | null, pilotId?: string | null, from?: any | null, to?: any | null, notes?: string | null, isMaintenance?: boolean | null, createdAt: any, timezone?: string | null, allDay?: boolean | null, pilotName?: string | null, userId?: string | null, craft?: { __typename?: 'Craft', craftName: string } | null }> | null }> };

export type GetReservationsQueryVariables = Exact<{
  where: ReservationWhereInput;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReservationOrderByWithRelationInput> | ReservationOrderByWithRelationInput>;
}>;


export type GetReservationsQuery = { __typename?: 'Query', reservationCount?: number | null, reservations?: Array<{ __typename?: 'Reservation', id: string, craftId?: string | null, from?: any | null, to?: any | null, timezone?: string | null, notes?: string | null, isMaintenance?: boolean | null, createdAt: any, allDay?: boolean | null, pilotName?: string | null, pilot?: { __typename?: 'UserOrganizationProfile', id: string, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null, craft?: { __typename?: 'Craft', craftName: string } | null }> | null };

export type IntervalFragmentFragment = { __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, isCustom: boolean, optional?: boolean | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null };

export type GetCraftsWithUsersQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type GetCraftsWithUsersQuery = { __typename?: 'Query', crafts: Array<{ __typename?: 'Craft', id: string, label?: string | null, loggingOption: LogType, fuelAmount: string, type: CraftType, hourlyRate?: number | null, hourlyRateMethod?: string | null, lastAirport?: { __typename?: 'LastAirport', id?: string | null, icao?: string | null } | null, normalLoggingIntervals: Array<{ __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, isCustom: boolean, optional?: boolean | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }>, consumableIntervals: Array<{ __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, isCustom: boolean, optional?: boolean | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null }>, billingInterval?: { __typename?: 'Interval', id: string, name: string, intervalType: IntervalType, intervalSubType?: IntervalSubtype | null, isCustom: boolean, optional?: boolean | null, recentIntervalLog?: { __typename?: 'IntervalLog', id: string, startValue?: any | null, endValue?: any | null } | null } | null, userProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string, userName?: string | null, nameInvite?: string | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null }> | null }> };

export type CreateReservationMutationVariables = Exact<{
  input: ReservationCreateInput;
}>;


export type CreateReservationMutation = { __typename?: 'Mutation', createReservationAndNotify?: { __typename?: 'Reservation', id: string } | null };

export type UpdateReservationMutationVariables = Exact<{
  input: ReservationUpdateInput;
}>;


export type UpdateReservationMutation = { __typename?: 'Mutation', updateReservation: { __typename?: 'Reservation', id: string, craftId?: string | null, pilotId?: string | null, from?: any | null, to?: any | null, allDay?: boolean | null, timezone?: string | null, notes?: string | null, isMaintenance?: boolean | null } };

export type RemoveReservationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveReservationMutation = { __typename?: 'Mutation', removeReservation: { __typename?: 'Reservation', id: string } };

export type ApplyCouponToUserMutationVariables = Exact<{
  couponCode: Scalars['String'];
}>;


export type ApplyCouponToUserMutation = { __typename?: 'Mutation', applyCouponToUser: { __typename?: 'Coupon', id: string } };

export type RemoveCouponFromUserMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCouponFromUserMutation = { __typename?: 'Mutation', removeCouponFromUser: boolean };

export type ChargebeePortalQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type ChargebeePortalQuery = { __typename?: 'Query', chargebeePortal: string };

export type ChargebeeSubscribeInfoQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type ChargebeeSubscribeInfoQuery = { __typename?: 'Query', chargebeeSubcriptionInfo?: { __typename?: 'ChargebeeSubscription', id: string, planName: string, billingAmount: string, billingPeriod: string, nextBillingInfo: string } | null };

export type CreateChargebeeSubscriptionMutationVariables = Exact<{
  planId: Scalars['String'];
  organizationId: Scalars['String'];
  input: ChargebeeSubscribeInput;
}>;


export type CreateChargebeeSubscriptionMutation = { __typename?: 'Mutation', createChargebeeSubscription: string };

export type GetPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlansQuery = { __typename?: 'Query', stripePlans: Array<{ __typename?: 'StripePlan', id: string, planName?: string | null, cost: string, link: string, type: string, isTrial: boolean }> };

export type StripeSubscriptionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type StripeSubscriptionQuery = { __typename?: 'Query', stripeSubscription: { __typename?: 'StripeSubscription', id: string, planName: string, cost: string, billingDate: string, interval: string, customerPortalUrl: string, craftProrateCost?: string | null, craftCost?: string | null, isPendingCancel?: boolean | null, craftSubscription?: { __typename?: 'CraftSubscription', planName: string, cost: string, billingDate: string, interval: string, quantity: string } | null } };

export type UpdateCraftAmountMutationVariables = Exact<{
  amount: Scalars['Int'];
}>;


export type UpdateCraftAmountMutation = { __typename?: 'Mutation', updateCraftAmountSubsciption: string };

export type SetupAirblyMutationVariables = Exact<{
  key: Scalars['String'];
  organizationId: Scalars['String'];
}>;


export type SetupAirblyMutation = { __typename?: 'Mutation', setupAirbly: { __typename?: 'AirblySetup', integration_enabled?: boolean | null, message?: string | null } };

export type DisconnectAirblyMutationVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type DisconnectAirblyMutation = { __typename?: 'Mutation', disconnectAirbly: { __typename?: 'AirblySetup', integration_enabled?: boolean | null, message?: string | null } };

export type GetForeflightLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type GetForeflightLoginQuery = { __typename?: 'Query', foreflightLoginLink: string };

export type DisconnectForeflightMutationVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type DisconnectForeflightMutation = { __typename?: 'Mutation', disconnectForeflight: string };

export type FindOrganizationAirsyncTailsQueryVariables = Exact<{
  organizationId: Scalars['String'];
}>;


export type FindOrganizationAirsyncTailsQuery = { __typename?: 'Query', findOrganizationAirsyncTails: Array<{ __typename?: 'AirSyncTail', tailNumber: string, airSyncId: string, craftId: string, isAircraftRegistered: boolean, isSetup: boolean }> };

export type SetupAirsyncTailsMutationVariables = Exact<{
  input: Array<AirsyncSetupInput> | AirsyncSetupInput;
}>;


export type SetupAirsyncTailsMutation = { __typename?: 'Mutation', setupAirsyncTails: Array<{ __typename?: 'AirSyncSetup', airSyncId: string, isSetup: boolean }> };

export type RemoveAirsyncTailMutationVariables = Exact<{
  input: AirsyncSetupInput;
}>;


export type RemoveAirsyncTailMutation = { __typename?: 'Mutation', removeAirsyncTail: { __typename?: 'AirSyncTail', airSyncId: string, isSetup: boolean } };

export type SyncAirSyncLogsMutationVariables = Exact<{
  input: AirsyncSetupInput;
}>;


export type SyncAirSyncLogsMutation = { __typename?: 'Mutation', syncAirsyncLogs: { __typename?: 'AirSyncLogSync', error?: string | null, status: string } };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, airmenLicense?: any | null, timezone?: string | null, selectedOrganizationProfile?: { __typename?: 'UserOrganizationProfile', id: string, notificationSettings?: any | null, phone?: string | null, foreflightInfo?: any | null } | null } };

export type GetTimezoneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimezoneQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, timezone?: string | null } };

export type GetUserCouponQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCouponQuery = { __typename?: 'Query', me: { __typename?: 'User', coupon?: { __typename?: 'Coupon', id: string, code: string, discountId?: string | null, couponType?: CouponType | null, discount?: any | null, description?: string | null, active?: boolean | null, supportedPlans?: Array<string> | null, expiresAt?: any | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, email: string, firstName?: string | null, lastName?: string | null, selectedOrganizationProfile?: { __typename?: 'UserOrganizationProfile', id: string, notificationSettings?: any | null } | null } };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UserOrganizationProfileUpdateInput;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserOrganizationProfile: { __typename?: 'UserOrganizationProfile', id: string } };

export type ResendInvitationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: string };

export type GetOrganizationSettingsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, billingEmail?: string | null, billingAddress?: any | null, trialEndsAt?: any | null, stripeSubscriptionId?: string | null, airblyReadKey?: string | null, reservationSettings?: any | null, freeAircrafts?: number | null, organizationType: string, cbInfo?: any | null } | null };

export type GetOrganizationBillingQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationBillingQuery = { __typename?: 'Query', organizationAuth?: { __typename?: 'Organization', id: string, name: string, organizationType: string, cbInfo?: any | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string } };

export type CreateFlightPurposeMutationVariables = Exact<{
  input: FlightPurposeCreateInput;
}>;


export type CreateFlightPurposeMutation = { __typename?: 'Mutation', createFlightPurposeWithSort: { __typename?: 'FlightPurpose', id: string } };

export type UpdateFlightPurposeMutationVariables = Exact<{
  input: FlightPurposeUpdateInput;
}>;


export type UpdateFlightPurposeMutation = { __typename?: 'Mutation', updateFlightPurposeWithSort: { __typename?: 'FlightPurpose', id: string } };

export type DeleteFlightPurposeMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteFlightPurposeMutation = { __typename?: 'Mutation', deleteFlightPurposeWithSort: { __typename?: 'FlightPurpose', id: string } };

export type GetFlightPurposeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFlightPurposeQuery = { __typename?: 'Query', flightPurpose?: { __typename?: 'FlightPurpose', id: string, name: string, sort?: number | null, isCustom?: boolean | null } | null };

export type GetUserOrganizationProfilesQueryVariables = Exact<{
  where: UserOrganizationProfileWhereInput;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUserOrganizationProfilesQuery = { __typename?: 'Query', userOrganizationProfiles?: Array<{ __typename?: 'UserOrganizationProfile', id: string, phone?: string | null, status?: string | null, userName?: string | null, nameInvite?: string | null, emailInvite?: string | null, phoneInvite?: string | null, createdAt: any, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, userOrganizationRole?: { __typename?: 'UserOrganizationRole', id: string, title: string } | null }> | null };

export type CreateUserOrganizationProfileMutationVariables = Exact<{
  input: UserOrganizationProfileCreateInput;
}>;


export type CreateUserOrganizationProfileMutation = { __typename?: 'Mutation', addUser: { __typename?: 'UserOrganizationProfile', id: string } };

export type UpdateUserOrganizationProfileMutationVariables = Exact<{
  input: UserOrganizationProfileUpdateInput;
}>;


export type UpdateUserOrganizationProfileMutation = { __typename?: 'Mutation', updateUserOrganizationProfile: { __typename?: 'UserOrganizationProfile', id: string } };

export type GetUserOrganizationRolesQueryVariables = Exact<{
  where: UserOrganizationRoleWhereInput;
}>;


export type GetUserOrganizationRolesQuery = { __typename?: 'Query', userOrganizationRoles?: Array<{ __typename?: 'UserOrganizationRole', id: string, title: string }> | null };

export type GetUserOrganizationProfileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserOrganizationProfileQuery = { __typename?: 'Query', userOrganizationProfile?: { __typename?: 'UserOrganizationProfile', id: string, phone?: string | null, status?: string | null, nameInvite?: string | null, emailInvite?: string | null, phoneInvite?: string | null, createdAt: any, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, userOrganizationRole?: { __typename?: 'UserOrganizationRole', id: string, title: string } | null } | null };

export type GetServiceRequestBadgesQueryVariables = Exact<{
  mroOrganizationId: Scalars['String'];
}>;


export type GetServiceRequestBadgesQuery = { __typename?: 'Query', mroServiceRequests?: Array<{ __typename?: 'MroServiceRequest', id: string }> | null };

export type GetOrganizationsQueryVariables = Exact<{
  where: OrganizationWhereInput;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string, cbInfo?: any | null, myRole?: string | null, crafts?: Array<{ __typename?: 'Craft', id: string }> | null, users?: Array<{ __typename?: 'User', id: string }> | null }> };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, aircraftLimit?: number | null, billingEmail?: string | null, legacyId?: string | null } | null };

export const OrgInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrgInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"aircraftLimit"}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"crafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]} as unknown as DocumentNode<OrgInfoFragment, unknown>;
export const ServiceInfoFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userOrganizationProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgInfo"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrgInfo"}}]}}]}},...OrgInfoFragmentDoc.definitions]} as unknown as DocumentNode<ServiceInfoFragment, unknown>;
export const OnboardInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OnboardInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardOrganization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"aircraftLimit"}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"crafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]} as unknown as DocumentNode<OnboardInfoFragment, unknown>;
export const EstimateInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EstimateInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroEstimate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationId"}}]}}]} as unknown as DocumentNode<EstimateInfoFragment, unknown>;
export const MroDashboardWorkOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MroDashboardWorkOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"make"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<MroDashboardWorkOrderFragment, unknown>;
export const MroDashboardTaskDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MroDashboardTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"allAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}}]}}]}}]} as unknown as DocumentNode<MroDashboardTaskDetailsFragment, unknown>;
export const DashboardWorkOrderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardWorkOrder"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrder"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"make"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}}]} as unknown as DocumentNode<DashboardWorkOrderFragment, unknown>;
export const TaskDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"allAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TaskDetailsFragment, unknown>;
export const MroPartInventoryInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MroPartInventoryInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartInventory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}}]}}]} as unknown as DocumentNode<MroPartInventoryInfoFragment, unknown>;
export const MroPartSerizaledInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MroPartSerizaledInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroSerializedPart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}}]}}]} as unknown as DocumentNode<MroPartSerizaledInfoFragment, unknown>;
export const MroPartInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MroPartInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"partDescription"}},{"kind":"Field","name":{"kind":"Name","value":"shippingType"}},{"kind":"Field","name":{"kind":"Name","value":"neededDate"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"costPrice"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroSerializedPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartInventory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}}]}}]}}]} as unknown as DocumentNode<MroPartInfoFragment, unknown>;
export const PartDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PartDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPart"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"costPrice"}},{"kind":"Field","name":{"kind":"Name","value":"partDescription"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"neededDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"shippingType"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"trackingInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}}]}}]}}]} as unknown as DocumentNode<PartDetailsFragment, unknown>;
export const LaborDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LaborDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroLaborEntry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}}]}}]}}]} as unknown as DocumentNode<LaborDetailsFragment, unknown>;
export const MroWorkOrderItemDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MroWorkOrderItemDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"enableLogEntry"}},{"kind":"Field","name":{"kind":"Name","value":"logEntry"}},{"kind":"Field","name":{"kind":"Name","value":"isFlatRate"}},{"kind":"Field","name":{"kind":"Name","value":"flatRate"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalPartsBillable"}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborBillable"}},{"kind":"Field","name":{"kind":"Name","value":"totalPartsBillable"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"partDescription"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderSignoffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]}}]} as unknown as DocumentNode<MroWorkOrderItemDetailsFragment, unknown>;
export const CategoryDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CategoryDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItemCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"categoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mroComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]} as unknown as DocumentNode<CategoryDetailsFragment, unknown>;
export const FlightIntervalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"flightInterval"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FlightIntervals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}}]}}]} as unknown as DocumentNode<FlightIntervalFragment, unknown>;
export const FlightInfoFragmentDoc = {"kind":"Document", "definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"flightInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Flight"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flightDate"}},{"kind":"Field","name":{"kind":"Name","value":"route"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icaos"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"flightLog"}},{"kind":"Field","name":{"kind":"Name","value":"purposeName"}},{"kind":"Field","name":{"kind":"Name","value":"isPending"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"soruce"}},{"kind":"Field","name":{"kind":"Name","value":"normalIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flightInterval"}}]}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},...FlightIntervalFragmentDoc.definitions]} as unknown as DocumentNode<FlightInfoFragment, unknown>;
export const PilotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Pilot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<PilotFragment, unknown>;
export const IntervalFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IntervalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Interval"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}}]} as unknown as DocumentNode<IntervalFragmentFragment, unknown>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"redirectToken"}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const SignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Signup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<SignupMutation, SignupMutationVariables>;
export const GetCaslRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaslRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caslRules"}}]}}]} as unknown as DocumentNode<GetCaslRulesQuery, GetCaslRulesQueryVariables>;
export const GetOrgSubtypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrgSubtype"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}}]}}]}}]} as unknown as DocumentNode<GetOrgSubtypeQuery, GetOrgSubtypeQueryVariables>;
export const MainLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MainLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"redirectToken"}}]}}]}}]} as unknown as DocumentNode<MainLoginMutation, MainLoginMutationVariables>;
export const ImpersonateLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImpersonateLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"impersonate"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"redirectToken"}}]}}]}}]} as unknown as DocumentNode<ImpersonateLoginMutation, ImpersonateLoginMutationVariables>;
export const SendResetEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendResetEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPasswordResetEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<SendResetEmailMutation, SendResetEmailMutationVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const NewUserSignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewUserSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<NewUserSignupMutation, NewUserSignupMutationVariables>;
export const HasCompletedWalkthroughDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasCompletedWalkthrough"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasCompletedWalkthrough"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<HasCompletedWalkthroughQuery, HasCompletedWalkthroughQueryVariables>;
export const CompletedWalkthroughDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompletedWalkthrough"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedWalkthrough"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<CompletedWalkthroughMutation, CompletedWalkthroughMutationVariables>;
export const GetInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameInvite"}},{"kind":"Field","name":{"kind":"Name","value":"emailInvite"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetInvitationQuery, GetInvitationQueryVariables>;
export const AcceptInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]} as unknown as DocumentNode<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const GetMigrateInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMigrateInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"migrateInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetMigrateInfoQuery, GetMigrateInfoQueryVariables>;
export const SetupPasswordFromTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetupPasswordFromToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupPasswordFromToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<SetupPasswordFromTokenMutation, SetupPasswordFromTokenMutationVariables>;
export const GetCouponCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCouponCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCouponCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetCouponCodeQuery, GetCouponCodeQueryVariables>;
export const SwitchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SwitchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"switchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>;
export const CheckIfUserHasInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckIfUserHasInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIfUserHasInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<CheckIfUserHasInviteQuery, CheckIfUserHasInviteQueryVariables>;
export const GetMroCraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroCrafts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCraftWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroCraftsQuery, GetMroCraftsQueryVariables>;
export const GetMroCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroCraftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroCraftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroCraftQuery, GetMroCraftQueryVariables>;
export const GetMroLogEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroLogEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLogEntryWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroLogEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"signedAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLogEntryItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroLogEntriesQuery, GetMroLogEntriesQueryVariables>;
export const UpdateMroCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCraftUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroCraftMutation, UpdateMroCraftMutationVariables>;
export const CreateMroCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCraftCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroCraftMutation, CreateMroCraftMutationVariables>;
export const RemoveMroCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroCraftMutation, RemoveMroCraftMutationVariables>;
export const GetTwilioTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetTwilioToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTwilioAccessToken"}}]}}]} as unknown as DocumentNode<GetTwilioTokenMutation, GetTwilioTokenMutationVariables>;
export const CreateCustomerThreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerThread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCommunicationThreadCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroCommunicationThread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"twilioConversationSid"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerThreadMutation, CreateCustomerThreadMutationVariables>;
export const GetCustomerThreadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomerThreads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCommunicationThreadWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCommunicationThreads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"twilioConversationSid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetCustomerThreadsQuery, GetCustomerThreadsQueryVariables>;
export const AddConversationParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddConversationParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddConversationParticipantInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addConversationParticipant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddConversationParticipantMutation, AddConversationParticipantMutationVariables>;
export const LoginForServiceDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginForService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceInfo"}}]}}]}}]}},...ServiceInfoFragmentDoc.definitions]} as unknown as DocumentNode<LoginForServiceMutation, LoginForServiceMutationVariables>;
export const SignupForServiceDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignupForService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceInfo"}}]}}]}}]}},...ServiceInfoFragmentDoc.definitions]} as unknown as DocumentNode<SignupForServiceMutation, SignupForServiceMutationVariables>;
export const GetServiceUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceInfo"}}]}}]}},...ServiceInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetServiceUserQuery, GetServiceUserQueryVariables>;
export const OnboardOrgDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OnboardOrg"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craft"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardCraftInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboardOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"craft"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craft"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"organization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organization"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OnboardInfo"}},{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}},...OnboardInfoFragmentDoc.definitions]} as unknown as DocumentNode<OnboardOrgMutation, OnboardOrgMutationVariables>;
export const CreateCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craft"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craft"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCraftMutation, CreateCraftMutationVariables>;
export const LookupTailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookupTail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tailNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registrations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tailNumber"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"yearMfr"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}},{"kind":"Field","name":{"kind":"Name","value":"onAccount"}},{"kind":"Field","name":{"kind":"Name","value":"engineType"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"model"}}]}}]}}]} as unknown as DocumentNode<LookupTailQuery, LookupTailQueryVariables>;
export const CreateServiceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateServiceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardMroRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroRequstWithRelations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateServiceRequestMutation, CreateServiceRequestMutationVariables>;
export const GetServiceEstimateTokenDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceEstimateToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEstimateWithToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateInfo"}}]}}]}},...EstimateInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetServiceEstimateTokenQuery, GetServiceEstimateTokenQueryVariables>;
export const GetServiceEstimateDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EstimateInfo"}}]}}]}},...EstimateInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetServiceEstimateQuery, GetServiceEstimateQueryVariables>;
export const GetMroOrganizationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganizationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMroOrganizationName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}]}]}}]} as unknown as DocumentNode<GetMroOrganizationNameQuery, GetMroOrganizationNameQueryVariables>;
export const GetMroOrganizationLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganizationLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMroOrganizationLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetMroOrganizationLocationsQuery, GetMroOrganizationLocationsQueryVariables>;
export const UpdateMroEstimateWithTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroEstimateWithToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEstimateWithToken"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroEstimateStatusWithToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateMroEstimateWithTokenMutation, UpdateMroEstimateWithTokenMutationVariables>;
export const GetMroInvoiceWithTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroInvoiceWithToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroInvoiceWithToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"mro"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"laborSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationId"}}]}}]}}]} as unknown as DocumentNode<GetMroInvoiceWithTokenQuery, GetMroInvoiceWithTokenQueryVariables>;
export const GetMroOrganizationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganizationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAuthorization"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<GetMroOrganizationInfoQuery, GetMroOrganizationInfoQueryVariables>;
export const GetPublicMroOrganizationsInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPublicMroOrganizationsInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MroOrganizationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPublicMroOrganizationsInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]} as unknown as DocumentNode<GetPublicMroOrganizationsInfoQuery, GetPublicMroOrganizationsInfoQueryVariables>;
export const GetMroCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCustomerWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroCustomersQuery, GetMroCustomersQueryVariables>;
export const GetMroCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroCustomerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroCustomerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroCustomerQuery, GetMroCustomerQueryVariables>;
export const CreateMroCustomerAndCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroCustomerAndCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardMroCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"onboardMroCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMroCustomerAndCraftMutation, CreateMroCustomerAndCraftMutationVariables>;
export const AddMemberToMroCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddMemberToMroCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddContactToMroCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addContactToMroCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<AddMemberToMroCustomerMutation, AddMemberToMroCustomerMutationVariables>;
export const GetMroInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroInvoiceWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"mro"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"laborSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}}]}}]}}]} as unknown as DocumentNode<GetMroInvoicesQuery, GetMroInvoicesQueryVariables>;
export const AddCraftToMroCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCraftToMroCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCraftToMroCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCraftToMroCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}}]}}]}}]} as unknown as DocumentNode<AddCraftToMroCustomerMutation, AddCraftToMroCustomerMutationVariables>;
export const UpdateMroCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCustomerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMroCustomerMutation, UpdateMroCustomerMutationVariables>;
export const RemoveMroCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroCustomerMutation, RemoveMroCustomerMutationVariables>;
export const GetPendingPartRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPendingPartRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrderItem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"AWAITING_APPROVAL","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"neededDate"}},{"kind":"Field","name":{"kind":"Name","value":"shippingType"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPendingPartRequestsQuery, GetPendingPartRequestsQueryVariables>;
export const GetDueSoonWorkOrdersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDueSoonWorkOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"StringValue","value":"CLOSED","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroDashboardWorkOrder"}}]}}]}},...MroDashboardWorkOrderFragmentDoc.definitions]} as unknown as DocumentNode<GetDueSoonWorkOrdersQuery, GetDueSoonWorkOrdersQueryVariables>;
export const GetMroLaborEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroLaborEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrderItem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"startTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroLaborEntriesQuery, GetMroLaborEntriesQueryVariables>;
export const GetDashboardBadgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardBadges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"CLOSED","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroServiceRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"OPEN","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"NullValue"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"endTime"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrderItem"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"AWAITING_APPROVAL","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetDashboardBadgesQuery, GetDashboardBadgesQueryVariables>;
export const StartTimerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartTimer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employeeProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startTimer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employeeProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employeeProfileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"workOrderItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderItemId"}}},{"kind":"Argument","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}}]} as unknown as DocumentNode<StartTimerMutation, StartTimerMutationVariables>;
export const StopTimerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StopTimer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"laborEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopTimer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mroLaborEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"laborEntryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}}]}}]}}]} as unknown as DocumentNode<StopTimerMutation, StopTimerMutationVariables>;
export const ResumeTimerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResumeTimer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"laborEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resumeTimer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mroLaborEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"laborEntryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}}]}}]}}]} as unknown as DocumentNode<ResumeTimerMutation, ResumeTimerMutationVariables>;
export const PauseTimerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PauseTimer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"laborEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pauseTimer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mroLaborEntryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"laborEntryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}}]}}]}}]} as unknown as DocumentNode<PauseTimerMutation, PauseTimerMutationVariables>;
export const GetMroDashboardDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignees"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"IN_PROGRESS","block":false}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroDashboardTaskDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"currentLaborEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"CLOSED","block":false},{"kind":"StringValue","value":"COMPLETED","block":false}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignees"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroDashboardWorkOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}},...MroDashboardTaskDetailsFragmentDoc.definitions,...MroDashboardWorkOrderFragmentDoc.definitions]} as unknown as DocumentNode<GetMroDashboardQuery, GetMroDashboardQueryVariables>;
export const GetMroDashboardOrdersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroDashboardOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"IN_PROGRESS","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroDashboardWorkOrder"}}]}}]}},...MroDashboardWorkOrderFragmentDoc.definitions]} as unknown as DocumentNode<GetMroDashboardOrdersQuery, GetMroDashboardOrdersQueryVariables>;
export const GetFullTaskDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFullTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroDashboardTaskDetails"}}]}}]}},...MroDashboardTaskDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetFullTaskQuery, GetFullTaskQueryVariables>;
export const GetDashboardOrdersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"CLOSED","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardWorkOrder"}}]}}]}},...DashboardWorkOrderFragmentDoc.definitions]} as unknown as DocumentNode<GetDashboardOrdersQuery, GetDashboardOrdersQueryVariables>;
export const GetMroEmployeeDashboardDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroEmployeeDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assignees"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"CLOSED","block":false},{"kind":"StringValue","value":"COMPLETED","block":false}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TaskDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"currentLaborEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"CLOSED","block":false},{"kind":"StringValue","value":"COMPLETED","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardWorkOrder"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"pauseTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}},...TaskDetailsFragmentDoc.definitions,...DashboardWorkOrderFragmentDoc.definitions]} as unknown as DocumentNode<GetMroEmployeeDashboardQuery, GetMroEmployeeDashboardQueryVariables>;
export const GetMroEmployeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroEmployees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"accountSetup"}},{"kind":"Field","name":{"kind":"Name","value":"latestActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroEmployeesQuery, GetMroEmployeesQueryVariables>;
export const GetMroEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}},{"kind":"Field","name":{"kind":"Name","value":"airmenLicense"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"accountSetup"}},{"kind":"Field","name":{"kind":"Name","value":"inviteLink"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"latestActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroEmployeeQuery, GetMroEmployeeQueryVariables>;
export const UpdateMroEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroEmployeeProfileUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroEmployeeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroEmployeeMutation, UpdateMroEmployeeMutationVariables>;
export const RemoveMroEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroEmployeeProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroEmployeeMutation, RemoveMroEmployeeMutationVariables>;
export const CreateMroEmployeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroEmployee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroEmployeeProfileCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroEmployeeProfileAndUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateMroEmployeeMutation, CreateMroEmployeeMutationVariables>;
export const GetMroPartVariantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartVariants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"variantsLeft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variantsRight"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartVariantsQuery, GetMroPartVariantsQueryVariables>;
export const GetMroPartInventoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartInventories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartInventoryWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartInventories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartInventoriesQuery, GetMroPartInventoriesQueryVariables>;
export const GetMroPartInventoryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroPartInventoryInfo"}}]}}]}},...MroPartInventoryInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetMroPartInventoryQuery, GetMroPartInventoryQueryVariables>;
export const UpdateMroPartInventoryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroPartInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartInventoryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroPartInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroPartInventoryInfo"}}]}}]}},...MroPartInventoryInfoFragmentDoc.definitions]} as unknown as DocumentNode<UpdateMroPartInventoryMutation, UpdateMroPartInventoryMutationVariables>;
export const CreatePartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAndUpdateWoPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreatePartMutation, CreatePartMutationVariables>;
export const CreateInventoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createInventory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartInventoryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroPartInventory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateInventoryMutation, CreateInventoryMutationVariables>;
export const GetMroPartRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPartWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"partDescription"}},{"kind":"Field","name":{"kind":"Name","value":"neededDate"}},{"kind":"Field","name":{"kind":"Name","value":"shippingType"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requester"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartRequestsQuery, GetMroPartRequestsQueryVariables>;
export const GetMroPartOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartOrderWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"trackingInfo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartOrdersQuery, GetMroPartOrdersQueryVariables>;
export const GetMroWorkOrderPartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderParts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPartWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderPartsQuery, GetMroWorkOrderPartsQueryVariables>;
export const GetMroPartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroParts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"availablePartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableSerializedParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroSerializedParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<GetMroPartsQuery, GetMroPartsQueryVariables>;
export const GetMroSerilizedPartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroSerilizedParts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroSerializedPartWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroSerializedParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"coreCost"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroSerilizedPartsQuery, GetMroSerilizedPartsQueryVariables>;
export const GetMroSerilizedPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroSerilizedPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroSerializedPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"coreCost"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroSerilizedPartQuery, GetMroSerilizedPartQueryVariables>;
export const GetMroPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"preferred"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartQuery, GetMroPartQueryVariables>;
export const GetMroPartRequestDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partRequestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partRequestId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroPartInfo"}}]}}]}},...MroPartInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetMroPartRequestQuery, GetMroPartRequestQueryVariables>;
export const UpdateMroPartRequestDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroPartRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPartUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroPartInfo"}}]}}]}},...MroPartInfoFragmentDoc.definitions]} as unknown as DocumentNode<UpdateMroPartRequestMutation, UpdateMroPartRequestMutationVariables>;
export const FulfillRequestDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FulfillRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPartUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fulfillRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroPartInfo"}}]}}]}},...MroPartInfoFragmentDoc.definitions]} as unknown as DocumentNode<FulfillRequestMutation, FulfillRequestMutationVariables>;
export const GetMroPartWarehouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartWarehouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartWarehouseWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetMroPartWarehouseQuery, GetMroPartWarehouseQueryVariables>;
export const UpdateMroPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}}]}}]}}]} as unknown as DocumentNode<UpdateMroPartMutation, UpdateMroPartMutationVariables>;
export const CreateSerializedPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSerializedPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroSerializedPartCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroSerializedPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSerializedPartMutation, CreateSerializedPartMutationVariables>;
export const CreateMroSerializedPartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMroSerializedParts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSerializedPartsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroSerializedParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMroSerializedPartsMutation, CreateMroSerializedPartsMutationVariables>;
export const UpdateSerializedPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSerializedPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroSerializedPartUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroSerializedPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}}]}}]}}]} as unknown as DocumentNode<UpdateSerializedPartMutation, UpdateSerializedPartMutationVariables>;
export const CreateMroPartOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMroPartOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartOrderCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroPartOrderAndChangeWOPartStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroPartOrderMutation, CreateMroPartOrderMutationVariables>;
export const UpdateMroPartOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMroPartOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartOrderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroPartOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroPartOrderMutation, UpdateMroPartOrderMutationVariables>;
export const UpdateMroPartOrderAndChangeWoPartStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMroPartOrderAndChangeWOPartStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartOrderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroPartOrderAndChangeWOPartStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroPartOrderAndChangeWoPartStatusMutation, UpdateMroPartOrderAndChangeWoPartStatusMutationVariables>;
export const UpdateMroPartOrderItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMroPartOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartOrderItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroPartOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroPartOrderItemMutation, UpdateMroPartOrderItemMutationVariables>;
export const GetMroPartOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}},{"kind":"Field","name":{"kind":"Name","value":"issuedDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"trackingInfo"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartVendor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vendorCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePicture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPartOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"requestedDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartOrderQuery, GetMroPartOrderQueryVariables>;
export const GetMroPartAndInventoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartAndInventories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partNumber"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedCost"}},{"kind":"Field","name":{"kind":"Name","value":"isSerialized"}},{"kind":"Field","name":{"kind":"Name","value":"availableSerializedParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePartInventories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartWarehouse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bin"}},{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"condition"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartAndInventoriesQuery, GetMroPartAndInventoriesQueryVariables>;
export const GetLastPartOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastPartOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastPartOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mroOrgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderNumber"}}]}}]}}]} as unknown as DocumentNode<GetLastPartOrderQuery, GetLastPartOrderQueryVariables>;
export const GetMroPartVendorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartVendors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartVendorWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartVendors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"vendorCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroPartVendorsQuery, GetMroPartVendorsQueryVariables>;
export const GetMroPartManufacturersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroPartManufacturers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartManufacturerWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroPartManufacturers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetMroPartManufacturersQuery, GetMroPartManufacturersQueryVariables>;
export const GetMroOrgnizationPartPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrgnizationPartPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroPartPriceMatrix"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"partMatrix"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroOrgnizationPartPriceQuery, GetMroOrgnizationPartPriceQueryVariables>;
export const GetMroReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MroReportWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetMroReportsQuery, GetMroReportsQueryVariables>;
export const GetMroReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetMroReportQuery, GetMroReportQueryVariables>;
export const GetMroReportTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroReportTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportTypes"}}]}}]} as unknown as DocumentNode<GetMroReportTypesQuery, GetMroReportTypesQueryVariables>;
export const CreateMroReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroReportCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroReportMutation, CreateMroReportMutationVariables>;
export const UpdateMroReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroReportUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroReportMutation, UpdateMroReportMutationVariables>;
export const GetServiceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroServiceRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"craftServiceRequests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetServiceRequestQuery, GetServiceRequestQueryVariables>;
export const GetServiceRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroServiceRequestWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroServiceRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>;
export const UpdateServiceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateServiceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroServiceRequestUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroServiceRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>;
export const GetMroRoleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroRoleData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caslRules"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroActions"}}]}}]} as unknown as DocumentNode<GetMroRoleDataQuery, GetMroRoleDataQueryVariables>;
export const GetMroCaslRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroCaslRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caslRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgType"},"value":{"kind":"StringValue","value":"PART145","block":false}}]}]}}]} as unknown as DocumentNode<GetMroCaslRulesQuery, GetMroCaslRulesQueryVariables>;
export const UpdateMroRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroRoleUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caslRules"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UpdateMroRoleMutation, UpdateMroRoleMutationVariables>;
export const CreateMroRoleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroRoleCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caslRules"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<CreateMroRoleMutation, CreateMroRoleMutationVariables>;
export const GetMroRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caslRules"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroRolesQuery, GetMroRolesQueryVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changePassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"oldPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oldPassword"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const GetMroWorkOrderTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"templateData"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderTemplatesQuery, GetMroWorkOrderTemplatesQueryVariables>;
export const UpdateMroWorkOrderTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderTemplateUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroWorkOrderTemplateMutation, UpdateMroWorkOrderTemplateMutationVariables>;
export const RemoveMroWorkOrderTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroWorkOrderTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroWorkOrderTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroWorkOrderTemplateMutation, RemoveMroWorkOrderTemplateMutationVariables>;
export const GetMroOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"defaultBillableRate"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCostRate"}},{"kind":"Field","name":{"kind":"Name","value":"estimateAuthorization"}}]}}]}}]} as unknown as DocumentNode<GetMroOrganizationQuery, GetMroOrganizationQueryVariables>;
export const UpdateOrganizationIconDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganizationIcon"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"colorIconId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blackIconId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganizationIcon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"colorIconId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"colorIconId"}}},{"kind":"Argument","name":{"kind":"Name","value":"blackIconId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blackIconId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationIconMutation, UpdateOrganizationIconMutationVariables>;
export const UpdateMroOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroOrganizationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroOrganizationMutation, UpdateMroOrganizationMutationVariables>;
export const CreateMroPartWarehouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroPartWarehouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartWarehouseCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroPartWarehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroPartWarehouseMutation, CreateMroPartWarehouseMutationVariables>;
export const UpdateMroPartWarehouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroPartWarehouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroPartWarehouseUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroPartWarehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroPartWarehouseMutation, UpdateMroPartWarehouseMutationVariables>;
export const RemoveMroPartWarehouseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroPartWarehouse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroPartWarehouse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroPartWarehouseMutation, RemoveMroPartWarehouseMutationVariables>;
export const GetMroOrganizationIconsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganizationIcons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroColorIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroBlackAndWhiteIcon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroOrganizationIconsQuery, GetMroOrganizationIconsQueryVariables>;
export const UpdateMroLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLocationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroLocationMutation, UpdateMroLocationMutationVariables>;
export const CreateMroLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLocationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroLocationMutation, CreateMroLocationMutationVariables>;
export const RemoveMroLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroLocationMutation, RemoveMroLocationMutationVariables>;
export const GetMroRtsTextsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroRTSTexts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroRTSTexts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<GetMroRtsTextsQuery, GetMroRtsTextsQueryVariables>;
export const GetMroRtsTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroRTSText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroRTSText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]} as unknown as DocumentNode<GetMroRtsTextQuery, GetMroRtsTextQueryVariables>;
export const CreateMroRtsTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroRTSText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroRTSTextCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroRTSText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroRtsTextMutation, CreateMroRtsTextMutationVariables>;
export const UpdateMroRtsTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroRTSText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroRTSTextUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroRTSText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroRtsTextMutation, UpdateMroRtsTextMutationVariables>;
export const RemoveMroRtsTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroRTSText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroRTSText"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroRtsTextMutation, RemoveMroRtsTextMutationVariables>;
export const GetMroOrganizationFeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganizationFees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationFees"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"isPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"billableType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"onByDefault"}}]}}]}}]} as unknown as DocumentNode<GetMroOrganizationFeesQuery, GetMroOrganizationFeesQueryVariables>;
export const GetMroOrganizationFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroOrganizationFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"isPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"billableType"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"onByDefault"}}]}}]}}]} as unknown as DocumentNode<GetMroOrganizationFeeQuery, GetMroOrganizationFeeQueryVariables>;
export const CreateMroOrganizationFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroOrganizationFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroOrganizationFeeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroOrganizationFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroOrganizationFeeMutation, CreateMroOrganizationFeeMutationVariables>;
export const UpdateMroOrganizationFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroOrganizationFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroOrganizationFeeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroOrganizationFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroOrganizationFeeMutation, UpdateMroOrganizationFeeMutationVariables>;
export const RemoveMroOrganizationFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroOrganizationFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroOrganizationFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroOrganizationFeeMutation, RemoveMroOrganizationFeeMutationVariables>;
export const NewOrderCraftLookupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewOrderCraftLookup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tailNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}}]}}]}}]} as unknown as DocumentNode<NewOrderCraftLookupQuery, NewOrderCraftLookupQueryVariables>;
export const NewOrderCreateCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewOrderCreateCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCraftCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}}]}}]}}]} as unknown as DocumentNode<NewOrderCreateCraftMutation, NewOrderCreateCraftMutationVariables>;
export const CreateWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMroWorkOrderFromTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderFromTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}}]}}]}}]} as unknown as DocumentNode<CreateWorkOrderMutation, CreateWorkOrderMutationVariables>;
export const NewOrderCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewOrderCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tailNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"mroCrafts"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tailNumber"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tailNumber"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deletedAt"},"value":{"kind":"NullValue"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"engineCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<NewOrderCustomersQuery, NewOrderCustomersQueryVariables>;
export const NewOrderEmployeesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewOrderEmployees"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]} as unknown as DocumentNode<NewOrderEmployeesQuery, NewOrderEmployeesQueryVariables>;
export const MroCustomerLookupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MroCustomerLookup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroCustomerWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCrafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<MroCustomerLookupQuery, MroCustomerLookupQueryVariables>;
export const MroWorkOrderTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MroWorkOrderTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<MroWorkOrderTemplatesQuery, MroWorkOrderTemplatesQueryVariables>;
export const GetMroComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroCraftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroComponents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroCraftId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroCraftId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItemCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroComponentsQuery, GetMroComponentsQueryVariables>;
export const LastEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mroOrgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"estimateNumber"}}]}}]}}]} as unknown as DocumentNode<LastEstimateQuery, LastEstimateQueryVariables>;
export const SendEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"emails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}]}]}}]} as unknown as DocumentNode<SendEstimateMutation, SendEstimateMutationVariables>;
export const CreateMroEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroEstimateCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEstimateNum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"}}]}}]}}]} as unknown as DocumentNode<CreateMroEstimateMutation, CreateMroEstimateMutationVariables>;
export const GetMroEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateNumber"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"laborSummary"}},{"kind":"Field","name":{"kind":"Name","value":"authorizedTotal"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"customerNotes"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroEstimateQuery, GetMroEstimateQueryVariables>;
export const UpdateMroEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroEstimateUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroEstimateMutation, UpdateMroEstimateMutationVariables>;
export const GetMroWorkOrderIntervalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderIntervals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderIntervalWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderIntervals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderIntervalsQuery, GetMroWorkOrderIntervalsQueryVariables>;
export const GetMroWorkOrderIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderIntervalQuery, GetMroWorkOrderIntervalQueryVariables>;
export const CreateMroWorkOrderIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroWorkOrderInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderIntervalCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroWorkOrderIntervalMutation, CreateMroWorkOrderIntervalMutationVariables>;
export const UpdateMroWorkOrderIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderIntervalUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroWorkOrderIntervalMutation, UpdateMroWorkOrderIntervalMutationVariables>;
export const DeleteMroWorkOrderIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMroWorkOrderInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroWorkOrderInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMroWorkOrderIntervalMutation, DeleteMroWorkOrderIntervalMutationVariables>;
export const GetMroInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroInvoiceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroInvoiceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"mro"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"laborSummary"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationId"}}]}}]}}]} as unknown as DocumentNode<GetMroInvoiceQuery, GetMroInvoiceQueryVariables>;
export const UpdateMroInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroInvoiceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroInvoiceMutation, UpdateMroInvoiceMutationVariables>;
export const LastInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mroOrgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrgId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}}]}}]}}]} as unknown as DocumentNode<LastInvoiceQuery, LastInvoiceQueryVariables>;
export const SendInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"emails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}]}]}}]} as unknown as DocumentNode<SendInvoiceMutation, SendInvoiceMutationVariables>;
export const GetOrganizationRateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationRate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationRateQuery, GetOrganizationRateQueryVariables>;
export const CreateMroInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroInvoiceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"mro"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"laborSummary"}}]}}]}}]} as unknown as DocumentNode<CreateMroInvoiceMutation, CreateMroInvoiceMutationVariables>;
export const UpdateInvoiceStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInvoiceStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInvoiceStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}]}}]} as unknown as DocumentNode<UpdateInvoiceStatusMutation, UpdateInvoiceStatusMutationVariables>;
export const GetWorkOrderBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"mro"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"discounts"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"laborSummary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroEstimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateNumber"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderBillingQuery, GetWorkOrderBillingQueryVariables>;
export const GetWorkOrderLogEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkOrderLogEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroWorkOrderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroLogEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"signedAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"itemCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLogEntryItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkOrderLogEntriesQuery, GetWorkOrderLogEntriesQueryVariables>;
export const UpdateMroLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLogEntryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroLogEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroLogEntryMutation, UpdateMroLogEntryMutationVariables>;
export const CreateMroLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLogEntryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroLogEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroLogEntryMutation, CreateMroLogEntryMutationVariables>;
export const GetMroLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroLogEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroLogEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroLogEntryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"certificationText"}},{"kind":"Field","name":{"kind":"Name","value":"signedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"signer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"categoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logEntry"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLogEntryItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMroLogEntryQuery, GetMroLogEntryQueryVariables>;
export const GetMroWorkOrderDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"primaryConcern"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroWorkOrderItemDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"itemCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryDetails"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroWorkOrderItemDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroServiceRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"mroCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"mroContacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumbers"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},...MroWorkOrderItemDetailsFragmentDoc.definitions,...CategoryDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetMroWorkOrderQuery, GetMroWorkOrderQueryVariables>;
export const GetMroWorkOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"workOrderNum"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalDate"}},{"kind":"Field","name":{"kind":"Name","value":"promiseDate"}},{"kind":"Field","name":{"kind":"Name","value":"mroLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"ownerName"}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAssignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrdersQuery, GetMroWorkOrdersQueryVariables>;
export const UpdateMroWorkOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMroWorkOrderWithContactInfo"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderWithContactInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroWorkOrderMutation, UpdateMroWorkOrderMutationVariables>;
export const GetMroWorkOrderItemDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isEstimate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"parentId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isFlatRate"}},{"kind":"Field","name":{"kind":"Name","value":"flatRate"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalLaborHours"}},{"kind":"Field","name":{"kind":"Name","value":"assignees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaborDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderParts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderSignoffs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pin"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enableLogEntry"}},{"kind":"Field","name":{"kind":"Name","value":"logEntry"}}]}}]}},...LaborDetailsFragmentDoc.definitions,...PartDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetMroWorkOrderItemQuery, GetMroWorkOrderItemQueryVariables>;
export const GetMroWorkOrderPartDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartDetails"}}]}}]}},...PartDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetMroWorkOrderPartQuery, GetMroWorkOrderPartQueryVariables>;
export const GetMroLaborEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroLaborEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroLaborEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaborDetails"}}]}}]}},...LaborDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetMroLaborEntryQuery, GetMroLaborEntryQueryVariables>;
export const UpdateMroWorkOrderPartDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPartUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartDetails"}}]}}]}},...PartDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateMroWorkOrderPartMutation, UpdateMroWorkOrderPartMutationVariables>;
export const UpdateMroWorkOrderPartStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderPartStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requesterId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderPartStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requester"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requesterId"}}}]}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateMroWorkOrderPartStatusMutation, UpdateMroWorkOrderPartStatusMutationVariables>;
export const CreateMroWorkOrderPartDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroWorkOrderPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderPartCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PartDetails"}}]}}]}},...PartDetailsFragmentDoc.definitions]} as unknown as DocumentNode<CreateMroWorkOrderPartMutation, CreateMroWorkOrderPartMutationVariables>;
export const RemoveMroWorkOrderPartDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroWorkOrderPart"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroWorkOrderPart"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveMroWorkOrderPartMutation, RemoveMroWorkOrderPartMutationVariables>;
export const UpdateMroLaborEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroLaborEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLaborEntryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroLaborEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaborDetails"}}]}}]}},...LaborDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateMroLaborEntryMutation, UpdateMroLaborEntryMutationVariables>;
export const UpdateMroWorkOrderItemDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWorkOrderItemAndNumbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroWorkOrderItemDetails"}}]}}]}},...MroWorkOrderItemDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateMroWorkOrderItemMutation, UpdateMroWorkOrderItemMutationVariables>;
export const GetMroEmployeeProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroEmployeeProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroEmployeeProfileWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroEmployeeProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"profileColor"}},{"kind":"Field","name":{"kind":"Name","value":"profilePictureId"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"costRate"}},{"kind":"Field","name":{"kind":"Name","value":"billableRate"}}]}}]}}]} as unknown as DocumentNode<GetMroEmployeeProfilesQuery, GetMroEmployeeProfilesQueryVariables>;
export const CreateMroWorkOrderItemDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroWorkOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderItemWithNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MroWorkOrderItemDetails"}}]}}]}},...MroWorkOrderItemDetailsFragmentDoc.definitions]} as unknown as DocumentNode<CreateMroWorkOrderItemMutation, CreateMroWorkOrderItemMutationVariables>;
export const CreateMroLaborEntryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroLaborEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLaborEntryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroLaborEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LaborDetails"}}]}}]}},...LaborDetailsFragmentDoc.definitions]} as unknown as DocumentNode<CreateMroLaborEntryMutation, CreateMroLaborEntryMutationVariables>;
export const GetItemCategoriesDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetItemCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItemCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroWorkOrderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workOrderId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryDetails"}}]}}]}},...CategoryDetailsFragmentDoc.definitions]} as unknown as DocumentNode<GetItemCategoriesQuery, GetItemCategoriesQueryVariables>;
export const CreateCategoryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItemCategoryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderItemCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryDetails"}}]}}]}},...CategoryDetailsFragmentDoc.definitions]} as unknown as DocumentNode<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderItemCategoryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderItemCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CategoryDetails"}}]}}]}},...CategoryDetailsFragmentDoc.definitions]} as unknown as DocumentNode<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const DeleteCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroWorkOrderItemCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const CreateWorkOrderTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWorkOrderTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateWorkOrderTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreateWorkOrderTemplateMutation, CreateWorkOrderTemplateMutationVariables>;
export const UpdateMroWorkOrderSignoffStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderSignoffStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeProfileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSignoffStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"mroEmployeeProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroEmployeeProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroWorkOrderSignoffStatusMutation, UpdateMroWorkOrderSignoffStatusMutationVariables>;
export const GetCategoryDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategoryDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderItemCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"categoryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"mroComponent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroCraft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mroComponents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoryDetailsQuery, GetCategoryDetailsQueryVariables>;
export const GetLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroLocationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetLocationsQuery, GetLocationsQueryVariables>;
export const UpdateWoStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWOStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateWoStatusMutation, UpdateWoStatusMutationVariables>;
export const RequestAllWorkOrderItemsPartsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestAllWorkOrderItemsParts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestAllWorkOrderItemsParts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RequestAllWorkOrderItemsPartsMutation, RequestAllWorkOrderItemsPartsMutationVariables>;
export const GetMroWorkOrderBillingItemsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderBillingItems"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderBillingItemWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderBillingItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"billableType"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderBillingItemsQuery, GetMroWorkOrderBillingItemsQueryVariables>;
export const GetMroWorkOrderBillingItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderBillingItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderBillingItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"isDiscount"}},{"kind":"Field","name":{"kind":"Name","value":"billableType"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderBillingItemQuery, GetMroWorkOrderBillingItemQueryVariables>;
export const UpdateMroWorkOrderBillingItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroWorkOrderBillingItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderBillingItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroWorkOrderBillingItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroWorkOrderBillingItemMutation, UpdateMroWorkOrderBillingItemMutationVariables>;
export const CreateMroWorkOrderBillingItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMroWorkOrderBillingItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderBillingItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMroWorkOrderBillingItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMroWorkOrderBillingItemMutation, CreateMroWorkOrderBillingItemMutationVariables>;
export const DeleteMroWorkOrderBillingItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMroWorkOrderBillingItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroWorkOrderBillingItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMroWorkOrderBillingItemMutation, DeleteMroWorkOrderBillingItemMutationVariables>;
export const GetMroWorkOrderCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMroWorkOrderCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroWorkOrderCategoryWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroWorkOrderCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"workType"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]} as unknown as DocumentNode<GetMroWorkOrderCategoriesQuery, GetMroWorkOrderCategoriesQueryVariables>;
export const DeleteMroWorkOrderItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMroWorkOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWorkOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMroWorkOrderItemMutation, DeleteMroWorkOrderItemMutationVariables>;
export const UpdateMroComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMroComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MroComponentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMroComponent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMroComponentMutation, UpdateMroComponentMutationVariables>;
export const RemoveMroComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMroComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMroComponent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveMroComponentMutation, RemoveMroComponentMutationVariables>;
export const GetCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"squawksWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SquawkWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}},{"kind":"Field","name":{"kind":"Name","value":"usageRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"fuelUnit"}},{"kind":"Field","name":{"kind":"Name","value":"oilUnit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"regAddress"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"year"}},{"kind":"Field","name":{"kind":"Name","value":"homeBase"}},{"kind":"Field","name":{"kind":"Name","value":"fuelCapacity"}},{"kind":"Field","name":{"kind":"Name","value":"isAirworthy"}},{"kind":"Field","name":{"kind":"Name","value":"fuelAmount"}},{"kind":"Field","name":{"kind":"Name","value":"squawks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"squawksWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inspections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"almostDue"}},{"kind":"Field","name":{"kind":"Name","value":"due"}}]}},{"kind":"Field","name":{"kind":"Name","value":"components"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextReservation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"pilot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentReservation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"pilot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCraftQuery, GetCraftQueryVariables>;
export const UpdateCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCraftInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateCraftInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCraftInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"fuelUnit"}},{"kind":"Field","name":{"kind":"Name","value":"oilUnit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"regAddress"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"fuelCapacity"}}]}}]}}]} as unknown as DocumentNode<UpdateCraftMutation, UpdateCraftMutationVariables>;
export const RemoveCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveCraftMutation, RemoveCraftMutationVariables>;
export const CreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const GetDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentsQuery, GetDocumentsQueryVariables>;
export const GetDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"favorite"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentQuery, GetDocumentQueryVariables>;
export const UpdateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const RemoveDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveDocumentMutation, RemoveDocumentMutationVariables>;
export const GetIntervalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIntervals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intervals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"craftId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}}]}}]} as unknown as DocumentNode<GetIntervalsQuery, GetIntervalsQueryVariables>;
export const GetIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}}]}}]}}]} as unknown as DocumentNode<GetIntervalQuery, GetIntervalQueryVariables>;
export const RemoveIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveIntervalMutation, RemoveIntervalMutationVariables>;
export const UpdateIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}}]}}]}}]} as unknown as DocumentNode<UpdateIntervalMutation, UpdateIntervalMutationVariables>;
export const CreateIntervalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInterval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInterval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}}]}}]}}]} as unknown as DocumentNode<CreateIntervalMutation, CreateIntervalMutationVariables>;
export const GetLogbooksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLogbooks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logBooks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"craftId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"totalEntries"}},{"kind":"Field","name":{"kind":"Name","value":"lastEntry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"logDate"}}]}}]}}]}}]} as unknown as DocumentNode<GetLogbooksQuery, GetLogbooksQueryVariables>;
export const CreateLogBookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLogBook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogBookCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLogBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateLogBookMutation, CreateLogBookMutationVariables>;
export const UpdateLogBookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLogBook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogBookUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLogBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLogBookMutation, UpdateLogBookMutationVariables>;
export const DeleteLogBookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLogBook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeLogBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLogBookMutation, DeleteLogBookMutationVariables>;
export const GetLogbookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLogbook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logBookId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logBookId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"components"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logDate"}},{"kind":"Field","name":{"kind":"Name","value":"signedOffBy"}}]}}]}}]}}]} as unknown as DocumentNode<GetLogbookQuery, GetLogbookQueryVariables>;
export const GetJascCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetJascCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jascCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"jascSystems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetJascCategoriesQuery, GetJascCategoriesQueryVariables>;
export const CreateLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLogEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logDate"}}]}}]}}]} as unknown as DocumentNode<CreateLogEntryMutation, CreateLogEntryMutationVariables>;
export const UpdateLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogEntryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLogEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLogEntryMutation, UpdateLogEntryMutationVariables>;
export const DeleteLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeLogEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLogEntryMutation, DeleteLogEntryMutationVariables>;
export const GetLogEntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLogEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logEntryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logEntryId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"logDate"}},{"kind":"Field","name":{"kind":"Name","value":"intervalValues"}},{"kind":"Field","name":{"kind":"Name","value":"signedOffBy"}},{"kind":"Field","name":{"kind":"Name","value":"signedOffAt"}},{"kind":"Field","name":{"kind":"Name","value":"signOffInfo"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logBook"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"systemsAffected"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<GetLogEntryQuery, GetLogEntryQueryVariables>;
export const GetMaintenanceRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenanceRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenanceRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"craftId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftId"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetMaintenanceRecordsQuery, GetMaintenanceRecordsQueryVariables>;
export const GetRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CraftServiceRequestWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craftServiceRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationPhone"}}]}}]}}]} as unknown as DocumentNode<GetRequestsQuery, GetRequestsQueryVariables>;
export const GetRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craftServiceRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationName"}},{"kind":"Field","name":{"kind":"Name","value":"mroOrganizationPhone"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTokens"}},{"kind":"Field","name":{"kind":"Name","value":"estimates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"estimateNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"priceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pdfLink"}}]}}]}}]}}]} as unknown as DocumentNode<GetRequestQuery, GetRequestQueryVariables>;
export const GetComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"craftId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"squawks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetComponentsQuery, GetComponentsQueryVariables>;
export const UpdateComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComponent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateComponentMutation, UpdateComponentMutationVariables>;
export const CreateComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComponentCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComponent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateComponentMutation, CreateComponentMutationVariables>;
export const RemoveComponentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveComponent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeComponent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveComponentMutation, RemoveComponentMutationVariables>;
export const GetSquawksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSquawks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SquawkWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"squawks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"systemsAffected"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"components"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"craftId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetSquawksQuery, GetSquawksQueryVariables>;
export const GetSquawkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSquawk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"squawk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"systemsAffected"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"severityStatus"}},{"kind":"Field","name":{"kind":"Name","value":"performedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"component"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}}]}}]}}]} as unknown as DocumentNode<GetSquawkQuery, GetSquawkQueryVariables>;
export const UpdateSquawkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSquawk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SquawkUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSquawkAndSendUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSquawkMutation, UpdateSquawkMutationVariables>;
export const CreateSquawkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSquawk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSquawkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSquawkWithNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSquawkMutation, CreateSquawkMutationVariables>;
export const DeleteSquawkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSquawk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSquawk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSquawkMutation, DeleteSquawkMutationVariables>;
export const GetMaintenanceRecordSquawkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenanceRecordSquawk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenanceRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"intervalValues"}},{"kind":"Field","name":{"kind":"Name","value":"severityStatus"}},{"kind":"Field","name":{"kind":"Name","value":"squawks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"performedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<GetMaintenanceRecordSquawkQuery, GetMaintenanceRecordSquawkQueryVariables>;
export const GetInspectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInspections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"inspections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"due"}},{"kind":"Field","name":{"kind":"Name","value":"almostDue"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastPerformed"}},{"kind":"Field","name":{"kind":"Name","value":"lastPerformedInterval"}},{"kind":"Field","name":{"kind":"Name","value":"nextDueText"}},{"kind":"Field","name":{"kind":"Name","value":"nextDuePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"doesRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"airworthinessItem"}},{"kind":"Field","name":{"kind":"Name","value":"dueMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amountLeft"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"newestInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInspectionsQuery, GetInspectionsQueryVariables>;
export const GetIntervalsForCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIntervalsForCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"normalIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIntervalsForCraftQuery, GetIntervalsForCraftQueryVariables>;
export const GetIntervalsAndLogbooksForCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIntervalsAndLogbooksForCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"normalIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logBooks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetIntervalsAndLogbooksForCraftQuery, GetIntervalsAndLogbooksForCraftQueryVariables>;
export const GetInspectionGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInspectionGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inspectionGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]} as unknown as DocumentNode<GetInspectionGroupQuery, GetInspectionGroupQueryVariables>;
export const GetInspectionGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInspectionGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectionGroupWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectionGroupOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inspectionGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}}]} as unknown as DocumentNode<GetInspectionGroupsQuery, GetInspectionGroupsQueryVariables>;
export const CreateInspectionGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInspectionGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectionGroupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroupWithPosition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateInspectionGroupMutation, CreateInspectionGroupMutationVariables>;
export const UpdateInspectionGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInspectionGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectionGroupUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInspectionGroupWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateInspectionGroupMutation, UpdateInspectionGroupMutationVariables>;
export const DeleteInspectionGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInspectionGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInspectionGroupWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteInspectionGroupMutation, DeleteInspectionGroupMutationVariables>;
export const GetAdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetADS"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adsForCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adNumber"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"models"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<GetAdsQuery, GetAdsQueryVariables>;
export const GetInspectionFreeLimitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInspectionFreeLimit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionFreeLimit"}}]}}]}}]} as unknown as DocumentNode<GetInspectionFreeLimitQuery, GetInspectionFreeLimitQueryVariables>;
export const GetInspectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInspection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inspection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"due"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"dueMethod"}},{"kind":"Field","name":{"kind":"Name","value":"lastPerformed"}},{"kind":"Field","name":{"kind":"Name","value":"lastPerformedInterval"}},{"kind":"Field","name":{"kind":"Name","value":"airworthinessItem"}},{"kind":"Field","name":{"kind":"Name","value":"nextDueText"}},{"kind":"Field","name":{"kind":"Name","value":"faaInfo"}},{"kind":"Field","name":{"kind":"Name","value":"doesRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"dueDateDaysFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"dueDateMonthsFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"dueDateSoon"}},{"kind":"Field","name":{"kind":"Name","value":"lastPerformedInterval"}},{"kind":"Field","name":{"kind":"Name","value":"dueInterval"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"intervalValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"newestInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"newestIntervalDueRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetInspectionQuery, GetInspectionQueryVariables>;
export const CreateInspectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInspection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInspectionWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateInspectionMutation, CreateInspectionMutationVariables>;
export const UpdateInspectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInspection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InspectionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInspectionWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateInspectionMutation, UpdateInspectionMutationVariables>;
export const DeleteInspectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInspection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeInspection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteInspectionMutation, DeleteInspectionMutationVariables>;
export const CreateMaintenanceRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMaintenanceRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenanceRecordCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMaintenanceRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateMaintenanceRecordMutation, CreateMaintenanceRecordMutationVariables>;
export const GetMaintenanceRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaintenanceRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maintenanceRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"completionDate"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"intervalValues"}},{"kind":"Field","name":{"kind":"Name","value":"newestInspection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueMethod"}},{"kind":"Field","name":{"kind":"Name","value":"newestInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMaintenanceRecordQuery, GetMaintenanceRecordQueryVariables>;
export const UpdateMaintenanceRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMaintenanceRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MaintenanceRecordUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMaintenanceRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateMaintenanceRecordMutation, UpdateMaintenanceRecordMutationVariables>;
export const DeleteMaintenanceRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMaintenanceRecord"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMaintenanceRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteMaintenanceRecordMutation, DeleteMaintenanceRecordMutationVariables>;
export const UpdateIntervalsOnInspectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntervalsOnInspections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IntervalsOnInspectionsUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntervalsOnInspections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateIntervalsOnInspectionsMutation, UpdateIntervalsOnInspectionsMutationVariables>;
export const GetAnnouncementCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnouncementCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcementCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<GetAnnouncementCountQuery, GetAnnouncementCountQueryVariables>;
export const GetAnnouncementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnouncements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>;
export const GetAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"announcement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorName"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAnnouncementQuery, GetAnnouncementQueryVariables>;
export const CreateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnnouncementAndSendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAnnouncementMutation, CreateAnnouncementMutationVariables>;
export const UpdateAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnnouncementUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnnouncementAndSendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAnnouncementMutation, UpdateAnnouncementMutationVariables>;
export const DeleteAnnouncementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAnnouncement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAnnouncement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteAnnouncementMutation, DeleteAnnouncementMutationVariables>;
export const GetCraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCrafts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"make"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"fuelUnit"}},{"kind":"Field","name":{"kind":"Name","value":"oilUnit"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"regAddress"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isAirworthy"}},{"kind":"Field","name":{"kind":"Name","value":"squawks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inspections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"almostDue"}},{"kind":"Field","name":{"kind":"Name","value":"due"}}]}}]}}]}}]} as unknown as DocumentNode<GetCraftsQuery, GetCraftsQueryVariables>;
export const SetSelectCraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSelectCraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setSelectCraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"craftId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetSelectCraftMutation, SetSelectCraftMutationVariables>;
export const GetFlightsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlights"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flightInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flightCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]},{"kind":"Field","name":{"kind":"Name","value":"pendingFlights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flightInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pendingFlightCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}},...FlightInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetFlightsQuery, GetFlightsQueryVariables>;
export const GetFlightDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flightDate"}},{"kind":"Field","name":{"kind":"Name","value":"consumables"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flightInterval"}}]}},{"kind":"Field","name":{"kind":"Name","value":"normalIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"flightInterval"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proRataShare"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"route"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"customPurpose"}},{"kind":"Field","name":{"kind":"Name","value":"icaos"}},{"kind":"Field","name":{"kind":"Name","value":"isPending"}},{"kind":"Field","name":{"kind":"Name","value":"proRataShare"}},{"kind":"Field","name":{"kind":"Name","value":"soruce"}},{"kind":"Field","name":{"kind":"Name","value":"consumableEntries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purpose"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flightTime"}},{"kind":"Field","name":{"kind":"Name","value":"passengers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nameInvite"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billable"}},{"kind":"Field","name":{"kind":"Name","value":"usageRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"intervalLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}},{"kind":"Field","name":{"kind":"Name","value":"interval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"intervalSubType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"intervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"intervalType"}},{"kind":"Field","name":{"kind":"Name","value":"recentIntervalLog"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startValue"}},{"kind":"Field","name":{"kind":"Name","value":"endValue"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotName"}},{"kind":"Field","name":{"kind":"Name","value":"userProfileId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inputData"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pilotName"}}]}}]}}]}},...FlightIntervalFragmentDoc.definitions]} as unknown as DocumentNode<GetFlightQuery, GetFlightQueryVariables>;
export const GetFlightImportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlightImports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetFlightImportsQuery, GetFlightImportsQueryVariables>;
export const CreateFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightCreateWithIntervalsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFlightWithIntervals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateFlightMutation, CreateFlightMutationVariables>;
export const UpdateFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightUpdateWithIntervalsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFlightWithIntervals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateFlightMutation, UpdateFlightMutationVariables>;
export const DeleteFlightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFlight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFlight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteFlightMutation, DeleteFlightMutationVariables>;
export const GetOrgUserProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrgUserProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationProfileWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOrganizationProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetOrgUserProfilesQuery, GetOrgUserProfilesQueryVariables>;
export const GetAirportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAirports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AirportWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"airports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icao"}},{"kind":"Field","name":{"kind":"Name","value":"facilityName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<GetAirportsQuery, GetAirportsQueryVariables>;
export const GetFlightPurposesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlightPurposes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightPurposeWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightPurposes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetFlightPurposesQuery, GetFlightPurposesQueryVariables>;
export const GetFavoriteRoutesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFavoriteRoutes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteRouteWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteRoutes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icaos"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"airports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icao"}}]}}]}}]}}]} as unknown as DocumentNode<GetFavoriteRoutesQuery, GetFavoriteRoutesQueryVariables>;
export const GetFavoriteRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFavoriteRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favoriteRoute"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"icaos"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"airports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icao"}}]}}]}}]}}]} as unknown as DocumentNode<GetFavoriteRouteQuery, GetFavoriteRouteQueryVariables>;
export const GetOrganizationFlightBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationFlightBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flightBillingEnabled"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationFlightBillingQuery, GetOrganizationFlightBillingQueryVariables>;
export const CreateFavoriteRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFavoriteRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteRouteCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFavoriteRouteWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateFavoriteRouteMutation, CreateFavoriteRouteMutationVariables>;
export const UpdateFavoriteRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFavoriteRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteRouteUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFavoriteRouteWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateFavoriteRouteMutation, UpdateFavoriteRouteMutationVariables>;
export const DeleteFavoriteRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFavoriteRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFavoriteRouteWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteFavoriteRouteMutation, DeleteFavoriteRouteMutationVariables>;
export const GetTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputData"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDeposit"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const GetTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inputData"}},{"kind":"Field","name":{"kind":"Name","value":"formattedValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDeposit"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"wallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<GetTransactionQuery, GetTransactionQueryVariables>;
export const GetUserWalletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserWallet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userProfileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userWallet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userProfileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userProfileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balanceCache"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserWalletQuery, GetUserWalletQueryVariables>;
export const GetCraftBillingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraftBillingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetCraftBillingInfoQuery, GetCraftBillingInfoQueryVariables>;
export const GetOrganizationBillingInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationBillingInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyContribution"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyContributionEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"flightBillingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"billingEnabledByDefault"}},{"kind":"Field","name":{"kind":"Name","value":"supportedPaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"adminPayMonthlyContribution"}},{"kind":"Field","name":{"kind":"Name","value":"specialBillingEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"totalOwed"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationBillingInfoQuery, GetOrganizationBillingInfoQueryVariables>;
export const GetOrganizationWalletsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationWallets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wallets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balanceCache"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganizationWalletsQuery, GetOrganizationWalletsQueryVariables>;
export const UpdateCraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCrafts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCraftInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateCraftInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCraftsMutation, UpdateCraftsMutationVariables>;
export const CreateTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTransactionAndUpdateWallet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const UpdateTransactionAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTransactionAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attachments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionsUpdateAttachmentsInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTransactionAttachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"attachments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attachments"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTransactionAttachmentsMutation, UpdateTransactionAttachmentsMutationVariables>;
export const StripePayBalanceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripePayBalance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePayBalance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<StripePayBalanceQuery, StripePayBalanceQueryVariables>;
export const StripePayPartialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripePayPartial"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePayPartial"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}]}]}}]} as unknown as DocumentNode<StripePayPartialQuery, StripePayPartialQueryVariables>;
export const StripeDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripeDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeDashboard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<StripeDashboardQuery, StripeDashboardQueryVariables>;
export const UpdateStripeConnectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateStripeConnect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateStripeConnect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateStripeConnectMutation, UpdateStripeConnectMutationVariables>;
export const ForeflightAuthDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"foreflightAuth"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foreflightAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}]}}]} as unknown as DocumentNode<ForeflightAuthMutation, ForeflightAuthMutationVariables>;
export const GetReportInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"timeframe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeframe"}}},{"kind":"Argument","name":{"kind":"Name","value":"craftId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"craftId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightTime"}},{"kind":"Field","name":{"kind":"Name","value":"flights"}},{"kind":"Field","name":{"kind":"Name","value":"xcMiles"}},{"kind":"Field","name":{"kind":"Name","value":"xcFlightTime"}},{"kind":"Field","name":{"kind":"Name","value":"currentLocation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}}]}},{"kind":"Field","name":{"kind":"Name","value":"flightRoutes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"routes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"long"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReportInfoQuery, GetReportInfoQueryVariables>;
export const FuelOilReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FuelOilReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fuelOilReports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"Fuel_Per_Hobbs_Hour"}},{"kind":"Field","name":{"kind":"Name","value":"Oil_Per_Hobbs_Hour"}},{"kind":"Field","name":{"kind":"Name","value":"Fuel_Per_Tach_Hour"}},{"kind":"Field","name":{"kind":"Name","value":"Oil_Per_Tach_Hour"}},{"kind":"Field","name":{"kind":"Name","value":"Fuel_Per_Tach_2_Hour"}},{"kind":"Field","name":{"kind":"Name","value":"Oil_Per_Tach_2_Hour"}}]}}]}}]} as unknown as DocumentNode<FuelOilReportsQuery, FuelOilReportsQueryVariables>;
export const GetReservationDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftId"}},{"kind":"Field","name":{"kind":"Name","value":"pilotId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"pilot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pilot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"isMaintenance"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}}]}}]}},...PilotFragmentDoc.definitions]} as unknown as DocumentNode<GetReservationQuery, GetReservationQueryVariables>;
export const GetCraftsReservationExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraftsReservationExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservationsCalendarLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<GetCraftsReservationExportQuery, GetCraftsReservationExportQueryVariables>;
export const GetCraftsReservationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraftsReservations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"reservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"selectedDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftId"}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craftName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pilotId"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"isMaintenance"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"pilotName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]}}]} as unknown as DocumentNode<GetCraftsReservationsQuery, GetCraftsReservationsQueryVariables>;
export const GetReservationsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pilot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Pilot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"craftId"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"isMaintenance"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"pilotName"}},{"kind":"Field","name":{"kind":"Name","value":"craft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"craftName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservationCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}},...PilotFragmentDoc.definitions]} as unknown as DocumentNode<GetReservationsQuery, GetReservationsQueryVariables>;
export const GetCraftsWithUsersDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCraftsWithUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"loggingOption"}},{"kind":"Field","name":{"kind":"Name","value":"fuelAmount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"lastAirport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"icao"}}]}},{"kind":"Field","name":{"kind":"Name","value":"normalLoggingIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntervalFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consumableIntervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntervalFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingInterval"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IntervalFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"nameInvite"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateMethod"}}]}}]}},...IntervalFragmentFragmentDoc.definitions]} as unknown as DocumentNode<GetCraftsWithUsersQuery, GetCraftsWithUsersQueryVariables>;
export const CreateReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReservationAndNotify"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateReservationMutation, CreateReservationMutationVariables>;
export const UpdateReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReservationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"craftId"}},{"kind":"Field","name":{"kind":"Name","value":"pilotId"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"isMaintenance"}}]}}]}}]} as unknown as DocumentNode<UpdateReservationMutation, UpdateReservationMutationVariables>;
export const RemoveReservationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveReservation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeReservation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveReservationMutation, RemoveReservationMutationVariables>;
export const ApplyCouponToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"applyCouponToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyCouponToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"couponCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"couponCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApplyCouponToUserMutation, ApplyCouponToUserMutationVariables>;
export const RemoveCouponFromUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCouponFromUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCouponFromUser"}}]}}]} as unknown as DocumentNode<RemoveCouponFromUserMutation, RemoveCouponFromUserMutationVariables>;
export const ChargebeePortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChargebeePortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargebeePortal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<ChargebeePortalQuery, ChargebeePortalQueryVariables>;
export const ChargebeeSubscribeInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChargebeeSubscribeInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargebeeSubcriptionInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"billingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"billingPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"nextBillingInfo"}}]}}]}}]} as unknown as DocumentNode<ChargebeeSubscribeInfoQuery, ChargebeeSubscribeInfoQueryVariables>;
export const CreateChargebeeSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChargebeeSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChargebeeSubscribeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChargebeeSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateChargebeeSubscriptionMutation, CreateChargebeeSubscriptionMutationVariables>;
export const GetPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productType"},"value":{"kind":"StringValue","value":"organizationPlans","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isTrial"}}]}}]}}]} as unknown as DocumentNode<GetPlansQuery, GetPlansQueryVariables>;
export const StripeSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StripeSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripeSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"billingDate"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"customerPortalUrl"}},{"kind":"Field","name":{"kind":"Name","value":"craftProrateCost"}},{"kind":"Field","name":{"kind":"Name","value":"craftCost"}},{"kind":"Field","name":{"kind":"Name","value":"isPendingCancel"}},{"kind":"Field","name":{"kind":"Name","value":"craftSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planName"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"billingDate"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]} as unknown as DocumentNode<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>;
export const UpdateCraftAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCraftAmount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCraftAmountSubsciption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}]}]}}]} as unknown as DocumentNode<UpdateCraftAmountMutation, UpdateCraftAmountMutationVariables>;
export const SetupAirblyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetupAirbly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupAirbly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integration_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<SetupAirblyMutation, SetupAirblyMutationVariables>;
export const DisconnectAirblyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisconnectAirbly"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disconnectAirbly"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integration_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DisconnectAirblyMutation, DisconnectAirblyMutationVariables>;
export const GetForeflightLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetForeflightLogin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"foreflightLoginLink"}}]}}]} as unknown as DocumentNode<GetForeflightLoginQuery, GetForeflightLoginQueryVariables>;
export const DisconnectForeflightDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisconnectForeflight"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disconnectForeflight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}]}}]} as unknown as DocumentNode<DisconnectForeflightMutation, DisconnectForeflightMutationVariables>;
export const FindOrganizationAirsyncTailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"findOrganizationAirsyncTails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findOrganizationAirsyncTails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tailNumber"}},{"kind":"Field","name":{"kind":"Name","value":"airSyncId"}},{"kind":"Field","name":{"kind":"Name","value":"craftId"}},{"kind":"Field","name":{"kind":"Name","value":"isAircraftRegistered"}},{"kind":"Field","name":{"kind":"Name","value":"isSetup"}}]}}]}}]} as unknown as DocumentNode<FindOrganizationAirsyncTailsQuery, FindOrganizationAirsyncTailsQueryVariables>;
export const SetupAirsyncTailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setupAirsyncTails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AirsyncSetupInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setupAirsyncTails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"airsyncSetupInputs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"airSyncId"}},{"kind":"Field","name":{"kind":"Name","value":"isSetup"}}]}}]}}]} as unknown as DocumentNode<SetupAirsyncTailsMutation, SetupAirsyncTailsMutationVariables>;
export const RemoveAirsyncTailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeAirsyncTail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AirsyncSetupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeAirsyncTail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"airsyncSetupInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"airSyncId"}},{"kind":"Field","name":{"kind":"Name","value":"isSetup"}}]}}]}}]} as unknown as DocumentNode<RemoveAirsyncTailMutation, RemoveAirsyncTailMutationVariables>;
export const SyncAirSyncLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"syncAirSyncLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AirsyncSetupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncAirsyncLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"airsyncInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SyncAirSyncLogsMutation, SyncAirSyncLogsMutationVariables>;
export const GetUserInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"airmenLicense"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOrganizationProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"foreflightInfo"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const GetTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTimezone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]} as unknown as DocumentNode<GetTimezoneQuery, GetTimezoneQueryVariables>;
export const GetUserCouponDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserCoupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coupon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"discountId"}},{"kind":"Field","name":{"kind":"Name","value":"couponType"}},{"kind":"Field","name":{"kind":"Name","value":"discount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"supportedPlans"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserCouponQuery, GetUserCouponQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOrganizationProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationProfileUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserOrganizationProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const ResendInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resendInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const GetOrganizationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"aircraftLimit"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"}},{"kind":"Field","name":{"kind":"Name","value":"trialEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"stripeSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"airblyReadKey"}},{"kind":"Field","name":{"kind":"Name","value":"reservationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"freeAircrafts"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"cbInfo"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetOrganizationBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganizationBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationAuth"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"cbInfo"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationBillingQuery, GetOrganizationBillingQueryVariables>;
export const UpdateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const CreateFlightPurposeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFlightPurpose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightPurposeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFlightPurposeWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateFlightPurposeMutation, CreateFlightPurposeMutationVariables>;
export const UpdateFlightPurposeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFlightPurpose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FlightPurposeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFlightPurposeWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateFlightPurposeMutation, UpdateFlightPurposeMutationVariables>;
export const DeleteFlightPurposeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFlightPurpose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFlightPurposeWithSort"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteFlightPurposeMutation, DeleteFlightPurposeMutationVariables>;
export const GetFlightPurposeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlightPurpose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flightPurpose"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"sort"}},{"kind":"Field","name":{"kind":"Name","value":"isCustom"}}]}}]}}]} as unknown as DocumentNode<GetFlightPurposeQuery, GetFlightPurposeQueryVariables>;
export const GetUserOrganizationProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserOrganizationProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationProfileWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOrganizationProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"nameInvite"}},{"kind":"Field","name":{"kind":"Name","value":"emailInvite"}},{"kind":"Field","name":{"kind":"Name","value":"phoneInvite"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userOrganizationRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserOrganizationProfilesQuery, GetUserOrganizationProfilesQueryVariables>;
export const CreateUserOrganizationProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUserOrganizationProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationProfileCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateUserOrganizationProfileMutation, CreateUserOrganizationProfileMutationVariables>;
export const UpdateUserOrganizationProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserOrganizationProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationProfileUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserOrganizationProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserOrganizationProfileMutation, UpdateUserOrganizationProfileMutationVariables>;
export const GetUserOrganizationRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserOrganizationRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrganizationRoleWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOrganizationRoles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetUserOrganizationRolesQuery, GetUserOrganizationRolesQueryVariables>;
export const GetUserOrganizationProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserOrganizationProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userOrganizationProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"nameInvite"}},{"kind":"Field","name":{"kind":"Name","value":"emailInvite"}},{"kind":"Field","name":{"kind":"Name","value":"phoneInvite"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userOrganizationRole"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetUserOrganizationProfileQuery, GetUserOrganizationProfileQueryVariables>;
export const GetServiceRequestBadgesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceRequestBadges"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mroServiceRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mroOrganizationId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mroOrganizationId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"OPEN","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetServiceRequestBadgesQuery, GetServiceRequestBadgesQueryVariables>;
export const GetOrganizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrganizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cbInfo"}},{"kind":"Field","name":{"kind":"Name","value":"crafts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRole"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"aircraftLimit"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"legacyId"}}]}}]}}]} as unknown as DocumentNode<GetOrganizationQuery, GetOrganizationQueryVariables>;